(function(){"use strict";try{if(typeof document!="undefined"){var r=document.createElement("style");r.appendChild(document.createTextNode('.grow-wrap[data-v-40194afa]{display:grid}.grow-wrap[data-v-40194afa]:after{content:attr(data-replicated-value) " ";white-space:pre-wrap;visibility:hidden}.grow-wrap>textarea[data-v-40194afa]{resize:none;overflow:hidden}.grow-wrap>textarea[data-v-40194afa],.grow-wrap[data-v-40194afa]:after{font:inherit;grid-area:1 / 1 / 2 / 2}label[data-v-40194afa]{display:block}.dp__input_wrap{position:relative;width:100%;box-sizing:unset}.dp__input_wrap:focus{border-color:var(--dp-border-color-hover);outline:none}.dp__input_valid{box-shadow:0 0 var(--dp-border-radius) var(--dp-success-color);border-color:var(--dp-success-color)}.dp__input_valid:hover{border-color:var(--dp-success-color)}.dp__input_invalid{box-shadow:0 0 var(--dp-border-radius) var(--dp-danger-color);border-color:var(--dp-danger-color)}.dp__input_invalid:hover{border-color:var(--dp-danger-color)}.dp__input{background-color:var(--dp-background-color);border-radius:var(--dp-border-radius);font-family:var(--dp-font-family);border:1px solid var(--dp-border-color);outline:none;transition:border-color .2s cubic-bezier(.645,.045,.355,1);width:100%;font-size:var(--dp-font-size);line-height:calc(var(--dp-font-size)*1.5);padding:var(--dp-input-padding);color:var(--dp-text-color);box-sizing:border-box}.dp__input::-moz-placeholder{opacity:.7}.dp__input::placeholder{opacity:.7}.dp__input:hover:not(.dp__input_focus){border-color:var(--dp-border-color-hover)}.dp__input_reg{caret-color:#0000}.dp__input_focus{border-color:var(--dp-border-color-focus)}.dp__disabled{background:var(--dp-disabled-color)}.dp__disabled::-moz-placeholder{color:var(--dp-disabled-color-text)}.dp__disabled::placeholder{color:var(--dp-disabled-color-text)}.dp__input_icons{display:inline-block;width:var(--dp-font-size);height:var(--dp-font-size);stroke-width:0;font-size:var(--dp-font-size);line-height:calc(var(--dp-font-size)*1.5);padding:6px 12px;color:var(--dp-icon-color);box-sizing:content-box}.dp__input_icon{cursor:pointer;position:absolute;top:50%;inset-inline-start:0;transform:translateY(-50%);color:var(--dp-icon-color)}.dp__clear_icon{position:absolute;top:50%;inset-inline-end:0;transform:translateY(-50%);cursor:pointer;color:var(--dp-icon-color)}.dp__input_icon_pad{padding-inline-start:var(--dp-input-icon-padding)}.dp__menu{background:var(--dp-background-color);border-radius:var(--dp-border-radius);min-width:var(--dp-menu-min-width);font-family:var(--dp-font-family);font-size:var(--dp-font-size);-webkit-user-select:none;-moz-user-select:none;user-select:none;border:1px solid var(--dp-menu-border-color);box-sizing:border-box}.dp__menu:after{box-sizing:border-box}.dp__menu:before{box-sizing:border-box}.dp__menu:focus{border:1px solid var(--dp-menu-border-color);outline:none}.dp--menu-wrapper{position:absolute;z-index:99999}.dp__menu_inner{padding:var(--dp-menu-padding)}.dp--menu--inner-stretched{padding:6px 0}.dp__menu_index{z-index:99999}.dp-menu-loading,.dp__menu_readonly,.dp__menu_disabled{position:absolute;top:0;right:0;bottom:0;left:0;z-index:999999}.dp__menu_disabled{background:rgba(255,255,255,.5);cursor:not-allowed}.dp__menu_readonly{background:rgba(0,0,0,0);cursor:default}.dp-menu-loading{background:rgba(255,255,255,.5);cursor:default}.dp--menu-load-container{display:flex;height:100%;width:100%;justify-content:center;align-items:center}.dp--menu-loader{width:48px;height:48px;border:var(--dp-loader);border-bottom-color:#0000;border-radius:50%;display:inline-block;box-sizing:border-box;animation:dp-load-rotation 1s linear infinite;position:absolute}@keyframes dp-load-rotation{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.dp__arrow_top{left:var(--dp-arrow-left);top:0;height:12px;width:12px;background-color:var(--dp-background-color);position:absolute;border-inline-end:1px solid var(--dp-menu-border-color);border-top:1px solid var(--dp-menu-border-color);transform:translate(-50%,-50%) rotate(-45deg)}.dp__arrow_bottom{left:var(--dp-arrow-left);bottom:0;height:12px;width:12px;background-color:var(--dp-background-color);position:absolute;border-inline-end:1px solid var(--dp-menu-border-color);border-bottom:1px solid var(--dp-menu-border-color);transform:translate(-50%,50%) rotate(45deg)}.dp__action_extra{text-align:center;padding:2px 0}.dp--preset-dates{padding:5px;border-inline-end:1px solid var(--dp-border-color)}@media only screen and (width <= 600px){.dp--preset-dates{display:flex;align-self:center;border:none;overflow-x:auto;max-width:calc(var(--dp-menu-width) - var(--dp-action-row-padding)*2)}}.dp--preset-dates-collapsed{display:flex;align-self:center;border:none;overflow-x:auto;max-width:calc(var(--dp-menu-width) - var(--dp-action-row-padding)*2)}.dp__sidebar_left{padding:5px;border-inline-end:1px solid var(--dp-border-color)}.dp__sidebar_right{padding:5px;margin-inline-end:1px solid var(--dp-border-color)}.dp--preset-range{display:block;width:100%;padding:5px;text-align:left;white-space:nowrap;color:var(--dp-text-color);border-radius:var(--dp-border-radius);transition:var(--dp-common-transition)}.dp--preset-range:hover{background-color:var(--dp-hover-color);color:var(--dp-hover-text-color);cursor:pointer}@media only screen and (width <= 600px){.dp--preset-range{border:1px solid var(--dp-border-color);margin:0 3px}.dp--preset-range:first-child{margin-left:0}.dp--preset-range:last-child{margin-right:0}}.dp--preset-range-collapsed{border:1px solid var(--dp-border-color);margin:0 3px}.dp--preset-range-collapsed:first-child{margin-left:0}.dp--preset-range-collapsed:last-child{margin-right:0}.dp__menu_content_wrapper{display:flex}@media only screen and (width <= 600px){.dp__menu_content_wrapper{flex-direction:column-reverse}}.dp--menu-content-wrapper-collapsed{flex-direction:column-reverse}.dp__calendar_header{position:relative;display:flex;justify-content:center;align-items:center;color:var(--dp-text-color);white-space:nowrap;font-weight:700}.dp__calendar_header_item{text-align:center;flex-grow:1;height:var(--dp-cell-size);padding:var(--dp-cell-padding);width:var(--dp-cell-size);box-sizing:border-box}.dp__calendar_row{display:flex;justify-content:center;align-items:center;margin:var(--dp-row-margin)}.dp__calendar_item{text-align:center;flex-grow:1;box-sizing:border-box;color:var(--dp-text-color)}.dp__calendar{position:relative}.dp__calendar_header_cell{border-bottom:thin solid var(--dp-border-color);padding:var(--dp-calendar-header-cell-padding)}.dp__cell_inner{display:flex;align-items:center;text-align:center;justify-content:center;border-radius:var(--dp-cell-border-radius);height:var(--dp-cell-size);padding:var(--dp-cell-padding);width:var(--dp-cell-size);border:1px solid rgba(0,0,0,0);box-sizing:border-box;position:relative}.dp__cell_inner:hover{transition:all .2s}.dp__cell_auto_range_start,.dp__date_hover_start:hover,.dp__range_start{border-end-end-radius:0;border-start-end-radius:0}.dp__cell_auto_range_end,.dp__date_hover_end:hover,.dp__range_end{border-end-start-radius:0;border-start-start-radius:0}.dp__range_end,.dp__range_start,.dp__active_date{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__date_hover_end:hover,.dp__date_hover_start:hover,.dp__date_hover:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__cell_offset{color:var(--dp-secondary-color)}.dp__cell_disabled{color:var(--dp-secondary-color);cursor:not-allowed}.dp__range_between{background:var(--dp-range-between-dates-background-color);color:var(--dp-range-between-dates-text-color);border-radius:0;border:1px solid var(--dp-range-between-border-color)}.dp__range_between_week{background:var(--dp-primary-color);color:var(--dp-primary-text-color);border-radius:0;border-top:1px solid var(--dp-primary-color);border-bottom:1px solid var(--dp-primary-color)}.dp__today{border:1px solid var(--dp-primary-color)}.dp__week_num{color:var(--dp-secondary-color);text-align:center}.dp__cell_auto_range{border-radius:0;border-top:1px dashed var(--dp-primary-color);border-bottom:1px dashed var(--dp-primary-color)}.dp__cell_auto_range_start{border-start-start-radius:var(--dp-cell-border-radius);border-end-start-radius:var(--dp-cell-border-radius);border-inline-start:1px dashed var(--dp-primary-color);border-top:1px dashed var(--dp-primary-color);border-bottom:1px dashed var(--dp-primary-color)}.dp__cell_auto_range_end{border-start-end-radius:var(--dp-cell-border-radius);border-end-end-radius:var(--dp-cell-border-radius);border-top:1px dashed var(--dp-primary-color);border-bottom:1px dashed var(--dp-primary-color);border-inline-end:1px dashed var(--dp-primary-color)}.dp__calendar_header_separator{width:100%;height:1px;background:var(--dp-border-color)}.dp__calendar_next{margin-inline-start:var(--dp-multi-calendars-spacing)}.dp__marker_line,.dp__marker_dot{height:5px;background-color:var(--dp-marker-color);position:absolute;bottom:0}.dp__marker_dot{width:5px;border-radius:50%;left:50%;transform:translate(-50%)}.dp__marker_line{width:100%;left:0}.dp__marker_tooltip{position:absolute;border-radius:var(--dp-border-radius);background-color:var(--dp-tooltip-color);padding:5px;border:1px solid var(--dp-border-color);z-index:99999;box-sizing:border-box;cursor:default}.dp__tooltip_content{white-space:nowrap}.dp__tooltip_text{display:flex;align-items:center;flex-flow:row nowrap;color:var(--dp-text-color)}.dp__tooltip_mark{height:5px;width:5px;border-radius:50%;background-color:var(--dp-text-color);color:var(--dp-text-color);margin-inline-end:5px}.dp__arrow_bottom_tp{bottom:0;height:8px;width:8px;background-color:var(--dp-tooltip-color);position:absolute;border-inline-end:1px solid var(--dp-border-color);border-bottom:1px solid var(--dp-border-color);transform:translate(-50%,50%) rotate(45deg)}.dp__instance_calendar{position:relative;width:100%}@media only screen and (width <= 600px){.dp__flex_display{flex-direction:column}}.dp--flex-display-collapsed{flex-direction:column}.dp__cell_highlight{background-color:var(--dp-highlight-color)}.dp__month_year_row{display:flex;align-items:center;height:var(--dp-month-year-row-height);color:var(--dp-text-color);box-sizing:border-box}.dp__inner_nav{display:flex;align-items:center;justify-content:center;cursor:pointer;height:var(--dp-month-year-row-button-size);width:var(--dp-month-year-row-button-size);color:var(--dp-icon-color);text-align:center;border-radius:50%}.dp__inner_nav svg{height:var(--dp-button-icon-height);width:var(--dp-button-icon-height)}.dp__inner_nav:hover{background:var(--dp-hover-color);color:var(--dp-hover-icon-color)}[dir=rtl] .dp__inner_nav{transform:rotate(180deg)}.dp__inner_nav_disabled:hover,.dp__inner_nav_disabled{background:var(--dp-disabled-color);color:var(--dp-disabled-color-text);cursor:not-allowed}.dp--year-select,.dp__month_year_select{text-align:center;cursor:pointer;height:var(--dp-month-year-row-height);display:flex;align-items:center;justify-content:center;border-radius:var(--dp-border-radius);box-sizing:border-box;color:var(--dp-text-color)}.dp--year-select:hover,.dp__month_year_select:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp__month_year_select{width:50%}.dp--year-select{width:100%}.dp__month_year_wrap{display:flex;flex-direction:row;width:100%}.dp__year_disable_select{justify-content:space-around}.dp--header-wrap{display:flex;width:100%;flex-direction:column}.dp__overlay{width:100%;background:var(--dp-background-color);transition:opacity 1s ease-out;z-index:99999;font-family:var(--dp-font-family);color:var(--dp-text-color);box-sizing:border-box}.dp--overlay-absolute{position:absolute;height:100%;top:0;left:0}.dp--overlay-relative{position:relative}.dp__overlay_container::-webkit-scrollbar-track{box-shadow:var(--dp-scroll-bar-background);background-color:var(--dp-scroll-bar-background)}.dp__overlay_container::-webkit-scrollbar{width:5px;background-color:var(--dp-scroll-bar-background)}.dp__overlay_container::-webkit-scrollbar-thumb{background-color:var(--dp-scroll-bar-color);border-radius:10px}.dp__overlay:focus{border:none;outline:none}.dp__container_flex{display:flex}.dp__container_block{display:block}.dp__overlay_container{flex-direction:column;overflow-y:auto;height:var(--dp-overlay-height)}.dp__time_picker_overlay_container{height:100%}.dp__overlay_row{padding:0;box-sizing:border-box;display:flex;margin-inline:auto auto;flex-wrap:wrap;max-width:100%;width:100%;align-items:center}.dp__flex_row{flex:1}.dp__overlay_col{box-sizing:border-box;width:33%;padding:var(--dp-overlay-col-padding);white-space:nowrap}.dp__overlay_cell_pad{padding:var(--dp-common-padding) 0}.dp__overlay_cell_active{cursor:pointer;border-radius:var(--dp-border-radius);text-align:center;background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__overlay_cell{cursor:pointer;border-radius:var(--dp-border-radius);text-align:center}.dp__overlay_cell:hover{background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp__cell_in_between{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__over_action_scroll{right:5px;box-sizing:border-box}.dp__overlay_cell_disabled{cursor:not-allowed;background:var(--dp-disabled-color)}.dp__overlay_cell_disabled:hover{background:var(--dp-disabled-color)}.dp__overlay_cell_active_disabled{cursor:not-allowed;background:var(--dp-primary-disabled-color)}.dp__overlay_cell_active_disabled:hover{background:var(--dp-primary-disabled-color)}.dp__btn,.dp--qr-btn,.dp--time-invalid,.dp--time-overlay-btn{border:none;font:inherit;transition:var(--dp-common-transition);line-height:normal}.dp--tp-wrap{max-width:var(--dp-menu-min-width)}.dp__time_input{width:100%;display:flex;align-items:center;justify-content:center;-webkit-user-select:none;-moz-user-select:none;user-select:none;font-family:var(--dp-font-family);color:var(--dp-text-color)}.dp__time_col_reg_block{padding:0 20px}.dp__time_col_reg_inline{padding:0 10px}.dp__time_col_reg_with_button{padding:0 15px}.dp__time_col_sec{padding:0 10px}.dp__time_col_sec_with_button{padding:0 5px}.dp__time_col{text-align:center;display:flex;align-items:center;justify-content:center;flex-direction:column}.dp__time_col_block{font-size:var(--dp-time-font-size)}.dp__time_display_block{padding:0 3px}.dp__time_display_inline{padding:5px}.dp__time_picker_inline_container{display:flex;width:100%;justify-content:center}.dp__inc_dec_button{padding:5px;margin:0;height:var(--dp-time-inc-dec-button-size);width:var(--dp-time-inc-dec-button-size);display:flex;align-items:center;justify-content:center;cursor:pointer;border-radius:50%;color:var(--dp-icon-color);box-sizing:border-box}.dp__inc_dec_button svg{height:var(--dp-time-inc-dec-button-size);width:var(--dp-time-inc-dec-button-size)}.dp__inc_dec_button:hover{background:var(--dp-hover-color);color:var(--dp-primary-color)}.dp__time_display{cursor:pointer;color:var(--dp-text-color);border-radius:var(--dp-border-radius);display:flex;align-items:center;justify-content:center}.dp__time_display:hover:enabled{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__inc_dec_button_inline{width:100%;padding:0;height:8px;cursor:pointer;display:flex;align-items:center}.dp__inc_dec_button_disabled,.dp__inc_dec_button_disabled:hover{background:var(--dp-disabled-color);color:var(--dp-disabled-color-text);cursor:not-allowed}.dp__pm_am_button{background:var(--dp-primary-color);color:var(--dp-primary-text-color);border:none;padding:var(--dp-common-padding);border-radius:var(--dp-border-radius);cursor:pointer}.dp__tp_inline_btn_bar{width:100%;height:4px;background-color:var(--dp-secondary-color);transition:var(--dp-common-transition);border-collapse:collapse}.dp__tp_inline_btn_top:hover .dp__tp_btn_in_r{background-color:var(--dp-primary-color);transform:rotate(12deg) scale(1.15) translateY(-2px)}.dp__tp_inline_btn_top:hover .dp__tp_btn_in_l,.dp__tp_inline_btn_bottom:hover .dp__tp_btn_in_r{background-color:var(--dp-primary-color);transform:rotate(-12deg) scale(1.15) translateY(-2px)}.dp__tp_inline_btn_bottom:hover .dp__tp_btn_in_l{background-color:var(--dp-primary-color);transform:rotate(12deg) scale(1.15) translateY(-2px)}.dp--time-overlay-btn{background:none}.dp--time-invalid{background-color:var(--dp-disabled-color)}.dp__action_row{display:flex;align-items:center;width:100%;padding:var(--dp-action-row-padding);box-sizing:border-box;color:var(--dp-text-color);flex-flow:row nowrap}.dp__action_row svg{height:var(--dp-button-icon-height);width:auto}.dp__selection_preview{display:block;color:var(--dp-text-color);font-size:var(--dp-preview-font-size);overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.dp__action_buttons{display:flex;flex:0;white-space:nowrap;align-items:center;justify-content:flex-end;margin-inline-start:auto}.dp__action_button{display:inline-flex;align-items:center;background:rgba(0,0,0,0);border:1px solid rgba(0,0,0,0);padding:var(--dp-action-buttons-padding);line-height:var(--dp-action-button-height);margin-inline-start:3px;height:var(--dp-action-button-height);cursor:pointer;border-radius:var(--dp-border-radius);font-size:var(--dp-preview-font-size);font-family:var(--dp-font-family)}.dp__action_cancel{color:var(--dp-text-color);border:1px solid var(--dp-border-color)}.dp__action_cancel:hover{border-color:var(--dp-primary-color);transition:var(--dp-action-row-transtion)}.dp__action_buttons .dp__action_select{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp__action_buttons .dp__action_select:hover{background:var(--dp-primary-color);transition:var(--dp-action-row-transtion)}.dp__action_buttons .dp__action_select:disabled{background:var(--dp-primary-disabled-color);cursor:not-allowed}.dp-quarter-picker-wrap{display:flex;flex-direction:column;height:100%;min-width:var(--dp-menu-min-width)}.dp--qr-btn-disabled{cursor:not-allowed;background:var(--dp-disabled-color)}.dp--qr-btn-disabled:hover{background:var(--dp-disabled-color)}.dp--qr-btn{width:100%;padding:var(--dp-common-padding)}.dp--qr-btn:not(.dp--highlighted,.dp--qr-btn-active,.dp--qr-btn-disabled,.dp--qr-btn-between){background:none}.dp--qr-btn:hover:not(.dp--qr-btn-active,.dp--qr-btn-disabled){background:var(--dp-hover-color);color:var(--dp-hover-text-color);transition:var(--dp-common-transition)}.dp--quarter-items{display:flex;flex-direction:column;flex:1;width:100%;height:100%;justify-content:space-evenly}.dp--qr-btn-active{background:var(--dp-primary-color);color:var(--dp-primary-text-color)}.dp--qr-btn-between{background:var(--dp-hover-color);color:var(--dp-hover-text-color)}.dp__btn,.dp--time-overlay-btn,.dp--time-invalid,.dp--qr-btn{border:none;font:inherit;transition:var(--dp-common-transition);line-height:normal}.dp--year-mode-picker{display:flex;width:100%;align-items:center;justify-content:space-between;height:var(--dp-cell-size)}:root{--dp-common-transition: all .1s ease-in;--dp-menu-padding: 6px 8px;--dp-animation-duration: .1s;--dp-menu-appear-transition-timing: cubic-bezier(.4, 0, 1, 1);--dp-transition-timing: ease-out;--dp-action-row-transtion: all .2s ease-in;--dp-font-family: -apple-system, blinkmacsystemfont, "Segoe UI", roboto, oxygen, ubuntu, cantarell, "Open Sans", "Helvetica Neue", sans-serif;--dp-border-radius: 4px;--dp-cell-border-radius: 4px;--dp-transition-length: 22px;--dp-transition-timing-general: .1s;--dp-button-height: 35px;--dp-month-year-row-height: 35px;--dp-month-year-row-button-size: 25px;--dp-button-icon-height: 20px;--dp-calendar-wrap-padding: 0 5px;--dp-cell-size: 35px;--dp-cell-padding: 5px;--dp-common-padding: 10px;--dp-input-icon-padding: 35px;--dp-input-padding: 6px 30px 6px 12px;--dp-menu-min-width: 260px;--dp-action-buttons-padding: 1px 6px;--dp-row-margin: 5px 0;--dp-calendar-header-cell-padding: .5rem;--dp-multi-calendars-spacing: 10px;--dp-overlay-col-padding: 3px;--dp-time-inc-dec-button-size: 32px;--dp-font-size: 1rem;--dp-preview-font-size: .8rem;--dp-time-font-size: 2rem;--dp-action-button-height: 22px;--dp-action-row-padding: 8px}.dp__theme_dark{--dp-background-color: #212121;--dp-text-color: #fff;--dp-hover-color: #484848;--dp-hover-text-color: #fff;--dp-hover-icon-color: #959595;--dp-primary-color: #005cb2;--dp-primary-disabled-color: #61a8ea;--dp-primary-text-color: #fff;--dp-secondary-color: #a9a9a9;--dp-border-color: #2d2d2d;--dp-menu-border-color: #2d2d2d;--dp-border-color-hover: #aaaeb7;--dp-border-color-focus: #aaaeb7;--dp-disabled-color: #737373;--dp-disabled-color-text: #d0d0d0;--dp-scroll-bar-background: #212121;--dp-scroll-bar-color: #484848;--dp-success-color: #00701a;--dp-success-color-disabled: #428f59;--dp-icon-color: #959595;--dp-danger-color: #e53935;--dp-marker-color: #e53935;--dp-tooltip-color: #3e3e3e;--dp-highlight-color: rgb(0 92 178 / 20%);--dp-range-between-dates-background-color: var(--dp-hover-color, #484848);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #fff);--dp-range-between-border-color: var(--dp-hover-color, #fff);--dp-loader: 5px solid #005cb2}.dp__theme_light{--dp-background-color: #fff;--dp-text-color: #212121;--dp-hover-color: #f3f3f3;--dp-hover-text-color: #212121;--dp-hover-icon-color: #959595;--dp-primary-color: #1976d2;--dp-primary-disabled-color: #6bacea;--dp-primary-text-color: #f8f5f5;--dp-secondary-color: #c0c4cc;--dp-border-color: #ddd;--dp-menu-border-color: #ddd;--dp-border-color-hover: #aaaeb7;--dp-border-color-focus: #aaaeb7;--dp-disabled-color: #f6f6f6;--dp-scroll-bar-background: #f3f3f3;--dp-scroll-bar-color: #959595;--dp-success-color: #76d275;--dp-success-color-disabled: #a3d9b1;--dp-icon-color: #959595;--dp-danger-color: #ff6f60;--dp-marker-color: #ff6f60;--dp-tooltip-color: #fafafa;--dp-disabled-color-text: #8e8e8e;--dp-highlight-color: rgb(25 118 210 / 10%);--dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);--dp-range-between-border-color: var(--dp-hover-color, #f3f3f3);--dp-loader: 5px solid #1976d2}.dp__flex{display:flex;align-items:center}.dp__btn{background:none}.dp__main{font-family:var(--dp-font-family);-webkit-user-select:none;-moz-user-select:none;user-select:none;box-sizing:border-box;position:relative;width:100%}.dp__pointer{cursor:pointer}.dp__icon{stroke:currentcolor;fill:currentcolor}.dp__button{width:100%;text-align:center;color:var(--dp-icon-color);cursor:pointer;display:flex;align-items:center;place-content:center center;padding:var(--dp-common-padding);box-sizing:border-box;height:var(--dp-button-height)}.dp__button.dp__overlay_action{position:absolute;bottom:0}.dp__button:hover{background:var(--dp-hover-color);color:var(--dp-hover-icon-color)}.dp__button svg{height:var(--dp-button-icon-height);width:auto}.dp__button_bottom{border-bottom-left-radius:var(--dp-border-radius);border-bottom-right-radius:var(--dp-border-radius)}.dp__flex_display{display:flex}.dp__flex_display_with_input{flex-direction:column;align-items:flex-start}.dp__relative{position:relative}.calendar-next-enter-active,.calendar-next-leave-active,.calendar-prev-enter-active,.calendar-prev-leave-active{transition:all var(--dp-transition-timing-general) ease-out}.calendar-next-enter-from{opacity:0;transform:translate(var(--dp-transition-length))}.calendar-next-leave-to,.calendar-prev-enter-from{opacity:0;transform:translate(calc(var(--dp-transition-length) * -1))}.calendar-prev-leave-to{opacity:0;transform:translate(var(--dp-transition-length))}.dp-menu-appear-bottom-enter-active,.dp-menu-appear-bottom-leave-active,.dp-menu-appear-top-enter-active,.dp-menu-appear-top-leave-active,.dp-slide-up-enter-active,.dp-slide-up-leave-active,.dp-slide-down-enter-active,.dp-slide-down-leave-active{transition:all var(--dp-animation-duration) var(--dp-transition-timing)}.dp-menu-appear-top-enter-from,.dp-menu-appear-top-leave-to,.dp-slide-down-leave-to,.dp-slide-up-enter-from{opacity:0;transform:translateY(var(--dp-transition-length))}.dp-menu-appear-bottom-enter-from,.dp-menu-appear-bottom-leave-to,.dp-slide-down-enter-from,.dp-slide-up-leave-to{opacity:0;transform:translateY(calc(var(--dp-transition-length) * -1))}.dp--arrow-btn-nav{transition:var(--dp-common-transition)}.dp--highlighted{background-color:var(--dp-highlight-color)}:root{--dp-font-family: -apple-system, blinkmacsystemfont, "Segoe UI", roboto, oxygen, ubuntu, cantarell, "Open Sans", "Helvetica Neue", sans-serif;--dp-border-radius: 12px;--dp-cell-border-radius: 4px;--dp-common-transition: all .1s ease-in;--dp-button-height: 35px;--dp-month-year-row-height: 35px;--dp-month-year-row-button-size: 35px;--dp-button-icon-height: 20px;--dp-cell-size: 35px;--dp-cell-padding: 5px;--dp-common-padding: 10px;--dp-input-icon-padding: 35px;--dp-input-padding: 8px 12px 8px 12px;--dp-menu-min-width: 260px;--dp-action-buttons-padding: 2px 5px;--dp-row-margin: 5px 0;--dp-calendar-header-cell-padding: .5rem;--dp-two-calendars-spacing: 10px;--dp-overlay-col-padding: 3px;--dp-time-inc-dec-button-size: 32px;--dp-menu-padding: 6px 8px;--dp-font-size: 1rem;--dp-preview-font-size: .8rem;--dp-time-font-size: .8rem;--dp-animation-duration: .1s;--dp-menu-appear-transition-timing: cubic-bezier( .4, 0, 1, 1 );--dp-transition-timing: ease-out}.dp__theme_light{--dp-background-color: #ffffff;--dp-text-color: #212121;--dp-hover-color: #f3f3f3;--dp-hover-text-color: #212121;--dp-hover-icon-color: #959595;--dp-primary-color: #262626;--dp-primary-disabled-color: #6bacea;--dp-primary-text-color: #f8f5f5;--dp-secondary-color: #c0c4cc;--dp-border-color: #ddd;--dp-menu-border-color: #ddd;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #f6f6f6;--dp-scroll-bar-background: #f3f3f3;--dp-scroll-bar-color: #959595;--dp-success-color: #76d275;--dp-success-color-disabled: #a3d9b1;--dp-icon-color: #959595;--dp-danger-color: #ff6f60;--dp-marker-color: #ff6f60;--dp-tooltip-color: #fafafa;--dp-disabled-color-text: #8e8e8e;--dp-highlight-color: rgb(25 118 210 / 10%);--dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);--dp-range-between-border-color: var(--dp-hover-color, #f3f3f3)}.dp__theme_dark{--dp-background-color: #212121;--dp-text-color: #fff;--dp-hover-color: #484848;--dp-hover-text-color: #fff;--dp-hover-icon-color: #959595;--dp-primary-color: #ffffff;--dp-primary-disabled-color: #61a8ea;--dp-primary-text-color: #262626;--dp-secondary-color: #a9a9a9;--dp-border-color: #2d2d2d;--dp-menu-border-color: #2d2d2d;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #737373;--dp-disabled-color-text: #d0d0d0;--dp-scroll-bar-background: #212121;--dp-scroll-bar-color: #484848;--dp-success-color: #00701a;--dp-success-color-disabled: #428f59;--dp-icon-color: #959595;--dp-danger-color: #e53935;--dp-marker-color: #e53935;--dp-tooltip-color: #3e3e3e;--dp-highlight-color: rgb(0 92 178 / 20%);--dp-range-between-dates-background-color: var(--dp-hover-color, #484848);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #fff);--dp-range-between-border-color: var(--dp-hover-color, #fff)}.dp__theme_light .dp__menu_disabled{background-color:#ffffffbf}.dp__theme_dark .dp__menu_disabled{background-color:#000000bf}.dpkr{--dp-font-family: var(--font-family-primary);--dp-border-radius: .75rem}.dpkr .dp__theme_light{--dp-background-color: #f5f5f5;--dp-hover-color: #f3f3f3;--dp-hover-text-color: #212121;--dp-hover-icon-color: #959595;--dp-primary-color: #4d3831;--dp-primary-disabled-color: #b0988d;--dp-primary-text-color: #f8f5f5;--dp-secondary-color: #c0c4cc;--dp-border-color: #ddd;--dp-menu-border-color: #ddd;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #f6f6f6;--dp-scroll-bar-background: #f3f3f3;--dp-scroll-bar-color: #959595;--dp-success-color: #76d275;--dp-success-color-disabled: #a3d9b1;--dp-icon-color: #959595;--dp-danger-color: #ff6f60;--dp-marker-color: #ff6f60;--dp-tooltip-color: #fafafa;--dp-disabled-color-text: #8e8e8e;--dp-highlight-color: rgb(25 118 210 / 10%);--dp-range-between-dates-background-color: var(--dp-hover-color, #f3f3f3);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #212121);--dp-range-between-border-color: var(--dp-hover-color, #f3f3f3)}.dpkr .dp__theme_dark{--dp-background-color: #212121;--dp-text-color: #fff;--dp-hover-color: #484848;--dp-hover-text-color: #fff;--dp-hover-icon-color: #959595;--dp-primary-color: #005cb2;--dp-primary-disabled-color: #61a8ea;--dp-primary-text-color: #fff;--dp-secondary-color: #a9a9a9;--dp-border-color: #2d2d2d;--dp-menu-border-color: #2d2d2d;--dp-border-color-hover: #aaaeb7;--dp-disabled-color: #737373;--dp-disabled-color-text: #d0d0d0;--dp-scroll-bar-background: #212121;--dp-scroll-bar-color: #484848;--dp-success-color: #00701a;--dp-success-color-disabled: #428f59;--dp-icon-color: #959595;--dp-danger-color: #e53935;--dp-marker-color: #e53935;--dp-tooltip-color: #3e3e3e;--dp-highlight-color: rgb(0 92 178 / 20%);--dp-range-between-dates-background-color: var(--dp-hover-color, #484848);--dp-range-between-dates-text-color: var(--dp-hover-text-color, #fff);--dp-range-between-border-color: var(--dp-hover-color, #fff)}.dpkr .dp__today{border:1px solid #e8d2c4}.iframe-container{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;max-width:100%}.iframe-container iframe{position:absolute;top:0;left:0;width:100%;height:100%}')),document.head.appendChild(r)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
var EC = Object.defineProperty;
var UC = (e, a, t) => a in e ? EC(e, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[a] = t;
var Me = (e, a, t) => (UC(e, typeof a != "symbol" ? a + "" : a, t), t);
import { h as Lx, getCurrentInstance as tI, computed as F, inject as Fw, defineAsyncComponent as aI, openBlock as d, createBlock as K, unref as s, normalizeProps as j, mergeProps as H, createCommentVNode as y, ref as U, watch as We, createElementBlock as h, guardReactiveProps as re, resolveDynamicComponent as st, withCtx as fe, renderSlot as te, toDisplayString as N, createElementVNode as P, onMounted as Qe, normalizeClass as be, onUnmounted as er, toRef as Gt, createTextVNode as lt, createVNode as Le, Fragment as ve, renderList as Ie, toRaw as Br, useAttrs as NC, withDirectives as Ot, vShow as Rt, reactive as Rr, defineComponent as it, useSlots as tr, nextTick as Mt, isRef as Aw, createSlots as ht, Teleport as WC, Transition as mr, normalizeStyle as ut, withModifiers as Dr, render as qL, onBeforeUpdate as GC, withKeys as ZC, getCurrentScope as YC, onScopeDispose as KC, resolveComponent as Fr, toHandlers as nI, isReactive as XC } from "vue";
const zL = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), QC = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (a, t, o) => o ? o.toUpperCase() : t.toLowerCase()
), JC = (e) => {
  const a = QC(e);
  return a.charAt(0).toUpperCase() + a.slice(1);
}, eA = (...e) => e.filter((a, t, o) => !!a && a.trim() !== "" && o.indexOf(a) === t).join(" ").trim();
var Jr = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": 2,
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
const oI = ({ size: e, strokeWidth: a = 2, absoluteStrokeWidth: t, color: o, iconNode: r, name: l, class: i, ...c }, { slots: u }) => Lx(
  "svg",
  {
    ...Jr,
    width: e || Jr.width,
    height: e || Jr.height,
    stroke: o || Jr.stroke,
    "stroke-width": t ? Number(a) * 24 / Number(e) : a,
    class: eA(
      "lucide",
      ...l ? [`lucide-${zL(JC(l))}-icon`, `lucide-${zL(l)}`] : ["lucide-icon"]
    ),
    ...c
  },
  [...r.map((v) => Lx(...v)), ...u.default ? [u.default()] : []]
);
const n = (e, a) => (t, { slots: o }) => Lx(
  oI,
  {
    ...t,
    iconNode: a,
    name: e
  },
  o
);
const ll = n("a-arrow-down", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 7v9", key: "pknjwm" }],
  ["path", { d: "m14 12 4 4 4-4", key: "buelq4" }]
]);
const il = n("a-arrow-up", [
  ["path", { d: "M3.5 13h6", key: "p1my2r" }],
  ["path", { d: "m2 16 4.5-9 4.5 9", key: "ndf0b3" }],
  ["path", { d: "M18 16V7", key: "ty0viw" }],
  ["path", { d: "m14 11 4-4 4 4", key: "1pu57t" }]
]);
const cl = n("a-large-small", [
  ["path", { d: "M21 14h-5", key: "1vh23k" }],
  ["path", { d: "M16 16v-3.5a2.5 2.5 0 0 1 5 0V16", key: "1wh10o" }],
  ["path", { d: "M4.5 13h6", key: "dfilno" }],
  ["path", { d: "m3 16 4.5-9 4.5 9", key: "2dxa0e" }]
]);
const dl = n("accessibility", [
  ["circle", { cx: "16", cy: "4", r: "1", key: "1grugj" }],
  ["path", { d: "m18 19 1-7-6 1", key: "r0i19z" }],
  ["path", { d: "m5 8 3-3 5.5 3-2.36 3.5", key: "9ptxx2" }],
  ["path", { d: "M4.24 14.5a5 5 0 0 0 6.88 6", key: "10kmtu" }],
  ["path", { d: "M13.76 17.5a5 5 0 0 0-6.88-6", key: "2qq6rc" }]
]);
const sl = n("activity", [
  [
    "path",
    {
      d: "M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2",
      key: "169zse"
    }
  ]
]);
const ul = n("air-vent", [
  [
    "path",
    {
      d: "M6 12H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "larmp2"
    }
  ],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "M18.3 17.7a2.5 2.5 0 0 1-3.16 3.83 2.53 2.53 0 0 1-1.14-2V12", key: "1bo8pg" }],
  ["path", { d: "M6.6 15.6A2 2 0 1 0 10 17v-5", key: "t9h90c" }]
]);
const hl = n("airplay", [
  [
    "path",
    {
      d: "M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1",
      key: "ns4c3b"
    }
  ],
  ["path", { d: "m12 15 5 6H7Z", key: "14qnn2" }]
]);
const da = n("alarm-clock-check", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
const sa = n("alarm-clock-minus", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
const pl = n("alarm-clock-off", [
  ["path", { d: "M6.87 6.87a8 8 0 1 0 11.26 11.26", key: "3on8tj" }],
  ["path", { d: "M19.9 14.25a8 8 0 0 0-9.15-9.15", key: "15ghsc" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.26 18.67 4 21", key: "yzmioq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M4 4 2 6", key: "1ycko6" }]
]);
const ua = n("alarm-clock-plus", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }]
]);
const yl = n("alarm-clock", [
  ["circle", { cx: "12", cy: "13", r: "8", key: "3y4lt7" }],
  ["path", { d: "M12 9v4l2 2", key: "1c63tq" }],
  ["path", { d: "M5 3 2 6", key: "18tl5t" }],
  ["path", { d: "m22 6-3-3", key: "1opdir" }],
  ["path", { d: "M6.38 18.7 4 21", key: "17xu3x" }],
  ["path", { d: "M17.64 18.67 20 21", key: "kv2oe2" }]
]);
const kl = n("alarm-smoke", [
  ["path", { d: "M11 21c0-2.5 2-2.5 2-5", key: "1sicvv" }],
  ["path", { d: "M16 21c0-2.5 2-2.5 2-5", key: "1o3eny" }],
  ["path", { d: "m19 8-.8 3a1.25 1.25 0 0 1-1.2 1H7a1.25 1.25 0 0 1-1.2-1L5 8", key: "1bvca4" }],
  [
    "path",
    { d: "M21 3a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1z", key: "x3qr1j" }
  ],
  ["path", { d: "M6 21c0-2.5 2-2.5 2-5", key: "i3w1gp" }]
]);
const ml = n("album", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["polyline", { points: "11 3 11 11 14 8 17 11 17 3", key: "1wcwz3" }]
]);
const fl = n("align-center-horizontal", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M10 16v4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-4", key: "11f1s0" }],
  ["path", { d: "M10 8V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v4", key: "t14dx9" }],
  ["path", { d: "M20 16v1a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2v-1", key: "1w07xs" }],
  ["path", { d: "M14 8V7c0-1.1.9-2 2-2h2a2 2 0 0 1 2 2v1", key: "1apec2" }]
]);
const vl = n("align-center-vertical", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M8 10H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2h4", key: "14d6g8" }],
  ["path", { d: "M16 10h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-4", key: "1e2lrw" }],
  ["path", { d: "M8 20H7a2 2 0 0 1-2-2v-2c0-1.1.9-2 2-2h1", key: "1fkdwx" }],
  ["path", { d: "M16 14h1a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-1", key: "1euafb" }]
]);
const gl = n("align-center", [
  ["path", { d: "M17 12H7", key: "16if0g" }],
  ["path", { d: "M19 18H5", key: "18s9l3" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
const Ml = n("align-end-horizontal", [
  ["rect", { width: "6", height: "16", x: "4", y: "2", rx: "2", key: "z5wdxg" }],
  ["rect", { width: "6", height: "9", x: "14", y: "9", rx: "2", key: "um7a8w" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }]
]);
const bl = n("align-end-vertical", [
  ["rect", { width: "16", height: "6", x: "2", y: "4", rx: "2", key: "10wcwx" }],
  ["rect", { width: "9", height: "6", x: "9", y: "14", rx: "2", key: "4p5bwg" }],
  ["path", { d: "M22 22V2", key: "12ipfv" }]
]);
const xl = n("align-horizontal-distribute-center", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M17 22v-5", key: "4b6g73" }],
  ["path", { d: "M17 7V2", key: "hnrr36" }],
  ["path", { d: "M7 22v-3", key: "1r4jpn" }],
  ["path", { d: "M7 5V2", key: "liy1u9" }]
]);
const wl = n("align-horizontal-distribute-end", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M10 2v20", key: "uyc634" }],
  ["path", { d: "M20 2v20", key: "1tx262" }]
]);
const Ll = n("align-horizontal-distribute-start", [
  ["rect", { width: "6", height: "14", x: "4", y: "5", rx: "2", key: "1wwnby" }],
  ["rect", { width: "6", height: "10", x: "14", y: "7", rx: "2", key: "1fe6j6" }],
  ["path", { d: "M4 2v20", key: "gtpd5x" }],
  ["path", { d: "M14 2v20", key: "tg6bpw" }]
]);
const Sl = n("align-horizontal-justify-center", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
const Il = n("align-horizontal-justify-end", [
  ["rect", { width: "6", height: "14", x: "2", y: "5", rx: "2", key: "dy24zr" }],
  ["rect", { width: "6", height: "10", x: "12", y: "7", rx: "2", key: "1ht384" }],
  ["path", { d: "M22 2v20", key: "40qfg1" }]
]);
const Cl = n("align-horizontal-justify-start", [
  ["rect", { width: "6", height: "14", x: "6", y: "5", rx: "2", key: "hsirpf" }],
  ["rect", { width: "6", height: "10", x: "16", y: "7", rx: "2", key: "13zkjt" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
const Al = n("align-horizontal-space-around", [
  ["rect", { width: "6", height: "10", x: "9", y: "7", rx: "2", key: "yn7j0q" }],
  ["path", { d: "M4 22V2", key: "tsjzd3" }],
  ["path", { d: "M20 22V2", key: "1bnhr8" }]
]);
const ql = n("align-horizontal-space-between", [
  ["rect", { width: "6", height: "14", x: "3", y: "5", rx: "2", key: "j77dae" }],
  ["rect", { width: "6", height: "10", x: "15", y: "7", rx: "2", key: "bq30hj" }],
  ["path", { d: "M3 2v20", key: "1d2pfg" }],
  ["path", { d: "M21 2v20", key: "p059bm" }]
]);
const zl = n("align-justify", [
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }]
]);
const Pl = n("align-left", [
  ["path", { d: "M15 12H3", key: "6jk70r" }],
  ["path", { d: "M17 18H3", key: "1amg6g" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
const _l = n("align-right", [
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M21 18H7", key: "1ygte8" }],
  ["path", { d: "M21 6H3", key: "1jwq7v" }]
]);
const jl = n("align-start-horizontal", [
  ["rect", { width: "6", height: "16", x: "4", y: "6", rx: "2", key: "1n4dg1" }],
  ["rect", { width: "6", height: "9", x: "14", y: "6", rx: "2", key: "17khns" }],
  ["path", { d: "M22 2H2", key: "fhrpnj" }]
]);
const Hl = n("align-start-vertical", [
  ["rect", { width: "9", height: "6", x: "6", y: "14", rx: "2", key: "lpm2y7" }],
  ["rect", { width: "16", height: "6", x: "6", y: "4", rx: "2", key: "rdj6ps" }],
  ["path", { d: "M2 2v20", key: "1ivd8o" }]
]);
const Vl = n("align-vertical-distribute-center", [
  ["path", { d: "M22 17h-3", key: "1lwga1" }],
  ["path", { d: "M22 7h-5", key: "o2endc" }],
  ["path", { d: "M5 17H2", key: "1gx9xc" }],
  ["path", { d: "M7 7H2", key: "6bq26l" }],
  ["rect", { x: "5", y: "14", width: "14", height: "6", rx: "2", key: "1qrzuf" }],
  ["rect", { x: "7", y: "4", width: "10", height: "6", rx: "2", key: "we8e9z" }]
]);
const Bl = n("align-vertical-distribute-end", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
const Dl = n("align-vertical-distribute-start", [
  ["rect", { width: "14", height: "6", x: "5", y: "14", rx: "2", key: "jmoj9s" }],
  ["rect", { width: "10", height: "6", x: "7", y: "4", rx: "2", key: "aza5on" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M2 4h20", key: "mda7wb" }]
]);
const Tl = n("align-vertical-justify-center", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
const $l = n("align-vertical-justify-end", [
  ["rect", { width: "14", height: "6", x: "5", y: "12", rx: "2", key: "4l4tp2" }],
  ["rect", { width: "10", height: "6", x: "7", y: "2", rx: "2", key: "ypihtt" }],
  ["path", { d: "M2 22h20", key: "272qi7" }]
]);
const Ol = n("align-vertical-justify-start", [
  ["rect", { width: "14", height: "6", x: "5", y: "16", rx: "2", key: "1i8z2d" }],
  ["rect", { width: "10", height: "6", x: "7", y: "6", rx: "2", key: "13squh" }],
  ["path", { d: "M2 2h20", key: "1ennik" }]
]);
const Rl = n("align-vertical-space-around", [
  ["rect", { width: "10", height: "6", x: "7", y: "9", rx: "2", key: "b1zbii" }],
  ["path", { d: "M22 20H2", key: "1p1f7z" }],
  ["path", { d: "M22 4H2", key: "1b7qnq" }]
]);
const Fl = n("align-vertical-space-between", [
  ["rect", { width: "14", height: "6", x: "5", y: "15", rx: "2", key: "1w91an" }],
  ["rect", { width: "10", height: "6", x: "7", y: "3", rx: "2", key: "17wqzy" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M2 3h20", key: "91anmk" }]
]);
const El = n("ambulance", [
  ["path", { d: "M10 10H6", key: "1bsnug" }],
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.28a1 1 0 0 0-.684-.948l-1.923-.641a1 1 0 0 1-.578-.502l-1.539-3.076A1 1 0 0 0 16.382 8H14",
      key: "lrkjwd"
    }
  ],
  ["path", { d: "M8 8v4", key: "1fwk8c" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
const Ul = n("ampersand", [
  [
    "path",
    {
      d: "M17.5 12c0 4.4-3.6 8-8 8A4.5 4.5 0 0 1 5 15.5c0-6 8-4 8-8.5a3 3 0 1 0-6 0c0 3 2.5 8.5 12 13",
      key: "1o9ehi"
    }
  ],
  ["path", { d: "M16 12h3", key: "4uvgyw" }]
]);
const Nl = n("ampersands", [
  [
    "path",
    {
      d: "M10 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "12lh1k"
    }
  ],
  [
    "path",
    {
      d: "M22 17c-5-3-7-7-7-9a2 2 0 0 1 4 0c0 2.5-5 2.5-5 6 0 1.7 1.3 3 3 3 2.8 0 5-2.2 5-5",
      key: "173c68"
    }
  ]
]);
const Wl = n("amphora", [
  [
    "path",
    { d: "M10 2v5.632c0 .424-.272.795-.653.982A6 6 0 0 0 6 14c.006 4 3 7 5 8", key: "1h8rid" }
  ],
  ["path", { d: "M10 5H8a2 2 0 0 0 0 4h.68", key: "3ezsi6" }],
  ["path", { d: "M14 2v5.632c0 .424.272.795.652.982A6 6 0 0 1 18 14c0 4-3 7-5 8", key: "yt6q09" }],
  ["path", { d: "M14 5h2a2 2 0 0 1 0 4h-.68", key: "8f95yk" }],
  ["path", { d: "M18 22H6", key: "mg6kv4" }],
  ["path", { d: "M9 2h6", key: "1jrp98" }]
]);
const Gl = n("anchor", [
  ["path", { d: "M12 22V8", key: "qkxhtm" }],
  ["path", { d: "M5 12H2a10 10 0 0 0 20 0h-3", key: "1hv3nh" }],
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }]
]);
const Zl = n("angry", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["path", { d: "M7.5 8 10 9", key: "olxxln" }],
  ["path", { d: "m14 9 2.5-1", key: "1j6cij" }],
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }]
]);
const Yl = n("annoyed", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M14 9h2", key: "116p9w" }]
]);
const Kl = n("antenna", [
  ["path", { d: "M2 12 7 2", key: "117k30" }],
  ["path", { d: "m7 12 5-10", key: "1tvx22" }],
  ["path", { d: "m12 12 5-10", key: "ev1o1a" }],
  ["path", { d: "m17 12 5-10", key: "1e4ti3" }],
  ["path", { d: "M4.5 7h15", key: "vlsxkz" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
const Xl = n("anvil", [
  ["path", { d: "M7 10H6a4 4 0 0 1-4-4 1 1 0 0 1 1-1h4", key: "1hjpb6" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1 7 7 0 0 1-7 7H8a1 1 0 0 1-1-1z", key: "1qn45f" }
  ],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  [
    "path",
    { d: "M5 20a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3 1 1 0 0 1-1 1H6a1 1 0 0 1-1-1", key: "1fi4x8" }
  ]
]);
const Ql = n("aperture", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14.31 8 5.74 9.94", key: "1y6ab4" }],
  ["path", { d: "M9.69 8h11.48", key: "1wxppr" }],
  ["path", { d: "m7.38 12 5.74-9.94", key: "1grp0k" }],
  ["path", { d: "M9.69 16 3.95 6.06", key: "libnyf" }],
  ["path", { d: "M14.31 16H2.83", key: "x5fava" }],
  ["path", { d: "m16.62 12-5.74 9.94", key: "1vwawt" }]
]);
const Jl = n("app-window-mac", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M14 8h.01", key: "1primd" }]
]);
const ei = n("app-window", [
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }],
  ["path", { d: "M10 4v4", key: "pp8u80" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["path", { d: "M6 4v4", key: "1svtjw" }]
]);
const ti = n("apple", [
  [
    "path",
    {
      d: "M12 20.94c1.5 0 2.75 1.06 4 1.06 3 0 6-8 6-12.22A4.91 4.91 0 0 0 17 5c-2.22 0-4 1.44-5 2-1-.56-2.78-2-5-2a4.9 4.9 0 0 0-5 4.78C2 14 5 22 8 22c1.25 0 2.5-1.06 4-1.06Z",
      key: "3s7exb"
    }
  ],
  ["path", { d: "M10 2c1 .5 2 2 2 5", key: "fcco2y" }]
]);
const ai = n("archive-restore", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h2", key: "tvwodi" }],
  ["path", { d: "M20 8v11a2 2 0 0 1-2 2h-2", key: "1gkqxj" }],
  ["path", { d: "m9 15 3-3 3 3", key: "1pd0qc" }],
  ["path", { d: "M12 12v9", key: "192myk" }]
]);
const ni = n("archive-x", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "m9.5 17 5-5", key: "nakeu6" }],
  ["path", { d: "m9.5 12 5 5", key: "1hccrj" }]
]);
const oi = n("archive", [
  ["rect", { width: "20", height: "5", x: "2", y: "3", rx: "1", key: "1wp1u1" }],
  ["path", { d: "M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8", key: "1s80jp" }],
  ["path", { d: "M10 12h4", key: "a56b0p" }]
]);
const ri = n("armchair", [
  ["path", { d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3", key: "irtipd" }],
  [
    "path",
    {
      d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "1qyhux"
    }
  ],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
const li = n("arrow-big-down-dash", [
  ["path", { d: "M15 5H9", key: "1tp3ed" }],
  ["path", { d: "M15 9v3h4l-7 7-7-7h4V9z", key: "ncdc4b" }]
]);
const ii = n("arrow-big-down", [
  ["path", { d: "M15 6v6h4l-7 7-7-7h4V6h6z", key: "1thax2" }]
]);
const ci = n("arrow-big-left-dash", [
  ["path", { d: "M19 15V9", key: "1hci5f" }],
  ["path", { d: "M15 15h-3v4l-7-7 7-7v4h3v6z", key: "16tjna" }]
]);
const di = n("arrow-big-left", [
  ["path", { d: "M18 15h-6v4l-7-7 7-7v4h6v6z", key: "lbrdak" }]
]);
const si = n("arrow-big-right-dash", [
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["path", { d: "M9 9h3V5l7 7-7 7v-4H9V9z", key: "1sg2xn" }]
]);
const ui = n("arrow-big-right", [
  ["path", { d: "M6 9h6V5l7 7-7 7v-4H6V9z", key: "7fvt9c" }]
]);
const hi = n("arrow-big-up-dash", [
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["path", { d: "M9 15v-3H5l7-7 7 7h-4v3H9z", key: "1r2uve" }]
]);
const pi = n("arrow-big-up", [
  ["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z", key: "1x06kx" }]
]);
const yi = n("arrow-down-0-1", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
const ki = n("arrow-down-1-0", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
const ha = n("arrow-down-a-z", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
const mi = n("arrow-down-from-line", [
  ["path", { d: "M19 3H5", key: "1236rx" }],
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m6 15 6 6 6-6", key: "h15q88" }]
]);
const fi = n("arrow-down-left", [
  ["path", { d: "M17 7 7 17", key: "15tmo1" }],
  ["path", { d: "M17 17H7V7", key: "1org7z" }]
]);
const vi = n("arrow-down-narrow-wide", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h4", key: "6d7r33" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h10", key: "1438ji" }]
]);
const gi = n("arrow-down-right", [
  ["path", { d: "m7 7 10 10", key: "1fmybs" }],
  ["path", { d: "M17 7v10H7", key: "6fjiku" }]
]);
const Mi = n("arrow-down-to-dot", [
  ["path", { d: "M12 2v14", key: "jyx4ut" }],
  ["path", { d: "m19 9-7 7-7-7", key: "1oe3oy" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
const bi = n("arrow-down-to-line", [
  ["path", { d: "M12 17V3", key: "1cwfxf" }],
  ["path", { d: "m6 11 6 6 6-6", key: "12ii2o" }],
  ["path", { d: "M19 21H5", key: "150jfl" }]
]);
const xi = n("arrow-down-up", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "m21 8-4-4-4 4", key: "1c9v7m" }],
  ["path", { d: "M17 4v16", key: "7dpous" }]
]);
const pa = n("arrow-down-wide-narrow", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 20V4", key: "1yoxec" }],
  ["path", { d: "M11 4h10", key: "1w87gc" }],
  ["path", { d: "M11 8h7", key: "djye34" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }]
]);
const ya = n("arrow-down-z-a", [
  ["path", { d: "m3 16 4 4 4-4", key: "1co6wj" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
const wi = n("arrow-down", [
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
]);
const Li = n("arrow-left-from-line", [
  ["path", { d: "m9 6-6 6 6 6", key: "7v63n9" }],
  ["path", { d: "M3 12h14", key: "13k4hi" }],
  ["path", { d: "M21 19V5", key: "b4bplr" }]
]);
const Si = n("arrow-left-right", [
  ["path", { d: "M8 3 4 7l4 4", key: "9rb6wj" }],
  ["path", { d: "M4 7h16", key: "6tx8e3" }],
  ["path", { d: "m16 21 4-4-4-4", key: "siv7j2" }],
  ["path", { d: "M20 17H4", key: "h6l3hr" }]
]);
const Ii = n("arrow-left-to-line", [
  ["path", { d: "M3 19V5", key: "rwsyhb" }],
  ["path", { d: "m13 6-6 6 6 6", key: "1yhaz7" }],
  ["path", { d: "M7 12h14", key: "uoisry" }]
]);
const Ci = n("arrow-left", [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
]);
const Ai = n("arrow-right-from-line", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M21 12H7", key: "13ipq5" }],
  ["path", { d: "m15 18 6-6-6-6", key: "6tx3qv" }]
]);
const qi = n("arrow-right-left", [
  ["path", { d: "m16 3 4 4-4 4", key: "1x1c3m" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "m8 21-4-4 4-4", key: "h9nckh" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
const zi = n("arrow-right-to-line", [
  ["path", { d: "M17 12H3", key: "8awo09" }],
  ["path", { d: "m11 18 6-6-6-6", key: "8c2y43" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
const Pi = n("arrow-right", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
]);
const _i = n("arrow-up-0-1", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["rect", { x: "15", y: "4", width: "4", height: "6", ry: "2", key: "1bwicg" }],
  ["path", { d: "M17 20v-6h-2", key: "1qp1so" }],
  ["path", { d: "M15 20h4", key: "1j968p" }]
]);
const ji = n("arrow-up-1-0", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M17 10V4h-2", key: "zcsr5x" }],
  ["path", { d: "M15 10h4", key: "id2lce" }],
  ["rect", { x: "15", y: "14", width: "4", height: "6", ry: "2", key: "33xykx" }]
]);
const ka = n("arrow-up-a-z", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M20 8h-5", key: "1vsyxs" }],
  ["path", { d: "M15 10V6.5a2.5 2.5 0 0 1 5 0V10", key: "ag13bf" }],
  ["path", { d: "M15 14h5l-5 6h5", key: "ur5jdg" }]
]);
const Hi = n("arrow-up-down", [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
]);
const Vi = n("arrow-up-from-dot", [
  ["path", { d: "m5 9 7-7 7 7", key: "1hw5ic" }],
  ["path", { d: "M12 16V2", key: "ywoabb" }],
  ["circle", { cx: "12", cy: "21", r: "1", key: "o0uj5v" }]
]);
const Bi = n("arrow-up-from-line", [
  ["path", { d: "m18 9-6-6-6 6", key: "kcunyi" }],
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
const Di = n("arrow-up-left", [
  ["path", { d: "M7 17V7h10", key: "11bw93" }],
  ["path", { d: "M17 17 7 7", key: "2786uv" }]
]);
const ma = n("arrow-up-narrow-wide", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h4", key: "q8tih4" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h10", key: "jvxblo" }]
]);
const Ti = n("arrow-up-right", [
  ["path", { d: "M7 7h10v10", key: "1tivn9" }],
  ["path", { d: "M7 17 17 7", key: "1vkiza" }]
]);
const $i = n("arrow-up-to-line", [
  ["path", { d: "M5 3h14", key: "7usisc" }],
  ["path", { d: "m18 13-6-6-6 6", key: "1kf1n9" }],
  ["path", { d: "M12 7v14", key: "1akyts" }]
]);
const Oi = n("arrow-up-wide-narrow", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M11 12h10", key: "1438ji" }],
  ["path", { d: "M11 16h7", key: "uosisv" }],
  ["path", { d: "M11 20h4", key: "1krc32" }]
]);
const fa = n("arrow-up-z-a", [
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }],
  ["path", { d: "M15 4h5l-5 6h5", key: "8asdl1" }],
  ["path", { d: "M15 20v-3.5a2.5 2.5 0 0 1 5 0V20", key: "r6l5cz" }],
  ["path", { d: "M20 18h-5", key: "18j1r2" }]
]);
const Ri = n("arrow-up", [
  ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
  ["path", { d: "M12 19V5", key: "x0mq9r" }]
]);
const Fi = n("arrows-up-from-line", [
  ["path", { d: "m4 6 3-3 3 3", key: "9aidw8" }],
  ["path", { d: "M7 17V3", key: "19qxw1" }],
  ["path", { d: "m14 6 3-3 3 3", key: "6iy689" }],
  ["path", { d: "M17 17V3", key: "o0fmgi" }],
  ["path", { d: "M4 21h16", key: "1h09gz" }]
]);
const Ei = n("asterisk", [
  ["path", { d: "M12 6v12", key: "1vza4d" }],
  ["path", { d: "M17.196 9 6.804 15", key: "1ah31z" }],
  ["path", { d: "m6.804 9 10.392 6", key: "1b6pxd" }]
]);
const Ui = n("at-sign", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-4 8", key: "7n84p3" }]
]);
const Ni = n("atom", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M20.2 20.2c2.04-2.03.02-7.36-4.5-11.9-4.54-4.52-9.87-6.54-11.9-4.5-2.04 2.03-.02 7.36 4.5 11.9 4.54 4.52 9.87 6.54 11.9 4.5Z",
      key: "1l2ple"
    }
  ],
  [
    "path",
    {
      d: "M15.7 15.7c4.52-4.54 6.54-9.87 4.5-11.9-2.03-2.04-7.36-.02-11.9 4.5-4.52 4.54-6.54 9.87-4.5 11.9 2.03 2.04 7.36.02 11.9-4.5Z",
      key: "1wam0m"
    }
  ]
]);
const Wi = n("audio-lines", [
  ["path", { d: "M2 10v3", key: "1fnikh" }],
  ["path", { d: "M6 6v11", key: "11sgs0" }],
  ["path", { d: "M10 3v18", key: "yhl04a" }],
  ["path", { d: "M14 8v7", key: "3a1oy3" }],
  ["path", { d: "M18 5v13", key: "123xd1" }],
  ["path", { d: "M22 10v3", key: "154ddg" }]
]);
const Gi = n("audio-waveform", [
  [
    "path",
    {
      d: "M2 13a2 2 0 0 0 2-2V7a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0V4a2 2 0 0 1 4 0v13a2 2 0 0 0 4 0v-4a2 2 0 0 1 2-2",
      key: "57tc96"
    }
  ]
]);
const Zi = n("award", [
  [
    "path",
    {
      d: "m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526",
      key: "1yiouv"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "6", key: "1vp47v" }]
]);
const Yi = n("axe", [
  ["path", { d: "m14 12-8.5 8.5a2.12 2.12 0 1 1-3-3L11 9", key: "csbz4o" }],
  ["path", { d: "M15 13 9 7l4-4 6 6h3a8 8 0 0 1-7 7z", key: "113wfo" }]
]);
const va = n("axis-3d", [
  ["path", { d: "M4 4v16h16", key: "1s015l" }],
  ["path", { d: "m4 20 7-7", key: "17qe9y" }]
]);
const Ki = n("baby", [
  ["path", { d: "M9 12h.01", key: "157uk2" }],
  ["path", { d: "M15 12h.01", key: "1k8ypt" }],
  ["path", { d: "M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5", key: "1u7htd" }],
  [
    "path",
    {
      d: "M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 2.5-2 2.5c-.8 0-1.5-.4-1.5-1",
      key: "5yv0yz"
    }
  ]
]);
const Xi = n("backpack", [
  [
    "path",
    { d: "M4 10a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z", key: "1ol0lm" }
  ],
  ["path", { d: "M8 10h8", key: "c7uz4u" }],
  ["path", { d: "M8 18h8", key: "1no2b1" }],
  ["path", { d: "M8 22v-6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v6", key: "1fr6do" }],
  ["path", { d: "M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2", key: "donm21" }]
]);
const Qi = n("badge-alert", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
const Ji = n("badge-cent", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M15.4 10a4 4 0 1 0 0 4", key: "2eqtx8" }]
]);
const ga = n("badge-check", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const e2 = n("badge-dollar-sign", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
const t2 = n("badge-euro", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M7 12h5", key: "gblrwe" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
const a2 = n("badge-help", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["line", { x1: "12", x2: "12.01", y1: "17", y2: "17", key: "io3f8k" }]
]);
const n2 = n("badge-indian-rupee", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 8h8", key: "1bis0t" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m13 17-5-1h1a4 4 0 0 0 0-8", key: "nu2bwa" }]
]);
const o2 = n("badge-info", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "12", key: "1y1yb1" }],
  ["line", { x1: "12", x2: "12.01", y1: "8", y2: "8", key: "110wyk" }]
]);
const r2 = n("badge-japanese-yen", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 8 3 3v7", key: "17yadx" }],
  ["path", { d: "m12 11 3-3", key: "p4cfq1" }],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M9 16h6", key: "8wimt3" }]
]);
const l2 = n("badge-minus", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
const i2 = n("badge-percent", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
const c2 = n("badge-plus", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "16", key: "10p56q" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
const d2 = n("badge-pound-sterling", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M8 12h4", key: "qz6y1c" }],
  ["path", { d: "M10 16V9.5a2.5 2.5 0 0 1 5 0", key: "3mlbjk" }],
  ["path", { d: "M8 16h7", key: "sbedsn" }]
]);
const s2 = n("badge-russian-ruble", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M9 16h5", key: "1syiyw" }],
  ["path", { d: "M9 12h5a2 2 0 1 0 0-4h-3v9", key: "1ge9c1" }]
]);
const u2 = n("badge-swiss-franc", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "M11 17V8h4", key: "1bfq6y" }],
  ["path", { d: "M11 12h3", key: "2eqnfz" }],
  ["path", { d: "M9 16h4", key: "1skf3a" }]
]);
const h2 = n("badge-x", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
const p2 = n("badge", [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ]
]);
const y2 = n("baggage-claim", [
  ["path", { d: "M22 18H6a2 2 0 0 1-2-2V7a2 2 0 0 0-2-2", key: "4irg2o" }],
  ["path", { d: "M17 14V4a2 2 0 0 0-2-2h-1a2 2 0 0 0-2 2v10", key: "14fcyx" }],
  ["rect", { width: "13", height: "8", x: "8", y: "6", rx: "1", key: "o6oiis" }],
  ["circle", { cx: "18", cy: "20", r: "2", key: "t9985n" }],
  ["circle", { cx: "9", cy: "20", r: "2", key: "e5v82j" }]
]);
const k2 = n("ban", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.9 4.9 14.2 14.2", key: "1m5liu" }]
]);
const m2 = n("banana", [
  ["path", { d: "M4 13c3.5-2 8-2 10 2a5.5 5.5 0 0 1 8 5", key: "1cscit" }],
  [
    "path",
    {
      d: "M5.15 17.89c5.52-1.52 8.65-6.89 7-12C11.55 4 11.5 2 13 2c3.22 0 5 5.5 5 8 0 6.5-4.2 12-10.49 12C5.11 22 2 22 2 20c0-1.5 1.14-1.55 3.15-2.11Z",
      key: "1y1nbv"
    }
  ]
]);
const f2 = n("bandage", [
  ["path", { d: "M10 10.01h.01", key: "1e9xi7" }],
  ["path", { d: "M10 14.01h.01", key: "ac23bv" }],
  ["path", { d: "M14 10.01h.01", key: "2wfrvf" }],
  ["path", { d: "M14 14.01h.01", key: "8tw8yn" }],
  ["path", { d: "M18 6v11.5", key: "dkbidh" }],
  ["path", { d: "M6 6v12", key: "vkc79e" }],
  ["rect", { x: "2", y: "6", width: "20", height: "12", rx: "2", key: "1wpnh2" }]
]);
const v2 = n("banknote-arrow-down", [
  ["path", { d: "M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5", key: "x6cv4u" }],
  ["path", { d: "m16 19 3 3 3-3", key: "1ibux0" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M6 12h.01", key: "c2rlol" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const g2 = n("banknote-arrow-up", [
  ["path", { d: "M12 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5", key: "x6cv4u" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  ["path", { d: "M19 22v-6", key: "qhmiwi" }],
  ["path", { d: "m22 19-3-3-3 3", key: "rn6bg2" }],
  ["path", { d: "M6 12h.01", key: "c2rlol" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const M2 = n("banknote-x", [
  ["path", { d: "M13 18H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5", key: "16nib6" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }],
  ["path", { d: "M6 12h.01", key: "c2rlol" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const b2 = n("banknote", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M6 12h.01M18 12h.01", key: "113zkx" }]
]);
const x2 = n("barcode", [
  ["path", { d: "M3 5v14", key: "1nt18q" }],
  ["path", { d: "M8 5v14", key: "1ybrkv" }],
  ["path", { d: "M12 5v14", key: "s699le" }],
  ["path", { d: "M17 5v14", key: "ycjyhj" }],
  ["path", { d: "M21 5v14", key: "nzette" }]
]);
const w2 = n("baseline", [
  ["path", { d: "M4 20h16", key: "14thso" }],
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const L2 = n("bath", [
  ["path", { d: "M10 4 8 6", key: "1rru8s" }],
  ["path", { d: "M17 19v2", key: "ts1sot" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M7 19v2", key: "12npes" }],
  [
    "path",
    {
      d: "M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5",
      key: "14ym8i"
    }
  ]
]);
const S2 = n("battery-charging", [
  ["path", { d: "M15 7h1a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1sdynx" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h1", key: "1gkd3k" }],
  ["path", { d: "m11 7-3 5h4l-3 5", key: "b4a64w" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
const I2 = n("battery-full", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "13", key: "c6fn6x" }]
]);
const C2 = n("battery-low", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }]
]);
const A2 = n("battery-medium", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }],
  ["line", { x1: "6", x2: "6", y1: "11", y2: "13", key: "1wd6dw" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "13", key: "haxvl5" }]
]);
const q2 = n("battery-plus", [
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["path", { d: "M13.5 7H16a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2.5", key: "jzl4pj" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6.5 17H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2.5", key: "1ar5vp" }],
  ["path", { d: "M7 12h6", key: "iekk3h" }]
]);
const z2 = n("battery-warning", [
  ["path", { d: "M10 17h.01", key: "nbq80n" }],
  ["path", { d: "M10 7v6", key: "nne03l" }],
  ["path", { d: "M14 7h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2", key: "1x5o8m" }],
  ["path", { d: "M22 11v2", key: "1wo06k" }],
  ["path", { d: "M6 7H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "1mdjgh" }]
]);
const P2 = n("battery", [
  ["rect", { width: "16", height: "10", x: "2", y: "7", rx: "2", ry: "2", key: "1w10f2" }],
  ["line", { x1: "22", x2: "22", y1: "11", y2: "13", key: "4dh1rd" }]
]);
const _2 = n("beaker", [
  ["path", { d: "M4.5 3h15", key: "c7n0jr" }],
  ["path", { d: "M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3", key: "m1uhx7" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }]
]);
const j2 = n("bean-off", [
  [
    "path",
    {
      d: "M9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22a13.96 13.96 0 0 0 9.9-4.1",
      key: "bq3udt"
    }
  ],
  ["path", { d: "M10.75 5.093A6 6 0 0 1 22 8c0 2.411-.61 4.68-1.683 6.66", key: "17ccse" }],
  [
    "path",
    {
      d: "M5.341 10.62a4 4 0 0 0 6.487 1.208M10.62 5.341a4.015 4.015 0 0 1 2.039 2.04",
      key: "18zqgq"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const H2 = n("bean", [
  [
    "path",
    {
      d: "M10.165 6.598C9.954 7.478 9.64 8.36 9 9c-.64.64-1.521.954-2.402 1.165A6 6 0 0 0 8 22c7.732 0 14-6.268 14-14a6 6 0 0 0-11.835-1.402Z",
      key: "1tvzk7"
    }
  ],
  ["path", { d: "M5.341 10.62a4 4 0 1 0 5.279-5.28", key: "2cyri2" }]
]);
const V2 = n("bed-double", [
  ["path", { d: "M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8", key: "1k78r4" }],
  ["path", { d: "M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "fb3tl2" }],
  ["path", { d: "M12 4v6", key: "1dcgq2" }],
  ["path", { d: "M2 18h20", key: "ajqnye" }]
]);
const B2 = n("bed-single", [
  ["path", { d: "M3 20v-8a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8", key: "1wm6mi" }],
  ["path", { d: "M5 10V6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4", key: "4k93s5" }],
  ["path", { d: "M3 18h18", key: "1h113x" }]
]);
const D2 = n("bed", [
  ["path", { d: "M2 4v16", key: "vw9hq8" }],
  ["path", { d: "M2 8h18a2 2 0 0 1 2 2v10", key: "1dgv2r" }],
  ["path", { d: "M2 17h20", key: "18nfp3" }],
  ["path", { d: "M6 8v9", key: "1yriud" }]
]);
const T2 = n("beef", [
  [
    "path",
    {
      d: "M16.4 13.7A6.5 6.5 0 1 0 6.28 6.6c-1.1 3.13-.78 3.9-3.18 6.08A3 3 0 0 0 5 18c4 0 8.4-1.8 11.4-4.3",
      key: "cisjcv"
    }
  ],
  [
    "path",
    {
      d: "m18.5 6 2.19 4.5a6.48 6.48 0 0 1-2.29 7.2C15.4 20.2 11 22 7 22a3 3 0 0 1-2.68-1.66L2.4 16.5",
      key: "5byaag"
    }
  ],
  ["circle", { cx: "12.5", cy: "8.5", r: "2.5", key: "9738u8" }]
]);
const $2 = n("beer-off", [
  ["path", { d: "M13 13v5", key: "igwfh0" }],
  ["path", { d: "M17 11.47V8", key: "16yw0g" }],
  ["path", { d: "M17 11h1a3 3 0 0 1 2.745 4.211", key: "1xbt65" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-3", key: "c55o3e" }],
  [
    "path",
    { d: "M7.536 7.535C6.766 7.649 6.154 8 5.5 8a2.5 2.5 0 0 1-1.768-4.268", key: "1ydug7" }
  ],
  [
    "path",
    {
      d: "M8.727 3.204C9.306 2.767 9.885 2 11 2c1.56 0 2 1.5 3 1.5s1.72-.5 2.5-.5a1 1 0 1 1 0 5c-.78 0-1.5-.5-2.5-.5a3.149 3.149 0 0 0-.842.12",
      key: "q81o7q"
    }
  ],
  ["path", { d: "M9 14.6V18", key: "20ek98" }]
]);
const O2 = n("beer", [
  ["path", { d: "M17 11h1a3 3 0 0 1 0 6h-1", key: "1yp76v" }],
  ["path", { d: "M9 12v6", key: "1u1cab" }],
  ["path", { d: "M13 12v6", key: "1sugkk" }],
  [
    "path",
    {
      d: "M14 7.5c-1 0-1.44.5-3 .5s-2-.5-3-.5-1.72.5-2.5.5a2.5 2.5 0 0 1 0-5c.78 0 1.57.5 2.5.5S9.44 2 11 2s2 1.5 3 1.5 1.72-.5 2.5-.5a2.5 2.5 0 0 1 0 5c-.78 0-1.5-.5-2.5-.5Z",
      key: "1510fo"
    }
  ],
  ["path", { d: "M5 8v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8", key: "19jb7n" }]
]);
const R2 = n("bell-dot", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M13.916 2.314A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.74 7.327A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673 9 9 0 0 1-.585-.665",
      key: "1tip0g"
    }
  ],
  ["circle", { cx: "18", cy: "8", r: "3", key: "1g0gzu" }]
]);
const F2 = n("bell-electric", [
  ["path", { d: "M18.8 4A6.3 8.7 0 0 1 20 9", key: "xve1fh" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["rect", { width: "10", height: "6", x: "4", y: "16", rx: "2", key: "17f3te" }],
  ["path", { d: "M14 19c3 0 4.6-1.6 4.6-1.6", key: "n7odp6" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }]
]);
const E2 = n("bell-minus", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  [
    "path",
    {
      d: "M16.243 3.757A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673A9.4 9.4 0 0 1 18.667 12",
      key: "bdwj86"
    }
  ]
]);
const U2 = n("bell-off", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M17 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 .258-1.742",
      key: "178tsu"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.668 3.01A6 6 0 0 1 18 8c0 2.687.77 4.653 1.707 6.05", key: "1hqiys" }]
]);
const N2 = n("bell-plus", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }],
  [
    "path",
    {
      d: "M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332",
      key: "1abcvy"
    }
  ]
]);
const W2 = n("bell-ring", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M22 8c0-2.3-.8-4.3-2-6", key: "5bb3ad" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ],
  ["path", { d: "M4 2C2.8 3.7 2 5.7 2 8", key: "tap9e0" }]
]);
const G2 = n("bell", [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
]);
const Ma = n("between-horizontal-end", [
  ["rect", { width: "13", height: "7", x: "3", y: "3", rx: "1", key: "11xb64" }],
  ["path", { d: "m22 15-3-3 3-3", key: "26chmm" }],
  ["rect", { width: "13", height: "7", x: "3", y: "14", rx: "1", key: "k6ky7n" }]
]);
const ba = n("between-horizontal-start", [
  ["rect", { width: "13", height: "7", x: "8", y: "3", rx: "1", key: "pkso9a" }],
  ["path", { d: "m2 9 3 3-3 3", key: "1agib5" }],
  ["rect", { width: "13", height: "7", x: "8", y: "14", rx: "1", key: "1q5fc1" }]
]);
const Z2 = n("between-vertical-end", [
  ["rect", { width: "7", height: "13", x: "3", y: "3", rx: "1", key: "1fdu0f" }],
  ["path", { d: "m9 22 3-3 3 3", key: "17z65a" }],
  ["rect", { width: "7", height: "13", x: "14", y: "3", rx: "1", key: "1squn4" }]
]);
const Y2 = n("between-vertical-start", [
  ["rect", { width: "7", height: "13", x: "3", y: "8", rx: "1", key: "1fjrkv" }],
  ["path", { d: "m15 2-3 3-3-3", key: "1uh6eb" }],
  ["rect", { width: "7", height: "13", x: "14", y: "8", rx: "1", key: "w3fjg8" }]
]);
const K2 = n("biceps-flexed", [
  [
    "path",
    {
      d: "M12.409 13.017A5 5 0 0 1 22 15c0 3.866-4 7-9 7-4.077 0-8.153-.82-10.371-2.462-.426-.316-.631-.832-.62-1.362C2.118 12.723 2.627 2 10 2a3 3 0 0 1 3 3 2 2 0 0 1-2 2c-1.105 0-1.64-.444-2-1",
      key: "1pmlyh"
    }
  ],
  ["path", { d: "M15 14a5 5 0 0 0-7.584 2", key: "5rb254" }],
  ["path", { d: "M9.964 6.825C8.019 7.977 9.5 13 8 15", key: "kbvsx9" }]
]);
const X2 = n("bike", [
  ["circle", { cx: "18.5", cy: "17.5", r: "3.5", key: "15x4ox" }],
  ["circle", { cx: "5.5", cy: "17.5", r: "3.5", key: "1noe27" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["path", { d: "M12 17.5V14l-3-3 4-3 2 3h2", key: "1npguv" }]
]);
const Q2 = n("binary", [
  ["rect", { x: "14", y: "14", width: "4", height: "6", rx: "2", key: "p02svl" }],
  ["rect", { x: "6", y: "4", width: "4", height: "6", rx: "2", key: "xm4xkj" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 10h4", key: "ru81e7" }],
  ["path", { d: "M6 14h2v6", key: "16z9wg" }],
  ["path", { d: "M14 4h2v6", key: "1idq9u" }]
]);
const J2 = n("binoculars", [
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M19 7V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3", key: "3apit1" }],
  [
    "path",
    {
      d: "M20 21a2 2 0 0 0 2-2v-3.851c0-1.39-2-2.962-2-4.829V8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2z",
      key: "rhpgnw"
    }
  ],
  ["path", { d: "M 22 16 L 2 16", key: "14lkq7" }],
  [
    "path",
    {
      d: "M4 21a2 2 0 0 1-2-2v-3.851c0-1.39 2-2.962 2-4.829V8a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11a2 2 0 0 1-2 2z",
      key: "104b3k"
    }
  ],
  ["path", { d: "M9 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3", key: "14fczp" }]
]);
const ec = n("biohazard", [
  ["circle", { cx: "12", cy: "11.9", r: "2", key: "e8h31w" }],
  ["path", { d: "M6.7 3.4c-.9 2.5 0 5.2 2.2 6.7C6.5 9 3.7 9.6 2 11.6", key: "17bolr" }],
  ["path", { d: "m8.9 10.1 1.4.8", key: "15ezny" }],
  ["path", { d: "M17.3 3.4c.9 2.5 0 5.2-2.2 6.7 2.4-1.2 5.2-.6 6.9 1.5", key: "wtwa5u" }],
  ["path", { d: "m15.1 10.1-1.4.8", key: "1r0b28" }],
  ["path", { d: "M16.7 20.8c-2.6-.4-4.6-2.6-4.7-5.3-.2 2.6-2.1 4.8-4.7 5.2", key: "m7qszh" }],
  ["path", { d: "M12 13.9v1.6", key: "zfyyim" }],
  ["path", { d: "M13.5 5.4c-1-.2-2-.2-3 0", key: "1bi9q0" }],
  ["path", { d: "M17 16.4c.7-.7 1.2-1.6 1.5-2.5", key: "1rhjqw" }],
  ["path", { d: "M5.5 13.9c.3.9.8 1.8 1.5 2.5", key: "8gsud3" }]
]);
const tc = n("bird", [
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20", key: "oj1oa8" }],
  ["path", { d: "m20 7 2 .5-2 .5", key: "12nv4d" }],
  ["path", { d: "M10 18v3", key: "1yea0a" }],
  ["path", { d: "M14 17.75V21", key: "1pymcb" }],
  ["path", { d: "M7 18a6 6 0 0 0 3.84-10.61", key: "1npnn0" }]
]);
const ac = n("bitcoin", [
  [
    "path",
    {
      d: "M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727",
      key: "yr8idg"
    }
  ]
]);
const nc = n("blend", [
  ["circle", { cx: "9", cy: "9", r: "7", key: "p2h5vp" }],
  ["circle", { cx: "15", cy: "15", r: "7", key: "19ennj" }]
]);
const oc = n("blinds", [
  ["path", { d: "M3 3h18", key: "o7r712" }],
  ["path", { d: "M20 7H8", key: "gd2fo2" }],
  ["path", { d: "M20 11H8", key: "1ynp89" }],
  ["path", { d: "M10 19h10", key: "19hjk5" }],
  ["path", { d: "M8 15h12", key: "1yqzne" }],
  ["path", { d: "M4 3v14", key: "fggqzn" }],
  ["circle", { cx: "4", cy: "19", r: "2", key: "p3m9r0" }]
]);
const rc = n("blocks", [
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  [
    "path",
    {
      d: "M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3",
      key: "1fpvtg"
    }
  ]
]);
const lc = n("bluetooth-connected", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "12", key: "1rsjjs" }],
  ["line", { x1: "3", x2: "6", y1: "12", y2: "12", key: "11yl8c" }]
]);
const ic = n("bluetooth-off", [
  ["path", { d: "m17 17-5 5V12l-5 5", key: "v5aci6" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M14.5 9.5 17 7l-5-5v4.5", key: "1kddfz" }]
]);
const cc = n("bluetooth", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }]
]);
const dc = n("bluetooth-searching", [
  ["path", { d: "m7 7 10 10-5 5V2l5 5L7 17", key: "1q5490" }],
  ["path", { d: "M20.83 14.83a4 4 0 0 0 0-5.66", key: "k8tn1j" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
const sc = n("bold", [
  [
    "path",
    { d: "M6 12h9a4 4 0 0 1 0 8H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a4 4 0 0 1 0 8", key: "mg9rjx" }
  ]
]);
const uc = n("bolt", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
const hc = n("bomb", [
  ["circle", { cx: "11", cy: "13", r: "9", key: "hd149" }],
  [
    "path",
    {
      d: "M14.35 4.65 16.3 2.7a2.41 2.41 0 0 1 3.4 0l1.6 1.6a2.4 2.4 0 0 1 0 3.4l-1.95 1.95",
      key: "jp4j1b"
    }
  ],
  ["path", { d: "m22 2-1.5 1.5", key: "ay92ug" }]
]);
const pc = n("bone", [
  [
    "path",
    {
      d: "M17 10c.7-.7 1.69 0 2.5 0a2.5 2.5 0 1 0 0-5 .5.5 0 0 1-.5-.5 2.5 2.5 0 1 0-5 0c0 .81.7 1.8 0 2.5l-7 7c-.7.7-1.69 0-2.5 0a2.5 2.5 0 0 0 0 5c.28 0 .5.22.5.5a2.5 2.5 0 1 0 5 0c0-.81-.7-1.8 0-2.5Z",
      key: "w610uw"
    }
  ]
]);
const yc = n("book-a", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m8 13 4-7 4 7", key: "4rari8" }],
  ["path", { d: "M9.1 11h5.7", key: "1gkovt" }]
]);
const kc = n("book-audio", [
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8v3", key: "gejaml" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 8v3", key: "1qzp49" }]
]);
const mc = n("book-check", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 9.5 2 2 4-4", key: "1dth82" }]
]);
const fc = n("book-copy", [
  ["path", { d: "M2 16V4a2 2 0 0 1 2-2h11", key: "spzkk5" }],
  [
    "path",
    {
      d: "M22 18H11a2 2 0 1 0 0 4h10.5a.5.5 0 0 0 .5-.5v-15a.5.5 0 0 0-.5-.5H11a2 2 0 0 0-2 2v12",
      key: "1wz07i"
    }
  ],
  ["path", { d: "M5 14H4a2 2 0 1 0 0 4h1", key: "16gqf9" }]
]);
const xa = n("book-dashed", [
  ["path", { d: "M12 17h1.5", key: "1gkc67" }],
  ["path", { d: "M12 22h1.5", key: "1my7sn" }],
  ["path", { d: "M12 2h1.5", key: "19tvb7" }],
  ["path", { d: "M17.5 22H19a1 1 0 0 0 1-1", key: "10akbh" }],
  ["path", { d: "M17.5 2H19a1 1 0 0 1 1 1v1.5", key: "1vrfjs" }],
  ["path", { d: "M20 14v3h-2.5", key: "1naeju" }],
  ["path", { d: "M20 8.5V10", key: "1ctpfu" }],
  ["path", { d: "M4 10V8.5", key: "1o3zg5" }],
  ["path", { d: "M4 19.5V14", key: "ob81pf" }],
  ["path", { d: "M4 4.5A2.5 2.5 0 0 1 6.5 2H8", key: "s8vcyb" }],
  ["path", { d: "M8 22H6.5a1 1 0 0 1 0-5H8", key: "1cu73q" }]
]);
const vc = n("book-down", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3 3 3-3", key: "zt5b4y" }]
]);
const gc = n("book-headphones", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 12v-2a4 4 0 0 1 8 0v2", key: "1vsqkj" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
]);
const Mc = n("book-heart", [
  [
    "path",
    {
      d: "M16 8.2A2.22 2.22 0 0 0 13.8 6c-.8 0-1.4.3-1.8.9-.4-.6-1-.9-1.8-.9A2.22 2.22 0 0 0 8 8.2c0 .6.3 1.2.7 1.6A226.652 226.652 0 0 0 12 13a404 404 0 0 0 3.3-3.1 2.413 2.413 0 0 0 .7-1.7",
      key: "1t75a8"
    }
  ],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
const bc = n("book-image", [
  ["path", { d: "m20 13.7-2.1-2.1a2 2 0 0 0-2.8 0L9.7 17", key: "q6ojf0" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "2", key: "2qkj4p" }]
]);
const xc = n("book-key", [
  ["path", { d: "m19 3 1 1", key: "ze14oc" }],
  ["path", { d: "m20 2-4.5 4.5", key: "1sppr8" }],
  ["path", { d: "M20 8v13a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1ocbpn" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H14", key: "1gfsgw" }],
  ["circle", { cx: "14", cy: "8", r: "2", key: "u49eql" }]
]);
const wc = n("book-lock", [
  ["path", { d: "M18 6V4a2 2 0 1 0-4 0v2", key: "1aquzs" }],
  ["path", { d: "M20 15v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "1rkj32" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10", key: "18wgow" }],
  ["rect", { x: "12", y: "6", width: "8", height: "5", rx: "1", key: "73l30o" }]
]);
const Lc = n("book-marked", [
  ["path", { d: "M10 2v8l3-3 3 3V2", key: "sqw3rj" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
const Sc = n("book-minus", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const Ic = n("book-open-check", [
  ["path", { d: "M12 21V7", key: "gj6g52" }],
  ["path", { d: "m16 12 2 2 4-4", key: "mdajum" }],
  [
    "path",
    {
      d: "M22 6V4a1 1 0 0 0-1-1h-5a4 4 0 0 0-4 4 4 4 0 0 0-4-4H3a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h6a3 3 0 0 1 3 3 3 3 0 0 1 3-3h6a1 1 0 0 0 1-1v-1.3",
      key: "8arnkb"
    }
  ]
]);
const Cc = n("book-open-text", [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  ["path", { d: "M16 12h2", key: "7q9ll5" }],
  ["path", { d: "M16 8h2", key: "msurwy" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ],
  ["path", { d: "M6 12h2", key: "32wvfc" }],
  ["path", { d: "M6 8h2", key: "30oboj" }]
]);
const Ac = n("book-open", [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
]);
const qc = n("book-plus", [
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const zc = n("book-text", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "M8 11h8", key: "vwpz6n" }],
  ["path", { d: "M8 7h6", key: "1f0q6e" }]
]);
const Pc = n("book-type", [
  ["path", { d: "M10 13h4", key: "ytezjc" }],
  ["path", { d: "M12 6v7", key: "1f6ttz" }],
  ["path", { d: "M16 8V6H8v2", key: "x8j6u4" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
const _c = n("book-up", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
const jc = n("book-up-2", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M18 2h1a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20", key: "161d7n" }],
  ["path", { d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2", key: "1lorq7" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
const Hc = n("book-user", [
  ["path", { d: "M15 13a3 3 0 1 0-6 0", key: "10j68g" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }]
]);
const Vc = n("book-x", [
  ["path", { d: "m14.5 7-5 5", key: "dy991v" }],
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ],
  ["path", { d: "m9.5 7 5 5", key: "s45iea" }]
]);
const Bc = n("book", [
  [
    "path",
    {
      d: "M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H19a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20",
      key: "k3hazp"
    }
  ]
]);
const Dc = n("bookmark-check", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);
const Tc = n("bookmark-minus", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
const $c = n("bookmark-plus", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }],
  ["line", { x1: "12", x2: "12", y1: "7", y2: "13", key: "1cppfj" }],
  ["line", { x1: "15", x2: "9", y1: "10", y2: "10", key: "1gty7f" }]
]);
const Oc = n("bookmark-x", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2Z", key: "169p4p" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
const Rc = n("bookmark", [
  ["path", { d: "m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z", key: "1fy3hk" }]
]);
const Fc = n("boom-box", [
  ["path", { d: "M4 9V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4", key: "vvzvr1" }],
  ["path", { d: "M8 8v1", key: "xcqmfk" }],
  ["path", { d: "M12 8v1", key: "1rj8u4" }],
  ["path", { d: "M16 8v1", key: "1q12zr" }],
  ["rect", { width: "20", height: "12", x: "2", y: "9", rx: "2", key: "igpb89" }],
  ["circle", { cx: "8", cy: "15", r: "2", key: "fa4a8s" }],
  ["circle", { cx: "16", cy: "15", r: "2", key: "14c3ya" }]
]);
const Ec = n("bot-message-square", [
  ["path", { d: "M12 6V2H8", key: "1155em" }],
  ["path", { d: "m8 18-4 4V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2Z", key: "w2lp3e" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M9 11v2", key: "1ueba0" }],
  ["path", { d: "M15 11v2", key: "i11awn" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }]
]);
const Uc = n("bot-off", [
  ["path", { d: "M13.67 8H18a2 2 0 0 1 2 2v4.33", key: "7az073" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }],
  ["path", { d: "M8 8H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 1.414-.586", key: "s09a7a" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }],
  ["path", { d: "M9.67 4H12v2.33", key: "110xot" }]
]);
const Nc = n("bot", [
  ["path", { d: "M12 8V4H8", key: "hb8ula" }],
  ["rect", { width: "16", height: "12", x: "4", y: "8", rx: "2", key: "enze0r" }],
  ["path", { d: "M2 14h2", key: "vft8re" }],
  ["path", { d: "M20 14h2", key: "4cs60a" }],
  ["path", { d: "M15 13v2", key: "1xurst" }],
  ["path", { d: "M9 13v2", key: "rq6x2g" }]
]);
const Wc = n("box", [
  [
    "path",
    {
      d: "M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z",
      key: "hh9hay"
    }
  ],
  ["path", { d: "m3.3 7 8.7 5 8.7-5", key: "g66t2b" }],
  ["path", { d: "M12 22V12", key: "d0xqtd" }]
]);
const Gc = n("boxes", [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
]);
const wa = n("braces", [
  [
    "path",
    { d: "M8 3H7a2 2 0 0 0-2 2v5a2 2 0 0 1-2 2 2 2 0 0 1 2 2v5c0 1.1.9 2 2 2h1", key: "ezmyqa" }
  ],
  [
    "path",
    {
      d: "M16 21h1a2 2 0 0 0 2-2v-5c0-1.1.9-2 2-2a2 2 0 0 1-2-2V5a2 2 0 0 0-2-2h-1",
      key: "e1hn23"
    }
  ]
]);
const Zc = n("brackets", [
  ["path", { d: "M16 3h2a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-2", key: "tum69e" }],
  ["path", { d: "M8 21H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2", key: "z7wn0n" }]
]);
const Yc = n("brain-circuit", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  ["path", { d: "M9 13a4.5 4.5 0 0 0 3-4", key: "10igwf" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M12 13h4", key: "1ku699" }],
  ["path", { d: "M12 18h6a2 2 0 0 1 2 2v1", key: "105ag5" }],
  ["path", { d: "M12 8h8", key: "1lhi5i" }],
  ["path", { d: "M16 8V5a2 2 0 0 1 2-2", key: "u6izg6" }],
  ["circle", { cx: "16", cy: "13", r: ".5", key: "ry7gng" }],
  ["circle", { cx: "18", cy: "3", r: ".5", key: "1aiba7" }],
  ["circle", { cx: "20", cy: "21", r: ".5", key: "yhc1fs" }],
  ["circle", { cx: "20", cy: "8", r: ".5", key: "1e43v0" }]
]);
const Kc = n("brain-cog", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.142 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588 4 4 0 0 0 7.636 2.106 3.2 3.2 0 0 0 .164-.546c.028-.13.306-.13.335 0a3.2 3.2 0 0 0 .163.546 4 4 0 0 0 7.636-2.106 4 4 0 0 0 .556-6.588 4 4 0 0 0-2.526-5.77A3 3 0 1 0 12 5",
      key: "1kgmhc"
    }
  ],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m15.7 10.4-.9.4", key: "ayzo6p" }],
  ["path", { d: "m9.2 13.2-.9.4", key: "1uzb3g" }],
  ["path", { d: "m13.6 15.7-.4-.9", key: "11ifqf" }],
  ["path", { d: "m10.8 9.2-.4-.9", key: "1pmk2v" }],
  ["path", { d: "m15.7 13.5-.9-.4", key: "7ng02m" }],
  ["path", { d: "m9.2 10.9-.9-.4", key: "1x66zd" }],
  ["path", { d: "m10.5 15.7.4-.9", key: "3js94g" }],
  ["path", { d: "m13.1 9.2.4-.9", key: "18n7mc" }]
]);
const Xc = n("brain", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 0-5.997.125 4 4 0 0 0-2.526 5.77 4 4 0 0 0 .556 6.588A4 4 0 1 0 12 18Z",
      key: "l5xja"
    }
  ],
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 5.997.125 4 4 0 0 1 2.526 5.77 4 4 0 0 1-.556 6.588A4 4 0 1 1 12 18Z",
      key: "ep3f8r"
    }
  ],
  ["path", { d: "M15 13a4.5 4.5 0 0 1-3-4 4.5 4.5 0 0 1-3 4", key: "1p4c4q" }],
  ["path", { d: "M17.599 6.5a3 3 0 0 0 .399-1.375", key: "tmeiqw" }],
  ["path", { d: "M6.003 5.125A3 3 0 0 0 6.401 6.5", key: "105sqy" }],
  ["path", { d: "M3.477 10.896a4 4 0 0 1 .585-.396", key: "ql3yin" }],
  ["path", { d: "M19.938 10.5a4 4 0 0 1 .585.396", key: "1qfode" }],
  ["path", { d: "M6 18a4 4 0 0 1-1.967-.516", key: "2e4loj" }],
  ["path", { d: "M19.967 17.484A4 4 0 0 1 18 18", key: "159ez6" }]
]);
const Qc = n("brick-wall", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 9v6", key: "199k2o" }],
  ["path", { d: "M16 15v6", key: "8rj2es" }],
  ["path", { d: "M16 3v6", key: "1j6rpj" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M8 15v6", key: "1stoo3" }],
  ["path", { d: "M8 3v6", key: "vlvjmk" }]
]);
const Jc = n("briefcase-business", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M22 13a18.15 18.15 0 0 1-20 0", key: "12hx5q" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
const e0 = n("briefcase-conveyor-belt", [
  ["path", { d: "M10 20v2", key: "1n8e1g" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M18 20v2", key: "10uadw" }],
  ["path", { d: "M21 20H3", key: "kdqkdp" }],
  ["path", { d: "M6 20v2", key: "a9bc87" }],
  ["path", { d: "M8 16V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v12", key: "17n9tx" }],
  ["rect", { x: "4", y: "6", width: "16", height: "10", rx: "2", key: "1097i5" }]
]);
const t0 = n("briefcase", [
  ["path", { d: "M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16", key: "jecpp" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
const a0 = n("briefcase-medical", [
  ["path", { d: "M12 11v4", key: "a6ujw6" }],
  ["path", { d: "M14 13h-4", key: "1pl8zg" }],
  ["path", { d: "M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2", key: "1ksdt3" }],
  ["path", { d: "M18 6v14", key: "1mu4gy" }],
  ["path", { d: "M6 6v14", key: "1s15cj" }],
  ["rect", { width: "20", height: "14", x: "2", y: "6", rx: "2", key: "i6l2r4" }]
]);
const n0 = n("bring-to-front", [
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "2", key: "yj20xf" }],
  ["path", { d: "M4 10a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2", key: "1ltk23" }],
  ["path", { d: "M14 20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2", key: "1q24h9" }]
]);
const o0 = n("brush", [
  ["path", { d: "m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08", key: "1styjt" }],
  [
    "path",
    {
      d: "M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z",
      key: "z0l1mu"
    }
  ]
]);
const r0 = n("bug-off", [
  ["path", { d: "M15 7.13V6a3 3 0 0 0-5.14-2.1L8 2", key: "vl8zik" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M22 13h-4v-2a4 4 0 0 0-4-4h-1.3", key: "1ou0bd" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7.7 7.7A4 4 0 0 0 6 11v3a6 6 0 0 0 11.13 3.13", key: "1njkjs" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }]
]);
const l0 = n("bug-play", [
  [
    "path",
    {
      d: "M12.765 21.522a.5.5 0 0 1-.765-.424v-8.196a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "17shqo"
    }
  ],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M18 11a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4v3a6.1 6.1 0 0 0 2 4.5", key: "1tjixy" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }]
]);
const i0 = n("bug", [
  ["path", { d: "m8 2 1.88 1.88", key: "fmnt4t" }],
  ["path", { d: "M14.12 3.88 16 2", key: "qol33r" }],
  ["path", { d: "M9 7.13v-1a3.003 3.003 0 1 1 6 0v1", key: "d7y7pr" }],
  [
    "path",
    {
      d: "M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v3c0 3.3-2.7 6-6 6",
      key: "xs1cw7"
    }
  ],
  ["path", { d: "M12 20v-9", key: "1qisl0" }],
  ["path", { d: "M6.53 9C4.6 8.8 3 7.1 3 5", key: "32zzws" }],
  ["path", { d: "M6 13H2", key: "82j7cp" }],
  ["path", { d: "M3 21c0-2.1 1.7-3.9 3.8-4", key: "4p0ekp" }],
  ["path", { d: "M20.97 5c0 2.1-1.6 3.8-3.5 4", key: "18gb23" }],
  ["path", { d: "M22 13h-4", key: "1jl80f" }],
  ["path", { d: "M17.2 17c2.1.1 3.8 1.9 3.8 4", key: "k3fwyw" }]
]);
const c0 = n("building-2", [
  ["path", { d: "M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z", key: "1b4qmf" }],
  ["path", { d: "M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2", key: "i71pzd" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2", key: "10jefs" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "M10 10h4", key: "tcdvrf" }],
  ["path", { d: "M10 14h4", key: "kelpxr" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
const d0 = n("building", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["path", { d: "M9 22v-4h6v4", key: "r93iot" }],
  ["path", { d: "M8 6h.01", key: "1dz90k" }],
  ["path", { d: "M16 6h.01", key: "1x0f13" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }]
]);
const s0 = n("bus-front", [
  ["path", { d: "M4 6 2 7", key: "1mqr15" }],
  ["path", { d: "M10 6h4", key: "1itunk" }],
  ["path", { d: "m22 7-2-1", key: "1umjhc" }],
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 21v-2", key: "sqyl04" }]
]);
const u0 = n("bus", [
  ["path", { d: "M8 6v6", key: "18i7km" }],
  ["path", { d: "M15 6v6", key: "1sg6z9" }],
  ["path", { d: "M2 12h19.6", key: "de5uta" }],
  [
    "path",
    {
      d: "M18 18h3s.5-1.7.8-2.8c.1-.4.2-.8.2-1.2 0-.4-.1-.8-.2-1.2l-1.4-5C20.1 6.8 19.1 6 18 6H4a2 2 0 0 0-2 2v10h3",
      key: "1wwztk"
    }
  ],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }],
  ["path", { d: "M9 18h5", key: "lrx6i" }],
  ["circle", { cx: "16", cy: "18", r: "2", key: "1v4tcr" }]
]);
const h0 = n("cable-car", [
  ["path", { d: "M10 3h.01", key: "lbucoy" }],
  ["path", { d: "M14 2h.01", key: "1k8aa1" }],
  ["path", { d: "m2 9 20-5", key: "1kz0j5" }],
  ["path", { d: "M12 12V6.5", key: "1vbrij" }],
  ["rect", { width: "16", height: "10", x: "4", y: "12", rx: "3", key: "if91er" }],
  ["path", { d: "M9 12v5", key: "3anwtq" }],
  ["path", { d: "M15 12v5", key: "5xh3zn" }],
  ["path", { d: "M4 17h16", key: "g4d7ey" }]
]);
const p0 = n("cable", [
  [
    "path",
    {
      d: "M17 21v-2a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1",
      key: "10bnsj"
    }
  ],
  ["path", { d: "M19 15V6.5a1 1 0 0 0-7 0v11a1 1 0 0 1-7 0V9", key: "1eqmu1" }],
  ["path", { d: "M21 21v-2h-4", key: "14zm7j" }],
  ["path", { d: "M3 5h4V3", key: "z442eg" }],
  [
    "path",
    { d: "M7 5a1 1 0 0 1 1 1v1a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a1 1 0 0 1 1-1V3", key: "ebdjd7" }
  ]
]);
const y0 = n("cake-slice", [
  ["circle", { cx: "9", cy: "7", r: "2", key: "1305pl" }],
  [
    "path",
    { d: "M7.2 7.9 3 11v9c0 .6.4 1 1 1h16c.6 0 1-.4 1-1v-9c0-2-3-6-7-8l-3.6 2.6", key: "xle13f" }
  ],
  ["path", { d: "M16 13H3", key: "1wpj08" }],
  ["path", { d: "M16 17H3", key: "3lvfcd" }]
]);
const k0 = n("cake", [
  ["path", { d: "M20 21v-8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8", key: "1w3rig" }],
  ["path", { d: "M4 16s.5-1 2-1 2.5 2 4 2 2.5-2 4-2 2.5 2 4 2 2-1 2-1", key: "n2jgmb" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }],
  ["path", { d: "M7 8v3", key: "1qtyvj" }],
  ["path", { d: "M12 8v3", key: "hwp4zt" }],
  ["path", { d: "M17 8v3", key: "1i6e5u" }],
  ["path", { d: "M7 4h.01", key: "1bh4kh" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M17 4h.01", key: "1upcoc" }]
]);
const m0 = n("calculator", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["line", { x1: "8", x2: "16", y1: "6", y2: "6", key: "x4nwl0" }],
  ["line", { x1: "16", x2: "16", y1: "14", y2: "18", key: "wjye3r" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
const f0 = n("calendar-1", [
  ["path", { d: "M11 14h1v4", key: "fy54vd" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
const v0 = n("calendar-arrow-down", [
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 14v8", key: "irew45" }],
  [
    "path",
    { d: "M21 11.354V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.343", key: "bse4f3" }
  ],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
const g0 = n("calendar-arrow-up", [
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }],
  ["path", { d: "M21 11.343V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h9", key: "1exg90" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
const M0 = n("calendar-check-2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 14V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "bce9hv" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
const b0 = n("calendar-check", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m9 16 2 2 4-4", key: "19s6y9" }]
]);
const x0 = n("calendar-clock", [
  ["path", { d: "M21 7.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3.5", key: "1osxxc" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M3 10h5", key: "r794hk" }],
  ["path", { d: "M17.5 17.5 16 16.3V14", key: "akvzfd" }],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }]
]);
const w0 = n("calendar-cog", [
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "M21 10.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "11kmuh" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
const L0 = n("calendar-days", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 14h.01", key: "6423bh" }],
  ["path", { d: "M12 14h.01", key: "1etili" }],
  ["path", { d: "M16 14h.01", key: "1gbofw" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M16 18h.01", key: "kzsmim" }]
]);
const S0 = n("calendar-fold", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 17V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h11Z", key: "kg77oy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M15 22v-4a2 2 0 0 1 2-2h4", key: "1gnbqr" }]
]);
const I0 = n("calendar-heart", [
  ["path", { d: "M3 10h18V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7", key: "136lmk" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  [
    "path",
    {
      d: "M21.29 14.7a2.43 2.43 0 0 0-2.65-.52c-.3.12-.57.3-.8.53l-.34.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L17.5 22l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1t7hil"
    }
  ]
]);
const C0 = n("calendar-minus-2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }]
]);
const A0 = n("calendar-minus", [
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 15V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.5", key: "1scpom" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
const q0 = n("calendar-off", [
  ["path", { d: "M4.2 4.2A2 2 0 0 0 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 1.82-1.18", key: "16swn3" }],
  ["path", { d: "M21 15.5V6a2 2 0 0 0-2-2H9.5", key: "yhw86o" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h7", key: "1wap6i" }],
  ["path", { d: "M21 10h-5.5", key: "quycpq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const z0 = n("calendar-plus-2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M10 16h4", key: "17e571" }],
  ["path", { d: "M12 14v4", key: "1thi36" }]
]);
const P0 = n("calendar-plus", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }]
]);
const _0 = n("calendar-search", [
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 11.75V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7.25", key: "1jrsq6" }],
  ["path", { d: "m22 22-1.875-1.875", key: "13zax7" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
const j0 = n("calendar-range", [
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M17 14h-6", key: "bkmgh3" }],
  ["path", { d: "M13 18H7", key: "bb0bb7" }],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 18h.01", key: "1bdyru" }]
]);
const H0 = n("calendar-sync", [
  ["path", { d: "M11 10v4h4", key: "172dkj" }],
  ["path", { d: "m11 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "vu0qm5" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "m21 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "1qgeyt" }],
  ["path", { d: "M21 22v-4h-4", key: "hrummi" }],
  ["path", { d: "M21 8.5V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h4.3", key: "mctw84" }],
  ["path", { d: "M3 10h4", key: "1el30a" }],
  ["path", { d: "M8 2v4", key: "1cmpym" }]
]);
const V0 = n("calendar-x-2", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M21 13V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8", key: "3spt84" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m17 22 5-5", key: "1k6ppv" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }]
]);
const B0 = n("calendar-x", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }],
  ["path", { d: "m14 14-4 4", key: "rymu2i" }],
  ["path", { d: "m10 14 4 4", key: "3sz06r" }]
]);
const D0 = n("calendar", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
]);
const T0 = n("camera-off", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16", key: "qmtpty" }],
  ["path", { d: "M9.5 4h5L17 7h3a2 2 0 0 1 2 2v7.5", key: "1ufyfc" }],
  ["path", { d: "M14.121 15.121A3 3 0 1 1 9.88 10.88", key: "11zox6" }]
]);
const $0 = n("camera", [
  [
    "path",
    {
      d: "M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z",
      key: "1tc9qg"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "3", key: "1vg3eu" }]
]);
const O0 = n("candy-cane", [
  [
    "path",
    {
      d: "M5.7 21a2 2 0 0 1-3.5-2l8.6-14a6 6 0 0 1 10.4 6 2 2 0 1 1-3.464-2 2 2 0 1 0-3.464-2Z",
      key: "isaq8g"
    }
  ],
  ["path", { d: "M17.75 7 15 2.1", key: "12x7e8" }],
  ["path", { d: "M10.9 4.8 13 9", key: "100a87" }],
  ["path", { d: "m7.9 9.7 2 4.4", key: "ntfhaj" }],
  ["path", { d: "M4.9 14.7 7 18.9", key: "1x43jy" }]
]);
const R0 = n("candy-off", [
  ["path", { d: "M10 10v7.9", key: "m8g9tt" }],
  ["path", { d: "M11.802 6.145a5 5 0 0 1 6.053 6.053", key: "dn87i3" }],
  ["path", { d: "M14 6.1v2.243", key: "1kzysn" }],
  [
    "path",
    { d: "m15.5 15.571-.964.964a5 5 0 0 1-7.071 0 5 5 0 0 1 0-7.07l.964-.965", key: "3sxy18" }
  ],
  [
    "path",
    {
      d: "M16 7V3a1 1 0 0 1 1.707-.707 2.5 2.5 0 0 0 2.152.717 1 1 0 0 1 1.131 1.131 2.5 2.5 0 0 0 .717 2.152A1 1 0 0 1 21 8h-4",
      key: "gpb6xx"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M8 17v4a1 1 0 0 1-1.707.707 2.5 2.5 0 0 0-2.152-.717 1 1 0 0 1-1.131-1.131 2.5 2.5 0 0 0-.717-2.152A1 1 0 0 1 3 16h4",
      key: "qexcha"
    }
  ]
]);
const F0 = n("candy", [
  ["path", { d: "M10 7v10.9", key: "1gynux" }],
  ["path", { d: "M14 6.1V17", key: "116kdf" }],
  [
    "path",
    {
      d: "M16 7V3a1 1 0 0 1 1.707-.707 2.5 2.5 0 0 0 2.152.717 1 1 0 0 1 1.131 1.131 2.5 2.5 0 0 0 .717 2.152A1 1 0 0 1 21 8h-4",
      key: "gpb6xx"
    }
  ],
  [
    "path",
    {
      d: "M16.536 7.465a5 5 0 0 0-7.072 0l-2 2a5 5 0 0 0 0 7.07 5 5 0 0 0 7.072 0l2-2a5 5 0 0 0 0-7.07",
      key: "1tsln4"
    }
  ],
  [
    "path",
    {
      d: "M8 17v4a1 1 0 0 1-1.707.707 2.5 2.5 0 0 0-2.152-.717 1 1 0 0 1-1.131-1.131 2.5 2.5 0 0 0-.717-2.152A1 1 0 0 1 3 16h4",
      key: "qexcha"
    }
  ]
]);
const E0 = n("cannabis", [
  ["path", { d: "M12 22v-4", key: "1utk9m" }],
  [
    "path",
    {
      d: "M7 12c-1.5 0-4.5 1.5-5 3 3.5 1.5 6 1 6 1-1.5 1.5-2 3.5-2 5 2.5 0 4.5-1.5 6-3 1.5 1.5 3.5 3 6 3 0-1.5-.5-3.5-2-5 0 0 2.5.5 6-1-.5-1.5-3.5-3-5-3 1.5-1 4-4 4-6-2.5 0-5.5 1.5-7 3 0-2.5-.5-5-2-7-1.5 2-2 4.5-2 7-1.5-1.5-4.5-3-7-3 0 2 2.5 5 4 6",
      key: "1mezod"
    }
  ]
]);
const U0 = n("captions-off", [
  ["path", { d: "M10.5 5H19a2 2 0 0 1 2 2v8.5", key: "jqtk4d" }],
  ["path", { d: "M17 11h-.5", key: "1961ue" }],
  ["path", { d: "M19 19H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2", key: "1keqsi" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M7 11h4", key: "1o1z6v" }],
  ["path", { d: "M7 15h2.5", key: "1ina1g" }]
]);
const La = n("captions", [
  ["rect", { width: "18", height: "14", x: "3", y: "5", rx: "2", ry: "2", key: "12ruh7" }],
  ["path", { d: "M7 15h4M15 15h2M7 11h2M13 11h4", key: "1ueiar" }]
]);
const N0 = n("car-front", [
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
const W0 = n("car-taxi-front", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  [
    "path",
    { d: "m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8", key: "1imjwt" }
  ],
  ["path", { d: "M7 14h.01", key: "1qa3f1" }],
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  ["rect", { width: "18", height: "8", x: "3", y: "10", rx: "2", key: "a7itu8" }],
  ["path", { d: "M5 18v2", key: "ppbyun" }],
  ["path", { d: "M19 18v2", key: "gy7782" }]
]);
const G0 = n("car", [
  [
    "path",
    {
      d: "M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2",
      key: "5owen"
    }
  ],
  ["circle", { cx: "7", cy: "17", r: "2", key: "u2ysq9" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }],
  ["circle", { cx: "17", cy: "17", r: "2", key: "axvx0g" }]
]);
const Z0 = n("caravan", [
  ["path", { d: "M18 19V9a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v8a2 2 0 0 0 2 2h2", key: "19jm3t" }],
  ["path", { d: "M2 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H2", key: "13hakp" }],
  ["path", { d: "M22 17v1a1 1 0 0 1-1 1H10v-9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v9", key: "1crci8" }],
  ["circle", { cx: "8", cy: "19", r: "2", key: "t8fc5s" }]
]);
const Y0 = n("carrot", [
  [
    "path",
    {
      d: "M2.27 21.7s9.87-3.5 12.73-6.36a4.5 4.5 0 0 0-6.36-6.37C5.77 11.84 2.27 21.7 2.27 21.7zM8.64 14l-2.05-2.04M15.34 15l-2.46-2.46",
      key: "rfqxbe"
    }
  ],
  ["path", { d: "M22 9s-1.33-2-3.5-2C16.86 7 15 9 15 9s1.33 2 3.5 2S22 9 22 9z", key: "6b25w4" }],
  ["path", { d: "M15 2s-2 1.33-2 3.5S15 9 15 9s2-1.84 2-3.5C17 3.33 15 2 15 2z", key: "fn65lo" }]
]);
const K0 = n("case-lower", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }]
]);
const X0 = n("case-sensitive", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["circle", { cx: "18", cy: "12", r: "3", key: "1kchzo" }],
  ["path", { d: "M21 9v6", key: "anns31" }]
]);
const Q0 = n("case-upper", [
  ["path", { d: "m3 15 4-8 4 8", key: "1vwr6u" }],
  ["path", { d: "M4 13h6", key: "1r9ots" }],
  ["path", { d: "M15 11h4.5a2 2 0 0 1 0 4H15V7h4a2 2 0 0 1 0 4", key: "1sqfas" }]
]);
const J0 = n("cassette-tape", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["circle", { cx: "8", cy: "10", r: "2", key: "1xl4ub" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "10", r: "2", key: "r14t7q" }],
  ["path", { d: "m6 20 .7-2.9A1.4 1.4 0 0 1 8.1 16h7.8a1.4 1.4 0 0 1 1.4 1l.7 3", key: "l01ucn" }]
]);
const ed = n("cast", [
  ["path", { d: "M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6", key: "3zrzxg" }],
  ["path", { d: "M2 12a9 9 0 0 1 8 8", key: "g6cvee" }],
  ["path", { d: "M2 16a5 5 0 0 1 4 4", key: "1y1dii" }],
  ["line", { x1: "2", x2: "2.01", y1: "20", y2: "20", key: "xu2jvo" }]
]);
const td = n("castle", [
  ["path", { d: "M22 20v-9H2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2Z", key: "109fe4" }],
  ["path", { d: "M18 11V4H6v7", key: "mon5oj" }],
  ["path", { d: "M15 22v-4a3 3 0 0 0-3-3a3 3 0 0 0-3 3v4", key: "1k4jtn" }],
  ["path", { d: "M22 11V9", key: "3zbp94" }],
  ["path", { d: "M2 11V9", key: "1x5rnq" }],
  ["path", { d: "M6 4V2", key: "1rsq15" }],
  ["path", { d: "M18 4V2", key: "1jsdo1" }],
  ["path", { d: "M10 4V2", key: "75d9ly" }],
  ["path", { d: "M14 4V2", key: "8nj3z6" }]
]);
const ad = n("cat", [
  [
    "path",
    {
      d: "M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z",
      key: "x6xyqk"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  ["path", { d: "M11.25 16.25h1.5L12 17l-.75-.75Z", key: "12kq1m" }]
]);
const nd = n("cctv", [
  [
    "path",
    {
      d: "M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97",
      key: "ir91b5"
    }
  ],
  [
    "path",
    {
      d: "M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z",
      key: "jlp8i1"
    }
  ],
  ["path", { d: "M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15", key: "19bib8" }],
  ["path", { d: "M2 21v-4", key: "l40lih" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }]
]);
const Sa = n("chart-area", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  [
    "path",
    {
      d: "M7 11.207a.5.5 0 0 1 .146-.353l2-2a.5.5 0 0 1 .708 0l3.292 3.292a.5.5 0 0 0 .708 0l4.292-4.292a.5.5 0 0 1 .854.353V16a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1z",
      key: "q0gr47"
    }
  ]
]);
const Ia = n("chart-bar-big", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
]);
const od = n("chart-bar-decreasing", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h3", key: "ur6vzw" }],
  ["path", { d: "M7 6h12", key: "sz5b0d" }]
]);
const rd = n("chart-bar-increasing", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 11h8", key: "1feolt" }],
  ["path", { d: "M7 16h12", key: "wsnu98" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);
const ld = n("chart-bar-stacked", [
  ["path", { d: "M11 13v4", key: "vyy2rb" }],
  ["path", { d: "M15 5v4", key: "1gx88a" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "7", y: "13", width: "9", height: "4", rx: "1", key: "1iip1u" }],
  ["rect", { x: "7", y: "5", width: "12", height: "4", rx: "1", key: "1anskk" }]
]);
const Ca = n("chart-bar", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16h8", key: "srdodz" }],
  ["path", { d: "M7 11h12", key: "127s9w" }],
  ["path", { d: "M7 6h3", key: "w9rmul" }]
]);
const Aa = n("chart-candlestick", [
  ["path", { d: "M9 5v4", key: "14uxtq" }],
  ["rect", { width: "4", height: "6", x: "7", y: "9", rx: "1", key: "f4fvz0" }],
  ["path", { d: "M9 15v2", key: "r5rk32" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["rect", { width: "4", height: "8", x: "15", y: "5", rx: "1", key: "z38je5" }],
  ["path", { d: "M17 13v3", key: "5l0wba" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
]);
const qa = n("chart-column-big", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
]);
const id = n("chart-column-decreasing", [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17v-3", key: "1sqioe" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17V5", key: "1wzmnc" }]
]);
const za = n("chart-column-increasing", [
  ["path", { d: "M13 17V9", key: "1fwyjl" }],
  ["path", { d: "M18 17V5", key: "sfb6ij" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
const cd = n("chart-column-stacked", [
  ["path", { d: "M11 13H7", key: "t0o9gq" }],
  ["path", { d: "M19 9h-4", key: "rera1j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["rect", { x: "15", y: "5", width: "4", height: "12", rx: "1", key: "q8uenq" }],
  ["rect", { x: "7", y: "8", width: "4", height: "9", rx: "1", key: "sr5ea" }]
]);
const Pa = n("chart-column", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M18 17V9", key: "2bz60n" }],
  ["path", { d: "M13 17V5", key: "1frdt8" }],
  ["path", { d: "M8 17v-3", key: "17ska0" }]
]);
const dd = n("chart-gantt", [
  ["path", { d: "M10 6h8", key: "zvc2xc" }],
  ["path", { d: "M12 16h6", key: "yi5mkt" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M8 11h7", key: "wz2hg0" }]
]);
const _a = n("chart-line", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "m19 9-5 5-4-4-3 3", key: "2osh9i" }]
]);
const sd = n("chart-network", [
  ["path", { d: "m13.11 7.664 1.78 2.672", key: "go2gg9" }],
  ["path", { d: "m14.162 12.788-3.324 1.424", key: "11x848" }],
  ["path", { d: "m20 4-6.06 1.515", key: "1wxxh7" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["circle", { cx: "12", cy: "6", r: "2", key: "1jj5th" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }],
  ["circle", { cx: "9", cy: "15", r: "2", key: "lf2ghp" }]
]);
const ud = n("chart-no-axes-column-decreasing", [
  ["path", { d: "M12 20V10", key: "g8npz5" }],
  ["path", { d: "M18 20v-4", key: "8uic4z" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }]
]);
const ja = n("chart-no-axes-column-increasing", [
  ["line", { x1: "12", x2: "12", y1: "20", y2: "10", key: "1vz5eb" }],
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "16", key: "hq0ia6" }]
]);
const Ha = n("chart-no-axes-column", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "10", key: "1xfpm4" }],
  ["line", { x1: "12", x2: "12", y1: "20", y2: "4", key: "be30l9" }],
  ["line", { x1: "6", x2: "6", y1: "20", y2: "14", key: "1r4le6" }]
]);
const hd = n("chart-no-axes-combined", [
  ["path", { d: "M12 16v5", key: "zza2cw" }],
  ["path", { d: "M16 14v7", key: "1g90b9" }],
  ["path", { d: "M20 10v11", key: "1iqoj0" }],
  [
    "path",
    { d: "m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15", key: "1fw8x9" }
  ],
  ["path", { d: "M4 18v3", key: "1yp0dc" }],
  ["path", { d: "M8 14v7", key: "n3cwzv" }]
]);
const Va = n("chart-no-axes-gantt", [
  ["path", { d: "M8 6h10", key: "9lnwnk" }],
  ["path", { d: "M6 12h9", key: "1g9pqf" }],
  ["path", { d: "M11 18h7", key: "c8dzvl" }]
]);
const Ba = n("chart-pie", [
  [
    "path",
    {
      d: "M21 12c.552 0 1.005-.449.95-.998a10 10 0 0 0-8.953-8.951c-.55-.055-.998.398-.998.95v8a1 1 0 0 0 1 1z",
      key: "pzmjnu"
    }
  ],
  ["path", { d: "M21.21 15.89A10 10 0 1 1 8 2.83", key: "k2fpak" }]
]);
const Da = n("chart-scatter", [
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["circle", { cx: "18.5", cy: "5.5", r: ".5", fill: "currentColor", key: "lysivs" }],
  ["circle", { cx: "11.5", cy: "11.5", r: ".5", fill: "currentColor", key: "byv1b8" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["circle", { cx: "17.5", cy: "14.5", r: ".5", fill: "currentColor", key: "1gjh6j" }],
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }]
]);
const pd = n("chart-spline", [
  ["path", { d: "M3 3v16a2 2 0 0 0 2 2h16", key: "c24i48" }],
  ["path", { d: "M7 16c.5-2 1.5-7 4-7 2 0 2 3 4 3 2.5 0 4.5-5 5-7", key: "lw07rv" }]
]);
const yd = n("check-check", [
  ["path", { d: "M18 6 7 17l-5-5", key: "116fxf" }],
  ["path", { d: "m22 10-7.5 7.5L13 16", key: "ke71qq" }]
]);
const kd = n("check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
const md = n("chef-hat", [
  [
    "path",
    {
      d: "M17 21a1 1 0 0 0 1-1v-5.35c0-.457.316-.844.727-1.041a4 4 0 0 0-2.134-7.589 5 5 0 0 0-9.186 0 4 4 0 0 0-2.134 7.588c.411.198.727.585.727 1.041V20a1 1 0 0 0 1 1Z",
      key: "1qvrer"
    }
  ],
  ["path", { d: "M6 17h12", key: "1jwigz" }]
]);
const fd = n("cherry", [
  ["path", { d: "M2 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "cvxqlc" }],
  ["path", { d: "M12 17a5 5 0 0 0 10 0c0-2.76-2.5-5-5-3-2.5-2-5 .24-5 3Z", key: "1ostrc" }],
  ["path", { d: "M7 14c3.22-2.91 4.29-8.75 5-12 1.66 2.38 4.94 9 5 12", key: "hqx58h" }],
  ["path", { d: "M22 9c-4.29 0-7.14-2.33-10-7 5.71 0 10 4.67 10 7Z", key: "eykp1o" }]
]);
const vd = n("chevron-down", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
const gd = n("chevron-first", [
  ["path", { d: "m17 18-6-6 6-6", key: "1yerx2" }],
  ["path", { d: "M7 6v12", key: "1p53r6" }]
]);
const Md = n("chevron-last", [
  ["path", { d: "m7 18 6-6-6-6", key: "lwmzdw" }],
  ["path", { d: "M17 6v12", key: "1o0aio" }]
]);
const bd = n("chevron-left", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
const xd = n("chevron-right", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
const wd = n("chevron-up", [
  ["path", { d: "m18 15-6-6-6 6", key: "153udz" }]
]);
const Ld = n("chevrons-down-up", [
  ["path", { d: "m7 20 5-5 5 5", key: "13a0gw" }],
  ["path", { d: "m7 4 5 5 5-5", key: "1kwcof" }]
]);
const Sd = n("chevrons-down", [
  ["path", { d: "m7 6 5 5 5-5", key: "1lc07p" }],
  ["path", { d: "m7 13 5 5 5-5", key: "1d48rs" }]
]);
const Id = n("chevrons-left-right-ellipsis", [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
const Cd = n("chevrons-left-right", [
  ["path", { d: "m9 7-5 5 5 5", key: "j5w590" }],
  ["path", { d: "m15 7 5 5-5 5", key: "1bl6da" }]
]);
const Ad = n("chevrons-left", [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
]);
const qd = n("chevrons-right-left", [
  ["path", { d: "m20 17-5-5 5-5", key: "30x0n2" }],
  ["path", { d: "m4 17 5-5-5-5", key: "16spf4" }]
]);
const zd = n("chevrons-right", [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
]);
const Pd = n("chevrons-up-down", [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
]);
const _d = n("chevrons-up", [
  ["path", { d: "m17 11-5-5-5 5", key: "e8nh98" }],
  ["path", { d: "m17 18-5-5-5 5", key: "2avn1x" }]
]);
const jd = n("chrome", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["line", { x1: "21.17", x2: "12", y1: "8", y2: "8", key: "a0cw5f" }],
  ["line", { x1: "3.95", x2: "8.54", y1: "6.06", y2: "14", key: "1kftof" }],
  ["line", { x1: "10.88", x2: "15.46", y1: "21.94", y2: "14", key: "1ymyh8" }]
]);
const Hd = n("church", [
  ["path", { d: "M10 9h4", key: "u4k05v" }],
  ["path", { d: "M12 7v5", key: "ma6bk" }],
  ["path", { d: "M14 22v-4a2 2 0 0 0-4 0v4", key: "1pdhuj" }],
  [
    "path",
    {
      d: "M18 22V5.618a1 1 0 0 0-.553-.894l-4.553-2.277a2 2 0 0 0-1.788 0L6.553 4.724A1 1 0 0 0 6 5.618V22",
      key: "1rkokr"
    }
  ],
  [
    "path",
    {
      d: "m18 7 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.618a1 1 0 0 1 .553-.894L6 7",
      key: "1w6esw"
    }
  ]
]);
const Vd = n("cigarette-off", [
  ["path", { d: "M12 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h13", key: "1gdiyg" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 12a1 1 0 0 1 1 1v2a1 1 0 0 1-.5.866", key: "166zjj" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
]);
const Bd = n("cigarette", [
  ["path", { d: "M17 12H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h14", key: "1mb5g1" }],
  ["path", { d: "M18 8c0-2.5-2-2.5-2-5", key: "1il607" }],
  ["path", { d: "M21 16a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1", key: "1yl5r7" }],
  ["path", { d: "M22 8c0-2.5-2-2.5-2-5", key: "1gah44" }],
  ["path", { d: "M7 12v4", key: "jqww69" }]
]);
const Ta = n("circle-alert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]);
const $a = n("circle-arrow-down", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
const Oa = n("circle-arrow-left", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }]
]);
const Ra = n("circle-arrow-out-down-left", [
  ["path", { d: "M2 12a10 10 0 1 1 10 10", key: "1yn6ov" }],
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "M8 22H2v-6", key: "sulq54" }]
]);
const Fa = n("circle-arrow-out-down-right", [
  ["path", { d: "M12 22a10 10 0 1 1 10-10", key: "130bv5" }],
  ["path", { d: "M22 22 12 12", key: "131aw7" }],
  ["path", { d: "M22 16v6h-6", key: "1gvm70" }]
]);
const Ea = n("circle-arrow-out-up-left", [
  ["path", { d: "M2 8V2h6", key: "hiwtdz" }],
  ["path", { d: "m2 2 10 10", key: "1oh8rs" }],
  ["path", { d: "M12 2A10 10 0 1 1 2 12", key: "rrk4fa" }]
]);
const Ua = n("circle-arrow-out-up-right", [
  ["path", { d: "M22 12A10 10 0 1 1 12 2", key: "1fm58d" }],
  ["path", { d: "M22 2 12 12", key: "yg2myt" }],
  ["path", { d: "M16 2h6v6", key: "zan5cs" }]
]);
const Na = n("circle-arrow-right", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
const Wa = n("circle-arrow-up", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
const Ga = n("circle-check-big", [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
const Za = n("circle-check", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const Ya = n("circle-chevron-down", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
const Ka = n("circle-chevron-left", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
const Xa = n("circle-chevron-right", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
const Qa = n("circle-chevron-up", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
const Dd = n("circle-dashed", [
  ["path", { d: "M10.1 2.182a10 10 0 0 1 3.8 0", key: "5ilxe3" }],
  ["path", { d: "M13.9 21.818a10 10 0 0 1-3.8 0", key: "11zvb9" }],
  ["path", { d: "M17.609 3.721a10 10 0 0 1 2.69 2.7", key: "1iw5b2" }],
  ["path", { d: "M2.182 13.9a10 10 0 0 1 0-3.8", key: "c0bmvh" }],
  ["path", { d: "M20.279 17.609a10 10 0 0 1-2.7 2.69", key: "1ruxm7" }],
  ["path", { d: "M21.818 10.1a10 10 0 0 1 0 3.8", key: "qkgqxc" }],
  ["path", { d: "M3.721 6.391a10 10 0 0 1 2.7-2.69", key: "1mcia2" }],
  ["path", { d: "M6.391 20.279a10 10 0 0 1-2.69-2.7", key: "1fvljs" }]
]);
const Ja = n("circle-divide", [
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Td = n("circle-dollar-sign", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }]
]);
const $d = n("circle-dot-dashed", [
  ["path", { d: "M10.1 2.18a9.93 9.93 0 0 1 3.8 0", key: "1qdqn0" }],
  ["path", { d: "M17.6 3.71a9.95 9.95 0 0 1 2.69 2.7", key: "1bq7p6" }],
  ["path", { d: "M21.82 10.1a9.93 9.93 0 0 1 0 3.8", key: "1rlaqf" }],
  ["path", { d: "M20.29 17.6a9.95 9.95 0 0 1-2.7 2.69", key: "1xk03u" }],
  ["path", { d: "M13.9 21.82a9.94 9.94 0 0 1-3.8 0", key: "l7re25" }],
  ["path", { d: "M6.4 20.29a9.95 9.95 0 0 1-2.69-2.7", key: "1v18p6" }],
  ["path", { d: "M2.18 13.9a9.93 9.93 0 0 1 0-3.8", key: "xdo6bj" }],
  ["path", { d: "M3.71 6.4a9.95 9.95 0 0 1 2.7-2.69", key: "1jjmaz" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
const Od = n("circle-dot", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
const Rd = n("circle-ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
const Fd = n("circle-equal", [
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Ed = n("circle-fading-arrow-up", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
const Ud = n("circle-fading-plus", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
const e1 = n("circle-gauge", [
  ["path", { d: "M15.6 2.7a10 10 0 1 0 5.7 5.7", key: "1e0p6d" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M13.4 10.6 19 5", key: "1kr7tw" }]
]);
const t1 = n("circle-help", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const a1 = n("circle-minus", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const Nd = n("circle-off", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.35 2.69A10 10 0 0 1 21.3 15.65", key: "1pfsoa" }],
  ["path", { d: "M19.08 19.08A10 10 0 1 1 4.92 4.92", key: "1ablyi" }]
]);
const n1 = n("circle-parking-off", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.34", key: "a9qo08" }]
]);
const o1 = n("circle-parking", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
const r1 = n("circle-pause", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "10", x2: "10", y1: "15", y2: "9", key: "c1nkhi" }],
  ["line", { x1: "14", x2: "14", y1: "15", y2: "9", key: "h65svq" }]
]);
const l1 = n("circle-percent", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
const i1 = n("circle-play", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polygon", { points: "10 8 16 12 10 16 10 8", key: "1cimsy" }]
]);
const c1 = n("circle-plus", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
const d1 = n("circle-power", [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const s1 = n("circle-slash-2", [
  ["path", { d: "M22 2 2 22", key: "y4kqgn" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Wd = n("circle-slash", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
const Gd = n("circle-small", [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }]
]);
const u1 = n("circle-stop", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["rect", { x: "9", y: "9", width: "6", height: "6", rx: "1", key: "1ssd4o" }]
]);
const h1 = n("circle-user-round", [
  ["path", { d: "M18 20a6 6 0 0 0-12 0", key: "1qehca" }],
  ["circle", { cx: "12", cy: "10", r: "4", key: "1h16sb" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const p1 = n("circle-user", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662", key: "154egf" }]
]);
const y1 = n("circle-x", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
const Zd = n("circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Yd = n("circuit-board", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M11 9h4a2 2 0 0 0 2-2V3", key: "1ve2rv" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "M7 21v-4a2 2 0 0 1 2-2h4", key: "1fwkro" }],
  ["circle", { cx: "15", cy: "15", r: "2", key: "3i40o0" }]
]);
const Kd = n("citrus", [
  [
    "path",
    {
      d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
      key: "4ite01"
    }
  ],
  ["path", { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", key: "1gxipu" }],
  ["path", { d: "m14 10-5.5 5.5", key: "92pfem" }],
  ["path", { d: "M14 17.85V10H6.15", key: "xqmtsk" }]
]);
const Xd = n("clapperboard", [
  [
    "path",
    { d: "M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3Z", key: "1tn4o7" }
  ],
  ["path", { d: "m6.2 5.3 3.1 3.9", key: "iuk76l" }],
  ["path", { d: "m12.4 3.4 3.1 4", key: "6hsd6n" }],
  ["path", { d: "M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z", key: "ltgou9" }]
]);
const Qd = n("clipboard-check", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m9 14 2 2 4-4", key: "df797q" }]
]);
const Jd = n("clipboard-copy", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2", key: "4jdomd" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v4", key: "3hqy98" }],
  ["path", { d: "M21 14H11", key: "1bme5i" }],
  ["path", { d: "m15 10-4 4 4 4", key: "5dvupr" }]
]);
const es = n("clipboard-list", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M12 11h4", key: "1jrz19" }],
  ["path", { d: "M12 16h4", key: "n85exb" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
const ts = n("clipboard-minus", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }]
]);
const as = n("clipboard-paste", [
  [
    "path",
    { d: "M15 2H9a1 1 0 0 0-1 1v2c0 .6.4 1 1 1h6c.6 0 1-.4 1-1V3c0-.6-.4-1-1-1Z", key: "1pp7kr" }
  ],
  [
    "path",
    {
      d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2M16 4h2a2 2 0 0 1 2 2v2M11 14h10",
      key: "2ik1ml"
    }
  ],
  ["path", { d: "m17 10 4 4-4 4", key: "vp2hj1" }]
]);
const k1 = n("clipboard-pen-line", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M8 4H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5", key: "1but9f" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 1.73 1", key: "1p8n7l" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ]
]);
const m1 = n("clipboard-pen", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", key: "1oijnt" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-5.5", key: "cereej" }],
  ["path", { d: "M4 13.5V6a2 2 0 0 1 2-2h2", key: "5ua5vh" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
]);
const ns = n("clipboard-plus", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 14h6", key: "159ibu" }],
  ["path", { d: "M12 17v-6", key: "1y8rbf" }]
]);
const os = n("clipboard-type", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "M9 12v-1h6v1", key: "iehl6m" }],
  ["path", { d: "M11 17h2", key: "12w5me" }],
  ["path", { d: "M12 11v6", key: "1bwqyc" }]
]);
const rs = n("clipboard-x", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ],
  ["path", { d: "m15 11-6 6", key: "1toa9n" }],
  ["path", { d: "m9 11 6 6", key: "wlibny" }]
]);
const ls = n("clipboard", [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
]);
const is = n("clock-1", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 8", key: "12zbmj" }]
]);
const cs = n("clock-10", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 10", key: "atfzqc" }]
]);
const ds = n("clock-11", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 8", key: "l5bg6f" }]
]);
const ss = n("clock-12", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12", key: "1fub01" }]
]);
const us = n("clock-2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 10", key: "1g230d" }]
]);
const hs = n("clock-3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16.5 12", key: "1aq6pp" }]
]);
const ps = n("clock-4", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
const ys = n("clock-5", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 14.5 16", key: "1pcbox" }]
]);
const ks = n("clock-6", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 12 16.5", key: "hb2qv6" }]
]);
const ms = n("clock-7", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 9.5 16", key: "ka3394" }]
]);
const fs = n("clock-8", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 8 14", key: "tmc9b4" }]
]);
const vs = n("clock-9", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 7.5 12", key: "1k60p0" }]
]);
const gs = n("clock-alert", [
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M16 21.16a10 10 0 1 1 5-13.516", key: "cxo92l" }],
  ["path", { d: "M20 11.5v6", key: "2ei3xq" }],
  ["path", { d: "M20 21.5h.01", key: "1r2dzp" }]
]);
const Ms = n("clock-arrow-down", [
  ["path", { d: "M12.338 21.994A10 10 0 1 1 21.925 13.227", key: "1i7shu" }],
  ["path", { d: "M12 6v6l2 1", key: "19cm8n" }],
  ["path", { d: "m14 18 4 4 4-4", key: "1waygx" }],
  ["path", { d: "M18 14v8", key: "irew45" }]
]);
const bs = n("clock-arrow-up", [
  ["path", { d: "M13.228 21.925A10 10 0 1 1 21.994 12.338", key: "1fzlyi" }],
  ["path", { d: "M12 6v6l1.562.781", key: "1ujuk9" }],
  ["path", { d: "m14 18 4-4 4 4", key: "ftkppy" }],
  ["path", { d: "M18 22v-8", key: "su0gjh" }]
]);
const xs = n("clock-fading", [
  ["path", { d: "M12 2a10 10 0 0 1 7.38 16.75", key: "175t95" }],
  ["path", { d: "M12 6v6l4 2", key: "mmk7yg" }],
  ["path", { d: "M2.5 8.875a10 10 0 0 0-.5 3", key: "1vce0s" }],
  ["path", { d: "M2.83 16a10 10 0 0 0 2.43 3.4", key: "o3fkw4" }],
  ["path", { d: "M4.636 5.235a10 10 0 0 1 .891-.857", key: "1szpfk" }],
  ["path", { d: "M8.644 21.42a10 10 0 0 0 7.631-.38", key: "9yhvd4" }]
]);
const ws = n("clock", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["polyline", { points: "12 6 12 12 16 14", key: "68esgv" }]
]);
const Ls = n("cloud-alert", [
  ["path", { d: "M12 12v4", key: "tww15h" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M17 18h.5a1 1 0 0 0 0-9h-1.79A7 7 0 1 0 7 17.708", key: "xsb5ju" }]
]);
const f1 = n("cloud-download", [
  ["path", { d: "M12 13v8l-4-4", key: "1f5nwf" }],
  ["path", { d: "m12 21 4-4", key: "1lfcce" }],
  ["path", { d: "M4.393 15.269A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.436 8.284", key: "ui1hmy" }]
]);
const Ss = n("cloud-cog", [
  ["circle", { cx: "12", cy: "17", r: "3", key: "1spfwm" }],
  ["path", { d: "M4.2 15.1A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.2", key: "zaobp" }],
  ["path", { d: "m15.7 18.4-.9-.3", key: "4qxpbn" }],
  ["path", { d: "m9.2 15.9-.9-.3", key: "17q7o2" }],
  ["path", { d: "m10.6 20.7.3-.9", key: "1pf4s2" }],
  ["path", { d: "m13.1 14.2.3-.9", key: "1mnuqm" }],
  ["path", { d: "m13.6 20.7-.4-1", key: "1jpd1m" }],
  ["path", { d: "m10.8 14.3-.4-1", key: "17ugyy" }],
  ["path", { d: "m8.3 18.6 1-.4", key: "s42vdx" }],
  ["path", { d: "m14.7 15.8 1-.4", key: "2wizun" }]
]);
const Is = n("cloud-drizzle", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 19v1", key: "1dk2by" }],
  ["path", { d: "M8 14v1", key: "84yxot" }],
  ["path", { d: "M16 19v1", key: "v220m7" }],
  ["path", { d: "M16 14v1", key: "g12gj6" }],
  ["path", { d: "M12 21v1", key: "q8vafk" }],
  ["path", { d: "M12 16v1", key: "1mx6rx" }]
]);
const Cs = n("cloud-hail", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v2", key: "a1is7l" }],
  ["path", { d: "M8 14v2", key: "1e9m6t" }],
  ["path", { d: "M16 20h.01", key: "xwek51" }],
  ["path", { d: "M8 20h.01", key: "1vjney" }],
  ["path", { d: "M12 16v2", key: "z66u1j" }],
  ["path", { d: "M12 22h.01", key: "1urd7a" }]
]);
const As = n("cloud-fog", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 17H7", key: "pygtm1" }],
  ["path", { d: "M17 21H9", key: "1u2q02" }]
]);
const qs = n("cloud-lightning", [
  ["path", { d: "M6 16.326A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 .5 8.973", key: "1cez44" }],
  ["path", { d: "m13 12-3 5h4l-3 5", key: "1t22er" }]
]);
const zs = n("cloud-moon-rain", [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
const Ps = n("cloud-off", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.782 5.782A7 7 0 0 0 9 19h8.5a4.5 4.5 0 0 0 1.307-.193", key: "yfwify" }],
  [
    "path",
    { d: "M21.532 16.5A4.5 4.5 0 0 0 17.5 10h-1.79A7.008 7.008 0 0 0 10 5.07", key: "jlfiyv" }
  ]
]);
const _s = n("cloud-moon", [
  ["path", { d: "M10.188 8.5A6 6 0 0 1 16 4a1 1 0 0 0 6 6 6 6 0 0 1-3 5.197", key: "erj67n" }],
  ["path", { d: "M13 16a3 3 0 1 1 0 6H7a5 5 0 1 1 4.9-6Z", key: "p44pc9" }]
]);
const js = n("cloud-rain-wind", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m9.2 22 3-7", key: "sb5f6j" }],
  ["path", { d: "m9 13-3 7", key: "500co5" }],
  ["path", { d: "m17 13-3 7", key: "8t2fiy" }]
]);
const Hs = n("cloud-rain", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M16 14v6", key: "1j4efv" }],
  ["path", { d: "M8 14v6", key: "17c4r9" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }]
]);
const Vs = n("cloud-snow", [
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M8 19h.01", key: "puxtts" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M12 21h.01", key: "h35vbk" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }],
  ["path", { d: "M16 19h.01", key: "1vcnzz" }]
]);
const Bs = n("cloud-sun-rain", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M3 20a5 5 0 1 1 8.9-4H13a3 3 0 0 1 2 5.24", key: "1qmrp3" }],
  ["path", { d: "M11 20v2", key: "174qtz" }],
  ["path", { d: "M7 19v2", key: "12npes" }]
]);
const Ds = n("cloud-sun", [
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }],
  ["path", { d: "M15.947 12.65a4 4 0 0 0-5.925-4.128", key: "dpwdj0" }],
  ["path", { d: "M13 22H7a5 5 0 1 1 4.9-6H13a3 3 0 0 1 0 6Z", key: "s09mg5" }]
]);
const v1 = n("cloud-upload", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M4 14.899A7 7 0 1 1 15.71 8h1.79a4.5 4.5 0 0 1 2.5 8.242", key: "1pljnt" }],
  ["path", { d: "m8 17 4-4 4 4", key: "1quai1" }]
]);
const Ts = n("cloud", [
  ["path", { d: "M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "p7xjir" }]
]);
const $s = n("cloudy", [
  ["path", { d: "M17.5 21H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z", key: "gqqjvc" }],
  ["path", { d: "M22 10a3 3 0 0 0-3-3h-2.207a5.502 5.502 0 0 0-10.702.5", key: "1p2s76" }]
]);
const Os = n("clover", [
  ["path", { d: "M16.17 7.83 2 22", key: "t58vo8" }],
  [
    "path",
    {
      d: "M4.02 12a2.827 2.827 0 1 1 3.81-4.17A2.827 2.827 0 1 1 12 4.02a2.827 2.827 0 1 1 4.17 3.81A2.827 2.827 0 1 1 19.98 12a2.827 2.827 0 1 1-3.81 4.17A2.827 2.827 0 1 1 12 19.98a2.827 2.827 0 1 1-4.17-3.81A1 1 0 1 1 4 12",
      key: "17k36q"
    }
  ],
  ["path", { d: "m7.83 7.83 8.34 8.34", key: "1d7sxk" }]
]);
const Rs = n("club", [
  [
    "path",
    {
      d: "M17.28 9.05a5.5 5.5 0 1 0-10.56 0A5.5 5.5 0 1 0 12 17.66a5.5 5.5 0 1 0 5.28-8.6Z",
      key: "27yuqz"
    }
  ],
  ["path", { d: "M12 17.66L12 22", key: "ogfahf" }]
]);
const g1 = n("code-xml", [
  ["path", { d: "m18 16 4-4-4-4", key: "1inbqp" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }],
  ["path", { d: "m14.5 4-5 16", key: "e7oirm" }]
]);
const Fs = n("code", [
  ["polyline", { points: "16 18 22 12 16 6", key: "z7tu5w" }],
  ["polyline", { points: "8 6 2 12 8 18", key: "1eg1df" }]
]);
const Es = n("codepen", [
  ["polygon", { points: "12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2", key: "srzb37" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "15.5", key: "1t73f2" }],
  ["polyline", { points: "22 8.5 12 15.5 2 8.5", key: "ajlxae" }],
  ["polyline", { points: "2 15.5 12 8.5 22 15.5", key: "susrui" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "8.5", key: "2cldga" }]
]);
const Us = n("codesandbox", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ],
  ["polyline", { points: "7.5 4.21 12 6.81 16.5 4.21", key: "fabo96" }],
  ["polyline", { points: "7.5 19.79 7.5 14.6 3 12", key: "z377f1" }],
  ["polyline", { points: "21 12 16.5 14.6 16.5 19.79", key: "9nrev1" }],
  ["polyline", { points: "3.27 6.96 12 12.01 20.73 6.96", key: "1180pa" }],
  ["line", { x1: "12", x2: "12", y1: "22.08", y2: "12", key: "3z3uq6" }]
]);
const Ns = n("cog", [
  ["path", { d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z", key: "sobvz5" }],
  ["path", { d: "M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z", key: "11i496" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }]
]);
const Ws = n("coffee", [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  [
    "path",
    {
      d: "M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1",
      key: "pwadti"
    }
  ],
  ["path", { d: "M6 2v2", key: "colzsn" }]
]);
const Gs = n("coins", [
  ["circle", { cx: "8", cy: "8", r: "6", key: "3yglwk" }],
  ["path", { d: "M18.09 10.37A6 6 0 1 1 10.34 18", key: "t5s6rm" }],
  ["path", { d: "M7 6h1v4", key: "1obek4" }],
  ["path", { d: "m16.71 13.88.7.71-2.82 2.82", key: "1rbuyh" }]
]);
const M1 = n("columns-2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 3v18", key: "108xh3" }]
]);
const b1 = n("columns-3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
const Zs = n("columns-4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7.5 3v18", key: "w0wo6v" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M16.5 3v18", key: "10tjh1" }]
]);
const Ys = n("combine", [
  ["path", { d: "M10 18H5a3 3 0 0 1-3-3v-1", key: "ru65g8" }],
  ["path", { d: "M14 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "e30een" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "2ahx8o" }],
  ["path", { d: "m7 21 3-3-3-3", key: "127cv2" }],
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }]
]);
const Ks = n("command", [
  [
    "path",
    { d: "M15 6v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3", key: "11bfej" }
  ]
]);
const Xs = n("compass", [
  [
    "path",
    {
      d: "m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z",
      key: "9ktpf1"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Qs = n("component", [
  [
    "path",
    {
      d: "M15.536 11.293a1 1 0 0 0 0 1.414l2.376 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1uwlt4"
    }
  ],
  [
    "path",
    {
      d: "M2.297 11.293a1 1 0 0 0 0 1.414l2.377 2.377a1 1 0 0 0 1.414 0l2.377-2.377a1 1 0 0 0 0-1.414L6.088 8.916a1 1 0 0 0-1.414 0z",
      key: "10291m"
    }
  ],
  [
    "path",
    {
      d: "M8.916 17.912a1 1 0 0 0 0 1.415l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.415l-2.377-2.376a1 1 0 0 0-1.414 0z",
      key: "1tqoq1"
    }
  ],
  [
    "path",
    {
      d: "M8.916 4.674a1 1 0 0 0 0 1.414l2.377 2.376a1 1 0 0 0 1.414 0l2.377-2.376a1 1 0 0 0 0-1.414l-2.377-2.377a1 1 0 0 0-1.414 0z",
      key: "1x6lto"
    }
  ]
]);
const Js = n("computer", [
  ["rect", { width: "14", height: "8", x: "5", y: "2", rx: "2", key: "wc9tft" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h2", key: "rwmk9e" }],
  ["path", { d: "M12 18h6", key: "aqd8w3" }]
]);
const eu = n("concierge-bell", [
  [
    "path",
    { d: "M3 20a1 1 0 0 1-1-1v-1a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1Z", key: "1pvr1r" }
  ],
  ["path", { d: "M20 16a8 8 0 1 0-16 0", key: "1pa543" }],
  ["path", { d: "M12 4v4", key: "1bq03y" }],
  ["path", { d: "M10 4h4", key: "1xpv9s" }]
]);
const tu = n("cone", [
  ["path", { d: "m20.9 18.55-8-15.98a1 1 0 0 0-1.8 0l-8 15.98", key: "53pte7" }],
  ["ellipse", { cx: "12", cy: "19", rx: "9", ry: "3", key: "1ji25f" }]
]);
const au = n("construction", [
  ["rect", { x: "2", y: "6", width: "20", height: "8", rx: "1", key: "1estib" }],
  ["path", { d: "M17 14v7", key: "7m2elx" }],
  ["path", { d: "M7 14v7", key: "1cm7wv" }],
  ["path", { d: "M17 3v3", key: "1v4jwn" }],
  ["path", { d: "M7 3v3", key: "7o6guu" }],
  ["path", { d: "M10 14 2.3 6.3", key: "1023jk" }],
  ["path", { d: "m14 6 7.7 7.7", key: "1s8pl2" }],
  ["path", { d: "m8 6 8 8", key: "hl96qh" }]
]);
const x1 = n("contact-round", [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M17.915 22a6 6 0 0 0-12 0", key: "suqz9p" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
const nu = n("contact", [
  ["path", { d: "M16 2v2", key: "scm5qe" }],
  ["path", { d: "M7 22v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1waht3" }],
  ["path", { d: "M8 2v2", key: "pbkmx" }],
  ["circle", { cx: "12", cy: "11", r: "3", key: "itu57m" }],
  ["rect", { x: "3", y: "4", width: "18", height: "18", rx: "2", key: "12vinp" }]
]);
const ou = n("container", [
  [
    "path",
    {
      d: "M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z",
      key: "1t2lqe"
    }
  ],
  ["path", { d: "M10 21.9V14L2.1 9.1", key: "o7czzq" }],
  ["path", { d: "m10 14 11.9-6.9", key: "zm5e20" }],
  ["path", { d: "M14 19.8v-8.1", key: "159ecu" }],
  ["path", { d: "M18 17.5V9.4", key: "11uown" }]
]);
const ru = n("contrast", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 18a6 6 0 0 0 0-12v12z", key: "j4l70d" }]
]);
const lu = n("cookie", [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
]);
const iu = n("cooking-pot", [
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8", key: "u0tga0" }],
  ["path", { d: "m4 8 16-4", key: "16g0ng" }],
  [
    "path",
    {
      d: "m8.86 6.78-.45-1.81a2 2 0 0 1 1.45-2.43l1.94-.48a2 2 0 0 1 2.43 1.46l.45 1.8",
      key: "12cejc"
    }
  ]
]);
const cu = n("copy-check", [
  ["path", { d: "m12 15 2 2 4-4", key: "2c609p" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const du = n("copy-plus", [
  ["line", { x1: "15", x2: "15", y1: "12", y2: "18", key: "1p7wdc" }],
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const su = n("copy-slash", [
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const uu = n("copy-x", [
  ["line", { x1: "12", x2: "18", y1: "12", y2: "18", key: "1rg63v" }],
  ["line", { x1: "12", x2: "18", y1: "18", y2: "12", key: "ebkxgr" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const hu = n("copy-minus", [
  ["line", { x1: "12", x2: "18", y1: "15", y2: "15", key: "1nscbv" }],
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const pu = n("copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
const yu = n("copyleft", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.17 14.83a4 4 0 1 0 0-5.66", key: "1sveal" }]
]);
const ku = n("copyright", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M14.83 14.83a4 4 0 1 1 0-5.66", key: "1i56pz" }]
]);
const mu = n("corner-down-left", [
  ["polyline", { points: "9 10 4 15 9 20", key: "r3jprv" }],
  ["path", { d: "M20 4v7a4 4 0 0 1-4 4H4", key: "6o5b7l" }]
]);
const fu = n("corner-down-right", [
  ["polyline", { points: "15 10 20 15 15 20", key: "1q7qjw" }],
  ["path", { d: "M4 4v7a4 4 0 0 0 4 4h12", key: "z08zvw" }]
]);
const vu = n("corner-left-down", [
  ["polyline", { points: "14 15 9 20 4 15", key: "nkc4i" }],
  ["path", { d: "M20 4h-7a4 4 0 0 0-4 4v12", key: "nbpdq2" }]
]);
const gu = n("corner-left-up", [
  ["polyline", { points: "14 9 9 4 4 9", key: "m9oyvo" }],
  ["path", { d: "M20 20h-7a4 4 0 0 1-4-4V4", key: "1blwi3" }]
]);
const Mu = n("corner-right-down", [
  ["polyline", { points: "10 15 15 20 20 15", key: "axus6l" }],
  ["path", { d: "M4 4h7a4 4 0 0 1 4 4v12", key: "wcbgct" }]
]);
const bu = n("corner-right-up", [
  ["polyline", { points: "10 9 15 4 20 9", key: "1lr6px" }],
  ["path", { d: "M4 20h7a4 4 0 0 0 4-4V4", key: "1plgdj" }]
]);
const xu = n("corner-up-left", [
  ["polyline", { points: "9 14 4 9 9 4", key: "881910" }],
  ["path", { d: "M20 20v-7a4 4 0 0 0-4-4H4", key: "1nkjon" }]
]);
const wu = n("corner-up-right", [
  ["polyline", { points: "15 14 20 9 15 4", key: "1tbx3s" }],
  ["path", { d: "M4 20v-7a4 4 0 0 1 4-4h12", key: "1lu4f8" }]
]);
const Lu = n("cpu", [
  ["rect", { width: "16", height: "16", x: "4", y: "4", rx: "2", key: "14l7u7" }],
  ["rect", { width: "6", height: "6", x: "9", y: "9", rx: "1", key: "5aljv4" }],
  ["path", { d: "M15 2v2", key: "13l42r" }],
  ["path", { d: "M15 20v2", key: "15mkzm" }],
  ["path", { d: "M2 15h2", key: "1gxd5l" }],
  ["path", { d: "M2 9h2", key: "1bbxkp" }],
  ["path", { d: "M20 15h2", key: "19e6y8" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M9 2v2", key: "165o2o" }],
  ["path", { d: "M9 20v2", key: "i2bqo8" }]
]);
const Su = n("credit-card", [
  ["rect", { width: "20", height: "14", x: "2", y: "5", rx: "2", key: "ynyp8z" }],
  ["line", { x1: "2", x2: "22", y1: "10", y2: "10", key: "1b3vmo" }]
]);
const Iu = n("creative-commons", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  [
    "path",
    { d: "M10 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1ss3eq" }
  ],
  [
    "path",
    { d: "M17 9.3a2.8 2.8 0 0 0-3.5 1 3.1 3.1 0 0 0 0 3.4 2.7 2.7 0 0 0 3.5 1", key: "1od56t" }
  ]
]);
const Cu = n("croissant", [
  [
    "path",
    {
      d: "m4.6 13.11 5.79-3.21c1.89-1.05 4.79 1.78 3.71 3.71l-3.22 5.81C8.8 23.16.79 15.23 4.6 13.11Z",
      key: "1ozxlb"
    }
  ],
  [
    "path",
    {
      d: "m10.5 9.5-1-2.29C9.2 6.48 8.8 6 8 6H4.5C2.79 6 2 6.5 2 8.5a7.71 7.71 0 0 0 2 4.83",
      key: "ffuyb5"
    }
  ],
  ["path", { d: "M8 6c0-1.55.24-4-2-4-2 0-2.5 2.17-2.5 4", key: "osnpzi" }],
  [
    "path",
    {
      d: "m14.5 13.5 2.29 1c.73.3 1.21.7 1.21 1.5v3.5c0 1.71-.5 2.5-2.5 2.5a7.71 7.71 0 0 1-4.83-2",
      key: "1vubaw"
    }
  ],
  ["path", { d: "M18 16c1.55 0 4-.24 4 2 0 2-2.17 2.5-4 2.5", key: "wxr772" }]
]);
const Au = n("crop", [
  ["path", { d: "M6 2v14a2 2 0 0 0 2 2h14", key: "ron5a4" }],
  ["path", { d: "M18 22V8a2 2 0 0 0-2-2H2", key: "7s9ehn" }]
]);
const qu = n("cross", [
  [
    "path",
    {
      d: "M4 9a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h4a1 1 0 0 1 1 1v4a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-4a1 1 0 0 1 1-1h4a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2h-4a1 1 0 0 1-1-1V4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4a1 1 0 0 1-1 1z",
      key: "1xbrqy"
    }
  ]
]);
const zu = n("crosshair", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "22", x2: "18", y1: "12", y2: "12", key: "l9bcsi" }],
  ["line", { x1: "6", x2: "2", y1: "12", y2: "12", key: "13hhkx" }],
  ["line", { x1: "12", x2: "12", y1: "6", y2: "2", key: "10w3f3" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "18", key: "15g9kq" }]
]);
const Pu = n("crown", [
  [
    "path",
    {
      d: "M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z",
      key: "1vdc57"
    }
  ],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
const _u = n("cuboid", [
  [
    "path",
    {
      d: "m21.12 6.4-6.05-4.06a2 2 0 0 0-2.17-.05L2.95 8.41a2 2 0 0 0-.95 1.7v5.82a2 2 0 0 0 .88 1.66l6.05 4.07a2 2 0 0 0 2.17.05l9.95-6.12a2 2 0 0 0 .95-1.7V8.06a2 2 0 0 0-.88-1.66Z",
      key: "1u2ovd"
    }
  ],
  ["path", { d: "M10 22v-8L2.25 9.15", key: "11pn4q" }],
  ["path", { d: "m10 14 11.77-6.87", key: "1kt1wh" }]
]);
const ju = n("cup-soda", [
  ["path", { d: "m6 8 1.75 12.28a2 2 0 0 0 2 1.72h4.54a2 2 0 0 0 2-1.72L18 8", key: "8166m8" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "yjz344" }],
  ["path", { d: "m12 8 1-6h2", key: "3ybfa4" }]
]);
const Hu = n("currency", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["line", { x1: "3", x2: "6", y1: "3", y2: "6", key: "1jkytn" }],
  ["line", { x1: "21", x2: "18", y1: "3", y2: "6", key: "14zfjt" }],
  ["line", { x1: "3", x2: "6", y1: "21", y2: "18", key: "iusuec" }],
  ["line", { x1: "21", x2: "18", y1: "21", y2: "18", key: "yj2dd7" }]
]);
const Vu = n("cylinder", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 18 0V5", key: "aqi0yr" }]
]);
const Bu = n("dam", [
  [
    "path",
    { d: "M11 11.31c1.17.56 1.54 1.69 3.5 1.69 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "157kva" }
  ],
  ["path", { d: "M11.75 18c.35.5 1.45 1 2.75 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1", key: "d7q6m6" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  [
    "path",
    { d: "M7 3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1L10 4a1 1 0 0 0-1-1z", key: "pr6s65" }
  ]
]);
const Du = n("database-backup", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 12a9 3 0 0 0 5 2.69", key: "1ui2ym" }],
  ["path", { d: "M21 9.3V5", key: "6k6cib" }],
  ["path", { d: "M3 5v14a9 3 0 0 0 6.47 2.88", key: "i62tjy" }],
  ["path", { d: "M12 12v4h4", key: "1bxaet" }],
  [
    "path",
    {
      d: "M13 20a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L12 16",
      key: "1f4ei9"
    }
  ]
]);
const Tu = n("database", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 21 19V5", key: "1wlel7" }],
  ["path", { d: "M3 12A9 3 0 0 0 21 12", key: "mv7ke4" }]
]);
const $u = n("database-zap", [
  ["ellipse", { cx: "12", cy: "5", rx: "9", ry: "3", key: "msslwz" }],
  ["path", { d: "M3 5V19A9 3 0 0 0 15 21.84", key: "14ibmq" }],
  ["path", { d: "M21 5V8", key: "1marbg" }],
  ["path", { d: "M21 12L18 17H22L19 22", key: "zafso" }],
  ["path", { d: "M3 12A9 3 0 0 0 14.59 14.87", key: "1y4wr8" }]
]);
const Ou = n("delete", [
  [
    "path",
    {
      d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
      key: "1yo7s0"
    }
  ],
  ["path", { d: "m12 9 6 6", key: "anjzzh" }],
  ["path", { d: "m18 9-6 6", key: "1fp51s" }]
]);
const Ru = n("dessert", [
  ["circle", { cx: "12", cy: "4", r: "2", key: "muu5ef" }],
  [
    "path",
    {
      d: "M10.2 3.2C5.5 4 2 8.1 2 13a2 2 0 0 0 4 0v-1a2 2 0 0 1 4 0v4a2 2 0 0 0 4 0v-4a2 2 0 0 1 4 0v1a2 2 0 0 0 4 0c0-4.9-3.5-9-8.2-9.8",
      key: "lfo06j"
    }
  ],
  ["path", { d: "M3.2 14.8a9 9 0 0 0 17.6 0", key: "12xarc" }]
]);
const Fu = n("diameter", [
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }],
  ["path", { d: "M6.48 3.66a10 10 0 0 1 13.86 13.86", key: "xr8kdq" }],
  ["path", { d: "m6.41 6.41 11.18 11.18", key: "uhpjw7" }],
  ["path", { d: "M3.66 6.48a10 10 0 0 0 13.86 13.86", key: "cldpwv" }]
]);
const Eu = n("diamond-minus", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const w1 = n("diamond-percent", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0Z",
      key: "1tpxz2"
    }
  ],
  ["path", { d: "M9.2 9.2h.01", key: "1b7bvt" }],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "M14.7 14.8h.01", key: "17nsh4" }]
]);
const Uu = n("diamond-plus", [
  ["path", { d: "M12 8v8", key: "napkw2" }],
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41L13.7 2.71a2.41 2.41 0 0 0-3.41 0z",
      key: "1ey20j"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const Nu = n("diamond", [
  [
    "path",
    {
      d: "M2.7 10.3a2.41 2.41 0 0 0 0 3.41l7.59 7.59a2.41 2.41 0 0 0 3.41 0l7.59-7.59a2.41 2.41 0 0 0 0-3.41l-7.59-7.59a2.41 2.41 0 0 0-3.41 0Z",
      key: "1f1r0c"
    }
  ]
]);
const Wu = n("dice-1", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
const Gu = n("dice-2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M9 15h.01", key: "fzyn71" }]
]);
const Zu = n("dice-3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
const Yu = n("dice-4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }]
]);
const Ku = n("dice-5", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
const Xu = n("dice-6", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M16 8h.01", key: "cr5u4v" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M16 16h.01", key: "1f9h7w" }],
  ["path", { d: "M8 8h.01", key: "1e4136" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M8 16h.01", key: "18s6g9" }]
]);
const Qu = n("dices", [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
]);
const Ju = n("diff", [
  ["path", { d: "M12 3v14", key: "7cf3v8" }],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M5 21h14", key: "11awu3" }]
]);
const eh = n("disc-2", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
const th = n("disc-3", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M6 12c0-1.7.7-3.2 1.8-4.2", key: "oqkarx" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M18 12c0 1.7-.7 3.2-1.8 4.2", key: "1eah9h" }]
]);
const ah = n("disc-album", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "5", key: "nd82uf" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }]
]);
const nh = n("disc", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const oh = n("divide", [
  ["circle", { cx: "12", cy: "6", r: "1", key: "1bh7o1" }],
  ["line", { x1: "5", x2: "19", y1: "12", y2: "12", key: "13b5wn" }],
  ["circle", { cx: "12", cy: "18", r: "1", key: "lqb9t5" }]
]);
const rh = n("dna-off", [
  ["path", { d: "M15 2c-1.35 1.5-2.092 3-2.5 4.5L14 8", key: "1bivrr" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c3.333-3 6.667-3 10-3", key: "nxix30" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M22 9c-1.5 1.35-3 2.092-4.5 2.5l-1-1", key: "18cutr" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.35-1.5 2.092-3 2.5-4.5L10 16", key: "rlvei3" }]
]);
const lh = n("dna", [
  ["path", { d: "m10 16 1.5 1.5", key: "11lckj" }],
  ["path", { d: "m14 8-1.5-1.5", key: "1ohn8i" }],
  ["path", { d: "M15 2c-1.798 1.998-2.518 3.995-2.807 5.993", key: "80uv8i" }],
  ["path", { d: "m16.5 10.5 1 1", key: "696xn5" }],
  ["path", { d: "m17 6-2.891-2.891", key: "xu6p2f" }],
  ["path", { d: "M2 15c6.667-6 13.333 0 20-6", key: "1pyr53" }],
  ["path", { d: "m20 9 .891.891", key: "3xwk7g" }],
  ["path", { d: "M3.109 14.109 4 15", key: "q76aoh" }],
  ["path", { d: "m6.5 12.5 1 1", key: "cs35ky" }],
  ["path", { d: "m7 18 2.891 2.891", key: "1sisit" }],
  ["path", { d: "M9 22c1.798-1.998 2.518-3.995 2.807-5.993", key: "q3hbxp" }]
]);
const ih = n("dock", [
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 16h12", key: "u522kt" }]
]);
const ch = n("dog", [
  ["path", { d: "M11.25 16.25h1.5L12 17z", key: "w7jh35" }],
  ["path", { d: "M16 14v.5", key: "1lajdz" }],
  [
    "path",
    {
      d: "M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444a11.702 11.702 0 0 0-.493-3.309",
      key: "u7s9ue"
    }
  ],
  ["path", { d: "M8 14v.5", key: "1nzgdb" }],
  [
    "path",
    {
      d: "M8.5 8.5c-.384 1.05-1.083 2.028-2.344 2.5-1.931.722-3.576-.297-3.656-1-.113-.994 1.177-6.53 4-7 1.923-.321 3.651.845 3.651 2.235A7.497 7.497 0 0 1 14 5.277c0-1.39 1.844-2.598 3.767-2.277 2.823.47 4.113 6.006 4 7-.08.703-1.725 1.722-3.656 1-1.261-.472-1.855-1.45-2.239-2.5",
      key: "v8hric"
    }
  ]
]);
const dh = n("dollar-sign", [
  ["line", { x1: "12", x2: "12", y1: "2", y2: "22", key: "7eqyqh" }],
  ["path", { d: "M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6", key: "1b0p4s" }]
]);
const sh = n("donut", [
  [
    "path",
    {
      d: "M20.5 10a2.5 2.5 0 0 1-2.4-3H18a2.95 2.95 0 0 1-2.6-4.4 10 10 0 1 0 6.3 7.1c-.3.2-.8.3-1.2.3",
      key: "19sr3x"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const uh = n("door-closed", [
  ["path", { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", key: "36qu9e" }],
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "M14 12v.01", key: "xfcn54" }]
]);
const hh = n("door-open", [
  ["path", { d: "M13 4h3a2 2 0 0 1 2 2v14", key: "hrm0s9" }],
  ["path", { d: "M2 20h3", key: "1gaodv" }],
  ["path", { d: "M13 20h9", key: "s90cdi" }],
  ["path", { d: "M10 12v.01", key: "vx6srw" }],
  [
    "path",
    {
      d: "M13 4.562v16.157a1 1 0 0 1-1.242.97L5 20V5.562a2 2 0 0 1 1.515-1.94l4-1A2 2 0 0 1 13 4.561Z",
      key: "199qr4"
    }
  ]
]);
const ph = n("dot", [
  ["circle", { cx: "12.1", cy: "12.1", r: "1", key: "18d7e5" }]
]);
const yh = n("download", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "7 10 12 15 17 10", key: "2ggqvy" }],
  ["line", { x1: "12", x2: "12", y1: "15", y2: "3", key: "1vk2je" }]
]);
const kh = n("drafting-compass", [
  ["path", { d: "m12.99 6.74 1.93 3.44", key: "iwagvd" }],
  ["path", { d: "M19.136 12a10 10 0 0 1-14.271 0", key: "ppmlo4" }],
  ["path", { d: "m21 21-2.16-3.84", key: "vylbct" }],
  ["path", { d: "m3 21 8.02-14.26", key: "1ssaw4" }],
  ["circle", { cx: "12", cy: "5", r: "2", key: "f1ur92" }]
]);
const mh = n("drama", [
  ["path", { d: "M10 11h.01", key: "d2at3l" }],
  ["path", { d: "M14 6h.01", key: "k028ub" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6.5 13.1h.01", key: "1748ia" }],
  ["path", { d: "M22 5c0 9-4 12-6 12s-6-3-6-12c0-2 2-3 6-3s6 1 6 3", key: "172yzv" }],
  ["path", { d: "M17.4 9.9c-.8.8-2 .8-2.8 0", key: "1obv0w" }],
  [
    "path",
    {
      d: "M10.1 7.1C9 7.2 7.7 7.7 6 8.6c-3.5 2-4.7 3.9-3.7 5.6 4.5 7.8 9.5 8.4 11.2 7.4.9-.5 1.9-2.1 1.9-4.7",
      key: "rqjl8i"
    }
  ],
  ["path", { d: "M9.1 16.5c.3-1.1 1.4-1.7 2.4-1.4", key: "1mr6wy" }]
]);
const fh = n("dribbble", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M19.13 5.09C15.22 9.14 10 10.44 2.25 10.94", key: "hpej1" }],
  ["path", { d: "M21.75 12.84c-6.62-1.41-12.14 1-16.38 6.32", key: "1tr44o" }],
  ["path", { d: "M8.56 2.75c4.37 6 6 9.42 8 17.72", key: "kbh691" }]
]);
const vh = n("drill", [
  [
    "path",
    { d: "M10 18a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H5a3 3 0 0 1-3-3 1 1 0 0 1 1-1z", key: "ioqxb1" }
  ],
  [
    "path",
    {
      d: "M13 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1l-.81 3.242a1 1 0 0 1-.97.758H8",
      key: "1rs59n"
    }
  ],
  ["path", { d: "M14 4h3a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3", key: "105ega" }],
  ["path", { d: "M18 6h4", key: "66u95g" }],
  ["path", { d: "m5 10-2 8", key: "xt2lic" }],
  ["path", { d: "m7 18 2-8", key: "1bzku2" }]
]);
const gh = n("droplet-off", [
  [
    "path",
    {
      d: "M18.715 13.186C18.29 11.858 17.384 10.607 16 9.5c-2-1.6-3.5-4-4-6.5a10.7 10.7 0 0 1-.884 2.586",
      key: "8suz2t"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M8.795 8.797A11 11 0 0 1 8 9.5C6 11.1 5 13 5 15a7 7 0 0 0 13.222 3.208", key: "19dw9m" }
  ]
]);
const Mh = n("droplet", [
  [
    "path",
    {
      d: "M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5c-.5 2.5-2 4.9-4 6.5C6 11.1 5 13 5 15a7 7 0 0 0 7 7z",
      key: "c7niix"
    }
  ]
]);
const bh = n("droplets", [
  [
    "path",
    {
      d: "M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z",
      key: "1ptgy4"
    }
  ],
  [
    "path",
    {
      d: "M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97",
      key: "1sl1rz"
    }
  ]
]);
const xh = n("drum", [
  ["path", { d: "m2 2 8 8", key: "1v6059" }],
  ["path", { d: "m22 2-8 8", key: "173r8a" }],
  ["ellipse", { cx: "12", cy: "9", rx: "10", ry: "5", key: "liohsx" }],
  ["path", { d: "M7 13.4v7.9", key: "1yi6u9" }],
  ["path", { d: "M12 14v8", key: "1tn2tj" }],
  ["path", { d: "M17 13.4v7.9", key: "eqz2v3" }],
  ["path", { d: "M2 9v8a10 5 0 0 0 20 0V9", key: "1750ul" }]
]);
const wh = n("drumstick", [
  [
    "path",
    { d: "M15.4 15.63a7.875 6 135 1 1 6.23-6.23 4.5 3.43 135 0 0-6.23 6.23", key: "1dtqwm" }
  ],
  [
    "path",
    {
      d: "m8.29 12.71-2.6 2.6a2.5 2.5 0 1 0-1.65 4.65A2.5 2.5 0 1 0 8.7 18.3l2.59-2.59",
      key: "1oq1fw"
    }
  ]
]);
const Lh = n("dumbbell", [
  ["path", { d: "M14.4 14.4 9.6 9.6", key: "ic80wn" }],
  [
    "path",
    {
      d: "M18.657 21.485a2 2 0 1 1-2.829-2.828l-1.767 1.768a2 2 0 1 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.829 2.829l-1.768 1.767a2 2 0 1 1 2.828 2.829z",
      key: "nnl7wr"
    }
  ],
  ["path", { d: "m21.5 21.5-1.4-1.4", key: "1f1ice" }],
  ["path", { d: "M3.9 3.9 2.5 2.5", key: "1evmna" }],
  [
    "path",
    {
      d: "M6.404 12.768a2 2 0 1 1-2.829-2.829l1.768-1.767a2 2 0 1 1-2.828-2.829l2.828-2.828a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z",
      key: "yhosts"
    }
  ]
]);
const Sh = n("ear-off", [
  ["path", { d: "M6 18.5a3.5 3.5 0 1 0 7 0c0-1.57.92-2.52 2.04-3.46", key: "1qngmn" }],
  ["path", { d: "M6 8.5c0-.75.13-1.47.36-2.14", key: "b06bma" }],
  ["path", { d: "M8.8 3.15A6.5 6.5 0 0 1 19 8.5c0 1.63-.44 2.81-1.09 3.76", key: "g10hsz" }],
  ["path", { d: "M12.5 6A2.5 2.5 0 0 1 15 8.5M10 13a2 2 0 0 0 1.82-1.18", key: "ygzou7" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const Ih = n("ear", [
  ["path", { d: "M6 8.5a6.5 6.5 0 1 1 13 0c0 6-6 6-6 10a3.5 3.5 0 1 1-7 0", key: "1dfaln" }],
  ["path", { d: "M15 8.5a2.5 2.5 0 0 0-5 0v1a2 2 0 1 1 0 4", key: "1qnva7" }]
]);
const Ch = n("earth-lock", [
  ["path", { d: "M7 3.34V5a3 3 0 0 0 3 3", key: "w732o8" }],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2 2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "f02343" }],
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  ["path", { d: "M12 2a10 10 0 1 0 9.54 13", key: "zjsr6q" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
const L1 = n("earth", [
  ["path", { d: "M21.54 15H17a2 2 0 0 0-2 2v4.54", key: "1djwo0" }],
  [
    "path",
    {
      d: "M7 3.34V5a3 3 0 0 0 3 3a2 2 0 0 1 2 2c0 1.1.9 2 2 2a2 2 0 0 0 2-2c0-1.1.9-2 2-2h3.17",
      key: "1tzkfa"
    }
  ],
  ["path", { d: "M11 21.95V18a2 2 0 0 0-2-2a2 2 0 0 1-2-2v-1a2 2 0 0 0-2-2H2.05", key: "14pb5j" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Ah = n("eclipse", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a7 7 0 1 0 10 10", key: "1yuj32" }]
]);
const qh = n("egg-fried", [
  ["circle", { cx: "11.5", cy: "12.5", r: "3.5", key: "1cl1mi" }],
  [
    "path",
    {
      d: "M3 8c0-3.5 2.5-6 6.5-6 5 0 4.83 3 7.5 5s5 2 5 6c0 4.5-2.5 6.5-7 6.5-2.5 0-2.5 2.5-6 2.5s-7-2-7-5.5c0-3 1.5-3 1.5-5C3.5 10 3 9 3 8Z",
      key: "165ef9"
    }
  ]
]);
const zh = n("egg-off", [
  [
    "path",
    {
      d: "M6.399 6.399C5.362 8.157 4.65 10.189 4.5 12c-.37 4.43 1.27 9.95 7.5 10 3.256-.026 5.259-1.547 6.375-3.625",
      key: "6et380"
    }
  ],
  [
    "path",
    {
      d: "M19.532 13.875A14.07 14.07 0 0 0 19.5 12c-.36-4.34-3.95-9.96-7.5-10-1.04.012-2.082.502-3.046 1.297",
      key: "gcdc3f"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const Ph = n("egg", [
  [
    "path",
    {
      d: "M12 22c6.23-.05 7.87-5.57 7.5-10-.36-4.34-3.95-9.96-7.5-10-3.55.04-7.14 5.66-7.5 10-.37 4.43 1.27 9.95 7.5 10z",
      key: "1c39pg"
    }
  ]
]);
const S1 = n("ellipsis-vertical", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
]);
const I1 = n("ellipsis", [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }]
]);
const _h = n("equal-approximately", [
  ["path", { d: "M5 15a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "yrdkhy" }],
  ["path", { d: "M5 9a6.5 6.5 0 0 1 7 0 6.5 6.5 0 0 0 7 0", key: "gzkvyz" }]
]);
const jh = n("equal-not", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }],
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }]
]);
const Hh = n("equal", [
  ["line", { x1: "5", x2: "19", y1: "9", y2: "9", key: "1nwqeh" }],
  ["line", { x1: "5", x2: "19", y1: "15", y2: "15", key: "g8yjpy" }]
]);
const Vh = n("eraser", [
  [
    "path",
    {
      d: "m7 21-4.3-4.3c-1-1-1-2.5 0-3.4l9.6-9.6c1-1 2.5-1 3.4 0l5.6 5.6c1 1 1 2.5 0 3.4L13 21",
      key: "182aya"
    }
  ],
  ["path", { d: "M22 21H7", key: "t4ddhn" }],
  ["path", { d: "m5 11 9 9", key: "1mo9qw" }]
]);
const Bh = n("ethernet-port", [
  [
    "path",
    {
      d: "m15 20 3-3h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2l3 3z",
      key: "rbahqx"
    }
  ],
  ["path", { d: "M6 8v1", key: "1636ez" }],
  ["path", { d: "M10 8v1", key: "1talb4" }],
  ["path", { d: "M14 8v1", key: "1rsfgr" }],
  ["path", { d: "M18 8v1", key: "gnkwox" }]
]);
const Dh = n("euro", [
  ["path", { d: "M4 10h12", key: "1y6xl8" }],
  ["path", { d: "M4 14h9", key: "1loblj" }],
  [
    "path",
    {
      d: "M19 6a7.7 7.7 0 0 0-5.2-2A7.9 7.9 0 0 0 6 12c0 4.4 3.5 8 7.8 8 2 0 3.8-.8 5.2-2",
      key: "1j6lzo"
    }
  ]
]);
const Th = n("expand", [
  ["path", { d: "m15 15 6 6", key: "1s409w" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }],
  ["path", { d: "M21 16.2V21h-4.8", key: "1hrera" }],
  ["path", { d: "M21 7.8V3h-4.8", key: "ul1q53" }],
  ["path", { d: "M3 16.2V21h4.8", key: "1x04uo" }],
  ["path", { d: "m3 21 6-6", key: "wwnumi" }],
  ["path", { d: "M3 7.8V3h4.8", key: "1ijppm" }],
  ["path", { d: "M9 9 3 3", key: "v551iv" }]
]);
const $h = n("external-link", [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "M10 14 21 3", key: "gplh6r" }],
  ["path", { d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6", key: "a6xqqp" }]
]);
const Oh = n("eye-closed", [
  ["path", { d: "m15 18-.722-3.25", key: "1j64jw" }],
  ["path", { d: "M2 8a10.645 10.645 0 0 0 20 0", key: "1e7gxb" }],
  ["path", { d: "m20 15-1.726-2.05", key: "1cnuld" }],
  ["path", { d: "m4 15 1.726-2.05", key: "1dsqqd" }],
  ["path", { d: "m9 18 .722-3.25", key: "ypw2yx" }]
]);
const Rh = n("eye-off", [
  [
    "path",
    {
      d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
      key: "ct8e1f"
    }
  ],
  ["path", { d: "M14.084 14.158a3 3 0 0 1-4.242-4.242", key: "151rxh" }],
  [
    "path",
    {
      d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
      key: "13bj9a"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const Fh = n("eye", [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const Eh = n("facebook", [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
]);
const Uh = n("factory", [
  [
    "path",
    {
      d: "M2 20a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8l-7 5V8l-7 5V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "159hny"
    }
  ],
  ["path", { d: "M17 18h1", key: "uldtlt" }],
  ["path", { d: "M12 18h1", key: "s9uhes" }],
  ["path", { d: "M7 18h1", key: "1neino" }]
]);
const Nh = n("fan", [
  [
    "path",
    {
      d: "M10.827 16.379a6.082 6.082 0 0 1-8.618-7.002l5.412 1.45a6.082 6.082 0 0 1 7.002-8.618l-1.45 5.412a6.082 6.082 0 0 1 8.618 7.002l-5.412-1.45a6.082 6.082 0 0 1-7.002 8.618l1.45-5.412Z",
      key: "484a7f"
    }
  ],
  ["path", { d: "M12 12v.01", key: "u5ubse" }]
]);
const Wh = n("fast-forward", [
  ["polygon", { points: "13 19 22 12 13 5 13 19", key: "587y9g" }],
  ["polygon", { points: "2 19 11 12 2 5 2 19", key: "3pweh0" }]
]);
const Gh = n("feather", [
  [
    "path",
    {
      d: "M12.67 19a2 2 0 0 0 1.416-.588l6.154-6.172a6 6 0 0 0-8.49-8.49L5.586 9.914A2 2 0 0 0 5 11.328V18a1 1 0 0 0 1 1z",
      key: "18jl4k"
    }
  ],
  ["path", { d: "M16 8 2 22", key: "vp34q" }],
  ["path", { d: "M17.5 15H9", key: "1oz8nu" }]
]);
const Zh = n("fence", [
  ["path", { d: "M4 3 2 5v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "1n2rgs" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M6 18h4", key: "12yh4b" }],
  ["path", { d: "m12 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "3ha7mj" }],
  ["path", { d: "M14 8h4", key: "1r8wg2" }],
  ["path", { d: "M14 18h4", key: "1t3kbu" }],
  ["path", { d: "m20 3-2 2v15c0 .6.4 1 1 1h2c.6 0 1-.4 1-1V5Z", key: "dfd4e2" }]
]);
const Yh = n("ferris-wheel", [
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m6.8 15-3.5 2", key: "hjy98k" }],
  ["path", { d: "m20.7 7-3.5 2", key: "f08gto" }],
  ["path", { d: "M6.8 9 3.3 7", key: "1aevh4" }],
  ["path", { d: "m20.7 17-3.5-2", key: "1liqo3" }],
  ["path", { d: "m9 22 3-8 3 8", key: "wees03" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M18 18.7a9 9 0 1 0-12 0", key: "dhzg4g" }]
]);
const Kh = n("figma", [
  ["path", { d: "M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z", key: "1340ok" }],
  ["path", { d: "M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z", key: "1hz3m3" }],
  ["path", { d: "M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z", key: "1oz8n2" }],
  ["path", { d: "M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z", key: "1ff65i" }],
  ["path", { d: "M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z", key: "pdip6e" }]
]);
const Xh = n("file-archive", [
  ["path", { d: "M10 12v-1", key: "v7bkov" }],
  ["path", { d: "M10 18v-2", key: "1cjy8d" }],
  ["path", { d: "M10 7V6", key: "dljcrl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M15.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 .274 1.01", key: "gkbcor" }
  ],
  ["circle", { cx: "10", cy: "20", r: "2", key: "1xzdoj" }]
]);
const Qh = n("file-audio-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "3", cy: "17", r: "1", key: "vo6nti" }],
  ["path", { d: "M2 17v-3a4 4 0 0 1 8 0v3", key: "1ggdre" }],
  ["circle", { cx: "9", cy: "17", r: "1", key: "bc1fq4" }]
]);
const Jh = n("file-audio", [
  ["path", { d: "M17.5 22h.5a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "rslqgf" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M2 19a2 2 0 1 1 4 0v1a2 2 0 1 1-4 0v-4a6 6 0 0 1 12 0v4a2 2 0 1 1-4 0v-1a2 2 0 1 1 4 0",
      key: "9f7x3i"
    }
  ]
]);
const C1 = n("file-axis-3d", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 18 4-4", key: "12zab0" }],
  ["path", { d: "M8 10v8h8", key: "tlaukw" }]
]);
const ep = n("file-badge-2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14 12.5 1 5.5-3-1-3 1 1-5.5", key: "14xlky" }]
]);
const tp = n("file-badge", [
  ["path", { d: "M12 22h6a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "12ixgl" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M5 17a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "u0c8gj" }],
  ["path", { d: "M7 16.5 8 22l-3-1-3 1 1-5.5", key: "5gm2nr" }]
]);
const ap = n("file-box", [
  ["path", { d: "M14.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "16lz6z" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M3 13.1a2 2 0 0 0-1 1.76v3.24a2 2 0 0 0 .97 1.78L6 21.7a2 2 0 0 0 2.03.01L11 19.9a2 2 0 0 0 1-1.76V14.9a2 2 0 0 0-.97-1.78L8 11.3a2 2 0 0 0-2.03-.01Z",
      key: "99pj1s"
    }
  ],
  ["path", { d: "M7 17v5", key: "1yj1jh" }],
  ["path", { d: "M11.7 14.2 7 17l-4.7-2.8", key: "1yk8tc" }]
]);
const A1 = n("file-chart-column-increasing", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-2", key: "qcmpov" }],
  ["path", { d: "M12 18v-4", key: "q1q25u" }],
  ["path", { d: "M16 18v-6", key: "15y0np" }]
]);
const q1 = n("file-chart-column", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 18v-1", key: "zg0ygc" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "M16 18v-3", key: "j5jt4h" }]
]);
const z1 = n("file-chart-line", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m16 13-3.5 3.5-2-2L8 17", key: "zz7yod" }]
]);
const P1 = n("file-chart-pie", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3.5", key: "13ddob" }],
  ["path", { d: "M4.017 11.512a6 6 0 1 0 8.466 8.475", key: "s6vs5t" }],
  [
    "path",
    {
      d: "M9 16a1 1 0 0 1-1-1v-4c0-.552.45-1.008.995-.917a6 6 0 0 1 4.922 4.922c.091.544-.365.995-.917.995z",
      key: "1dl6s6"
    }
  ]
]);
const np = n("file-check-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3 15 2 2 4-4", key: "1lhrkk" }]
]);
const op = n("file-check", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m9 15 2 2 4-4", key: "1grp1n" }]
]);
const rp = n("file-clock", [
  ["path", { d: "M16 22h2a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "37hlfg" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "8", cy: "16", r: "6", key: "10v15b" }],
  ["path", { d: "M9.5 17.5 8 16.25V14", key: "1o80t2" }]
]);
const lp = n("file-code-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m5 12-3 3 3 3", key: "oke12k" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
const ip = n("file-code", [
  ["path", { d: "M10 12.5 8 15l2 2.5", key: "1tg20x" }],
  ["path", { d: "m14 12.5 2 2.5-2 2.5", key: "yinavb" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }]
]);
const _1 = n("file-cog", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m3.2 12.9-.9-.4", key: "1i3dj5" }],
  ["path", { d: "m3.2 15.1-.9.4", key: "1fvgj0" }],
  [
    "path",
    {
      d: "M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5",
      key: "1yo3oz"
    }
  ],
  ["path", { d: "m4.9 11.2-.4-.9", key: "otmhb9" }],
  ["path", { d: "m4.9 16.8-.4.9", key: "1b8z07" }],
  ["path", { d: "m7.5 10.3-.4.9", key: "11k65u" }],
  ["path", { d: "m7.5 17.7-.4-.9", key: "431x55" }],
  ["path", { d: "m9.7 12.5-.9.4", key: "87sjan" }],
  ["path", { d: "m9.7 15.5-.9-.4", key: "khqm91" }],
  ["circle", { cx: "6", cy: "14", r: "3", key: "a1xfv6" }]
]);
const cp = n("file-diff", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
const dp = n("file-digit", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "4", height: "6", x: "2", y: "12", rx: "2", key: "jm304g" }],
  ["path", { d: "M10 12h2v6", key: "12zw74" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
const sp = n("file-down", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }],
  ["path", { d: "m9 15 3 3 3-3", key: "1npd3o" }]
]);
const up = n("file-heart", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2", key: "17k7jt" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M10.29 10.7a2.43 2.43 0 0 0-2.66-.52c-.29.12-.56.3-.78.53l-.35.34-.35-.34a2.43 2.43 0 0 0-2.65-.53c-.3.12-.56.3-.79.53-.95.94-1 2.53.2 3.74L6.5 18l3.6-3.55c1.2-1.21 1.14-2.8.19-3.74Z",
      key: "1c1fso"
    }
  ]
]);
const hp = n("file-image", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "10", cy: "12", r: "2", key: "737tya" }],
  ["path", { d: "m20 17-1.296-1.296a2.41 2.41 0 0 0-3.408 0L9 22", key: "wt3hpn" }]
]);
const pp = n("file-input", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 15h10", key: "jfw4w8" }],
  ["path", { d: "m9 18 3-3-3-3", key: "112psh" }]
]);
const yp = n("file-json-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "fq0c9t" }
  ],
  [
    "path",
    { d: "M8 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "4gibmv" }
  ]
]);
const kp = n("file-json", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M10 12a1 1 0 0 0-1 1v1a1 1 0 0 1-1 1 1 1 0 0 1 1 1v1a1 1 0 0 0 1 1", key: "1oajmo" }
  ],
  [
    "path",
    { d: "M14 18a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1 1 1 0 0 1-1-1v-1a1 1 0 0 0-1-1", key: "mpwhp6" }
  ]
]);
const mp = n("file-key-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v6", key: "rc0qvx" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "m10 10-4.5 4.5", key: "7fwrp6" }],
  ["path", { d: "m9 11 1 1", key: "wa6s5q" }]
]);
const fp = n("file-key", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["circle", { cx: "10", cy: "16", r: "2", key: "4ckbqe" }],
  ["path", { d: "m16 10-4.5 4.5", key: "7p3ebg" }],
  ["path", { d: "m15 11 1 1", key: "1bsyx3" }]
]);
const vp = n("file-lock-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v1", key: "jmtmu2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "5", x: "2", y: "13", rx: "1", key: "10y5wo" }],
  ["path", { d: "M8 13v-2a2 2 0 1 0-4 0v2", key: "1pdxzg" }]
]);
const gp = n("file-lock", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["rect", { width: "8", height: "6", x: "8", y: "12", rx: "1", key: "3yr8at" }],
  ["path", { d: "M10 12v-2a2 2 0 1 1 4 0v2", key: "j4i8d" }]
]);
const Mp = n("file-minus-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }]
]);
const bp = n("file-minus", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
const xp = n("file-music", [
  ["path", { d: "M10.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v8.4", key: "1d3kfm" }],
  ["path", { d: "M8 18v-7.7L16 9v7", key: "1oie6o" }],
  ["circle", { cx: "14", cy: "16", r: "2", key: "1bzzi3" }],
  ["circle", { cx: "6", cy: "18", r: "2", key: "1fncim" }]
]);
const wp = n("file-output", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M4 7V4a2 2 0 0 1 2-2 2 2 0 0 0-2 2", key: "1vk7w2" }],
  ["path", { d: "M4.063 20.999a2 2 0 0 0 2 1L18 22a2 2 0 0 0 2-2V7l-5-5H6", key: "1jink5" }],
  ["path", { d: "m5 11-3 3", key: "1dgrs4" }],
  ["path", { d: "m5 17-3-3h10", key: "1mvvaf" }]
]);
const j1 = n("file-pen-line", [
  [
    "path",
    {
      d: "m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2",
      key: "142zxg"
    }
  ],
  [
    "path",
    {
      d: "M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "2t3380"
    }
  ],
  ["path", { d: "M8 18h1", key: "13wk12" }]
]);
const H1 = n("file-pen", [
  ["path", { d: "M12.5 22H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v9.5", key: "1couwa" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M13.378 15.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1y4qbx"
    }
  ]
]);
const Lp = n("file-plus-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M3 15h6", key: "4e2qda" }],
  ["path", { d: "M6 12v6", key: "1u72j0" }]
]);
const Sp = n("file-plus", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }],
  ["path", { d: "M12 18v-6", key: "17g6i2" }]
]);
const Ip = n("file-question", [
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }]
]);
const Cp = n("file-scan", [
  ["path", { d: "M20 10V7l-5-5H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h4", key: "1rdf37" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M16 14a2 2 0 0 0-2 2", key: "ceaadl" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2", key: "1ny6zw" }],
  ["path", { d: "M20 22a2 2 0 0 0 2-2", key: "1l9q4k" }],
  ["path", { d: "M16 22a2 2 0 0 1-2-2", key: "1wqh5n" }]
]);
const Ap = n("file-search-2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["circle", { cx: "11.5", cy: "14.5", r: "2.5", key: "1bq0ko" }],
  ["path", { d: "M13.3 16.3 15 18", key: "2quom7" }]
]);
const qp = n("file-search", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4.268 21a2 2 0 0 0 1.727 1H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v3", key: "ms7g94" }
  ],
  ["path", { d: "m9 18-1.5-1.5", key: "1j6qii" }],
  ["circle", { cx: "5", cy: "14", r: "3", key: "ufru5t" }]
]);
const zp = n("file-sliders", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M10 11v2", key: "1s651w" }],
  ["path", { d: "M8 17h8", key: "wh5c61" }],
  ["path", { d: "M14 16v2", key: "12fp5e" }]
]);
const Pp = n("file-spreadsheet", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 13h2", key: "yr2amv" }],
  ["path", { d: "M14 13h2", key: "un5t4a" }],
  ["path", { d: "M8 17h2", key: "2yhykz" }],
  ["path", { d: "M14 17h2", key: "10kma7" }]
]);
const _p = n("file-stack", [
  ["path", { d: "M21 7h-3a2 2 0 0 1-2-2V2", key: "9rb54x" }],
  [
    "path",
    {
      d: "M21 6v6.5c0 .8-.7 1.5-1.5 1.5h-7c-.8 0-1.5-.7-1.5-1.5v-9c0-.8.7-1.5 1.5-1.5H17Z",
      key: "1059l0"
    }
  ],
  ["path", { d: "M7 8v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H15", key: "16874u" }],
  ["path", { d: "M3 12v8.8c0 .3.2.6.4.8.2.2.5.4.8.4H11", key: "k2ox98" }]
]);
const jp = n("file-symlink", [
  ["path", { d: "m10 18 3-3-3-3", key: "18f6ys" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    {
      d: "M4 11V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "50q2rw"
    }
  ]
]);
const Hp = n("file-terminal", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 16 2-2-2-2", key: "10vzyd" }],
  ["path", { d: "M12 18h4", key: "1wd2n7" }]
]);
const Vp = n("file-text", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
]);
const Bp = n("file-type-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M2 13v-1h6v1", key: "1dh9dg" }],
  ["path", { d: "M5 12v6", key: "150t9c" }],
  ["path", { d: "M4 18h2", key: "1xrofg" }]
]);
const Dp = n("file-type", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M9 13v-1h6v1", key: "1bb014" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M11 18h2", key: "12mj7e" }]
]);
const Tp = n("file-up", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "m15 15-3-3-3 3", key: "15xj92" }]
]);
const $p = n("file-user", [
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M15 18a3 3 0 1 0-6 0", key: "16awa0" }],
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z", key: "1mlx9k" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
]);
const Op = n("file-video-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["rect", { width: "8", height: "6", x: "2", y: "12", rx: "1", key: "1a6c1e" }],
  ["path", { d: "m10 15.5 4 2.5v-6l-4 2.5", key: "t7cp39" }]
]);
const Rp = n("file-video", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m10 11 5 3-5 3v-6Z", key: "7ntvm4" }]
]);
const Fp = n("file-volume-2", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M11.5 13.5a2.5 2.5 0 0 1 0 3", key: "1fccat" }],
  ["path", { d: "M15 12a5 5 0 0 1 0 6", key: "ps46cm" }]
]);
const Ep = n("file-volume", [
  ["path", { d: "M11 11a5 5 0 0 1 0 6", key: "193qb2" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  [
    "path",
    { d: "M4 6.765V4a2 2 0 0 1 2-2h9l5 5v13a2 2 0 0 1-2 2H6a2 2 0 0 1-.93-.23", key: "ifyjnl" }
  ],
  [
    "path",
    {
      d: "M7 10.51a.5.5 0 0 0-.826-.38l-1.893 1.628A1 1 0 0 1 3.63 12H2.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h1.129a1 1 0 0 1 .652.242l1.893 1.63a.5.5 0 0 0 .826-.38z",
      key: "mk8rxu"
    }
  ]
]);
const Up = n("file-warning", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const Np = n("file-x-2", [
  ["path", { d: "M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4", key: "1pf5j1" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m8 12.5-5 5", key: "b853mi" }],
  ["path", { d: "m3 12.5 5 5", key: "1qls4r" }]
]);
const Wp = n("file-x", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "m14.5 12.5-5 5", key: "b62r18" }],
  ["path", { d: "m9.5 12.5 5 5", key: "1rk7el" }]
]);
const Gp = n("file", [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }]
]);
const Zp = n("files", [
  ["path", { d: "M20 7h-3a2 2 0 0 1-2-2V2", key: "x099mo" }],
  ["path", { d: "M9 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h7l4 4v10a2 2 0 0 1-2 2Z", key: "18t6ie" }],
  ["path", { d: "M3 7.6v12.8A1.6 1.6 0 0 0 4.6 22h9.8", key: "1nja0z" }]
]);
const Yp = n("film", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  ["path", { d: "M3 7.5h4", key: "zfgn84" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["path", { d: "M3 16.5h4", key: "1230mu" }],
  ["path", { d: "M17 3v18", key: "in4fa5" }],
  ["path", { d: "M17 7.5h4", key: "myr1c1" }],
  ["path", { d: "M17 16.5h4", key: "go4c1d" }]
]);
const Kp = n("fingerprint", [
  ["path", { d: "M12 10a2 2 0 0 0-2 2c0 1.02-.1 2.51-.26 4", key: "1nerag" }],
  ["path", { d: "M14 13.12c0 2.38 0 6.38-1 8.88", key: "o46ks0" }],
  ["path", { d: "M17.29 21.02c.12-.6.43-2.3.5-3.02", key: "ptglia" }],
  ["path", { d: "M2 12a10 10 0 0 1 18-6", key: "ydlgp0" }],
  ["path", { d: "M2 16h.01", key: "1gqxmh" }],
  ["path", { d: "M21.8 16c.2-2 .131-5.354 0-6", key: "drycrb" }],
  ["path", { d: "M5 19.5C5.5 18 6 15 6 12a6 6 0 0 1 .34-2", key: "1tidbn" }],
  ["path", { d: "M8.65 22c.21-.66.45-1.32.57-2", key: "13wd9y" }],
  ["path", { d: "M9 6.8a6 6 0 0 1 9 5.2v2", key: "1fr1j5" }]
]);
const Xp = n("fire-extinguisher", [
  ["path", { d: "M15 6.5V3a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v3.5", key: "sqyvz" }],
  ["path", { d: "M9 18h8", key: "i7pszb" }],
  ["path", { d: "M18 3h-3", key: "7idoqj" }],
  ["path", { d: "M11 3a6 6 0 0 0-6 6v11", key: "1v5je3" }],
  ["path", { d: "M5 13h4", key: "svpcxo" }],
  ["path", { d: "M17 10a4 4 0 0 0-8 0v10a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2Z", key: "vsjego" }]
]);
const Qp = n("fish-off", [
  [
    "path",
    {
      d: "M18 12.47v.03m0-.5v.47m-.475 5.056A6.744 6.744 0 0 1 15 18c-3.56 0-7.56-2.53-8.5-6 .348-1.28 1.114-2.433 2.121-3.38m3.444-2.088A8.802 8.802 0 0 1 15 6c3.56 0 6.06 2.54 7 6-.309 1.14-.786 2.177-1.413 3.058",
      key: "1j1hse"
    }
  ],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33m7.48-4.372A9.77 9.77 0 0 1 16 6.07m0 11.86a9.77 9.77 0 0 1-1.728-3.618",
      key: "1q46z8"
    }
  ],
  [
    "path",
    {
      d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98M8.53 3h5.27a2 2 0 0 1 1.98 1.67l.23 1.4M2 2l20 20",
      key: "1407gh"
    }
  ]
]);
const Jp = n("fish-symbol", [
  ["path", { d: "M2 16s9-15 20-4C11 23 2 8 2 8", key: "h4oh4o" }]
]);
const ey = n("fish", [
  [
    "path",
    {
      d: "M6.5 12c.94-3.46 4.94-6 8.5-6 3.56 0 6.06 2.54 7 6-.94 3.47-3.44 6-7 6s-7.56-2.53-8.5-6Z",
      key: "15baut"
    }
  ],
  ["path", { d: "M18 12v.5", key: "18hhni" }],
  ["path", { d: "M16 17.93a9.77 9.77 0 0 1 0-11.86", key: "16dt7o" }],
  [
    "path",
    {
      d: "M7 10.67C7 8 5.58 5.97 2.73 5.5c-1 1.5-1 5 .23 6.5-1.24 1.5-1.24 5-.23 6.5C5.58 18.03 7 16 7 13.33",
      key: "l9di03"
    }
  ],
  [
    "path",
    { d: "M10.46 7.26C10.2 5.88 9.17 4.24 8 3h5.8a2 2 0 0 1 1.98 1.67l.23 1.4", key: "1kjonw" }
  ],
  [
    "path",
    { d: "m16.01 17.93-.23 1.4A2 2 0 0 1 13.8 21H9.5a5.96 5.96 0 0 0 1.49-3.98", key: "1zlm23" }
  ]
]);
const ty = n("flag-triangle-left", [
  ["path", { d: "M17 22V2L7 7l10 5", key: "1rmf0r" }]
]);
const ay = n("flag-off", [
  ["path", { d: "M8 2c3 0 5 2 8 2s4-1 4-1v11", key: "9rwyz9" }],
  ["path", { d: "M4 22V4", key: "1plyxx" }],
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2", key: "1myooe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const ny = n("flag-triangle-right", [
  ["path", { d: "M7 22V2l10 5-10 5", key: "17n18y" }]
]);
const oy = n("flag", [
  ["path", { d: "M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z", key: "i9b6wo" }],
  ["line", { x1: "4", x2: "4", y1: "22", y2: "15", key: "1cm3nv" }]
]);
const ry = n("flame-kindling", [
  [
    "path",
    {
      d: "M12 2c1 3 2.5 3.5 3.5 4.5A5 5 0 0 1 17 10a5 5 0 1 1-10 0c0-.3 0-.6.1-.9a2 2 0 1 0 3.3-2C8 4.5 11 2 12 2Z",
      key: "1ir223"
    }
  ],
  ["path", { d: "m5 22 14-4", key: "1brv4h" }],
  ["path", { d: "m5 18 14 4", key: "lgyyje" }]
]);
const ly = n("flame", [
  [
    "path",
    {
      d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
      key: "96xj49"
    }
  ]
]);
const iy = n("flashlight-off", [
  ["path", { d: "M16 16v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4", key: "1r120k" }],
  ["path", { d: "M7 2h11v4c0 2-2 2-2 4v1", key: "dz1920" }],
  ["line", { x1: "11", x2: "18", y1: "6", y2: "6", key: "bi1vpe" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const cy = n("flashlight", [
  [
    "path",
    {
      d: "M18 6c0 2-2 2-2 4v10a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V10c0-2-2-2-2-4V2h12z",
      key: "1orkel"
    }
  ],
  ["line", { x1: "6", x2: "18", y1: "6", y2: "6", key: "1z11jq" }],
  ["line", { x1: "12", x2: "12", y1: "12", y2: "12", key: "1f4yc1" }]
]);
const dy = n("flask-conical-off", [
  ["path", { d: "M10 2v2.343", key: "15t272" }],
  ["path", { d: "M14 2v6.343", key: "sxr80q" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20a2 2 0 0 1-2 2H6a2 2 0 0 1-1.755-2.96l5.227-9.563", key: "k0duyd" }],
  ["path", { d: "M6.453 15H15", key: "1f0z33" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
]);
const sy = n("flask-conical", [
  [
    "path",
    {
      d: "M14 2v6a2 2 0 0 0 .245.96l5.51 10.08A2 2 0 0 1 18 22H6a2 2 0 0 1-1.755-2.96l5.51-10.08A2 2 0 0 0 10 8V2",
      key: "18mbvz"
    }
  ],
  ["path", { d: "M6.453 15h11.094", key: "3shlmq" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
]);
const uy = n("flask-round", [
  ["path", { d: "M10 2v6.292a7 7 0 1 0 4 0V2", key: "1s42pc" }],
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }]
]);
const hy = n("flip-horizontal-2", [
  ["path", { d: "m3 7 5 5-5 5V7", key: "couhi7" }],
  ["path", { d: "m21 7-5 5 5 5V7", key: "6ouia7" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
const py = n("flip-horizontal", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h3", key: "1i73f7" }],
  ["path", { d: "M16 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-3", key: "saxlbk" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 2v2", key: "tus03m" }]
]);
const yy = n("flip-vertical-2", [
  ["path", { d: "m17 3-5 5-5-5h10", key: "1ftt6x" }],
  ["path", { d: "m17 21-5-5-5 5h10", key: "1m0wmu" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
const ky = n("flip-vertical", [
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v3", key: "14bfxa" }],
  ["path", { d: "M21 16v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3", key: "14rx03" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
const my = n("flower-2", [
  [
    "path",
    {
      d: "M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1",
      key: "3pnvol"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["path", { d: "M12 10v12", key: "6ubwww" }],
  ["path", { d: "M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z", key: "9hd38g" }],
  ["path", { d: "M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z", key: "ufn41s" }]
]);
const fy = n("flower", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5",
      key: "14wa3c"
    }
  ],
  ["path", { d: "M12 7.5V9", key: "1oy5b0" }],
  ["path", { d: "M7.5 12H9", key: "eltsq1" }],
  ["path", { d: "M16.5 12H15", key: "vk5kw4" }],
  ["path", { d: "M12 16.5V15", key: "k7eayi" }],
  ["path", { d: "m8 8 1.88 1.88", key: "nxy4qf" }],
  ["path", { d: "M14.12 9.88 16 8", key: "1lst6k" }],
  ["path", { d: "m8 16 1.88-1.88", key: "h2eex1" }],
  ["path", { d: "M14.12 14.12 16 16", key: "uqkrx3" }]
]);
const vy = n("focus", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
const gy = n("fold-horizontal", [
  ["path", { d: "M2 12h6", key: "1wqiqv" }],
  ["path", { d: "M22 12h-6", key: "1eg9hc" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 9-3 3 3 3", key: "12ol22" }],
  ["path", { d: "m5 15 3-3-3-3", key: "1kdhjc" }]
]);
const My = n("fold-vertical", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3-3-3 3", key: "e37ymu" }],
  ["path", { d: "m15 5-3 3-3-3", key: "19d6lf" }]
]);
const by = n("folder-archive", [
  ["circle", { cx: "15", cy: "19", r: "2", key: "u2pros" }],
  [
    "path",
    {
      d: "M20.9 19.8A2 2 0 0 0 22 18V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2h5.1",
      key: "1jj40k"
    }
  ],
  ["path", { d: "M15 11v-1", key: "cntcp" }],
  ["path", { d: "M15 17v-2", key: "1279jj" }]
]);
const xy = n("folder-check", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9 13 2 2 4-4", key: "6343dt" }]
]);
const wy = n("folder-clock", [
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  [
    "path",
    {
      d: "M7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2",
      key: "1urifu"
    }
  ],
  ["path", { d: "M16 14v2l1 1", key: "xth2jh" }]
]);
const Ly = n("folder-closed", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M2 10h20", key: "1ir3d8" }]
]);
const Sy = n("folder-code", [
  ["path", { d: "M10 10.5 8 13l2 2.5", key: "m4t9c1" }],
  ["path", { d: "m14 10.5 2 2.5-2 2.5", key: "14w2eb" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2z",
      key: "1u1bxd"
    }
  ]
]);
const V1 = n("folder-cog", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  [
    "path",
    {
      d: "M10.3 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v3.3",
      key: "1k8050"
    }
  ],
  ["path", { d: "m21.7 19.4-.9-.3", key: "1qgwi9" }],
  ["path", { d: "m15.2 16.9-.9-.3", key: "1t7mvx" }],
  ["path", { d: "m16.6 21.7.3-.9", key: "1j67ps" }],
  ["path", { d: "m19.1 15.2.3-.9", key: "18r7jp" }],
  ["path", { d: "m19.6 21.7-.4-1", key: "z2vh2" }],
  ["path", { d: "m16.8 15.3-.4-1", key: "1ei7r6" }],
  ["path", { d: "m14.3 19.6 1-.4", key: "11sv9r" }],
  ["path", { d: "m20.7 16.8 1-.4", key: "19m87a" }]
]);
const Iy = n("folder-dot", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "1", key: "49l61u" }]
]);
const Cy = n("folder-down", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m15 13-3 3-3-3", key: "6j2sf0" }]
]);
const Ay = n("folder-git-2", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v5",
      key: "1w6njk"
    }
  ],
  ["circle", { cx: "13", cy: "12", r: "2", key: "1j92g6" }],
  ["path", { d: "M18 19c-2.8 0-5-2.2-5-5v8", key: "pkpw2h" }],
  ["circle", { cx: "20", cy: "19", r: "2", key: "1obnsp" }]
]);
const qy = n("folder-git", [
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M14 13h3", key: "1dgedf" }],
  ["path", { d: "M7 13h3", key: "1pygq7" }]
]);
const zy = n("folder-heart", [
  [
    "path",
    {
      d: "M11 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v1.5",
      key: "6hud8k"
    }
  ],
  [
    "path",
    {
      d: "M13.9 17.45c-1.2-1.2-1.14-2.8-.2-3.73a2.43 2.43 0 0 1 3.44 0l.36.34.34-.34a2.43 2.43 0 0 1 3.45-.01c.95.95 1 2.53-.2 3.74L17.5 21Z",
      key: "wpff58"
    }
  ]
]);
const Py = n("folder-input", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-1",
      key: "fm4g5t"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m9 16 3-3-3-3", key: "6m91ic" }]
]);
const _y = n("folder-kanban", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["path", { d: "M8 10v4", key: "tgpxqk" }],
  ["path", { d: "M12 10v2", key: "hh53o1" }],
  ["path", { d: "M16 10v6", key: "1d6xys" }]
]);
const jy = n("folder-key", [
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2",
      key: "3hgo9p"
    }
  ],
  ["path", { d: "m22 14-4.5 4.5", key: "1ef6z8" }],
  ["path", { d: "m21 15 1 1", key: "1ejcpy" }]
]);
const Hy = n("folder-minus", [
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
const Vy = n("folder-lock", [
  ["rect", { width: "8", height: "5", x: "14", y: "17", rx: "1", key: "19aais" }],
  [
    "path",
    {
      d: "M10 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v2.5",
      key: "1w6v7t"
    }
  ],
  ["path", { d: "M20 17v-2a2 2 0 1 0-4 0v2", key: "pwaxnr" }]
]);
const By = n("folder-open-dot", [
  [
    "path",
    {
      d: "m6 14 1.45-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.55 6a2 2 0 0 1-1.94 1.5H4a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2h3.93a2 2 0 0 1 1.66.9l.82 1.2a2 2 0 0 0 1.66.9H18a2 2 0 0 1 2 2v2",
      key: "1nmvlm"
    }
  ],
  ["circle", { cx: "14", cy: "15", r: "1", key: "1gm4qj" }]
]);
const Dy = n("folder-open", [
  [
    "path",
    {
      d: "m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2",
      key: "usdka0"
    }
  ]
]);
const B1 = n("folder-pen", [
  [
    "path",
    {
      d: "M2 11.5V5a2 2 0 0 1 2-2h3.9c.7 0 1.3.3 1.7.9l.8 1.2c.4.6 1 .9 1.7.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-9.5",
      key: "a8xqs0"
    }
  ],
  [
    "path",
    {
      d: "M11.378 13.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1saktj"
    }
  ]
]);
const Ty = n("folder-output", [
  [
    "path",
    {
      d: "M2 7.5V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-1.5",
      key: "1yk7aj"
    }
  ],
  ["path", { d: "M2 13h10", key: "pgb2dq" }],
  ["path", { d: "m5 10-3 3 3 3", key: "1r8ie0" }]
]);
const $y = n("folder-plus", [
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "M9 13h6", key: "1uhe8q" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
const Oy = n("folder-root", [
  [
    "path",
    {
      d: "M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z",
      key: "1fr9dc"
    }
  ],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }],
  ["path", { d: "M12 15v5", key: "11xva1" }]
]);
const Ry = n("folder-search-2", [
  ["circle", { cx: "11.5", cy: "12.5", r: "2.5", key: "1ea5ju" }],
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M13.3 14.3 15 16", key: "1y4v1n" }]
]);
const Fy = n("folder-search", [
  [
    "path",
    {
      d: "M10.7 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v4.1",
      key: "1bw5m7"
    }
  ],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }]
]);
const Ey = n("folder-symlink", [
  [
    "path",
    {
      d: "M2 9V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h7",
      key: "x1c07l"
    }
  ],
  ["path", { d: "m8 16 3-3-3-3", key: "rlqrt1" }]
]);
const Uy = n("folder-sync", [
  [
    "path",
    {
      d: "M9 20H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H20a2 2 0 0 1 2 2v.5",
      key: "1dkoa9"
    }
  ],
  ["path", { d: "M12 10v4h4", key: "1czhmt" }],
  ["path", { d: "m12 14 1.535-1.605a5 5 0 0 1 8 1.5", key: "lvuxfi" }],
  ["path", { d: "M22 22v-4h-4", key: "1ewp4q" }],
  ["path", { d: "m22 18-1.535 1.605a5 5 0 0 1-8-1.5", key: "14ync0" }]
]);
const Ny = n("folder-tree", [
  [
    "path",
    {
      d: "M20 10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2.5a1 1 0 0 1-.8-.4l-.9-1.2A1 1 0 0 0 15 3h-2a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "hod4my"
    }
  ],
  [
    "path",
    {
      d: "M20 21a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1h-2.9a1 1 0 0 1-.88-.55l-.42-.85a1 1 0 0 0-.92-.6H13a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1Z",
      key: "w4yl2u"
    }
  ],
  ["path", { d: "M3 5a2 2 0 0 0 2 2h3", key: "f2jnh7" }],
  ["path", { d: "M3 3v13a2 2 0 0 0 2 2h3", key: "k8epm1" }]
]);
const Wy = n("folder-up", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "M12 10v6", key: "1bos4e" }],
  ["path", { d: "m9 13 3-3 3 3", key: "1pxg3c" }]
]);
const Gy = n("folder-x", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ],
  ["path", { d: "m9.5 10.5 5 5", key: "ra9qjz" }],
  ["path", { d: "m14.5 10.5-5 5", key: "l2rkpq" }]
]);
const Zy = n("folder", [
  [
    "path",
    {
      d: "M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z",
      key: "1kt360"
    }
  ]
]);
const Yy = n("folders", [
  [
    "path",
    {
      d: "M20 17a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3.9a2 2 0 0 1-1.69-.9l-.81-1.2a2 2 0 0 0-1.67-.9H8a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2Z",
      key: "4u7rpt"
    }
  ],
  ["path", { d: "M2 8v11a2 2 0 0 0 2 2h14", key: "1eicx1" }]
]);
const Ky = n("footprints", [
  [
    "path",
    {
      d: "M4 16v-2.38C4 11.5 2.97 10.5 3 8c.03-2.72 1.49-6 4.5-6C9.37 2 10 3.8 10 5.5c0 3.11-2 5.66-2 8.68V16a2 2 0 1 1-4 0Z",
      key: "1dudjm"
    }
  ],
  [
    "path",
    {
      d: "M20 20v-2.38c0-2.12 1.03-3.12 1-5.62-.03-2.72-1.49-6-4.5-6C14.63 6 14 7.8 14 9.5c0 3.11 2 5.66 2 8.68V20a2 2 0 1 0 4 0Z",
      key: "l2t8xc"
    }
  ],
  ["path", { d: "M16 17h4", key: "1dejxt" }],
  ["path", { d: "M4 13h4", key: "1bwh8b" }]
]);
const Xy = n("forklift", [
  ["path", { d: "M12 12H5a2 2 0 0 0-2 2v5", key: "7zsz91" }],
  ["circle", { cx: "13", cy: "19", r: "2", key: "wjnkru" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M8 19h3m5-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5", key: "13bk1p" }]
]);
const Qy = n("forward", [
  ["polyline", { points: "15 17 20 12 15 7", key: "1w3sku" }],
  ["path", { d: "M4 18v-2a4 4 0 0 1 4-4h12", key: "jmiej9" }]
]);
const Jy = n("frame", [
  ["line", { x1: "22", x2: "2", y1: "6", y2: "6", key: "15w7dq" }],
  ["line", { x1: "22", x2: "2", y1: "18", y2: "18", key: "1ip48p" }],
  ["line", { x1: "6", x2: "6", y1: "2", y2: "22", key: "a2lnyx" }],
  ["line", { x1: "18", x2: "18", y1: "2", y2: "22", key: "8vb6jd" }]
]);
const ek = n("framer", [
  ["path", { d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7", key: "1a2nng" }]
]);
const tk = n("frown", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M16 16s-1.5-2-4-2-4 2-4 2", key: "epbg0q" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
const ak = n("fuel", [
  ["line", { x1: "3", x2: "15", y1: "22", y2: "22", key: "xegly4" }],
  ["line", { x1: "4", x2: "14", y1: "9", y2: "9", key: "xcnuvu" }],
  ["path", { d: "M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18", key: "16j0yd" }],
  [
    "path",
    {
      d: "M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5",
      key: "7cu91f"
    }
  ]
]);
const nk = n("fullscreen", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { width: "10", height: "8", x: "7", y: "8", rx: "1", key: "vys8me" }]
]);
const ok = n("funnel-plus", [
  [
    "path",
    {
      d: "M13.354 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l1.218-1.348",
      key: "8mvsmf"
    }
  ],
  ["path", { d: "M16 6h6", key: "1dogtp" }],
  ["path", { d: "M19 3v6", key: "1ytpjt" }]
]);
const D1 = n("funnel-x", [
  [
    "path",
    {
      d: "M12.531 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l.427-.473",
      key: "ol2ft2"
    }
  ],
  ["path", { d: "m16.5 3.5 5 5", key: "15e6fa" }],
  ["path", { d: "m21.5 3.5-5 5", key: "m0lwru" }]
]);
const T1 = n("funnel", [
  [
    "path",
    {
      d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
      key: "sc7q7i"
    }
  ]
]);
const rk = n("gallery-horizontal-end", [
  ["path", { d: "M2 7v10", key: "a2pl2d" }],
  ["path", { d: "M6 5v14", key: "1kq3d7" }],
  ["rect", { width: "12", height: "18", x: "10", y: "3", rx: "2", key: "13i7bc" }]
]);
const lk = n("gallery-horizontal", [
  ["path", { d: "M2 3v18", key: "pzttux" }],
  ["rect", { width: "12", height: "18", x: "6", y: "3", rx: "2", key: "btr8bg" }],
  ["path", { d: "M22 3v18", key: "6jf3v" }]
]);
const ik = n("gallery-thumbnails", [
  ["rect", { width: "18", height: "14", x: "3", y: "3", rx: "2", key: "74y24f" }],
  ["path", { d: "M4 21h1", key: "16zlid" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M19 21h1", key: "edywat" }]
]);
const ck = n("gallery-vertical-end", [
  ["path", { d: "M7 2h10", key: "nczekb" }],
  ["path", { d: "M5 6h14", key: "u2x4p" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }]
]);
const dk = n("gallery-vertical", [
  ["path", { d: "M3 2h18", key: "15qxfx" }],
  ["rect", { width: "18", height: "12", x: "3", y: "6", rx: "2", key: "1439r6" }],
  ["path", { d: "M3 22h18", key: "8prr45" }]
]);
const sk = n("gamepad-2", [
  ["line", { x1: "6", x2: "10", y1: "11", y2: "11", key: "1gktln" }],
  ["line", { x1: "8", x2: "8", y1: "9", y2: "13", key: "qnk9ow" }],
  ["line", { x1: "15", x2: "15.01", y1: "12", y2: "12", key: "krot7o" }],
  ["line", { x1: "18", x2: "18.01", y1: "10", y2: "10", key: "1lcuu1" }],
  [
    "path",
    {
      d: "M17.32 5H6.68a4 4 0 0 0-3.978 3.59c-.006.052-.01.101-.017.152C2.604 9.416 2 14.456 2 16a3 3 0 0 0 3 3c1 0 1.5-.5 2-1l1.414-1.414A2 2 0 0 1 9.828 16h4.344a2 2 0 0 1 1.414.586L17 18c.5.5 1 1 2 1a3 3 0 0 0 3-3c0-1.545-.604-6.584-.685-7.258-.007-.05-.011-.1-.017-.151A4 4 0 0 0 17.32 5z",
      key: "mfqc10"
    }
  ]
]);
const uk = n("gamepad", [
  ["line", { x1: "6", x2: "10", y1: "12", y2: "12", key: "161bw2" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "15", x2: "15.01", y1: "13", y2: "13", key: "dqpgro" }],
  ["line", { x1: "18", x2: "18.01", y1: "11", y2: "11", key: "meh2c" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
const hk = n("gauge", [
  ["path", { d: "m12 14 4-4", key: "9kzdfg" }],
  ["path", { d: "M3.34 19a10 10 0 1 1 17.32 0", key: "19p75a" }]
]);
const pk = n("gavel", [
  ["path", { d: "m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8", key: "15492f" }],
  ["path", { d: "m16 16 6-6", key: "vzrcl6" }],
  ["path", { d: "m8 8 6-6", key: "18bi4p" }],
  ["path", { d: "m9 7 8 8", key: "5jnvq1" }],
  ["path", { d: "m21 11-8-8", key: "z4y7zo" }]
]);
const yk = n("gem", [
  ["path", { d: "M6 3h12l4 6-10 13L2 9Z", key: "1pcd5k" }],
  ["path", { d: "M11 3 8 9l4 13 4-13-3-6", key: "1fcu3u" }],
  ["path", { d: "M2 9h20", key: "16fsjt" }]
]);
const kk = n("ghost", [
  ["path", { d: "M9 10h.01", key: "qbtxuw" }],
  ["path", { d: "M15 10h.01", key: "1qmjsl" }],
  [
    "path",
    {
      d: "M12 2a8 8 0 0 0-8 8v12l3-3 2.5 2.5L12 19l2.5 2.5L17 19l3 3V10a8 8 0 0 0-8-8z",
      key: "uwwb07"
    }
  ]
]);
const mk = n("gift", [
  ["rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", key: "bkv52" }],
  ["path", { d: "M12 8v13", key: "1c76mn" }],
  ["path", { d: "M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7", key: "6wjy6b" }],
  [
    "path",
    {
      d: "M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5",
      key: "1ihvrl"
    }
  ]
]);
const fk = n("git-branch-plus", [
  ["path", { d: "M6 3v12", key: "qpgusn" }],
  ["path", { d: "M18 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "1d02ji" }],
  ["path", { d: "M6 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6z", key: "chk6ph" }],
  ["path", { d: "M15 6a9 9 0 0 0-9 9", key: "or332x" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
const vk = n("git-branch", [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
]);
const $1 = n("git-commit-horizontal", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["line", { x1: "3", x2: "9", y1: "12", y2: "12", key: "1dyftd" }],
  ["line", { x1: "15", x2: "21", y1: "12", y2: "12", key: "oup4p8" }]
]);
const gk = n("git-commit-vertical", [
  ["path", { d: "M12 3v6", key: "1holv5" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "M12 15v6", key: "a9ows0" }]
]);
const Mk = n("git-compare-arrows", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "M12 18H7a2 2 0 0 1-2-2V9", key: "16sdep" }],
  ["path", { d: "m9 15 3 3-3 3", key: "1m3kbl" }]
]);
const bk = n("git-compare", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["path", { d: "M11 18H8a2 2 0 0 1-2-2V9", key: "19pyzm" }]
]);
const xk = n("git-fork", [
  ["circle", { cx: "12", cy: "18", r: "3", key: "1mpf1b" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["path", { d: "M18 9v2c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V9", key: "1uq4wg" }],
  ["path", { d: "M12 12v3", key: "158kv8" }]
]);
const wk = n("git-graph", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v6", key: "158jrl" }],
  ["circle", { cx: "5", cy: "18", r: "3", key: "104gr9" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M16 15.7A9 9 0 0 0 19 9", key: "1e3vqb" }]
]);
const Lk = n("git-merge", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 21V9a9 9 0 0 0 9 9", key: "7kw0sc" }]
]);
const Sk = n("git-pull-request-arrow", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["circle", { cx: "19", cy: "18", r: "3", key: "1qljk2" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v7", key: "1yj91y" }]
]);
const Ik = n("git-pull-request-closed", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "m21 3-6 6", key: "16nqsk" }],
  ["path", { d: "m21 9-6-6", key: "9j17rh" }],
  ["path", { d: "M18 11.5V15", key: "65xf6f" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }]
]);
const Ck = n("git-pull-request-create-arrow", [
  ["circle", { cx: "5", cy: "6", r: "3", key: "1qnov2" }],
  ["path", { d: "M5 9v12", key: "ih889a" }],
  ["path", { d: "m15 9-3-3 3-3", key: "1lwv8l" }],
  ["path", { d: "M12 6h5a2 2 0 0 1 2 2v3", key: "1rbwk6" }],
  ["path", { d: "M19 15v6", key: "10aioa" }],
  ["path", { d: "M22 18h-6", key: "1d5gi5" }]
]);
const Ak = n("git-pull-request-create", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M6 9v12", key: "1sc30k" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v3", key: "1jb6z3" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }]
]);
const qk = n("git-pull-request-draft", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M18 6V5", key: "1oao2s" }],
  ["path", { d: "M18 11v-1", key: "11c8tz" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
const zk = n("git-pull-request", [
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M13 6h3a2 2 0 0 1 2 2v7", key: "1yeb86" }],
  ["line", { x1: "6", x2: "6", y1: "9", y2: "21", key: "rroup" }]
]);
const Pk = n("github", [
  [
    "path",
    {
      d: "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4",
      key: "tonef"
    }
  ],
  ["path", { d: "M9 18c-4.51 2-5-2-7-2", key: "9comsn" }]
]);
const _k = n("gitlab", [
  [
    "path",
    {
      d: "m22 13.29-3.33-10a.42.42 0 0 0-.14-.18.38.38 0 0 0-.22-.11.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18l-2.26 6.67H8.32L6.1 3.26a.42.42 0 0 0-.1-.18.38.38 0 0 0-.26-.08.39.39 0 0 0-.23.07.42.42 0 0 0-.14.18L2 13.29a.74.74 0 0 0 .27.83L12 21l9.69-6.88a.71.71 0 0 0 .31-.83Z",
      key: "148pdi"
    }
  ]
]);
const jk = n("glass-water", [
  [
    "path",
    {
      d: "M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z",
      key: "p55z4y"
    }
  ],
  ["path", { d: "M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0", key: "mjntcy" }]
]);
const Hk = n("glasses", [
  ["circle", { cx: "6", cy: "15", r: "4", key: "vux9w4" }],
  ["circle", { cx: "18", cy: "15", r: "4", key: "18o8ve" }],
  ["path", { d: "M14 15a2 2 0 0 0-2-2 2 2 0 0 0-2 2", key: "1ag4bs" }],
  ["path", { d: "M2.5 13 5 7c.7-1.3 1.4-2 3-2", key: "1hm1gs" }],
  ["path", { d: "M21.5 13 19 7c-.7-1.3-1.5-2-3-2", key: "1r31ai" }]
]);
const Vk = n("globe-lock", [
  [
    "path",
    {
      d: "M15.686 15A14.5 14.5 0 0 1 12 22a14.5 14.5 0 0 1 0-20 10 10 0 1 0 9.542 13",
      key: "qkt0x6"
    }
  ],
  ["path", { d: "M2 12h8.5", key: "ovaggd" }],
  ["path", { d: "M20 6V4a2 2 0 1 0-4 0v2", key: "1of5e8" }],
  ["rect", { width: "8", height: "5", x: "14", y: "6", rx: "1", key: "1fmf51" }]
]);
const Bk = n("globe", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
]);
const Dk = n("goal", [
  ["path", { d: "M12 13V2l8 4-8 4", key: "5wlwwj" }],
  ["path", { d: "M20.561 10.222a9 9 0 1 1-12.55-5.29", key: "1c0wjv" }],
  ["path", { d: "M8.002 9.997a5 5 0 1 0 8.9 2.02", key: "gb1g7m" }]
]);
const Tk = n("grab", [
  ["path", { d: "M18 11.5V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "edstyy" }],
  ["path", { d: "M14 10V8a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "19wdwo" }],
  ["path", { d: "M10 9.9V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "1lugqo" }],
  ["path", { d: "M6 14a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1hbeus" }],
  [
    "path",
    { d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-4a8 8 0 0 1-8-8 2 2 0 1 1 4 0", key: "1etffm" }
  ]
]);
const $k = n("graduation-cap", [
  [
    "path",
    {
      d: "M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z",
      key: "j76jl0"
    }
  ],
  ["path", { d: "M22 10v6", key: "1lu8f3" }],
  ["path", { d: "M6 12.5V16a6 3 0 0 0 12 0v-3.5", key: "1r8lef" }]
]);
const Ok = n("grape", [
  ["path", { d: "M22 5V2l-5.89 5.89", key: "1eenpo" }],
  ["circle", { cx: "16.6", cy: "15.89", r: "3", key: "xjtalx" }],
  ["circle", { cx: "8.11", cy: "7.4", r: "3", key: "u2fv6i" }],
  ["circle", { cx: "12.35", cy: "11.65", r: "3", key: "i6i8g7" }],
  ["circle", { cx: "13.91", cy: "5.85", r: "3", key: "6ye0dv" }],
  ["circle", { cx: "18.15", cy: "10.09", r: "3", key: "snx9no" }],
  ["circle", { cx: "6.56", cy: "13.2", r: "3", key: "17x4xg" }],
  ["circle", { cx: "10.8", cy: "17.44", r: "3", key: "1hogw9" }],
  ["circle", { cx: "5", cy: "19", r: "3", key: "1sn6vo" }]
]);
const O1 = n("grid-2x2-check", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
const R1 = n("grid-2x2-plus", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "M16 19h6", key: "xwg31i" }],
  ["path", { d: "M19 22v-6", key: "qhmiwi" }]
]);
const F1 = n("grid-2x2-x", [
  [
    "path",
    {
      d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3",
      key: "11za1p"
    }
  ],
  ["path", { d: "m16 16 5 5", key: "8tpb07" }],
  ["path", { d: "m16 21 5-5", key: "193jll" }]
]);
const E1 = n("grid-2x2", [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
const Vt = n("grid-3x3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
const Rk = n("grip-horizontal", [
  ["circle", { cx: "12", cy: "9", r: "1", key: "124mty" }],
  ["circle", { cx: "19", cy: "9", r: "1", key: "1ruzo2" }],
  ["circle", { cx: "5", cy: "9", r: "1", key: "1a8b28" }],
  ["circle", { cx: "12", cy: "15", r: "1", key: "1e56xg" }],
  ["circle", { cx: "19", cy: "15", r: "1", key: "1a92ep" }],
  ["circle", { cx: "5", cy: "15", r: "1", key: "5r1jwy" }]
]);
const Fk = n("grip-vertical", [
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }],
  ["circle", { cx: "9", cy: "5", r: "1", key: "hp0tcf" }],
  ["circle", { cx: "9", cy: "19", r: "1", key: "fkjjf6" }],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "15", cy: "5", r: "1", key: "19l28e" }],
  ["circle", { cx: "15", cy: "19", r: "1", key: "f4zoj3" }]
]);
const Ek = n("grip", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "19", cy: "5", r: "1", key: "w8mnmm" }],
  ["circle", { cx: "5", cy: "5", r: "1", key: "lttvr7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "19", cy: "12", r: "1", key: "1wjl8i" }],
  ["circle", { cx: "5", cy: "12", r: "1", key: "1pcz8c" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }],
  ["circle", { cx: "19", cy: "19", r: "1", key: "shf9b7" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
const Uk = n("group", [
  ["path", { d: "M3 7V5c0-1.1.9-2 2-2h2", key: "adw53z" }],
  ["path", { d: "M17 3h2c1.1 0 2 .9 2 2v2", key: "an4l38" }],
  ["path", { d: "M21 17v2c0 1.1-.9 2-2 2h-2", key: "144t0e" }],
  ["path", { d: "M7 21H5c-1.1 0-2-.9-2-2v-2", key: "rtnfgi" }],
  ["rect", { width: "7", height: "5", x: "7", y: "7", rx: "1", key: "1eyiv7" }],
  ["rect", { width: "7", height: "5", x: "10", y: "12", rx: "1", key: "1qlmkx" }]
]);
const Nk = n("guitar", [
  ["path", { d: "m11.9 12.1 4.514-4.514", key: "109xqo" }],
  [
    "path",
    {
      d: "M20.1 2.3a1 1 0 0 0-1.4 0l-1.114 1.114A2 2 0 0 0 17 4.828v1.344a2 2 0 0 1-.586 1.414A2 2 0 0 1 17.828 7h1.344a2 2 0 0 0 1.414-.586L21.7 5.3a1 1 0 0 0 0-1.4z",
      key: "txyc8t"
    }
  ],
  ["path", { d: "m6 16 2 2", key: "16qmzd" }],
  [
    "path",
    {
      d: "M8.2 9.9C8.7 8.8 9.8 8 11 8c2.8 0 5 2.2 5 5 0 1.2-.8 2.3-1.9 2.8l-.9.4A2 2 0 0 0 12 18a4 4 0 0 1-4 4c-3.3 0-6-2.7-6-6a4 4 0 0 1 4-4 2 2 0 0 0 1.8-1.2z",
      key: "1u8q3z"
    }
  ],
  ["circle", { cx: "11.5", cy: "12.5", r: ".5", fill: "currentColor", key: "16onso" }]
]);
const Wk = n("ham", [
  ["path", { d: "M13.144 21.144A7.274 10.445 45 1 0 2.856 10.856", key: "1k1t7q" }],
  [
    "path",
    {
      d: "M13.144 21.144A7.274 4.365 45 0 0 2.856 10.856a7.274 4.365 45 0 0 10.288 10.288",
      key: "153t1g"
    }
  ],
  [
    "path",
    {
      d: "M16.565 10.435 18.6 8.4a2.501 2.501 0 1 0 1.65-4.65 2.5 2.5 0 1 0-4.66 1.66l-2.024 2.025",
      key: "gzrt0n"
    }
  ],
  ["path", { d: "m8.5 16.5-1-1", key: "otr954" }]
]);
const Gk = n("hammer", [
  ["path", { d: "m15 12-8.373 8.373a1 1 0 1 1-3-3L12 9", key: "eefl8a" }],
  ["path", { d: "m18 15 4-4", key: "16gjal" }],
  [
    "path",
    {
      d: "m21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5",
      key: "b7pghm"
    }
  ]
]);
const Zk = n("hand-coins", [
  ["path", { d: "M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17", key: "geh8rc" }],
  [
    "path",
    {
      d: "m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "1fto5m"
    }
  ],
  ["path", { d: "m2 16 6 6", key: "1pfhp9" }],
  ["circle", { cx: "16", cy: "9", r: "2.9", key: "1n0dlu" }],
  ["circle", { cx: "6", cy: "5", r: "3", key: "151irh" }]
]);
const Yk = n("hand-heart", [
  ["path", { d: "M11 14h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 16", key: "1ifwr1" }],
  [
    "path",
    {
      d: "m7 20 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "17abbs"
    }
  ],
  ["path", { d: "m2 15 6 6", key: "10dquu" }],
  [
    "path",
    {
      d: "M19.5 8.5c.7-.7 1.5-1.6 1.5-2.7A2.73 2.73 0 0 0 16 4a2.78 2.78 0 0 0-5 1.8c0 1.2.8 2 1.5 2.8L16 12Z",
      key: "1h3036"
    }
  ]
]);
const U1 = n("hand-helping", [
  ["path", { d: "M11 12h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 14", key: "1j4xps" }],
  [
    "path",
    {
      d: "m7 18 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9",
      key: "uospg8"
    }
  ],
  ["path", { d: "m2 13 6 6", key: "16e5sb" }]
]);
const Kk = n("hand-metal", [
  ["path", { d: "M18 12.5V10a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1.4", key: "wc6myp" }],
  ["path", { d: "M14 11V9a2 2 0 1 0-4 0v2", key: "94qvcw" }],
  ["path", { d: "M10 10.5V5a2 2 0 1 0-4 0v9", key: "m1ah89" }],
  [
    "path",
    {
      d: "m7 15-1.76-1.76a2 2 0 0 0-2.83 2.82l3.6 3.6C7.5 21.14 9.2 22 12 22h2a8 8 0 0 0 8-8V7a2 2 0 1 0-4 0v5",
      key: "t1skq1"
    }
  ]
]);
const Xk = n("hand-platter", [
  ["path", { d: "M12 3V2", key: "ar7q03" }],
  [
    "path",
    {
      d: "m15.4 17.4 3.2-2.8a2 2 0 1 1 2.8 2.9l-3.6 3.3c-.7.8-1.7 1.2-2.8 1.2h-4c-1.1 0-2.1-.4-2.8-1.2l-1.302-1.464A1 1 0 0 0 6.151 19H5",
      key: "n2g93r"
    }
  ],
  ["path", { d: "M2 14h12a2 2 0 0 1 0 4h-2", key: "1o2jem" }],
  ["path", { d: "M4 10h16", key: "img6z1" }],
  ["path", { d: "M5 10a7 7 0 0 1 14 0", key: "1ega1o" }],
  ["path", { d: "M5 14v6a1 1 0 0 1-1 1H2", key: "1hescx" }]
]);
const Qk = n("hand", [
  ["path", { d: "M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1fvzgz" }],
  ["path", { d: "M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2", key: "1kc0my" }],
  ["path", { d: "M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8", key: "10h0bg" }],
  [
    "path",
    {
      d: "M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "1s1gnw"
    }
  ]
]);
const Jk = n("handshake", [
  ["path", { d: "m11 17 2 2a1 1 0 1 0 3-3", key: "efffak" }],
  [
    "path",
    {
      d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
      key: "9pr0kb"
    }
  ],
  ["path", { d: "m21 3 1 11h-2", key: "1tisrp" }],
  ["path", { d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3", key: "1uvwmv" }],
  ["path", { d: "M3 4h8", key: "1ep09j" }]
]);
const e4 = n("hard-drive-download", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
const t4 = n("hard-drive-upload", [
  ["path", { d: "m16 6-4-4-4 4", key: "13yo43" }],
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 18h.01", key: "h775k" }]
]);
const a4 = n("hard-drive", [
  ["line", { x1: "22", x2: "2", y1: "12", y2: "12", key: "1y58io" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ],
  ["line", { x1: "6", x2: "6.01", y1: "16", y2: "16", key: "sgf278" }],
  ["line", { x1: "10", x2: "10.01", y1: "16", y2: "16", key: "1l4acy" }]
]);
const n4 = n("hard-hat", [
  ["path", { d: "M10 10V5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v5", key: "1p9q5i" }],
  ["path", { d: "M14 6a6 6 0 0 1 6 6v3", key: "1hnv84" }],
  ["path", { d: "M4 15v-3a6 6 0 0 1 6-6", key: "9ciidu" }],
  ["rect", { x: "2", y: "15", width: "20", height: "4", rx: "1", key: "g3x8cw" }]
]);
const o4 = n("hash", [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
]);
const r4 = n("haze", [
  ["path", { d: "m5.2 6.2 1.4 1.4", key: "17imol" }],
  ["path", { d: "M2 13h2", key: "13gyu8" }],
  ["path", { d: "M20 13h2", key: "16rner" }],
  ["path", { d: "m17.4 7.6 1.4-1.4", key: "t4xlah" }],
  ["path", { d: "M22 17H2", key: "1gtaj3" }],
  ["path", { d: "M22 21H2", key: "1gy6en" }],
  ["path", { d: "M16 13a4 4 0 0 0-8 0", key: "1dyczq" }],
  ["path", { d: "M12 5V2.5", key: "1vytko" }]
]);
const l4 = n("hdmi-port", [
  [
    "path",
    {
      d: "M22 9a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h1l2 2h12l2-2h1a1 1 0 0 0 1-1Z",
      key: "2128wb"
    }
  ],
  ["path", { d: "M7.5 12h9", key: "1t0ckc" }]
]);
const i4 = n("heading-1", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "m17 12 3-2v8", key: "1hhhft" }]
]);
const c4 = n("heading-2", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M21 18h-4c0-4 4-3 4-6 0-1.5-2-2.5-4-1", key: "9jr5yi" }]
]);
const d4 = n("heading-3", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17.5 10.5c1.7-1 3.5 0 3.5 1.5a2 2 0 0 1-2 2", key: "68ncm8" }],
  ["path", { d: "M17 17.5c2 1.5 4 .3 4-1.5a2 2 0 0 0-2-2", key: "1ejuhz" }]
]);
const s4 = n("heading-4", [
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 10v3a1 1 0 0 0 1 1h3", key: "tj5zdr" }],
  ["path", { d: "M21 10v8", key: "1kdml4" }],
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }]
]);
const u4 = n("heading-5", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["path", { d: "M17 13v-3h4", key: "1nvgqp" }],
  [
    "path",
    { d: "M17 17.7c.4.2.8.3 1.3.3 1.5 0 2.7-1.1 2.7-2.5S19.8 13 18.3 13H17", key: "2nebdn" }
  ]
]);
const h4 = n("heading-6", [
  ["path", { d: "M4 12h8", key: "17cfdx" }],
  ["path", { d: "M4 18V6", key: "1rz3zl" }],
  ["path", { d: "M12 18V6", key: "zqpxq5" }],
  ["circle", { cx: "19", cy: "16", r: "2", key: "15mx69" }],
  ["path", { d: "M20 10c-2 2-3 3.5-3 6", key: "f35dl0" }]
]);
const p4 = n("heading", [
  ["path", { d: "M6 12h12", key: "8npq4p" }],
  ["path", { d: "M6 20V4", key: "1w1bmo" }],
  ["path", { d: "M18 20V4", key: "o2hl4u" }]
]);
const y4 = n("headphone-off", [
  ["path", { d: "M21 14h-1.343", key: "1jdnxi" }],
  ["path", { d: "M9.128 3.47A9 9 0 0 1 21 12v3.343", key: "6kipu2" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20.414 20.414A2 2 0 0 1 19 21h-1a2 2 0 0 1-2-2v-3", key: "9x50f4" }],
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 2.636-6.364",
      key: "1bkxnm"
    }
  ]
]);
const k4 = n("headphones", [
  [
    "path",
    {
      d: "M3 14h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-7a9 9 0 0 1 18 0v7a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3",
      key: "1xhozi"
    }
  ]
]);
const m4 = n("headset", [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
]);
const f4 = n("heart-crack", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "m12 13-1-1 2-2-3-3 2-2", key: "xjdxli" }]
]);
const v4 = n("heart-handshake", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  [
    "path",
    {
      d: "M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66",
      key: "4oyue0"
    }
  ],
  ["path", { d: "m18 15-2-2", key: "60u0ii" }],
  ["path", { d: "m15 18-2-2", key: "6p76be" }]
]);
const g4 = n("heart-off", [
  ["line", { x1: "2", y1: "2", x2: "22", y2: "22", key: "1w4vcy" }],
  [
    "path",
    { d: "M16.5 16.5 12 21l-7-7c-1.5-1.45-3-3.2-3-5.5a5.5 5.5 0 0 1 2.14-4.35", key: "3mpagl" }
  ],
  [
    "path",
    {
      d: "M8.76 3.1c1.15.22 2.13.78 3.24 1.9 1.5-1.5 2.74-2 4.5-2A5.5 5.5 0 0 1 22 8.5c0 2.12-1.3 3.78-2.67 5.17",
      key: "1gh3v3"
    }
  ]
]);
const M4 = n("heart-pulse", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ],
  ["path", { d: "M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27", key: "1uw2ng" }]
]);
const b4 = n("heart", [
  [
    "path",
    {
      d: "M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z",
      key: "c3ymky"
    }
  ]
]);
const x4 = n("heater", [
  ["path", { d: "M11 8c2-3-2-3 0-6", key: "1ldv5m" }],
  ["path", { d: "M15.5 8c2-3-2-3 0-6", key: "1otqoz" }],
  ["path", { d: "M6 10h.01", key: "1lbq93" }],
  ["path", { d: "M6 14h.01", key: "zudwn7" }],
  ["path", { d: "M10 16v-4", key: "1c25yv" }],
  ["path", { d: "M14 16v-4", key: "1dkbt8" }],
  ["path", { d: "M18 16v-4", key: "1yg9me" }],
  [
    "path",
    { d: "M20 6a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3", key: "1ubg90" }
  ],
  ["path", { d: "M5 20v2", key: "1abpe8" }],
  ["path", { d: "M19 20v2", key: "kqn6ft" }]
]);
const w4 = n("hexagon", [
  [
    "path",
    {
      d: "M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z",
      key: "yt0hxn"
    }
  ]
]);
const L4 = n("highlighter", [
  ["path", { d: "m9 11-6 6v3h9l3-3", key: "1a3l36" }],
  ["path", { d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4", key: "14a9rk" }]
]);
const S4 = n("history", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M12 7v5l4 2", key: "1fdv2h" }]
]);
const I4 = n("hop-off", [
  ["path", { d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.28.01.53-.09.7-.27", key: "qyzcap" }],
  [
    "path",
    {
      d: "M11.14 20.57c.52.24 2.44 1.12 4.08 1.37.46.06.86-.25.9-.71.12-1.52-.3-3.43-.5-4.28",
      key: "y078lb"
    }
  ],
  ["path", { d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .7-.26", key: "1utre3" }],
  [
    "path",
    {
      d: "M17.99 5.52a20.83 20.83 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-1.17.1-2.5.02-3.9-.25",
      key: "17o9hm"
    }
  ],
  ["path", { d: "M20.57 11.14c.24.52 1.12 2.44 1.37 4.08.04.3-.08.59-.31.75", key: "1d1n4p" }],
  [
    "path",
    {
      d: "M4.93 4.93a10 10 0 0 0-.67 13.4c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.85.85 0 0 0 .48-.24",
      key: "9uv3tt"
    }
  ],
  [
    "path",
    {
      d: "M5.52 17.99c1.05.95 2.91 2.42 4.5 3.15a.8.8 0 0 0 1.13-.68c.2-2.34-.33-5.3-1.57-8.28",
      key: "1292wz"
    }
  ],
  [
    "path",
    {
      d: "M8.35 2.68a10 10 0 0 1 9.98 1.58c.43.35.4.96-.12 1.17-1.5.6-4.3.98-6.07 1.05",
      key: "7ozu9p"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const C4 = n("hop", [
  [
    "path",
    {
      d: "M10.82 16.12c1.69.6 3.91.79 5.18.85.55.03 1-.42.97-.97-.06-1.27-.26-3.5-.85-5.18",
      key: "18lxf1"
    }
  ],
  [
    "path",
    {
      d: "M11.5 6.5c1.64 0 5-.38 6.71-1.07.52-.2.55-.82.12-1.17A10 10 0 0 0 4.26 18.33c.35.43.96.4 1.17-.12.69-1.71 1.07-5.07 1.07-6.71 1.34.45 3.1.9 4.88.62a.88.88 0 0 0 .73-.74c.3-2.14-.15-3.5-.61-4.88",
      key: "vtfxrw"
    }
  ],
  [
    "path",
    {
      d: "M15.62 16.95c.2.85.62 2.76.5 4.28a.77.77 0 0 1-.9.7 16.64 16.64 0 0 1-4.08-1.36",
      key: "13hl71"
    }
  ],
  [
    "path",
    {
      d: "M16.13 21.05c1.65.63 3.68.84 4.87.91a.9.9 0 0 0 .96-.96 17.68 17.68 0 0 0-.9-4.87",
      key: "1sl8oj"
    }
  ],
  [
    "path",
    {
      d: "M16.94 15.62c.86.2 2.77.62 4.29.5a.77.77 0 0 0 .7-.9 16.64 16.64 0 0 0-1.36-4.08",
      key: "19c6kt"
    }
  ],
  [
    "path",
    {
      d: "M17.99 5.52a20.82 20.82 0 0 1 3.15 4.5.8.8 0 0 1-.68 1.13c-2.33.2-5.3-.32-8.27-1.57",
      key: "85ghs3"
    }
  ],
  ["path", { d: "M4.93 4.93 3 3a.7.7 0 0 1 0-1", key: "x087yj" }],
  [
    "path",
    {
      d: "M9.58 12.18c1.24 2.98 1.77 5.95 1.57 8.28a.8.8 0 0 1-1.13.68 20.82 20.82 0 0 1-4.5-3.15",
      key: "11xdqo"
    }
  ]
]);
const A4 = n("hospital", [
  ["path", { d: "M12 6v4", key: "16clxf" }],
  ["path", { d: "M14 14h-4", key: "esezmu" }],
  ["path", { d: "M14 18h-4", key: "16mqa2" }],
  ["path", { d: "M14 8h-4", key: "z8ypaz" }],
  [
    "path",
    {
      d: "M18 12h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2",
      key: "b1k337"
    }
  ],
  ["path", { d: "M18 22V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v18", key: "16g51d" }]
]);
const q4 = n("hotel", [
  ["path", { d: "M10 22v-6.57", key: "1wmca3" }],
  ["path", { d: "M12 11h.01", key: "z322tv" }],
  ["path", { d: "M12 7h.01", key: "1ivr5q" }],
  ["path", { d: "M14 15.43V22", key: "1q2vjd" }],
  ["path", { d: "M15 16a5 5 0 0 0-6 0", key: "o9wqvi" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }],
  ["path", { d: "M16 7h.01", key: "1kdx03" }],
  ["path", { d: "M8 11h.01", key: "1dfujw" }],
  ["path", { d: "M8 7h.01", key: "1vti4s" }],
  ["rect", { x: "4", y: "2", width: "16", height: "20", rx: "2", key: "1uxh74" }]
]);
const z4 = n("hourglass", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  ["path", { d: "M5 2h14", key: "pdyrp9" }],
  [
    "path",
    {
      d: "M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22",
      key: "1d314k"
    }
  ],
  [
    "path",
    { d: "M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2", key: "1vvvr6" }
  ]
]);
const P4 = n("house-plug", [
  ["path", { d: "M10 12V8.964", key: "1vll13" }],
  ["path", { d: "M14 12V8.964", key: "1x3qvg" }],
  [
    "path",
    { d: "M15 12a1 1 0 0 1 1 1v2a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-2a1 1 0 0 1 1-1z", key: "ppykja" }
  ],
  [
    "path",
    {
      d: "M8.5 21H5a2 2 0 0 1-2-2v-9a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2v-2",
      key: "1gvg2z"
    }
  ]
]);
const _4 = n("house-plus", [
  [
    "path",
    {
      d: "M13.22 2.416a2 2 0 0 0-2.511.057l-7 5.999A2 2 0 0 0 3 10v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7.354",
      key: "5phn05"
    }
  ],
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 3v6", key: "x1uolp" }]
]);
const j4 = n("house-wifi", [
  ["path", { d: "M9.5 13.866a4 4 0 0 1 5 .01", key: "1wy54i" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ],
  ["path", { d: "M7 10.754a8 8 0 0 1 10 0", key: "exoy2g" }]
]);
const N1 = n("house", [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "1d0kgt"
    }
  ]
]);
const W1 = n("ice-cream-bowl", [
  [
    "path",
    {
      d: "M12 17c5 0 8-2.69 8-6H4c0 3.31 3 6 8 6m-4 4h8m-4-3v3M5.14 11a3.5 3.5 0 1 1 6.71 0",
      key: "1uxfcu"
    }
  ],
  ["path", { d: "M12.14 11a3.5 3.5 0 1 1 6.71 0", key: "4k3m1s" }],
  ["path", { d: "M15.5 6.5a3.5 3.5 0 1 0-7 0", key: "zmuahr" }]
]);
const H4 = n("id-card", [
  ["path", { d: "M16 10h2", key: "8sgtl7" }],
  ["path", { d: "M16 14h2", key: "epxaof" }],
  ["path", { d: "M6.17 15a3 3 0 0 1 5.66 0", key: "n6f512" }],
  ["circle", { cx: "9", cy: "11", r: "2", key: "yxgjnd" }],
  ["rect", { x: "2", y: "5", width: "20", height: "14", rx: "2", key: "qneu4z" }]
]);
const G1 = n("ice-cream-cone", [
  ["path", { d: "m7 11 4.08 10.35a1 1 0 0 0 1.84 0L17 11", key: "1v6356" }],
  ["path", { d: "M17 7A5 5 0 0 0 7 7", key: "151p3v" }],
  ["path", { d: "M17 7a2 2 0 0 1 0 4H7a2 2 0 0 1 0-4", key: "1sdaij" }]
]);
const V4 = n("image-down", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19 3 3v-5.5", key: "9ldu5r" }],
  ["path", { d: "m17 22 3-3", key: "1nkfve" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
const B4 = n("image-minus", [
  ["path", { d: "M21 9v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "m87ecr" }],
  ["line", { x1: "16", x2: "22", y1: "5", y2: "5", key: "ez7e4s" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
const D4 = n("image-play", [
  ["path", { d: "m11 16-5 5", key: "j5f7ct" }],
  ["path", { d: "M11 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6.5", key: "7s81lt" }],
  [
    "path",
    {
      d: "M15.765 22a.5.5 0 0 1-.765-.424V13.38a.5.5 0 0 1 .765-.424l5.878 3.674a1 1 0 0 1 0 1.696z",
      key: "1omb6s"
    }
  ],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
const T4 = n("image-off", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M10.41 10.41a2 2 0 1 1-2.83-2.83", key: "1bzlo9" }],
  ["line", { x1: "13.5", x2: "6", y1: "13.5", y2: "21", key: "1q0aeu" }],
  ["line", { x1: "18", x2: "21", y1: "12", y2: "15", key: "5mozeu" }],
  [
    "path",
    {
      d: "M3.59 3.59A1.99 1.99 0 0 0 3 5v14a2 2 0 0 0 2 2h14c.55 0 1.052-.22 1.41-.59",
      key: "mmje98"
    }
  ],
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }]
]);
const $4 = n("image-plus", [
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }],
  ["path", { d: "M21 11.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7.5", key: "1ue2ih" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
const O4 = n("image-up", [
  [
    "path",
    {
      d: "M10.3 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10l-3.1-3.1a2 2 0 0 0-2.814.014L6 21",
      key: "9csbqa"
    }
  ],
  ["path", { d: "m14 19.5 3-3 3 3", key: "9vmjn0" }],
  ["path", { d: "M17 22v-5.5", key: "1aa6fl" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }]
]);
const R4 = n("image-upscale", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M17 21h2a2 2 0 0 0 2-2", key: "130fy9" }],
  ["path", { d: "M21 12v3", key: "1wzk3p" }],
  ["path", { d: "m21 3-5 5", key: "1g5oa7" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2", key: "kk3yz1" }],
  ["path", { d: "m5 21 4.144-4.144a1.21 1.21 0 0 1 1.712 0L13 19", key: "fyekpt" }],
  ["path", { d: "M9 3h3", key: "d52fa" }],
  ["rect", { x: "3", y: "11", width: "10", height: "10", rx: "1", key: "1wpmix" }]
]);
const F4 = n("image", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["circle", { cx: "9", cy: "9", r: "2", key: "af1f0g" }],
  ["path", { d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21", key: "1xmnt7" }]
]);
const E4 = n("images", [
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  ["path", { d: "m22 13-1.296-1.296a2.41 2.41 0 0 0-3.408 0L11 18", key: "nf6bnh" }],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  ["rect", { width: "16", height: "16", x: "6", y: "2", rx: "2", key: "12espp" }]
]);
const U4 = n("import", [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m8 11 4 4 4-4", key: "1dohi6" }],
  [
    "path",
    {
      d: "M8 5H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-4",
      key: "1ywtjm"
    }
  ]
]);
const N4 = n("inbox", [
  ["polyline", { points: "22 12 16 12 14 15 10 15 8 12 2 12", key: "o97t9d" }],
  [
    "path",
    {
      d: "M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z",
      key: "oot6mr"
    }
  ]
]);
const Z1 = n("indent-increase", [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m3 8 4 4-4 4", key: "1a3j6y" }]
]);
const Y1 = n("indent-decrease", [
  ["path", { d: "M21 12H11", key: "wd7e0v" }],
  ["path", { d: "M21 18H11", key: "4wu86t" }],
  ["path", { d: "M21 6H11", key: "6dy1d6" }],
  ["path", { d: "m7 8-4 4 4 4", key: "o5hrat" }]
]);
const W4 = n("indian-rupee", [
  ["path", { d: "M6 3h12", key: "ggurg9" }],
  ["path", { d: "M6 8h12", key: "6g4wlu" }],
  ["path", { d: "m6 13 8.5 8", key: "u1kupk" }],
  ["path", { d: "M6 13h3", key: "wdp6ag" }],
  ["path", { d: "M9 13c6.667 0 6.667-10 0-10", key: "1nkvk2" }]
]);
const G4 = n("infinity", [
  ["path", { d: "M6 16c5 0 7-8 12-8a4 4 0 0 1 0 8c-5 0-7-8-12-8a4 4 0 1 0 0 8", key: "18ogeb" }]
]);
const Z4 = n("info", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
]);
const Y4 = n("inspection-panel", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h.01", key: "7u93v4" }],
  ["path", { d: "M17 7h.01", key: "14a9sn" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M17 17h.01", key: "1sd3ek" }]
]);
const K4 = n("instagram", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "5", ry: "5", key: "2e1cvw" }],
  ["path", { d: "M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z", key: "9exkf1" }],
  ["line", { x1: "17.5", x2: "17.51", y1: "6.5", y2: "6.5", key: "r4j83e" }]
]);
const X4 = n("italic", [
  ["line", { x1: "19", x2: "10", y1: "4", y2: "4", key: "15jd3p" }],
  ["line", { x1: "14", x2: "5", y1: "20", y2: "20", key: "bu0au3" }],
  ["line", { x1: "15", x2: "9", y1: "4", y2: "20", key: "uljnxc" }]
]);
const Q4 = n("iteration-ccw", [
  ["path", { d: "M20 10c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8h8", key: "4znkd0" }],
  ["polyline", { points: "16 14 20 18 16 22", key: "11njsm" }]
]);
const J4 = n("iteration-cw", [
  ["path", { d: "M4 10c0-4.4 3.6-8 8-8s8 3.6 8 8-3.6 8-8 8H4", key: "tuf4su" }],
  ["polyline", { points: "8 22 4 18 8 14", key: "evkj9s" }]
]);
const e5 = n("japanese-yen", [
  ["path", { d: "M12 9.5V21m0-11.5L6 3m6 6.5L18 3", key: "2ej80x" }],
  ["path", { d: "M6 15h12", key: "1hwgt5" }],
  ["path", { d: "M6 11h12", key: "wf4gp6" }]
]);
const t5 = n("joystick", [
  [
    "path",
    {
      d: "M21 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-2Z",
      key: "jg2n2t"
    }
  ],
  ["path", { d: "M6 15v-2", key: "gd6mvg" }],
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["circle", { cx: "12", cy: "6", r: "3", key: "1gm2ql" }]
]);
const a5 = n("key-round", [
  [
    "path",
    {
      d: "M2.586 17.414A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814a6.5 6.5 0 1 0-4-4z",
      key: "1s6t7t"
    }
  ],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }]
]);
const n5 = n("kanban", [
  ["path", { d: "M6 5v11", key: "mdvv1e" }],
  ["path", { d: "M12 5v6", key: "14ar3b" }],
  ["path", { d: "M18 5v14", key: "7ji314" }]
]);
const o5 = n("key-square", [
  [
    "path",
    {
      d: "M12.4 2.7a2.5 2.5 0 0 1 3.4 0l5.5 5.5a2.5 2.5 0 0 1 0 3.4l-3.7 3.7a2.5 2.5 0 0 1-3.4 0L8.7 9.8a2.5 2.5 0 0 1 0-3.4z",
      key: "165ttr"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  [
    "path",
    {
      d: "m9.4 10.6-6.814 6.814A2 2 0 0 0 2 18.828V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 0 1-1v-1a1 1 0 0 1 1-1h.172a2 2 0 0 0 1.414-.586l.814-.814",
      key: "1ubxi2"
    }
  ]
]);
const r5 = n("key", [
  ["path", { d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4", key: "g0fldk" }],
  ["path", { d: "m21 2-9.6 9.6", key: "1j0ho8" }],
  ["circle", { cx: "7.5", cy: "15.5", r: "5.5", key: "yqb3hr" }]
]);
const l5 = n("keyboard-off", [
  ["path", { d: "M 20 4 A2 2 0 0 1 22 6", key: "1g1fkt" }],
  ["path", { d: "M 22 6 L 22 16.41", key: "1qjg3w" }],
  ["path", { d: "M 7 16 L 16 16", key: "n0yqwb" }],
  ["path", { d: "M 9.69 4 L 20 4", key: "kbpcgx" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M20 20H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2", key: "s23sx2" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }]
]);
const i5 = n("keyboard", [
  ["path", { d: "M10 8h.01", key: "1r9ogq" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M6 8h.01", key: "x9i8wu" }],
  ["path", { d: "M7 16h10", key: "wp8him" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }]
]);
const c5 = n("keyboard-music", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M6 8h4", key: "utf9t1" }],
  ["path", { d: "M14 8h.01", key: "1primd" }],
  ["path", { d: "M18 8h.01", key: "emo2bl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "M6 12v4", key: "dy92yo" }],
  ["path", { d: "M10 12v4", key: "1fxnav" }],
  ["path", { d: "M14 12v4", key: "1hft58" }],
  ["path", { d: "M18 12v4", key: "tjjnbz" }]
]);
const d5 = n("lamp-ceiling", [
  ["path", { d: "M12 2v5", key: "nd4vlx" }],
  ["path", { d: "M6 7h12l4 9H2l4-9Z", key: "123d64" }],
  ["path", { d: "M9.17 16a3 3 0 1 0 5.66 0", key: "1061mw" }]
]);
const s5 = n("lamp-desk", [
  ["path", { d: "m14 5-3 3 2 7 8-8-7-2Z", key: "1b0msb" }],
  ["path", { d: "m14 5-3 3-3-3 3-3 3 3Z", key: "1uemms" }],
  ["path", { d: "M9.5 6.5 4 12l3 6", key: "1bx08v" }],
  ["path", { d: "M3 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H3Z", key: "wap775" }]
]);
const u5 = n("lamp-floor", [
  ["path", { d: "M9 2h6l3 7H6l3-7Z", key: "wcx6mj" }],
  ["path", { d: "M12 9v13", key: "3n1su1" }],
  ["path", { d: "M9 22h6", key: "1rlq3v" }]
]);
const h5 = n("lamp-wall-down", [
  ["path", { d: "M11 13h6l3 7H8l3-7Z", key: "9n3qlo" }],
  ["path", { d: "M14 13V8a2 2 0 0 0-2-2H8", key: "1hu4hb" }],
  ["path", { d: "M4 9h2a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H4v6Z", key: "s053bc" }]
]);
const p5 = n("lamp-wall-up", [
  ["path", { d: "M11 4h6l3 7H8l3-7Z", key: "11x1ee" }],
  ["path", { d: "M14 11v5a2 2 0 0 1-2 2H8", key: "eutp5o" }],
  ["path", { d: "M4 15h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2H4v-6Z", key: "1iuthr" }]
]);
const y5 = n("lamp", [
  ["path", { d: "M8 2h8l4 10H4L8 2Z", key: "9dma5w" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }],
  ["path", { d: "M8 22v-2c0-1.1.9-2 2-2h4a2 2 0 0 1 2 2v2H8Z", key: "mwf4oh" }]
]);
const k5 = n("land-plot", [
  ["path", { d: "m12 8 6-3-6-3v10", key: "mvpnpy" }],
  [
    "path",
    {
      d: "m8 11.99-5.5 3.14a1 1 0 0 0 0 1.74l8.5 4.86a2 2 0 0 0 2 0l8.5-4.86a1 1 0 0 0 0-1.74L16 12",
      key: "ek95tt"
    }
  ],
  ["path", { d: "m6.49 12.85 11.02 6.3", key: "1kt42w" }],
  ["path", { d: "M17.51 12.85 6.5 19.15", key: "v55bdg" }]
]);
const m5 = n("landmark", [
  ["line", { x1: "3", x2: "21", y1: "22", y2: "22", key: "j8o0r" }],
  ["line", { x1: "6", x2: "6", y1: "18", y2: "11", key: "10tf0k" }],
  ["line", { x1: "10", x2: "10", y1: "18", y2: "11", key: "54lgf6" }],
  ["line", { x1: "14", x2: "14", y1: "18", y2: "11", key: "380y" }],
  ["line", { x1: "18", x2: "18", y1: "18", y2: "11", key: "1kevvc" }],
  ["polygon", { points: "12 2 20 7 4 7", key: "jkujk7" }]
]);
const f5 = n("languages", [
  ["path", { d: "m5 8 6 6", key: "1wu5hv" }],
  ["path", { d: "m4 14 6-6 2-3", key: "1k1g8d" }],
  ["path", { d: "M2 5h12", key: "or177f" }],
  ["path", { d: "M7 2h1", key: "1t2jsx" }],
  ["path", { d: "m22 22-5-10-5 10", key: "don7ne" }],
  ["path", { d: "M14 18h6", key: "1m8k6r" }]
]);
const v5 = n("laptop-minimal-check", [
  ["path", { d: "M2 20h20", key: "owomy5" }],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { x: "3", y: "4", width: "18", height: "12", rx: "2", key: "8ur36m" }]
]);
const K1 = n("laptop-minimal", [
  ["rect", { width: "18", height: "12", x: "3", y: "4", rx: "2", ry: "2", key: "1qhy41" }],
  ["line", { x1: "2", x2: "22", y1: "20", y2: "20", key: "ni3hll" }]
]);
const g5 = n("laptop", [
  [
    "path",
    {
      d: "M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16",
      key: "tarvll"
    }
  ]
]);
const M5 = n("lasso-select", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  ["path", { d: "M7 16.93c.96.43 1.96.74 2.99.91", key: "ybbtv3" }],
  [
    "path",
    {
      d: "M3.34 14A6.8 6.8 0 0 1 2 10c0-4.42 4.48-8 10-8s10 3.58 10 8a7.19 7.19 0 0 1-.33 2",
      key: "gt5e1w"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }],
  [
    "path",
    {
      d: "M14.33 22h-.09a.35.35 0 0 1-.24-.32v-10a.34.34 0 0 1 .33-.34c.08 0 .15.03.21.08l7.34 6a.33.33 0 0 1-.21.59h-4.49l-2.57 3.85a.35.35 0 0 1-.28.14z",
      key: "72q637"
    }
  ]
]);
const b5 = n("lasso", [
  ["path", { d: "M7 22a5 5 0 0 1-2-4", key: "umushi" }],
  [
    "path",
    {
      d: "M3.3 14A6.8 6.8 0 0 1 2 10c0-4.4 4.5-8 10-8s10 3.6 10 8-4.5 8-10 8a12 12 0 0 1-5-1",
      key: "146dds"
    }
  ],
  ["path", { d: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", key: "bq3ynw" }]
]);
const x5 = n("laugh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M18 13a6 6 0 0 1-6 5 6 6 0 0 1-6-5h12Z", key: "b2q4dd" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
const w5 = n("layers-2", [
  [
    "path",
    {
      d: "m16.02 12 5.48 3.13a1 1 0 0 1 0 1.74L13 21.74a2 2 0 0 1-2 0l-8.5-4.87a1 1 0 0 1 0-1.74L7.98 12",
      key: "1cuww1"
    }
  ],
  [
    "path",
    {
      d: "M13 13.74a2 2 0 0 1-2 0L2.5 8.87a1 1 0 0 1 0-1.74L11 2.26a2 2 0 0 1 2 0l8.5 4.87a1 1 0 0 1 0 1.74Z",
      key: "pdlvxu"
    }
  ]
]);
const X1 = n("layers", [
  [
    "path",
    {
      d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
      key: "zw3jo"
    }
  ],
  [
    "path",
    {
      d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
      key: "1wduqc"
    }
  ],
  [
    "path",
    {
      d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
      key: "kqbvx6"
    }
  ]
]);
const L5 = n("layout-dashboard", [
  ["rect", { width: "7", height: "9", x: "3", y: "3", rx: "1", key: "10lvy0" }],
  ["rect", { width: "7", height: "5", x: "14", y: "3", rx: "1", key: "16une8" }],
  ["rect", { width: "7", height: "9", x: "14", y: "12", rx: "1", key: "1hutg5" }],
  ["rect", { width: "7", height: "5", x: "3", y: "16", rx: "1", key: "ldoo1y" }]
]);
const S5 = n("layout-grid", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }]
]);
const I5 = n("layout-list", [
  ["rect", { width: "7", height: "7", x: "3", y: "3", rx: "1", key: "1g98yp" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["path", { d: "M14 4h7", key: "3xa0d5" }],
  ["path", { d: "M14 9h7", key: "1icrd9" }],
  ["path", { d: "M14 15h7", key: "1mj8o2" }],
  ["path", { d: "M14 20h7", key: "11slyb" }]
]);
const C5 = n("layout-panel-left", [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
const A5 = n("layout-panel-top", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "7", height: "7", x: "3", y: "14", rx: "1", key: "1bb6yr" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
]);
const q5 = n("layout-template", [
  ["rect", { width: "18", height: "7", x: "3", y: "3", rx: "1", key: "f1a2em" }],
  ["rect", { width: "9", height: "7", x: "3", y: "14", rx: "1", key: "jqznyg" }],
  ["rect", { width: "5", height: "7", x: "16", y: "14", rx: "1", key: "q5h2i8" }]
]);
const z5 = n("leaf", [
  [
    "path",
    {
      d: "M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z",
      key: "nnexq3"
    }
  ],
  ["path", { d: "M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12", key: "mt58a7" }]
]);
const P5 = n("leafy-green", [
  [
    "path",
    {
      d: "M2 22c1.25-.987 2.27-1.975 3.9-2.2a5.56 5.56 0 0 1 3.8 1.5 4 4 0 0 0 6.187-2.353 3.5 3.5 0 0 0 3.69-5.116A3.5 3.5 0 0 0 20.95 8 3.5 3.5 0 1 0 16 3.05a3.5 3.5 0 0 0-5.831 1.373 3.5 3.5 0 0 0-5.116 3.69 4 4 0 0 0-2.348 6.155C3.499 15.42 4.409 16.712 4.2 18.1 3.926 19.743 3.014 20.732 2 22",
      key: "1134nt"
    }
  ],
  ["path", { d: "M2 22 17 7", key: "1q7jp2" }]
]);
const _5 = n("lectern", [
  [
    "path",
    {
      d: "M16 12h3a2 2 0 0 0 1.902-1.38l1.056-3.333A1 1 0 0 0 21 6H3a1 1 0 0 0-.958 1.287l1.056 3.334A2 2 0 0 0 5 12h3",
      key: "13jjxg"
    }
  ],
  ["path", { d: "M18 6V3a1 1 0 0 0-1-1h-3", key: "1550fe" }],
  ["rect", { width: "8", height: "12", x: "8", y: "10", rx: "1", key: "qmu8b6" }]
]);
const j5 = n("letter-text", [
  ["path", { d: "M15 12h6", key: "upa0zy" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "m3 13 3.553-7.724a.5.5 0 0 1 .894 0L11 13", key: "blevx4" }],
  ["path", { d: "M3 18h18", key: "1h113x" }],
  ["path", { d: "M4 11h6", key: "olkgv1" }]
]);
const H5 = n("library-big", [
  ["rect", { width: "8", height: "18", x: "3", y: "3", rx: "1", key: "oynpb5" }],
  ["path", { d: "M7 3v18", key: "bbkbws" }],
  [
    "path",
    {
      d: "M20.4 18.9c.2.5-.1 1.1-.6 1.3l-1.9.7c-.5.2-1.1-.1-1.3-.6L11.1 5.1c-.2-.5.1-1.1.6-1.3l1.9-.7c.5-.2 1.1.1 1.3.6Z",
      key: "1qboyk"
    }
  ]
]);
const V5 = n("library", [
  ["path", { d: "m16 6 4 14", key: "ji33uf" }],
  ["path", { d: "M12 6v14", key: "1n7gus" }],
  ["path", { d: "M8 8v12", key: "1gg7y9" }],
  ["path", { d: "M4 4v16", key: "6qkkli" }]
]);
const B5 = n("life-buoy", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m4.93 4.93 4.24 4.24", key: "1ymg45" }],
  ["path", { d: "m14.83 9.17 4.24-4.24", key: "1cb5xl" }],
  ["path", { d: "m14.83 14.83 4.24 4.24", key: "q42g0n" }],
  ["path", { d: "m9.17 14.83-4.24 4.24", key: "bqpfvv" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
const D5 = n("ligature", [
  ["path", { d: "M8 20V8c0-2.2 1.8-4 4-4 1.5 0 2.8.8 3.5 2", key: "1rtphz" }],
  ["path", { d: "M6 12h4", key: "a4o3ry" }],
  ["path", { d: "M14 12h2v8", key: "c1fccl" }],
  ["path", { d: "M6 20h4", key: "1i6q5t" }],
  ["path", { d: "M14 20h4", key: "lzx1xo" }]
]);
const T5 = n("lightbulb-off", [
  ["path", { d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5", key: "1fkcox" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5", key: "10m8kw" }],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
const $5 = n("lightbulb", [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
]);
const O5 = n("link-2-off", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7", key: "10o201" }],
  ["path", { d: "M15 7h2a5 5 0 0 1 4 8", key: "1d3206" }],
  ["line", { x1: "8", x2: "12", y1: "12", y2: "12", key: "rvw6j4" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const R5 = n("link-2", [
  ["path", { d: "M9 17H7A5 5 0 0 1 7 7h2", key: "8i5ue5" }],
  ["path", { d: "M15 7h2a5 5 0 1 1 0 10h-2", key: "1b9ql8" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }]
]);
const F5 = n("link", [
  ["path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71", key: "1cjeqo" }],
  ["path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71", key: "19qd67" }]
]);
const E5 = n("linkedin", [
  [
    "path",
    {
      d: "M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z",
      key: "c2jq9f"
    }
  ],
  ["rect", { width: "4", height: "12", x: "2", y: "9", key: "mk3on5" }],
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }]
]);
const U5 = n("list-check", [
  ["path", { d: "M11 18H3", key: "n3j2dh" }],
  ["path", { d: "m15 18 2 2 4-4", key: "1szwhi" }],
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }]
]);
const N5 = n("list-checks", [
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
const W5 = n("list-collapse", [
  ["path", { d: "m3 10 2.5-2.5L3 5", key: "i6eama" }],
  ["path", { d: "m3 19 2.5-2.5L3 14", key: "w2gmor" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }]
]);
const G5 = n("list-end", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["path", { d: "M21 6v10a2 2 0 0 1-2 2h-5", key: "ilrcs8" }],
  ["path", { d: "m16 16-2 2 2 2", key: "kkc6pm" }]
]);
const Z5 = n("list-filter", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M10 18h4", key: "1ulq68" }]
]);
const Y5 = n("list-minus", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
const K5 = n("list-filter-plus", [
  ["path", { d: "M10 18h4", key: "1ulq68" }],
  ["path", { d: "M11 6H3", key: "1u26ik" }],
  ["path", { d: "M15 6h6", key: "1jlkvy" }],
  ["path", { d: "M18 9V3", key: "xwwp7m" }],
  ["path", { d: "M7 12h8", key: "7a1bxv" }]
]);
const X5 = n("list-music", [
  ["path", { d: "M21 15V6", key: "h1cx4g" }],
  ["path", { d: "M18.5 18a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z", key: "8saifv" }],
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }]
]);
const Q5 = n("list-ordered", [
  ["path", { d: "M10 12h11", key: "6m4ad9" }],
  ["path", { d: "M10 18h11", key: "11hvi2" }],
  ["path", { d: "M10 6h11", key: "c7qv1k" }],
  ["path", { d: "M4 10h2", key: "16xx2s" }],
  ["path", { d: "M4 6h1v4", key: "cnovpq" }],
  ["path", { d: "M6 18H4c0-1 2-2 2-3s-1-1.5-2-1", key: "m9a95d" }]
]);
const J5 = n("list-plus", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M18 9v6", key: "1twb98" }],
  ["path", { d: "M21 12h-6", key: "bt1uis" }]
]);
const em = n("list-restart", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M7 12H3", key: "13ou7f" }],
  ["path", { d: "M7 18H3", key: "1sijw9" }],
  [
    "path",
    {
      d: "M12 18a5 5 0 0 0 9-3 4.5 4.5 0 0 0-4.5-4.5c-1.33 0-2.54.54-3.41 1.41L11 14",
      key: "qth677"
    }
  ],
  ["path", { d: "M11 10v4h4", key: "172dkj" }]
]);
const tm = n("list-start", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M10 6H3", key: "lf8lx7" }],
  ["path", { d: "M21 18V8a2 2 0 0 0-2-2h-5", key: "1hghli" }],
  ["path", { d: "m16 8-2-2 2-2", key: "160uvd" }]
]);
const am = n("list-todo", [
  ["rect", { x: "3", y: "5", width: "6", height: "6", rx: "1", key: "1defrl" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }]
]);
const nm = n("list-tree", [
  ["path", { d: "M21 12h-8", key: "1bmf0i" }],
  ["path", { d: "M21 6H8", key: "1pqkrb" }],
  ["path", { d: "M21 18h-8", key: "1tm79t" }],
  ["path", { d: "M3 6v4c0 1.1.9 2 2 2h3", key: "1ywdgy" }],
  ["path", { d: "M3 10v6c0 1.1.9 2 2 2h3", key: "2wc746" }]
]);
const om = n("list-video", [
  ["path", { d: "M12 12H3", key: "18klou" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M12 18H3", key: "11ftsu" }],
  ["path", { d: "m16 12 5 3-5 3v-6Z", key: "zpskkp" }]
]);
const rm = n("list-x", [
  ["path", { d: "M11 12H3", key: "51ecnj" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "m19 10-4 4", key: "1tz659" }],
  ["path", { d: "m15 10 4 4", key: "1n7nei" }]
]);
const lm = n("list", [
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M3 18h.01", key: "1tta3j" }],
  ["path", { d: "M3 6h.01", key: "1rqtza" }],
  ["path", { d: "M8 12h13", key: "1za7za" }],
  ["path", { d: "M8 18h13", key: "1lx6n3" }],
  ["path", { d: "M8 6h13", key: "ik3vkj" }]
]);
const Q1 = n("loader-circle", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
const im = n("loader-pinwheel", [
  ["path", { d: "M22 12a1 1 0 0 1-10 0 1 1 0 0 0-10 0", key: "1lzz15" }],
  ["path", { d: "M7 20.7a1 1 0 1 1 5-8.7 1 1 0 1 0 5-8.6", key: "1gnrpi" }],
  ["path", { d: "M7 3.3a1 1 0 1 1 5 8.6 1 1 0 1 0 5 8.6", key: "u9yy5q" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const cm = n("loader", [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
]);
const dm = n("locate-fixed", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const sm = n("locate-off", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  [
    "path",
    {
      d: "M7.11 7.11C5.83 8.39 5 10.1 5 12c0 3.87 3.13 7 7 7 1.9 0 3.61-.83 4.89-2.11",
      key: "1oh7ia"
    }
  ],
  [
    "path",
    {
      d: "M18.71 13.96c.19-.63.29-1.29.29-1.96 0-3.87-3.13-7-7-7-.67 0-1.33.1-1.96.29",
      key: "3qdecy"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const um = n("locate", [
  ["line", { x1: "2", x2: "5", y1: "12", y2: "12", key: "bvdh0s" }],
  ["line", { x1: "19", x2: "22", y1: "12", y2: "12", key: "1tbv5k" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "5", key: "11lu5j" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }],
  ["circle", { cx: "12", cy: "12", r: "7", key: "fim9np" }]
]);
const J1 = n("lock-keyhole-open", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { width: "18", height: "12", x: "3", y: "10", rx: "2", key: "l0tzu3" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 9.33-2.5", key: "car5b7" }]
]);
const hm = n("lock-keyhole", [
  ["circle", { cx: "12", cy: "16", r: "1", key: "1au0dj" }],
  ["rect", { x: "3", y: "10", width: "18", height: "12", rx: "2", key: "6s8ecr" }],
  ["path", { d: "M7 10V7a5 5 0 0 1 10 0v3", key: "1pqi11" }]
]);
const pm = n("lock", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
]);
const en = n("lock-open", [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 9.9-1", key: "1mm8w8" }]
]);
const ym = n("log-in", [
  ["path", { d: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4", key: "u53s6r" }],
  ["polyline", { points: "10 17 15 12 10 7", key: "1ail0h" }],
  ["line", { x1: "15", x2: "3", y1: "12", y2: "12", key: "v6grx8" }]
]);
const km = n("log-out", [
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }],
  ["polyline", { points: "16 17 21 12 16 7", key: "1gabdz" }],
  ["line", { x1: "21", x2: "9", y1: "12", y2: "12", key: "1uyos4" }]
]);
const mm = n("logs", [
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 18h8", key: "oe0vm4" }],
  ["path", { d: "M13 6h8", key: "15sg57" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M3 18h1", key: "1eiwyy" }],
  ["path", { d: "M3 6h1", key: "rgxa97" }],
  ["path", { d: "M8 12h1", key: "1con00" }],
  ["path", { d: "M8 18h1", key: "13wk12" }],
  ["path", { d: "M8 6h1", key: "tn6mkg" }]
]);
const fm = n("lollipop", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M11 11a2 2 0 0 0 4 0 4 4 0 0 0-8 0 6 6 0 0 0 12 0", key: "107gwy" }]
]);
const vm = n("luggage", [
  [
    "path",
    { d: "M6 20a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1m57jg" }
  ],
  ["path", { d: "M8 18V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v14", key: "1l99gc" }],
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["circle", { cx: "16", cy: "20", r: "2", key: "1vifvg" }],
  ["circle", { cx: "8", cy: "20", r: "2", key: "ckkr5m" }]
]);
const gm = n("magnet", [
  [
    "path",
    {
      d: "m6 15-4-4 6.75-6.77a7.79 7.79 0 0 1 11 11L13 22l-4-4 6.39-6.36a2.14 2.14 0 0 0-3-3L6 15",
      key: "1i3lhw"
    }
  ],
  ["path", { d: "m5 8 4 4", key: "j6kj7e" }],
  ["path", { d: "m12 15 4 4", key: "lnac28" }]
]);
const Mm = n("mail-check", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
const bm = n("mail-minus", [
  ["path", { d: "M22 15V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "fuxbkv" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
const xm = n("mail-open", [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
]);
const wm = n("mail-plus", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h8", key: "12jkf8" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M16 19h6", key: "xwg31i" }]
]);
const Lm = n("mail-question", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  [
    "path",
    {
      d: "M18 15.28c.2-.4.5-.8.9-1a2.1 2.1 0 0 1 2.6.4c.3.4.5.8.5 1.3 0 1.3-2 2-2 2",
      key: "7z9rxb"
    }
  ],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
const Sm = n("mail-search", [
  ["path", { d: "M22 12.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h7.5", key: "w80f2v" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M18 21a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z", key: "8lzu5m" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.5-1.5", key: "1x83k4" }]
]);
const Im = n("mail-warning", [
  ["path", { d: "M22 10.5V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h12.5", key: "e61zoh" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "M20 14v4", key: "1hm744" }],
  ["path", { d: "M20 22v.01", key: "12bgn6" }]
]);
const Cm = n("mail-x", [
  ["path", { d: "M22 13V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12c0 1.1.9 2 2 2h9", key: "1j9vog" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }],
  ["path", { d: "m17 17 4 4", key: "1b3523" }],
  ["path", { d: "m21 17-4 4", key: "uinynz" }]
]);
const Am = n("mail", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7", key: "1ocrg3" }]
]);
const qm = n("mailbox", [
  [
    "path",
    {
      d: "M22 17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.5C2 7 4 5 6.5 5H18c2.2 0 4 1.8 4 4v8Z",
      key: "1lbycx"
    }
  ],
  ["polyline", { points: "15,9 18,9 18,11", key: "1pm9c0" }],
  ["path", { d: "M6.5 5C9 5 11 7 11 9.5V17a2 2 0 0 1-2 2", key: "15i455" }],
  ["line", { x1: "6", x2: "7", y1: "10", y2: "10", key: "1e2scm" }]
]);
const zm = n("mails", [
  ["rect", { width: "16", height: "13", x: "6", y: "4", rx: "2", key: "1drq3f" }],
  ["path", { d: "m22 7-7.1 3.78c-.57.3-1.23.3-1.8 0L6 7", key: "xn252p" }],
  ["path", { d: "M2 8v11c0 1.1.9 2 2 2h14", key: "n13cji" }]
]);
const Pm = n("map-pin-check-inside", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }]
]);
const _m = n("map-pin-check", [
  [
    "path",
    {
      d: "M19.43 12.935c.357-.967.57-1.955.57-2.935a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32.197 32.197 0 0 0 .813-.728",
      key: "1dq61d"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m16 18 2 2 4-4", key: "1mkfmb" }]
]);
const jm = n("map-pin-house", [
  [
    "path",
    {
      d: "M15 22a1 1 0 0 1-1-1v-4a1 1 0 0 1 .445-.832l3-2a1 1 0 0 1 1.11 0l3 2A1 1 0 0 1 22 17v4a1 1 0 0 1-1 1z",
      key: "1p1rcz"
    }
  ],
  [
    "path",
    {
      d: "M18 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 .601.2",
      key: "mcbcs9"
    }
  ],
  ["path", { d: "M18 22v-3", key: "1t1ugv" }],
  ["circle", { cx: "10", cy: "10", r: "3", key: "1ns7v1" }]
]);
const Hm = n("map-pin-minus-inside", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const Vm = n("map-pin-minus", [
  [
    "path",
    {
      d: "M18.977 14C19.6 12.701 20 11.343 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "11uxia"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }]
]);
const Bm = n("map-pin-off", [
  ["path", { d: "M12.75 7.09a3 3 0 0 1 2.16 2.16", key: "1d4wjd" }],
  [
    "path",
    {
      d: "M17.072 17.072c-1.634 2.17-3.527 3.912-4.471 4.727a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 1.432-4.568",
      key: "12yil7"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M8.475 2.818A8 8 0 0 1 20 10c0 1.183-.31 2.377-.81 3.533", key: "lhrkcz" }],
  ["path", { d: "M9.13 9.13a3 3 0 0 0 3.74 3.74", key: "13wojd" }]
]);
const Dm = n("map-pin-plus-inside", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const Tm = n("map-pin-plus", [
  [
    "path",
    {
      d: "M19.914 11.105A7.298 7.298 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 32 32 0 0 0 .824-.738",
      key: "fcdtly"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M16 18h6", key: "987eiv" }],
  ["path", { d: "M19 15v6", key: "10aioa" }]
]);
const $m = n("map-pin-x-inside", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
const Om = n("map-pin-x", [
  [
    "path",
    {
      d: "M19.752 11.901A7.78 7.78 0 0 0 20 10a8 8 0 0 0-16 0c0 4.993 5.539 10.193 7.399 11.799a1 1 0 0 0 1.202 0 19 19 0 0 0 .09-.077",
      key: "y0ewhp"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "m21.5 15.5-5 5", key: "11iqnx" }],
  ["path", { d: "m21.5 20.5-5-5", key: "1bylgx" }]
]);
const Rm = n("map-pin", [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
]);
const Fm = n("map-pinned", [
  [
    "path",
    {
      d: "M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0",
      key: "11u0oz"
    }
  ],
  ["circle", { cx: "12", cy: "8", r: "2", key: "1822b1" }],
  [
    "path",
    {
      d: "M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712",
      key: "q8zwxj"
    }
  ]
]);
const Em = n("map-plus", [
  [
    "path",
    {
      d: "m11 19-1.106-.552a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0l4.212 2.106a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619V12",
      key: "svfegj"
    }
  ],
  ["path", { d: "M15 5.764V12", key: "1ocw4k" }],
  ["path", { d: "M18 15v6", key: "9wciyi" }],
  ["path", { d: "M21 18h-6", key: "139f0c" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
]);
const Um = n("map", [
  [
    "path",
    {
      d: "M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894l4.553-2.277a2 2 0 0 1 1.788 0z",
      key: "169xi5"
    }
  ],
  ["path", { d: "M15 5.764v15", key: "1pn4in" }],
  ["path", { d: "M9 3.236v15", key: "1uimfh" }]
]);
const Nm = n("mars-stroke", [
  ["path", { d: "m14 6 4 4", key: "1q72g9" }],
  ["path", { d: "M17 3h4v4", key: "19p9u1" }],
  ["path", { d: "m21 3-7.75 7.75", key: "1cjbfd" }],
  ["circle", { cx: "9", cy: "15", r: "6", key: "bx5svt" }]
]);
const Wm = n("mars", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m21 3-6.75 6.75", key: "pv0uzu" }],
  ["circle", { cx: "10", cy: "14", r: "6", key: "1qwbdc" }]
]);
const Gm = n("martini", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M12 11v11", key: "ur9y6a" }],
  ["path", { d: "m19 3-7 8-7-8Z", key: "1sgpiw" }]
]);
const Zm = n("maximize-2", [
  ["polyline", { points: "15 3 21 3 21 9", key: "mznyad" }],
  ["polyline", { points: "9 21 3 21 3 15", key: "1avn1i" }],
  ["line", { x1: "21", x2: "14", y1: "3", y2: "10", key: "ota7mn" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
const Ym = n("maximize", [
  ["path", { d: "M8 3H5a2 2 0 0 0-2 2v3", key: "1dcmit" }],
  ["path", { d: "M21 8V5a2 2 0 0 0-2-2h-3", key: "1e4gt3" }],
  ["path", { d: "M3 16v3a2 2 0 0 0 2 2h3", key: "wsl5sc" }],
  ["path", { d: "M16 21h3a2 2 0 0 0 2-2v-3", key: "18trek" }]
]);
const Km = n("medal", [
  [
    "path",
    {
      d: "M7.21 15 2.66 7.14a2 2 0 0 1 .13-2.2L4.4 2.8A2 2 0 0 1 6 2h12a2 2 0 0 1 1.6.8l1.6 2.14a2 2 0 0 1 .14 2.2L16.79 15",
      key: "143lza"
    }
  ],
  ["path", { d: "M11 12 5.12 2.2", key: "qhuxz6" }],
  ["path", { d: "m13 12 5.88-9.8", key: "hbye0f" }],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }],
  ["path", { d: "M12 18v-2h-.5", key: "fawc4q" }]
]);
const Xm = n("megaphone-off", [
  ["path", { d: "M9.26 9.26 3 11v3l14.14 3.14", key: "3429n" }],
  ["path", { d: "M21 15.34V6l-7.31 2.03", key: "4o1dh8" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const Qm = n("megaphone", [
  ["path", { d: "m3 11 18-5v12L3 14v-3z", key: "n962bs" }],
  ["path", { d: "M11.6 16.8a3 3 0 1 1-5.8-1.6", key: "1yl0tm" }]
]);
const Jm = n("meh", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "8", x2: "16", y1: "15", y2: "15", key: "1xb1d9" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
const e3 = n("memory-stick", [
  ["path", { d: "M6 19v-3", key: "1nvgqn" }],
  ["path", { d: "M10 19v-3", key: "iu8nkm" }],
  ["path", { d: "M14 19v-3", key: "kcehxu" }],
  ["path", { d: "M18 19v-3", key: "1vh91z" }],
  ["path", { d: "M8 11V9", key: "63erz4" }],
  ["path", { d: "M16 11V9", key: "fru6f3" }],
  ["path", { d: "M12 11V9", key: "ha00sb" }],
  ["path", { d: "M2 15h20", key: "16ne18" }],
  [
    "path",
    {
      d: "M2 7a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v1.1a2 2 0 0 0 0 3.837V17a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5.1a2 2 0 0 0 0-3.837Z",
      key: "lhddv3"
    }
  ]
]);
const t3 = n("menu", [
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }],
  ["line", { x1: "4", x2: "20", y1: "6", y2: "6", key: "1owob3" }],
  ["line", { x1: "4", x2: "20", y1: "18", y2: "18", key: "yk5zj1" }]
]);
const a3 = n("merge", [
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M12 2v10.3a4 4 0 0 1-1.172 2.872L4 22", key: "1hyw0i" }],
  ["path", { d: "m20 22-5-5", key: "1m27yz" }]
]);
const n3 = n("message-circle-code", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22z", key: "k85zhp" }]
]);
const o3 = n("message-circle-dashed", [
  ["path", { d: "M13.5 3.1c-.5 0-1-.1-1.5-.1s-1 .1-1.5.1", key: "16ll65" }],
  ["path", { d: "M19.3 6.8a10.45 10.45 0 0 0-2.1-2.1", key: "1nq77a" }],
  ["path", { d: "M20.9 13.5c.1-.5.1-1 .1-1.5s-.1-1-.1-1.5", key: "1sf7wn" }],
  ["path", { d: "M17.2 19.3a10.45 10.45 0 0 0 2.1-2.1", key: "x1hs5g" }],
  ["path", { d: "M10.5 20.9c.5.1 1 .1 1.5.1s1-.1 1.5-.1", key: "19m18z" }],
  ["path", { d: "M3.5 17.5 2 22l4.5-1.5", key: "1f36qi" }],
  ["path", { d: "M3.1 10.5c0 .5-.1 1-.1 1.5s.1 1 .1 1.5", key: "1vz3ju" }],
  ["path", { d: "M6.8 4.7a10.45 10.45 0 0 0-2.1 2.1", key: "19f9do" }]
]);
const r3 = n("message-circle-heart", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  [
    "path",
    {
      d: "M15.8 9.2a2.5 2.5 0 0 0-3.5 0l-.3.4-.35-.3a2.42 2.42 0 1 0-3.2 3.6l3.6 3.5 3.6-3.5c1.2-1.2 1.1-2.7.2-3.7",
      key: "43lnbm"
    }
  ]
]);
const l3 = n("message-circle-more", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
const i3 = n("message-circle-off", [
  ["path", { d: "M20.5 14.9A9 9 0 0 0 9.1 3.5", key: "1iebmn" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M5.6 5.6C3 8.3 2.2 12.5 4 16l-2 6 6-2c3.4 1.8 7.6 1.1 10.3-1.7", key: "1ov8ce" }]
]);
const c3 = n("message-circle-plus", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
const d3 = n("message-circle-question", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const s3 = n("message-circle-reply", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }],
  ["path", { d: "M7 12h7a2 2 0 0 1 2 2v1", key: "1gheu4" }]
]);
const u3 = n("message-circle-warning", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
const h3 = n("message-circle-x", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
const p3 = n("message-circle", [
  ["path", { d: "M7.9 20A9 9 0 1 0 4 16.1L2 22Z", key: "vv11sd" }]
]);
const y3 = n("message-square-code", [
  ["path", { d: "M10 7.5 8 10l2 2.5", key: "xb17xw" }],
  ["path", { d: "m14 7.5 2 2.5-2 2.5", key: "5rap1v" }],
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
const k3 = n("message-square-dashed", [
  ["path", { d: "M10 17H7l-4 4v-7", key: "1r71xu" }],
  ["path", { d: "M14 17h1", key: "nufu4t" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 14v1a2 2 0 0 1-2 2", key: "29akq3" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }]
]);
const m3 = n("message-square-diff", [
  ["path", { d: "m5 19-2 2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2", key: "1xuzuj" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 17h6", key: "r8uit2" }]
]);
const f3 = n("message-square-dot", [
  ["path", { d: "M11.7 3H5a2 2 0 0 0-2 2v16l4-4h12a2 2 0 0 0 2-2v-2.7", key: "uodpkb" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
]);
const v3 = n("message-square-heart", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  [
    "path",
    {
      d: "M14.8 7.5a1.84 1.84 0 0 0-2.6 0l-.2.3-.3-.3a1.84 1.84 0 1 0-2.4 2.8L12 13l2.7-2.7c.9-.9.8-2.1.1-2.8",
      key: "1blaws"
    }
  ]
]);
const g3 = n("message-square-lock", [
  ["path", { d: "M19 15v-2a2 2 0 1 0-4 0v2", key: "h3d1vz" }],
  ["path", { d: "M9 17H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v3.5", key: "xsnnhn" }],
  ["rect", { x: "13", y: "15", width: "8", height: "5", rx: "1", key: "1ccwuk" }]
]);
const M3 = n("message-square-more", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 10h.01", key: "19clt8" }],
  ["path", { d: "M12 10h.01", key: "1nrarc" }],
  ["path", { d: "M16 10h.01", key: "1m94wz" }]
]);
const b3 = n("message-square-off", [
  ["path", { d: "M21 15V5a2 2 0 0 0-2-2H9", key: "43el77" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M3.6 3.6c-.4.3-.6.8-.6 1.4v16l4-4h10", key: "pwpm4a" }]
]);
const x3 = n("message-square-plus", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v6", key: "lw1j43" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const w3 = n("message-square-quote", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M8 12a2 2 0 0 0 2-2V8H8", key: "1jfesj" }],
  ["path", { d: "M14 12a2 2 0 0 0 2-2V8h-2", key: "1dq9mh" }]
]);
const L3 = n("message-square-reply", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m10 7-3 3 3 3", key: "1eugdv" }],
  ["path", { d: "M17 13v-1a2 2 0 0 0-2-2H7", key: "ernfh3" }]
]);
const S3 = n("message-square-share", [
  ["path", { d: "M21 12v3a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h7", key: "tqtdkg" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "m16 8 5-5", key: "15mbrl" }]
]);
const I3 = n("message-square-text", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M13 8H7", key: "14i4kc" }],
  ["path", { d: "M17 12H7", key: "16if0g" }]
]);
const C3 = n("message-square-warning", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "M12 7v2", key: "stiyo7" }],
  ["path", { d: "M12 13h.01", key: "y0uutt" }]
]);
const A3 = n("message-square-x", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }],
  ["path", { d: "m14.5 7.5-5 5", key: "3lb6iw" }],
  ["path", { d: "m9.5 7.5 5 5", key: "ko136h" }]
]);
const q3 = n("message-square", [
  ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z", key: "1lielz" }]
]);
const z3 = n("messages-square", [
  ["path", { d: "M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z", key: "p1xzt8" }],
  ["path", { d: "M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1", key: "1cx29u" }]
]);
const P3 = n("mic-off", [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
const tn = n("mic-vocal", [
  [
    "path",
    {
      d: "m11 7.601-5.994 8.19a1 1 0 0 0 .1 1.298l.817.818a1 1 0 0 0 1.314.087L15.09 12",
      key: "80a601"
    }
  ],
  [
    "path",
    {
      d: "M16.5 21.174C15.5 20.5 14.372 20 13 20c-2.058 0-3.928 2.356-6 2-2.072-.356-2.775-3.369-1.5-4.5",
      key: "j0ngtp"
    }
  ],
  ["circle", { cx: "16", cy: "7", r: "5", key: "d08jfb" }]
]);
const _3 = n("mic", [
  ["path", { d: "M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z", key: "131961" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
]);
const j3 = n("microchip", [
  ["path", { d: "M18 12h2", key: "quuxs7" }],
  ["path", { d: "M18 16h2", key: "zsn3lv" }],
  ["path", { d: "M18 20h2", key: "9x5y9y" }],
  ["path", { d: "M18 4h2", key: "1luxfb" }],
  ["path", { d: "M18 8h2", key: "nxqzg" }],
  ["path", { d: "M4 12h2", key: "1ltxp0" }],
  ["path", { d: "M4 16h2", key: "8a5zha" }],
  ["path", { d: "M4 20h2", key: "27dk57" }],
  ["path", { d: "M4 4h2", key: "10groj" }],
  ["path", { d: "M4 8h2", key: "18vq6w" }],
  [
    "path",
    {
      d: "M8 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-1.5c-.276 0-.494.227-.562.495a2 2 0 0 1-3.876 0C9.994 2.227 9.776 2 9.5 2z",
      key: "1681fp"
    }
  ]
]);
const H3 = n("microscope", [
  ["path", { d: "M6 18h8", key: "1borvv" }],
  ["path", { d: "M3 22h18", key: "8prr45" }],
  ["path", { d: "M14 22a7 7 0 1 0 0-14h-1", key: "1jwaiy" }],
  ["path", { d: "M9 14h2", key: "197e7h" }],
  ["path", { d: "M9 12a2 2 0 0 1-2-2V6h6v4a2 2 0 0 1-2 2Z", key: "1bmzmy" }],
  ["path", { d: "M12 6V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v3", key: "1drr47" }]
]);
const V3 = n("microwave", [
  ["rect", { width: "20", height: "15", x: "2", y: "4", rx: "2", key: "2no95f" }],
  ["rect", { width: "8", height: "7", x: "6", y: "8", rx: "1", key: "zh9wx" }],
  ["path", { d: "M18 8v7", key: "o5zi4n" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["path", { d: "M18 19v2", key: "1dawf0" }]
]);
const B3 = n("milestone", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M4 6a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h13a2 2 0 0 0 1.152-.365l3.424-2.317a1 1 0 0 0 0-1.635l-3.424-2.318A2 2 0 0 0 17 6z",
      key: "1btarq"
    }
  ]
]);
const D3 = n("milk-off", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v1.343M15 2v2.789a4 4 0 0 0 .672 2.219l.656.984a4 4 0 0 1 .672 2.22v1.131M7.8 7.8l-.128.192A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-3",
      key: "y0ejgx"
    }
  ],
  ["path", { d: "M7 15a6.47 6.47 0 0 1 5 0 6.472 6.472 0 0 0 3.435.435", key: "iaxqsy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const T3 = n("milk", [
  ["path", { d: "M8 2h8", key: "1ssgc1" }],
  [
    "path",
    {
      d: "M9 2v2.789a4 4 0 0 1-.672 2.219l-.656.984A4 4 0 0 0 7 10.212V20a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-9.789a4 4 0 0 0-.672-2.219l-.656-.984A4 4 0 0 1 15 4.788V2",
      key: "qtp12x"
    }
  ],
  ["path", { d: "M7 15a6.472 6.472 0 0 1 5 0 6.47 6.47 0 0 0 5 0", key: "ygeh44" }]
]);
const $3 = n("minimize-2", [
  ["polyline", { points: "4 14 10 14 10 20", key: "11kfnr" }],
  ["polyline", { points: "20 10 14 10 14 4", key: "rlmsce" }],
  ["line", { x1: "14", x2: "21", y1: "10", y2: "3", key: "o5lafz" }],
  ["line", { x1: "3", x2: "10", y1: "21", y2: "14", key: "1atl0r" }]
]);
const O3 = n("minimize", [
  ["path", { d: "M8 3v3a2 2 0 0 1-2 2H3", key: "hohbtr" }],
  ["path", { d: "M21 8h-3a2 2 0 0 1-2-2V3", key: "5jw1f3" }],
  ["path", { d: "M3 16h3a2 2 0 0 1 2 2v3", key: "198tvr" }],
  ["path", { d: "M16 21v-3a2 2 0 0 1 2-2h3", key: "ph8mxp" }]
]);
const R3 = n("minus", [["path", { d: "M5 12h14", key: "1ays0h" }]]);
const F3 = n("monitor-check", [
  ["path", { d: "m9 10 2 2 4-4", key: "1gnqz4" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const E3 = n("monitor-cog", [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m15.2 4.9-.9-.4", key: "12wd2u" }],
  ["path", { d: "m15.2 7.1-.9.4", key: "1r2vl7" }],
  ["path", { d: "m16.9 3.2-.4-.9", key: "3zbo91" }],
  ["path", { d: "m16.9 8.8-.4.9", key: "1qr2dn" }],
  ["path", { d: "m19.5 2.3-.4.9", key: "1rjrkq" }],
  ["path", { d: "m19.5 9.7-.4-.9", key: "heryx5" }],
  ["path", { d: "m21.7 4.5-.9.4", key: "17fqt1" }],
  ["path", { d: "m21.7 7.5-.9-.4", key: "14zyni" }],
  ["path", { d: "M22 13v2a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h7", key: "1tnzv8" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }]
]);
const U3 = n("monitor-dot", [
  ["circle", { cx: "19", cy: "6", r: "3", key: "108a5v" }],
  ["path", { d: "M22 12v3a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9", key: "1fet9y" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const N3 = n("monitor-down", [
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["path", { d: "m15 10-3 3-3-3", key: "lzhmyn" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const W3 = n("monitor-off", [
  ["path", { d: "M17 17H4a2 2 0 0 1-2-2V5c0-1.5 1-2 1-2", key: "k0q8oc" }],
  ["path", { d: "M22 15V5a2 2 0 0 0-2-2H9", key: "cp1ac0" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const G3 = n("monitor-pause", [
  ["path", { d: "M10 13V7", key: "1u13u9" }],
  ["path", { d: "M14 13V7", key: "1vj9om" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const Z3 = n("monitor-play", [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }]
]);
const Y3 = n("monitor-smartphone", [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
]);
const K3 = n("monitor-speaker", [
  ["path", { d: "M5.5 20H8", key: "1k40s5" }],
  ["path", { d: "M17 9h.01", key: "1j24nn" }],
  ["rect", { width: "10", height: "16", x: "12", y: "4", rx: "2", key: "ixliua" }],
  ["path", { d: "M8 6H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h4", key: "1mp6e1" }],
  ["circle", { cx: "17", cy: "15", r: "1", key: "tqvash" }]
]);
const X3 = n("monitor-stop", [
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["rect", { x: "2", y: "3", width: "20", height: "14", rx: "2", key: "x3v2xh" }],
  ["rect", { x: "9", y: "7", width: "6", height: "6", rx: "1", key: "5m2oou" }]
]);
const Q3 = n("monitor-up", [
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }],
  ["path", { d: "M12 13V7", key: "h0r20n" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const J3 = n("monitor-x", [
  ["path", { d: "m14.5 12.5-5-5", key: "1jahn5" }],
  ["path", { d: "m9.5 12.5 5-5", key: "1k2t7b" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }]
]);
const ef = n("monitor", [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
]);
const tf = n("moon-star", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9", key: "4ay0iu" }],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }]
]);
const af = n("moon", [
  ["path", { d: "M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z", key: "a7tn18" }]
]);
const nf = n("mountain-snow", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }],
  [
    "path",
    { d: "M4.14 15.08c2.62-1.57 5.24-1.43 7.86.42 2.74 1.94 5.49 2 8.23.19", key: "1pvmmp" }
  ]
]);
const of = n("mountain", [
  ["path", { d: "m8 3 4 8 5-5 5 15H2L8 3z", key: "otkl63" }]
]);
const rf = n("mouse-off", [
  ["path", { d: "M12 6v.343", key: "1gyhex" }],
  ["path", { d: "M18.218 18.218A7 7 0 0 1 5 15V9a7 7 0 0 1 .782-3.218", key: "ukzz01" }],
  ["path", { d: "M19 13.343V9A7 7 0 0 0 8.56 2.902", key: "104jy9" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
const lf = n("mouse-pointer-2", [
  [
    "path",
    {
      d: "M4.037 4.688a.495.495 0 0 1 .651-.651l16 6.5a.5.5 0 0 1-.063.947l-6.124 1.58a2 2 0 0 0-1.438 1.435l-1.579 6.126a.5.5 0 0 1-.947.063z",
      key: "edeuup"
    }
  ]
]);
const cf = n("mouse-pointer-ban", [
  [
    "path",
    {
      d: "M2.034 2.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.944L8.204 7.545a1 1 0 0 0-.66.66l-1.066 3.443a.5.5 0 0 1-.944.033z",
      key: "11pp1i"
    }
  ],
  ["circle", { cx: "16", cy: "16", r: "6", key: "qoo3c4" }],
  ["path", { d: "m11.8 11.8 8.4 8.4", key: "oogvdj" }]
]);
const df = n("mouse-pointer-click", [
  ["path", { d: "M14 4.1 12 6", key: "ita8i4" }],
  ["path", { d: "m5.1 8-2.9-.8", key: "1go3kf" }],
  ["path", { d: "m6 12-1.9 2", key: "mnht97" }],
  ["path", { d: "M7.2 2.2 8 5.1", key: "1cfko1" }],
  [
    "path",
    {
      d: "M9.037 9.69a.498.498 0 0 1 .653-.653l11 4.5a.5.5 0 0 1-.074.949l-4.349 1.041a1 1 0 0 0-.74.739l-1.04 4.35a.5.5 0 0 1-.95.074z",
      key: "s0h3yz"
    }
  ]
]);
const sf = n("mouse-pointer", [
  ["path", { d: "M12.586 12.586 19 19", key: "ea5xo7" }],
  [
    "path",
    {
      d: "M3.688 3.037a.497.497 0 0 0-.651.651l6.5 15.999a.501.501 0 0 0 .947-.062l1.569-6.083a2 2 0 0 1 1.448-1.479l6.124-1.579a.5.5 0 0 0 .063-.947z",
      key: "277e5u"
    }
  ]
]);
const uf = n("mouse", [
  ["rect", { x: "5", y: "2", width: "14", height: "20", rx: "7", key: "11ol66" }],
  ["path", { d: "M12 6v4", key: "16clxf" }]
]);
const an = n("move-3d", [
  ["path", { d: "M5 3v16h16", key: "1mqmf9" }],
  ["path", { d: "m5 19 6-6", key: "jh6hbb" }],
  ["path", { d: "m2 6 3-3 3 3", key: "tkyvxa" }],
  ["path", { d: "m18 16 3 3-3 3", key: "1d4glt" }]
]);
const hf = n("move-diagonal-2", [
  ["path", { d: "M19 13v6h-6", key: "1hxl6d" }],
  ["path", { d: "M5 11V5h6", key: "12e2xe" }],
  ["path", { d: "m5 5 14 14", key: "11anup" }]
]);
const pf = n("move-diagonal", [
  ["path", { d: "M11 19H5v-6", key: "8awifj" }],
  ["path", { d: "M13 5h6v6", key: "7voy1q" }],
  ["path", { d: "M19 5 5 19", key: "wwaj1z" }]
]);
const yf = n("move-down-left", [
  ["path", { d: "M11 19H5V13", key: "1akmht" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
const kf = n("move-down-right", [
  ["path", { d: "M19 13V19H13", key: "10vkzq" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
const mf = n("move-down", [
  ["path", { d: "M8 18L12 22L16 18", key: "cskvfv" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
const ff = n("move-horizontal", [
  ["path", { d: "m18 8 4 4-4 4", key: "1ak13k" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m6 8-4 4 4 4", key: "15zrgr" }]
]);
const vf = n("move-left", [
  ["path", { d: "M6 8L2 12L6 16", key: "kyvwex" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
const gf = n("move-right", [
  ["path", { d: "M18 8L22 12L18 16", key: "1r0oui" }],
  ["path", { d: "M2 12H22", key: "1m8cig" }]
]);
const Mf = n("move-up-left", [
  ["path", { d: "M5 11V5H11", key: "3q78g9" }],
  ["path", { d: "M5 5L19 19", key: "5zm2fv" }]
]);
const bf = n("move-up-right", [
  ["path", { d: "M13 5H19V11", key: "1n1gyv" }],
  ["path", { d: "M19 5L5 19", key: "72u4yj" }]
]);
const xf = n("move-up", [
  ["path", { d: "M8 6L12 2L16 6", key: "1yvkyx" }],
  ["path", { d: "M12 2V22", key: "r89rzk" }]
]);
const wf = n("move-vertical", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m8 18 4 4 4-4", key: "bh5tu3" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }]
]);
const Lf = n("music-2", [
  ["circle", { cx: "8", cy: "18", r: "4", key: "1fc0mg" }],
  ["path", { d: "M12 18V2l7 4", key: "g04rme" }]
]);
const Sf = n("move", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m19 9 3 3-3 3", key: "1mg7y2" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }],
  ["path", { d: "m9 5 3-3 3 3", key: "l8vdw6" }]
]);
const If = n("music-3", [
  ["circle", { cx: "12", cy: "18", r: "4", key: "m3r9ws" }],
  ["path", { d: "M16 18V2", key: "40x2m5" }]
]);
const Cf = n("music-4", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["path", { d: "m9 9 12-2", key: "1e64n2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
const Af = n("music", [
  ["path", { d: "M9 18V5l12-2v13", key: "1jmyc2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["circle", { cx: "18", cy: "16", r: "3", key: "1hluhg" }]
]);
const qf = n("navigation-2-off", [
  ["path", { d: "M9.31 9.31 5 21l7-4 7 4-1.17-3.17", key: "qoq2o2" }],
  ["path", { d: "M14.53 8.88 12 2l-1.17 3.17", key: "k3sjzy" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const zf = n("navigation-2", [
  ["polygon", { points: "12 2 19 21 12 17 5 21 12 2", key: "x8c0qg" }]
]);
const Pf = n("navigation-off", [
  ["path", { d: "M8.43 8.43 3 11l8 2 2 8 2.57-5.43", key: "1vdtb7" }],
  ["path", { d: "M17.39 11.73 22 2l-9.73 4.61", key: "tya3r6" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const _f = n("navigation", [
  ["polygon", { points: "3 11 22 2 13 21 11 13 3 11", key: "1ltx0t" }]
]);
const jf = n("network", [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
]);
const Hf = n("newspaper", [
  ["path", { d: "M15 18h-5", key: "95g1m2" }],
  ["path", { d: "M18 14h-8", key: "sponae" }],
  [
    "path",
    {
      d: "M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2",
      key: "39pd36"
    }
  ],
  ["rect", { width: "8", height: "4", x: "10", y: "6", rx: "1", key: "aywv1n" }]
]);
const Vf = n("nfc", [
  ["path", { d: "M6 8.32a7.43 7.43 0 0 1 0 7.36", key: "9iaqei" }],
  ["path", { d: "M9.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "1yha7l" }],
  ["path", { d: "M12.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "4iu2gk" }],
  ["path", { d: "M16.37 2a20.16 20.16 0 0 1 0 20", key: "sap9u2" }]
]);
const Bf = n("non-binary", [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "m9 4 6 4", key: "t8piew" }],
  ["path", { d: "m9 8 6-4", key: "sndyih" }],
  ["circle", { cx: "12", cy: "17", r: "5", key: "qbz8iq" }]
]);
const Df = n("notebook-pen", [
  ["path", { d: "M13.4 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-7.4", key: "re6nr2" }],
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  [
    "path",
    {
      d: "M21.378 5.626a1 1 0 1 0-3.004-3.004l-5.01 5.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "pqwjuv"
    }
  ]
]);
const Tf = n("notebook-tabs", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M15 2v20", key: "dcj49h" }],
  ["path", { d: "M15 7h5", key: "1xj5lc" }],
  ["path", { d: "M15 12h5", key: "w5shd9" }],
  ["path", { d: "M15 17h5", key: "1qaofu" }]
]);
const $f = n("notebook-text", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M9.5 8h5", key: "11mslq" }],
  ["path", { d: "M9.5 12H16", key: "ktog6x" }],
  ["path", { d: "M9.5 16H14", key: "p1seyn" }]
]);
const Of = n("notebook", [
  ["path", { d: "M2 6h4", key: "aawbzj" }],
  ["path", { d: "M2 10h4", key: "l0bgd4" }],
  ["path", { d: "M2 14h4", key: "1gsvsf" }],
  ["path", { d: "M2 18h4", key: "1bu2t1" }],
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M16 2v20", key: "rotuqe" }]
]);
const Rf = n("notepad-text-dashed", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["path", { d: "M16 4h2a2 2 0 0 1 2 2v2", key: "j91f56" }],
  ["path", { d: "M20 12v2", key: "w8o0tu" }],
  ["path", { d: "M20 18v2a2 2 0 0 1-2 2h-1", key: "1c9ggx" }],
  ["path", { d: "M13 22h-2", key: "191ugt" }],
  ["path", { d: "M7 22H6a2 2 0 0 1-2-2v-2", key: "1rt9px" }],
  ["path", { d: "M4 14v-2", key: "1v0sqh" }],
  ["path", { d: "M4 8V6a2 2 0 0 1 2-2h2", key: "1mwabg" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
const Ff = n("notepad-text", [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "16", height: "18", x: "4", y: "4", rx: "2", key: "1u9h20" }],
  ["path", { d: "M8 10h6", key: "3oa6kw" }],
  ["path", { d: "M8 14h8", key: "1fgep2" }],
  ["path", { d: "M8 18h5", key: "17enja" }]
]);
const Ef = n("nut-off", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592a7.01 7.01 0 0 0 4.125-2.939",
      key: "1xcvy9"
    }
  ],
  ["path", { d: "M19 10v3.343", key: "163tfc" }],
  [
    "path",
    {
      d: "M12 12c-1.349-.573-1.905-1.005-2.5-2-.546.902-1.048 1.353-2.5 2-1.018-.644-1.46-1.08-2-2-1.028.71-1.69.918-3 1 1.081-1.048 1.757-2.03 2-3 .194-.776.84-1.551 1.79-2.21m11.654 5.997c.887-.457 1.28-.891 1.556-1.787 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4-.74 0-1.461.068-2.15.192",
      key: "17914v"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const Uf = n("nut", [
  ["path", { d: "M12 4V2", key: "1k5q1u" }],
  [
    "path",
    {
      d: "M5 10v4a7.004 7.004 0 0 0 5.277 6.787c.412.104.802.292 1.102.592L12 22l.621-.621c.3-.3.69-.488 1.102-.592A7.003 7.003 0 0 0 19 14v-4",
      key: "1tgyif"
    }
  ],
  [
    "path",
    {
      d: "M12 4C8 4 4.5 6 4 8c-.243.97-.919 1.952-2 3 1.31-.082 1.972-.29 3-1 .54.92.982 1.356 2 2 1.452-.647 1.954-1.098 2.5-2 .595.995 1.151 1.427 2.5 2 1.31-.621 1.862-1.058 2.5-2 .629.977 1.162 1.423 2.5 2 1.209-.548 1.68-.967 2-2 1.032.916 1.683 1.157 3 1-1.297-1.036-1.758-2.03-2-3-.5-2-4-4-8-4Z",
      key: "tnsqj"
    }
  ]
]);
const nn = n("octagon-alert", [
  ["path", { d: "M12 16h.01", key: "1drbdi" }],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  [
    "path",
    {
      d: "M15.312 2a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586l-4.688-4.688A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2z",
      key: "1fd625"
    }
  ]
]);
const Nf = n("octagon-minus", [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const on = n("octagon-pause", [
  ["path", { d: "M10 15V9", key: "1lckn7" }],
  ["path", { d: "M14 15V9", key: "1muqhk" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
]);
const rn = n("octagon-x", [
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
const Wf = n("octagon", [
  [
    "path",
    {
      d: "M2.586 16.726A2 2 0 0 1 2 15.312V8.688a2 2 0 0 1 .586-1.414l4.688-4.688A2 2 0 0 1 8.688 2h6.624a2 2 0 0 1 1.414.586l4.688 4.688A2 2 0 0 1 22 8.688v6.624a2 2 0 0 1-.586 1.414l-4.688 4.688a2 2 0 0 1-1.414.586H8.688a2 2 0 0 1-1.414-.586z",
      key: "2d38gg"
    }
  ]
]);
const Gf = n("omega", [
  [
    "path",
    {
      d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
      key: "1x94xo"
    }
  ]
]);
const Zf = n("option", [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
]);
const Yf = n("orbit", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M10.4 21.9a10 10 0 0 0 9.941-15.416", key: "eohfx2" }],
  ["path", { d: "M13.5 2.1a10 10 0 0 0-9.841 15.416", key: "19pvbm" }]
]);
const Kf = n("origami", [
  ["path", { d: "M12 12V4a1 1 0 0 1 1-1h6.297a1 1 0 0 1 .651 1.759l-4.696 4.025", key: "1bx4vc" }],
  [
    "path",
    {
      d: "m12 21-7.414-7.414A2 2 0 0 1 4 12.172V6.415a1.002 1.002 0 0 1 1.707-.707L20 20.009",
      key: "1h3km6"
    }
  ],
  [
    "path",
    {
      d: "m12.214 3.381 8.414 14.966a1 1 0 0 1-.167 1.199l-1.168 1.163a1 1 0 0 1-.706.291H6.351a1 1 0 0 1-.625-.219L3.25 18.8a1 1 0 0 1 .631-1.781l4.165.027",
      key: "1hj4wg"
    }
  ]
]);
const Xf = n("package-2", [
  ["path", { d: "M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z", key: "1ront0" }],
  ["path", { d: "m3 9 2.45-4.9A2 2 0 0 1 7.24 3h9.52a2 2 0 0 1 1.8 1.1L21 9", key: "19h2x1" }],
  ["path", { d: "M12 3v6", key: "1holv5" }]
]);
const Qf = n("package-check", [
  ["path", { d: "m16 16 2 2 4-4", key: "gfu2re" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
const Jf = n("package-minus", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
const ev = n("package-open", [
  ["path", { d: "M12 22v-9", key: "x3hkom" }],
  [
    "path",
    {
      d: "M15.17 2.21a1.67 1.67 0 0 1 1.63 0L21 4.57a1.93 1.93 0 0 1 0 3.36L8.82 14.79a1.655 1.655 0 0 1-1.64 0L3 12.43a1.93 1.93 0 0 1 0-3.36z",
      key: "2ntwy6"
    }
  ],
  [
    "path",
    {
      d: "M20 13v3.87a2.06 2.06 0 0 1-1.11 1.83l-6 3.08a1.93 1.93 0 0 1-1.78 0l-6-3.08A2.06 2.06 0 0 1 4 16.87V13",
      key: "1pmm1c"
    }
  ],
  [
    "path",
    {
      d: "M21 12.43a1.93 1.93 0 0 0 0-3.36L8.83 2.2a1.64 1.64 0 0 0-1.63 0L3 4.57a1.93 1.93 0 0 0 0 3.36l12.18 6.86a1.636 1.636 0 0 0 1.63 0z",
      key: "12ttoo"
    }
  ]
]);
const tv = n("package-plus", [
  ["path", { d: "M16 16h6", key: "100bgy" }],
  ["path", { d: "M19 13v6", key: "85cyf1" }],
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }]
]);
const av = n("package-search", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["circle", { cx: "18.5", cy: "15.5", r: "2.5", key: "b5zd12" }],
  ["path", { d: "M20.27 17.27 22 19", key: "1l4muz" }]
]);
const nv = n("package-x", [
  [
    "path",
    {
      d: "M21 10V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l2-1.14",
      key: "e7tb2h"
    }
  ],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["line", { x1: "12", x2: "12", y1: "22", y2: "12", key: "a4e8g8" }],
  ["path", { d: "m17 13 5 5m-5 0 5-5", key: "im3w4b" }]
]);
const ov = n("package", [
  [
    "path",
    {
      d: "M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z",
      key: "1a0edw"
    }
  ],
  ["path", { d: "M12 22V12", key: "d0xqtd" }],
  ["polyline", { points: "3.29 7 12 12 20.71 7", key: "ousv84" }],
  ["path", { d: "m7.5 4.27 9 5.15", key: "1c824w" }]
]);
const rv = n("paint-bucket", [
  [
    "path",
    { d: "m19 11-8-8-8.6 8.6a2 2 0 0 0 0 2.8l5.2 5.2c.8.8 2 .8 2.8 0L19 11Z", key: "irua1i" }
  ],
  ["path", { d: "m5 2 5 5", key: "1lls2c" }],
  ["path", { d: "M2 13h15", key: "1hkzvu" }],
  ["path", { d: "M22 20a2 2 0 1 1-4 0c0-1.6 1.7-2.4 2-4 .3 1.6 2 2.4 2 4Z", key: "xk76lq" }]
]);
const lv = n("paint-roller", [
  ["rect", { width: "16", height: "6", x: "2", y: "2", rx: "2", key: "jcyz7m" }],
  ["path", { d: "M10 16v-2a2 2 0 0 1 2-2h8a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1b9h7c" }],
  ["rect", { width: "4", height: "6", x: "8", y: "16", rx: "1", key: "d6e7yl" }]
]);
const ln = n("paintbrush-vertical", [
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M14 2v4", key: "qmzblu" }],
  ["path", { d: "M17 2a1 1 0 0 1 1 1v9H6V3a1 1 0 0 1 1-1z", key: "ycvu00" }],
  [
    "path",
    {
      d: "M6 12a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 1 1 1v2.9a2 2 0 1 0 4 0V17a1 1 0 0 1 1-1h2a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1",
      key: "iw4wnp"
    }
  ]
]);
const iv = n("paintbrush", [
  ["path", { d: "m14.622 17.897-10.68-2.913", key: "vj2p1u" }],
  [
    "path",
    {
      d: "M18.376 2.622a1 1 0 1 1 3.002 3.002L17.36 9.643a.5.5 0 0 0 0 .707l.944.944a2.41 2.41 0 0 1 0 3.408l-.944.944a.5.5 0 0 1-.707 0L8.354 7.348a.5.5 0 0 1 0-.707l.944-.944a2.41 2.41 0 0 1 3.408 0l.944.944a.5.5 0 0 0 .707 0z",
      key: "18tc5c"
    }
  ],
  [
    "path",
    {
      d: "M9 8c-1.804 2.71-3.97 3.46-6.583 3.948a.507.507 0 0 0-.302.819l7.32 8.883a1 1 0 0 0 1.185.204C12.735 20.405 16 16.792 16 15",
      key: "ytzfxy"
    }
  ]
]);
const cv = n("palette", [
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  [
    "path",
    {
      d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z",
      key: "12rzf8"
    }
  ]
]);
const dv = n("panel-bottom-close", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m15 8-3 3-3-3", key: "1oxy1z" }]
]);
const cn = n("panel-bottom-dashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 15h1", key: "171nev" }],
  ["path", { d: "M19 15h2", key: "1vnucp" }],
  ["path", { d: "M3 15h2", key: "8bym0q" }],
  ["path", { d: "M9 15h1", key: "1tg3ks" }]
]);
const sv = n("panel-bottom-open", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "m9 10 3-3 3 3", key: "11gsxs" }]
]);
const uv = n("panel-bottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
const dn = n("panel-left-close", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
]);
const sn = n("panel-left-dashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 14v1", key: "askpd8" }],
  ["path", { d: "M9 19v2", key: "16tejx" }],
  ["path", { d: "M9 3v2", key: "1noubl" }],
  ["path", { d: "M9 9v1", key: "19ebxg" }]
]);
const un = n("panel-left-open", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m14 9 3 3-3 3", key: "8010ee" }]
]);
const hn = n("panel-left", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
]);
const hv = n("panel-right-close", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
]);
const pn = n("panel-right-dashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 14v1", key: "ilsfch" }],
  ["path", { d: "M15 19v2", key: "1fst2f" }],
  ["path", { d: "M15 3v2", key: "z204g4" }],
  ["path", { d: "M15 9v1", key: "z2a8b1" }]
]);
const pv = n("panel-right-open", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m10 15-3-3 3-3", key: "1pgupc" }]
]);
const yv = n("panel-right", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
const kv = n("panel-top-close", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m9 16 3-3 3 3", key: "1idcnm" }]
]);
const yn = n("panel-top-dashed", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M14 9h1", key: "l0svgy" }],
  ["path", { d: "M19 9h2", key: "te2zfg" }],
  ["path", { d: "M3 9h2", key: "1h4ldw" }],
  ["path", { d: "M9 9h1", key: "15jzuz" }]
]);
const mv = n("panel-top-open", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "m15 14-3 3-3-3", key: "g215vf" }]
]);
const fv = n("panel-top", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }]
]);
const vv = n("panels-left-bottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "M9 15h12", key: "5ijen5" }]
]);
const gv = n("panels-right-bottom", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 15h12", key: "1wkqb3" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
]);
const kn = n("panels-top-left", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M9 21V9", key: "1oto5p" }]
]);
const Mv = n("paperclip", [
  ["path", { d: "M13.234 20.252 21 12.3", key: "1cbrk9" }],
  [
    "path",
    {
      d: "m16 6-8.414 8.586a2 2 0 0 0 0 2.828 2 2 0 0 0 2.828 0l8.414-8.586a4 4 0 0 0 0-5.656 4 4 0 0 0-5.656 0l-8.415 8.585a6 6 0 1 0 8.486 8.486",
      key: "1pkts6"
    }
  ]
]);
const bv = n("parking-meter", [
  ["path", { d: "M11 15h2", key: "199qp6" }],
  ["path", { d: "M12 12v3", key: "158kv8" }],
  ["path", { d: "M12 19v3", key: "npa21l" }],
  [
    "path",
    {
      d: "M15.282 19a1 1 0 0 0 .948-.68l2.37-6.988a7 7 0 1 0-13.2 0l2.37 6.988a1 1 0 0 0 .948.68z",
      key: "1jofit"
    }
  ],
  ["path", { d: "M9 9a3 3 0 1 1 6 0", key: "jdoeu8" }]
]);
const xv = n("parentheses", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }]
]);
const wv = n("party-popper", [
  ["path", { d: "M5.8 11.3 2 22l10.7-3.79", key: "gwxi1d" }],
  ["path", { d: "M4 3h.01", key: "1vcuye" }],
  ["path", { d: "M22 8h.01", key: "1mrtc2" }],
  ["path", { d: "M15 2h.01", key: "1cjtqr" }],
  ["path", { d: "M22 20h.01", key: "1mrys2" }],
  [
    "path",
    {
      d: "m22 2-2.24.75a2.9 2.9 0 0 0-1.96 3.12c.1.86-.57 1.63-1.45 1.63h-.38c-.86 0-1.6.6-1.76 1.44L14 10",
      key: "hbicv8"
    }
  ],
  [
    "path",
    { d: "m22 13-.82-.33c-.86-.34-1.82.2-1.98 1.11c-.11.7-.72 1.22-1.43 1.22H17", key: "1i94pl" }
  ],
  ["path", { d: "m11 2 .33.82c.34.86-.2 1.82-1.11 1.98C9.52 4.9 9 5.52 9 6.23V7", key: "1cofks" }],
  [
    "path",
    {
      d: "M11 13c1.93 1.93 2.83 4.17 2 5-.83.83-3.07-.07-5-2-1.93-1.93-2.83-4.17-2-5 .83-.83 3.07.07 5 2Z",
      key: "4kbmks"
    }
  ]
]);
const Lv = n("pause", [
  ["rect", { x: "14", y: "4", width: "4", height: "16", rx: "1", key: "zuxfzm" }],
  ["rect", { x: "6", y: "4", width: "4", height: "16", rx: "1", key: "1okwgv" }]
]);
const Sv = n("paw-print", [
  ["circle", { cx: "11", cy: "4", r: "2", key: "vol9p0" }],
  ["circle", { cx: "18", cy: "8", r: "2", key: "17gozi" }],
  ["circle", { cx: "20", cy: "16", r: "2", key: "1v9bxh" }],
  [
    "path",
    {
      d: "M9 10a5 5 0 0 1 5 5v3.5a3.5 3.5 0 0 1-6.84 1.045Q6.52 17.48 4.46 16.84A3.5 3.5 0 0 1 5.5 10Z",
      key: "1ydw1z"
    }
  ]
]);
const Iv = n("pc-case", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", key: "1uq1d7" }],
  ["path", { d: "M15 14h.01", key: "1kp3bh" }],
  ["path", { d: "M9 6h6", key: "dgm16u" }],
  ["path", { d: "M9 10h6", key: "9gxzsh" }]
]);
const mn = n("pen-line", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ]
]);
const Cv = n("pen-off", [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const Av = n("pen-tool", [
  [
    "path",
    {
      d: "M15.707 21.293a1 1 0 0 1-1.414 0l-1.586-1.586a1 1 0 0 1 0-1.414l5.586-5.586a1 1 0 0 1 1.414 0l1.586 1.586a1 1 0 0 1 0 1.414z",
      key: "nt11vn"
    }
  ],
  [
    "path",
    {
      d: "m18 13-1.375-6.874a1 1 0 0 0-.746-.776L3.235 2.028a1 1 0 0 0-1.207 1.207L5.35 15.879a1 1 0 0 0 .776.746L13 18",
      key: "15qc1e"
    }
  ],
  ["path", { d: "m2.3 2.3 7.286 7.286", key: "1wuzzi" }],
  ["circle", { cx: "11", cy: "11", r: "2", key: "xmgehs" }]
]);
const fn = n("pen", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
]);
const qv = n("pencil-line", [
  ["path", { d: "M12 20h9", key: "t2du7b" }],
  [
    "path",
    {
      d: "M16.376 3.622a1 1 0 0 1 3.002 3.002L7.368 18.635a2 2 0 0 1-.855.506l-2.872.838a.5.5 0 0 1-.62-.62l.838-2.872a2 2 0 0 1 .506-.854z",
      key: "1ykcvy"
    }
  ],
  ["path", { d: "m15 5 3 3", key: "1w25hb" }]
]);
const zv = n("pencil-off", [
  [
    "path",
    {
      d: "m10 10-6.157 6.162a2 2 0 0 0-.5.833l-1.322 4.36a.5.5 0 0 0 .622.624l4.358-1.323a2 2 0 0 0 .83-.5L14 13.982",
      key: "bjo8r8"
    }
  ],
  ["path", { d: "m12.829 7.172 4.359-4.346a1 1 0 1 1 3.986 3.986l-4.353 4.353", key: "16h5ne" }],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const Pv = n("pencil-ruler", [
  [
    "path",
    { d: "M13 7 8.7 2.7a2.41 2.41 0 0 0-3.4 0L2.7 5.3a2.41 2.41 0 0 0 0 3.4L7 13", key: "orapub" }
  ],
  ["path", { d: "m8 6 2-2", key: "115y1s" }],
  ["path", { d: "m18 16 2-2", key: "ee94s4" }],
  [
    "path",
    {
      d: "m17 11 4.3 4.3c.94.94.94 2.46 0 3.4l-2.6 2.6c-.94.94-2.46.94-3.4 0L11 17",
      key: "cfq27r"
    }
  ],
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
const _v = n("pencil", [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
]);
const jv = n("pentagon", [
  [
    "path",
    {
      d: "M10.83 2.38a2 2 0 0 1 2.34 0l8 5.74a2 2 0 0 1 .73 2.25l-3.04 9.26a2 2 0 0 1-1.9 1.37H7.04a2 2 0 0 1-1.9-1.37L2.1 10.37a2 2 0 0 1 .73-2.25z",
      key: "2hea0t"
    }
  ]
]);
const Hv = n("percent", [
  ["line", { x1: "19", x2: "5", y1: "5", y2: "19", key: "1x9vlm" }],
  ["circle", { cx: "6.5", cy: "6.5", r: "2.5", key: "4mh3h7" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "2.5", key: "1mdrzq" }]
]);
const Vv = n("person-standing", [
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["path", { d: "m9 20 3-6 3 6", key: "se2kox" }],
  ["path", { d: "m6 8 6 2 6-2", key: "4o3us4" }],
  ["path", { d: "M12 10v4", key: "1kjpxc" }]
]);
const Bv = n("philippine-peso", [
  ["path", { d: "M20 11H4", key: "6ut86h" }],
  ["path", { d: "M20 7H4", key: "zbl0bi" }],
  ["path", { d: "M7 21V4a1 1 0 0 1 1-1h4a1 1 0 0 1 0 12H7", key: "1ana5r" }]
]);
const Dv = n("phone-call", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ],
  ["path", { d: "M14.05 2a9 9 0 0 1 8 7.94", key: "vmijpz" }],
  ["path", { d: "M14.05 6A5 5 0 0 1 18 10", key: "13nbpp" }]
]);
const Tv = n("phone-forwarded", [
  ["polyline", { points: "18 2 22 6 18 10", key: "6vjanh" }],
  ["line", { x1: "14", x2: "22", y1: "6", y2: "6", key: "1jsywh" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const $v = n("phone-incoming", [
  ["polyline", { points: "16 2 16 8 22 8", key: "1ygljm" }],
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const Ov = n("phone-missed", [
  ["line", { x1: "22", x2: "16", y1: "2", y2: "8", key: "1xzwqn" }],
  ["line", { x1: "16", x2: "22", y1: "2", y2: "8", key: "13zxdn" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const Rv = n("phone-off", [
  [
    "path",
    {
      d: "M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91",
      key: "z86iuo"
    }
  ],
  ["line", { x1: "22", x2: "2", y1: "2", y2: "22", key: "11kh81" }]
]);
const Fv = n("phone-outgoing", [
  ["polyline", { points: "22 8 22 2 16 2", key: "1g204g" }],
  ["line", { x1: "16", x2: "22", y1: "8", y2: "2", key: "1ggias" }],
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const Ev = n("phone", [
  [
    "path",
    {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z",
      key: "foiqr5"
    }
  ]
]);
const Uv = n("pi", [
  ["line", { x1: "9", x2: "9", y1: "4", y2: "20", key: "ovs5a5" }],
  ["path", { d: "M4 7c0-1.7 1.3-3 3-3h13", key: "10pag4" }],
  ["path", { d: "M18 20c-1.7 0-3-1.3-3-3V4", key: "1gaosr" }]
]);
const Nv = n("piano", [
  [
    "path",
    {
      d: "M18.5 8c-1.4 0-2.6-.8-3.2-2A6.87 6.87 0 0 0 2 9v11a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8.5C22 9.6 20.4 8 18.5 8",
      key: "lag0yf"
    }
  ],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M6 14v4", key: "9ng0ue" }],
  ["path", { d: "M10 14v4", key: "1v8uk5" }],
  ["path", { d: "M14 14v4", key: "1tqops" }],
  ["path", { d: "M18 14v4", key: "18uqwm" }]
]);
const Wv = n("pickaxe", [
  ["path", { d: "M14.531 12.469 6.619 20.38a1 1 0 1 1-3-3l7.912-7.912", key: "we99rg" }],
  [
    "path",
    {
      d: "M15.686 4.314A12.5 12.5 0 0 0 5.461 2.958 1 1 0 0 0 5.58 4.71a22 22 0 0 1 6.318 3.393",
      key: "1w6hck"
    }
  ],
  [
    "path",
    {
      d: "M17.7 3.7a1 1 0 0 0-1.4 0l-4.6 4.6a1 1 0 0 0 0 1.4l2.6 2.6a1 1 0 0 0 1.4 0l4.6-4.6a1 1 0 0 0 0-1.4z",
      key: "15hgfx"
    }
  ],
  [
    "path",
    {
      d: "M19.686 8.314a12.501 12.501 0 0 1 1.356 10.225 1 1 0 0 1-1.751-.119 22 22 0 0 0-3.393-6.319",
      key: "452b4h"
    }
  ]
]);
const Gv = n("picture-in-picture-2", [
  ["path", { d: "M21 9V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10c0 1.1.9 2 2 2h4", key: "daa4of" }],
  ["rect", { width: "10", height: "7", x: "12", y: "13", rx: "2", key: "1nb8gs" }]
]);
const Zv = n("picture-in-picture", [
  ["path", { d: "M2 10h6V4", key: "zwrco" }],
  ["path", { d: "m2 4 6 6", key: "ug085t" }],
  ["path", { d: "M21 10V7a2 2 0 0 0-2-2h-7", key: "git5jr" }],
  ["path", { d: "M3 14v2a2 2 0 0 0 2 2h3", key: "1f7fh3" }],
  ["rect", { x: "12", y: "14", width: "10", height: "7", rx: "1", key: "1wjs3o" }]
]);
const Yv = n("piggy-bank", [
  [
    "path",
    {
      d: "M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z",
      key: "1ivx2i"
    }
  ],
  ["path", { d: "M2 9v1c0 1.1.9 2 2 2h1", key: "nm575m" }],
  ["path", { d: "M16 11h.01", key: "xkw8gn" }]
]);
const Kv = n("pilcrow-left", [
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "M14 9h-3a3 3 0 0 1 0-6h9", key: "1ulc19" }],
  ["path", { d: "M18 3v11", key: "1phi0r" }],
  ["path", { d: "M22 18H2l4-4", key: "yt65j9" }],
  ["path", { d: "m6 22-4-4", key: "6jgyf5" }]
]);
const Xv = n("pilcrow-right", [
  ["path", { d: "M10 3v11", key: "o3l5kj" }],
  ["path", { d: "M10 9H7a1 1 0 0 1 0-6h8", key: "1wb1nc" }],
  ["path", { d: "M14 3v11", key: "mlfb7b" }],
  ["path", { d: "m18 14 4 4H2", key: "4r8io1" }],
  ["path", { d: "m22 18-4 4", key: "1hjjrd" }]
]);
const Qv = n("pilcrow", [
  ["path", { d: "M13 4v16", key: "8vvj80" }],
  ["path", { d: "M17 4v16", key: "7dpous" }],
  ["path", { d: "M19 4H9.5a4.5 4.5 0 0 0 0 9H13", key: "sh4n9v" }]
]);
const Jv = n("pill-bottle", [
  ["path", { d: "M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4", key: "17ldeb" }],
  ["path", { d: "M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7", key: "nc37y6" }],
  ["rect", { width: "16", height: "5", x: "4", y: "2", rx: "1", key: "3jeezo" }]
]);
const e6 = n("pill", [
  [
    "path",
    { d: "m10.5 20.5 10-10a4.95 4.95 0 1 0-7-7l-10 10a4.95 4.95 0 1 0 7 7Z", key: "wa1lgi" }
  ],
  ["path", { d: "m8.5 8.5 7 7", key: "rvfmvr" }]
]);
const t6 = n("pin-off", [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M15 9.34V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H7.89", key: "znwnzq" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M9 9v1.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h11",
      key: "c9qhm2"
    }
  ]
]);
const a6 = n("pin", [
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  [
    "path",
    {
      d: "M9 10.76a2 2 0 0 1-1.11 1.79l-1.78.9A2 2 0 0 0 5 15.24V16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-.76a2 2 0 0 0-1.11-1.79l-1.78-.9A2 2 0 0 1 15 10.76V7a1 1 0 0 1 1-1 2 2 0 0 0 0-4H8a2 2 0 0 0 0 4 1 1 0 0 1 1 1z",
      key: "1nkz8b"
    }
  ]
]);
const n6 = n("pizza", [
  ["path", { d: "m12 14-1 1", key: "11onhr" }],
  ["path", { d: "m13.75 18.25-1.25 1.42", key: "1yisr3" }],
  ["path", { d: "M17.775 5.654a15.68 15.68 0 0 0-12.121 12.12", key: "1qtqk6" }],
  ["path", { d: "M18.8 9.3a1 1 0 0 0 2.1 7.7", key: "fbbbr2" }],
  [
    "path",
    {
      d: "M21.964 20.732a1 1 0 0 1-1.232 1.232l-18-5a1 1 0 0 1-.695-1.232A19.68 19.68 0 0 1 15.732 2.037a1 1 0 0 1 1.232.695z",
      key: "1hyfdd"
    }
  ]
]);
const o6 = n("pipette", [
  ["path", { d: "m2 22 1-1h3l9-9", key: "1sre89" }],
  ["path", { d: "M3 21v-3l9-9", key: "hpe2y6" }],
  [
    "path",
    {
      d: "m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z",
      key: "196du1"
    }
  ]
]);
const r6 = n("plane-landing", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M3.77 10.77 2 9l2-4.5 1.1.55c.55.28.9.84.9 1.45s.35 1.17.9 1.45L8 8.5l3-6 1.05.53a2 2 0 0 1 1.09 1.52l.72 5.4a2 2 0 0 0 1.09 1.52l4.4 2.2c.42.22.78.55 1.01.96l.6 1.03c.49.88-.06 1.98-1.06 2.1l-1.18.15c-.47.06-.95-.02-1.37-.24L4.29 11.15a2 2 0 0 1-.52-.38Z",
      key: "1ma21e"
    }
  ]
]);
const l6 = n("plane-takeoff", [
  ["path", { d: "M2 22h20", key: "272qi7" }],
  [
    "path",
    {
      d: "M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12 5 6l.9-.45a2 2 0 0 1 2.09.2l4.02 3a2 2 0 0 0 2.1.2l4.19-2.06a2.41 2.41 0 0 1 1.73-.17L21 7a1.4 1.4 0 0 1 .87 1.99l-.38.76c-.23.46-.6.84-1.07 1.08L7.58 17.2a2 2 0 0 1-1.22.18Z",
      key: "fkigj9"
    }
  ]
]);
const i6 = n("plane", [
  [
    "path",
    {
      d: "M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z",
      key: "1v9wt8"
    }
  ]
]);
const c6 = n("play", [
  ["polygon", { points: "6 3 20 12 6 21 6 3", key: "1oa8hb" }]
]);
const d6 = n("plug-2", [
  ["path", { d: "M9 2v6", key: "17ngun" }],
  ["path", { d: "M15 2v6", key: "s7yy2p" }],
  ["path", { d: "M12 17v5", key: "bb1du9" }],
  ["path", { d: "M5 8h14", key: "pcz4l3" }],
  ["path", { d: "M6 11V8h12v3a6 6 0 1 1-12 0Z", key: "wtfw2c" }]
]);
const vn = n("plug-zap", [
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  ["path", { d: "m18 3-4 4h6l-4 4", key: "16psg9" }]
]);
const s6 = n("plug", [
  ["path", { d: "M12 22v-5", key: "1ega77" }],
  ["path", { d: "M9 8V2", key: "14iosj" }],
  ["path", { d: "M15 8V2", key: "18g5xt" }],
  ["path", { d: "M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z", key: "osxo6l" }]
]);
const u6 = n("plus", [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
]);
const h6 = n("pocket", [
  [
    "path",
    {
      d: "M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z",
      key: "1mz881"
    }
  ],
  ["polyline", { points: "8 10 12 14 16 10", key: "w4mbv5" }]
]);
const p6 = n("pocket-knife", [
  ["path", { d: "M3 2v1c0 1 2 1 2 2S3 6 3 7s2 1 2 2-2 1-2 2 2 1 2 2", key: "19w3oe" }],
  ["path", { d: "M18 6h.01", key: "1v4wsw" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M20.83 8.83a4 4 0 0 0-5.66-5.66l-12 12a4 4 0 1 0 5.66 5.66Z", key: "6fykxj" }],
  ["path", { d: "M18 11.66V22a4 4 0 0 0 4-4V6", key: "1utzek" }]
]);
const y6 = n("podcast", [
  ["path", { d: "M16.85 18.58a9 9 0 1 0-9.7 0", key: "d71mpg" }],
  ["path", { d: "M8 14a5 5 0 1 1 8 0", key: "fc81rn" }],
  ["circle", { cx: "12", cy: "11", r: "1", key: "1gvufo" }],
  ["path", { d: "M13 17a1 1 0 1 0-2 0l.5 4.5a.5.5 0 1 0 1 0Z", key: "za5kbj" }]
]);
const k6 = n("pointer", [
  ["path", { d: "M22 14a8 8 0 0 1-8 8", key: "56vcr3" }],
  ["path", { d: "M18 11v-1a2 2 0 0 0-2-2a2 2 0 0 0-2 2", key: "1agjmk" }],
  ["path", { d: "M14 10V9a2 2 0 0 0-2-2a2 2 0 0 0-2 2v1", key: "wdbh2u" }],
  ["path", { d: "M10 9.5V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v10", key: "1ibuk9" }],
  [
    "path",
    {
      d: "M18 11a2 2 0 1 1 4 0v3a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15",
      key: "g6ys72"
    }
  ]
]);
const m6 = n("pointer-off", [
  ["path", { d: "M10 4.5V4a2 2 0 0 0-2.41-1.957", key: "jsi14n" }],
  ["path", { d: "M13.9 8.4a2 2 0 0 0-1.26-1.295", key: "hirc7f" }],
  [
    "path",
    { d: "M21.7 16.2A8 8 0 0 0 22 14v-3a2 2 0 1 0-4 0v-1a2 2 0 0 0-3.63-1.158", key: "1jxb2e" }
  ],
  [
    "path",
    {
      d: "m7 15-1.8-1.8a2 2 0 0 0-2.79 2.86L6 19.7a7.74 7.74 0 0 0 6 2.3h2a8 8 0 0 0 5.657-2.343",
      key: "10r7hm"
    }
  ],
  ["path", { d: "M6 6v8", key: "tv5xkp" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const f6 = n("popcorn", [
  [
    "path",
    {
      d: "M18 8a2 2 0 0 0 0-4 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0-4 0 2 2 0 0 0 0 4",
      key: "10td1f"
    }
  ],
  ["path", { d: "M10 22 9 8", key: "yjptiv" }],
  ["path", { d: "m14 22 1-14", key: "8jwc8b" }],
  [
    "path",
    {
      d: "M20 8c.5 0 .9.4.8 1l-2.6 12c-.1.5-.7 1-1.2 1H7c-.6 0-1.1-.4-1.2-1L3.2 9c-.1-.6.3-1 .8-1Z",
      key: "1qo33t"
    }
  ]
]);
const v6 = n("popsicle", [
  [
    "path",
    {
      d: "M18.6 14.4c.8-.8.8-2 0-2.8l-8.1-8.1a4.95 4.95 0 1 0-7.1 7.1l8.1 8.1c.9.7 2.1.7 2.9-.1Z",
      key: "1o68ps"
    }
  ],
  ["path", { d: "m22 22-5.5-5.5", key: "17o70y" }]
]);
const g6 = n("pound-sterling", [
  ["path", { d: "M18 7c0-5.333-8-5.333-8 0", key: "1prm2n" }],
  ["path", { d: "M10 7v14", key: "18tmcs" }],
  ["path", { d: "M6 21h12", key: "4dkmi1" }],
  ["path", { d: "M6 13h10", key: "ybwr4a" }]
]);
const M6 = n("power-off", [
  ["path", { d: "M18.36 6.64A9 9 0 0 1 20.77 15", key: "dxknvb" }],
  ["path", { d: "M6.16 6.16a9 9 0 1 0 12.68 12.68", key: "1x7qb5" }],
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const b6 = n("power", [
  ["path", { d: "M12 2v10", key: "mnfbl" }],
  ["path", { d: "M18.4 6.6a9 9 0 1 1-12.77.04", key: "obofu9" }]
]);
const x6 = n("presentation", [
  ["path", { d: "M2 3h20", key: "91anmk" }],
  ["path", { d: "M21 3v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V3", key: "2k9sn8" }],
  ["path", { d: "m7 21 5-5 5 5", key: "bip4we" }]
]);
const w6 = n("printer-check", [
  ["path", { d: "M13.5 22H7a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v.5", key: "qeb09x" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }],
  ["path", { d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2", key: "1md90i" }],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }]
]);
const L6 = n("printer", [
  [
    "path",
    {
      d: "M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2",
      key: "143wyd"
    }
  ],
  ["path", { d: "M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6", key: "1itne7" }],
  ["rect", { x: "6", y: "14", width: "12", height: "8", rx: "1", key: "1ue0tg" }]
]);
const S6 = n("projector", [
  ["path", { d: "M5 7 3 5", key: "1yys58" }],
  ["path", { d: "M9 6V3", key: "1ptz9u" }],
  ["path", { d: "m13 7 2-2", key: "1w3vmq" }],
  ["circle", { cx: "9", cy: "13", r: "3", key: "1mma13" }],
  [
    "path",
    {
      d: "M11.83 12H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17",
      key: "2frwzc"
    }
  ],
  ["path", { d: "M16 16h2", key: "dnq2od" }]
]);
const I6 = n("proportions", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M12 9v11", key: "1fnkrn" }],
  ["path", { d: "M2 9h13a2 2 0 0 1 2 2v9", key: "11z3ex" }]
]);
const C6 = n("pyramid", [
  [
    "path",
    {
      d: "M2.5 16.88a1 1 0 0 1-.32-1.43l9-13.02a1 1 0 0 1 1.64 0l9 13.01a1 1 0 0 1-.32 1.44l-8.51 4.86a2 2 0 0 1-1.98 0Z",
      key: "aenxs0"
    }
  ],
  ["path", { d: "M12 2v20", key: "t6zp3m" }]
]);
const A6 = n("puzzle", [
  [
    "path",
    {
      d: "M15.39 4.39a1 1 0 0 0 1.68-.474 2.5 2.5 0 1 1 3.014 3.015 1 1 0 0 0-.474 1.68l1.683 1.682a2.414 2.414 0 0 1 0 3.414L19.61 15.39a1 1 0 0 1-1.68-.474 2.5 2.5 0 1 0-3.014 3.015 1 1 0 0 1 .474 1.68l-1.683 1.682a2.414 2.414 0 0 1-3.414 0L8.61 19.61a1 1 0 0 0-1.68.474 2.5 2.5 0 1 1-3.014-3.015 1 1 0 0 0 .474-1.68l-1.683-1.682a2.414 2.414 0 0 1 0-3.414L4.39 8.61a1 1 0 0 1 1.68.474 2.5 2.5 0 1 0 3.014-3.015 1 1 0 0 1-.474-1.68l1.683-1.682a2.414 2.414 0 0 1 3.414 0z",
      key: "w46dr5"
    }
  ]
]);
const q6 = n("qr-code", [
  ["rect", { width: "5", height: "5", x: "3", y: "3", rx: "1", key: "1tu5fj" }],
  ["rect", { width: "5", height: "5", x: "16", y: "3", rx: "1", key: "1v8r4q" }],
  ["rect", { width: "5", height: "5", x: "3", y: "16", rx: "1", key: "1x03jg" }],
  ["path", { d: "M21 16h-3a2 2 0 0 0-2 2v3", key: "177gqh" }],
  ["path", { d: "M21 21v.01", key: "ents32" }],
  ["path", { d: "M12 7v3a2 2 0 0 1-2 2H7", key: "8crl2c" }],
  ["path", { d: "M3 12h.01", key: "nlz23k" }],
  ["path", { d: "M12 3h.01", key: "n36tog" }],
  ["path", { d: "M12 16v.01", key: "133mhm" }],
  ["path", { d: "M16 12h1", key: "1slzba" }],
  ["path", { d: "M21 12v.01", key: "1lwtk9" }],
  ["path", { d: "M12 21v-1", key: "1880an" }]
]);
const z6 = n("quote", [
  [
    "path",
    {
      d: "M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "rib7q0"
    }
  ],
  [
    "path",
    {
      d: "M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z",
      key: "1ymkrd"
    }
  ]
]);
const P6 = n("rabbit", [
  ["path", { d: "M13 16a3 3 0 0 1 2.24 5", key: "1epib5" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }],
  [
    "path",
    {
      d: "M18 21h-8a4 4 0 0 1-4-4 7 7 0 0 1 7-7h.2L9.6 6.4a1 1 0 1 1 2.8-2.8L15.8 7h.2c3.3 0 6 2.7 6 6v1a2 2 0 0 1-2 2h-1a3 3 0 0 0-3 3",
      key: "ue9ozu"
    }
  ],
  ["path", { d: "M20 8.54V4a2 2 0 1 0-4 0v3", key: "49iql8" }],
  ["path", { d: "M7.612 12.524a3 3 0 1 0-1.6 4.3", key: "1e33i0" }]
]);
const _6 = n("radar", [
  ["path", { d: "M19.07 4.93A10 10 0 0 0 6.99 3.34", key: "z3du51" }],
  ["path", { d: "M4 6h.01", key: "oypzma" }],
  ["path", { d: "M2.29 9.62A10 10 0 1 0 21.31 8.35", key: "qzzz0" }],
  ["path", { d: "M16.24 7.76A6 6 0 1 0 8.23 16.67", key: "1yjesh" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }],
  ["path", { d: "M17.99 11.66A6 6 0 0 1 15.77 16.67", key: "1u2y91" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "m13.41 10.59 5.66-5.66", key: "mhq4k0" }]
]);
const j6 = n("radiation", [
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  [
    "path",
    {
      d: "M7.5 4.2c-.3-.5-.9-.7-1.3-.4C3.9 5.5 2.3 8.1 2 11c-.1.5.4 1 1 1h5c0-1.5.8-2.8 2-3.4-1.1-1.9-2-3.5-2.5-4.4z",
      key: "wy49g3"
    }
  ],
  [
    "path",
    {
      d: "M21 12c.6 0 1-.4 1-1-.3-2.9-1.8-5.5-4.1-7.1-.4-.3-1.1-.2-1.3.3-.6.9-1.5 2.5-2.6 4.3 1.2.7 2 2 2 3.5h5z",
      key: "vklnvr"
    }
  ],
  [
    "path",
    {
      d: "M7.5 19.8c-.3.5-.1 1.1.4 1.3 2.6 1.2 5.6 1.2 8.2 0 .5-.2.7-.8.4-1.3-.5-.9-1.4-2.5-2.5-4.3-1.2.7-2.8.7-4 0-1.1 1.8-2 3.4-2.5 4.3z",
      key: "wkdf1o"
    }
  ]
]);
const H6 = n("radical", [
  [
    "path",
    {
      d: "M3 12h3.28a1 1 0 0 1 .948.684l2.298 7.934a.5.5 0 0 0 .96-.044L13.82 4.771A1 1 0 0 1 14.792 4H21",
      key: "1mqj8i"
    }
  ]
]);
const V6 = n("radio-receiver", [
  ["path", { d: "M5 16v2", key: "g5qcv5" }],
  ["path", { d: "M19 16v2", key: "1gbaio" }],
  ["rect", { width: "20", height: "8", x: "2", y: "8", rx: "2", key: "vjsjur" }],
  ["path", { d: "M18 12h.01", key: "yjnet6" }]
]);
const B6 = n("radio-tower", [
  ["path", { d: "M4.9 16.1C1 12.2 1 5.8 4.9 1.9", key: "s0qx1y" }],
  ["path", { d: "M7.8 4.7a6.14 6.14 0 0 0-.8 7.5", key: "1idnkw" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }],
  ["path", { d: "M16.2 4.8c2 2 2.26 5.11.8 7.47", key: "ojru2q" }],
  ["path", { d: "M19.1 1.9a9.96 9.96 0 0 1 0 14.1", key: "rhi7fg" }],
  ["path", { d: "M9.5 18h5", key: "mfy3pd" }],
  ["path", { d: "m8 22 4-11 4 11", key: "25yftu" }]
]);
const D6 = n("radio", [
  ["path", { d: "M4.9 19.1C1 15.2 1 8.8 4.9 4.9", key: "1vaf9d" }],
  ["path", { d: "M7.8 16.2c-2.3-2.3-2.3-6.1 0-8.5", key: "u1ii0m" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["path", { d: "M16.2 7.8c2.3 2.3 2.3 6.1 0 8.5", key: "1j5fej" }],
  ["path", { d: "M19.1 4.9C23 8.8 23 15.1 19.1 19", key: "10b0cb" }]
]);
const T6 = n("radius", [
  ["path", { d: "M20.34 17.52a10 10 0 1 0-2.82 2.82", key: "fydyku" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["path", { d: "m13.41 13.41 4.18 4.18", key: "1gqbwc" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const $6 = n("rail-symbol", [
  ["path", { d: "M5 15h14", key: "m0yey3" }],
  ["path", { d: "M5 9h14", key: "7tsvo6" }],
  ["path", { d: "m14 20-5-5 6-6-5-5", key: "1jo42i" }]
]);
const O6 = n("rainbow", [
  ["path", { d: "M22 17a10 10 0 0 0-20 0", key: "ozegv" }],
  ["path", { d: "M6 17a6 6 0 0 1 12 0", key: "5giftw" }],
  ["path", { d: "M10 17a2 2 0 0 1 4 0", key: "gnsikk" }]
]);
const R6 = n("rat", [
  ["path", { d: "M13 22H4a2 2 0 0 1 0-4h12", key: "bt3f23" }],
  ["path", { d: "M13.236 18a3 3 0 0 0-2.2-5", key: "1tbvmo" }],
  ["path", { d: "M16 9h.01", key: "1bdo4e" }],
  [
    "path",
    {
      d: "M16.82 3.94a3 3 0 1 1 3.237 4.868l1.815 2.587a1.5 1.5 0 0 1-1.5 2.1l-2.872-.453a3 3 0 0 0-3.5 3",
      key: "9ch7kn"
    }
  ],
  ["path", { d: "M17 4.988a3 3 0 1 0-5.2 2.052A7 7 0 0 0 4 14.015 4 4 0 0 0 8 18", key: "3s7e9i" }]
]);
const F6 = n("ratio", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }],
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
const E6 = n("receipt-cent", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M12 6.5v11", key: "ecfhkf" }],
  ["path", { d: "M15 9.4a4 4 0 1 0 0 5.2", key: "1makmb" }]
]);
const U6 = n("receipt-euro", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 12h5", key: "1g6qi8" }],
  ["path", { d: "M16 9.5a4 4 0 1 0 0 5.2", key: "b2px4r" }]
]);
const N6 = n("receipt-indian-rupee", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 7h8", key: "i86dvs" }],
  ["path", { d: "M12 17.5 8 15h1a4 4 0 0 0 0-8", key: "grpkl4" }],
  ["path", { d: "M8 11h8", key: "vwpz6n" }]
]);
const W6 = n("receipt-japanese-yen", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "m12 10 3-3", key: "1mc12w" }],
  ["path", { d: "m9 7 3 3v7.5", key: "39i0xv" }],
  ["path", { d: "M9 11h6", key: "1fldmi" }],
  ["path", { d: "M9 15h6", key: "cctwl0" }]
]);
const G6 = n("receipt-pound-sterling", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 13h5", key: "1k9z8w" }],
  ["path", { d: "M10 17V9.5a2.5 2.5 0 0 1 5 0", key: "1dzgp0" }],
  ["path", { d: "M8 17h7", key: "8mjdqu" }]
]);
const Z6 = n("receipt-russian-ruble", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M8 15h5", key: "vxg57a" }],
  ["path", { d: "M8 11h5a2 2 0 1 0 0-4h-3v10", key: "1usi5u" }]
]);
const Y6 = n("receipt-swiss-franc", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M10 17V7h5", key: "k7jq18" }],
  ["path", { d: "M10 11h4", key: "1i0mka" }],
  ["path", { d: "M8 15h5", key: "vxg57a" }]
]);
const K6 = n("receipt-text", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M14 8H8", key: "1l3xfs" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }],
  ["path", { d: "M13 16H8", key: "wsln4y" }]
]);
const X6 = n("receipt", [
  [
    "path",
    { d: "M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1Z", key: "q3az6g" }
  ],
  ["path", { d: "M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8", key: "1h4pet" }],
  ["path", { d: "M12 17.5v-11", key: "1jc1ny" }]
]);
const gn = n("rectangle-ellipsis", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M17 12h.01", key: "1m0b6t" }],
  ["path", { d: "M7 12h.01", key: "eqddd0" }]
]);
const Q6 = n("rectangle-horizontal", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "2", key: "9lu3g6" }]
]);
const J6 = n("rectangle-vertical", [
  ["rect", { width: "12", height: "20", x: "6", y: "2", rx: "2", key: "1oxtiu" }]
]);
const e8 = n("recycle", [
  [
    "path",
    {
      d: "M7 19H4.815a1.83 1.83 0 0 1-1.57-.881 1.785 1.785 0 0 1-.004-1.784L7.196 9.5",
      key: "x6z5xu"
    }
  ],
  [
    "path",
    {
      d: "M11 19h8.203a1.83 1.83 0 0 0 1.556-.89 1.784 1.784 0 0 0 0-1.775l-1.226-2.12",
      key: "1x4zh5"
    }
  ],
  ["path", { d: "m14 16-3 3 3 3", key: "f6jyew" }],
  ["path", { d: "M8.293 13.596 7.196 9.5 3.1 10.598", key: "wf1obh" }],
  [
    "path",
    {
      d: "m9.344 5.811 1.093-1.892A1.83 1.83 0 0 1 11.985 3a1.784 1.784 0 0 1 1.546.888l3.943 6.843",
      key: "9tzpgr"
    }
  ],
  ["path", { d: "m13.378 9.633 4.096 1.098 1.097-4.096", key: "1oe83g" }]
]);
const t8 = n("redo-2", [
  ["path", { d: "m15 14 5-5-5-5", key: "12vg1m" }],
  ["path", { d: "M20 9H9.5A5.5 5.5 0 0 0 4 14.5A5.5 5.5 0 0 0 9.5 20H13", key: "6uklza" }]
]);
const a8 = n("redo-dot", [
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }],
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
const n8 = n("redo", [
  ["path", { d: "M21 7v6h-6", key: "3ptur4" }],
  ["path", { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", key: "1kgawr" }]
]);
const o8 = n("refresh-ccw-dot", [
  ["path", { d: "M3 2v6h6", key: "18ldww" }],
  ["path", { d: "M21 12A9 9 0 0 0 6 5.3L3 8", key: "1pbrqz" }],
  ["path", { d: "M21 22v-6h-6", key: "usdfbe" }],
  ["path", { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", key: "1hosoe" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
const r8 = n("refresh-ccw", [
  ["path", { d: "M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "14sxne" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }],
  ["path", { d: "M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16", key: "1hlbsb" }],
  ["path", { d: "M16 16h5v5", key: "ccwih5" }]
]);
const l8 = n("refresh-cw-off", [
  ["path", { d: "M21 8L18.74 5.74A9.75 9.75 0 0 0 12 3C11 3 10.03 3.16 9.13 3.47", key: "1krf6h" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }],
  ["path", { d: "M3 12C3 9.51 4 7.26 5.64 5.64", key: "ruvoct" }],
  ["path", { d: "m3 16 2.26 2.26A9.75 9.75 0 0 0 12 21c2.49 0 4.74-1 6.36-2.64", key: "19q130" }],
  ["path", { d: "M21 12c0 1-.16 1.97-.47 2.87", key: "4w8emr" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M22 22 2 2", key: "1r8tn9" }]
]);
const i8 = n("refresh-cw", [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
]);
const c8 = n("refrigerator", [
  [
    "path",
    { d: "M5 6a4 4 0 0 1 4-4h6a4 4 0 0 1 4 4v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6Z", key: "fpq118" }
  ],
  ["path", { d: "M5 10h14", key: "elsbfy" }],
  ["path", { d: "M15 7v6", key: "1nx30x" }]
]);
const d8 = n("regex", [
  ["path", { d: "M17 3v10", key: "15fgeh" }],
  ["path", { d: "m12.67 5.5 8.66 5", key: "1gpheq" }],
  ["path", { d: "m12.67 10.5 8.66-5", key: "1dkfa6" }],
  [
    "path",
    { d: "M9 17a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2v-2z", key: "swwfx4" }
  ]
]);
const s8 = n("remove-formatting", [
  ["path", { d: "M4 7V4h16v3", key: "9msm58" }],
  ["path", { d: "M5 20h6", key: "1h6pxn" }],
  ["path", { d: "M13 4 8 20", key: "kqq6aj" }],
  ["path", { d: "m15 15 5 5", key: "me55sn" }],
  ["path", { d: "m20 15-5 5", key: "11p7ol" }]
]);
const u8 = n("repeat-1", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }],
  ["path", { d: "M11 10h1v4", key: "70cz1p" }]
]);
const h8 = n("repeat-2", [
  ["path", { d: "m2 9 3-3 3 3", key: "1ltn5i" }],
  ["path", { d: "M13 18H7a2 2 0 0 1-2-2V6", key: "1r6tfw" }],
  ["path", { d: "m22 15-3 3-3-3", key: "4rnwn2" }],
  ["path", { d: "M11 6h6a2 2 0 0 1 2 2v10", key: "2f72bc" }]
]);
const p8 = n("repeat", [
  ["path", { d: "m17 2 4 4-4 4", key: "nntrym" }],
  ["path", { d: "M3 11v-1a4 4 0 0 1 4-4h14", key: "84bu3i" }],
  ["path", { d: "m7 22-4-4 4-4", key: "1wqhfi" }],
  ["path", { d: "M21 13v1a4 4 0 0 1-4 4H3", key: "1rx37r" }]
]);
const y8 = n("replace-all", [
  ["path", { d: "M14 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "1yyzbs" }],
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2", key: "zfj4xr" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a 3 3 0 0 1 3-3h1", key: "1ageje" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
]);
const k8 = n("replace", [
  ["path", { d: "M14 4a2 2 0 0 1 2-2", key: "1w2hp7" }],
  ["path", { d: "M16 10a2 2 0 0 1-2-2", key: "shjach" }],
  ["path", { d: "M20 2a2 2 0 0 1 2 2", key: "188mtx" }],
  ["path", { d: "M22 8a2 2 0 0 1-2 2", key: "ddf4tu" }],
  ["path", { d: "m3 7 3 3 3-3", key: "x25e72" }],
  ["path", { d: "M6 10V5a3 3 0 0 1 3-3h1", key: "3y3t5z" }],
  ["rect", { x: "2", y: "14", width: "8", height: "8", rx: "2", key: "4rksxw" }]
]);
const m8 = n("reply-all", [
  ["polyline", { points: "7 17 2 12 7 7", key: "t83bqg" }],
  ["polyline", { points: "12 17 7 12 12 7", key: "1g4ajm" }],
  ["path", { d: "M22 18v-2a4 4 0 0 0-4-4H7", key: "1fcyog" }]
]);
const f8 = n("reply", [
  ["polyline", { points: "9 17 4 12 9 7", key: "hvgpf2" }],
  ["path", { d: "M20 18v-2a4 4 0 0 0-4-4H4", key: "5vmcpk" }]
]);
const v8 = n("rewind", [
  ["polygon", { points: "11 19 2 12 11 5 11 19", key: "14yba5" }],
  ["polygon", { points: "22 19 13 12 22 5 22 19", key: "1pi1cj" }]
]);
const g8 = n("ribbon", [
  [
    "path",
    { d: "M12 11.22C11 9.997 10 9 10 8a2 2 0 0 1 4 0c0 1-.998 2.002-2.01 3.22", key: "1rnhq3" }
  ],
  ["path", { d: "m12 18 2.57-3.5", key: "116vt7" }],
  ["path", { d: "M6.243 9.016a7 7 0 0 1 11.507-.009", key: "10dq0b" }],
  ["path", { d: "M9.35 14.53 12 11.22", key: "tdsyp2" }],
  [
    "path",
    {
      d: "M9.35 14.53C7.728 12.246 6 10.221 6 7a6 5 0 0 1 12 0c-.005 3.22-1.778 5.235-3.43 7.5l3.557 4.527a1 1 0 0 1-.203 1.43l-1.894 1.36a1 1 0 0 1-1.384-.215L12 18l-2.679 3.593a1 1 0 0 1-1.39.213l-1.865-1.353a1 1 0 0 1-.203-1.422z",
      key: "nmifey"
    }
  ]
]);
const M8 = n("rocket", [
  [
    "path",
    {
      d: "M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z",
      key: "m3kijz"
    }
  ],
  [
    "path",
    {
      d: "m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z",
      key: "1fmvmk"
    }
  ],
  ["path", { d: "M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0", key: "1f8sc4" }],
  ["path", { d: "M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5", key: "qeys4" }]
]);
const b8 = n("rocking-chair", [
  ["polyline", { points: "3.5 2 6.5 12.5 18 12.5", key: "y3iy52" }],
  ["line", { x1: "9.5", x2: "5.5", y1: "12.5", y2: "20", key: "19vg5i" }],
  ["line", { x1: "15", x2: "18.5", y1: "12.5", y2: "20", key: "1inpmv" }],
  ["path", { d: "M2.75 18a13 13 0 0 0 18.5 0", key: "1nquas" }]
]);
const x8 = n("roller-coaster", [
  ["path", { d: "M6 19V5", key: "1r845m" }],
  ["path", { d: "M10 19V6.8", key: "9j2tfs" }],
  ["path", { d: "M14 19v-7.8", key: "10s8qv" }],
  ["path", { d: "M18 5v4", key: "1tajlv" }],
  ["path", { d: "M18 19v-6", key: "ielfq3" }],
  ["path", { d: "M22 19V9", key: "158nzp" }],
  ["path", { d: "M2 19V9a4 4 0 0 1 4-4c2 0 4 1.33 6 4s4 4 6 4a4 4 0 1 0-3-6.65", key: "1930oh" }]
]);
const Mn = n("rotate-3d", [
  [
    "path",
    {
      d: "M16.466 7.5C15.643 4.237 13.952 2 12 2 9.239 2 7 6.477 7 12s2.239 10 5 10c.342 0 .677-.069 1-.2",
      key: "10n0gc"
    }
  ],
  ["path", { d: "m15.194 13.707 3.814 1.86-1.86 3.814", key: "16shm9" }],
  [
    "path",
    {
      d: "M19 15.57c-1.804.885-4.274 1.43-7 1.43-5.523 0-10-2.239-10-5s4.477-5 10-5c4.838 0 8.873 1.718 9.8 4",
      key: "1lxi77"
    }
  ]
]);
const w8 = n("rotate-ccw-square", [
  ["path", { d: "M20 9V7a2 2 0 0 0-2-2h-6", key: "19z8uc" }],
  ["path", { d: "m15 2-3 3 3 3", key: "177bxs" }],
  ["path", { d: "M20 13v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2", key: "d36hnl" }]
]);
const L8 = n("rotate-ccw", [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
]);
const S8 = n("rotate-cw-square", [
  ["path", { d: "M12 5H6a2 2 0 0 0-2 2v3", key: "l96uqu" }],
  ["path", { d: "m9 8 3-3-3-3", key: "1gzgc3" }],
  ["path", { d: "M4 14v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-2", key: "1w2k5h" }]
]);
const I8 = n("rotate-cw", [
  ["path", { d: "M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8", key: "1p45f6" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }]
]);
const C8 = n("route-off", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
const A8 = n("route", [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5a3.5 3.5 0 0 0 0-7h-11a3.5 3.5 0 0 1 0-7H15", key: "1d8sl" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
]);
const q8 = n("router", [
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", key: "w68u3i" }],
  ["path", { d: "M6.01 18H6", key: "19vcac" }],
  ["path", { d: "M10.01 18H10", key: "uamcmx" }],
  ["path", { d: "M15 10v4", key: "qjz1xs" }],
  ["path", { d: "M17.84 7.17a4 4 0 0 0-5.66 0", key: "1rif40" }],
  ["path", { d: "M20.66 4.34a8 8 0 0 0-11.31 0", key: "6a5xfq" }]
]);
const bn = n("rows-2", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 12h18", key: "1i2n21" }]
]);
const xn = n("rows-3", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
const z8 = n("rows-4", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 7.5H3", key: "1hm9pq" }],
  ["path", { d: "M21 12H3", key: "2avoz0" }],
  ["path", { d: "M21 16.5H3", key: "n7jzkj" }]
]);
const P8 = n("rss", [
  ["path", { d: "M4 11a9 9 0 0 1 9 9", key: "pv89mb" }],
  ["path", { d: "M4 4a16 16 0 0 1 16 16", key: "k0647b" }],
  ["circle", { cx: "5", cy: "19", r: "1", key: "bfqh0e" }]
]);
const _8 = n("ruler", [
  [
    "path",
    {
      d: "M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z",
      key: "icamh8"
    }
  ],
  ["path", { d: "m14.5 12.5 2-2", key: "inckbg" }],
  ["path", { d: "m11.5 9.5 2-2", key: "fmmyf7" }],
  ["path", { d: "m8.5 6.5 2-2", key: "vc6u1g" }],
  ["path", { d: "m17.5 15.5 2-2", key: "wo5hmg" }]
]);
const j8 = n("russian-ruble", [
  ["path", { d: "M6 11h8a4 4 0 0 0 0-8H9v18", key: "18ai8t" }],
  ["path", { d: "M6 15h8", key: "1y8f6l" }]
]);
const H8 = n("sailboat", [
  ["path", { d: "M22 18H2a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4Z", key: "1404fh" }],
  ["path", { d: "M21 14 10 2 3 14h18Z", key: "1nzg7v" }],
  ["path", { d: "M10 2v16", key: "1labyt" }]
]);
const V8 = n("salad", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  [
    "path",
    {
      d: "M11.38 12a2.4 2.4 0 0 1-.4-4.77 2.4 2.4 0 0 1 3.2-2.77 2.4 2.4 0 0 1 3.47-.63 2.4 2.4 0 0 1 3.37 3.37 2.4 2.4 0 0 1-1.1 3.7 2.51 2.51 0 0 1 .03 1.1",
      key: "10xrj0"
    }
  ],
  ["path", { d: "m13 12 4-4", key: "1hckqy" }],
  ["path", { d: "M10.9 7.25A3.99 3.99 0 0 0 4 10c0 .73.2 1.41.54 2", key: "1p4srx" }]
]);
const B8 = n("sandwich", [
  ["path", { d: "m2.37 11.223 8.372-6.777a2 2 0 0 1 2.516 0l8.371 6.777", key: "f1wd0e" }],
  ["path", { d: "M21 15a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-5.25", key: "1pfu07" }],
  ["path", { d: "M3 15a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h9", key: "1oq9qw" }],
  ["path", { d: "m6.67 15 6.13 4.6a2 2 0 0 0 2.8-.4l3.15-4.2", key: "1fnwu5" }],
  ["rect", { width: "20", height: "4", x: "2", y: "11", rx: "1", key: "itshg" }]
]);
const D8 = n("satellite-dish", [
  ["path", { d: "M4 10a7.31 7.31 0 0 0 10 10Z", key: "1fzpp3" }],
  ["path", { d: "m9 15 3-3", key: "88sc13" }],
  ["path", { d: "M17 13a6 6 0 0 0-6-6", key: "15cc6u" }],
  ["path", { d: "M21 13A10 10 0 0 0 11 3", key: "11nf8s" }]
]);
const T8 = n("satellite", [
  ["path", { d: "M13 7 9 3 5 7l4 4", key: "vyckw6" }],
  ["path", { d: "m17 11 4 4-4 4-4-4", key: "rchckc" }],
  ["path", { d: "m8 12 4 4 6-6-4-4Z", key: "1sshf7" }],
  ["path", { d: "m16 8 3-3", key: "x428zp" }],
  ["path", { d: "M9 21a6 6 0 0 0-6-6", key: "1iajcf" }]
]);
const $8 = n("saudi-riyal", [
  ["path", { d: "m20 19.5-5.5 1.2", key: "1aenhr" }],
  ["path", { d: "M14.5 4v11.22a1 1 0 0 0 1.242.97L20 15.2", key: "2rtezt" }],
  ["path", { d: "m2.978 19.351 5.549-1.363A2 2 0 0 0 10 16V2", key: "1kbm92" }],
  ["path", { d: "M20 10 4 13.5", key: "8nums9" }]
]);
const O8 = n("save-all", [
  ["path", { d: "M10 2v3a1 1 0 0 0 1 1h5", key: "1xspal" }],
  ["path", { d: "M18 18v-6a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v6", key: "1ra60u" }],
  ["path", { d: "M18 22H4a2 2 0 0 1-2-2V6", key: "pblm9e" }],
  [
    "path",
    {
      d: "M8 18a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9.172a2 2 0 0 1 1.414.586l2.828 2.828A2 2 0 0 1 22 6.828V16a2 2 0 0 1-2.01 2z",
      key: "1yve0x"
    }
  ]
]);
const R8 = n("save-off", [
  ["path", { d: "M13 13H8a1 1 0 0 0-1 1v7", key: "h8g396" }],
  ["path", { d: "M14 8h1", key: "1lfen6" }],
  ["path", { d: "M17 21v-4", key: "1yknxs" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    { d: "M20.41 20.41A2 2 0 0 1 19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 .59-1.41", key: "1t4vdl" }
  ],
  ["path", { d: "M29.5 11.5s5 5 4 5", key: "zzn4i6" }],
  ["path", { d: "M9 3h6.2a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V15", key: "24cby9" }]
]);
const F8 = n("save", [
  [
    "path",
    {
      d: "M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z",
      key: "1c8476"
    }
  ],
  ["path", { d: "M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7", key: "1ydtos" }],
  ["path", { d: "M7 3v4a1 1 0 0 0 1 1h7", key: "t51u73" }]
]);
const wn = n("scale-3d", [
  ["path", { d: "M5 7v11a1 1 0 0 0 1 1h11", key: "13dt1j" }],
  ["path", { d: "M5.293 18.707 11 13", key: "ezgbsx" }],
  ["circle", { cx: "19", cy: "19", r: "2", key: "17f5cg" }],
  ["circle", { cx: "5", cy: "5", r: "2", key: "1gwv83" }]
]);
const E8 = n("scale", [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
]);
const U8 = n("scaling", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  ["path", { d: "M14 15H9v-5", key: "pi4jk9" }],
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M21 3 9 15", key: "15kdhq" }]
]);
const N8 = n("scan-barcode", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 7v10", key: "23sfjj" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M17 7v10", key: "578dap" }]
]);
const W8 = n("scan-eye", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
]);
const G8 = n("scan-face", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }]
]);
const Z8 = n("scan-heart", [
  [
    "path",
    {
      d: "M11.246 16.657a1 1 0 0 0 1.508 0l3.57-4.101A2.75 2.75 0 1 0 12 9.168a2.75 2.75 0 1 0-4.324 3.388z",
      key: "1algrk"
    }
  ],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
const Y8 = n("scan-line", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }]
]);
const K8 = n("scan-qr-code", [
  ["path", { d: "M17 12v4a1 1 0 0 1-1 1h-4", key: "uk4fdo" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M17 8V7", key: "q2g9wo" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M7 17h.01", key: "19xn7k" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["rect", { x: "7", y: "7", width: "5", height: "5", rx: "1", key: "m9kyts" }]
]);
const X8 = n("scan-text", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["path", { d: "M7 8h8", key: "1jbsf9" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h6", key: "1vyc9m" }]
]);
const Q8 = n("scan-search", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m16 16-1.9-1.9", key: "1dq9hf" }]
]);
const J8 = n("scan", [
  ["path", { d: "M3 7V5a2 2 0 0 1 2-2h2", key: "aa7l1z" }],
  ["path", { d: "M17 3h2a2 2 0 0 1 2 2v2", key: "4qcy5o" }],
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2h-2", key: "6vwrx8" }],
  ["path", { d: "M7 21H5a2 2 0 0 1-2-2v-2", key: "ioqczr" }]
]);
const eg = n("school", [
  ["path", { d: "M14 22v-4a2 2 0 1 0-4 0v4", key: "hhkicm" }],
  [
    "path",
    {
      d: "m18 10 3.447 1.724a1 1 0 0 1 .553.894V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-7.382a1 1 0 0 1 .553-.894L6 10",
      key: "1xqip1"
    }
  ],
  ["path", { d: "M18 5v17", key: "1sw6gf" }],
  ["path", { d: "m4 6 7.106-3.553a2 2 0 0 1 1.788 0L20 6", key: "9d2mlk" }],
  ["path", { d: "M6 5v17", key: "1xfsm0" }],
  ["circle", { cx: "12", cy: "9", r: "2", key: "1092wv" }]
]);
const tg = n("scissors-line-dashed", [
  ["path", { d: "M5.42 9.42 8 12", key: "12pkuq" }],
  ["circle", { cx: "4", cy: "8", r: "2", key: "107mxr" }],
  ["path", { d: "m14 6-8.58 8.58", key: "gvzu5l" }],
  ["circle", { cx: "4", cy: "16", r: "2", key: "1ehqvc" }],
  ["path", { d: "M10.8 14.8 14 18", key: "ax7m9r" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }]
]);
const ag = n("scissors", [
  ["circle", { cx: "6", cy: "6", r: "3", key: "1lh9wr" }],
  ["path", { d: "M8.12 8.12 12 12", key: "1alkpv" }],
  ["path", { d: "M20 4 8.12 15.88", key: "xgtan2" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M14.8 14.8 20 20", key: "ptml3r" }]
]);
const ng = n("screen-share-off", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m22 3-5 5", key: "12jva0" }],
  ["path", { d: "m17 3 5 5", key: "k36vhe" }]
]);
const og = n("screen-share", [
  ["path", { d: "M13 3H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3", key: "i8wdob" }],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }],
  ["path", { d: "m17 8 5-5", key: "fqif7o" }],
  ["path", { d: "M17 3h5v5", key: "1o3tu8" }]
]);
const rg = n("scroll-text", [
  ["path", { d: "M15 12h-5", key: "r7krc0" }],
  ["path", { d: "M15 8h-5", key: "1khuty" }],
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
]);
const lg = n("scroll", [
  ["path", { d: "M19 17V5a2 2 0 0 0-2-2H4", key: "zz82l3" }],
  [
    "path",
    {
      d: "M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3",
      key: "1ph1d7"
    }
  ]
]);
const ig = n("search-check", [
  ["path", { d: "m8 11 2 2 4-4", key: "1sed1v" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const cg = n("search-code", [
  ["path", { d: "m13 13.5 2-2.5-2-2.5", key: "1rvxrh" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M9 8.5 7 11l2 2.5", key: "6ffwbx" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
]);
const dg = n("search-slash", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const sg = n("search-x", [
  ["path", { d: "m13.5 8.5-5 5", key: "1cs55j" }],
  ["path", { d: "m8.5 8.5 5 5", key: "a8mexj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const ug = n("search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
const hg = n("section", [
  ["path", { d: "M16 5a4 3 0 0 0-8 0c0 4 8 3 8 7a4 3 0 0 1-8 0", key: "vqan6v" }],
  ["path", { d: "M8 19a4 3 0 0 0 8 0c0-4-8-3-8-7a4 3 0 0 1 8 0", key: "wdjd8o" }]
]);
const Ln = n("send-horizontal", [
  [
    "path",
    {
      d: "M3.714 3.048a.498.498 0 0 0-.683.627l2.843 7.627a2 2 0 0 1 0 1.396l-2.842 7.627a.498.498 0 0 0 .682.627l18-8.5a.5.5 0 0 0 0-.904z",
      key: "117uat"
    }
  ],
  ["path", { d: "M6 12h16", key: "s4cdu5" }]
]);
const pg = n("send-to-back", [
  ["rect", { x: "14", y: "14", width: "8", height: "8", rx: "2", key: "1b0bso" }],
  ["rect", { x: "2", y: "2", width: "8", height: "8", rx: "2", key: "1x09vl" }],
  ["path", { d: "M7 14v1a2 2 0 0 0 2 2h1", key: "pao6x6" }],
  ["path", { d: "M14 7h1a2 2 0 0 1 2 2v1", key: "19tdru" }]
]);
const yg = n("send", [
  [
    "path",
    {
      d: "M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z",
      key: "1ffxy3"
    }
  ],
  ["path", { d: "m21.854 2.147-10.94 10.939", key: "12cjpa" }]
]);
const kg = n("separator-horizontal", [
  ["line", { x1: "3", x2: "21", y1: "12", y2: "12", key: "10d38w" }],
  ["polyline", { points: "8 8 12 4 16 8", key: "zo8t4w" }],
  ["polyline", { points: "16 16 12 20 8 16", key: "1oyrid" }]
]);
const mg = n("separator-vertical", [
  ["line", { x1: "12", x2: "12", y1: "3", y2: "21", key: "1efggb" }],
  ["polyline", { points: "8 8 4 12 8 16", key: "bnfmv4" }],
  ["polyline", { points: "16 16 20 12 16 8", key: "u90052" }]
]);
const fg = n("server-cog", [
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  [
    "path",
    {
      d: "M4.5 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-.5",
      key: "tn8das"
    }
  ],
  [
    "path",
    {
      d: "M4.5 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-.5",
      key: "1g2pve"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m15.7 13.4-.9-.3", key: "1jwmzr" }],
  ["path", { d: "m9.2 10.9-.9-.3", key: "qapnim" }],
  ["path", { d: "m10.6 15.7.3-.9", key: "quwk0k" }],
  ["path", { d: "m13.6 15.7-.4-1", key: "cb9xp7" }],
  ["path", { d: "m10.8 9.3-.4-1", key: "1uaiz5" }],
  ["path", { d: "m8.3 13.6 1-.4", key: "s6srou" }],
  ["path", { d: "m14.7 10.8 1-.4", key: "4d31cq" }],
  ["path", { d: "m13.4 8.3-.3.9", key: "1bm987" }]
]);
const vg = n("server-crash", [
  [
    "path",
    {
      d: "M6 10H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2",
      key: "4b9dqc"
    }
  ],
  [
    "path",
    {
      d: "M6 14H4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-2",
      key: "22nnkd"
    }
  ],
  ["path", { d: "M6 6h.01", key: "1utrut" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m13 6-4 6h6l-4 6", key: "14hqih" }]
]);
const gg = n("server-off", [
  ["path", { d: "M7 2h13a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-5", key: "bt2siv" }],
  ["path", { d: "M10 10 2.5 2.5C2 2 2 2.5 2 5v3a2 2 0 0 0 2 2h6z", key: "1hjrv1" }],
  ["path", { d: "M22 17v-1a2 2 0 0 0-2-2h-1", key: "1iynyr" }],
  ["path", { d: "M4 14a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h16.5l1-.5.5.5-8-8H4z", key: "161ggg" }],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const Mg = n("server", [
  ["rect", { width: "20", height: "8", x: "2", y: "2", rx: "2", ry: "2", key: "ngkwjq" }],
  ["rect", { width: "20", height: "8", x: "2", y: "14", rx: "2", ry: "2", key: "iecqi9" }],
  ["line", { x1: "6", x2: "6.01", y1: "6", y2: "6", key: "16zg32" }],
  ["line", { x1: "6", x2: "6.01", y1: "18", y2: "18", key: "nzw8ys" }]
]);
const bg = n("settings-2", [
  ["path", { d: "M20 7h-9", key: "3s1dr2" }],
  ["path", { d: "M14 17H5", key: "gfn3mx" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["circle", { cx: "7", cy: "7", r: "3", key: "dfmy0x" }]
]);
const xg = n("settings", [
  [
    "path",
    {
      d: "M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z",
      key: "1qme2f"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
]);
const wg = n("shapes", [
  [
    "path",
    {
      d: "M8.3 10a.7.7 0 0 1-.626-1.079L11.4 3a.7.7 0 0 1 1.198-.043L16.3 8.9a.7.7 0 0 1-.572 1.1Z",
      key: "1bo67w"
    }
  ],
  ["rect", { x: "3", y: "14", width: "7", height: "7", rx: "1", key: "1bkyp8" }],
  ["circle", { cx: "17.5", cy: "17.5", r: "3.5", key: "w3z12y" }]
]);
const Lg = n("share-2", [
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }],
  ["circle", { cx: "6", cy: "12", r: "3", key: "w7nqdw" }],
  ["circle", { cx: "18", cy: "19", r: "3", key: "1xt0gg" }],
  ["line", { x1: "8.59", x2: "15.42", y1: "13.51", y2: "17.49", key: "47mynk" }],
  ["line", { x1: "15.41", x2: "8.59", y1: "6.51", y2: "10.49", key: "1n3mei" }]
]);
const Sg = n("share", [
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["polyline", { points: "16 6 12 2 8 6", key: "m901s6" }],
  ["line", { x1: "12", x2: "12", y1: "2", y2: "15", key: "1p0rca" }]
]);
const Ig = n("sheet", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "3", x2: "21", y1: "9", y2: "9", key: "1vqk6q" }],
  ["line", { x1: "3", x2: "21", y1: "15", y2: "15", key: "o2sbyz" }],
  ["line", { x1: "9", x2: "9", y1: "9", y2: "21", key: "1ib60c" }],
  ["line", { x1: "15", x2: "15", y1: "9", y2: "21", key: "1n26ft" }]
]);
const Cg = n("shell", [
  [
    "path",
    {
      d: "M14 11a2 2 0 1 1-4 0 4 4 0 0 1 8 0 6 6 0 0 1-12 0 8 8 0 0 1 16 0 10 10 0 1 1-20 0 11.93 11.93 0 0 1 2.42-7.22 2 2 0 1 1 3.16 2.44",
      key: "1cn552"
    }
  ]
]);
const Ag = n("shield-alert", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 8v4", key: "1got3b" }],
  ["path", { d: "M12 16h.01", key: "1drbdi" }]
]);
const qg = n("shield-ban", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m4.243 5.21 14.39 12.472", key: "1c9a7c" }]
]);
const zg = n("shield-check", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const Pg = n("shield-ellipsis", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M8 12h.01", key: "czm47f" }],
  ["path", { d: "M12 12h.01", key: "1mp3jc" }],
  ["path", { d: "M16 12h.01", key: "1l6xoz" }]
]);
const _g = n("shield-half", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M12 22V2", key: "zs6s6o" }]
]);
const jg = n("shield-minus", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
const Hg = n("shield-off", [
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "M5 5a1 1 0 0 0-1 1v7c0 5 3.5 7.5 7.67 8.94a1 1 0 0 0 .67.01c2.35-.82 4.48-1.97 5.9-3.71",
      key: "1jlk70"
    }
  ],
  [
    "path",
    {
      d: "M9.309 3.652A12.252 12.252 0 0 0 11.24 2.28a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1v7a9.784 9.784 0 0 1-.08 1.264",
      key: "18rp1v"
    }
  ]
]);
const Vg = n("shield-plus", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
const Bg = n("shield-question", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M9.1 9a3 3 0 0 1 5.82 1c0 2-3 3-3 3", key: "mhlwft" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const Sn = n("shield-x", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "m14.5 9.5-5 5", key: "17q4r4" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
const Dg = n("shield-user", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M6.376 18.91a6 6 0 0 1 11.249.003", key: "hnjrf2" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }]
]);
const Tg = n("shield", [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ]
]);
const $g = n("ship-wheel", [
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }],
  ["path", { d: "M12 2v7.5", key: "1e5rl5" }],
  ["path", { d: "m19 5-5.23 5.23", key: "1ezxxf" }],
  ["path", { d: "M22 12h-7.5", key: "le1719" }],
  ["path", { d: "m19 19-5.23-5.23", key: "p3fmgn" }],
  ["path", { d: "M12 14.5V22", key: "dgcmos" }],
  ["path", { d: "M10.23 13.77 5 19", key: "qwopd4" }],
  ["path", { d: "M9.5 12H2", key: "r7bup8" }],
  ["path", { d: "M10.23 10.23 5 5", key: "k2y7lj" }],
  ["circle", { cx: "12", cy: "12", r: "2.5", key: "ix0uyj" }]
]);
const Og = n("ship", [
  ["path", { d: "M12 10.189V14", key: "1p8cqu" }],
  ["path", { d: "M12 2v3", key: "qbqxhf" }],
  ["path", { d: "M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6", key: "qpkstq" }],
  [
    "path",
    {
      d: "M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76",
      key: "7tigtc"
    }
  ],
  [
    "path",
    {
      d: "M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "1924j5"
    }
  ]
]);
const Rg = n("shirt", [
  [
    "path",
    {
      d: "M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z",
      key: "1wgbhj"
    }
  ]
]);
const Fg = n("shopping-bag", [
  ["path", { d: "M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z", key: "hou9p0" }],
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M16 10a4 4 0 0 1-8 0", key: "1ltviw" }]
]);
const Eg = n("shopping-basket", [
  ["path", { d: "m15 11-1 9", key: "5wnq3a" }],
  ["path", { d: "m19 11-4-7", key: "cnml18" }],
  ["path", { d: "M2 11h20", key: "3eubbj" }],
  ["path", { d: "m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4", key: "yiazzp" }],
  ["path", { d: "M4.5 15.5h15", key: "13mye1" }],
  ["path", { d: "m5 11 4-7", key: "116ra9" }],
  ["path", { d: "m9 11 1 9", key: "1ojof7" }]
]);
const Ug = n("shopping-cart", [
  ["circle", { cx: "8", cy: "21", r: "1", key: "jimo8o" }],
  ["circle", { cx: "19", cy: "21", r: "1", key: "13723u" }],
  [
    "path",
    {
      d: "M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12",
      key: "9zh506"
    }
  ]
]);
const Ng = n("shovel", [
  ["path", { d: "M2 22v-5l5-5 5 5-5 5z", key: "1fh25c" }],
  ["path", { d: "M9.5 14.5 16 8", key: "1smz5x" }],
  [
    "path",
    { d: "m17 2 5 5-.5.5a3.53 3.53 0 0 1-5 0s0 0 0 0a3.53 3.53 0 0 1 0-5L17 2", key: "1q8uv5" }
  ]
]);
const Wg = n("shower-head", [
  ["path", { d: "m4 4 2.5 2.5", key: "uv2vmf" }],
  ["path", { d: "M13.5 6.5a4.95 4.95 0 0 0-7 7", key: "frdkwv" }],
  ["path", { d: "M15 5 5 15", key: "1ag8rq" }],
  ["path", { d: "M14 17v.01", key: "eokfpp" }],
  ["path", { d: "M10 16v.01", key: "14uyyl" }],
  ["path", { d: "M13 13v.01", key: "1v1k97" }],
  ["path", { d: "M16 10v.01", key: "5169yg" }],
  ["path", { d: "M11 20v.01", key: "cj92p8" }],
  ["path", { d: "M17 14v.01", key: "11cswd" }],
  ["path", { d: "M20 11v.01", key: "19e0od" }]
]);
const Gg = n("shrimp", [
  ["path", { d: "M11 12h.01", key: "1lr4k6" }],
  ["path", { d: "M13 22c.5-.5 1.12-1 2.5-1-1.38 0-2-.5-2.5-1", key: "fatpdi" }],
  [
    "path",
    {
      d: "M14 2a3.28 3.28 0 0 1-3.227 1.798l-6.17-.561A2.387 2.387 0 1 0 4.387 8H15.5a1 1 0 0 1 0 13 1 1 0 0 0 0-5H12a7 7 0 0 1-7-7V8",
      key: "kehrqe"
    }
  ],
  ["path", { d: "M14 8a8.5 8.5 0 0 1 0 8", key: "1imjx2" }],
  ["path", { d: "M16 16c2 0 4.5-4 4-6", key: "z0nejz" }]
]);
const Zg = n("shrub", [
  ["path", { d: "M12 22v-7l-2-2", key: "eqv9mc" }],
  ["path", { d: "M17 8v.8A6 6 0 0 1 13.8 20H10A6.5 6.5 0 0 1 7 8a5 5 0 0 1 10 0Z", key: "ubcgy" }],
  ["path", { d: "m14 14-2 2", key: "847xa2" }]
]);
const Yg = n("shrink", [
  ["path", { d: "m15 15 6 6m-6-6v4.8m0-4.8h4.8", key: "17vawe" }],
  ["path", { d: "M9 19.8V15m0 0H4.2M9 15l-6 6", key: "chjx8e" }],
  ["path", { d: "M15 4.2V9m0 0h4.8M15 9l6-6", key: "lav6yq" }],
  ["path", { d: "M9 4.2V9m0 0H4.2M9 9 3 3", key: "1pxi2q" }]
]);
const Kg = n("shuffle", [
  ["path", { d: "m18 14 4 4-4 4", key: "10pe0f" }],
  ["path", { d: "m18 2 4 4-4 4", key: "pucp1d" }],
  ["path", { d: "M2 18h1.973a4 4 0 0 0 3.3-1.7l5.454-8.6a4 4 0 0 1 3.3-1.7H22", key: "1ailkh" }],
  ["path", { d: "M2 6h1.972a4 4 0 0 1 3.6 2.2", key: "km57vx" }],
  ["path", { d: "M22 18h-6.041a4 4 0 0 1-3.3-1.8l-.359-.45", key: "os18l9" }]
]);
const Xg = n("sigma", [
  [
    "path",
    {
      d: "M18 7V5a1 1 0 0 0-1-1H6.5a.5.5 0 0 0-.4.8l4.5 6a2 2 0 0 1 0 2.4l-4.5 6a.5.5 0 0 0 .4.8H17a1 1 0 0 0 1-1v-2",
      key: "wuwx1p"
    }
  ]
]);
const Qg = n("signal-high", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }]
]);
const Jg = n("signal-low", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }]
]);
const e7 = n("signal-medium", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }]
]);
const t7 = n("signal-zero", [["path", { d: "M2 20h.01", key: "4haj6o" }]]);
const a7 = n("signal", [
  ["path", { d: "M2 20h.01", key: "4haj6o" }],
  ["path", { d: "M7 20v-4", key: "j294jx" }],
  ["path", { d: "M12 20v-8", key: "i3yub9" }],
  ["path", { d: "M17 20V8", key: "1tkaf5" }],
  ["path", { d: "M22 4v16", key: "sih9yq" }]
]);
const n7 = n("signature", [
  [
    "path",
    {
      d: "m21 17-2.156-1.868A.5.5 0 0 0 18 15.5v.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1c0-2.545-3.991-3.97-8.5-4a1 1 0 0 0 0 5c4.153 0 4.745-11.295 5.708-13.5a2.5 2.5 0 1 1 3.31 3.284",
      key: "y32ogt"
    }
  ],
  ["path", { d: "M3 21h18", key: "itz85i" }]
]);
const o7 = n("signpost-big", [
  ["path", { d: "M10 9H4L2 7l2-2h6", key: "1hq7x2" }],
  ["path", { d: "M14 5h6l2 2-2 2h-6", key: "bv62ej" }],
  ["path", { d: "M10 22V4a2 2 0 1 1 4 0v18", key: "eqpcf2" }],
  ["path", { d: "M8 22h8", key: "rmew8v" }]
]);
const r7 = n("signpost", [
  ["path", { d: "M12 13v8", key: "1l5pq0" }],
  ["path", { d: "M12 3v3", key: "1n5kay" }],
  [
    "path",
    {
      d: "M18 6a2 2 0 0 1 1.387.56l2.307 2.22a1 1 0 0 1 0 1.44l-2.307 2.22A2 2 0 0 1 18 13H6a2 2 0 0 1-1.387-.56l-2.306-2.22a1 1 0 0 1 0-1.44l2.306-2.22A2 2 0 0 1 6 6z",
      key: "gqqp9m"
    }
  ]
]);
const l7 = n("siren", [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
]);
const i7 = n("skip-back", [
  ["polygon", { points: "19 20 9 12 19 4 19 20", key: "o2sva" }],
  ["line", { x1: "5", x2: "5", y1: "19", y2: "5", key: "1ocqjk" }]
]);
const c7 = n("skip-forward", [
  ["polygon", { points: "5 4 15 12 5 20 5 4", key: "16p6eg" }],
  ["line", { x1: "19", x2: "19", y1: "5", y2: "19", key: "futhcm" }]
]);
const d7 = n("skull", [
  ["path", { d: "m12.5 17-.5-1-.5 1h1z", key: "3me087" }],
  [
    "path",
    {
      d: "M15 22a1 1 0 0 0 1-1v-1a2 2 0 0 0 1.56-3.25 8 8 0 1 0-11.12 0A2 2 0 0 0 8 20v1a1 1 0 0 0 1 1z",
      key: "1o5pge"
    }
  ],
  ["circle", { cx: "15", cy: "12", r: "1", key: "1tmaij" }],
  ["circle", { cx: "9", cy: "12", r: "1", key: "1vctgf" }]
]);
const s7 = n("slack", [
  ["rect", { width: "3", height: "8", x: "13", y: "2", rx: "1.5", key: "diqz80" }],
  ["path", { d: "M19 8.5V10h1.5A1.5 1.5 0 1 0 19 8.5", key: "183iwg" }],
  ["rect", { width: "3", height: "8", x: "8", y: "14", rx: "1.5", key: "hqg7r1" }],
  ["path", { d: "M5 15.5V14H3.5A1.5 1.5 0 1 0 5 15.5", key: "76g71w" }],
  ["rect", { width: "8", height: "3", x: "14", y: "13", rx: "1.5", key: "1kmz0a" }],
  ["path", { d: "M15.5 19H14v1.5a1.5 1.5 0 1 0 1.5-1.5", key: "jc4sz0" }],
  ["rect", { width: "8", height: "3", x: "2", y: "8", rx: "1.5", key: "1omvl4" }],
  ["path", { d: "M8.5 5H10V3.5A1.5 1.5 0 1 0 8.5 5", key: "16f3cl" }]
]);
const u7 = n("slash", [["path", { d: "M22 2 2 22", key: "y4kqgn" }]]);
const h7 = n("slice", [
  [
    "path",
    {
      d: "M11 16.586V19a1 1 0 0 1-1 1H2L18.37 3.63a1 1 0 1 1 3 3l-9.663 9.663a1 1 0 0 1-1.414 0L8 14",
      key: "1sllp5"
    }
  ]
]);
const p7 = n("sliders-horizontal", [
  ["line", { x1: "21", x2: "14", y1: "4", y2: "4", key: "obuewd" }],
  ["line", { x1: "10", x2: "3", y1: "4", y2: "4", key: "1q6298" }],
  ["line", { x1: "21", x2: "12", y1: "12", y2: "12", key: "1iu8h1" }],
  ["line", { x1: "8", x2: "3", y1: "12", y2: "12", key: "ntss68" }],
  ["line", { x1: "21", x2: "16", y1: "20", y2: "20", key: "14d8ph" }],
  ["line", { x1: "12", x2: "3", y1: "20", y2: "20", key: "m0wm8r" }],
  ["line", { x1: "14", x2: "14", y1: "2", y2: "6", key: "14e1ph" }],
  ["line", { x1: "8", x2: "8", y1: "10", y2: "14", key: "1i6ji0" }],
  ["line", { x1: "16", x2: "16", y1: "18", y2: "22", key: "1lctlv" }]
]);
const In = n("sliders-vertical", [
  ["line", { x1: "4", x2: "4", y1: "21", y2: "14", key: "1p332r" }],
  ["line", { x1: "4", x2: "4", y1: "10", y2: "3", key: "gb41h5" }],
  ["line", { x1: "12", x2: "12", y1: "21", y2: "12", key: "hf2csr" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "3", key: "1kfi7u" }],
  ["line", { x1: "20", x2: "20", y1: "21", y2: "16", key: "1lhrwl" }],
  ["line", { x1: "20", x2: "20", y1: "12", y2: "3", key: "16vvfq" }],
  ["line", { x1: "2", x2: "6", y1: "14", y2: "14", key: "1uebub" }],
  ["line", { x1: "10", x2: "14", y1: "8", y2: "8", key: "1yglbp" }],
  ["line", { x1: "18", x2: "22", y1: "16", y2: "16", key: "1jxqpz" }]
]);
const y7 = n("smartphone-charging", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12.667 8 10 12h4l-2.667 4", key: "h9lk2d" }]
]);
const k7 = n("smartphone-nfc", [
  ["rect", { width: "7", height: "12", x: "2", y: "6", rx: "1", key: "5nje8w" }],
  ["path", { d: "M13 8.32a7.43 7.43 0 0 1 0 7.36", key: "1g306n" }],
  ["path", { d: "M16.46 6.21a11.76 11.76 0 0 1 0 11.58", key: "uqvjvo" }],
  ["path", { d: "M19.91 4.1a15.91 15.91 0 0 1 .01 15.8", key: "ujntz3" }]
]);
const m7 = n("smartphone", [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
]);
const f7 = n("smile-plus", [
  ["path", { d: "M22 11v1a10 10 0 1 1-9-10", key: "ew0xw9" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }],
  ["path", { d: "M16 5h6", key: "1vod17" }],
  ["path", { d: "M19 2v6", key: "4bpg5p" }]
]);
const v7 = n("smile", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 14s1.5 2 4 2 4-2 4-2", key: "1y1vjs" }],
  ["line", { x1: "9", x2: "9.01", y1: "9", y2: "9", key: "yxxnd0" }],
  ["line", { x1: "15", x2: "15.01", y1: "9", y2: "9", key: "1p4y9e" }]
]);
const g7 = n("snail", [
  ["path", { d: "M2 13a6 6 0 1 0 12 0 4 4 0 1 0-8 0 2 2 0 0 0 4 0", key: "hneq2s" }],
  ["circle", { cx: "10", cy: "13", r: "8", key: "194lz3" }],
  ["path", { d: "M2 21h12c4.4 0 8-3.6 8-8V7a2 2 0 1 0-4 0v6", key: "ixqyt7" }],
  ["path", { d: "M18 3 19.1 5.2", key: "9tjm43" }],
  ["path", { d: "M22 3 20.9 5.2", key: "j3odrs" }]
]);
const M7 = n("snowflake", [
  ["path", { d: "m10 20-1.25-2.5L6 18", key: "18frcb" }],
  ["path", { d: "M10 4 8.75 6.5 6 6", key: "7mghy3" }],
  ["path", { d: "m14 20 1.25-2.5L18 18", key: "1chtki" }],
  ["path", { d: "m14 4 1.25 2.5L18 6", key: "1b4wsy" }],
  ["path", { d: "m17 21-3-6h-4", key: "15hhxa" }],
  ["path", { d: "m17 3-3 6 1.5 3", key: "11697g" }],
  ["path", { d: "M2 12h6.5L10 9", key: "kv9z4n" }],
  ["path", { d: "m20 10-1.5 2 1.5 2", key: "1swlpi" }],
  ["path", { d: "M22 12h-6.5L14 15", key: "1mxi28" }],
  ["path", { d: "m4 10 1.5 2L4 14", key: "k9enpj" }],
  ["path", { d: "m7 21 3-6-1.5-3", key: "j8hb9u" }],
  ["path", { d: "m7 3 3 6h4", key: "1otusx" }]
]);
const b7 = n("sofa", [
  ["path", { d: "M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3", key: "1dgpiv" }],
  [
    "path",
    {
      d: "M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z",
      key: "xacw8m"
    }
  ],
  ["path", { d: "M4 18v2", key: "jwo5n2" }],
  ["path", { d: "M20 18v2", key: "1ar1qi" }],
  ["path", { d: "M12 4v9", key: "oqhhn3" }]
]);
const x7 = n("soup", [
  ["path", { d: "M12 21a9 9 0 0 0 9-9H3a9 9 0 0 0 9 9Z", key: "4rw317" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M19.5 12 22 6", key: "shfsr5" }],
  [
    "path",
    {
      d: "M16.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.73 1.62",
      key: "rpc6vp"
    }
  ],
  [
    "path",
    {
      d: "M11.25 3c.27.1.8.53.74 1.36-.05.83-.93 1.2-.98 2.02-.06.78.33 1.24.72 1.62",
      key: "1lf63m"
    }
  ],
  [
    "path",
    { d: "M6.25 3c.27.1.8.53.75 1.36-.06.83-.93 1.2-1 2.02-.05.78.34 1.24.74 1.62", key: "97tijn" }
  ]
]);
const w7 = n("space", [
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
const L7 = n("spade", [
  [
    "path",
    {
      d: "M5 9c-1.5 1.5-3 3.2-3 5.5A5.5 5.5 0 0 0 7.5 20c1.8 0 3-.5 4.5-2 1.5 1.5 2.7 2 4.5 2a5.5 5.5 0 0 0 5.5-5.5c0-2.3-1.5-4-3-5.5l-7-7-7 7Z",
      key: "40bo9n"
    }
  ],
  ["path", { d: "M12 18v4", key: "jadmvz" }]
]);
const S7 = n("sparkle", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ]
]);
const Cn = n("sparkles", [
  [
    "path",
    {
      d: "M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z",
      key: "4pj2yx"
    }
  ],
  ["path", { d: "M20 3v4", key: "1olli1" }],
  ["path", { d: "M22 5h-4", key: "1gvqau" }],
  ["path", { d: "M4 17v2", key: "vumght" }],
  ["path", { d: "M5 18H3", key: "zchphs" }]
]);
const I7 = n("speaker", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", key: "1nb95v" }],
  ["path", { d: "M12 6h.01", key: "1vi96p" }],
  ["circle", { cx: "12", cy: "14", r: "4", key: "1jruaj" }],
  ["path", { d: "M12 14h.01", key: "1etili" }]
]);
const C7 = n("speech", [
  [
    "path",
    {
      d: "M8.8 20v-4.1l1.9.2a2.3 2.3 0 0 0 2.164-2.1V8.3A5.37 5.37 0 0 0 2 8.25c0 2.8.656 3.054 1 4.55a5.77 5.77 0 0 1 .029 2.758L2 20",
      key: "11atix"
    }
  ],
  ["path", { d: "M19.8 17.8a7.5 7.5 0 0 0 .003-10.603", key: "yol142" }],
  ["path", { d: "M17 15a3.5 3.5 0 0 0-.025-4.975", key: "ssbmkc" }]
]);
const A7 = n("spell-check-2", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  [
    "path",
    {
      d: "M4 21c1.1 0 1.1-1 2.3-1s1.1 1 2.3 1c1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1 1.1 0 1.1 1 2.3 1 1.1 0 1.1-1 2.3-1",
      key: "8mdmtu"
    }
  ]
]);
const q7 = n("spell-check", [
  ["path", { d: "m6 16 6-12 6 12", key: "1b4byz" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m16 20 2 2 4-4", key: "13tcca" }]
]);
const z7 = n("spline-pointer", [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }],
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }]
]);
const P7 = n("spline", [
  ["circle", { cx: "19", cy: "5", r: "2", key: "mhkx31" }],
  ["circle", { cx: "5", cy: "19", r: "2", key: "v8kfzx" }],
  ["path", { d: "M5 17A12 12 0 0 1 17 5", key: "1okkup" }]
]);
const _7 = n("split", [
  ["path", { d: "M16 3h5v5", key: "1806ms" }],
  ["path", { d: "M8 3H3v5", key: "15dfkv" }],
  ["path", { d: "M12 22v-8.3a4 4 0 0 0-1.172-2.872L3 3", key: "1qrqzj" }],
  ["path", { d: "m15 9 6-6", key: "ko1vev" }]
]);
const j7 = n("spray-can", [
  ["path", { d: "M3 3h.01", key: "159qn6" }],
  ["path", { d: "M7 5h.01", key: "1hq22a" }],
  ["path", { d: "M11 7h.01", key: "1osv80" }],
  ["path", { d: "M3 7h.01", key: "1xzrh3" }],
  ["path", { d: "M7 9h.01", key: "19b3jx" }],
  ["path", { d: "M3 11h.01", key: "1eifu7" }],
  ["rect", { width: "4", height: "4", x: "15", y: "5", key: "mri9e4" }],
  ["path", { d: "m19 9 2 2v10c0 .6-.4 1-1 1h-6c-.6 0-1-.4-1-1V11l2-2", key: "aib6hk" }],
  ["path", { d: "m13 14 8-2", key: "1d7bmk" }],
  ["path", { d: "m13 19 8-2", key: "1y2vml" }]
]);
const H7 = n("sprout", [
  ["path", { d: "M7 20h10", key: "e6iznv" }],
  ["path", { d: "M10 20c5.5-2.5.8-6.4 3-10", key: "161w41" }],
  [
    "path",
    {
      d: "M9.5 9.4c1.1.8 1.8 2.2 2.3 3.7-2 .4-3.5.4-4.8-.3-1.2-.6-2.3-1.9-3-4.2 2.8-.5 4.4 0 5.5.8z",
      key: "9gtqwd"
    }
  ],
  [
    "path",
    {
      d: "M14.1 6a7 7 0 0 0-1.1 4c1.9-.1 3.3-.6 4.3-1.4 1-1 1.6-2.3 1.7-4.6-2.7.1-4 1-4.9 2z",
      key: "bkxnd2"
    }
  ]
]);
const An = n("square-activity", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M17 12h-2l-2 5-2-10-2 5H7", key: "15hlnc" }]
]);
const qn = n("square-arrow-down-left", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 8-8 8", key: "166keh" }],
  ["path", { d: "M16 16H8V8", key: "1w2ppm" }]
]);
const zn = n("square-arrow-down-right", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "M16 8v8H8", key: "1lbpgo" }]
]);
const Pn = n("square-arrow-down", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8 12 4 4 4-4", key: "k98ssh" }]
]);
const _n = n("square-arrow-left", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m12 8-4 4 4 4", key: "15vm53" }],
  ["path", { d: "M16 12H8", key: "1fr5h0" }]
]);
const jn = n("square-arrow-out-down-left", [
  ["path", { d: "M13 21h6a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6", key: "14qz4y" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
]);
const Hn = n("square-arrow-out-down-right", [
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }],
  ["path", { d: "m21 21-9-9", key: "1et2py" }],
  ["path", { d: "M21 15v6h-6", key: "1jko0i" }]
]);
const Vn = n("square-arrow-out-up-left", [
  ["path", { d: "M13 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-6", key: "14mv1t" }],
  ["path", { d: "m3 3 9 9", key: "rks13r" }],
  ["path", { d: "M3 9V3h6", key: "ira0h2" }]
]);
const Bn = n("square-arrow-out-up-right", [
  ["path", { d: "M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6", key: "y09zxi" }],
  ["path", { d: "m21 3-9 9", key: "mpx6sq" }],
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }]
]);
const Dn = n("square-arrow-right", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "m12 16 4-4-4-4", key: "1i9zcv" }]
]);
const Tn = n("square-arrow-up-left", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8h8", key: "19xb1h" }],
  ["path", { d: "M16 16 8 8", key: "1qdy8n" }]
]);
const $n = n("square-arrow-up-right", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 8h8v8", key: "b65dnt" }],
  ["path", { d: "m8 16 8-8", key: "13b9ih" }]
]);
const On = n("square-arrow-up", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 12-4-4-4 4", key: "177agl" }],
  ["path", { d: "M12 16V8", key: "1sbj14" }]
]);
const Rn = n("square-asterisk", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 8v8", key: "napkw2" }],
  ["path", { d: "m8.5 14 7-4", key: "12hpby" }],
  ["path", { d: "m8.5 10 7 4", key: "wwy2dy" }]
]);
const Fn = n("square-bottom-dashed-scissors", [
  [
    "path",
    { d: "M4 22a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2", key: "1vzg26" }
  ],
  ["path", { d: "M10 22H8", key: "euku7a" }],
  ["path", { d: "M16 22h-2", key: "18d249" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
const Bt = n("square-chart-gantt", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 8h7", key: "kbo1nt" }],
  ["path", { d: "M8 12h6", key: "ikassy" }],
  ["path", { d: "M11 16h5", key: "oq65wt" }]
]);
const En = n("square-check-big", [
  ["path", { d: "M21 10.5V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h12.5", key: "1uzm8b" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
]);
const Un = n("square-check", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const Nn = n("square-chevron-down", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m16 10-4 4-4-4", key: "894hmk" }]
]);
const Wn = n("square-chevron-left", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m14 16-4-4 4-4", key: "ojs7w8" }]
]);
const Gn = n("square-chevron-right", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m10 8 4 4-4 4", key: "1wy4r4" }]
]);
const Zn = n("square-chevron-up", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m8 14 4-4 4 4", key: "fy2ptz" }]
]);
const Yn = n("square-code", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const V7 = n("square-dashed-bottom-code", [
  ["path", { d: "M10 9.5 8 12l2 2.5", key: "3mjy60" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "m14 9.5 2 2.5-2 2.5", key: "1bir2l" }],
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }]
]);
const B7 = n("square-dashed-bottom", [
  [
    "path",
    { d: "M5 21a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2", key: "as5y1o" }
  ],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }]
]);
const Kn = n("square-dashed-kanban", [
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }]
]);
const Xn = n("square-dashed-mouse-pointer", [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h2", key: "1qve2z" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v2", key: "p14lih" }],
  ["path", { d: "M3 14v1", key: "vnatye" }]
]);
const Qn = n("square-dashed", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }]
]);
const Jn = n("square-dot", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }]
]);
const eo = n("square-divide", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["line", { x1: "8", x2: "16", y1: "12", y2: "12", key: "1jonct" }],
  ["line", { x1: "12", x2: "12", y1: "16", y2: "16", key: "aqc6ln" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "8", key: "1mkcni" }]
]);
const to = n("square-equal", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M7 14h10", key: "1mhdw3" }]
]);
const ao = n("square-function", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "M9 17c2 0 2.8-1 2.8-2.8V10c0-2 1-3.3 3.2-3", key: "m1af9g" }],
  ["path", { d: "M9 11.2h5.7", key: "3zgcl2" }]
]);
const no = n("square-kanban", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 7v7", key: "1x2jlm" }],
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M16 7v9", key: "1hp2iy" }]
]);
const oo = n("square-library", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7v10", key: "d5nglc" }],
  ["path", { d: "M11 7v10", key: "pptsnr" }],
  ["path", { d: "m15 7 2 10", key: "1m7qm5" }]
]);
const ro = n("square-m", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 16V8l4 4 4-4v8", key: "141u4e" }]
]);
const lo = n("square-menu", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 8h10", key: "1jw688" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["path", { d: "M7 16h10", key: "wp8him" }]
]);
const io = n("square-minus", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }]
]);
const co = n("square-mouse-pointer", [
  [
    "path",
    {
      d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z",
      key: "xwnzip"
    }
  ],
  ["path", { d: "M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6", key: "14rsvq" }]
]);
const so = n("square-parking-off", [
  ["path", { d: "M3.6 3.6A2 2 0 0 1 5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-.59 1.41", key: "9l1ft6" }],
  ["path", { d: "M3 8.7V19a2 2 0 0 0 2 2h10.3", key: "17knke" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M13 13a3 3 0 1 0 0-6H9v2", key: "uoagbd" }],
  ["path", { d: "M9 17v-2.3", key: "1jxgo2" }]
]);
const uo = n("square-parking", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 17V7h4a3 3 0 0 1 0 6H9", key: "1dfk2c" }]
]);
const xt = n("square-pen", [
  ["path", { d: "M12 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7", key: "1m0v6g" }],
  [
    "path",
    {
      d: "M18.375 2.625a1 1 0 0 1 3 3l-9.013 9.014a2 2 0 0 1-.853.505l-2.873.84a.5.5 0 0 1-.62-.62l.84-2.873a2 2 0 0 1 .506-.852z",
      key: "ohrbg2"
    }
  ]
]);
const ho = n("square-percent", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
const po = n("square-pi", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M7 7h10", key: "udp07y" }],
  ["path", { d: "M10 7v10", key: "i1d9ee" }],
  ["path", { d: "M16 17a2 2 0 0 1-2-2V7", key: "ftwdc7" }]
]);
const yo = n("square-pilcrow", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M12 12H9.5a2.5 2.5 0 0 1 0-5H17", key: "1l9586" }],
  ["path", { d: "M12 7v10", key: "jspqdw" }],
  ["path", { d: "M16 7v10", key: "lavkr4" }]
]);
const ko = n("square-play", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "m9 8 6 4-6 4Z", key: "f1r3lt" }]
]);
const mo = n("square-plus", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
]);
const fo = n("square-power", [
  ["path", { d: "M12 7v4", key: "xawao1" }],
  ["path", { d: "M7.998 9.003a5 5 0 1 0 8-.005", key: "1pek45" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
const D7 = n("square-radical", [
  ["path", { d: "M7 12h2l2 5 2-10h4", key: "1fxv6h" }],
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }]
]);
const T7 = n("square-round-corner", [
  ["path", { d: "M21 11a8 8 0 0 0-8-8", key: "1lxwo5" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1dv2y5" }]
]);
const vo = n("square-scissors", [
  ["rect", { width: "20", height: "20", x: "2", y: "2", rx: "2", key: "1btzen" }],
  ["circle", { cx: "8", cy: "8", r: "2", key: "14cg06" }],
  ["path", { d: "M9.414 9.414 12 12", key: "qz4lzr" }],
  ["path", { d: "M14.8 14.8 18 18", key: "11flf1" }],
  ["circle", { cx: "8", cy: "16", r: "2", key: "1acxsx" }],
  ["path", { d: "m18 6-8.586 8.586", key: "11kzk1" }]
]);
const go = n("square-sigma", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M16 8.9V7H8l4 5-4 5h8v-1.9", key: "9nih0i" }]
]);
const Mo = n("square-slash", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["line", { x1: "9", x2: "15", y1: "15", y2: "9", key: "1dfufj" }]
]);
const bo = n("square-split-horizontal", [
  ["path", { d: "M8 19H5c-1 0-2-1-2-2V7c0-1 1-2 2-2h3", key: "lubmu8" }],
  ["path", { d: "M16 5h3c1 0 2 1 2 2v10c0 1-1 2-2 2h-3", key: "1ag34g" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
const xo = n("square-split-vertical", [
  ["path", { d: "M5 8V5c0-1 1-2 2-2h10c1 0 2 1 2 2v3", key: "1pi83i" }],
  ["path", { d: "M19 16v3c0 1-1 2-2 2H7c-1 0-2-1-2-2v-3", key: "ido5k7" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
const $7 = n("square-square", [
  ["rect", { x: "3", y: "3", width: "18", height: "18", rx: "2", key: "h1oib" }],
  ["rect", { x: "8", y: "8", width: "8", height: "8", rx: "1", key: "z9xiuo" }]
]);
const O7 = n("square-stack", [
  ["path", { d: "M4 10c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "4i38lg" }],
  ["path", { d: "M10 16c-1.1 0-2-.9-2-2v-4c0-1.1.9-2 2-2h4c1.1 0 2 .9 2 2", key: "mlte4a" }],
  ["rect", { width: "8", height: "8", x: "14", y: "14", rx: "2", key: "1fa9i4" }]
]);
const wo = n("square-terminal", [
  ["path", { d: "m7 11 2-2-2-2", key: "1lz0vl" }],
  ["path", { d: "M11 13h4", key: "1p7l4v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }]
]);
const Lo = n("square-user-round", [
  ["path", { d: "M18 21a6 6 0 0 0-12 0", key: "kaz2du" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const So = n("square-user", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 21v-2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v2", key: "1m6ac2" }]
]);
const Io = n("square-x", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
const R7 = n("square", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const F7 = n("squircle", [
  ["path", { d: "M12 3c7.2 0 9 1.8 9 9s-1.8 9-9 9-9-1.8-9-9 1.8-9 9-9", key: "garfkc" }]
]);
const E7 = n("squirrel", [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
]);
const U7 = n("stamp", [
  ["path", { d: "M5 22h14", key: "ehvnwv" }],
  [
    "path",
    {
      d: "M19.27 13.73A2.5 2.5 0 0 0 17.5 13h-11A2.5 2.5 0 0 0 4 15.5V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1.5c0-.66-.26-1.3-.73-1.77Z",
      key: "1sy9ra"
    }
  ],
  [
    "path",
    { d: "M14 13V8.5C14 7 15 7 15 5a3 3 0 0 0-3-3c-1.66 0-3 1-3 3s1 2 1 3.5V13", key: "cnxgux" }
  ]
]);
const N7 = n("star-half", [
  [
    "path",
    {
      d: "M12 18.338a2.1 2.1 0 0 0-.987.244L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.12 2.12 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.12 2.12 0 0 0 1.597-1.16l2.309-4.679A.53.53 0 0 1 12 2",
      key: "2ksp49"
    }
  ]
]);
const W7 = n("star-off", [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const G7 = n("star", [
  [
    "path",
    {
      d: "M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z",
      key: "r04s7s"
    }
  ]
]);
const Z7 = n("step-back", [
  ["line", { x1: "18", x2: "18", y1: "20", y2: "4", key: "cun8e5" }],
  ["polygon", { points: "14,20 4,12 14,4", key: "ypakod" }]
]);
const Y7 = n("step-forward", [
  ["line", { x1: "6", x2: "6", y1: "4", y2: "20", key: "fy8qot" }],
  ["polygon", { points: "10,4 20,12 10,20", key: "1mc1pf" }]
]);
const K7 = n("stethoscope", [
  ["path", { d: "M11 2v2", key: "1539x4" }],
  ["path", { d: "M5 2v2", key: "1yf1q8" }],
  ["path", { d: "M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1", key: "rb5t3r" }],
  ["path", { d: "M8 15a6 6 0 0 0 12 0v-3", key: "x18d4x" }],
  ["circle", { cx: "20", cy: "10", r: "2", key: "ts1r5v" }]
]);
const X7 = n("sticker", [
  [
    "path",
    { d: "M15.5 3H5a2 2 0 0 0-2 2v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V8.5L15.5 3Z", key: "1wis1t" }
  ],
  ["path", { d: "M14 3v4a2 2 0 0 0 2 2h4", key: "36rjfy" }],
  ["path", { d: "M8 13h.01", key: "1sbv64" }],
  ["path", { d: "M16 13h.01", key: "wip0gl" }],
  ["path", { d: "M10 16s.8 1 2 1c1.3 0 2-1 2-1", key: "1vvgv3" }]
]);
const Q7 = n("sticky-note", [
  ["path", { d: "M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z", key: "qazsjp" }],
  ["path", { d: "M15 3v4a2 2 0 0 0 2 2h4", key: "40519r" }]
]);
const J7 = n("store", [
  ["path", { d: "m2 7 4.41-4.41A2 2 0 0 1 7.83 2h8.34a2 2 0 0 1 1.42.59L22 7", key: "ztvudi" }],
  ["path", { d: "M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8", key: "1b2hhj" }],
  ["path", { d: "M15 22v-4a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2v4", key: "2ebpfo" }],
  ["path", { d: "M2 7h20", key: "1fcdvo" }],
  [
    "path",
    {
      d: "M22 7v3a2 2 0 0 1-2 2a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 16 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 12 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 8 12a2.7 2.7 0 0 1-1.59-.63.7.7 0 0 0-.82 0A2.7 2.7 0 0 1 4 12a2 2 0 0 1-2-2V7",
      key: "6c3vgh"
    }
  ]
]);
const eM = n("stretch-horizontal", [
  ["rect", { width: "20", height: "6", x: "2", y: "4", rx: "2", key: "qdearl" }],
  ["rect", { width: "20", height: "6", x: "2", y: "14", rx: "2", key: "1xrn6j" }]
]);
const tM = n("stretch-vertical", [
  ["rect", { width: "6", height: "20", x: "4", y: "2", rx: "2", key: "19qu7m" }],
  ["rect", { width: "6", height: "20", x: "14", y: "2", rx: "2", key: "24v0nk" }]
]);
const aM = n("strikethrough", [
  ["path", { d: "M16 4H9a3 3 0 0 0-2.83 4", key: "43sutm" }],
  ["path", { d: "M14 12a4 4 0 0 1 0 8H6", key: "nlfj13" }],
  ["line", { x1: "4", x2: "20", y1: "12", y2: "12", key: "1e0a9i" }]
]);
const nM = n("subscript", [
  ["path", { d: "m4 5 8 8", key: "1eunvl" }],
  ["path", { d: "m12 5-8 8", key: "1ah0jp" }],
  [
    "path",
    {
      d: "M20 19h-4c0-1.5.44-2 1.5-2.5S20 15.33 20 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07",
      key: "e8ta8j"
    }
  ]
]);
const oM = n("sun-dim", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 4h.01", key: "1ujb9j" }],
  ["path", { d: "M20 12h.01", key: "1ykeid" }],
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M4 12h.01", key: "158zrr" }],
  ["path", { d: "M17.657 6.343h.01", key: "31pqzk" }],
  ["path", { d: "M17.657 17.657h.01", key: "jehnf4" }],
  ["path", { d: "M6.343 17.657h.01", key: "gdk6ow" }],
  ["path", { d: "M6.343 6.343h.01", key: "1uurf0" }]
]);
const rM = n("sun-medium", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 3v1", key: "1asbbs" }],
  ["path", { d: "M12 20v1", key: "1wcdkc" }],
  ["path", { d: "M3 12h1", key: "lp3yf2" }],
  ["path", { d: "M20 12h1", key: "1vloll" }],
  ["path", { d: "m18.364 5.636-.707.707", key: "1hakh0" }],
  ["path", { d: "m6.343 17.657-.707.707", key: "18m9nf" }],
  ["path", { d: "m5.636 5.636.707.707", key: "1xv1c5" }],
  ["path", { d: "m17.657 17.657.707.707", key: "vl76zb" }]
]);
const lM = n("sun-moon", [
  ["path", { d: "M12 8a2.83 2.83 0 0 0 4 4 4 4 0 1 1-4-4", key: "1fu5g2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.9 4.9 1.4 1.4", key: "b9915j" }],
  ["path", { d: "m17.7 17.7 1.4 1.4", key: "qc3ed3" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.3 17.7-1.4 1.4", key: "5gca6" }],
  ["path", { d: "m19.1 4.9-1.4 1.4", key: "wpu9u6" }]
]);
const iM = n("sun-snow", [
  ["path", { d: "M10 21v-1", key: "1u8rkd" }],
  ["path", { d: "M10 4V3", key: "pkzwkn" }],
  ["path", { d: "M10 9a3 3 0 0 0 0 6", key: "gv75dk" }],
  ["path", { d: "m14 20 1.25-2.5L18 18", key: "1chtki" }],
  ["path", { d: "m14 4 1.25 2.5L18 6", key: "1b4wsy" }],
  ["path", { d: "m17 21-3-6 1.5-3H22", key: "o5qa3v" }],
  ["path", { d: "m17 3-3 6 1.5 3", key: "11697g" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "m20 10-1.5 2 1.5 2", key: "1swlpi" }],
  ["path", { d: "m3.64 18.36.7-.7", key: "105rm9" }],
  ["path", { d: "m4.34 6.34-.7-.7", key: "d3unjp" }]
]);
const cM = n("sun", [
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m4.93 4.93 1.41 1.41", key: "149t6j" }],
  ["path", { d: "m17.66 17.66 1.41 1.41", key: "ptbguv" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "M20 12h2", key: "1q8mjw" }],
  ["path", { d: "m6.34 17.66-1.41 1.41", key: "1m8zz5" }],
  ["path", { d: "m19.07 4.93-1.41 1.41", key: "1shlcs" }]
]);
const dM = n("sunrise", [
  ["path", { d: "M12 2v8", key: "1q4o3n" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m8 6 4-4 4 4", key: "ybng9g" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
const sM = n("sunset", [
  ["path", { d: "M12 10V2", key: "16sf7g" }],
  ["path", { d: "m4.93 10.93 1.41 1.41", key: "2a7f42" }],
  ["path", { d: "M2 18h2", key: "j10viu" }],
  ["path", { d: "M20 18h2", key: "wocana" }],
  ["path", { d: "m19.07 10.93-1.41 1.41", key: "15zs5n" }],
  ["path", { d: "M22 22H2", key: "19qnx5" }],
  ["path", { d: "m16 6-4 4-4-4", key: "6wukr" }],
  ["path", { d: "M16 18a4 4 0 0 0-8 0", key: "1lzouq" }]
]);
const uM = n("superscript", [
  ["path", { d: "m4 19 8-8", key: "hr47gm" }],
  ["path", { d: "m12 19-8-8", key: "1dhhmo" }],
  [
    "path",
    {
      d: "M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 0 0-2.617-.436c-.42.239-.738.614-.899 1.06",
      key: "1dfcux"
    }
  ]
]);
const hM = n("swatch-book", [
  ["path", { d: "M11 17a4 4 0 0 1-8 0V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2Z", key: "1ldrpk" }],
  ["path", { d: "M16.7 13H19a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H7", key: "11i5po" }],
  ["path", { d: "M 7 17h.01", key: "1euzgo" }],
  [
    "path",
    {
      d: "m11 8 2.3-2.3a2.4 2.4 0 0 1 3.404.004L18.6 7.6a2.4 2.4 0 0 1 .026 3.434L9.9 19.8",
      key: "o2gii7"
    }
  ]
]);
const pM = n("swiss-franc", [
  ["path", { d: "M10 21V3h8", key: "br2l0g" }],
  ["path", { d: "M6 16h9", key: "2py0wn" }],
  ["path", { d: "M10 9.5h7", key: "13dmhz" }]
]);
const yM = n("switch-camera", [
  ["path", { d: "M11 19H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h5", key: "mtk2lu" }],
  ["path", { d: "M13 5h7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-5", key: "120jsl" }],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }],
  ["path", { d: "m18 22-3-3 3-3", key: "kgdoj7" }],
  ["path", { d: "m6 2 3 3-3 3", key: "1fnbkv" }]
]);
const kM = n("sword", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }]
]);
const mM = n("swords", [
  ["polyline", { points: "14.5 17.5 3 6 3 3 6 3 17.5 14.5", key: "1hfsw2" }],
  ["line", { x1: "13", x2: "19", y1: "19", y2: "13", key: "1vrmhu" }],
  ["line", { x1: "16", x2: "20", y1: "16", y2: "20", key: "1bron3" }],
  ["line", { x1: "19", x2: "21", y1: "21", y2: "19", key: "13pww6" }],
  ["polyline", { points: "14.5 6.5 18 3 21 3 21 6 17.5 9.5", key: "hbey2j" }],
  ["line", { x1: "5", x2: "9", y1: "14", y2: "18", key: "1hf58s" }],
  ["line", { x1: "7", x2: "4", y1: "17", y2: "20", key: "pidxm4" }],
  ["line", { x1: "3", x2: "5", y1: "19", y2: "21", key: "1pehsh" }]
]);
const fM = n("syringe", [
  ["path", { d: "m18 2 4 4", key: "22kx64" }],
  ["path", { d: "m17 7 3-3", key: "1w1zoj" }],
  ["path", { d: "M19 9 8.7 19.3c-1 1-2.5 1-3.4 0l-.6-.6c-1-1-1-2.5 0-3.4L15 5", key: "1exhtz" }],
  ["path", { d: "m9 11 4 4", key: "rovt3i" }],
  ["path", { d: "m5 19-3 3", key: "59f2uf" }],
  ["path", { d: "m14 4 6 6", key: "yqp9t2" }]
]);
const vM = n("table-2", [
  [
    "path",
    {
      d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18",
      key: "gugj83"
    }
  ]
]);
const gM = n("table-cells-merge", [
  ["path", { d: "M12 21v-6", key: "lihzve" }],
  ["path", { d: "M12 9V3", key: "da5inc" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const MM = n("table-cells-split", [
  ["path", { d: "M12 15V9", key: "8c7uyn" }],
  ["path", { d: "M3 15h18", key: "5xshup" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }]
]);
const bM = n("table-columns-split", [
  ["path", { d: "M14 14v2", key: "w2a1xv" }],
  ["path", { d: "M14 20v2", key: "1lq872" }],
  ["path", { d: "M14 2v2", key: "6buw04" }],
  ["path", { d: "M14 8v2", key: "i67w9a" }],
  ["path", { d: "M2 15h8", key: "82wtch" }],
  ["path", { d: "M2 3h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2", key: "up0l64" }],
  ["path", { d: "M2 9h8", key: "yelfik" }],
  ["path", { d: "M22 15h-4", key: "1es58f" }],
  ["path", { d: "M22 3h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h2", key: "pdjoqf" }],
  ["path", { d: "M22 9h-4", key: "1luja7" }],
  ["path", { d: "M5 3v18", key: "14hmio" }]
]);
const xM = n("table-of-contents", [
  ["path", { d: "M16 12H3", key: "1a2rj7" }],
  ["path", { d: "M16 18H3", key: "12xzn7" }],
  ["path", { d: "M16 6H3", key: "1wxfjs" }],
  ["path", { d: "M21 12h.01", key: "msek7k" }],
  ["path", { d: "M21 18h.01", key: "1e8rq1" }],
  ["path", { d: "M21 6h.01", key: "1koanj" }]
]);
const wM = n("table-properties", [
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M21 9H3", key: "1338ky" }],
  ["path", { d: "M21 15H3", key: "9uk58r" }]
]);
const LM = n("table-rows-split", [
  ["path", { d: "M14 10h2", key: "1lstlu" }],
  ["path", { d: "M15 22v-8", key: "1fwwgm" }],
  ["path", { d: "M15 2v4", key: "1044rn" }],
  ["path", { d: "M2 10h2", key: "1r8dkt" }],
  ["path", { d: "M20 10h2", key: "1ug425" }],
  ["path", { d: "M3 19h18", key: "awlh7x" }],
  ["path", { d: "M3 22v-6a2 2 135 0 1 2-2h14a2 2 45 0 1 2 2v6", key: "ibqhof" }],
  ["path", { d: "M3 2v2a2 2 45 0 0 2 2h14a2 2 135 0 0 2-2V2", key: "1uenja" }],
  ["path", { d: "M8 10h2", key: "66od0" }],
  ["path", { d: "M9 22v-8", key: "fmnu31" }],
  ["path", { d: "M9 2v4", key: "j1yeou" }]
]);
const SM = n("table", [
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9h18", key: "1pudct" }],
  ["path", { d: "M3 15h18", key: "5xshup" }]
]);
const IM = n("tablet-smartphone", [
  ["rect", { width: "10", height: "14", x: "3", y: "8", rx: "2", key: "1vrsiq" }],
  ["path", { d: "M5 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2h-2.4", key: "1j4zmg" }],
  ["path", { d: "M8 18h.01", key: "lrp35t" }]
]);
const CM = n("tablet", [
  ["rect", { width: "16", height: "20", x: "4", y: "2", rx: "2", ry: "2", key: "76otgf" }],
  ["line", { x1: "12", x2: "12.01", y1: "18", y2: "18", key: "1dp563" }]
]);
const AM = n("tablets", [
  ["circle", { cx: "7", cy: "7", r: "5", key: "x29byf" }],
  ["circle", { cx: "17", cy: "17", r: "5", key: "1op1d2" }],
  ["path", { d: "M12 17h10", key: "ls21zv" }],
  ["path", { d: "m3.46 10.54 7.08-7.08", key: "1rehiu" }]
]);
const qM = n("tags", [
  ["path", { d: "m15 5 6.3 6.3a2.4 2.4 0 0 1 0 3.4L17 19", key: "1cbfv1" }],
  [
    "path",
    {
      d: "M9.586 5.586A2 2 0 0 0 8.172 5H3a1 1 0 0 0-1 1v5.172a2 2 0 0 0 .586 1.414L8.29 18.29a2.426 2.426 0 0 0 3.42 0l3.58-3.58a2.426 2.426 0 0 0 0-3.42z",
      key: "135mg7"
    }
  ],
  ["circle", { cx: "6.5", cy: "9.5", r: ".5", fill: "currentColor", key: "5pm5xn" }]
]);
const zM = n("tally-1", [["path", { d: "M4 4v16", key: "6qkkli" }]]);
const PM = n("tag", [
  [
    "path",
    {
      d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z",
      key: "vktsd0"
    }
  ],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }]
]);
const _M = n("tally-2", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }]
]);
const jM = n("tally-3", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }]
]);
const HM = n("tally-4", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }]
]);
const VM = n("tally-5", [
  ["path", { d: "M4 4v16", key: "6qkkli" }],
  ["path", { d: "M9 4v16", key: "81ygyz" }],
  ["path", { d: "M14 4v16", key: "12vmem" }],
  ["path", { d: "M19 4v16", key: "8ij5ei" }],
  ["path", { d: "M22 6 2 18", key: "h9moai" }]
]);
const BM = n("tangent", [
  ["circle", { cx: "17", cy: "4", r: "2", key: "y5j2s2" }],
  ["path", { d: "M15.59 5.41 5.41 15.59", key: "l0vprr" }],
  ["circle", { cx: "4", cy: "17", r: "2", key: "9p4efm" }],
  ["path", { d: "M12 22s-4-9-1.5-11.5S22 12 22 12", key: "1twk4o" }]
]);
const DM = n("target", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const TM = n("telescope", [
  [
    "path",
    {
      d: "m10.065 12.493-6.18 1.318a.934.934 0 0 1-1.108-.702l-.537-2.15a1.07 1.07 0 0 1 .691-1.265l13.504-4.44",
      key: "k4qptu"
    }
  ],
  ["path", { d: "m13.56 11.747 4.332-.924", key: "19l80z" }],
  ["path", { d: "m16 21-3.105-6.21", key: "7oh9d" }],
  [
    "path",
    {
      d: "M16.485 5.94a2 2 0 0 1 1.455-2.425l1.09-.272a1 1 0 0 1 1.212.727l1.515 6.06a1 1 0 0 1-.727 1.213l-1.09.272a2 2 0 0 1-2.425-1.455z",
      key: "m7xp4m"
    }
  ],
  ["path", { d: "m6.158 8.633 1.114 4.456", key: "74o979" }],
  ["path", { d: "m8 21 3.105-6.21", key: "1fvxut" }],
  ["circle", { cx: "12", cy: "13", r: "2", key: "1c1ljs" }]
]);
const $M = n("tent-tree", [
  ["circle", { cx: "4", cy: "4", r: "2", key: "bt5ra8" }],
  ["path", { d: "m14 5 3-3 3 3", key: "1sorif" }],
  ["path", { d: "m14 10 3-3 3 3", key: "1jyi9h" }],
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  ["path", { d: "M17 14H7l-5 8h20Z", key: "13ar7p" }],
  ["path", { d: "M8 14v8", key: "1ghmqk" }],
  ["path", { d: "m9 14 5 8", key: "13pgi6" }]
]);
const OM = n("tent", [
  ["path", { d: "M3.5 21 14 3", key: "1szst5" }],
  ["path", { d: "M20.5 21 10 3", key: "1310c3" }],
  ["path", { d: "M15.5 21 12 15l-3.5 6", key: "1ddtfw" }],
  ["path", { d: "M2 21h20", key: "1nyx9w" }]
]);
const RM = n("terminal", [
  ["polyline", { points: "4 17 10 11 4 5", key: "akl6gq" }],
  ["line", { x1: "12", x2: "20", y1: "19", y2: "19", key: "q2wloq" }]
]);
const Co = n("test-tube-diagonal", [
  [
    "path",
    { d: "M21 7 6.82 21.18a2.83 2.83 0 0 1-3.99-.01a2.83 2.83 0 0 1 0-4L17 3", key: "1ub6xw" }
  ],
  ["path", { d: "m16 2 6 6", key: "1gw87d" }],
  ["path", { d: "M12 16H4", key: "1cjfip" }]
]);
const FM = n("test-tube", [
  ["path", { d: "M14.5 2v17.5c0 1.4-1.1 2.5-2.5 2.5c-1.4 0-2.5-1.1-2.5-2.5V2", key: "125lnx" }],
  ["path", { d: "M8.5 2h7", key: "csnxdl" }],
  ["path", { d: "M14.5 16h-5", key: "1ox875" }]
]);
const EM = n("test-tubes", [
  ["path", { d: "M9 2v17.5A2.5 2.5 0 0 1 6.5 22A2.5 2.5 0 0 1 4 19.5V2", key: "1hjrqt" }],
  ["path", { d: "M20 2v17.5a2.5 2.5 0 0 1-2.5 2.5a2.5 2.5 0 0 1-2.5-2.5V2", key: "16lc8n" }],
  ["path", { d: "M3 2h7", key: "7s29d5" }],
  ["path", { d: "M14 2h7", key: "7sicin" }],
  ["path", { d: "M9 16H4", key: "1bfye3" }],
  ["path", { d: "M20 16h-5", key: "ddnjpe" }]
]);
const UM = n("text-cursor-input", [
  ["path", { d: "M5 4h1a3 3 0 0 1 3 3 3 3 0 0 1 3-3h1", key: "18xjzo" }],
  ["path", { d: "M13 20h-1a3 3 0 0 1-3-3 3 3 0 0 1-3 3H5", key: "fj48gi" }],
  ["path", { d: "M5 16H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h1", key: "1n9rhb" }],
  ["path", { d: "M13 8h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-7", key: "13ksps" }],
  ["path", { d: "M9 7v10", key: "1vc8ob" }]
]);
const NM = n("text-cursor", [
  ["path", { d: "M17 22h-1a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h1", key: "uvaxm9" }],
  ["path", { d: "M7 22h1a4 4 0 0 0 4-4v-1", key: "11xy8d" }],
  ["path", { d: "M7 2h1a4 4 0 0 1 4 4v1", key: "1uw06m" }]
]);
const WM = n("text-quote", [
  ["path", { d: "M17 6H3", key: "16j9eg" }],
  ["path", { d: "M21 12H8", key: "scolzb" }],
  ["path", { d: "M21 18H8", key: "1wfozv" }],
  ["path", { d: "M3 12v6", key: "fv4c87" }]
]);
const GM = n("text-search", [
  ["path", { d: "M21 6H3", key: "1jwq7v" }],
  ["path", { d: "M10 12H3", key: "1ulcyk" }],
  ["path", { d: "M10 18H3", key: "13769t" }],
  ["circle", { cx: "17", cy: "15", r: "3", key: "1upz2a" }],
  ["path", { d: "m21 19-1.9-1.9", key: "dwi7p8" }]
]);
const Ao = n("text-select", [
  ["path", { d: "M5 3a2 2 0 0 0-2 2", key: "y57alp" }],
  ["path", { d: "M19 3a2 2 0 0 1 2 2", key: "18rm91" }],
  ["path", { d: "M21 19a2 2 0 0 1-2 2", key: "1j7049" }],
  ["path", { d: "M5 21a2 2 0 0 1-2-2", key: "sbafld" }],
  ["path", { d: "M9 3h1", key: "1yesri" }],
  ["path", { d: "M9 21h1", key: "15o7lz" }],
  ["path", { d: "M14 3h1", key: "1ec4yj" }],
  ["path", { d: "M14 21h1", key: "v9vybs" }],
  ["path", { d: "M3 9v1", key: "1r0deq" }],
  ["path", { d: "M21 9v1", key: "mxsmne" }],
  ["path", { d: "M3 14v1", key: "vnatye" }],
  ["path", { d: "M21 14v1", key: "169vum" }],
  ["line", { x1: "7", x2: "15", y1: "8", y2: "8", key: "1758g8" }],
  ["line", { x1: "7", x2: "17", y1: "12", y2: "12", key: "197423" }],
  ["line", { x1: "7", x2: "13", y1: "16", y2: "16", key: "37cgm6" }]
]);
const ZM = n("text", [
  ["path", { d: "M17 6.1H3", key: "wptmhv" }],
  ["path", { d: "M21 12.1H3", key: "1j38uz" }],
  ["path", { d: "M15.1 18H3", key: "1nb16a" }]
]);
const YM = n("theater", [
  ["path", { d: "M2 10s3-3 3-8", key: "3xiif0" }],
  ["path", { d: "M22 10s-3-3-3-8", key: "ioaa5q" }],
  ["path", { d: "M10 2c0 4.4-3.6 8-8 8", key: "16fkpi" }],
  ["path", { d: "M14 2c0 4.4 3.6 8 8 8", key: "b9eulq" }],
  ["path", { d: "M2 10s2 2 2 5", key: "1au1lb" }],
  ["path", { d: "M22 10s-2 2-2 5", key: "qi2y5e" }],
  ["path", { d: "M8 15h8", key: "45n4r" }],
  ["path", { d: "M2 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "1vsc2m" }],
  ["path", { d: "M14 22v-1a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v1", key: "hrha4u" }]
]);
const KM = n("thermometer-snowflake", [
  ["path", { d: "m10 20-1.25-2.5L6 18", key: "18frcb" }],
  ["path", { d: "M10 4 8.75 6.5 6 6", key: "7mghy3" }],
  ["path", { d: "M10.585 15H10", key: "4nqulp" }],
  ["path", { d: "M2 12h6.5L10 9", key: "kv9z4n" }],
  ["path", { d: "M20 14.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0z", key: "yu0u2z" }],
  ["path", { d: "m4 10 1.5 2L4 14", key: "k9enpj" }],
  ["path", { d: "m7 21 3-6-1.5-3", key: "j8hb9u" }],
  ["path", { d: "m7 3 3 6h2", key: "1bbqgq" }]
]);
const XM = n("thermometer-sun", [
  ["path", { d: "M12 9a4 4 0 0 0-2 7.5", key: "1jvsq6" }],
  ["path", { d: "M12 3v2", key: "1w22ol" }],
  ["path", { d: "m6.6 18.4-1.4 1.4", key: "w2yidj" }],
  ["path", { d: "M20 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "iof6y5" }],
  ["path", { d: "M4 13H2", key: "118le4" }],
  ["path", { d: "M6.34 7.34 4.93 5.93", key: "1brd51" }]
]);
const QM = n("thermometer", [
  ["path", { d: "M14 4v10.54a4 4 0 1 1-4 0V4a2 2 0 0 1 4 0Z", key: "17jzev" }]
]);
const JM = n("thumbs-down", [
  ["path", { d: "M17 14V2", key: "8ymqnk" }],
  [
    "path",
    {
      d: "M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22a3.13 3.13 0 0 1-3-3.88Z",
      key: "m61m77"
    }
  ]
]);
const e9 = n("thumbs-up", [
  ["path", { d: "M7 10v12", key: "1qc93n" }],
  [
    "path",
    {
      d: "M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2a3.13 3.13 0 0 1 3 3.88Z",
      key: "emmmcr"
    }
  ]
]);
const t9 = n("ticket-check", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
const a9 = n("ticket-minus", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }]
]);
const n9 = n("ticket-percent", [
  [
    "path",
    {
      d: "M2 9a3 3 0 1 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "1l48ns"
    }
  ],
  ["path", { d: "M9 9h.01", key: "1q5me6" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "M15 15h.01", key: "lqbp3k" }]
]);
const o9 = n("ticket-plus", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M9 12h6", key: "1c52cq" }],
  ["path", { d: "M12 9v6", key: "199k2o" }]
]);
const r9 = n("ticket-slash", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }]
]);
const l9 = n("ticket-x", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "m9.5 14.5 5-5", key: "qviqfa" }],
  ["path", { d: "m9.5 9.5 5 5", key: "18nt4w" }]
]);
const i9 = n("ticket", [
  [
    "path",
    {
      d: "M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z",
      key: "qn84l0"
    }
  ],
  ["path", { d: "M13 5v2", key: "dyzc3o" }],
  ["path", { d: "M13 17v2", key: "1ont0d" }],
  ["path", { d: "M13 11v2", key: "1wjjxi" }]
]);
const c9 = n("tickets-plane", [
  ["path", { d: "M10.5 17h1.227a2 2 0 0 0 1.345-.52L18 12", key: "16muxl" }],
  ["path", { d: "m12 13.5 3.75.5", key: "1i9qhk" }],
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
]);
const d9 = n("tickets", [
  ["path", { d: "m4.5 8 10.58-5.06a1 1 0 0 1 1.342.488L18.5 8", key: "12lg5p" }],
  ["path", { d: "M6 10V8", key: "1y41hn" }],
  ["path", { d: "M6 14v1", key: "cao2tf" }],
  ["path", { d: "M6 19v2", key: "1loha6" }],
  ["rect", { x: "2", y: "8", width: "20", height: "13", rx: "2", key: "p3bz5l" }]
]);
const s9 = n("timer-off", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M4.6 11a8 8 0 0 0 1.7 8.7 8 8 0 0 0 8.7 1.7", key: "10he05" }],
  ["path", { d: "M7.4 7.4a8 8 0 0 1 10.3 1 8 8 0 0 1 .9 10.2", key: "15f7sh" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M12 12v-2", key: "fwoke6" }]
]);
const u9 = n("timer-reset", [
  ["path", { d: "M10 2h4", key: "n1abiw" }],
  ["path", { d: "M12 14v-4", key: "1evpnu" }],
  ["path", { d: "M4 13a8 8 0 0 1 8-7 8 8 0 1 1-5.3 14L4 17.6", key: "1ts96g" }],
  ["path", { d: "M9 17H4v5", key: "8t5av" }]
]);
const h9 = n("timer", [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
]);
const p9 = n("toggle-left", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "8", cy: "12", r: "2", key: "1nvbw3" }]
]);
const y9 = n("toggle-right", [
  ["rect", { width: "20", height: "12", x: "2", y: "6", rx: "6", ry: "6", key: "f2vt7d" }],
  ["circle", { cx: "16", cy: "12", r: "2", key: "4ma0v8" }]
]);
const k9 = n("toilet", [
  [
    "path",
    {
      d: "M7 12h13a1 1 0 0 1 1 1 5 5 0 0 1-5 5h-.598a.5.5 0 0 0-.424.765l1.544 2.47a.5.5 0 0 1-.424.765H5.402a.5.5 0 0 1-.424-.765L7 18",
      key: "kc4kqr"
    }
  ],
  ["path", { d: "M8 18a5 5 0 0 1-5-5V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8", key: "1tqs57" }]
]);
const m9 = n("tornado", [
  ["path", { d: "M21 4H3", key: "1hwok0" }],
  ["path", { d: "M18 8H6", key: "41n648" }],
  ["path", { d: "M19 12H9", key: "1g4lpz" }],
  ["path", { d: "M16 16h-6", key: "1j5d54" }],
  ["path", { d: "M11 20H9", key: "39obr8" }]
]);
const f9 = n("torus", [
  ["ellipse", { cx: "12", cy: "11", rx: "3", ry: "2", key: "1b2qxu" }],
  ["ellipse", { cx: "12", cy: "12.5", rx: "10", ry: "8.5", key: "h8emeu" }]
]);
const v9 = n("touchpad-off", [
  ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16", key: "lnt0bk" }],
  ["path", { d: "M2 14h12", key: "d8icqz" }],
  ["path", { d: "M22 14h-2", key: "jrx26d" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10", key: "11y8e4" }]
]);
const g9 = n("touchpad", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 14h20", key: "myj16y" }],
  ["path", { d: "M12 20v-6", key: "1rm09r" }]
]);
const M9 = n("tower-control", [
  [
    "path",
    { d: "M18.2 12.27 20 6H4l1.8 6.27a1 1 0 0 0 .95.73h10.5a1 1 0 0 0 .96-.73Z", key: "1pledb" }
  ],
  ["path", { d: "M8 13v9", key: "hmv0ci" }],
  ["path", { d: "M16 22v-9", key: "ylnf1u" }],
  ["path", { d: "m9 6 1 7", key: "dpdgam" }],
  ["path", { d: "m15 6-1 7", key: "ls7zgu" }],
  ["path", { d: "M12 6V2", key: "1pj48d" }],
  ["path", { d: "M13 2h-2", key: "mj6ths" }]
]);
const b9 = n("toy-brick", [
  ["rect", { width: "18", height: "12", x: "3", y: "8", rx: "1", key: "158fvp" }],
  ["path", { d: "M10 8V5c0-.6-.4-1-1-1H6a1 1 0 0 0-1 1v3", key: "s0042v" }],
  ["path", { d: "M19 8V5c0-.6-.4-1-1-1h-3a1 1 0 0 0-1 1v3", key: "9wmeh2" }]
]);
const x9 = n("tractor", [
  ["path", { d: "m10 11 11 .9a1 1 0 0 1 .8 1.1l-.665 4.158a1 1 0 0 1-.988.842H20", key: "she1j9" }],
  ["path", { d: "M16 18h-5", key: "bq60fd" }],
  ["path", { d: "M18 5a1 1 0 0 0-1 1v5.573", key: "1kv8ia" }],
  ["path", { d: "M3 4h8.129a1 1 0 0 1 .99.863L13 11.246", key: "1q1ert" }],
  ["path", { d: "M4 11V4", key: "9ft8pt" }],
  ["path", { d: "M7 15h.01", key: "k5ht0j" }],
  ["path", { d: "M8 10.1V4", key: "1jgyzo" }],
  ["circle", { cx: "18", cy: "18", r: "2", key: "1emm8v" }],
  ["circle", { cx: "7", cy: "15", r: "5", key: "ddtuc" }]
]);
const w9 = n("traffic-cone", [
  ["path", { d: "M9.3 6.2a4.55 4.55 0 0 0 5.4 0", key: "flyxqv" }],
  ["path", { d: "M7.9 10.7c.9.8 2.4 1.3 4.1 1.3s3.2-.5 4.1-1.3", key: "1nlxxg" }],
  [
    "path",
    {
      d: "M13.9 3.5a1.93 1.93 0 0 0-3.8-.1l-3 10c-.1.2-.1.4-.1.6 0 1.7 2.2 3 5 3s5-1.3 5-3c0-.2 0-.4-.1-.5Z",
      key: "vz7x1l"
    }
  ],
  [
    "path",
    {
      d: "m7.5 12.2-4.7 2.7c-.5.3-.8.7-.8 1.1s.3.8.8 1.1l7.6 4.5c.9.5 2.1.5 3 0l7.6-4.5c.7-.3 1-.7 1-1.1s-.3-.8-.8-1.1l-4.7-2.8",
      key: "1xfzlw"
    }
  ]
]);
const L9 = n("train-front-tunnel", [
  ["path", { d: "M2 22V12a10 10 0 1 1 20 0v10", key: "o0fyp0" }],
  ["path", { d: "M15 6.8v1.4a3 2.8 0 1 1-6 0V6.8", key: "m8q3n9" }],
  ["path", { d: "M10 15h.01", key: "44in9x" }],
  ["path", { d: "M14 15h.01", key: "5mohn5" }],
  ["path", { d: "M10 19a4 4 0 0 1-4-4v-3a6 6 0 1 1 12 0v3a4 4 0 0 1-4 4Z", key: "hckbmu" }],
  ["path", { d: "m9 19-2 3", key: "iij7hm" }],
  ["path", { d: "m15 19 2 3", key: "npx8sa" }]
]);
const S9 = n("train-front", [
  ["path", { d: "M8 3.1V7a4 4 0 0 0 8 0V3.1", key: "1v71zp" }],
  ["path", { d: "m9 15-1-1", key: "1yrq24" }],
  ["path", { d: "m15 15 1-1", key: "1t0d6s" }],
  ["path", { d: "M9 19c-2.8 0-5-2.2-5-5v-4a8 8 0 0 1 16 0v4c0 2.8-2.2 5-5 5Z", key: "1p0hjs" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m16 19 2 3", key: "xo31yx" }]
]);
const I9 = n("train-track", [
  ["path", { d: "M2 17 17 2", key: "18b09t" }],
  ["path", { d: "m2 14 8 8", key: "1gv9hu" }],
  ["path", { d: "m5 11 8 8", key: "189pqp" }],
  ["path", { d: "m8 8 8 8", key: "1imecy" }],
  ["path", { d: "m11 5 8 8", key: "ummqn6" }],
  ["path", { d: "m14 2 8 8", key: "1vk7dn" }],
  ["path", { d: "M7 22 22 7", key: "15mb1i" }]
]);
const qo = n("tram-front", [
  ["rect", { width: "16", height: "16", x: "4", y: "3", rx: "2", key: "1wxw4b" }],
  ["path", { d: "M4 11h16", key: "mpoxn0" }],
  ["path", { d: "M12 3v8", key: "1h2ygw" }],
  ["path", { d: "m8 19-2 3", key: "13i0xs" }],
  ["path", { d: "m18 22-2-3", key: "1p0ohu" }],
  ["path", { d: "M8 15h.01", key: "a7atzg" }],
  ["path", { d: "M16 15h.01", key: "rnfrdf" }]
]);
const C9 = n("trash-2", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
]);
const A9 = n("transgender", [
  ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ["path", { d: "M14 20h-4", key: "m8m19d" }],
  ["path", { d: "M18 2h4v4", key: "1341mj" }],
  ["path", { d: "m2 2 7.17 7.17", key: "13q8l2" }],
  ["path", { d: "M2 5.355V2h3.357", key: "18136r" }],
  ["path", { d: "m22 2-7.17 7.17", key: "1epvy4" }],
  ["path", { d: "M8 5 5 8", key: "mgbjhz" }],
  ["circle", { cx: "12", cy: "12", r: "4", key: "4exip2" }]
]);
const q9 = n("trash", [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }]
]);
const z9 = n("tree-deciduous", [
  [
    "path",
    {
      d: "M8 19a4 4 0 0 1-2.24-7.32A3.5 3.5 0 0 1 9 6.03V6a3 3 0 1 1 6 0v.04a3.5 3.5 0 0 1 3.24 5.65A4 4 0 0 1 16 19Z",
      key: "oadzkq"
    }
  ],
  ["path", { d: "M12 19v3", key: "npa21l" }]
]);
const zo = n("tree-palm", [
  ["path", { d: "M13 8c0-2.76-2.46-5-5.5-5S2 5.24 2 8h2l1-1 1 1h4", key: "foxbe7" }],
  [
    "path",
    { d: "M13 7.14A5.82 5.82 0 0 1 16.5 6c3.04 0 5.5 2.24 5.5 5h-3l-1-1-1 1h-3", key: "18arnh" }
  ],
  [
    "path",
    {
      d: "M5.89 9.71c-2.15 2.15-2.3 5.47-.35 7.43l4.24-4.25.7-.7.71-.71 2.12-2.12c-1.95-1.96-5.27-1.8-7.42.35",
      key: "ywahnh"
    }
  ],
  ["path", { d: "M11 15.5c.5 2.5-.17 4.5-1 6.5h4c2-5.5-.5-12-1-14", key: "ft0feo" }]
]);
const P9 = n("tree-pine", [
  [
    "path",
    {
      d: "m17 14 3 3.3a1 1 0 0 1-.7 1.7H4.7a1 1 0 0 1-.7-1.7L7 14h-.3a1 1 0 0 1-.7-1.7L9 9h-.2A1 1 0 0 1 8 7.3L12 3l4 4.3a1 1 0 0 1-.8 1.7H15l3 3.3a1 1 0 0 1-.7 1.7H17Z",
      key: "cpyugq"
    }
  ],
  ["path", { d: "M12 22v-3", key: "kmzjlo" }]
]);
const _9 = n("trees", [
  ["path", { d: "M10 10v.2A3 3 0 0 1 8.9 16H5a3 3 0 0 1-1-5.8V10a3 3 0 0 1 6 0Z", key: "1l6gj6" }],
  ["path", { d: "M7 16v6", key: "1a82de" }],
  ["path", { d: "M13 19v3", key: "13sx9i" }],
  [
    "path",
    {
      d: "M12 19h8.3a1 1 0 0 0 .7-1.7L18 14h.3a1 1 0 0 0 .7-1.7L16 9h.2a1 1 0 0 0 .8-1.7L13 3l-1.4 1.5",
      key: "1sj9kv"
    }
  ]
]);
const j9 = n("trello", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2", key: "1m3agn" }],
  ["rect", { width: "3", height: "9", x: "7", y: "7", key: "14n3xi" }],
  ["rect", { width: "3", height: "5", x: "14", y: "7", key: "s4azjd" }]
]);
const H9 = n("trending-down", [
  ["polyline", { points: "22 17 13.5 8.5 8.5 13.5 2 7", key: "1r2t7k" }],
  ["polyline", { points: "16 17 22 17 22 11", key: "11uiuu" }]
]);
const V9 = n("trending-up-down", [
  ["path", { d: "M14.828 14.828 21 21", key: "ar5fw7" }],
  ["path", { d: "M21 16v5h-5", key: "1ck2sf" }],
  ["path", { d: "m21 3-9 9-4-4-6 6", key: "1h02xo" }],
  ["path", { d: "M21 8V3h-5", key: "1qoq8a" }]
]);
const B9 = n("trending-up", [
  ["polyline", { points: "22 7 13.5 15.5 8.5 10.5 2 17", key: "126l90" }],
  ["polyline", { points: "16 7 22 7 22 13", key: "kwv8wd" }]
]);
const Po = n("triangle-alert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]);
const D9 = n("triangle-dashed", [
  ["path", { d: "M10.17 4.193a2 2 0 0 1 3.666.013", key: "pltmmw" }],
  ["path", { d: "M14 21h2", key: "v4qezv" }],
  ["path", { d: "m15.874 7.743 1 1.732", key: "10m0iw" }],
  ["path", { d: "m18.849 12.952 1 1.732", key: "zadnam" }],
  ["path", { d: "M21.824 18.18a2 2 0 0 1-1.835 2.824", key: "fvwuk4" }],
  ["path", { d: "M4.024 21a2 2 0 0 1-1.839-2.839", key: "1e1kah" }],
  ["path", { d: "m5.136 12.952-1 1.732", key: "1u4ldi" }],
  ["path", { d: "M8 21h2", key: "i9zjee" }],
  ["path", { d: "m8.102 7.743-1 1.732", key: "1zzo4u" }]
]);
const T9 = n("triangle-right", [
  [
    "path",
    {
      d: "M22 18a2 2 0 0 1-2 2H3c-1.1 0-1.3-.6-.4-1.3L20.4 4.3c.9-.7 1.6-.4 1.6.7Z",
      key: "183wce"
    }
  ]
]);
const $9 = n("triangle", [
  [
    "path",
    { d: "M13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z", key: "14u9p9" }
  ]
]);
const O9 = n("trophy", [
  ["path", { d: "M6 9H4.5a2.5 2.5 0 0 1 0-5H6", key: "17hqa7" }],
  ["path", { d: "M18 9h1.5a2.5 2.5 0 0 0 0-5H18", key: "lmptdp" }],
  ["path", { d: "M4 22h16", key: "57wxv0" }],
  ["path", { d: "M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22", key: "1nw9bq" }],
  ["path", { d: "M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22", key: "1np0yb" }],
  ["path", { d: "M18 2H6v7a6 6 0 0 0 12 0V2Z", key: "u46fv3" }]
]);
const R9 = n("truck", [
  ["path", { d: "M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2", key: "wrbu53" }],
  ["path", { d: "M15 18H9", key: "1lyqi6" }],
  [
    "path",
    {
      d: "M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14",
      key: "lysw3i"
    }
  ],
  ["circle", { cx: "17", cy: "18", r: "2", key: "332jqn" }],
  ["circle", { cx: "7", cy: "18", r: "2", key: "19iecd" }]
]);
const F9 = n("turtle", [
  [
    "path",
    {
      d: "m12 10 2 4v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3a8 8 0 1 0-16 0v3a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-3l2-4h4Z",
      key: "1lbbv7"
    }
  ],
  ["path", { d: "M4.82 7.9 8 10", key: "m9wose" }],
  ["path", { d: "M15.18 7.9 12 10", key: "p8dp2u" }],
  ["path", { d: "M16.93 10H20a2 2 0 0 1 0 4H2", key: "12nsm7" }]
]);
const E9 = n("tv-minimal-play", [
  [
    "path",
    {
      d: "M10 7.75a.75.75 0 0 1 1.142-.638l3.664 2.249a.75.75 0 0 1 0 1.278l-3.664 2.25a.75.75 0 0 1-1.142-.64z",
      key: "1pctta"
    }
  ],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
const _o = n("tv-minimal", [
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }]
]);
const U9 = n("tv", [
  ["rect", { width: "20", height: "15", x: "2", y: "7", rx: "2", ry: "2", key: "10ag99" }],
  ["polyline", { points: "17 2 12 7 7 2", key: "11pgbg" }]
]);
const N9 = n("twitch", [
  ["path", { d: "M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7", key: "c0yzno" }]
]);
const W9 = n("twitter", [
  [
    "path",
    {
      d: "M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z",
      key: "pff0z6"
    }
  ]
]);
const G9 = n("type-outline", [
  [
    "path",
    {
      d: "M14 16.5a.5.5 0 0 0 .5.5h.5a2 2 0 0 1 0 4H9a2 2 0 0 1 0-4h.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V8a2 2 0 0 1-4 0V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v3a2 2 0 0 1-4 0v-.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5Z",
      key: "1reda3"
    }
  ]
]);
const Z9 = n("type", [
  ["polyline", { points: "4 7 4 4 20 4 20 7", key: "1nosan" }],
  ["line", { x1: "9", x2: "15", y1: "20", y2: "20", key: "swin9y" }],
  ["line", { x1: "12", x2: "12", y1: "4", y2: "20", key: "1tx1rr" }]
]);
const Y9 = n("umbrella-off", [
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "M15.5 21a1.85 1.85 0 0 1-3.5-1v-8H2a10 10 0 0 1 3.428-6.575", key: "eki10q" }],
  ["path", { d: "M17.5 12H22A10 10 0 0 0 9.004 3.455", key: "n2ayka" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const K9 = n("umbrella", [
  ["path", { d: "M22 12a10.06 10.06 1 0 0-20 0Z", key: "1teyop" }],
  ["path", { d: "M12 12v8a2 2 0 0 0 4 0", key: "ulpmoc" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }]
]);
const X9 = n("underline", [
  ["path", { d: "M6 4v6a6 6 0 0 0 12 0V4", key: "9kb039" }],
  ["line", { x1: "4", x2: "20", y1: "20", y2: "20", key: "nun2al" }]
]);
const Q9 = n("undo-2", [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
]);
const J9 = n("undo-dot", [
  ["path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13", key: "8mp6z9" }],
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["circle", { cx: "12", cy: "17", r: "1", key: "1ixnty" }]
]);
const eb = n("undo", [
  ["path", { d: "M3 7v6h6", key: "1v2h90" }],
  ["path", { d: "M21 17a9 9 0 0 0-9-9 9 9 0 0 0-6 2.3L3 13", key: "1r6uu6" }]
]);
const tb = n("unfold-horizontal", [
  ["path", { d: "M16 12h6", key: "15xry1" }],
  ["path", { d: "M8 12H2", key: "1jqql6" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M12 8v2", key: "1woqiv" }],
  ["path", { d: "M12 14v2", key: "8jcxud" }],
  ["path", { d: "M12 20v2", key: "1lh1kg" }],
  ["path", { d: "m19 15 3-3-3-3", key: "wjy7rq" }],
  ["path", { d: "m5 9-3 3 3 3", key: "j64kie" }]
]);
const ab = n("unfold-vertical", [
  ["path", { d: "M12 22v-6", key: "6o8u61" }],
  ["path", { d: "M12 8V2", key: "1wkif3" }],
  ["path", { d: "M4 12H2", key: "rhcxmi" }],
  ["path", { d: "M10 12H8", key: "s88cx1" }],
  ["path", { d: "M16 12h-2", key: "10asgb" }],
  ["path", { d: "M22 12h-2", key: "14jgyd" }],
  ["path", { d: "m15 19-3 3-3-3", key: "11eu04" }],
  ["path", { d: "m15 5-3-3-3 3", key: "itvq4r" }]
]);
const nb = n("ungroup", [
  ["rect", { width: "8", height: "6", x: "5", y: "4", rx: "1", key: "nzclkv" }],
  ["rect", { width: "8", height: "6", x: "11", y: "14", rx: "1", key: "4tytwb" }]
]);
const jo = n("university", [
  ["circle", { cx: "12", cy: "10", r: "1", key: "1gnqs8" }],
  ["path", { d: "M22 20V8h-4l-6-4-6 4H2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2", key: "1qj5sn" }],
  ["path", { d: "M6 17v.01", key: "roodi6" }],
  ["path", { d: "M6 13v.01", key: "67c122" }],
  ["path", { d: "M18 17v.01", key: "12ktxm" }],
  ["path", { d: "M18 13v.01", key: "tn1rt1" }],
  ["path", { d: "M14 22v-5a2 2 0 0 0-2-2a2 2 0 0 0-2 2v5", key: "11g7fi" }]
]);
const ob = n("unlink-2", [
  ["path", { d: "M15 7h2a5 5 0 0 1 0 10h-2m-6 0H7A5 5 0 0 1 7 7h2", key: "1re2ne" }]
]);
const rb = n("unlink", [
  [
    "path",
    {
      d: "m18.84 12.25 1.72-1.71h-.02a5.004 5.004 0 0 0-.12-7.07 5.006 5.006 0 0 0-6.95 0l-1.72 1.71",
      key: "yqzxt4"
    }
  ],
  [
    "path",
    {
      d: "m5.17 11.75-1.71 1.71a5.004 5.004 0 0 0 .12 7.07 5.006 5.006 0 0 0 6.95 0l1.71-1.71",
      key: "4qinb0"
    }
  ],
  ["line", { x1: "8", x2: "8", y1: "2", y2: "5", key: "1041cp" }],
  ["line", { x1: "2", x2: "5", y1: "8", y2: "8", key: "14m1p5" }],
  ["line", { x1: "16", x2: "16", y1: "19", y2: "22", key: "rzdirn" }],
  ["line", { x1: "19", x2: "22", y1: "16", y2: "16", key: "ox905f" }]
]);
const lb = n("unplug", [
  ["path", { d: "m19 5 3-3", key: "yk6iyv" }],
  ["path", { d: "m2 22 3-3", key: "19mgm9" }],
  [
    "path",
    { d: "M6.3 20.3a2.4 2.4 0 0 0 3.4 0L12 18l-6-6-2.3 2.3a2.4 2.4 0 0 0 0 3.4Z", key: "goz73y" }
  ],
  ["path", { d: "M7.5 13.5 10 11", key: "7xgeeb" }],
  ["path", { d: "M10.5 16.5 13 14", key: "10btkg" }],
  [
    "path",
    { d: "m12 6 6 6 2.3-2.3a2.4 2.4 0 0 0 0-3.4l-2.6-2.6a2.4 2.4 0 0 0-3.4 0Z", key: "1snsnr" }
  ]
]);
const ib = n("upload", [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
]);
const cb = n("usb", [
  ["circle", { cx: "10", cy: "7", r: "1", key: "dypaad" }],
  ["circle", { cx: "4", cy: "20", r: "1", key: "22iqad" }],
  ["path", { d: "M4.7 19.3 19 5", key: "1enqfc" }],
  ["path", { d: "m21 3-3 1 2 2Z", key: "d3ov82" }],
  ["path", { d: "M9.26 7.68 5 12l2 5", key: "1esawj" }],
  ["path", { d: "m10 14 5 2 3.5-3.5", key: "v8oal5" }],
  ["path", { d: "m18 12 1-1 1 1-1 1Z", key: "1bh22v" }]
]);
const db = n("user-check", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["polyline", { points: "16 11 18 13 22 9", key: "1pwet4" }]
]);
const sb = n("user-cog", [
  ["circle", { cx: "18", cy: "15", r: "3", key: "gjjjvw" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M10 15H6a4 4 0 0 0-4 4v2", key: "1nfge6" }],
  ["path", { d: "m21.7 16.4-.9-.3", key: "12j9ji" }],
  ["path", { d: "m15.2 13.9-.9-.3", key: "1fdjdi" }],
  ["path", { d: "m16.6 18.7.3-.9", key: "heedtr" }],
  ["path", { d: "m19.1 12.2.3-.9", key: "1af3ki" }],
  ["path", { d: "m19.6 18.7-.4-1", key: "1x9vze" }],
  ["path", { d: "m16.8 12.3-.4-1", key: "vqeiwj" }],
  ["path", { d: "m14.3 16.6 1-.4", key: "1qlj63" }],
  ["path", { d: "m20.7 13.8 1-.4", key: "1v5t8k" }]
]);
const ub = n("user-minus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
const hb = n("user-pen", [
  ["path", { d: "M11.5 15H7a4 4 0 0 0-4 4v2", key: "15lzij" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }]
]);
const pb = n("user-plus", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "19", x2: "19", y1: "8", y2: "14", key: "1bvyxn" }],
  ["line", { x1: "22", x2: "16", y1: "11", y2: "11", key: "1shjgl" }]
]);
const Ho = n("user-round-check", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m16 19 2 2 4-4", key: "1b14m6" }]
]);
const Vo = n("user-round-cog", [
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m19.5 14.3-.4.9", key: "1eb35c" }],
  ["path", { d: "m16.9 20.8-.4.9", key: "dfjc4z" }],
  ["path", { d: "m21.7 19.5-.9-.4", key: "q4dx6b" }],
  ["path", { d: "m15.2 16.9-.9-.4", key: "1r0w5f" }],
  ["path", { d: "m21.7 16.5-.9.4", key: "1knoei" }],
  ["path", { d: "m15.2 19.1-.9.4", key: "j188fs" }],
  ["path", { d: "m19.5 21.7-.4-.9", key: "1tonu5" }],
  ["path", { d: "m16.9 15.2-.4-.9", key: "699xu" }]
]);
const Bo = n("user-round-minus", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
const yb = n("user-round-pen", [
  ["path", { d: "M2 21a8 8 0 0 1 10.821-7.487", key: "1c8h7z" }],
  [
    "path",
    {
      d: "M21.378 16.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z",
      key: "1817ys"
    }
  ],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }]
]);
const Do = n("user-round-plus", [
  ["path", { d: "M2 21a8 8 0 0 1 13.292-6", key: "bjp14o" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M19 16v6", key: "tddt3s" }],
  ["path", { d: "M22 19h-6", key: "vcuq98" }]
]);
const kb = n("user-round-search", [
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M2 21a8 8 0 0 1 10.434-7.62", key: "1yezr2" }],
  ["circle", { cx: "18", cy: "18", r: "3", key: "1xkwt0" }],
  ["path", { d: "m22 22-1.9-1.9", key: "1e5ubv" }]
]);
const To = n("user-round-x", [
  ["path", { d: "M2 21a8 8 0 0 1 11.873-7", key: "74fkxq" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "m17 17 5 5", key: "p7ous7" }],
  ["path", { d: "m22 17-5 5", key: "gqnmv0" }]
]);
const $o = n("user-round", [
  ["circle", { cx: "12", cy: "8", r: "5", key: "1hypcn" }],
  ["path", { d: "M20 21a8 8 0 0 0-16 0", key: "rfgkzh" }]
]);
const mb = n("user-search", [
  ["circle", { cx: "10", cy: "7", r: "4", key: "e45bow" }],
  ["path", { d: "M10.3 15H7a4 4 0 0 0-4 4v2", key: "3bnktk" }],
  ["circle", { cx: "17", cy: "17", r: "3", key: "18b49y" }],
  ["path", { d: "m21 21-1.9-1.9", key: "1g2n9r" }]
]);
const fb = n("user-x", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["line", { x1: "17", x2: "22", y1: "8", y2: "13", key: "3nzzx3" }],
  ["line", { x1: "22", x2: "17", y1: "8", y2: "13", key: "1swrse" }]
]);
const vb = n("user", [
  ["path", { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2", key: "975kel" }],
  ["circle", { cx: "12", cy: "7", r: "4", key: "17ys0d" }]
]);
const Oo = n("users-round", [
  ["path", { d: "M18 21a8 8 0 0 0-16 0", key: "3ypg7q" }],
  ["circle", { cx: "10", cy: "8", r: "5", key: "o932ke" }],
  ["path", { d: "M22 20c0-3.37-2-6.5-4-8a5 5 0 0 0-.45-8.3", key: "10s06x" }]
]);
const gb = n("users", [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }]
]);
const Ro = n("utensils-crossed", [
  ["path", { d: "m16 2-2.3 2.3a3 3 0 0 0 0 4.2l1.8 1.8a3 3 0 0 0 4.2 0L22 8", key: "n7qcjb" }],
  [
    "path",
    { d: "M15 15 3.3 3.3a4.2 4.2 0 0 0 0 6l7.3 7.3c.7.7 2 .7 2.8 0L15 15Zm0 0 7 7", key: "d0u48b" }
  ],
  ["path", { d: "m2.1 21.8 6.4-6.3", key: "yn04lh" }],
  ["path", { d: "m19 5-7 7", key: "194lzd" }]
]);
const Fo = n("utensils", [
  ["path", { d: "M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2", key: "cjf0a3" }],
  ["path", { d: "M7 2v20", key: "1473qp" }],
  ["path", { d: "M21 15V2a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7", key: "j28e5" }]
]);
const Mb = n("utility-pole", [
  ["path", { d: "M12 2v20", key: "t6zp3m" }],
  ["path", { d: "M2 5h20", key: "1fs1ex" }],
  ["path", { d: "M3 3v2", key: "9imdir" }],
  ["path", { d: "M7 3v2", key: "n0os7" }],
  ["path", { d: "M17 3v2", key: "1l2re6" }],
  ["path", { d: "M21 3v2", key: "1duuac" }],
  ["path", { d: "m19 5-7 7-7-7", key: "133zxf" }]
]);
const bb = n("variable", [
  ["path", { d: "M8 21s-4-3-4-9 4-9 4-9", key: "uto9ud" }],
  ["path", { d: "M16 3s4 3 4 9-4 9-4 9", key: "4w2vsq" }],
  ["line", { x1: "15", x2: "9", y1: "9", y2: "15", key: "f7djnv" }],
  ["line", { x1: "9", x2: "15", y1: "9", y2: "15", key: "1shsy8" }]
]);
const xb = n("vault", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }],
  ["path", { d: "m7.9 7.9 2.7 2.7", key: "hpeyl3" }],
  ["circle", { cx: "16.5", cy: "7.5", r: ".5", fill: "currentColor", key: "w0ekpg" }],
  ["path", { d: "m13.4 10.6 2.7-2.7", key: "264c1n" }],
  ["circle", { cx: "7.5", cy: "16.5", r: ".5", fill: "currentColor", key: "nkw3mc" }],
  ["path", { d: "m7.9 16.1 2.7-2.7", key: "p81g5e" }],
  ["circle", { cx: "16.5", cy: "16.5", r: ".5", fill: "currentColor", key: "fubopw" }],
  ["path", { d: "m13.4 13.4 2.7 2.7", key: "abhel3" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }]
]);
const wb = n("vegan", [
  ["path", { d: "M16 8q6 0 6-6-6 0-6 6", key: "qsyyc4" }],
  ["path", { d: "M17.41 3.59a10 10 0 1 0 3 3", key: "41m9h7" }],
  ["path", { d: "M2 2a26.6 26.6 0 0 1 10 20c.9-6.82 1.5-9.5 4-14", key: "qiv7li" }]
]);
const Lb = n("venetian-mask", [
  ["path", { d: "M18 11c-1.5 0-2.5.5-3 2", key: "1fod00" }],
  [
    "path",
    {
      d: "M4 6a2 2 0 0 0-2 2v4a5 5 0 0 0 5 5 8 8 0 0 1 5 2 8 8 0 0 1 5-2 5 5 0 0 0 5-5V8a2 2 0 0 0-2-2h-3a8 8 0 0 0-5 2 8 8 0 0 0-5-2z",
      key: "d70hit"
    }
  ],
  ["path", { d: "M6 11c1.5 0 2.5.5 3 2", key: "136fht" }]
]);
const Sb = n("venus-and-mars", [
  ["path", { d: "M10 20h4", key: "ni2waw" }],
  ["path", { d: "M12 16v6", key: "c8a4gj" }],
  ["path", { d: "M17 2h4v4", key: "vhe59" }],
  ["path", { d: "m21 2-5.46 5.46", key: "19kypf" }],
  ["circle", { cx: "12", cy: "11", r: "5", key: "16gxyc" }]
]);
const Ib = n("venus", [
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  ["path", { d: "M9 19h6", key: "456am0" }],
  ["circle", { cx: "12", cy: "9", r: "6", key: "1nw4tq" }]
]);
const Cb = n("vibrate", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["rect", { width: "8", height: "14", x: "8", y: "5", rx: "1", key: "1oyrl4" }]
]);
const Ab = n("vibrate-off", [
  ["path", { d: "m2 8 2 2-2 2 2 2-2 2", key: "sv1b1" }],
  ["path", { d: "m22 8-2 2 2 2-2 2 2 2", key: "101i4y" }],
  ["path", { d: "M8 8v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2", key: "1hbad5" }],
  ["path", { d: "M16 10.34V6c0-.55-.45-1-1-1h-4.34", key: "1x5tf0" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const qb = n("video-off", [
  [
    "path",
    { d: "M10.66 6H14a2 2 0 0 1 2 2v2.5l5.248-3.062A.5.5 0 0 1 22 7.87v8.196", key: "w8jjjt" }
  ],
  ["path", { d: "M16 16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h2", key: "1xawa7" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const zb = n("video", [
  [
    "path",
    {
      d: "m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5",
      key: "ftymec"
    }
  ],
  ["rect", { x: "2", y: "6", width: "14", height: "12", rx: "2", key: "158x01" }]
]);
const Pb = n("videotape", [
  ["rect", { width: "20", height: "16", x: "2", y: "4", rx: "2", key: "18n3k1" }],
  ["path", { d: "M2 8h20", key: "d11cs7" }],
  ["circle", { cx: "8", cy: "14", r: "2", key: "1k2qr5" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["circle", { cx: "16", cy: "14", r: "2", key: "14k7lr" }]
]);
const _b = n("view", [
  ["path", { d: "M21 17v2a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-2", key: "mrq65r" }],
  ["path", { d: "M21 7V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2", key: "be3xqs" }],
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  [
    "path",
    {
      d: "M18.944 12.33a1 1 0 0 0 0-.66 7.5 7.5 0 0 0-13.888 0 1 1 0 0 0 0 .66 7.5 7.5 0 0 0 13.888 0",
      key: "11ak4c"
    }
  ]
]);
const jb = n("volleyball", [
  ["path", { d: "M11.1 7.1a16.55 16.55 0 0 1 10.9 4", key: "2880wi" }],
  ["path", { d: "M12 12a12.6 12.6 0 0 1-8.7 5", key: "113sja" }],
  ["path", { d: "M16.8 13.6a16.55 16.55 0 0 1-9 7.5", key: "1qmsgl" }],
  ["path", { d: "M20.7 17a12.8 12.8 0 0 0-8.7-5 13.3 13.3 0 0 1 0-10", key: "1bmeqp" }],
  ["path", { d: "M6.3 3.8a16.55 16.55 0 0 0 1.9 11.5", key: "iekzv9" }],
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
const Hb = n("voicemail", [
  ["circle", { cx: "6", cy: "12", r: "4", key: "1ehtga" }],
  ["circle", { cx: "18", cy: "12", r: "4", key: "4vafl8" }],
  ["line", { x1: "6", x2: "18", y1: "16", y2: "16", key: "pmt8us" }]
]);
const Vb = n("volume-1", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }]
]);
const Bb = n("volume-2", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["path", { d: "M16 9a5 5 0 0 1 0 6", key: "1q6k2b" }],
  ["path", { d: "M19.364 18.364a9 9 0 0 0 0-12.728", key: "ijwkga" }]
]);
const Db = n("volume-off", [
  ["path", { d: "M16 9a5 5 0 0 1 .95 2.293", key: "1fgyg8" }],
  ["path", { d: "M19.364 5.636a9 9 0 0 1 1.889 9.96", key: "l3zxae" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  [
    "path",
    {
      d: "m7 7-.587.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298V11",
      key: "1gbwow"
    }
  ],
  ["path", { d: "M9.828 4.172A.686.686 0 0 1 11 4.657v.686", key: "s2je0y" }]
]);
const Tb = n("volume-x", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ],
  ["line", { x1: "22", x2: "16", y1: "9", y2: "15", key: "1ewh16" }],
  ["line", { x1: "16", x2: "22", y1: "9", y2: "15", key: "5ykzw1" }]
]);
const $b = n("volume", [
  [
    "path",
    {
      d: "M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z",
      key: "uqj9uw"
    }
  ]
]);
const Ob = n("vote", [
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }],
  ["path", { d: "M5 7c0-1.1.9-2 2-2h10a2 2 0 0 1 2 2v12H5V7Z", key: "1ezoue" }],
  ["path", { d: "M22 19H2", key: "nuriw5" }]
]);
const Rb = n("wallet-cards", [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M3 9a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2", key: "4125el" }],
  [
    "path",
    {
      d: "M3 11h3c.8 0 1.6.3 2.1.9l1.1.9c1.6 1.6 4.1 1.6 5.7 0l1.1-.9c.5-.5 1.3-.9 2.1-.9H21",
      key: "1dpki6"
    }
  ]
]);
const Eo = n("wallet-minimal", [
  ["path", { d: "M17 14h.01", key: "7oqj8z" }],
  [
    "path",
    {
      d: "M7 7h12a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14",
      key: "u1rqew"
    }
  ]
]);
const Fb = n("wallet", [
  [
    "path",
    {
      d: "M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h15a1 1 0 0 1 1 1v4h-3a2 2 0 0 0 0 4h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1",
      key: "18etb6"
    }
  ],
  ["path", { d: "M3 5v14a2 2 0 0 0 2 2h15a1 1 0 0 0 1-1v-4", key: "xoc0q4" }]
]);
const Eb = n("wallpaper", [
  ["circle", { cx: "8", cy: "9", r: "2", key: "gjzl9d" }],
  [
    "path",
    {
      d: "m9 17 6.1-6.1a2 2 0 0 1 2.81.01L22 15V5a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2",
      key: "69xh40"
    }
  ],
  ["path", { d: "M8 21h8", key: "1ev6f3" }],
  ["path", { d: "M12 17v4", key: "1riwvh" }]
]);
const Uo = n("wand-sparkles", [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
]);
const Ub = n("wand", [
  ["path", { d: "M15 4V2", key: "z1p9b7" }],
  ["path", { d: "M15 16v-2", key: "px0unx" }],
  ["path", { d: "M8 9h2", key: "1g203m" }],
  ["path", { d: "M20 9h2", key: "19tzq7" }],
  ["path", { d: "M17.8 11.8 19 13", key: "yihg8r" }],
  ["path", { d: "M15 9h.01", key: "x1ddxp" }],
  ["path", { d: "M17.8 6.2 19 5", key: "fd4us0" }],
  ["path", { d: "m3 21 9-9", key: "1jfql5" }],
  ["path", { d: "M12.2 6.2 11 5", key: "i3da3b" }]
]);
const Nb = n("warehouse", [
  [
    "path",
    {
      d: "M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z",
      key: "gksnxg"
    }
  ],
  ["path", { d: "M6 18h12", key: "9pbo8z" }],
  ["path", { d: "M6 14h12", key: "4cwo0f" }],
  ["rect", { width: "12", height: "12", x: "6", y: "10", key: "apd30q" }]
]);
const Wb = n("washing-machine", [
  ["path", { d: "M3 6h3", key: "155dbl" }],
  ["path", { d: "M17 6h.01", key: "e2y6kg" }],
  ["rect", { width: "18", height: "20", x: "3", y: "2", rx: "2", key: "od3kk9" }],
  ["circle", { cx: "12", cy: "13", r: "5", key: "nlbqau" }],
  ["path", { d: "M12 18a2.5 2.5 0 0 0 0-5 2.5 2.5 0 0 1 0-5", key: "17lach" }]
]);
const Gb = n("watch", [
  ["circle", { cx: "12", cy: "12", r: "6", key: "1vlfrh" }],
  ["polyline", { points: "12 10 12 12 13 13", key: "19dquz" }],
  [
    "path",
    { d: "m16.13 7.66-.81-4.05a2 2 0 0 0-2-1.61h-2.68a2 2 0 0 0-2 1.61l-.78 4.05", key: "18k57s" }
  ],
  ["path", { d: "m7.88 16.36.8 4a2 2 0 0 0 2 1.61h2.72a2 2 0 0 0 2-1.61l.81-4.05", key: "16ny36" }]
]);
const Zb = n("waves-ladder", [
  ["path", { d: "M19 5a2 2 0 0 0-2 2v11", key: "s41o68" }],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ],
  ["path", { d: "M7 13h10", key: "1rwob1" }],
  ["path", { d: "M7 9h10", key: "12czzb" }],
  ["path", { d: "M9 5a2 2 0 0 0-2 2v11", key: "x0q4gh" }]
]);
const Yb = n("waves", [
  [
    "path",
    {
      d: "M2 6c.6.5 1.2 1 2.5 1C7 7 7 5 9.5 5c2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "knzxuh"
    }
  ],
  [
    "path",
    {
      d: "M2 12c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "2jd2cc"
    }
  ],
  [
    "path",
    {
      d: "M2 18c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 2.6 0 2.4 2 5 2 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1",
      key: "rd2r6e"
    }
  ]
]);
const Kb = n("waypoints", [
  ["circle", { cx: "12", cy: "4.5", r: "2.5", key: "r5ysbb" }],
  ["path", { d: "m10.2 6.3-3.9 3.9", key: "1nzqf6" }],
  ["circle", { cx: "4.5", cy: "12", r: "2.5", key: "jydg6v" }],
  ["path", { d: "M7 12h10", key: "b7w52i" }],
  ["circle", { cx: "19.5", cy: "12", r: "2.5", key: "1piiel" }],
  ["path", { d: "m13.8 17.7 3.9-3.9", key: "1wyg1y" }],
  ["circle", { cx: "12", cy: "19.5", r: "2.5", key: "13o1pw" }]
]);
const Xb = n("webcam", [
  ["circle", { cx: "12", cy: "10", r: "8", key: "1gshiw" }],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }],
  ["path", { d: "M7 22h10", key: "10w4w3" }],
  ["path", { d: "M12 22v-4", key: "1utk9m" }]
]);
const Qb = n("webhook-off", [
  ["path", { d: "M17 17h-5c-1.09-.02-1.94.92-2.5 1.9A3 3 0 1 1 2.57 15", key: "1tvl6x" }],
  ["path", { d: "M9 3.4a4 4 0 0 1 6.52.66", key: "q04jfq" }],
  ["path", { d: "m6 17 3.1-5.8a2.5 2.5 0 0 0 .057-2.05", key: "azowf0" }],
  ["path", { d: "M20.3 20.3a4 4 0 0 1-2.3.7", key: "5joiws" }],
  ["path", { d: "M18.6 13a4 4 0 0 1 3.357 3.414", key: "cangb8" }],
  ["path", { d: "m12 6 .6 1", key: "tpjl1n" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const Jb = n("webhook", [
  [
    "path",
    {
      d: "M18 16.98h-5.99c-1.1 0-1.95.94-2.48 1.9A4 4 0 0 1 2 17c.01-.7.2-1.4.57-2",
      key: "q3hayz"
    }
  ],
  ["path", { d: "m6 17 3.13-5.78c.53-.97.1-2.18-.5-3.1a4 4 0 1 1 6.89-4.06", key: "1go1hn" }],
  ["path", { d: "m12 6 3.13 5.73C15.66 12.7 16.9 13 18 13a4 4 0 0 1 0 8", key: "qlwsc0" }]
]);
const ex = n("weight", [
  ["circle", { cx: "12", cy: "5", r: "3", key: "rqqgnr" }],
  [
    "path",
    {
      d: "M6.5 8a2 2 0 0 0-1.905 1.46L2.1 18.5A2 2 0 0 0 4 21h16a2 2 0 0 0 1.925-2.54L19.4 9.5A2 2 0 0 0 17.48 8Z",
      key: "56o5sh"
    }
  ]
]);
const tx = n("wheat-off", [
  ["path", { d: "m2 22 10-10", key: "28ilpk" }],
  ["path", { d: "m16 8-1.17 1.17", key: "1qqm82" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    { d: "m8 8-.53.53a3.5 3.5 0 0 0 0 4.94L9 15l1.53-1.53c.55-.55.88-1.25.98-1.97", key: "4wz8re" }
  ],
  [
    "path",
    { d: "M10.91 5.26c.15-.26.34-.51.56-.73L13 3l1.53 1.53a3.5 3.5 0 0 1 .28 4.62", key: "rves66" }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "m16 16-.53.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.49 3.49 0 0 1 1.97-.98",
      key: "ak46r"
    }
  ],
  [
    "path",
    {
      d: "M18.74 13.09c.26-.15.51-.34.73-.56L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.62-.28",
      key: "1tw520"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const ax = n("wheat", [
  ["path", { d: "M2 22 16 8", key: "60hf96" }],
  [
    "path",
    {
      d: "M3.47 12.53 5 11l1.53 1.53a3.5 3.5 0 0 1 0 4.94L5 19l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1rdhi6"
    }
  ],
  [
    "path",
    {
      d: "M7.47 8.53 9 7l1.53 1.53a3.5 3.5 0 0 1 0 4.94L9 15l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "1sdzmb"
    }
  ],
  [
    "path",
    {
      d: "M11.47 4.53 13 3l1.53 1.53a3.5 3.5 0 0 1 0 4.94L13 11l-1.53-1.53a3.5 3.5 0 0 1 0-4.94Z",
      key: "eoatbi"
    }
  ],
  ["path", { d: "M20 2h2v2a4 4 0 0 1-4 4h-2V6a4 4 0 0 1 4-4Z", key: "19rau1" }],
  [
    "path",
    {
      d: "M11.47 17.47 13 19l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L5 19l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "tc8ph9"
    }
  ],
  [
    "path",
    {
      d: "M15.47 13.47 17 15l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L9 15l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "2m8kc5"
    }
  ],
  [
    "path",
    {
      d: "M19.47 9.47 21 11l-1.53 1.53a3.5 3.5 0 0 1-4.94 0L13 11l1.53-1.53a3.5 3.5 0 0 1 4.94 0Z",
      key: "vex3ng"
    }
  ]
]);
const nx = n("whole-word", [
  ["circle", { cx: "7", cy: "12", r: "3", key: "12clwm" }],
  ["path", { d: "M10 9v6", key: "17i7lo" }],
  ["circle", { cx: "17", cy: "12", r: "3", key: "gl7c2s" }],
  ["path", { d: "M14 7v8", key: "dl84cr" }],
  ["path", { d: "M22 17v1c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1v-1", key: "lt2kga" }]
]);
const ox = n("wifi-high", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
const rx = n("wifi-low", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
const lx = n("wifi-off", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 5.17-2.69", key: "1dl1wf" }],
  ["path", { d: "M19 12.859a10 10 0 0 0-2.007-1.523", key: "4k23kn" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 4.177-2.643", key: "1grhjp" }],
  ["path", { d: "M22 8.82a15 15 0 0 0-11.288-3.764", key: "z3jwby" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const ix = n("wifi-zero", [["path", { d: "M12 20h.01", key: "zekei9" }]]);
const cx = n("wifi", [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
]);
const dx = n("wind-arrow-down", [
  ["path", { d: "M10 2v8", key: "d4bbey" }],
  ["path", { d: "M12.8 21.6A2 2 0 1 0 14 18H2", key: "19kp1d" }],
  ["path", { d: "M17.5 10a2.5 2.5 0 1 1 2 4H2", key: "19kpjc" }],
  ["path", { d: "m6 6 4 4 4-4", key: "k13n16" }]
]);
const sx = n("wind", [
  ["path", { d: "M12.8 19.6A2 2 0 1 0 14 16H2", key: "148xed" }],
  ["path", { d: "M17.5 8a2.5 2.5 0 1 1 2 4H2", key: "1u4tom" }],
  ["path", { d: "M9.8 4.4A2 2 0 1 1 11 8H2", key: "75valh" }]
]);
const ux = n("wine-off", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h3m7 0h-1.343", key: "v48bem" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    {
      d: "M7.307 7.307A12.33 12.33 0 0 0 7 10a5 5 0 0 0 7.391 4.391M8.638 2.981C8.75 2.668 8.872 2.34 9 2h6c1.5 4 2 6 2 8 0 .407-.05.809-.145 1.198",
      key: "1ymjlu"
    }
  ],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
const hx = n("wine", [
  ["path", { d: "M8 22h8", key: "rmew8v" }],
  ["path", { d: "M7 10h10", key: "1101jm" }],
  ["path", { d: "M12 15v7", key: "t2xh3l" }],
  [
    "path",
    { d: "M12 15a5 5 0 0 0 5-5c0-2-.5-4-2-8H9c-1.5 4-2 6-2 8a5 5 0 0 0 5 5Z", key: "10ffi3" }
  ]
]);
const px = n("workflow", [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
]);
const yx = n("worm", [
  ["path", { d: "m19 12-1.5 3", key: "9bcu4o" }],
  ["path", { d: "M19.63 18.81 22 20", key: "121v98" }],
  [
    "path",
    {
      d: "M6.47 8.23a1.68 1.68 0 0 1 2.44 1.93l-.64 2.08a6.76 6.76 0 0 0 10.16 7.67l.42-.27a1 1 0 1 0-2.73-4.21l-.42.27a1.76 1.76 0 0 1-2.63-1.99l.64-2.08A6.66 6.66 0 0 0 3.94 3.9l-.7.4a1 1 0 1 0 2.55 4.34z",
      key: "1tij6q"
    }
  ]
]);
const kx = n("wrap-text", [
  ["line", { x1: "3", x2: "21", y1: "6", y2: "6", key: "4m8b97" }],
  ["path", { d: "M3 12h15a3 3 0 1 1 0 6h-4", key: "1cl7v7" }],
  ["polyline", { points: "16 16 14 18 16 20", key: "1jznyi" }],
  ["line", { x1: "3", x2: "10", y1: "18", y2: "18", key: "1h33wv" }]
]);
const mx = n("wrench", [
  [
    "path",
    {
      d: "M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z",
      key: "cbrjhi"
    }
  ]
]);
const fx = n("x", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]);
const vx = n("youtube", [
  [
    "path",
    {
      d: "M2.5 17a24.12 24.12 0 0 1 0-10 2 2 0 0 1 1.4-1.4 49.56 49.56 0 0 1 16.2 0A2 2 0 0 1 21.5 7a24.12 24.12 0 0 1 0 10 2 2 0 0 1-1.4 1.4 49.55 49.55 0 0 1-16.2 0A2 2 0 0 1 2.5 17",
      key: "1q2vi4"
    }
  ],
  ["path", { d: "m10 15 5-3-5-3z", key: "1jp15x" }]
]);
const gx = n("zap-off", [
  ["path", { d: "M10.513 4.856 13.12 2.17a.5.5 0 0 1 .86.46l-1.377 4.317", key: "193nxd" }],
  ["path", { d: "M15.656 10H20a1 1 0 0 1 .78 1.63l-1.72 1.773", key: "27a7lr" }],
  [
    "path",
    {
      d: "M16.273 16.273 10.88 21.83a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14H4a1 1 0 0 1-.78-1.63l4.507-4.643",
      key: "1e0qe9"
    }
  ],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }]
]);
const Mx = n("zap", [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
]);
const bx = n("zoom-in", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "11", x2: "11", y1: "8", y2: "14", key: "1vmskp" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
const xx = n("zoom-out", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["line", { x1: "21", x2: "16.65", y1: "21", y2: "16.65", key: "13gj7c" }],
  ["line", { x1: "8", x2: "14", y1: "11", y2: "11", key: "durymu" }]
]);
const tA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: ll,
  AArrowUp: il,
  ALargeSmall: cl,
  Accessibility: dl,
  Activity: sl,
  AirVent: ul,
  Airplay: hl,
  AlarmClock: yl,
  AlarmClockCheck: da,
  AlarmClockMinus: sa,
  AlarmClockOff: pl,
  AlarmClockPlus: ua,
  AlarmSmoke: kl,
  Album: ml,
  AlignCenter: gl,
  AlignCenterHorizontal: fl,
  AlignCenterVertical: vl,
  AlignEndHorizontal: Ml,
  AlignEndVertical: bl,
  AlignHorizontalDistributeCenter: xl,
  AlignHorizontalDistributeEnd: wl,
  AlignHorizontalDistributeStart: Ll,
  AlignHorizontalJustifyCenter: Sl,
  AlignHorizontalJustifyEnd: Il,
  AlignHorizontalJustifyStart: Cl,
  AlignHorizontalSpaceAround: Al,
  AlignHorizontalSpaceBetween: ql,
  AlignJustify: zl,
  AlignLeft: Pl,
  AlignRight: _l,
  AlignStartHorizontal: jl,
  AlignStartVertical: Hl,
  AlignVerticalDistributeCenter: Vl,
  AlignVerticalDistributeEnd: Bl,
  AlignVerticalDistributeStart: Dl,
  AlignVerticalJustifyCenter: Tl,
  AlignVerticalJustifyEnd: $l,
  AlignVerticalJustifyStart: Ol,
  AlignVerticalSpaceAround: Rl,
  AlignVerticalSpaceBetween: Fl,
  Ambulance: El,
  Ampersand: Ul,
  Ampersands: Nl,
  Amphora: Wl,
  Anchor: Gl,
  Angry: Zl,
  Annoyed: Yl,
  Antenna: Kl,
  Anvil: Xl,
  Aperture: Ql,
  AppWindow: ei,
  AppWindowMac: Jl,
  Apple: ti,
  Archive: oi,
  ArchiveRestore: ai,
  ArchiveX: ni,
  Armchair: ri,
  ArrowBigDown: ii,
  ArrowBigDownDash: li,
  ArrowBigLeft: di,
  ArrowBigLeftDash: ci,
  ArrowBigRight: ui,
  ArrowBigRightDash: si,
  ArrowBigUp: pi,
  ArrowBigUpDash: hi,
  ArrowDown: wi,
  ArrowDown01: yi,
  ArrowDown10: ki,
  ArrowDownAZ: ha,
  ArrowDownFromLine: mi,
  ArrowDownLeft: fi,
  ArrowDownNarrowWide: vi,
  ArrowDownRight: gi,
  ArrowDownToDot: Mi,
  ArrowDownToLine: bi,
  ArrowDownUp: xi,
  ArrowDownWideNarrow: pa,
  ArrowDownZA: ya,
  ArrowLeft: Ci,
  ArrowLeftFromLine: Li,
  ArrowLeftRight: Si,
  ArrowLeftToLine: Ii,
  ArrowRight: Pi,
  ArrowRightFromLine: Ai,
  ArrowRightLeft: qi,
  ArrowRightToLine: zi,
  ArrowUp: Ri,
  ArrowUp01: _i,
  ArrowUp10: ji,
  ArrowUpAZ: ka,
  ArrowUpDown: Hi,
  ArrowUpFromDot: Vi,
  ArrowUpFromLine: Bi,
  ArrowUpLeft: Di,
  ArrowUpNarrowWide: ma,
  ArrowUpRight: Ti,
  ArrowUpToLine: $i,
  ArrowUpWideNarrow: Oi,
  ArrowUpZA: fa,
  ArrowsUpFromLine: Fi,
  Asterisk: Ei,
  AtSign: Ui,
  Atom: Ni,
  AudioLines: Wi,
  AudioWaveform: Gi,
  Award: Zi,
  Axe: Yi,
  Axis3d: va,
  Baby: Ki,
  Backpack: Xi,
  Badge: p2,
  BadgeAlert: Qi,
  BadgeCent: Ji,
  BadgeCheck: ga,
  BadgeDollarSign: e2,
  BadgeEuro: t2,
  BadgeHelp: a2,
  BadgeIndianRupee: n2,
  BadgeInfo: o2,
  BadgeJapaneseYen: r2,
  BadgeMinus: l2,
  BadgePercent: i2,
  BadgePlus: c2,
  BadgePoundSterling: d2,
  BadgeRussianRuble: s2,
  BadgeSwissFranc: u2,
  BadgeX: h2,
  BaggageClaim: y2,
  Ban: k2,
  Banana: m2,
  Bandage: f2,
  Banknote: b2,
  BanknoteArrowDown: v2,
  BanknoteArrowUp: g2,
  BanknoteX: M2,
  Barcode: x2,
  Baseline: w2,
  Bath: L2,
  Battery: P2,
  BatteryCharging: S2,
  BatteryFull: I2,
  BatteryLow: C2,
  BatteryMedium: A2,
  BatteryPlus: q2,
  BatteryWarning: z2,
  Beaker: _2,
  Bean: H2,
  BeanOff: j2,
  Bed: D2,
  BedDouble: V2,
  BedSingle: B2,
  Beef: T2,
  Beer: O2,
  BeerOff: $2,
  Bell: G2,
  BellDot: R2,
  BellElectric: F2,
  BellMinus: E2,
  BellOff: U2,
  BellPlus: N2,
  BellRing: W2,
  BetweenHorizontalEnd: Ma,
  BetweenHorizontalStart: ba,
  BetweenVerticalEnd: Z2,
  BetweenVerticalStart: Y2,
  BicepsFlexed: K2,
  Bike: X2,
  Binary: Q2,
  Binoculars: J2,
  Biohazard: ec,
  Bird: tc,
  Bitcoin: ac,
  Blend: nc,
  Blinds: oc,
  Blocks: rc,
  Bluetooth: cc,
  BluetoothConnected: lc,
  BluetoothOff: ic,
  BluetoothSearching: dc,
  Bold: sc,
  Bolt: uc,
  Bomb: hc,
  Bone: pc,
  Book: Bc,
  BookA: yc,
  BookAudio: kc,
  BookCheck: mc,
  BookCopy: fc,
  BookDashed: xa,
  BookDown: vc,
  BookHeadphones: gc,
  BookHeart: Mc,
  BookImage: bc,
  BookKey: xc,
  BookLock: wc,
  BookMarked: Lc,
  BookMinus: Sc,
  BookOpen: Ac,
  BookOpenCheck: Ic,
  BookOpenText: Cc,
  BookPlus: qc,
  BookText: zc,
  BookType: Pc,
  BookUp: _c,
  BookUp2: jc,
  BookUser: Hc,
  BookX: Vc,
  Bookmark: Rc,
  BookmarkCheck: Dc,
  BookmarkMinus: Tc,
  BookmarkPlus: $c,
  BookmarkX: Oc,
  BoomBox: Fc,
  Bot: Nc,
  BotMessageSquare: Ec,
  BotOff: Uc,
  Box: Wc,
  Boxes: Gc,
  Braces: wa,
  Brackets: Zc,
  Brain: Xc,
  BrainCircuit: Yc,
  BrainCog: Kc,
  BrickWall: Qc,
  Briefcase: t0,
  BriefcaseBusiness: Jc,
  BriefcaseConveyorBelt: e0,
  BriefcaseMedical: a0,
  BringToFront: n0,
  Brush: o0,
  Bug: i0,
  BugOff: r0,
  BugPlay: l0,
  Building: d0,
  Building2: c0,
  Bus: u0,
  BusFront: s0,
  Cable: p0,
  CableCar: h0,
  Cake: k0,
  CakeSlice: y0,
  Calculator: m0,
  Calendar: D0,
  Calendar1: f0,
  CalendarArrowDown: v0,
  CalendarArrowUp: g0,
  CalendarCheck: b0,
  CalendarCheck2: M0,
  CalendarClock: x0,
  CalendarCog: w0,
  CalendarDays: L0,
  CalendarFold: S0,
  CalendarHeart: I0,
  CalendarMinus: A0,
  CalendarMinus2: C0,
  CalendarOff: q0,
  CalendarPlus: P0,
  CalendarPlus2: z0,
  CalendarRange: j0,
  CalendarSearch: _0,
  CalendarSync: H0,
  CalendarX: B0,
  CalendarX2: V0,
  Camera: $0,
  CameraOff: T0,
  Candy: F0,
  CandyCane: O0,
  CandyOff: R0,
  Cannabis: E0,
  Captions: La,
  CaptionsOff: U0,
  Car: G0,
  CarFront: N0,
  CarTaxiFront: W0,
  Caravan: Z0,
  Carrot: Y0,
  CaseLower: K0,
  CaseSensitive: X0,
  CaseUpper: Q0,
  CassetteTape: J0,
  Cast: ed,
  Castle: td,
  Cat: ad,
  Cctv: nd,
  ChartArea: Sa,
  ChartBar: Ca,
  ChartBarBig: Ia,
  ChartBarDecreasing: od,
  ChartBarIncreasing: rd,
  ChartBarStacked: ld,
  ChartCandlestick: Aa,
  ChartColumn: Pa,
  ChartColumnBig: qa,
  ChartColumnDecreasing: id,
  ChartColumnIncreasing: za,
  ChartColumnStacked: cd,
  ChartGantt: dd,
  ChartLine: _a,
  ChartNetwork: sd,
  ChartNoAxesColumn: Ha,
  ChartNoAxesColumnDecreasing: ud,
  ChartNoAxesColumnIncreasing: ja,
  ChartNoAxesCombined: hd,
  ChartNoAxesGantt: Va,
  ChartPie: Ba,
  ChartScatter: Da,
  ChartSpline: pd,
  Check: kd,
  CheckCheck: yd,
  ChefHat: md,
  Cherry: fd,
  ChevronDown: vd,
  ChevronFirst: gd,
  ChevronLast: Md,
  ChevronLeft: bd,
  ChevronRight: xd,
  ChevronUp: wd,
  ChevronsDown: Sd,
  ChevronsDownUp: Ld,
  ChevronsLeft: Ad,
  ChevronsLeftRight: Cd,
  ChevronsLeftRightEllipsis: Id,
  ChevronsRight: zd,
  ChevronsRightLeft: qd,
  ChevronsUp: _d,
  ChevronsUpDown: Pd,
  Chrome: jd,
  Church: Hd,
  Cigarette: Bd,
  CigaretteOff: Vd,
  Circle: Zd,
  CircleAlert: Ta,
  CircleArrowDown: $a,
  CircleArrowLeft: Oa,
  CircleArrowOutDownLeft: Ra,
  CircleArrowOutDownRight: Fa,
  CircleArrowOutUpLeft: Ea,
  CircleArrowOutUpRight: Ua,
  CircleArrowRight: Na,
  CircleArrowUp: Wa,
  CircleCheck: Za,
  CircleCheckBig: Ga,
  CircleChevronDown: Ya,
  CircleChevronLeft: Ka,
  CircleChevronRight: Xa,
  CircleChevronUp: Qa,
  CircleDashed: Dd,
  CircleDivide: Ja,
  CircleDollarSign: Td,
  CircleDot: Od,
  CircleDotDashed: $d,
  CircleEllipsis: Rd,
  CircleEqual: Fd,
  CircleFadingArrowUp: Ed,
  CircleFadingPlus: Ud,
  CircleGauge: e1,
  CircleHelp: t1,
  CircleMinus: a1,
  CircleOff: Nd,
  CircleParking: o1,
  CircleParkingOff: n1,
  CirclePause: r1,
  CirclePercent: l1,
  CirclePlay: i1,
  CirclePlus: c1,
  CirclePower: d1,
  CircleSlash: Wd,
  CircleSlash2: s1,
  CircleSmall: Gd,
  CircleStop: u1,
  CircleUser: p1,
  CircleUserRound: h1,
  CircleX: y1,
  CircuitBoard: Yd,
  Citrus: Kd,
  Clapperboard: Xd,
  Clipboard: ls,
  ClipboardCheck: Qd,
  ClipboardCopy: Jd,
  ClipboardList: es,
  ClipboardMinus: ts,
  ClipboardPaste: as,
  ClipboardPen: m1,
  ClipboardPenLine: k1,
  ClipboardPlus: ns,
  ClipboardType: os,
  ClipboardX: rs,
  Clock: ws,
  Clock1: is,
  Clock10: cs,
  Clock11: ds,
  Clock12: ss,
  Clock2: us,
  Clock3: hs,
  Clock4: ps,
  Clock5: ys,
  Clock6: ks,
  Clock7: ms,
  Clock8: fs,
  Clock9: vs,
  ClockAlert: gs,
  ClockArrowDown: Ms,
  ClockArrowUp: bs,
  ClockFading: xs,
  Cloud: Ts,
  CloudAlert: Ls,
  CloudCog: Ss,
  CloudDownload: f1,
  CloudDrizzle: Is,
  CloudFog: As,
  CloudHail: Cs,
  CloudLightning: qs,
  CloudMoon: _s,
  CloudMoonRain: zs,
  CloudOff: Ps,
  CloudRain: Hs,
  CloudRainWind: js,
  CloudSnow: Vs,
  CloudSun: Ds,
  CloudSunRain: Bs,
  CloudUpload: v1,
  Cloudy: $s,
  Clover: Os,
  Club: Rs,
  Code: Fs,
  CodeXml: g1,
  Codepen: Es,
  Codesandbox: Us,
  Coffee: Ws,
  Cog: Ns,
  Coins: Gs,
  Columns2: M1,
  Columns3: b1,
  Columns4: Zs,
  Combine: Ys,
  Command: Ks,
  Compass: Xs,
  Component: Qs,
  Computer: Js,
  ConciergeBell: eu,
  Cone: tu,
  Construction: au,
  Contact: nu,
  ContactRound: x1,
  Container: ou,
  Contrast: ru,
  Cookie: lu,
  CookingPot: iu,
  Copy: pu,
  CopyCheck: cu,
  CopyMinus: hu,
  CopyPlus: du,
  CopySlash: su,
  CopyX: uu,
  Copyleft: yu,
  Copyright: ku,
  CornerDownLeft: mu,
  CornerDownRight: fu,
  CornerLeftDown: vu,
  CornerLeftUp: gu,
  CornerRightDown: Mu,
  CornerRightUp: bu,
  CornerUpLeft: xu,
  CornerUpRight: wu,
  Cpu: Lu,
  CreativeCommons: Iu,
  CreditCard: Su,
  Croissant: Cu,
  Crop: Au,
  Cross: qu,
  Crosshair: zu,
  Crown: Pu,
  Cuboid: _u,
  CupSoda: ju,
  Currency: Hu,
  Cylinder: Vu,
  Dam: Bu,
  Database: Tu,
  DatabaseBackup: Du,
  DatabaseZap: $u,
  Delete: Ou,
  Dessert: Ru,
  Diameter: Fu,
  Diamond: Nu,
  DiamondMinus: Eu,
  DiamondPercent: w1,
  DiamondPlus: Uu,
  Dice1: Wu,
  Dice2: Gu,
  Dice3: Zu,
  Dice4: Yu,
  Dice5: Ku,
  Dice6: Xu,
  Dices: Qu,
  Diff: Ju,
  Disc: nh,
  Disc2: eh,
  Disc3: th,
  DiscAlbum: ah,
  Divide: oh,
  Dna: lh,
  DnaOff: rh,
  Dock: ih,
  Dog: ch,
  DollarSign: dh,
  Donut: sh,
  DoorClosed: uh,
  DoorOpen: hh,
  Dot: ph,
  Download: yh,
  DraftingCompass: kh,
  Drama: mh,
  Dribbble: fh,
  Drill: vh,
  Droplet: Mh,
  DropletOff: gh,
  Droplets: bh,
  Drum: xh,
  Drumstick: wh,
  Dumbbell: Lh,
  Ear: Ih,
  EarOff: Sh,
  Earth: L1,
  EarthLock: Ch,
  Eclipse: Ah,
  Egg: Ph,
  EggFried: qh,
  EggOff: zh,
  Ellipsis: I1,
  EllipsisVertical: S1,
  Equal: Hh,
  EqualApproximately: _h,
  EqualNot: jh,
  Eraser: Vh,
  EthernetPort: Bh,
  Euro: Dh,
  Expand: Th,
  ExternalLink: $h,
  Eye: Fh,
  EyeClosed: Oh,
  EyeOff: Rh,
  Facebook: Eh,
  Factory: Uh,
  Fan: Nh,
  FastForward: Wh,
  Feather: Gh,
  Fence: Zh,
  FerrisWheel: Yh,
  Figma: Kh,
  File: Gp,
  FileArchive: Xh,
  FileAudio: Jh,
  FileAudio2: Qh,
  FileAxis3d: C1,
  FileBadge: tp,
  FileBadge2: ep,
  FileBox: ap,
  FileChartColumn: q1,
  FileChartColumnIncreasing: A1,
  FileChartLine: z1,
  FileChartPie: P1,
  FileCheck: op,
  FileCheck2: np,
  FileClock: rp,
  FileCode: ip,
  FileCode2: lp,
  FileCog: _1,
  FileDiff: cp,
  FileDigit: dp,
  FileDown: sp,
  FileHeart: up,
  FileImage: hp,
  FileInput: pp,
  FileJson: kp,
  FileJson2: yp,
  FileKey: fp,
  FileKey2: mp,
  FileLock: gp,
  FileLock2: vp,
  FileMinus: bp,
  FileMinus2: Mp,
  FileMusic: xp,
  FileOutput: wp,
  FilePen: H1,
  FilePenLine: j1,
  FilePlus: Sp,
  FilePlus2: Lp,
  FileQuestion: Ip,
  FileScan: Cp,
  FileSearch: qp,
  FileSearch2: Ap,
  FileSliders: zp,
  FileSpreadsheet: Pp,
  FileStack: _p,
  FileSymlink: jp,
  FileTerminal: Hp,
  FileText: Vp,
  FileType: Dp,
  FileType2: Bp,
  FileUp: Tp,
  FileUser: $p,
  FileVideo: Rp,
  FileVideo2: Op,
  FileVolume: Ep,
  FileVolume2: Fp,
  FileWarning: Up,
  FileX: Wp,
  FileX2: Np,
  Files: Zp,
  Film: Yp,
  Fingerprint: Kp,
  FireExtinguisher: Xp,
  Fish: ey,
  FishOff: Qp,
  FishSymbol: Jp,
  Flag: oy,
  FlagOff: ay,
  FlagTriangleLeft: ty,
  FlagTriangleRight: ny,
  Flame: ly,
  FlameKindling: ry,
  Flashlight: cy,
  FlashlightOff: iy,
  FlaskConical: sy,
  FlaskConicalOff: dy,
  FlaskRound: uy,
  FlipHorizontal: py,
  FlipHorizontal2: hy,
  FlipVertical: ky,
  FlipVertical2: yy,
  Flower: fy,
  Flower2: my,
  Focus: vy,
  FoldHorizontal: gy,
  FoldVertical: My,
  Folder: Zy,
  FolderArchive: by,
  FolderCheck: xy,
  FolderClock: wy,
  FolderClosed: Ly,
  FolderCode: Sy,
  FolderCog: V1,
  FolderDot: Iy,
  FolderDown: Cy,
  FolderGit: qy,
  FolderGit2: Ay,
  FolderHeart: zy,
  FolderInput: Py,
  FolderKanban: _y,
  FolderKey: jy,
  FolderLock: Vy,
  FolderMinus: Hy,
  FolderOpen: Dy,
  FolderOpenDot: By,
  FolderOutput: Ty,
  FolderPen: B1,
  FolderPlus: $y,
  FolderRoot: Oy,
  FolderSearch: Fy,
  FolderSearch2: Ry,
  FolderSymlink: Ey,
  FolderSync: Uy,
  FolderTree: Ny,
  FolderUp: Wy,
  FolderX: Gy,
  Folders: Yy,
  Footprints: Ky,
  Forklift: Xy,
  Forward: Qy,
  Frame: Jy,
  Framer: ek,
  Frown: tk,
  Fuel: ak,
  Fullscreen: nk,
  Funnel: T1,
  FunnelPlus: ok,
  FunnelX: D1,
  GalleryHorizontal: lk,
  GalleryHorizontalEnd: rk,
  GalleryThumbnails: ik,
  GalleryVertical: dk,
  GalleryVerticalEnd: ck,
  Gamepad: uk,
  Gamepad2: sk,
  Gauge: hk,
  Gavel: pk,
  Gem: yk,
  Ghost: kk,
  Gift: mk,
  GitBranch: vk,
  GitBranchPlus: fk,
  GitCommitHorizontal: $1,
  GitCommitVertical: gk,
  GitCompare: bk,
  GitCompareArrows: Mk,
  GitFork: xk,
  GitGraph: wk,
  GitMerge: Lk,
  GitPullRequest: zk,
  GitPullRequestArrow: Sk,
  GitPullRequestClosed: Ik,
  GitPullRequestCreate: Ak,
  GitPullRequestCreateArrow: Ck,
  GitPullRequestDraft: qk,
  Github: Pk,
  Gitlab: _k,
  GlassWater: jk,
  Glasses: Hk,
  Globe: Bk,
  GlobeLock: Vk,
  Goal: Dk,
  Grab: Tk,
  GraduationCap: $k,
  Grape: Ok,
  Grid2x2: E1,
  Grid2x2Check: O1,
  Grid2x2Plus: R1,
  Grid2x2X: F1,
  Grid3x3: Vt,
  Grip: Ek,
  GripHorizontal: Rk,
  GripVertical: Fk,
  Group: Uk,
  Guitar: Nk,
  Ham: Wk,
  Hammer: Gk,
  Hand: Qk,
  HandCoins: Zk,
  HandHeart: Yk,
  HandHelping: U1,
  HandMetal: Kk,
  HandPlatter: Xk,
  Handshake: Jk,
  HardDrive: a4,
  HardDriveDownload: e4,
  HardDriveUpload: t4,
  HardHat: n4,
  Hash: o4,
  Haze: r4,
  HdmiPort: l4,
  Heading: p4,
  Heading1: i4,
  Heading2: c4,
  Heading3: d4,
  Heading4: s4,
  Heading5: u4,
  Heading6: h4,
  HeadphoneOff: y4,
  Headphones: k4,
  Headset: m4,
  Heart: b4,
  HeartCrack: f4,
  HeartHandshake: v4,
  HeartOff: g4,
  HeartPulse: M4,
  Heater: x4,
  Hexagon: w4,
  Highlighter: L4,
  History: S4,
  Hop: C4,
  HopOff: I4,
  Hospital: A4,
  Hotel: q4,
  Hourglass: z4,
  House: N1,
  HousePlug: P4,
  HousePlus: _4,
  HouseWifi: j4,
  IceCreamBowl: W1,
  IceCreamCone: G1,
  IdCard: H4,
  Image: F4,
  ImageDown: V4,
  ImageMinus: B4,
  ImageOff: T4,
  ImagePlay: D4,
  ImagePlus: $4,
  ImageUp: O4,
  ImageUpscale: R4,
  Images: E4,
  Import: U4,
  Inbox: N4,
  IndentDecrease: Y1,
  IndentIncrease: Z1,
  IndianRupee: W4,
  Infinity: G4,
  Info: Z4,
  InspectionPanel: Y4,
  Instagram: K4,
  Italic: X4,
  IterationCcw: Q4,
  IterationCw: J4,
  JapaneseYen: e5,
  Joystick: t5,
  Kanban: n5,
  Key: r5,
  KeyRound: a5,
  KeySquare: o5,
  Keyboard: i5,
  KeyboardMusic: c5,
  KeyboardOff: l5,
  Lamp: y5,
  LampCeiling: d5,
  LampDesk: s5,
  LampFloor: u5,
  LampWallDown: h5,
  LampWallUp: p5,
  LandPlot: k5,
  Landmark: m5,
  Languages: f5,
  Laptop: g5,
  LaptopMinimal: K1,
  LaptopMinimalCheck: v5,
  Lasso: b5,
  LassoSelect: M5,
  Laugh: x5,
  Layers: X1,
  Layers2: w5,
  LayoutDashboard: L5,
  LayoutGrid: S5,
  LayoutList: I5,
  LayoutPanelLeft: C5,
  LayoutPanelTop: A5,
  LayoutTemplate: q5,
  Leaf: z5,
  LeafyGreen: P5,
  Lectern: _5,
  LetterText: j5,
  Library: V5,
  LibraryBig: H5,
  LifeBuoy: B5,
  Ligature: D5,
  Lightbulb: $5,
  LightbulbOff: T5,
  Link: F5,
  Link2: R5,
  Link2Off: O5,
  Linkedin: E5,
  List: lm,
  ListCheck: U5,
  ListChecks: N5,
  ListCollapse: W5,
  ListEnd: G5,
  ListFilter: Z5,
  ListFilterPlus: K5,
  ListMinus: Y5,
  ListMusic: X5,
  ListOrdered: Q5,
  ListPlus: J5,
  ListRestart: em,
  ListStart: tm,
  ListTodo: am,
  ListTree: nm,
  ListVideo: om,
  ListX: rm,
  Loader: cm,
  LoaderCircle: Q1,
  LoaderPinwheel: im,
  Locate: um,
  LocateFixed: dm,
  LocateOff: sm,
  Lock: pm,
  LockKeyhole: hm,
  LockKeyholeOpen: J1,
  LockOpen: en,
  LogIn: ym,
  LogOut: km,
  Logs: mm,
  Lollipop: fm,
  Luggage: vm,
  Magnet: gm,
  Mail: Am,
  MailCheck: Mm,
  MailMinus: bm,
  MailOpen: xm,
  MailPlus: wm,
  MailQuestion: Lm,
  MailSearch: Sm,
  MailWarning: Im,
  MailX: Cm,
  Mailbox: qm,
  Mails: zm,
  Map: Um,
  MapPin: Rm,
  MapPinCheck: _m,
  MapPinCheckInside: Pm,
  MapPinHouse: jm,
  MapPinMinus: Vm,
  MapPinMinusInside: Hm,
  MapPinOff: Bm,
  MapPinPlus: Tm,
  MapPinPlusInside: Dm,
  MapPinX: Om,
  MapPinXInside: $m,
  MapPinned: Fm,
  MapPlus: Em,
  Mars: Wm,
  MarsStroke: Nm,
  Martini: Gm,
  Maximize: Ym,
  Maximize2: Zm,
  Medal: Km,
  Megaphone: Qm,
  MegaphoneOff: Xm,
  Meh: Jm,
  MemoryStick: e3,
  Menu: t3,
  Merge: a3,
  MessageCircle: p3,
  MessageCircleCode: n3,
  MessageCircleDashed: o3,
  MessageCircleHeart: r3,
  MessageCircleMore: l3,
  MessageCircleOff: i3,
  MessageCirclePlus: c3,
  MessageCircleQuestion: d3,
  MessageCircleReply: s3,
  MessageCircleWarning: u3,
  MessageCircleX: h3,
  MessageSquare: q3,
  MessageSquareCode: y3,
  MessageSquareDashed: k3,
  MessageSquareDiff: m3,
  MessageSquareDot: f3,
  MessageSquareHeart: v3,
  MessageSquareLock: g3,
  MessageSquareMore: M3,
  MessageSquareOff: b3,
  MessageSquarePlus: x3,
  MessageSquareQuote: w3,
  MessageSquareReply: L3,
  MessageSquareShare: S3,
  MessageSquareText: I3,
  MessageSquareWarning: C3,
  MessageSquareX: A3,
  MessagesSquare: z3,
  Mic: _3,
  MicOff: P3,
  MicVocal: tn,
  Microchip: j3,
  Microscope: H3,
  Microwave: V3,
  Milestone: B3,
  Milk: T3,
  MilkOff: D3,
  Minimize: O3,
  Minimize2: $3,
  Minus: R3,
  Monitor: ef,
  MonitorCheck: F3,
  MonitorCog: E3,
  MonitorDot: U3,
  MonitorDown: N3,
  MonitorOff: W3,
  MonitorPause: G3,
  MonitorPlay: Z3,
  MonitorSmartphone: Y3,
  MonitorSpeaker: K3,
  MonitorStop: X3,
  MonitorUp: Q3,
  MonitorX: J3,
  Moon: af,
  MoonStar: tf,
  Mountain: of,
  MountainSnow: nf,
  Mouse: uf,
  MouseOff: rf,
  MousePointer: sf,
  MousePointer2: lf,
  MousePointerBan: cf,
  MousePointerClick: df,
  Move: Sf,
  Move3d: an,
  MoveDiagonal: pf,
  MoveDiagonal2: hf,
  MoveDown: mf,
  MoveDownLeft: yf,
  MoveDownRight: kf,
  MoveHorizontal: ff,
  MoveLeft: vf,
  MoveRight: gf,
  MoveUp: xf,
  MoveUpLeft: Mf,
  MoveUpRight: bf,
  MoveVertical: wf,
  Music: Af,
  Music2: Lf,
  Music3: If,
  Music4: Cf,
  Navigation: _f,
  Navigation2: zf,
  Navigation2Off: qf,
  NavigationOff: Pf,
  Network: jf,
  Newspaper: Hf,
  Nfc: Vf,
  NonBinary: Bf,
  Notebook: Of,
  NotebookPen: Df,
  NotebookTabs: Tf,
  NotebookText: $f,
  NotepadText: Ff,
  NotepadTextDashed: Rf,
  Nut: Uf,
  NutOff: Ef,
  Octagon: Wf,
  OctagonAlert: nn,
  OctagonMinus: Nf,
  OctagonPause: on,
  OctagonX: rn,
  Omega: Gf,
  Option: Zf,
  Orbit: Yf,
  Origami: Kf,
  Package: ov,
  Package2: Xf,
  PackageCheck: Qf,
  PackageMinus: Jf,
  PackageOpen: ev,
  PackagePlus: tv,
  PackageSearch: av,
  PackageX: nv,
  PaintBucket: rv,
  PaintRoller: lv,
  Paintbrush: iv,
  PaintbrushVertical: ln,
  Palette: cv,
  PanelBottom: uv,
  PanelBottomClose: dv,
  PanelBottomDashed: cn,
  PanelBottomOpen: sv,
  PanelLeft: hn,
  PanelLeftClose: dn,
  PanelLeftDashed: sn,
  PanelLeftOpen: un,
  PanelRight: yv,
  PanelRightClose: hv,
  PanelRightDashed: pn,
  PanelRightOpen: pv,
  PanelTop: fv,
  PanelTopClose: kv,
  PanelTopDashed: yn,
  PanelTopOpen: mv,
  PanelsLeftBottom: vv,
  PanelsRightBottom: gv,
  PanelsTopLeft: kn,
  Paperclip: Mv,
  Parentheses: xv,
  ParkingMeter: bv,
  PartyPopper: wv,
  Pause: Lv,
  PawPrint: Sv,
  PcCase: Iv,
  Pen: fn,
  PenLine: mn,
  PenOff: Cv,
  PenTool: Av,
  Pencil: _v,
  PencilLine: qv,
  PencilOff: zv,
  PencilRuler: Pv,
  Pentagon: jv,
  Percent: Hv,
  PersonStanding: Vv,
  PhilippinePeso: Bv,
  Phone: Ev,
  PhoneCall: Dv,
  PhoneForwarded: Tv,
  PhoneIncoming: $v,
  PhoneMissed: Ov,
  PhoneOff: Rv,
  PhoneOutgoing: Fv,
  Pi: Uv,
  Piano: Nv,
  Pickaxe: Wv,
  PictureInPicture: Zv,
  PictureInPicture2: Gv,
  PiggyBank: Yv,
  Pilcrow: Qv,
  PilcrowLeft: Kv,
  PilcrowRight: Xv,
  Pill: e6,
  PillBottle: Jv,
  Pin: a6,
  PinOff: t6,
  Pipette: o6,
  Pizza: n6,
  Plane: i6,
  PlaneLanding: r6,
  PlaneTakeoff: l6,
  Play: c6,
  Plug: s6,
  Plug2: d6,
  PlugZap: vn,
  Plus: u6,
  Pocket: h6,
  PocketKnife: p6,
  Podcast: y6,
  Pointer: k6,
  PointerOff: m6,
  Popcorn: f6,
  Popsicle: v6,
  PoundSterling: g6,
  Power: b6,
  PowerOff: M6,
  Presentation: x6,
  Printer: L6,
  PrinterCheck: w6,
  Projector: S6,
  Proportions: I6,
  Puzzle: A6,
  Pyramid: C6,
  QrCode: q6,
  Quote: z6,
  Rabbit: P6,
  Radar: _6,
  Radiation: j6,
  Radical: H6,
  Radio: D6,
  RadioReceiver: V6,
  RadioTower: B6,
  Radius: T6,
  RailSymbol: $6,
  Rainbow: O6,
  Rat: R6,
  Ratio: F6,
  Receipt: X6,
  ReceiptCent: E6,
  ReceiptEuro: U6,
  ReceiptIndianRupee: N6,
  ReceiptJapaneseYen: W6,
  ReceiptPoundSterling: G6,
  ReceiptRussianRuble: Z6,
  ReceiptSwissFranc: Y6,
  ReceiptText: K6,
  RectangleEllipsis: gn,
  RectangleHorizontal: Q6,
  RectangleVertical: J6,
  Recycle: e8,
  Redo: n8,
  Redo2: t8,
  RedoDot: a8,
  RefreshCcw: r8,
  RefreshCcwDot: o8,
  RefreshCw: i8,
  RefreshCwOff: l8,
  Refrigerator: c8,
  Regex: d8,
  RemoveFormatting: s8,
  Repeat: p8,
  Repeat1: u8,
  Repeat2: h8,
  Replace: k8,
  ReplaceAll: y8,
  Reply: f8,
  ReplyAll: m8,
  Rewind: v8,
  Ribbon: g8,
  Rocket: M8,
  RockingChair: b8,
  RollerCoaster: x8,
  Rotate3d: Mn,
  RotateCcw: L8,
  RotateCcwSquare: w8,
  RotateCw: I8,
  RotateCwSquare: S8,
  Route: A8,
  RouteOff: C8,
  Router: q8,
  Rows2: bn,
  Rows3: xn,
  Rows4: z8,
  Rss: P8,
  Ruler: _8,
  RussianRuble: j8,
  Sailboat: H8,
  Salad: V8,
  Sandwich: B8,
  Satellite: T8,
  SatelliteDish: D8,
  SaudiRiyal: $8,
  Save: F8,
  SaveAll: O8,
  SaveOff: R8,
  Scale: E8,
  Scale3d: wn,
  Scaling: U8,
  Scan: J8,
  ScanBarcode: N8,
  ScanEye: W8,
  ScanFace: G8,
  ScanHeart: Z8,
  ScanLine: Y8,
  ScanQrCode: K8,
  ScanSearch: Q8,
  ScanText: X8,
  School: eg,
  Scissors: ag,
  ScissorsLineDashed: tg,
  ScreenShare: og,
  ScreenShareOff: ng,
  Scroll: lg,
  ScrollText: rg,
  Search: ug,
  SearchCheck: ig,
  SearchCode: cg,
  SearchSlash: dg,
  SearchX: sg,
  Section: hg,
  Send: yg,
  SendHorizontal: Ln,
  SendToBack: pg,
  SeparatorHorizontal: kg,
  SeparatorVertical: mg,
  Server: Mg,
  ServerCog: fg,
  ServerCrash: vg,
  ServerOff: gg,
  Settings: xg,
  Settings2: bg,
  Shapes: wg,
  Share: Sg,
  Share2: Lg,
  Sheet: Ig,
  Shell: Cg,
  Shield: Tg,
  ShieldAlert: Ag,
  ShieldBan: qg,
  ShieldCheck: zg,
  ShieldEllipsis: Pg,
  ShieldHalf: _g,
  ShieldMinus: jg,
  ShieldOff: Hg,
  ShieldPlus: Vg,
  ShieldQuestion: Bg,
  ShieldUser: Dg,
  ShieldX: Sn,
  Ship: Og,
  ShipWheel: $g,
  Shirt: Rg,
  ShoppingBag: Fg,
  ShoppingBasket: Eg,
  ShoppingCart: Ug,
  Shovel: Ng,
  ShowerHead: Wg,
  Shrimp: Gg,
  Shrink: Yg,
  Shrub: Zg,
  Shuffle: Kg,
  Sigma: Xg,
  Signal: a7,
  SignalHigh: Qg,
  SignalLow: Jg,
  SignalMedium: e7,
  SignalZero: t7,
  Signature: n7,
  Signpost: r7,
  SignpostBig: o7,
  Siren: l7,
  SkipBack: i7,
  SkipForward: c7,
  Skull: d7,
  Slack: s7,
  Slash: u7,
  Slice: h7,
  SlidersHorizontal: p7,
  SlidersVertical: In,
  Smartphone: m7,
  SmartphoneCharging: y7,
  SmartphoneNfc: k7,
  Smile: v7,
  SmilePlus: f7,
  Snail: g7,
  Snowflake: M7,
  Sofa: b7,
  Soup: x7,
  Space: w7,
  Spade: L7,
  Sparkle: S7,
  Sparkles: Cn,
  Speaker: I7,
  Speech: C7,
  SpellCheck: q7,
  SpellCheck2: A7,
  Spline: P7,
  SplinePointer: z7,
  Split: _7,
  SprayCan: j7,
  Sprout: H7,
  Square: R7,
  SquareActivity: An,
  SquareArrowDown: Pn,
  SquareArrowDownLeft: qn,
  SquareArrowDownRight: zn,
  SquareArrowLeft: _n,
  SquareArrowOutDownLeft: jn,
  SquareArrowOutDownRight: Hn,
  SquareArrowOutUpLeft: Vn,
  SquareArrowOutUpRight: Bn,
  SquareArrowRight: Dn,
  SquareArrowUp: On,
  SquareArrowUpLeft: Tn,
  SquareArrowUpRight: $n,
  SquareAsterisk: Rn,
  SquareBottomDashedScissors: Fn,
  SquareChartGantt: Bt,
  SquareCheck: Un,
  SquareCheckBig: En,
  SquareChevronDown: Nn,
  SquareChevronLeft: Wn,
  SquareChevronRight: Gn,
  SquareChevronUp: Zn,
  SquareCode: Yn,
  SquareDashed: Qn,
  SquareDashedBottom: B7,
  SquareDashedBottomCode: V7,
  SquareDashedKanban: Kn,
  SquareDashedMousePointer: Xn,
  SquareDivide: eo,
  SquareDot: Jn,
  SquareEqual: to,
  SquareFunction: ao,
  SquareKanban: no,
  SquareLibrary: oo,
  SquareM: ro,
  SquareMenu: lo,
  SquareMinus: io,
  SquareMousePointer: co,
  SquareParking: uo,
  SquareParkingOff: so,
  SquarePen: xt,
  SquarePercent: ho,
  SquarePi: po,
  SquarePilcrow: yo,
  SquarePlay: ko,
  SquarePlus: mo,
  SquarePower: fo,
  SquareRadical: D7,
  SquareRoundCorner: T7,
  SquareScissors: vo,
  SquareSigma: go,
  SquareSlash: Mo,
  SquareSplitHorizontal: bo,
  SquareSplitVertical: xo,
  SquareSquare: $7,
  SquareStack: O7,
  SquareTerminal: wo,
  SquareUser: So,
  SquareUserRound: Lo,
  SquareX: Io,
  Squircle: F7,
  Squirrel: E7,
  Stamp: U7,
  Star: G7,
  StarHalf: N7,
  StarOff: W7,
  StepBack: Z7,
  StepForward: Y7,
  Stethoscope: K7,
  Sticker: X7,
  StickyNote: Q7,
  Store: J7,
  StretchHorizontal: eM,
  StretchVertical: tM,
  Strikethrough: aM,
  Subscript: nM,
  Sun: cM,
  SunDim: oM,
  SunMedium: rM,
  SunMoon: lM,
  SunSnow: iM,
  Sunrise: dM,
  Sunset: sM,
  Superscript: uM,
  SwatchBook: hM,
  SwissFranc: pM,
  SwitchCamera: yM,
  Sword: kM,
  Swords: mM,
  Syringe: fM,
  Table: SM,
  Table2: vM,
  TableCellsMerge: gM,
  TableCellsSplit: MM,
  TableColumnsSplit: bM,
  TableOfContents: xM,
  TableProperties: wM,
  TableRowsSplit: LM,
  Tablet: CM,
  TabletSmartphone: IM,
  Tablets: AM,
  Tag: PM,
  Tags: qM,
  Tally1: zM,
  Tally2: _M,
  Tally3: jM,
  Tally4: HM,
  Tally5: VM,
  Tangent: BM,
  Target: DM,
  Telescope: TM,
  Tent: OM,
  TentTree: $M,
  Terminal: RM,
  TestTube: FM,
  TestTubeDiagonal: Co,
  TestTubes: EM,
  Text: ZM,
  TextCursor: NM,
  TextCursorInput: UM,
  TextQuote: WM,
  TextSearch: GM,
  TextSelect: Ao,
  Theater: YM,
  Thermometer: QM,
  ThermometerSnowflake: KM,
  ThermometerSun: XM,
  ThumbsDown: JM,
  ThumbsUp: e9,
  Ticket: i9,
  TicketCheck: t9,
  TicketMinus: a9,
  TicketPercent: n9,
  TicketPlus: o9,
  TicketSlash: r9,
  TicketX: l9,
  Tickets: d9,
  TicketsPlane: c9,
  Timer: h9,
  TimerOff: s9,
  TimerReset: u9,
  ToggleLeft: p9,
  ToggleRight: y9,
  Toilet: k9,
  Tornado: m9,
  Torus: f9,
  Touchpad: g9,
  TouchpadOff: v9,
  TowerControl: M9,
  ToyBrick: b9,
  Tractor: x9,
  TrafficCone: w9,
  TrainFront: S9,
  TrainFrontTunnel: L9,
  TrainTrack: I9,
  TramFront: qo,
  Transgender: A9,
  Trash: q9,
  Trash2: C9,
  TreeDeciduous: z9,
  TreePalm: zo,
  TreePine: P9,
  Trees: _9,
  Trello: j9,
  TrendingDown: H9,
  TrendingUp: B9,
  TrendingUpDown: V9,
  Triangle: $9,
  TriangleAlert: Po,
  TriangleDashed: D9,
  TriangleRight: T9,
  Trophy: O9,
  Truck: R9,
  Turtle: F9,
  Tv: U9,
  TvMinimal: _o,
  TvMinimalPlay: E9,
  Twitch: N9,
  Twitter: W9,
  Type: Z9,
  TypeOutline: G9,
  Umbrella: K9,
  UmbrellaOff: Y9,
  Underline: X9,
  Undo: eb,
  Undo2: Q9,
  UndoDot: J9,
  UnfoldHorizontal: tb,
  UnfoldVertical: ab,
  Ungroup: nb,
  University: jo,
  Unlink: rb,
  Unlink2: ob,
  Unplug: lb,
  Upload: ib,
  Usb: cb,
  User: vb,
  UserCheck: db,
  UserCog: sb,
  UserMinus: ub,
  UserPen: hb,
  UserPlus: pb,
  UserRound: $o,
  UserRoundCheck: Ho,
  UserRoundCog: Vo,
  UserRoundMinus: Bo,
  UserRoundPen: yb,
  UserRoundPlus: Do,
  UserRoundSearch: kb,
  UserRoundX: To,
  UserSearch: mb,
  UserX: fb,
  Users: gb,
  UsersRound: Oo,
  Utensils: Fo,
  UtensilsCrossed: Ro,
  UtilityPole: Mb,
  Variable: bb,
  Vault: xb,
  Vegan: wb,
  VenetianMask: Lb,
  Venus: Ib,
  VenusAndMars: Sb,
  Vibrate: Cb,
  VibrateOff: Ab,
  Video: zb,
  VideoOff: qb,
  Videotape: Pb,
  View: _b,
  Voicemail: Hb,
  Volleyball: jb,
  Volume: $b,
  Volume1: Vb,
  Volume2: Bb,
  VolumeOff: Db,
  VolumeX: Tb,
  Vote: Ob,
  Wallet: Fb,
  WalletCards: Rb,
  WalletMinimal: Eo,
  Wallpaper: Eb,
  Wand: Ub,
  WandSparkles: Uo,
  Warehouse: Nb,
  WashingMachine: Wb,
  Watch: Gb,
  Waves: Yb,
  WavesLadder: Zb,
  Waypoints: Kb,
  Webcam: Xb,
  Webhook: Jb,
  WebhookOff: Qb,
  Weight: ex,
  Wheat: ax,
  WheatOff: tx,
  WholeWord: nx,
  Wifi: cx,
  WifiHigh: ox,
  WifiLow: rx,
  WifiOff: lx,
  WifiZero: ix,
  Wind: sx,
  WindArrowDown: dx,
  Wine: hx,
  WineOff: ux,
  Workflow: px,
  Worm: yx,
  WrapText: kx,
  Wrench: mx,
  X: fx,
  Youtube: vx,
  Zap: Mx,
  ZapOff: gx,
  ZoomIn: bx,
  ZoomOut: xx
}, Symbol.toStringTag, { value: "Module" }));
const rI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AArrowDown: ll,
  AArrowDownIcon: ll,
  AArrowUp: il,
  AArrowUpIcon: il,
  ALargeSmall: cl,
  ALargeSmallIcon: cl,
  Accessibility: dl,
  AccessibilityIcon: dl,
  Activity: sl,
  ActivityIcon: sl,
  ActivitySquare: An,
  ActivitySquareIcon: An,
  AirVent: ul,
  AirVentIcon: ul,
  Airplay: hl,
  AirplayIcon: hl,
  AlarmCheck: da,
  AlarmCheckIcon: da,
  AlarmClock: yl,
  AlarmClockCheck: da,
  AlarmClockCheckIcon: da,
  AlarmClockIcon: yl,
  AlarmClockMinus: sa,
  AlarmClockMinusIcon: sa,
  AlarmClockOff: pl,
  AlarmClockOffIcon: pl,
  AlarmClockPlus: ua,
  AlarmClockPlusIcon: ua,
  AlarmMinus: sa,
  AlarmMinusIcon: sa,
  AlarmPlus: ua,
  AlarmPlusIcon: ua,
  AlarmSmoke: kl,
  AlarmSmokeIcon: kl,
  Album: ml,
  AlbumIcon: ml,
  AlertCircle: Ta,
  AlertCircleIcon: Ta,
  AlertOctagon: nn,
  AlertOctagonIcon: nn,
  AlertTriangle: Po,
  AlertTriangleIcon: Po,
  AlignCenter: gl,
  AlignCenterHorizontal: fl,
  AlignCenterHorizontalIcon: fl,
  AlignCenterIcon: gl,
  AlignCenterVertical: vl,
  AlignCenterVerticalIcon: vl,
  AlignEndHorizontal: Ml,
  AlignEndHorizontalIcon: Ml,
  AlignEndVertical: bl,
  AlignEndVerticalIcon: bl,
  AlignHorizontalDistributeCenter: xl,
  AlignHorizontalDistributeCenterIcon: xl,
  AlignHorizontalDistributeEnd: wl,
  AlignHorizontalDistributeEndIcon: wl,
  AlignHorizontalDistributeStart: Ll,
  AlignHorizontalDistributeStartIcon: Ll,
  AlignHorizontalJustifyCenter: Sl,
  AlignHorizontalJustifyCenterIcon: Sl,
  AlignHorizontalJustifyEnd: Il,
  AlignHorizontalJustifyEndIcon: Il,
  AlignHorizontalJustifyStart: Cl,
  AlignHorizontalJustifyStartIcon: Cl,
  AlignHorizontalSpaceAround: Al,
  AlignHorizontalSpaceAroundIcon: Al,
  AlignHorizontalSpaceBetween: ql,
  AlignHorizontalSpaceBetweenIcon: ql,
  AlignJustify: zl,
  AlignJustifyIcon: zl,
  AlignLeft: Pl,
  AlignLeftIcon: Pl,
  AlignRight: _l,
  AlignRightIcon: _l,
  AlignStartHorizontal: jl,
  AlignStartHorizontalIcon: jl,
  AlignStartVertical: Hl,
  AlignStartVerticalIcon: Hl,
  AlignVerticalDistributeCenter: Vl,
  AlignVerticalDistributeCenterIcon: Vl,
  AlignVerticalDistributeEnd: Bl,
  AlignVerticalDistributeEndIcon: Bl,
  AlignVerticalDistributeStart: Dl,
  AlignVerticalDistributeStartIcon: Dl,
  AlignVerticalJustifyCenter: Tl,
  AlignVerticalJustifyCenterIcon: Tl,
  AlignVerticalJustifyEnd: $l,
  AlignVerticalJustifyEndIcon: $l,
  AlignVerticalJustifyStart: Ol,
  AlignVerticalJustifyStartIcon: Ol,
  AlignVerticalSpaceAround: Rl,
  AlignVerticalSpaceAroundIcon: Rl,
  AlignVerticalSpaceBetween: Fl,
  AlignVerticalSpaceBetweenIcon: Fl,
  Ambulance: El,
  AmbulanceIcon: El,
  Ampersand: Ul,
  AmpersandIcon: Ul,
  Ampersands: Nl,
  AmpersandsIcon: Nl,
  Amphora: Wl,
  AmphoraIcon: Wl,
  Anchor: Gl,
  AnchorIcon: Gl,
  Angry: Zl,
  AngryIcon: Zl,
  Annoyed: Yl,
  AnnoyedIcon: Yl,
  Antenna: Kl,
  AntennaIcon: Kl,
  Anvil: Xl,
  AnvilIcon: Xl,
  Aperture: Ql,
  ApertureIcon: Ql,
  AppWindow: ei,
  AppWindowIcon: ei,
  AppWindowMac: Jl,
  AppWindowMacIcon: Jl,
  Apple: ti,
  AppleIcon: ti,
  Archive: oi,
  ArchiveIcon: oi,
  ArchiveRestore: ai,
  ArchiveRestoreIcon: ai,
  ArchiveX: ni,
  ArchiveXIcon: ni,
  AreaChart: Sa,
  AreaChartIcon: Sa,
  Armchair: ri,
  ArmchairIcon: ri,
  ArrowBigDown: ii,
  ArrowBigDownDash: li,
  ArrowBigDownDashIcon: li,
  ArrowBigDownIcon: ii,
  ArrowBigLeft: di,
  ArrowBigLeftDash: ci,
  ArrowBigLeftDashIcon: ci,
  ArrowBigLeftIcon: di,
  ArrowBigRight: ui,
  ArrowBigRightDash: si,
  ArrowBigRightDashIcon: si,
  ArrowBigRightIcon: ui,
  ArrowBigUp: pi,
  ArrowBigUpDash: hi,
  ArrowBigUpDashIcon: hi,
  ArrowBigUpIcon: pi,
  ArrowDown: wi,
  ArrowDown01: yi,
  ArrowDown01Icon: yi,
  ArrowDown10: ki,
  ArrowDown10Icon: ki,
  ArrowDownAZ: ha,
  ArrowDownAZIcon: ha,
  ArrowDownAz: ha,
  ArrowDownAzIcon: ha,
  ArrowDownCircle: $a,
  ArrowDownCircleIcon: $a,
  ArrowDownFromLine: mi,
  ArrowDownFromLineIcon: mi,
  ArrowDownIcon: wi,
  ArrowDownLeft: fi,
  ArrowDownLeftFromCircle: Ra,
  ArrowDownLeftFromCircleIcon: Ra,
  ArrowDownLeftFromSquare: jn,
  ArrowDownLeftFromSquareIcon: jn,
  ArrowDownLeftIcon: fi,
  ArrowDownLeftSquare: qn,
  ArrowDownLeftSquareIcon: qn,
  ArrowDownNarrowWide: vi,
  ArrowDownNarrowWideIcon: vi,
  ArrowDownRight: gi,
  ArrowDownRightFromCircle: Fa,
  ArrowDownRightFromCircleIcon: Fa,
  ArrowDownRightFromSquare: Hn,
  ArrowDownRightFromSquareIcon: Hn,
  ArrowDownRightIcon: gi,
  ArrowDownRightSquare: zn,
  ArrowDownRightSquareIcon: zn,
  ArrowDownSquare: Pn,
  ArrowDownSquareIcon: Pn,
  ArrowDownToDot: Mi,
  ArrowDownToDotIcon: Mi,
  ArrowDownToLine: bi,
  ArrowDownToLineIcon: bi,
  ArrowDownUp: xi,
  ArrowDownUpIcon: xi,
  ArrowDownWideNarrow: pa,
  ArrowDownWideNarrowIcon: pa,
  ArrowDownZA: ya,
  ArrowDownZAIcon: ya,
  ArrowDownZa: ya,
  ArrowDownZaIcon: ya,
  ArrowLeft: Ci,
  ArrowLeftCircle: Oa,
  ArrowLeftCircleIcon: Oa,
  ArrowLeftFromLine: Li,
  ArrowLeftFromLineIcon: Li,
  ArrowLeftIcon: Ci,
  ArrowLeftRight: Si,
  ArrowLeftRightIcon: Si,
  ArrowLeftSquare: _n,
  ArrowLeftSquareIcon: _n,
  ArrowLeftToLine: Ii,
  ArrowLeftToLineIcon: Ii,
  ArrowRight: Pi,
  ArrowRightCircle: Na,
  ArrowRightCircleIcon: Na,
  ArrowRightFromLine: Ai,
  ArrowRightFromLineIcon: Ai,
  ArrowRightIcon: Pi,
  ArrowRightLeft: qi,
  ArrowRightLeftIcon: qi,
  ArrowRightSquare: Dn,
  ArrowRightSquareIcon: Dn,
  ArrowRightToLine: zi,
  ArrowRightToLineIcon: zi,
  ArrowUp: Ri,
  ArrowUp01: _i,
  ArrowUp01Icon: _i,
  ArrowUp10: ji,
  ArrowUp10Icon: ji,
  ArrowUpAZ: ka,
  ArrowUpAZIcon: ka,
  ArrowUpAz: ka,
  ArrowUpAzIcon: ka,
  ArrowUpCircle: Wa,
  ArrowUpCircleIcon: Wa,
  ArrowUpDown: Hi,
  ArrowUpDownIcon: Hi,
  ArrowUpFromDot: Vi,
  ArrowUpFromDotIcon: Vi,
  ArrowUpFromLine: Bi,
  ArrowUpFromLineIcon: Bi,
  ArrowUpIcon: Ri,
  ArrowUpLeft: Di,
  ArrowUpLeftFromCircle: Ea,
  ArrowUpLeftFromCircleIcon: Ea,
  ArrowUpLeftFromSquare: Vn,
  ArrowUpLeftFromSquareIcon: Vn,
  ArrowUpLeftIcon: Di,
  ArrowUpLeftSquare: Tn,
  ArrowUpLeftSquareIcon: Tn,
  ArrowUpNarrowWide: ma,
  ArrowUpNarrowWideIcon: ma,
  ArrowUpRight: Ti,
  ArrowUpRightFromCircle: Ua,
  ArrowUpRightFromCircleIcon: Ua,
  ArrowUpRightFromSquare: Bn,
  ArrowUpRightFromSquareIcon: Bn,
  ArrowUpRightIcon: Ti,
  ArrowUpRightSquare: $n,
  ArrowUpRightSquareIcon: $n,
  ArrowUpSquare: On,
  ArrowUpSquareIcon: On,
  ArrowUpToLine: $i,
  ArrowUpToLineIcon: $i,
  ArrowUpWideNarrow: Oi,
  ArrowUpWideNarrowIcon: Oi,
  ArrowUpZA: fa,
  ArrowUpZAIcon: fa,
  ArrowUpZa: fa,
  ArrowUpZaIcon: fa,
  ArrowsUpFromLine: Fi,
  ArrowsUpFromLineIcon: Fi,
  Asterisk: Ei,
  AsteriskIcon: Ei,
  AsteriskSquare: Rn,
  AsteriskSquareIcon: Rn,
  AtSign: Ui,
  AtSignIcon: Ui,
  Atom: Ni,
  AtomIcon: Ni,
  AudioLines: Wi,
  AudioLinesIcon: Wi,
  AudioWaveform: Gi,
  AudioWaveformIcon: Gi,
  Award: Zi,
  AwardIcon: Zi,
  Axe: Yi,
  AxeIcon: Yi,
  Axis3D: va,
  Axis3DIcon: va,
  Axis3d: va,
  Axis3dIcon: va,
  Baby: Ki,
  BabyIcon: Ki,
  Backpack: Xi,
  BackpackIcon: Xi,
  Badge: p2,
  BadgeAlert: Qi,
  BadgeAlertIcon: Qi,
  BadgeCent: Ji,
  BadgeCentIcon: Ji,
  BadgeCheck: ga,
  BadgeCheckIcon: ga,
  BadgeDollarSign: e2,
  BadgeDollarSignIcon: e2,
  BadgeEuro: t2,
  BadgeEuroIcon: t2,
  BadgeHelp: a2,
  BadgeHelpIcon: a2,
  BadgeIcon: p2,
  BadgeIndianRupee: n2,
  BadgeIndianRupeeIcon: n2,
  BadgeInfo: o2,
  BadgeInfoIcon: o2,
  BadgeJapaneseYen: r2,
  BadgeJapaneseYenIcon: r2,
  BadgeMinus: l2,
  BadgeMinusIcon: l2,
  BadgePercent: i2,
  BadgePercentIcon: i2,
  BadgePlus: c2,
  BadgePlusIcon: c2,
  BadgePoundSterling: d2,
  BadgePoundSterlingIcon: d2,
  BadgeRussianRuble: s2,
  BadgeRussianRubleIcon: s2,
  BadgeSwissFranc: u2,
  BadgeSwissFrancIcon: u2,
  BadgeX: h2,
  BadgeXIcon: h2,
  BaggageClaim: y2,
  BaggageClaimIcon: y2,
  Ban: k2,
  BanIcon: k2,
  Banana: m2,
  BananaIcon: m2,
  Bandage: f2,
  BandageIcon: f2,
  Banknote: b2,
  BanknoteArrowDown: v2,
  BanknoteArrowDownIcon: v2,
  BanknoteArrowUp: g2,
  BanknoteArrowUpIcon: g2,
  BanknoteIcon: b2,
  BanknoteX: M2,
  BanknoteXIcon: M2,
  BarChart: ja,
  BarChart2: Ha,
  BarChart2Icon: Ha,
  BarChart3: Pa,
  BarChart3Icon: Pa,
  BarChart4: za,
  BarChart4Icon: za,
  BarChartBig: qa,
  BarChartBigIcon: qa,
  BarChartHorizontal: Ca,
  BarChartHorizontalBig: Ia,
  BarChartHorizontalBigIcon: Ia,
  BarChartHorizontalIcon: Ca,
  BarChartIcon: ja,
  Barcode: x2,
  BarcodeIcon: x2,
  Baseline: w2,
  BaselineIcon: w2,
  Bath: L2,
  BathIcon: L2,
  Battery: P2,
  BatteryCharging: S2,
  BatteryChargingIcon: S2,
  BatteryFull: I2,
  BatteryFullIcon: I2,
  BatteryIcon: P2,
  BatteryLow: C2,
  BatteryLowIcon: C2,
  BatteryMedium: A2,
  BatteryMediumIcon: A2,
  BatteryPlus: q2,
  BatteryPlusIcon: q2,
  BatteryWarning: z2,
  BatteryWarningIcon: z2,
  Beaker: _2,
  BeakerIcon: _2,
  Bean: H2,
  BeanIcon: H2,
  BeanOff: j2,
  BeanOffIcon: j2,
  Bed: D2,
  BedDouble: V2,
  BedDoubleIcon: V2,
  BedIcon: D2,
  BedSingle: B2,
  BedSingleIcon: B2,
  Beef: T2,
  BeefIcon: T2,
  Beer: O2,
  BeerIcon: O2,
  BeerOff: $2,
  BeerOffIcon: $2,
  Bell: G2,
  BellDot: R2,
  BellDotIcon: R2,
  BellElectric: F2,
  BellElectricIcon: F2,
  BellIcon: G2,
  BellMinus: E2,
  BellMinusIcon: E2,
  BellOff: U2,
  BellOffIcon: U2,
  BellPlus: N2,
  BellPlusIcon: N2,
  BellRing: W2,
  BellRingIcon: W2,
  BetweenHorizonalEnd: Ma,
  BetweenHorizonalEndIcon: Ma,
  BetweenHorizonalStart: ba,
  BetweenHorizonalStartIcon: ba,
  BetweenHorizontalEnd: Ma,
  BetweenHorizontalEndIcon: Ma,
  BetweenHorizontalStart: ba,
  BetweenHorizontalStartIcon: ba,
  BetweenVerticalEnd: Z2,
  BetweenVerticalEndIcon: Z2,
  BetweenVerticalStart: Y2,
  BetweenVerticalStartIcon: Y2,
  BicepsFlexed: K2,
  BicepsFlexedIcon: K2,
  Bike: X2,
  BikeIcon: X2,
  Binary: Q2,
  BinaryIcon: Q2,
  Binoculars: J2,
  BinocularsIcon: J2,
  Biohazard: ec,
  BiohazardIcon: ec,
  Bird: tc,
  BirdIcon: tc,
  Bitcoin: ac,
  BitcoinIcon: ac,
  Blend: nc,
  BlendIcon: nc,
  Blinds: oc,
  BlindsIcon: oc,
  Blocks: rc,
  BlocksIcon: rc,
  Bluetooth: cc,
  BluetoothConnected: lc,
  BluetoothConnectedIcon: lc,
  BluetoothIcon: cc,
  BluetoothOff: ic,
  BluetoothOffIcon: ic,
  BluetoothSearching: dc,
  BluetoothSearchingIcon: dc,
  Bold: sc,
  BoldIcon: sc,
  Bolt: uc,
  BoltIcon: uc,
  Bomb: hc,
  BombIcon: hc,
  Bone: pc,
  BoneIcon: pc,
  Book: Bc,
  BookA: yc,
  BookAIcon: yc,
  BookAudio: kc,
  BookAudioIcon: kc,
  BookCheck: mc,
  BookCheckIcon: mc,
  BookCopy: fc,
  BookCopyIcon: fc,
  BookDashed: xa,
  BookDashedIcon: xa,
  BookDown: vc,
  BookDownIcon: vc,
  BookHeadphones: gc,
  BookHeadphonesIcon: gc,
  BookHeart: Mc,
  BookHeartIcon: Mc,
  BookIcon: Bc,
  BookImage: bc,
  BookImageIcon: bc,
  BookKey: xc,
  BookKeyIcon: xc,
  BookLock: wc,
  BookLockIcon: wc,
  BookMarked: Lc,
  BookMarkedIcon: Lc,
  BookMinus: Sc,
  BookMinusIcon: Sc,
  BookOpen: Ac,
  BookOpenCheck: Ic,
  BookOpenCheckIcon: Ic,
  BookOpenIcon: Ac,
  BookOpenText: Cc,
  BookOpenTextIcon: Cc,
  BookPlus: qc,
  BookPlusIcon: qc,
  BookTemplate: xa,
  BookTemplateIcon: xa,
  BookText: zc,
  BookTextIcon: zc,
  BookType: Pc,
  BookTypeIcon: Pc,
  BookUp: _c,
  BookUp2: jc,
  BookUp2Icon: jc,
  BookUpIcon: _c,
  BookUser: Hc,
  BookUserIcon: Hc,
  BookX: Vc,
  BookXIcon: Vc,
  Bookmark: Rc,
  BookmarkCheck: Dc,
  BookmarkCheckIcon: Dc,
  BookmarkIcon: Rc,
  BookmarkMinus: Tc,
  BookmarkMinusIcon: Tc,
  BookmarkPlus: $c,
  BookmarkPlusIcon: $c,
  BookmarkX: Oc,
  BookmarkXIcon: Oc,
  BoomBox: Fc,
  BoomBoxIcon: Fc,
  Bot: Nc,
  BotIcon: Nc,
  BotMessageSquare: Ec,
  BotMessageSquareIcon: Ec,
  BotOff: Uc,
  BotOffIcon: Uc,
  Box: Wc,
  BoxIcon: Wc,
  BoxSelect: Qn,
  BoxSelectIcon: Qn,
  Boxes: Gc,
  BoxesIcon: Gc,
  Braces: wa,
  BracesIcon: wa,
  Brackets: Zc,
  BracketsIcon: Zc,
  Brain: Xc,
  BrainCircuit: Yc,
  BrainCircuitIcon: Yc,
  BrainCog: Kc,
  BrainCogIcon: Kc,
  BrainIcon: Xc,
  BrickWall: Qc,
  BrickWallIcon: Qc,
  Briefcase: t0,
  BriefcaseBusiness: Jc,
  BriefcaseBusinessIcon: Jc,
  BriefcaseConveyorBelt: e0,
  BriefcaseConveyorBeltIcon: e0,
  BriefcaseIcon: t0,
  BriefcaseMedical: a0,
  BriefcaseMedicalIcon: a0,
  BringToFront: n0,
  BringToFrontIcon: n0,
  Brush: o0,
  BrushIcon: o0,
  Bug: i0,
  BugIcon: i0,
  BugOff: r0,
  BugOffIcon: r0,
  BugPlay: l0,
  BugPlayIcon: l0,
  Building: d0,
  Building2: c0,
  Building2Icon: c0,
  BuildingIcon: d0,
  Bus: u0,
  BusFront: s0,
  BusFrontIcon: s0,
  BusIcon: u0,
  Cable: p0,
  CableCar: h0,
  CableCarIcon: h0,
  CableIcon: p0,
  Cake: k0,
  CakeIcon: k0,
  CakeSlice: y0,
  CakeSliceIcon: y0,
  Calculator: m0,
  CalculatorIcon: m0,
  Calendar: D0,
  Calendar1: f0,
  Calendar1Icon: f0,
  CalendarArrowDown: v0,
  CalendarArrowDownIcon: v0,
  CalendarArrowUp: g0,
  CalendarArrowUpIcon: g0,
  CalendarCheck: b0,
  CalendarCheck2: M0,
  CalendarCheck2Icon: M0,
  CalendarCheckIcon: b0,
  CalendarClock: x0,
  CalendarClockIcon: x0,
  CalendarCog: w0,
  CalendarCogIcon: w0,
  CalendarDays: L0,
  CalendarDaysIcon: L0,
  CalendarFold: S0,
  CalendarFoldIcon: S0,
  CalendarHeart: I0,
  CalendarHeartIcon: I0,
  CalendarIcon: D0,
  CalendarMinus: A0,
  CalendarMinus2: C0,
  CalendarMinus2Icon: C0,
  CalendarMinusIcon: A0,
  CalendarOff: q0,
  CalendarOffIcon: q0,
  CalendarPlus: P0,
  CalendarPlus2: z0,
  CalendarPlus2Icon: z0,
  CalendarPlusIcon: P0,
  CalendarRange: j0,
  CalendarRangeIcon: j0,
  CalendarSearch: _0,
  CalendarSearchIcon: _0,
  CalendarSync: H0,
  CalendarSyncIcon: H0,
  CalendarX: B0,
  CalendarX2: V0,
  CalendarX2Icon: V0,
  CalendarXIcon: B0,
  Camera: $0,
  CameraIcon: $0,
  CameraOff: T0,
  CameraOffIcon: T0,
  CandlestickChart: Aa,
  CandlestickChartIcon: Aa,
  Candy: F0,
  CandyCane: O0,
  CandyCaneIcon: O0,
  CandyIcon: F0,
  CandyOff: R0,
  CandyOffIcon: R0,
  Cannabis: E0,
  CannabisIcon: E0,
  Captions: La,
  CaptionsIcon: La,
  CaptionsOff: U0,
  CaptionsOffIcon: U0,
  Car: G0,
  CarFront: N0,
  CarFrontIcon: N0,
  CarIcon: G0,
  CarTaxiFront: W0,
  CarTaxiFrontIcon: W0,
  Caravan: Z0,
  CaravanIcon: Z0,
  Carrot: Y0,
  CarrotIcon: Y0,
  CaseLower: K0,
  CaseLowerIcon: K0,
  CaseSensitive: X0,
  CaseSensitiveIcon: X0,
  CaseUpper: Q0,
  CaseUpperIcon: Q0,
  CassetteTape: J0,
  CassetteTapeIcon: J0,
  Cast: ed,
  CastIcon: ed,
  Castle: td,
  CastleIcon: td,
  Cat: ad,
  CatIcon: ad,
  Cctv: nd,
  CctvIcon: nd,
  ChartArea: Sa,
  ChartAreaIcon: Sa,
  ChartBar: Ca,
  ChartBarBig: Ia,
  ChartBarBigIcon: Ia,
  ChartBarDecreasing: od,
  ChartBarDecreasingIcon: od,
  ChartBarIcon: Ca,
  ChartBarIncreasing: rd,
  ChartBarIncreasingIcon: rd,
  ChartBarStacked: ld,
  ChartBarStackedIcon: ld,
  ChartCandlestick: Aa,
  ChartCandlestickIcon: Aa,
  ChartColumn: Pa,
  ChartColumnBig: qa,
  ChartColumnBigIcon: qa,
  ChartColumnDecreasing: id,
  ChartColumnDecreasingIcon: id,
  ChartColumnIcon: Pa,
  ChartColumnIncreasing: za,
  ChartColumnIncreasingIcon: za,
  ChartColumnStacked: cd,
  ChartColumnStackedIcon: cd,
  ChartGantt: dd,
  ChartGanttIcon: dd,
  ChartLine: _a,
  ChartLineIcon: _a,
  ChartNetwork: sd,
  ChartNetworkIcon: sd,
  ChartNoAxesColumn: Ha,
  ChartNoAxesColumnDecreasing: ud,
  ChartNoAxesColumnDecreasingIcon: ud,
  ChartNoAxesColumnIcon: Ha,
  ChartNoAxesColumnIncreasing: ja,
  ChartNoAxesColumnIncreasingIcon: ja,
  ChartNoAxesCombined: hd,
  ChartNoAxesCombinedIcon: hd,
  ChartNoAxesGantt: Va,
  ChartNoAxesGanttIcon: Va,
  ChartPie: Ba,
  ChartPieIcon: Ba,
  ChartScatter: Da,
  ChartScatterIcon: Da,
  ChartSpline: pd,
  ChartSplineIcon: pd,
  Check: kd,
  CheckCheck: yd,
  CheckCheckIcon: yd,
  CheckCircle: Ga,
  CheckCircle2: Za,
  CheckCircle2Icon: Za,
  CheckCircleIcon: Ga,
  CheckIcon: kd,
  CheckSquare: En,
  CheckSquare2: Un,
  CheckSquare2Icon: Un,
  CheckSquareIcon: En,
  ChefHat: md,
  ChefHatIcon: md,
  Cherry: fd,
  CherryIcon: fd,
  ChevronDown: vd,
  ChevronDownCircle: Ya,
  ChevronDownCircleIcon: Ya,
  ChevronDownIcon: vd,
  ChevronDownSquare: Nn,
  ChevronDownSquareIcon: Nn,
  ChevronFirst: gd,
  ChevronFirstIcon: gd,
  ChevronLast: Md,
  ChevronLastIcon: Md,
  ChevronLeft: bd,
  ChevronLeftCircle: Ka,
  ChevronLeftCircleIcon: Ka,
  ChevronLeftIcon: bd,
  ChevronLeftSquare: Wn,
  ChevronLeftSquareIcon: Wn,
  ChevronRight: xd,
  ChevronRightCircle: Xa,
  ChevronRightCircleIcon: Xa,
  ChevronRightIcon: xd,
  ChevronRightSquare: Gn,
  ChevronRightSquareIcon: Gn,
  ChevronUp: wd,
  ChevronUpCircle: Qa,
  ChevronUpCircleIcon: Qa,
  ChevronUpIcon: wd,
  ChevronUpSquare: Zn,
  ChevronUpSquareIcon: Zn,
  ChevronsDown: Sd,
  ChevronsDownIcon: Sd,
  ChevronsDownUp: Ld,
  ChevronsDownUpIcon: Ld,
  ChevronsLeft: Ad,
  ChevronsLeftIcon: Ad,
  ChevronsLeftRight: Cd,
  ChevronsLeftRightEllipsis: Id,
  ChevronsLeftRightEllipsisIcon: Id,
  ChevronsLeftRightIcon: Cd,
  ChevronsRight: zd,
  ChevronsRightIcon: zd,
  ChevronsRightLeft: qd,
  ChevronsRightLeftIcon: qd,
  ChevronsUp: _d,
  ChevronsUpDown: Pd,
  ChevronsUpDownIcon: Pd,
  ChevronsUpIcon: _d,
  Chrome: jd,
  ChromeIcon: jd,
  Church: Hd,
  ChurchIcon: Hd,
  Cigarette: Bd,
  CigaretteIcon: Bd,
  CigaretteOff: Vd,
  CigaretteOffIcon: Vd,
  Circle: Zd,
  CircleAlert: Ta,
  CircleAlertIcon: Ta,
  CircleArrowDown: $a,
  CircleArrowDownIcon: $a,
  CircleArrowLeft: Oa,
  CircleArrowLeftIcon: Oa,
  CircleArrowOutDownLeft: Ra,
  CircleArrowOutDownLeftIcon: Ra,
  CircleArrowOutDownRight: Fa,
  CircleArrowOutDownRightIcon: Fa,
  CircleArrowOutUpLeft: Ea,
  CircleArrowOutUpLeftIcon: Ea,
  CircleArrowOutUpRight: Ua,
  CircleArrowOutUpRightIcon: Ua,
  CircleArrowRight: Na,
  CircleArrowRightIcon: Na,
  CircleArrowUp: Wa,
  CircleArrowUpIcon: Wa,
  CircleCheck: Za,
  CircleCheckBig: Ga,
  CircleCheckBigIcon: Ga,
  CircleCheckIcon: Za,
  CircleChevronDown: Ya,
  CircleChevronDownIcon: Ya,
  CircleChevronLeft: Ka,
  CircleChevronLeftIcon: Ka,
  CircleChevronRight: Xa,
  CircleChevronRightIcon: Xa,
  CircleChevronUp: Qa,
  CircleChevronUpIcon: Qa,
  CircleDashed: Dd,
  CircleDashedIcon: Dd,
  CircleDivide: Ja,
  CircleDivideIcon: Ja,
  CircleDollarSign: Td,
  CircleDollarSignIcon: Td,
  CircleDot: Od,
  CircleDotDashed: $d,
  CircleDotDashedIcon: $d,
  CircleDotIcon: Od,
  CircleEllipsis: Rd,
  CircleEllipsisIcon: Rd,
  CircleEqual: Fd,
  CircleEqualIcon: Fd,
  CircleFadingArrowUp: Ed,
  CircleFadingArrowUpIcon: Ed,
  CircleFadingPlus: Ud,
  CircleFadingPlusIcon: Ud,
  CircleGauge: e1,
  CircleGaugeIcon: e1,
  CircleHelp: t1,
  CircleHelpIcon: t1,
  CircleIcon: Zd,
  CircleMinus: a1,
  CircleMinusIcon: a1,
  CircleOff: Nd,
  CircleOffIcon: Nd,
  CircleParking: o1,
  CircleParkingIcon: o1,
  CircleParkingOff: n1,
  CircleParkingOffIcon: n1,
  CirclePause: r1,
  CirclePauseIcon: r1,
  CirclePercent: l1,
  CirclePercentIcon: l1,
  CirclePlay: i1,
  CirclePlayIcon: i1,
  CirclePlus: c1,
  CirclePlusIcon: c1,
  CirclePower: d1,
  CirclePowerIcon: d1,
  CircleSlash: Wd,
  CircleSlash2: s1,
  CircleSlash2Icon: s1,
  CircleSlashIcon: Wd,
  CircleSlashed: s1,
  CircleSlashedIcon: s1,
  CircleSmall: Gd,
  CircleSmallIcon: Gd,
  CircleStop: u1,
  CircleStopIcon: u1,
  CircleUser: p1,
  CircleUserIcon: p1,
  CircleUserRound: h1,
  CircleUserRoundIcon: h1,
  CircleX: y1,
  CircleXIcon: y1,
  CircuitBoard: Yd,
  CircuitBoardIcon: Yd,
  Citrus: Kd,
  CitrusIcon: Kd,
  Clapperboard: Xd,
  ClapperboardIcon: Xd,
  Clipboard: ls,
  ClipboardCheck: Qd,
  ClipboardCheckIcon: Qd,
  ClipboardCopy: Jd,
  ClipboardCopyIcon: Jd,
  ClipboardEdit: m1,
  ClipboardEditIcon: m1,
  ClipboardIcon: ls,
  ClipboardList: es,
  ClipboardListIcon: es,
  ClipboardMinus: ts,
  ClipboardMinusIcon: ts,
  ClipboardPaste: as,
  ClipboardPasteIcon: as,
  ClipboardPen: m1,
  ClipboardPenIcon: m1,
  ClipboardPenLine: k1,
  ClipboardPenLineIcon: k1,
  ClipboardPlus: ns,
  ClipboardPlusIcon: ns,
  ClipboardSignature: k1,
  ClipboardSignatureIcon: k1,
  ClipboardType: os,
  ClipboardTypeIcon: os,
  ClipboardX: rs,
  ClipboardXIcon: rs,
  Clock: ws,
  Clock1: is,
  Clock10: cs,
  Clock10Icon: cs,
  Clock11: ds,
  Clock11Icon: ds,
  Clock12: ss,
  Clock12Icon: ss,
  Clock1Icon: is,
  Clock2: us,
  Clock2Icon: us,
  Clock3: hs,
  Clock3Icon: hs,
  Clock4: ps,
  Clock4Icon: ps,
  Clock5: ys,
  Clock5Icon: ys,
  Clock6: ks,
  Clock6Icon: ks,
  Clock7: ms,
  Clock7Icon: ms,
  Clock8: fs,
  Clock8Icon: fs,
  Clock9: vs,
  Clock9Icon: vs,
  ClockAlert: gs,
  ClockAlertIcon: gs,
  ClockArrowDown: Ms,
  ClockArrowDownIcon: Ms,
  ClockArrowUp: bs,
  ClockArrowUpIcon: bs,
  ClockFading: xs,
  ClockFadingIcon: xs,
  ClockIcon: ws,
  Cloud: Ts,
  CloudAlert: Ls,
  CloudAlertIcon: Ls,
  CloudCog: Ss,
  CloudCogIcon: Ss,
  CloudDownload: f1,
  CloudDownloadIcon: f1,
  CloudDrizzle: Is,
  CloudDrizzleIcon: Is,
  CloudFog: As,
  CloudFogIcon: As,
  CloudHail: Cs,
  CloudHailIcon: Cs,
  CloudIcon: Ts,
  CloudLightning: qs,
  CloudLightningIcon: qs,
  CloudMoon: _s,
  CloudMoonIcon: _s,
  CloudMoonRain: zs,
  CloudMoonRainIcon: zs,
  CloudOff: Ps,
  CloudOffIcon: Ps,
  CloudRain: Hs,
  CloudRainIcon: Hs,
  CloudRainWind: js,
  CloudRainWindIcon: js,
  CloudSnow: Vs,
  CloudSnowIcon: Vs,
  CloudSun: Ds,
  CloudSunIcon: Ds,
  CloudSunRain: Bs,
  CloudSunRainIcon: Bs,
  CloudUpload: v1,
  CloudUploadIcon: v1,
  Cloudy: $s,
  CloudyIcon: $s,
  Clover: Os,
  CloverIcon: Os,
  Club: Rs,
  ClubIcon: Rs,
  Code: Fs,
  Code2: g1,
  Code2Icon: g1,
  CodeIcon: Fs,
  CodeSquare: Yn,
  CodeSquareIcon: Yn,
  CodeXml: g1,
  CodeXmlIcon: g1,
  Codepen: Es,
  CodepenIcon: Es,
  Codesandbox: Us,
  CodesandboxIcon: Us,
  Coffee: Ws,
  CoffeeIcon: Ws,
  Cog: Ns,
  CogIcon: Ns,
  Coins: Gs,
  CoinsIcon: Gs,
  Columns: M1,
  Columns2: M1,
  Columns2Icon: M1,
  Columns3: b1,
  Columns3Icon: b1,
  Columns4: Zs,
  Columns4Icon: Zs,
  ColumnsIcon: M1,
  Combine: Ys,
  CombineIcon: Ys,
  Command: Ks,
  CommandIcon: Ks,
  Compass: Xs,
  CompassIcon: Xs,
  Component: Qs,
  ComponentIcon: Qs,
  Computer: Js,
  ComputerIcon: Js,
  ConciergeBell: eu,
  ConciergeBellIcon: eu,
  Cone: tu,
  ConeIcon: tu,
  Construction: au,
  ConstructionIcon: au,
  Contact: nu,
  Contact2: x1,
  Contact2Icon: x1,
  ContactIcon: nu,
  ContactRound: x1,
  ContactRoundIcon: x1,
  Container: ou,
  ContainerIcon: ou,
  Contrast: ru,
  ContrastIcon: ru,
  Cookie: lu,
  CookieIcon: lu,
  CookingPot: iu,
  CookingPotIcon: iu,
  Copy: pu,
  CopyCheck: cu,
  CopyCheckIcon: cu,
  CopyIcon: pu,
  CopyMinus: hu,
  CopyMinusIcon: hu,
  CopyPlus: du,
  CopyPlusIcon: du,
  CopySlash: su,
  CopySlashIcon: su,
  CopyX: uu,
  CopyXIcon: uu,
  Copyleft: yu,
  CopyleftIcon: yu,
  Copyright: ku,
  CopyrightIcon: ku,
  CornerDownLeft: mu,
  CornerDownLeftIcon: mu,
  CornerDownRight: fu,
  CornerDownRightIcon: fu,
  CornerLeftDown: vu,
  CornerLeftDownIcon: vu,
  CornerLeftUp: gu,
  CornerLeftUpIcon: gu,
  CornerRightDown: Mu,
  CornerRightDownIcon: Mu,
  CornerRightUp: bu,
  CornerRightUpIcon: bu,
  CornerUpLeft: xu,
  CornerUpLeftIcon: xu,
  CornerUpRight: wu,
  CornerUpRightIcon: wu,
  Cpu: Lu,
  CpuIcon: Lu,
  CreativeCommons: Iu,
  CreativeCommonsIcon: Iu,
  CreditCard: Su,
  CreditCardIcon: Su,
  Croissant: Cu,
  CroissantIcon: Cu,
  Crop: Au,
  CropIcon: Au,
  Cross: qu,
  CrossIcon: qu,
  Crosshair: zu,
  CrosshairIcon: zu,
  Crown: Pu,
  CrownIcon: Pu,
  Cuboid: _u,
  CuboidIcon: _u,
  CupSoda: ju,
  CupSodaIcon: ju,
  CurlyBraces: wa,
  CurlyBracesIcon: wa,
  Currency: Hu,
  CurrencyIcon: Hu,
  Cylinder: Vu,
  CylinderIcon: Vu,
  Dam: Bu,
  DamIcon: Bu,
  Database: Tu,
  DatabaseBackup: Du,
  DatabaseBackupIcon: Du,
  DatabaseIcon: Tu,
  DatabaseZap: $u,
  DatabaseZapIcon: $u,
  Delete: Ou,
  DeleteIcon: Ou,
  Dessert: Ru,
  DessertIcon: Ru,
  Diameter: Fu,
  DiameterIcon: Fu,
  Diamond: Nu,
  DiamondIcon: Nu,
  DiamondMinus: Eu,
  DiamondMinusIcon: Eu,
  DiamondPercent: w1,
  DiamondPercentIcon: w1,
  DiamondPlus: Uu,
  DiamondPlusIcon: Uu,
  Dice1: Wu,
  Dice1Icon: Wu,
  Dice2: Gu,
  Dice2Icon: Gu,
  Dice3: Zu,
  Dice3Icon: Zu,
  Dice4: Yu,
  Dice4Icon: Yu,
  Dice5: Ku,
  Dice5Icon: Ku,
  Dice6: Xu,
  Dice6Icon: Xu,
  Dices: Qu,
  DicesIcon: Qu,
  Diff: Ju,
  DiffIcon: Ju,
  Disc: nh,
  Disc2: eh,
  Disc2Icon: eh,
  Disc3: th,
  Disc3Icon: th,
  DiscAlbum: ah,
  DiscAlbumIcon: ah,
  DiscIcon: nh,
  Divide: oh,
  DivideCircle: Ja,
  DivideCircleIcon: Ja,
  DivideIcon: oh,
  DivideSquare: eo,
  DivideSquareIcon: eo,
  Dna: lh,
  DnaIcon: lh,
  DnaOff: rh,
  DnaOffIcon: rh,
  Dock: ih,
  DockIcon: ih,
  Dog: ch,
  DogIcon: ch,
  DollarSign: dh,
  DollarSignIcon: dh,
  Donut: sh,
  DonutIcon: sh,
  DoorClosed: uh,
  DoorClosedIcon: uh,
  DoorOpen: hh,
  DoorOpenIcon: hh,
  Dot: ph,
  DotIcon: ph,
  DotSquare: Jn,
  DotSquareIcon: Jn,
  Download: yh,
  DownloadCloud: f1,
  DownloadCloudIcon: f1,
  DownloadIcon: yh,
  DraftingCompass: kh,
  DraftingCompassIcon: kh,
  Drama: mh,
  DramaIcon: mh,
  Dribbble: fh,
  DribbbleIcon: fh,
  Drill: vh,
  DrillIcon: vh,
  Droplet: Mh,
  DropletIcon: Mh,
  DropletOff: gh,
  DropletOffIcon: gh,
  Droplets: bh,
  DropletsIcon: bh,
  Drum: xh,
  DrumIcon: xh,
  Drumstick: wh,
  DrumstickIcon: wh,
  Dumbbell: Lh,
  DumbbellIcon: Lh,
  Ear: Ih,
  EarIcon: Ih,
  EarOff: Sh,
  EarOffIcon: Sh,
  Earth: L1,
  EarthIcon: L1,
  EarthLock: Ch,
  EarthLockIcon: Ch,
  Eclipse: Ah,
  EclipseIcon: Ah,
  Edit: xt,
  Edit2: fn,
  Edit2Icon: fn,
  Edit3: mn,
  Edit3Icon: mn,
  EditIcon: xt,
  Egg: Ph,
  EggFried: qh,
  EggFriedIcon: qh,
  EggIcon: Ph,
  EggOff: zh,
  EggOffIcon: zh,
  Ellipsis: I1,
  EllipsisIcon: I1,
  EllipsisVertical: S1,
  EllipsisVerticalIcon: S1,
  Equal: Hh,
  EqualApproximately: _h,
  EqualApproximatelyIcon: _h,
  EqualIcon: Hh,
  EqualNot: jh,
  EqualNotIcon: jh,
  EqualSquare: to,
  EqualSquareIcon: to,
  Eraser: Vh,
  EraserIcon: Vh,
  EthernetPort: Bh,
  EthernetPortIcon: Bh,
  Euro: Dh,
  EuroIcon: Dh,
  Expand: Th,
  ExpandIcon: Th,
  ExternalLink: $h,
  ExternalLinkIcon: $h,
  Eye: Fh,
  EyeClosed: Oh,
  EyeClosedIcon: Oh,
  EyeIcon: Fh,
  EyeOff: Rh,
  EyeOffIcon: Rh,
  Facebook: Eh,
  FacebookIcon: Eh,
  Factory: Uh,
  FactoryIcon: Uh,
  Fan: Nh,
  FanIcon: Nh,
  FastForward: Wh,
  FastForwardIcon: Wh,
  Feather: Gh,
  FeatherIcon: Gh,
  Fence: Zh,
  FenceIcon: Zh,
  FerrisWheel: Yh,
  FerrisWheelIcon: Yh,
  Figma: Kh,
  FigmaIcon: Kh,
  File: Gp,
  FileArchive: Xh,
  FileArchiveIcon: Xh,
  FileAudio: Jh,
  FileAudio2: Qh,
  FileAudio2Icon: Qh,
  FileAudioIcon: Jh,
  FileAxis3D: C1,
  FileAxis3DIcon: C1,
  FileAxis3d: C1,
  FileAxis3dIcon: C1,
  FileBadge: tp,
  FileBadge2: ep,
  FileBadge2Icon: ep,
  FileBadgeIcon: tp,
  FileBarChart: A1,
  FileBarChart2: q1,
  FileBarChart2Icon: q1,
  FileBarChartIcon: A1,
  FileBox: ap,
  FileBoxIcon: ap,
  FileChartColumn: q1,
  FileChartColumnIcon: q1,
  FileChartColumnIncreasing: A1,
  FileChartColumnIncreasingIcon: A1,
  FileChartLine: z1,
  FileChartLineIcon: z1,
  FileChartPie: P1,
  FileChartPieIcon: P1,
  FileCheck: op,
  FileCheck2: np,
  FileCheck2Icon: np,
  FileCheckIcon: op,
  FileClock: rp,
  FileClockIcon: rp,
  FileCode: ip,
  FileCode2: lp,
  FileCode2Icon: lp,
  FileCodeIcon: ip,
  FileCog: _1,
  FileCog2: _1,
  FileCog2Icon: _1,
  FileCogIcon: _1,
  FileDiff: cp,
  FileDiffIcon: cp,
  FileDigit: dp,
  FileDigitIcon: dp,
  FileDown: sp,
  FileDownIcon: sp,
  FileEdit: H1,
  FileEditIcon: H1,
  FileHeart: up,
  FileHeartIcon: up,
  FileIcon: Gp,
  FileImage: hp,
  FileImageIcon: hp,
  FileInput: pp,
  FileInputIcon: pp,
  FileJson: kp,
  FileJson2: yp,
  FileJson2Icon: yp,
  FileJsonIcon: kp,
  FileKey: fp,
  FileKey2: mp,
  FileKey2Icon: mp,
  FileKeyIcon: fp,
  FileLineChart: z1,
  FileLineChartIcon: z1,
  FileLock: gp,
  FileLock2: vp,
  FileLock2Icon: vp,
  FileLockIcon: gp,
  FileMinus: bp,
  FileMinus2: Mp,
  FileMinus2Icon: Mp,
  FileMinusIcon: bp,
  FileMusic: xp,
  FileMusicIcon: xp,
  FileOutput: wp,
  FileOutputIcon: wp,
  FilePen: H1,
  FilePenIcon: H1,
  FilePenLine: j1,
  FilePenLineIcon: j1,
  FilePieChart: P1,
  FilePieChartIcon: P1,
  FilePlus: Sp,
  FilePlus2: Lp,
  FilePlus2Icon: Lp,
  FilePlusIcon: Sp,
  FileQuestion: Ip,
  FileQuestionIcon: Ip,
  FileScan: Cp,
  FileScanIcon: Cp,
  FileSearch: qp,
  FileSearch2: Ap,
  FileSearch2Icon: Ap,
  FileSearchIcon: qp,
  FileSignature: j1,
  FileSignatureIcon: j1,
  FileSliders: zp,
  FileSlidersIcon: zp,
  FileSpreadsheet: Pp,
  FileSpreadsheetIcon: Pp,
  FileStack: _p,
  FileStackIcon: _p,
  FileSymlink: jp,
  FileSymlinkIcon: jp,
  FileTerminal: Hp,
  FileTerminalIcon: Hp,
  FileText: Vp,
  FileTextIcon: Vp,
  FileType: Dp,
  FileType2: Bp,
  FileType2Icon: Bp,
  FileTypeIcon: Dp,
  FileUp: Tp,
  FileUpIcon: Tp,
  FileUser: $p,
  FileUserIcon: $p,
  FileVideo: Rp,
  FileVideo2: Op,
  FileVideo2Icon: Op,
  FileVideoIcon: Rp,
  FileVolume: Ep,
  FileVolume2: Fp,
  FileVolume2Icon: Fp,
  FileVolumeIcon: Ep,
  FileWarning: Up,
  FileWarningIcon: Up,
  FileX: Wp,
  FileX2: Np,
  FileX2Icon: Np,
  FileXIcon: Wp,
  Files: Zp,
  FilesIcon: Zp,
  Film: Yp,
  FilmIcon: Yp,
  Filter: T1,
  FilterIcon: T1,
  FilterX: D1,
  FilterXIcon: D1,
  Fingerprint: Kp,
  FingerprintIcon: Kp,
  FireExtinguisher: Xp,
  FireExtinguisherIcon: Xp,
  Fish: ey,
  FishIcon: ey,
  FishOff: Qp,
  FishOffIcon: Qp,
  FishSymbol: Jp,
  FishSymbolIcon: Jp,
  Flag: oy,
  FlagIcon: oy,
  FlagOff: ay,
  FlagOffIcon: ay,
  FlagTriangleLeft: ty,
  FlagTriangleLeftIcon: ty,
  FlagTriangleRight: ny,
  FlagTriangleRightIcon: ny,
  Flame: ly,
  FlameIcon: ly,
  FlameKindling: ry,
  FlameKindlingIcon: ry,
  Flashlight: cy,
  FlashlightIcon: cy,
  FlashlightOff: iy,
  FlashlightOffIcon: iy,
  FlaskConical: sy,
  FlaskConicalIcon: sy,
  FlaskConicalOff: dy,
  FlaskConicalOffIcon: dy,
  FlaskRound: uy,
  FlaskRoundIcon: uy,
  FlipHorizontal: py,
  FlipHorizontal2: hy,
  FlipHorizontal2Icon: hy,
  FlipHorizontalIcon: py,
  FlipVertical: ky,
  FlipVertical2: yy,
  FlipVertical2Icon: yy,
  FlipVerticalIcon: ky,
  Flower: fy,
  Flower2: my,
  Flower2Icon: my,
  FlowerIcon: fy,
  Focus: vy,
  FocusIcon: vy,
  FoldHorizontal: gy,
  FoldHorizontalIcon: gy,
  FoldVertical: My,
  FoldVerticalIcon: My,
  Folder: Zy,
  FolderArchive: by,
  FolderArchiveIcon: by,
  FolderCheck: xy,
  FolderCheckIcon: xy,
  FolderClock: wy,
  FolderClockIcon: wy,
  FolderClosed: Ly,
  FolderClosedIcon: Ly,
  FolderCode: Sy,
  FolderCodeIcon: Sy,
  FolderCog: V1,
  FolderCog2: V1,
  FolderCog2Icon: V1,
  FolderCogIcon: V1,
  FolderDot: Iy,
  FolderDotIcon: Iy,
  FolderDown: Cy,
  FolderDownIcon: Cy,
  FolderEdit: B1,
  FolderEditIcon: B1,
  FolderGit: qy,
  FolderGit2: Ay,
  FolderGit2Icon: Ay,
  FolderGitIcon: qy,
  FolderHeart: zy,
  FolderHeartIcon: zy,
  FolderIcon: Zy,
  FolderInput: Py,
  FolderInputIcon: Py,
  FolderKanban: _y,
  FolderKanbanIcon: _y,
  FolderKey: jy,
  FolderKeyIcon: jy,
  FolderLock: Vy,
  FolderLockIcon: Vy,
  FolderMinus: Hy,
  FolderMinusIcon: Hy,
  FolderOpen: Dy,
  FolderOpenDot: By,
  FolderOpenDotIcon: By,
  FolderOpenIcon: Dy,
  FolderOutput: Ty,
  FolderOutputIcon: Ty,
  FolderPen: B1,
  FolderPenIcon: B1,
  FolderPlus: $y,
  FolderPlusIcon: $y,
  FolderRoot: Oy,
  FolderRootIcon: Oy,
  FolderSearch: Fy,
  FolderSearch2: Ry,
  FolderSearch2Icon: Ry,
  FolderSearchIcon: Fy,
  FolderSymlink: Ey,
  FolderSymlinkIcon: Ey,
  FolderSync: Uy,
  FolderSyncIcon: Uy,
  FolderTree: Ny,
  FolderTreeIcon: Ny,
  FolderUp: Wy,
  FolderUpIcon: Wy,
  FolderX: Gy,
  FolderXIcon: Gy,
  Folders: Yy,
  FoldersIcon: Yy,
  Footprints: Ky,
  FootprintsIcon: Ky,
  ForkKnife: Fo,
  ForkKnifeCrossed: Ro,
  ForkKnifeCrossedIcon: Ro,
  ForkKnifeIcon: Fo,
  Forklift: Xy,
  ForkliftIcon: Xy,
  FormInput: gn,
  FormInputIcon: gn,
  Forward: Qy,
  ForwardIcon: Qy,
  Frame: Jy,
  FrameIcon: Jy,
  Framer: ek,
  FramerIcon: ek,
  Frown: tk,
  FrownIcon: tk,
  Fuel: ak,
  FuelIcon: ak,
  Fullscreen: nk,
  FullscreenIcon: nk,
  FunctionSquare: ao,
  FunctionSquareIcon: ao,
  Funnel: T1,
  FunnelIcon: T1,
  FunnelPlus: ok,
  FunnelPlusIcon: ok,
  FunnelX: D1,
  FunnelXIcon: D1,
  GalleryHorizontal: lk,
  GalleryHorizontalEnd: rk,
  GalleryHorizontalEndIcon: rk,
  GalleryHorizontalIcon: lk,
  GalleryThumbnails: ik,
  GalleryThumbnailsIcon: ik,
  GalleryVertical: dk,
  GalleryVerticalEnd: ck,
  GalleryVerticalEndIcon: ck,
  GalleryVerticalIcon: dk,
  Gamepad: uk,
  Gamepad2: sk,
  Gamepad2Icon: sk,
  GamepadIcon: uk,
  GanttChart: Va,
  GanttChartIcon: Va,
  GanttChartSquare: Bt,
  GanttChartSquareIcon: Bt,
  Gauge: hk,
  GaugeCircle: e1,
  GaugeCircleIcon: e1,
  GaugeIcon: hk,
  Gavel: pk,
  GavelIcon: pk,
  Gem: yk,
  GemIcon: yk,
  Ghost: kk,
  GhostIcon: kk,
  Gift: mk,
  GiftIcon: mk,
  GitBranch: vk,
  GitBranchIcon: vk,
  GitBranchPlus: fk,
  GitBranchPlusIcon: fk,
  GitCommit: $1,
  GitCommitHorizontal: $1,
  GitCommitHorizontalIcon: $1,
  GitCommitIcon: $1,
  GitCommitVertical: gk,
  GitCommitVerticalIcon: gk,
  GitCompare: bk,
  GitCompareArrows: Mk,
  GitCompareArrowsIcon: Mk,
  GitCompareIcon: bk,
  GitFork: xk,
  GitForkIcon: xk,
  GitGraph: wk,
  GitGraphIcon: wk,
  GitMerge: Lk,
  GitMergeIcon: Lk,
  GitPullRequest: zk,
  GitPullRequestArrow: Sk,
  GitPullRequestArrowIcon: Sk,
  GitPullRequestClosed: Ik,
  GitPullRequestClosedIcon: Ik,
  GitPullRequestCreate: Ak,
  GitPullRequestCreateArrow: Ck,
  GitPullRequestCreateArrowIcon: Ck,
  GitPullRequestCreateIcon: Ak,
  GitPullRequestDraft: qk,
  GitPullRequestDraftIcon: qk,
  GitPullRequestIcon: zk,
  Github: Pk,
  GithubIcon: Pk,
  Gitlab: _k,
  GitlabIcon: _k,
  GlassWater: jk,
  GlassWaterIcon: jk,
  Glasses: Hk,
  GlassesIcon: Hk,
  Globe: Bk,
  Globe2: L1,
  Globe2Icon: L1,
  GlobeIcon: Bk,
  GlobeLock: Vk,
  GlobeLockIcon: Vk,
  Goal: Dk,
  GoalIcon: Dk,
  Grab: Tk,
  GrabIcon: Tk,
  GraduationCap: $k,
  GraduationCapIcon: $k,
  Grape: Ok,
  GrapeIcon: Ok,
  Grid: Vt,
  Grid2X2: E1,
  Grid2X2Check: O1,
  Grid2X2CheckIcon: O1,
  Grid2X2Icon: E1,
  Grid2X2Plus: R1,
  Grid2X2PlusIcon: R1,
  Grid2X2X: F1,
  Grid2X2XIcon: F1,
  Grid2x2: E1,
  Grid2x2Check: O1,
  Grid2x2CheckIcon: O1,
  Grid2x2Icon: E1,
  Grid2x2Plus: R1,
  Grid2x2PlusIcon: R1,
  Grid2x2X: F1,
  Grid2x2XIcon: F1,
  Grid3X3: Vt,
  Grid3X3Icon: Vt,
  Grid3x3: Vt,
  Grid3x3Icon: Vt,
  GridIcon: Vt,
  Grip: Ek,
  GripHorizontal: Rk,
  GripHorizontalIcon: Rk,
  GripIcon: Ek,
  GripVertical: Fk,
  GripVerticalIcon: Fk,
  Group: Uk,
  GroupIcon: Uk,
  Guitar: Nk,
  GuitarIcon: Nk,
  Ham: Wk,
  HamIcon: Wk,
  Hammer: Gk,
  HammerIcon: Gk,
  Hand: Qk,
  HandCoins: Zk,
  HandCoinsIcon: Zk,
  HandHeart: Yk,
  HandHeartIcon: Yk,
  HandHelping: U1,
  HandHelpingIcon: U1,
  HandIcon: Qk,
  HandMetal: Kk,
  HandMetalIcon: Kk,
  HandPlatter: Xk,
  HandPlatterIcon: Xk,
  Handshake: Jk,
  HandshakeIcon: Jk,
  HardDrive: a4,
  HardDriveDownload: e4,
  HardDriveDownloadIcon: e4,
  HardDriveIcon: a4,
  HardDriveUpload: t4,
  HardDriveUploadIcon: t4,
  HardHat: n4,
  HardHatIcon: n4,
  Hash: o4,
  HashIcon: o4,
  Haze: r4,
  HazeIcon: r4,
  HdmiPort: l4,
  HdmiPortIcon: l4,
  Heading: p4,
  Heading1: i4,
  Heading1Icon: i4,
  Heading2: c4,
  Heading2Icon: c4,
  Heading3: d4,
  Heading3Icon: d4,
  Heading4: s4,
  Heading4Icon: s4,
  Heading5: u4,
  Heading5Icon: u4,
  Heading6: h4,
  Heading6Icon: h4,
  HeadingIcon: p4,
  HeadphoneOff: y4,
  HeadphoneOffIcon: y4,
  Headphones: k4,
  HeadphonesIcon: k4,
  Headset: m4,
  HeadsetIcon: m4,
  Heart: b4,
  HeartCrack: f4,
  HeartCrackIcon: f4,
  HeartHandshake: v4,
  HeartHandshakeIcon: v4,
  HeartIcon: b4,
  HeartOff: g4,
  HeartOffIcon: g4,
  HeartPulse: M4,
  HeartPulseIcon: M4,
  Heater: x4,
  HeaterIcon: x4,
  HelpCircle: t1,
  HelpCircleIcon: t1,
  HelpingHand: U1,
  HelpingHandIcon: U1,
  Hexagon: w4,
  HexagonIcon: w4,
  Highlighter: L4,
  HighlighterIcon: L4,
  History: S4,
  HistoryIcon: S4,
  Home: N1,
  HomeIcon: N1,
  Hop: C4,
  HopIcon: C4,
  HopOff: I4,
  HopOffIcon: I4,
  Hospital: A4,
  HospitalIcon: A4,
  Hotel: q4,
  HotelIcon: q4,
  Hourglass: z4,
  HourglassIcon: z4,
  House: N1,
  HouseIcon: N1,
  HousePlug: P4,
  HousePlugIcon: P4,
  HousePlus: _4,
  HousePlusIcon: _4,
  HouseWifi: j4,
  HouseWifiIcon: j4,
  IceCream: G1,
  IceCream2: W1,
  IceCream2Icon: W1,
  IceCreamBowl: W1,
  IceCreamBowlIcon: W1,
  IceCreamCone: G1,
  IceCreamConeIcon: G1,
  IceCreamIcon: G1,
  Icon: oI,
  IdCard: H4,
  IdCardIcon: H4,
  Image: F4,
  ImageDown: V4,
  ImageDownIcon: V4,
  ImageIcon: F4,
  ImageMinus: B4,
  ImageMinusIcon: B4,
  ImageOff: T4,
  ImageOffIcon: T4,
  ImagePlay: D4,
  ImagePlayIcon: D4,
  ImagePlus: $4,
  ImagePlusIcon: $4,
  ImageUp: O4,
  ImageUpIcon: O4,
  ImageUpscale: R4,
  ImageUpscaleIcon: R4,
  Images: E4,
  ImagesIcon: E4,
  Import: U4,
  ImportIcon: U4,
  Inbox: N4,
  InboxIcon: N4,
  Indent: Z1,
  IndentDecrease: Y1,
  IndentDecreaseIcon: Y1,
  IndentIcon: Z1,
  IndentIncrease: Z1,
  IndentIncreaseIcon: Z1,
  IndianRupee: W4,
  IndianRupeeIcon: W4,
  Infinity: G4,
  InfinityIcon: G4,
  Info: Z4,
  InfoIcon: Z4,
  Inspect: co,
  InspectIcon: co,
  InspectionPanel: Y4,
  InspectionPanelIcon: Y4,
  Instagram: K4,
  InstagramIcon: K4,
  Italic: X4,
  ItalicIcon: X4,
  IterationCcw: Q4,
  IterationCcwIcon: Q4,
  IterationCw: J4,
  IterationCwIcon: J4,
  JapaneseYen: e5,
  JapaneseYenIcon: e5,
  Joystick: t5,
  JoystickIcon: t5,
  Kanban: n5,
  KanbanIcon: n5,
  KanbanSquare: no,
  KanbanSquareDashed: Kn,
  KanbanSquareDashedIcon: Kn,
  KanbanSquareIcon: no,
  Key: r5,
  KeyIcon: r5,
  KeyRound: a5,
  KeyRoundIcon: a5,
  KeySquare: o5,
  KeySquareIcon: o5,
  Keyboard: i5,
  KeyboardIcon: i5,
  KeyboardMusic: c5,
  KeyboardMusicIcon: c5,
  KeyboardOff: l5,
  KeyboardOffIcon: l5,
  Lamp: y5,
  LampCeiling: d5,
  LampCeilingIcon: d5,
  LampDesk: s5,
  LampDeskIcon: s5,
  LampFloor: u5,
  LampFloorIcon: u5,
  LampIcon: y5,
  LampWallDown: h5,
  LampWallDownIcon: h5,
  LampWallUp: p5,
  LampWallUpIcon: p5,
  LandPlot: k5,
  LandPlotIcon: k5,
  Landmark: m5,
  LandmarkIcon: m5,
  Languages: f5,
  LanguagesIcon: f5,
  Laptop: g5,
  Laptop2: K1,
  Laptop2Icon: K1,
  LaptopIcon: g5,
  LaptopMinimal: K1,
  LaptopMinimalCheck: v5,
  LaptopMinimalCheckIcon: v5,
  LaptopMinimalIcon: K1,
  Lasso: b5,
  LassoIcon: b5,
  LassoSelect: M5,
  LassoSelectIcon: M5,
  Laugh: x5,
  LaughIcon: x5,
  Layers: X1,
  Layers2: w5,
  Layers2Icon: w5,
  Layers3: X1,
  Layers3Icon: X1,
  LayersIcon: X1,
  Layout: kn,
  LayoutDashboard: L5,
  LayoutDashboardIcon: L5,
  LayoutGrid: S5,
  LayoutGridIcon: S5,
  LayoutIcon: kn,
  LayoutList: I5,
  LayoutListIcon: I5,
  LayoutPanelLeft: C5,
  LayoutPanelLeftIcon: C5,
  LayoutPanelTop: A5,
  LayoutPanelTopIcon: A5,
  LayoutTemplate: q5,
  LayoutTemplateIcon: q5,
  Leaf: z5,
  LeafIcon: z5,
  LeafyGreen: P5,
  LeafyGreenIcon: P5,
  Lectern: _5,
  LecternIcon: _5,
  LetterText: j5,
  LetterTextIcon: j5,
  Library: V5,
  LibraryBig: H5,
  LibraryBigIcon: H5,
  LibraryIcon: V5,
  LibrarySquare: oo,
  LibrarySquareIcon: oo,
  LifeBuoy: B5,
  LifeBuoyIcon: B5,
  Ligature: D5,
  LigatureIcon: D5,
  Lightbulb: $5,
  LightbulbIcon: $5,
  LightbulbOff: T5,
  LightbulbOffIcon: T5,
  LineChart: _a,
  LineChartIcon: _a,
  Link: F5,
  Link2: R5,
  Link2Icon: R5,
  Link2Off: O5,
  Link2OffIcon: O5,
  LinkIcon: F5,
  Linkedin: E5,
  LinkedinIcon: E5,
  List: lm,
  ListCheck: U5,
  ListCheckIcon: U5,
  ListChecks: N5,
  ListChecksIcon: N5,
  ListCollapse: W5,
  ListCollapseIcon: W5,
  ListEnd: G5,
  ListEndIcon: G5,
  ListFilter: Z5,
  ListFilterIcon: Z5,
  ListFilterPlus: K5,
  ListFilterPlusIcon: K5,
  ListIcon: lm,
  ListMinus: Y5,
  ListMinusIcon: Y5,
  ListMusic: X5,
  ListMusicIcon: X5,
  ListOrdered: Q5,
  ListOrderedIcon: Q5,
  ListPlus: J5,
  ListPlusIcon: J5,
  ListRestart: em,
  ListRestartIcon: em,
  ListStart: tm,
  ListStartIcon: tm,
  ListTodo: am,
  ListTodoIcon: am,
  ListTree: nm,
  ListTreeIcon: nm,
  ListVideo: om,
  ListVideoIcon: om,
  ListX: rm,
  ListXIcon: rm,
  Loader: cm,
  Loader2: Q1,
  Loader2Icon: Q1,
  LoaderCircle: Q1,
  LoaderCircleIcon: Q1,
  LoaderIcon: cm,
  LoaderPinwheel: im,
  LoaderPinwheelIcon: im,
  Locate: um,
  LocateFixed: dm,
  LocateFixedIcon: dm,
  LocateIcon: um,
  LocateOff: sm,
  LocateOffIcon: sm,
  Lock: pm,
  LockIcon: pm,
  LockKeyhole: hm,
  LockKeyholeIcon: hm,
  LockKeyholeOpen: J1,
  LockKeyholeOpenIcon: J1,
  LockOpen: en,
  LockOpenIcon: en,
  LogIn: ym,
  LogInIcon: ym,
  LogOut: km,
  LogOutIcon: km,
  Logs: mm,
  LogsIcon: mm,
  Lollipop: fm,
  LollipopIcon: fm,
  LucideAArrowDown: ll,
  LucideAArrowUp: il,
  LucideALargeSmall: cl,
  LucideAccessibility: dl,
  LucideActivity: sl,
  LucideActivitySquare: An,
  LucideAirVent: ul,
  LucideAirplay: hl,
  LucideAlarmCheck: da,
  LucideAlarmClock: yl,
  LucideAlarmClockCheck: da,
  LucideAlarmClockMinus: sa,
  LucideAlarmClockOff: pl,
  LucideAlarmClockPlus: ua,
  LucideAlarmMinus: sa,
  LucideAlarmPlus: ua,
  LucideAlarmSmoke: kl,
  LucideAlbum: ml,
  LucideAlertCircle: Ta,
  LucideAlertOctagon: nn,
  LucideAlertTriangle: Po,
  LucideAlignCenter: gl,
  LucideAlignCenterHorizontal: fl,
  LucideAlignCenterVertical: vl,
  LucideAlignEndHorizontal: Ml,
  LucideAlignEndVertical: bl,
  LucideAlignHorizontalDistributeCenter: xl,
  LucideAlignHorizontalDistributeEnd: wl,
  LucideAlignHorizontalDistributeStart: Ll,
  LucideAlignHorizontalJustifyCenter: Sl,
  LucideAlignHorizontalJustifyEnd: Il,
  LucideAlignHorizontalJustifyStart: Cl,
  LucideAlignHorizontalSpaceAround: Al,
  LucideAlignHorizontalSpaceBetween: ql,
  LucideAlignJustify: zl,
  LucideAlignLeft: Pl,
  LucideAlignRight: _l,
  LucideAlignStartHorizontal: jl,
  LucideAlignStartVertical: Hl,
  LucideAlignVerticalDistributeCenter: Vl,
  LucideAlignVerticalDistributeEnd: Bl,
  LucideAlignVerticalDistributeStart: Dl,
  LucideAlignVerticalJustifyCenter: Tl,
  LucideAlignVerticalJustifyEnd: $l,
  LucideAlignVerticalJustifyStart: Ol,
  LucideAlignVerticalSpaceAround: Rl,
  LucideAlignVerticalSpaceBetween: Fl,
  LucideAmbulance: El,
  LucideAmpersand: Ul,
  LucideAmpersands: Nl,
  LucideAmphora: Wl,
  LucideAnchor: Gl,
  LucideAngry: Zl,
  LucideAnnoyed: Yl,
  LucideAntenna: Kl,
  LucideAnvil: Xl,
  LucideAperture: Ql,
  LucideAppWindow: ei,
  LucideAppWindowMac: Jl,
  LucideApple: ti,
  LucideArchive: oi,
  LucideArchiveRestore: ai,
  LucideArchiveX: ni,
  LucideAreaChart: Sa,
  LucideArmchair: ri,
  LucideArrowBigDown: ii,
  LucideArrowBigDownDash: li,
  LucideArrowBigLeft: di,
  LucideArrowBigLeftDash: ci,
  LucideArrowBigRight: ui,
  LucideArrowBigRightDash: si,
  LucideArrowBigUp: pi,
  LucideArrowBigUpDash: hi,
  LucideArrowDown: wi,
  LucideArrowDown01: yi,
  LucideArrowDown10: ki,
  LucideArrowDownAZ: ha,
  LucideArrowDownAz: ha,
  LucideArrowDownCircle: $a,
  LucideArrowDownFromLine: mi,
  LucideArrowDownLeft: fi,
  LucideArrowDownLeftFromCircle: Ra,
  LucideArrowDownLeftFromSquare: jn,
  LucideArrowDownLeftSquare: qn,
  LucideArrowDownNarrowWide: vi,
  LucideArrowDownRight: gi,
  LucideArrowDownRightFromCircle: Fa,
  LucideArrowDownRightFromSquare: Hn,
  LucideArrowDownRightSquare: zn,
  LucideArrowDownSquare: Pn,
  LucideArrowDownToDot: Mi,
  LucideArrowDownToLine: bi,
  LucideArrowDownUp: xi,
  LucideArrowDownWideNarrow: pa,
  LucideArrowDownZA: ya,
  LucideArrowDownZa: ya,
  LucideArrowLeft: Ci,
  LucideArrowLeftCircle: Oa,
  LucideArrowLeftFromLine: Li,
  LucideArrowLeftRight: Si,
  LucideArrowLeftSquare: _n,
  LucideArrowLeftToLine: Ii,
  LucideArrowRight: Pi,
  LucideArrowRightCircle: Na,
  LucideArrowRightFromLine: Ai,
  LucideArrowRightLeft: qi,
  LucideArrowRightSquare: Dn,
  LucideArrowRightToLine: zi,
  LucideArrowUp: Ri,
  LucideArrowUp01: _i,
  LucideArrowUp10: ji,
  LucideArrowUpAZ: ka,
  LucideArrowUpAz: ka,
  LucideArrowUpCircle: Wa,
  LucideArrowUpDown: Hi,
  LucideArrowUpFromDot: Vi,
  LucideArrowUpFromLine: Bi,
  LucideArrowUpLeft: Di,
  LucideArrowUpLeftFromCircle: Ea,
  LucideArrowUpLeftFromSquare: Vn,
  LucideArrowUpLeftSquare: Tn,
  LucideArrowUpNarrowWide: ma,
  LucideArrowUpRight: Ti,
  LucideArrowUpRightFromCircle: Ua,
  LucideArrowUpRightFromSquare: Bn,
  LucideArrowUpRightSquare: $n,
  LucideArrowUpSquare: On,
  LucideArrowUpToLine: $i,
  LucideArrowUpWideNarrow: Oi,
  LucideArrowUpZA: fa,
  LucideArrowUpZa: fa,
  LucideArrowsUpFromLine: Fi,
  LucideAsterisk: Ei,
  LucideAsteriskSquare: Rn,
  LucideAtSign: Ui,
  LucideAtom: Ni,
  LucideAudioLines: Wi,
  LucideAudioWaveform: Gi,
  LucideAward: Zi,
  LucideAxe: Yi,
  LucideAxis3D: va,
  LucideAxis3d: va,
  LucideBaby: Ki,
  LucideBackpack: Xi,
  LucideBadge: p2,
  LucideBadgeAlert: Qi,
  LucideBadgeCent: Ji,
  LucideBadgeCheck: ga,
  LucideBadgeDollarSign: e2,
  LucideBadgeEuro: t2,
  LucideBadgeHelp: a2,
  LucideBadgeIndianRupee: n2,
  LucideBadgeInfo: o2,
  LucideBadgeJapaneseYen: r2,
  LucideBadgeMinus: l2,
  LucideBadgePercent: i2,
  LucideBadgePlus: c2,
  LucideBadgePoundSterling: d2,
  LucideBadgeRussianRuble: s2,
  LucideBadgeSwissFranc: u2,
  LucideBadgeX: h2,
  LucideBaggageClaim: y2,
  LucideBan: k2,
  LucideBanana: m2,
  LucideBandage: f2,
  LucideBanknote: b2,
  LucideBanknoteArrowDown: v2,
  LucideBanknoteArrowUp: g2,
  LucideBanknoteX: M2,
  LucideBarChart: ja,
  LucideBarChart2: Ha,
  LucideBarChart3: Pa,
  LucideBarChart4: za,
  LucideBarChartBig: qa,
  LucideBarChartHorizontal: Ca,
  LucideBarChartHorizontalBig: Ia,
  LucideBarcode: x2,
  LucideBaseline: w2,
  LucideBath: L2,
  LucideBattery: P2,
  LucideBatteryCharging: S2,
  LucideBatteryFull: I2,
  LucideBatteryLow: C2,
  LucideBatteryMedium: A2,
  LucideBatteryPlus: q2,
  LucideBatteryWarning: z2,
  LucideBeaker: _2,
  LucideBean: H2,
  LucideBeanOff: j2,
  LucideBed: D2,
  LucideBedDouble: V2,
  LucideBedSingle: B2,
  LucideBeef: T2,
  LucideBeer: O2,
  LucideBeerOff: $2,
  LucideBell: G2,
  LucideBellDot: R2,
  LucideBellElectric: F2,
  LucideBellMinus: E2,
  LucideBellOff: U2,
  LucideBellPlus: N2,
  LucideBellRing: W2,
  LucideBetweenHorizonalEnd: Ma,
  LucideBetweenHorizonalStart: ba,
  LucideBetweenHorizontalEnd: Ma,
  LucideBetweenHorizontalStart: ba,
  LucideBetweenVerticalEnd: Z2,
  LucideBetweenVerticalStart: Y2,
  LucideBicepsFlexed: K2,
  LucideBike: X2,
  LucideBinary: Q2,
  LucideBinoculars: J2,
  LucideBiohazard: ec,
  LucideBird: tc,
  LucideBitcoin: ac,
  LucideBlend: nc,
  LucideBlinds: oc,
  LucideBlocks: rc,
  LucideBluetooth: cc,
  LucideBluetoothConnected: lc,
  LucideBluetoothOff: ic,
  LucideBluetoothSearching: dc,
  LucideBold: sc,
  LucideBolt: uc,
  LucideBomb: hc,
  LucideBone: pc,
  LucideBook: Bc,
  LucideBookA: yc,
  LucideBookAudio: kc,
  LucideBookCheck: mc,
  LucideBookCopy: fc,
  LucideBookDashed: xa,
  LucideBookDown: vc,
  LucideBookHeadphones: gc,
  LucideBookHeart: Mc,
  LucideBookImage: bc,
  LucideBookKey: xc,
  LucideBookLock: wc,
  LucideBookMarked: Lc,
  LucideBookMinus: Sc,
  LucideBookOpen: Ac,
  LucideBookOpenCheck: Ic,
  LucideBookOpenText: Cc,
  LucideBookPlus: qc,
  LucideBookTemplate: xa,
  LucideBookText: zc,
  LucideBookType: Pc,
  LucideBookUp: _c,
  LucideBookUp2: jc,
  LucideBookUser: Hc,
  LucideBookX: Vc,
  LucideBookmark: Rc,
  LucideBookmarkCheck: Dc,
  LucideBookmarkMinus: Tc,
  LucideBookmarkPlus: $c,
  LucideBookmarkX: Oc,
  LucideBoomBox: Fc,
  LucideBot: Nc,
  LucideBotMessageSquare: Ec,
  LucideBotOff: Uc,
  LucideBox: Wc,
  LucideBoxSelect: Qn,
  LucideBoxes: Gc,
  LucideBraces: wa,
  LucideBrackets: Zc,
  LucideBrain: Xc,
  LucideBrainCircuit: Yc,
  LucideBrainCog: Kc,
  LucideBrickWall: Qc,
  LucideBriefcase: t0,
  LucideBriefcaseBusiness: Jc,
  LucideBriefcaseConveyorBelt: e0,
  LucideBriefcaseMedical: a0,
  LucideBringToFront: n0,
  LucideBrush: o0,
  LucideBug: i0,
  LucideBugOff: r0,
  LucideBugPlay: l0,
  LucideBuilding: d0,
  LucideBuilding2: c0,
  LucideBus: u0,
  LucideBusFront: s0,
  LucideCable: p0,
  LucideCableCar: h0,
  LucideCake: k0,
  LucideCakeSlice: y0,
  LucideCalculator: m0,
  LucideCalendar: D0,
  LucideCalendar1: f0,
  LucideCalendarArrowDown: v0,
  LucideCalendarArrowUp: g0,
  LucideCalendarCheck: b0,
  LucideCalendarCheck2: M0,
  LucideCalendarClock: x0,
  LucideCalendarCog: w0,
  LucideCalendarDays: L0,
  LucideCalendarFold: S0,
  LucideCalendarHeart: I0,
  LucideCalendarMinus: A0,
  LucideCalendarMinus2: C0,
  LucideCalendarOff: q0,
  LucideCalendarPlus: P0,
  LucideCalendarPlus2: z0,
  LucideCalendarRange: j0,
  LucideCalendarSearch: _0,
  LucideCalendarSync: H0,
  LucideCalendarX: B0,
  LucideCalendarX2: V0,
  LucideCamera: $0,
  LucideCameraOff: T0,
  LucideCandlestickChart: Aa,
  LucideCandy: F0,
  LucideCandyCane: O0,
  LucideCandyOff: R0,
  LucideCannabis: E0,
  LucideCaptions: La,
  LucideCaptionsOff: U0,
  LucideCar: G0,
  LucideCarFront: N0,
  LucideCarTaxiFront: W0,
  LucideCaravan: Z0,
  LucideCarrot: Y0,
  LucideCaseLower: K0,
  LucideCaseSensitive: X0,
  LucideCaseUpper: Q0,
  LucideCassetteTape: J0,
  LucideCast: ed,
  LucideCastle: td,
  LucideCat: ad,
  LucideCctv: nd,
  LucideChartArea: Sa,
  LucideChartBar: Ca,
  LucideChartBarBig: Ia,
  LucideChartBarDecreasing: od,
  LucideChartBarIncreasing: rd,
  LucideChartBarStacked: ld,
  LucideChartCandlestick: Aa,
  LucideChartColumn: Pa,
  LucideChartColumnBig: qa,
  LucideChartColumnDecreasing: id,
  LucideChartColumnIncreasing: za,
  LucideChartColumnStacked: cd,
  LucideChartGantt: dd,
  LucideChartLine: _a,
  LucideChartNetwork: sd,
  LucideChartNoAxesColumn: Ha,
  LucideChartNoAxesColumnDecreasing: ud,
  LucideChartNoAxesColumnIncreasing: ja,
  LucideChartNoAxesCombined: hd,
  LucideChartNoAxesGantt: Va,
  LucideChartPie: Ba,
  LucideChartScatter: Da,
  LucideChartSpline: pd,
  LucideCheck: kd,
  LucideCheckCheck: yd,
  LucideCheckCircle: Ga,
  LucideCheckCircle2: Za,
  LucideCheckSquare: En,
  LucideCheckSquare2: Un,
  LucideChefHat: md,
  LucideCherry: fd,
  LucideChevronDown: vd,
  LucideChevronDownCircle: Ya,
  LucideChevronDownSquare: Nn,
  LucideChevronFirst: gd,
  LucideChevronLast: Md,
  LucideChevronLeft: bd,
  LucideChevronLeftCircle: Ka,
  LucideChevronLeftSquare: Wn,
  LucideChevronRight: xd,
  LucideChevronRightCircle: Xa,
  LucideChevronRightSquare: Gn,
  LucideChevronUp: wd,
  LucideChevronUpCircle: Qa,
  LucideChevronUpSquare: Zn,
  LucideChevronsDown: Sd,
  LucideChevronsDownUp: Ld,
  LucideChevronsLeft: Ad,
  LucideChevronsLeftRight: Cd,
  LucideChevronsLeftRightEllipsis: Id,
  LucideChevronsRight: zd,
  LucideChevronsRightLeft: qd,
  LucideChevronsUp: _d,
  LucideChevronsUpDown: Pd,
  LucideChrome: jd,
  LucideChurch: Hd,
  LucideCigarette: Bd,
  LucideCigaretteOff: Vd,
  LucideCircle: Zd,
  LucideCircleAlert: Ta,
  LucideCircleArrowDown: $a,
  LucideCircleArrowLeft: Oa,
  LucideCircleArrowOutDownLeft: Ra,
  LucideCircleArrowOutDownRight: Fa,
  LucideCircleArrowOutUpLeft: Ea,
  LucideCircleArrowOutUpRight: Ua,
  LucideCircleArrowRight: Na,
  LucideCircleArrowUp: Wa,
  LucideCircleCheck: Za,
  LucideCircleCheckBig: Ga,
  LucideCircleChevronDown: Ya,
  LucideCircleChevronLeft: Ka,
  LucideCircleChevronRight: Xa,
  LucideCircleChevronUp: Qa,
  LucideCircleDashed: Dd,
  LucideCircleDivide: Ja,
  LucideCircleDollarSign: Td,
  LucideCircleDot: Od,
  LucideCircleDotDashed: $d,
  LucideCircleEllipsis: Rd,
  LucideCircleEqual: Fd,
  LucideCircleFadingArrowUp: Ed,
  LucideCircleFadingPlus: Ud,
  LucideCircleGauge: e1,
  LucideCircleHelp: t1,
  LucideCircleMinus: a1,
  LucideCircleOff: Nd,
  LucideCircleParking: o1,
  LucideCircleParkingOff: n1,
  LucideCirclePause: r1,
  LucideCirclePercent: l1,
  LucideCirclePlay: i1,
  LucideCirclePlus: c1,
  LucideCirclePower: d1,
  LucideCircleSlash: Wd,
  LucideCircleSlash2: s1,
  LucideCircleSlashed: s1,
  LucideCircleSmall: Gd,
  LucideCircleStop: u1,
  LucideCircleUser: p1,
  LucideCircleUserRound: h1,
  LucideCircleX: y1,
  LucideCircuitBoard: Yd,
  LucideCitrus: Kd,
  LucideClapperboard: Xd,
  LucideClipboard: ls,
  LucideClipboardCheck: Qd,
  LucideClipboardCopy: Jd,
  LucideClipboardEdit: m1,
  LucideClipboardList: es,
  LucideClipboardMinus: ts,
  LucideClipboardPaste: as,
  LucideClipboardPen: m1,
  LucideClipboardPenLine: k1,
  LucideClipboardPlus: ns,
  LucideClipboardSignature: k1,
  LucideClipboardType: os,
  LucideClipboardX: rs,
  LucideClock: ws,
  LucideClock1: is,
  LucideClock10: cs,
  LucideClock11: ds,
  LucideClock12: ss,
  LucideClock2: us,
  LucideClock3: hs,
  LucideClock4: ps,
  LucideClock5: ys,
  LucideClock6: ks,
  LucideClock7: ms,
  LucideClock8: fs,
  LucideClock9: vs,
  LucideClockAlert: gs,
  LucideClockArrowDown: Ms,
  LucideClockArrowUp: bs,
  LucideClockFading: xs,
  LucideCloud: Ts,
  LucideCloudAlert: Ls,
  LucideCloudCog: Ss,
  LucideCloudDownload: f1,
  LucideCloudDrizzle: Is,
  LucideCloudFog: As,
  LucideCloudHail: Cs,
  LucideCloudLightning: qs,
  LucideCloudMoon: _s,
  LucideCloudMoonRain: zs,
  LucideCloudOff: Ps,
  LucideCloudRain: Hs,
  LucideCloudRainWind: js,
  LucideCloudSnow: Vs,
  LucideCloudSun: Ds,
  LucideCloudSunRain: Bs,
  LucideCloudUpload: v1,
  LucideCloudy: $s,
  LucideClover: Os,
  LucideClub: Rs,
  LucideCode: Fs,
  LucideCode2: g1,
  LucideCodeSquare: Yn,
  LucideCodeXml: g1,
  LucideCodepen: Es,
  LucideCodesandbox: Us,
  LucideCoffee: Ws,
  LucideCog: Ns,
  LucideCoins: Gs,
  LucideColumns: M1,
  LucideColumns2: M1,
  LucideColumns3: b1,
  LucideColumns4: Zs,
  LucideCombine: Ys,
  LucideCommand: Ks,
  LucideCompass: Xs,
  LucideComponent: Qs,
  LucideComputer: Js,
  LucideConciergeBell: eu,
  LucideCone: tu,
  LucideConstruction: au,
  LucideContact: nu,
  LucideContact2: x1,
  LucideContactRound: x1,
  LucideContainer: ou,
  LucideContrast: ru,
  LucideCookie: lu,
  LucideCookingPot: iu,
  LucideCopy: pu,
  LucideCopyCheck: cu,
  LucideCopyMinus: hu,
  LucideCopyPlus: du,
  LucideCopySlash: su,
  LucideCopyX: uu,
  LucideCopyleft: yu,
  LucideCopyright: ku,
  LucideCornerDownLeft: mu,
  LucideCornerDownRight: fu,
  LucideCornerLeftDown: vu,
  LucideCornerLeftUp: gu,
  LucideCornerRightDown: Mu,
  LucideCornerRightUp: bu,
  LucideCornerUpLeft: xu,
  LucideCornerUpRight: wu,
  LucideCpu: Lu,
  LucideCreativeCommons: Iu,
  LucideCreditCard: Su,
  LucideCroissant: Cu,
  LucideCrop: Au,
  LucideCross: qu,
  LucideCrosshair: zu,
  LucideCrown: Pu,
  LucideCuboid: _u,
  LucideCupSoda: ju,
  LucideCurlyBraces: wa,
  LucideCurrency: Hu,
  LucideCylinder: Vu,
  LucideDam: Bu,
  LucideDatabase: Tu,
  LucideDatabaseBackup: Du,
  LucideDatabaseZap: $u,
  LucideDelete: Ou,
  LucideDessert: Ru,
  LucideDiameter: Fu,
  LucideDiamond: Nu,
  LucideDiamondMinus: Eu,
  LucideDiamondPercent: w1,
  LucideDiamondPlus: Uu,
  LucideDice1: Wu,
  LucideDice2: Gu,
  LucideDice3: Zu,
  LucideDice4: Yu,
  LucideDice5: Ku,
  LucideDice6: Xu,
  LucideDices: Qu,
  LucideDiff: Ju,
  LucideDisc: nh,
  LucideDisc2: eh,
  LucideDisc3: th,
  LucideDiscAlbum: ah,
  LucideDivide: oh,
  LucideDivideCircle: Ja,
  LucideDivideSquare: eo,
  LucideDna: lh,
  LucideDnaOff: rh,
  LucideDock: ih,
  LucideDog: ch,
  LucideDollarSign: dh,
  LucideDonut: sh,
  LucideDoorClosed: uh,
  LucideDoorOpen: hh,
  LucideDot: ph,
  LucideDotSquare: Jn,
  LucideDownload: yh,
  LucideDownloadCloud: f1,
  LucideDraftingCompass: kh,
  LucideDrama: mh,
  LucideDribbble: fh,
  LucideDrill: vh,
  LucideDroplet: Mh,
  LucideDropletOff: gh,
  LucideDroplets: bh,
  LucideDrum: xh,
  LucideDrumstick: wh,
  LucideDumbbell: Lh,
  LucideEar: Ih,
  LucideEarOff: Sh,
  LucideEarth: L1,
  LucideEarthLock: Ch,
  LucideEclipse: Ah,
  LucideEdit: xt,
  LucideEdit2: fn,
  LucideEdit3: mn,
  LucideEgg: Ph,
  LucideEggFried: qh,
  LucideEggOff: zh,
  LucideEllipsis: I1,
  LucideEllipsisVertical: S1,
  LucideEqual: Hh,
  LucideEqualApproximately: _h,
  LucideEqualNot: jh,
  LucideEqualSquare: to,
  LucideEraser: Vh,
  LucideEthernetPort: Bh,
  LucideEuro: Dh,
  LucideExpand: Th,
  LucideExternalLink: $h,
  LucideEye: Fh,
  LucideEyeClosed: Oh,
  LucideEyeOff: Rh,
  LucideFacebook: Eh,
  LucideFactory: Uh,
  LucideFan: Nh,
  LucideFastForward: Wh,
  LucideFeather: Gh,
  LucideFence: Zh,
  LucideFerrisWheel: Yh,
  LucideFigma: Kh,
  LucideFile: Gp,
  LucideFileArchive: Xh,
  LucideFileAudio: Jh,
  LucideFileAudio2: Qh,
  LucideFileAxis3D: C1,
  LucideFileAxis3d: C1,
  LucideFileBadge: tp,
  LucideFileBadge2: ep,
  LucideFileBarChart: A1,
  LucideFileBarChart2: q1,
  LucideFileBox: ap,
  LucideFileChartColumn: q1,
  LucideFileChartColumnIncreasing: A1,
  LucideFileChartLine: z1,
  LucideFileChartPie: P1,
  LucideFileCheck: op,
  LucideFileCheck2: np,
  LucideFileClock: rp,
  LucideFileCode: ip,
  LucideFileCode2: lp,
  LucideFileCog: _1,
  LucideFileCog2: _1,
  LucideFileDiff: cp,
  LucideFileDigit: dp,
  LucideFileDown: sp,
  LucideFileEdit: H1,
  LucideFileHeart: up,
  LucideFileImage: hp,
  LucideFileInput: pp,
  LucideFileJson: kp,
  LucideFileJson2: yp,
  LucideFileKey: fp,
  LucideFileKey2: mp,
  LucideFileLineChart: z1,
  LucideFileLock: gp,
  LucideFileLock2: vp,
  LucideFileMinus: bp,
  LucideFileMinus2: Mp,
  LucideFileMusic: xp,
  LucideFileOutput: wp,
  LucideFilePen: H1,
  LucideFilePenLine: j1,
  LucideFilePieChart: P1,
  LucideFilePlus: Sp,
  LucideFilePlus2: Lp,
  LucideFileQuestion: Ip,
  LucideFileScan: Cp,
  LucideFileSearch: qp,
  LucideFileSearch2: Ap,
  LucideFileSignature: j1,
  LucideFileSliders: zp,
  LucideFileSpreadsheet: Pp,
  LucideFileStack: _p,
  LucideFileSymlink: jp,
  LucideFileTerminal: Hp,
  LucideFileText: Vp,
  LucideFileType: Dp,
  LucideFileType2: Bp,
  LucideFileUp: Tp,
  LucideFileUser: $p,
  LucideFileVideo: Rp,
  LucideFileVideo2: Op,
  LucideFileVolume: Ep,
  LucideFileVolume2: Fp,
  LucideFileWarning: Up,
  LucideFileX: Wp,
  LucideFileX2: Np,
  LucideFiles: Zp,
  LucideFilm: Yp,
  LucideFilter: T1,
  LucideFilterX: D1,
  LucideFingerprint: Kp,
  LucideFireExtinguisher: Xp,
  LucideFish: ey,
  LucideFishOff: Qp,
  LucideFishSymbol: Jp,
  LucideFlag: oy,
  LucideFlagOff: ay,
  LucideFlagTriangleLeft: ty,
  LucideFlagTriangleRight: ny,
  LucideFlame: ly,
  LucideFlameKindling: ry,
  LucideFlashlight: cy,
  LucideFlashlightOff: iy,
  LucideFlaskConical: sy,
  LucideFlaskConicalOff: dy,
  LucideFlaskRound: uy,
  LucideFlipHorizontal: py,
  LucideFlipHorizontal2: hy,
  LucideFlipVertical: ky,
  LucideFlipVertical2: yy,
  LucideFlower: fy,
  LucideFlower2: my,
  LucideFocus: vy,
  LucideFoldHorizontal: gy,
  LucideFoldVertical: My,
  LucideFolder: Zy,
  LucideFolderArchive: by,
  LucideFolderCheck: xy,
  LucideFolderClock: wy,
  LucideFolderClosed: Ly,
  LucideFolderCode: Sy,
  LucideFolderCog: V1,
  LucideFolderCog2: V1,
  LucideFolderDot: Iy,
  LucideFolderDown: Cy,
  LucideFolderEdit: B1,
  LucideFolderGit: qy,
  LucideFolderGit2: Ay,
  LucideFolderHeart: zy,
  LucideFolderInput: Py,
  LucideFolderKanban: _y,
  LucideFolderKey: jy,
  LucideFolderLock: Vy,
  LucideFolderMinus: Hy,
  LucideFolderOpen: Dy,
  LucideFolderOpenDot: By,
  LucideFolderOutput: Ty,
  LucideFolderPen: B1,
  LucideFolderPlus: $y,
  LucideFolderRoot: Oy,
  LucideFolderSearch: Fy,
  LucideFolderSearch2: Ry,
  LucideFolderSymlink: Ey,
  LucideFolderSync: Uy,
  LucideFolderTree: Ny,
  LucideFolderUp: Wy,
  LucideFolderX: Gy,
  LucideFolders: Yy,
  LucideFootprints: Ky,
  LucideForkKnife: Fo,
  LucideForkKnifeCrossed: Ro,
  LucideForklift: Xy,
  LucideFormInput: gn,
  LucideForward: Qy,
  LucideFrame: Jy,
  LucideFramer: ek,
  LucideFrown: tk,
  LucideFuel: ak,
  LucideFullscreen: nk,
  LucideFunctionSquare: ao,
  LucideFunnel: T1,
  LucideFunnelPlus: ok,
  LucideFunnelX: D1,
  LucideGalleryHorizontal: lk,
  LucideGalleryHorizontalEnd: rk,
  LucideGalleryThumbnails: ik,
  LucideGalleryVertical: dk,
  LucideGalleryVerticalEnd: ck,
  LucideGamepad: uk,
  LucideGamepad2: sk,
  LucideGanttChart: Va,
  LucideGanttChartSquare: Bt,
  LucideGauge: hk,
  LucideGaugeCircle: e1,
  LucideGavel: pk,
  LucideGem: yk,
  LucideGhost: kk,
  LucideGift: mk,
  LucideGitBranch: vk,
  LucideGitBranchPlus: fk,
  LucideGitCommit: $1,
  LucideGitCommitHorizontal: $1,
  LucideGitCommitVertical: gk,
  LucideGitCompare: bk,
  LucideGitCompareArrows: Mk,
  LucideGitFork: xk,
  LucideGitGraph: wk,
  LucideGitMerge: Lk,
  LucideGitPullRequest: zk,
  LucideGitPullRequestArrow: Sk,
  LucideGitPullRequestClosed: Ik,
  LucideGitPullRequestCreate: Ak,
  LucideGitPullRequestCreateArrow: Ck,
  LucideGitPullRequestDraft: qk,
  LucideGithub: Pk,
  LucideGitlab: _k,
  LucideGlassWater: jk,
  LucideGlasses: Hk,
  LucideGlobe: Bk,
  LucideGlobe2: L1,
  LucideGlobeLock: Vk,
  LucideGoal: Dk,
  LucideGrab: Tk,
  LucideGraduationCap: $k,
  LucideGrape: Ok,
  LucideGrid: Vt,
  LucideGrid2X2: E1,
  LucideGrid2X2Check: O1,
  LucideGrid2X2Plus: R1,
  LucideGrid2X2X: F1,
  LucideGrid2x2: E1,
  LucideGrid2x2Check: O1,
  LucideGrid2x2Plus: R1,
  LucideGrid2x2X: F1,
  LucideGrid3X3: Vt,
  LucideGrid3x3: Vt,
  LucideGrip: Ek,
  LucideGripHorizontal: Rk,
  LucideGripVertical: Fk,
  LucideGroup: Uk,
  LucideGuitar: Nk,
  LucideHam: Wk,
  LucideHammer: Gk,
  LucideHand: Qk,
  LucideHandCoins: Zk,
  LucideHandHeart: Yk,
  LucideHandHelping: U1,
  LucideHandMetal: Kk,
  LucideHandPlatter: Xk,
  LucideHandshake: Jk,
  LucideHardDrive: a4,
  LucideHardDriveDownload: e4,
  LucideHardDriveUpload: t4,
  LucideHardHat: n4,
  LucideHash: o4,
  LucideHaze: r4,
  LucideHdmiPort: l4,
  LucideHeading: p4,
  LucideHeading1: i4,
  LucideHeading2: c4,
  LucideHeading3: d4,
  LucideHeading4: s4,
  LucideHeading5: u4,
  LucideHeading6: h4,
  LucideHeadphoneOff: y4,
  LucideHeadphones: k4,
  LucideHeadset: m4,
  LucideHeart: b4,
  LucideHeartCrack: f4,
  LucideHeartHandshake: v4,
  LucideHeartOff: g4,
  LucideHeartPulse: M4,
  LucideHeater: x4,
  LucideHelpCircle: t1,
  LucideHelpingHand: U1,
  LucideHexagon: w4,
  LucideHighlighter: L4,
  LucideHistory: S4,
  LucideHome: N1,
  LucideHop: C4,
  LucideHopOff: I4,
  LucideHospital: A4,
  LucideHotel: q4,
  LucideHourglass: z4,
  LucideHouse: N1,
  LucideHousePlug: P4,
  LucideHousePlus: _4,
  LucideHouseWifi: j4,
  LucideIceCream: G1,
  LucideIceCream2: W1,
  LucideIceCreamBowl: W1,
  LucideIceCreamCone: G1,
  LucideIdCard: H4,
  LucideImage: F4,
  LucideImageDown: V4,
  LucideImageMinus: B4,
  LucideImageOff: T4,
  LucideImagePlay: D4,
  LucideImagePlus: $4,
  LucideImageUp: O4,
  LucideImageUpscale: R4,
  LucideImages: E4,
  LucideImport: U4,
  LucideInbox: N4,
  LucideIndent: Z1,
  LucideIndentDecrease: Y1,
  LucideIndentIncrease: Z1,
  LucideIndianRupee: W4,
  LucideInfinity: G4,
  LucideInfo: Z4,
  LucideInspect: co,
  LucideInspectionPanel: Y4,
  LucideInstagram: K4,
  LucideItalic: X4,
  LucideIterationCcw: Q4,
  LucideIterationCw: J4,
  LucideJapaneseYen: e5,
  LucideJoystick: t5,
  LucideKanban: n5,
  LucideKanbanSquare: no,
  LucideKanbanSquareDashed: Kn,
  LucideKey: r5,
  LucideKeyRound: a5,
  LucideKeySquare: o5,
  LucideKeyboard: i5,
  LucideKeyboardMusic: c5,
  LucideKeyboardOff: l5,
  LucideLamp: y5,
  LucideLampCeiling: d5,
  LucideLampDesk: s5,
  LucideLampFloor: u5,
  LucideLampWallDown: h5,
  LucideLampWallUp: p5,
  LucideLandPlot: k5,
  LucideLandmark: m5,
  LucideLanguages: f5,
  LucideLaptop: g5,
  LucideLaptop2: K1,
  LucideLaptopMinimal: K1,
  LucideLaptopMinimalCheck: v5,
  LucideLasso: b5,
  LucideLassoSelect: M5,
  LucideLaugh: x5,
  LucideLayers: X1,
  LucideLayers2: w5,
  LucideLayers3: X1,
  LucideLayout: kn,
  LucideLayoutDashboard: L5,
  LucideLayoutGrid: S5,
  LucideLayoutList: I5,
  LucideLayoutPanelLeft: C5,
  LucideLayoutPanelTop: A5,
  LucideLayoutTemplate: q5,
  LucideLeaf: z5,
  LucideLeafyGreen: P5,
  LucideLectern: _5,
  LucideLetterText: j5,
  LucideLibrary: V5,
  LucideLibraryBig: H5,
  LucideLibrarySquare: oo,
  LucideLifeBuoy: B5,
  LucideLigature: D5,
  LucideLightbulb: $5,
  LucideLightbulbOff: T5,
  LucideLineChart: _a,
  LucideLink: F5,
  LucideLink2: R5,
  LucideLink2Off: O5,
  LucideLinkedin: E5,
  LucideList: lm,
  LucideListCheck: U5,
  LucideListChecks: N5,
  LucideListCollapse: W5,
  LucideListEnd: G5,
  LucideListFilter: Z5,
  LucideListFilterPlus: K5,
  LucideListMinus: Y5,
  LucideListMusic: X5,
  LucideListOrdered: Q5,
  LucideListPlus: J5,
  LucideListRestart: em,
  LucideListStart: tm,
  LucideListTodo: am,
  LucideListTree: nm,
  LucideListVideo: om,
  LucideListX: rm,
  LucideLoader: cm,
  LucideLoader2: Q1,
  LucideLoaderCircle: Q1,
  LucideLoaderPinwheel: im,
  LucideLocate: um,
  LucideLocateFixed: dm,
  LucideLocateOff: sm,
  LucideLock: pm,
  LucideLockKeyhole: hm,
  LucideLockKeyholeOpen: J1,
  LucideLockOpen: en,
  LucideLogIn: ym,
  LucideLogOut: km,
  LucideLogs: mm,
  LucideLollipop: fm,
  LucideLuggage: vm,
  LucideMSquare: ro,
  LucideMagnet: gm,
  LucideMail: Am,
  LucideMailCheck: Mm,
  LucideMailMinus: bm,
  LucideMailOpen: xm,
  LucideMailPlus: wm,
  LucideMailQuestion: Lm,
  LucideMailSearch: Sm,
  LucideMailWarning: Im,
  LucideMailX: Cm,
  LucideMailbox: qm,
  LucideMails: zm,
  LucideMap: Um,
  LucideMapPin: Rm,
  LucideMapPinCheck: _m,
  LucideMapPinCheckInside: Pm,
  LucideMapPinHouse: jm,
  LucideMapPinMinus: Vm,
  LucideMapPinMinusInside: Hm,
  LucideMapPinOff: Bm,
  LucideMapPinPlus: Tm,
  LucideMapPinPlusInside: Dm,
  LucideMapPinX: Om,
  LucideMapPinXInside: $m,
  LucideMapPinned: Fm,
  LucideMapPlus: Em,
  LucideMars: Wm,
  LucideMarsStroke: Nm,
  LucideMartini: Gm,
  LucideMaximize: Ym,
  LucideMaximize2: Zm,
  LucideMedal: Km,
  LucideMegaphone: Qm,
  LucideMegaphoneOff: Xm,
  LucideMeh: Jm,
  LucideMemoryStick: e3,
  LucideMenu: t3,
  LucideMenuSquare: lo,
  LucideMerge: a3,
  LucideMessageCircle: p3,
  LucideMessageCircleCode: n3,
  LucideMessageCircleDashed: o3,
  LucideMessageCircleHeart: r3,
  LucideMessageCircleMore: l3,
  LucideMessageCircleOff: i3,
  LucideMessageCirclePlus: c3,
  LucideMessageCircleQuestion: d3,
  LucideMessageCircleReply: s3,
  LucideMessageCircleWarning: u3,
  LucideMessageCircleX: h3,
  LucideMessageSquare: q3,
  LucideMessageSquareCode: y3,
  LucideMessageSquareDashed: k3,
  LucideMessageSquareDiff: m3,
  LucideMessageSquareDot: f3,
  LucideMessageSquareHeart: v3,
  LucideMessageSquareLock: g3,
  LucideMessageSquareMore: M3,
  LucideMessageSquareOff: b3,
  LucideMessageSquarePlus: x3,
  LucideMessageSquareQuote: w3,
  LucideMessageSquareReply: L3,
  LucideMessageSquareShare: S3,
  LucideMessageSquareText: I3,
  LucideMessageSquareWarning: C3,
  LucideMessageSquareX: A3,
  LucideMessagesSquare: z3,
  LucideMic: _3,
  LucideMic2: tn,
  LucideMicOff: P3,
  LucideMicVocal: tn,
  LucideMicrochip: j3,
  LucideMicroscope: H3,
  LucideMicrowave: V3,
  LucideMilestone: B3,
  LucideMilk: T3,
  LucideMilkOff: D3,
  LucideMinimize: O3,
  LucideMinimize2: $3,
  LucideMinus: R3,
  LucideMinusCircle: a1,
  LucideMinusSquare: io,
  LucideMonitor: ef,
  LucideMonitorCheck: F3,
  LucideMonitorCog: E3,
  LucideMonitorDot: U3,
  LucideMonitorDown: N3,
  LucideMonitorOff: W3,
  LucideMonitorPause: G3,
  LucideMonitorPlay: Z3,
  LucideMonitorSmartphone: Y3,
  LucideMonitorSpeaker: K3,
  LucideMonitorStop: X3,
  LucideMonitorUp: Q3,
  LucideMonitorX: J3,
  LucideMoon: af,
  LucideMoonStar: tf,
  LucideMoreHorizontal: I1,
  LucideMoreVertical: S1,
  LucideMountain: of,
  LucideMountainSnow: nf,
  LucideMouse: uf,
  LucideMouseOff: rf,
  LucideMousePointer: sf,
  LucideMousePointer2: lf,
  LucideMousePointerBan: cf,
  LucideMousePointerClick: df,
  LucideMousePointerSquareDashed: Xn,
  LucideMove: Sf,
  LucideMove3D: an,
  LucideMove3d: an,
  LucideMoveDiagonal: pf,
  LucideMoveDiagonal2: hf,
  LucideMoveDown: mf,
  LucideMoveDownLeft: yf,
  LucideMoveDownRight: kf,
  LucideMoveHorizontal: ff,
  LucideMoveLeft: vf,
  LucideMoveRight: gf,
  LucideMoveUp: xf,
  LucideMoveUpLeft: Mf,
  LucideMoveUpRight: bf,
  LucideMoveVertical: wf,
  LucideMusic: Af,
  LucideMusic2: Lf,
  LucideMusic3: If,
  LucideMusic4: Cf,
  LucideNavigation: _f,
  LucideNavigation2: zf,
  LucideNavigation2Off: qf,
  LucideNavigationOff: Pf,
  LucideNetwork: jf,
  LucideNewspaper: Hf,
  LucideNfc: Vf,
  LucideNonBinary: Bf,
  LucideNotebook: Of,
  LucideNotebookPen: Df,
  LucideNotebookTabs: Tf,
  LucideNotebookText: $f,
  LucideNotepadText: Ff,
  LucideNotepadTextDashed: Rf,
  LucideNut: Uf,
  LucideNutOff: Ef,
  LucideOctagon: Wf,
  LucideOctagonAlert: nn,
  LucideOctagonMinus: Nf,
  LucideOctagonPause: on,
  LucideOctagonX: rn,
  LucideOmega: Gf,
  LucideOption: Zf,
  LucideOrbit: Yf,
  LucideOrigami: Kf,
  LucideOutdent: Y1,
  LucidePackage: ov,
  LucidePackage2: Xf,
  LucidePackageCheck: Qf,
  LucidePackageMinus: Jf,
  LucidePackageOpen: ev,
  LucidePackagePlus: tv,
  LucidePackageSearch: av,
  LucidePackageX: nv,
  LucidePaintBucket: rv,
  LucidePaintRoller: lv,
  LucidePaintbrush: iv,
  LucidePaintbrush2: ln,
  LucidePaintbrushVertical: ln,
  LucidePalette: cv,
  LucidePalmtree: zo,
  LucidePanelBottom: uv,
  LucidePanelBottomClose: dv,
  LucidePanelBottomDashed: cn,
  LucidePanelBottomInactive: cn,
  LucidePanelBottomOpen: sv,
  LucidePanelLeft: hn,
  LucidePanelLeftClose: dn,
  LucidePanelLeftDashed: sn,
  LucidePanelLeftInactive: sn,
  LucidePanelLeftOpen: un,
  LucidePanelRight: yv,
  LucidePanelRightClose: hv,
  LucidePanelRightDashed: pn,
  LucidePanelRightInactive: pn,
  LucidePanelRightOpen: pv,
  LucidePanelTop: fv,
  LucidePanelTopClose: kv,
  LucidePanelTopDashed: yn,
  LucidePanelTopInactive: yn,
  LucidePanelTopOpen: mv,
  LucidePanelsLeftBottom: vv,
  LucidePanelsLeftRight: b1,
  LucidePanelsRightBottom: gv,
  LucidePanelsTopBottom: xn,
  LucidePanelsTopLeft: kn,
  LucidePaperclip: Mv,
  LucideParentheses: xv,
  LucideParkingCircle: o1,
  LucideParkingCircleOff: n1,
  LucideParkingMeter: bv,
  LucideParkingSquare: uo,
  LucideParkingSquareOff: so,
  LucidePartyPopper: wv,
  LucidePause: Lv,
  LucidePauseCircle: r1,
  LucidePauseOctagon: on,
  LucidePawPrint: Sv,
  LucidePcCase: Iv,
  LucidePen: fn,
  LucidePenBox: xt,
  LucidePenLine: mn,
  LucidePenOff: Cv,
  LucidePenSquare: xt,
  LucidePenTool: Av,
  LucidePencil: _v,
  LucidePencilLine: qv,
  LucidePencilOff: zv,
  LucidePencilRuler: Pv,
  LucidePentagon: jv,
  LucidePercent: Hv,
  LucidePercentCircle: l1,
  LucidePercentDiamond: w1,
  LucidePercentSquare: ho,
  LucidePersonStanding: Vv,
  LucidePhilippinePeso: Bv,
  LucidePhone: Ev,
  LucidePhoneCall: Dv,
  LucidePhoneForwarded: Tv,
  LucidePhoneIncoming: $v,
  LucidePhoneMissed: Ov,
  LucidePhoneOff: Rv,
  LucidePhoneOutgoing: Fv,
  LucidePi: Uv,
  LucidePiSquare: po,
  LucidePiano: Nv,
  LucidePickaxe: Wv,
  LucidePictureInPicture: Zv,
  LucidePictureInPicture2: Gv,
  LucidePieChart: Ba,
  LucidePiggyBank: Yv,
  LucidePilcrow: Qv,
  LucidePilcrowLeft: Kv,
  LucidePilcrowRight: Xv,
  LucidePilcrowSquare: yo,
  LucidePill: e6,
  LucidePillBottle: Jv,
  LucidePin: a6,
  LucidePinOff: t6,
  LucidePipette: o6,
  LucidePizza: n6,
  LucidePlane: i6,
  LucidePlaneLanding: r6,
  LucidePlaneTakeoff: l6,
  LucidePlay: c6,
  LucidePlayCircle: i1,
  LucidePlaySquare: ko,
  LucidePlug: s6,
  LucidePlug2: d6,
  LucidePlugZap: vn,
  LucidePlugZap2: vn,
  LucidePlus: u6,
  LucidePlusCircle: c1,
  LucidePlusSquare: mo,
  LucidePocket: h6,
  LucidePocketKnife: p6,
  LucidePodcast: y6,
  LucidePointer: k6,
  LucidePointerOff: m6,
  LucidePopcorn: f6,
  LucidePopsicle: v6,
  LucidePoundSterling: g6,
  LucidePower: b6,
  LucidePowerCircle: d1,
  LucidePowerOff: M6,
  LucidePowerSquare: fo,
  LucidePresentation: x6,
  LucidePrinter: L6,
  LucidePrinterCheck: w6,
  LucideProjector: S6,
  LucideProportions: I6,
  LucidePuzzle: A6,
  LucidePyramid: C6,
  LucideQrCode: q6,
  LucideQuote: z6,
  LucideRabbit: P6,
  LucideRadar: _6,
  LucideRadiation: j6,
  LucideRadical: H6,
  LucideRadio: D6,
  LucideRadioReceiver: V6,
  LucideRadioTower: B6,
  LucideRadius: T6,
  LucideRailSymbol: $6,
  LucideRainbow: O6,
  LucideRat: R6,
  LucideRatio: F6,
  LucideReceipt: X6,
  LucideReceiptCent: E6,
  LucideReceiptEuro: U6,
  LucideReceiptIndianRupee: N6,
  LucideReceiptJapaneseYen: W6,
  LucideReceiptPoundSterling: G6,
  LucideReceiptRussianRuble: Z6,
  LucideReceiptSwissFranc: Y6,
  LucideReceiptText: K6,
  LucideRectangleEllipsis: gn,
  LucideRectangleHorizontal: Q6,
  LucideRectangleVertical: J6,
  LucideRecycle: e8,
  LucideRedo: n8,
  LucideRedo2: t8,
  LucideRedoDot: a8,
  LucideRefreshCcw: r8,
  LucideRefreshCcwDot: o8,
  LucideRefreshCw: i8,
  LucideRefreshCwOff: l8,
  LucideRefrigerator: c8,
  LucideRegex: d8,
  LucideRemoveFormatting: s8,
  LucideRepeat: p8,
  LucideRepeat1: u8,
  LucideRepeat2: h8,
  LucideReplace: k8,
  LucideReplaceAll: y8,
  LucideReply: f8,
  LucideReplyAll: m8,
  LucideRewind: v8,
  LucideRibbon: g8,
  LucideRocket: M8,
  LucideRockingChair: b8,
  LucideRollerCoaster: x8,
  LucideRotate3D: Mn,
  LucideRotate3d: Mn,
  LucideRotateCcw: L8,
  LucideRotateCcwSquare: w8,
  LucideRotateCw: I8,
  LucideRotateCwSquare: S8,
  LucideRoute: A8,
  LucideRouteOff: C8,
  LucideRouter: q8,
  LucideRows: bn,
  LucideRows2: bn,
  LucideRows3: xn,
  LucideRows4: z8,
  LucideRss: P8,
  LucideRuler: _8,
  LucideRussianRuble: j8,
  LucideSailboat: H8,
  LucideSalad: V8,
  LucideSandwich: B8,
  LucideSatellite: T8,
  LucideSatelliteDish: D8,
  LucideSaudiRiyal: $8,
  LucideSave: F8,
  LucideSaveAll: O8,
  LucideSaveOff: R8,
  LucideScale: E8,
  LucideScale3D: wn,
  LucideScale3d: wn,
  LucideScaling: U8,
  LucideScan: J8,
  LucideScanBarcode: N8,
  LucideScanEye: W8,
  LucideScanFace: G8,
  LucideScanHeart: Z8,
  LucideScanLine: Y8,
  LucideScanQrCode: K8,
  LucideScanSearch: Q8,
  LucideScanText: X8,
  LucideScatterChart: Da,
  LucideSchool: eg,
  LucideSchool2: jo,
  LucideScissors: ag,
  LucideScissorsLineDashed: tg,
  LucideScissorsSquare: vo,
  LucideScissorsSquareDashedBottom: Fn,
  LucideScreenShare: og,
  LucideScreenShareOff: ng,
  LucideScroll: lg,
  LucideScrollText: rg,
  LucideSearch: ug,
  LucideSearchCheck: ig,
  LucideSearchCode: cg,
  LucideSearchSlash: dg,
  LucideSearchX: sg,
  LucideSection: hg,
  LucideSend: yg,
  LucideSendHorizonal: Ln,
  LucideSendHorizontal: Ln,
  LucideSendToBack: pg,
  LucideSeparatorHorizontal: kg,
  LucideSeparatorVertical: mg,
  LucideServer: Mg,
  LucideServerCog: fg,
  LucideServerCrash: vg,
  LucideServerOff: gg,
  LucideSettings: xg,
  LucideSettings2: bg,
  LucideShapes: wg,
  LucideShare: Sg,
  LucideShare2: Lg,
  LucideSheet: Ig,
  LucideShell: Cg,
  LucideShield: Tg,
  LucideShieldAlert: Ag,
  LucideShieldBan: qg,
  LucideShieldCheck: zg,
  LucideShieldClose: Sn,
  LucideShieldEllipsis: Pg,
  LucideShieldHalf: _g,
  LucideShieldMinus: jg,
  LucideShieldOff: Hg,
  LucideShieldPlus: Vg,
  LucideShieldQuestion: Bg,
  LucideShieldUser: Dg,
  LucideShieldX: Sn,
  LucideShip: Og,
  LucideShipWheel: $g,
  LucideShirt: Rg,
  LucideShoppingBag: Fg,
  LucideShoppingBasket: Eg,
  LucideShoppingCart: Ug,
  LucideShovel: Ng,
  LucideShowerHead: Wg,
  LucideShrimp: Gg,
  LucideShrink: Yg,
  LucideShrub: Zg,
  LucideShuffle: Kg,
  LucideSidebar: hn,
  LucideSidebarClose: dn,
  LucideSidebarOpen: un,
  LucideSigma: Xg,
  LucideSigmaSquare: go,
  LucideSignal: a7,
  LucideSignalHigh: Qg,
  LucideSignalLow: Jg,
  LucideSignalMedium: e7,
  LucideSignalZero: t7,
  LucideSignature: n7,
  LucideSignpost: r7,
  LucideSignpostBig: o7,
  LucideSiren: l7,
  LucideSkipBack: i7,
  LucideSkipForward: c7,
  LucideSkull: d7,
  LucideSlack: s7,
  LucideSlash: u7,
  LucideSlashSquare: Mo,
  LucideSlice: h7,
  LucideSliders: In,
  LucideSlidersHorizontal: p7,
  LucideSlidersVertical: In,
  LucideSmartphone: m7,
  LucideSmartphoneCharging: y7,
  LucideSmartphoneNfc: k7,
  LucideSmile: v7,
  LucideSmilePlus: f7,
  LucideSnail: g7,
  LucideSnowflake: M7,
  LucideSofa: b7,
  LucideSortAsc: ma,
  LucideSortDesc: pa,
  LucideSoup: x7,
  LucideSpace: w7,
  LucideSpade: L7,
  LucideSparkle: S7,
  LucideSparkles: Cn,
  LucideSpeaker: I7,
  LucideSpeech: C7,
  LucideSpellCheck: q7,
  LucideSpellCheck2: A7,
  LucideSpline: P7,
  LucideSplinePointer: z7,
  LucideSplit: _7,
  LucideSplitSquareHorizontal: bo,
  LucideSplitSquareVertical: xo,
  LucideSprayCan: j7,
  LucideSprout: H7,
  LucideSquare: R7,
  LucideSquareActivity: An,
  LucideSquareArrowDown: Pn,
  LucideSquareArrowDownLeft: qn,
  LucideSquareArrowDownRight: zn,
  LucideSquareArrowLeft: _n,
  LucideSquareArrowOutDownLeft: jn,
  LucideSquareArrowOutDownRight: Hn,
  LucideSquareArrowOutUpLeft: Vn,
  LucideSquareArrowOutUpRight: Bn,
  LucideSquareArrowRight: Dn,
  LucideSquareArrowUp: On,
  LucideSquareArrowUpLeft: Tn,
  LucideSquareArrowUpRight: $n,
  LucideSquareAsterisk: Rn,
  LucideSquareBottomDashedScissors: Fn,
  LucideSquareChartGantt: Bt,
  LucideSquareCheck: Un,
  LucideSquareCheckBig: En,
  LucideSquareChevronDown: Nn,
  LucideSquareChevronLeft: Wn,
  LucideSquareChevronRight: Gn,
  LucideSquareChevronUp: Zn,
  LucideSquareCode: Yn,
  LucideSquareDashed: Qn,
  LucideSquareDashedBottom: B7,
  LucideSquareDashedBottomCode: V7,
  LucideSquareDashedKanban: Kn,
  LucideSquareDashedMousePointer: Xn,
  LucideSquareDivide: eo,
  LucideSquareDot: Jn,
  LucideSquareEqual: to,
  LucideSquareFunction: ao,
  LucideSquareGanttChart: Bt,
  LucideSquareKanban: no,
  LucideSquareLibrary: oo,
  LucideSquareM: ro,
  LucideSquareMenu: lo,
  LucideSquareMinus: io,
  LucideSquareMousePointer: co,
  LucideSquareParking: uo,
  LucideSquareParkingOff: so,
  LucideSquarePen: xt,
  LucideSquarePercent: ho,
  LucideSquarePi: po,
  LucideSquarePilcrow: yo,
  LucideSquarePlay: ko,
  LucideSquarePlus: mo,
  LucideSquarePower: fo,
  LucideSquareRadical: D7,
  LucideSquareRoundCorner: T7,
  LucideSquareScissors: vo,
  LucideSquareSigma: go,
  LucideSquareSlash: Mo,
  LucideSquareSplitHorizontal: bo,
  LucideSquareSplitVertical: xo,
  LucideSquareSquare: $7,
  LucideSquareStack: O7,
  LucideSquareTerminal: wo,
  LucideSquareUser: So,
  LucideSquareUserRound: Lo,
  LucideSquareX: Io,
  LucideSquircle: F7,
  LucideSquirrel: E7,
  LucideStamp: U7,
  LucideStar: G7,
  LucideStarHalf: N7,
  LucideStarOff: W7,
  LucideStars: Cn,
  LucideStepBack: Z7,
  LucideStepForward: Y7,
  LucideStethoscope: K7,
  LucideSticker: X7,
  LucideStickyNote: Q7,
  LucideStopCircle: u1,
  LucideStore: J7,
  LucideStretchHorizontal: eM,
  LucideStretchVertical: tM,
  LucideStrikethrough: aM,
  LucideSubscript: nM,
  LucideSubtitles: La,
  LucideSun: cM,
  LucideSunDim: oM,
  LucideSunMedium: rM,
  LucideSunMoon: lM,
  LucideSunSnow: iM,
  LucideSunrise: dM,
  LucideSunset: sM,
  LucideSuperscript: uM,
  LucideSwatchBook: hM,
  LucideSwissFranc: pM,
  LucideSwitchCamera: yM,
  LucideSword: kM,
  LucideSwords: mM,
  LucideSyringe: fM,
  LucideTable: SM,
  LucideTable2: vM,
  LucideTableCellsMerge: gM,
  LucideTableCellsSplit: MM,
  LucideTableColumnsSplit: bM,
  LucideTableOfContents: xM,
  LucideTableProperties: wM,
  LucideTableRowsSplit: LM,
  LucideTablet: CM,
  LucideTabletSmartphone: IM,
  LucideTablets: AM,
  LucideTag: PM,
  LucideTags: qM,
  LucideTally1: zM,
  LucideTally2: _M,
  LucideTally3: jM,
  LucideTally4: HM,
  LucideTally5: VM,
  LucideTangent: BM,
  LucideTarget: DM,
  LucideTelescope: TM,
  LucideTent: OM,
  LucideTentTree: $M,
  LucideTerminal: RM,
  LucideTerminalSquare: wo,
  LucideTestTube: FM,
  LucideTestTube2: Co,
  LucideTestTubeDiagonal: Co,
  LucideTestTubes: EM,
  LucideText: ZM,
  LucideTextCursor: NM,
  LucideTextCursorInput: UM,
  LucideTextQuote: WM,
  LucideTextSearch: GM,
  LucideTextSelect: Ao,
  LucideTextSelection: Ao,
  LucideTheater: YM,
  LucideThermometer: QM,
  LucideThermometerSnowflake: KM,
  LucideThermometerSun: XM,
  LucideThumbsDown: JM,
  LucideThumbsUp: e9,
  LucideTicket: i9,
  LucideTicketCheck: t9,
  LucideTicketMinus: a9,
  LucideTicketPercent: n9,
  LucideTicketPlus: o9,
  LucideTicketSlash: r9,
  LucideTicketX: l9,
  LucideTickets: d9,
  LucideTicketsPlane: c9,
  LucideTimer: h9,
  LucideTimerOff: s9,
  LucideTimerReset: u9,
  LucideToggleLeft: p9,
  LucideToggleRight: y9,
  LucideToilet: k9,
  LucideTornado: m9,
  LucideTorus: f9,
  LucideTouchpad: g9,
  LucideTouchpadOff: v9,
  LucideTowerControl: M9,
  LucideToyBrick: b9,
  LucideTractor: x9,
  LucideTrafficCone: w9,
  LucideTrain: qo,
  LucideTrainFront: S9,
  LucideTrainFrontTunnel: L9,
  LucideTrainTrack: I9,
  LucideTramFront: qo,
  LucideTransgender: A9,
  LucideTrash: q9,
  LucideTrash2: C9,
  LucideTreeDeciduous: z9,
  LucideTreePalm: zo,
  LucideTreePine: P9,
  LucideTrees: _9,
  LucideTrello: j9,
  LucideTrendingDown: H9,
  LucideTrendingUp: B9,
  LucideTrendingUpDown: V9,
  LucideTriangle: $9,
  LucideTriangleAlert: Po,
  LucideTriangleDashed: D9,
  LucideTriangleRight: T9,
  LucideTrophy: O9,
  LucideTruck: R9,
  LucideTurtle: F9,
  LucideTv: U9,
  LucideTv2: _o,
  LucideTvMinimal: _o,
  LucideTvMinimalPlay: E9,
  LucideTwitch: N9,
  LucideTwitter: W9,
  LucideType: Z9,
  LucideTypeOutline: G9,
  LucideUmbrella: K9,
  LucideUmbrellaOff: Y9,
  LucideUnderline: X9,
  LucideUndo: eb,
  LucideUndo2: Q9,
  LucideUndoDot: J9,
  LucideUnfoldHorizontal: tb,
  LucideUnfoldVertical: ab,
  LucideUngroup: nb,
  LucideUniversity: jo,
  LucideUnlink: rb,
  LucideUnlink2: ob,
  LucideUnlock: en,
  LucideUnlockKeyhole: J1,
  LucideUnplug: lb,
  LucideUpload: ib,
  LucideUploadCloud: v1,
  LucideUsb: cb,
  LucideUser: vb,
  LucideUser2: $o,
  LucideUserCheck: db,
  LucideUserCheck2: Ho,
  LucideUserCircle: p1,
  LucideUserCircle2: h1,
  LucideUserCog: sb,
  LucideUserCog2: Vo,
  LucideUserMinus: ub,
  LucideUserMinus2: Bo,
  LucideUserPen: hb,
  LucideUserPlus: pb,
  LucideUserPlus2: Do,
  LucideUserRound: $o,
  LucideUserRoundCheck: Ho,
  LucideUserRoundCog: Vo,
  LucideUserRoundMinus: Bo,
  LucideUserRoundPen: yb,
  LucideUserRoundPlus: Do,
  LucideUserRoundSearch: kb,
  LucideUserRoundX: To,
  LucideUserSearch: mb,
  LucideUserSquare: So,
  LucideUserSquare2: Lo,
  LucideUserX: fb,
  LucideUserX2: To,
  LucideUsers: gb,
  LucideUsers2: Oo,
  LucideUsersRound: Oo,
  LucideUtensils: Fo,
  LucideUtensilsCrossed: Ro,
  LucideUtilityPole: Mb,
  LucideVariable: bb,
  LucideVault: xb,
  LucideVegan: wb,
  LucideVenetianMask: Lb,
  LucideVenus: Ib,
  LucideVenusAndMars: Sb,
  LucideVerified: ga,
  LucideVibrate: Cb,
  LucideVibrateOff: Ab,
  LucideVideo: zb,
  LucideVideoOff: qb,
  LucideVideotape: Pb,
  LucideView: _b,
  LucideVoicemail: Hb,
  LucideVolleyball: jb,
  LucideVolume: $b,
  LucideVolume1: Vb,
  LucideVolume2: Bb,
  LucideVolumeOff: Db,
  LucideVolumeX: Tb,
  LucideVote: Ob,
  LucideWallet: Fb,
  LucideWallet2: Eo,
  LucideWalletCards: Rb,
  LucideWalletMinimal: Eo,
  LucideWallpaper: Eb,
  LucideWand: Ub,
  LucideWand2: Uo,
  LucideWandSparkles: Uo,
  LucideWarehouse: Nb,
  LucideWashingMachine: Wb,
  LucideWatch: Gb,
  LucideWaves: Yb,
  LucideWavesLadder: Zb,
  LucideWaypoints: Kb,
  LucideWebcam: Xb,
  LucideWebhook: Jb,
  LucideWebhookOff: Qb,
  LucideWeight: ex,
  LucideWheat: ax,
  LucideWheatOff: tx,
  LucideWholeWord: nx,
  LucideWifi: cx,
  LucideWifiHigh: ox,
  LucideWifiLow: rx,
  LucideWifiOff: lx,
  LucideWifiZero: ix,
  LucideWind: sx,
  LucideWindArrowDown: dx,
  LucideWine: hx,
  LucideWineOff: ux,
  LucideWorkflow: px,
  LucideWorm: yx,
  LucideWrapText: kx,
  LucideWrench: mx,
  LucideX: fx,
  LucideXCircle: y1,
  LucideXOctagon: rn,
  LucideXSquare: Io,
  LucideYoutube: vx,
  LucideZap: Mx,
  LucideZapOff: gx,
  LucideZoomIn: bx,
  LucideZoomOut: xx,
  Luggage: vm,
  LuggageIcon: vm,
  MSquare: ro,
  MSquareIcon: ro,
  Magnet: gm,
  MagnetIcon: gm,
  Mail: Am,
  MailCheck: Mm,
  MailCheckIcon: Mm,
  MailIcon: Am,
  MailMinus: bm,
  MailMinusIcon: bm,
  MailOpen: xm,
  MailOpenIcon: xm,
  MailPlus: wm,
  MailPlusIcon: wm,
  MailQuestion: Lm,
  MailQuestionIcon: Lm,
  MailSearch: Sm,
  MailSearchIcon: Sm,
  MailWarning: Im,
  MailWarningIcon: Im,
  MailX: Cm,
  MailXIcon: Cm,
  Mailbox: qm,
  MailboxIcon: qm,
  Mails: zm,
  MailsIcon: zm,
  Map: Um,
  MapIcon: Um,
  MapPin: Rm,
  MapPinCheck: _m,
  MapPinCheckIcon: _m,
  MapPinCheckInside: Pm,
  MapPinCheckInsideIcon: Pm,
  MapPinHouse: jm,
  MapPinHouseIcon: jm,
  MapPinIcon: Rm,
  MapPinMinus: Vm,
  MapPinMinusIcon: Vm,
  MapPinMinusInside: Hm,
  MapPinMinusInsideIcon: Hm,
  MapPinOff: Bm,
  MapPinOffIcon: Bm,
  MapPinPlus: Tm,
  MapPinPlusIcon: Tm,
  MapPinPlusInside: Dm,
  MapPinPlusInsideIcon: Dm,
  MapPinX: Om,
  MapPinXIcon: Om,
  MapPinXInside: $m,
  MapPinXInsideIcon: $m,
  MapPinned: Fm,
  MapPinnedIcon: Fm,
  MapPlus: Em,
  MapPlusIcon: Em,
  Mars: Wm,
  MarsIcon: Wm,
  MarsStroke: Nm,
  MarsStrokeIcon: Nm,
  Martini: Gm,
  MartiniIcon: Gm,
  Maximize: Ym,
  Maximize2: Zm,
  Maximize2Icon: Zm,
  MaximizeIcon: Ym,
  Medal: Km,
  MedalIcon: Km,
  Megaphone: Qm,
  MegaphoneIcon: Qm,
  MegaphoneOff: Xm,
  MegaphoneOffIcon: Xm,
  Meh: Jm,
  MehIcon: Jm,
  MemoryStick: e3,
  MemoryStickIcon: e3,
  Menu: t3,
  MenuIcon: t3,
  MenuSquare: lo,
  MenuSquareIcon: lo,
  Merge: a3,
  MergeIcon: a3,
  MessageCircle: p3,
  MessageCircleCode: n3,
  MessageCircleCodeIcon: n3,
  MessageCircleDashed: o3,
  MessageCircleDashedIcon: o3,
  MessageCircleHeart: r3,
  MessageCircleHeartIcon: r3,
  MessageCircleIcon: p3,
  MessageCircleMore: l3,
  MessageCircleMoreIcon: l3,
  MessageCircleOff: i3,
  MessageCircleOffIcon: i3,
  MessageCirclePlus: c3,
  MessageCirclePlusIcon: c3,
  MessageCircleQuestion: d3,
  MessageCircleQuestionIcon: d3,
  MessageCircleReply: s3,
  MessageCircleReplyIcon: s3,
  MessageCircleWarning: u3,
  MessageCircleWarningIcon: u3,
  MessageCircleX: h3,
  MessageCircleXIcon: h3,
  MessageSquare: q3,
  MessageSquareCode: y3,
  MessageSquareCodeIcon: y3,
  MessageSquareDashed: k3,
  MessageSquareDashedIcon: k3,
  MessageSquareDiff: m3,
  MessageSquareDiffIcon: m3,
  MessageSquareDot: f3,
  MessageSquareDotIcon: f3,
  MessageSquareHeart: v3,
  MessageSquareHeartIcon: v3,
  MessageSquareIcon: q3,
  MessageSquareLock: g3,
  MessageSquareLockIcon: g3,
  MessageSquareMore: M3,
  MessageSquareMoreIcon: M3,
  MessageSquareOff: b3,
  MessageSquareOffIcon: b3,
  MessageSquarePlus: x3,
  MessageSquarePlusIcon: x3,
  MessageSquareQuote: w3,
  MessageSquareQuoteIcon: w3,
  MessageSquareReply: L3,
  MessageSquareReplyIcon: L3,
  MessageSquareShare: S3,
  MessageSquareShareIcon: S3,
  MessageSquareText: I3,
  MessageSquareTextIcon: I3,
  MessageSquareWarning: C3,
  MessageSquareWarningIcon: C3,
  MessageSquareX: A3,
  MessageSquareXIcon: A3,
  MessagesSquare: z3,
  MessagesSquareIcon: z3,
  Mic: _3,
  Mic2: tn,
  Mic2Icon: tn,
  MicIcon: _3,
  MicOff: P3,
  MicOffIcon: P3,
  MicVocal: tn,
  MicVocalIcon: tn,
  Microchip: j3,
  MicrochipIcon: j3,
  Microscope: H3,
  MicroscopeIcon: H3,
  Microwave: V3,
  MicrowaveIcon: V3,
  Milestone: B3,
  MilestoneIcon: B3,
  Milk: T3,
  MilkIcon: T3,
  MilkOff: D3,
  MilkOffIcon: D3,
  Minimize: O3,
  Minimize2: $3,
  Minimize2Icon: $3,
  MinimizeIcon: O3,
  Minus: R3,
  MinusCircle: a1,
  MinusCircleIcon: a1,
  MinusIcon: R3,
  MinusSquare: io,
  MinusSquareIcon: io,
  Monitor: ef,
  MonitorCheck: F3,
  MonitorCheckIcon: F3,
  MonitorCog: E3,
  MonitorCogIcon: E3,
  MonitorDot: U3,
  MonitorDotIcon: U3,
  MonitorDown: N3,
  MonitorDownIcon: N3,
  MonitorIcon: ef,
  MonitorOff: W3,
  MonitorOffIcon: W3,
  MonitorPause: G3,
  MonitorPauseIcon: G3,
  MonitorPlay: Z3,
  MonitorPlayIcon: Z3,
  MonitorSmartphone: Y3,
  MonitorSmartphoneIcon: Y3,
  MonitorSpeaker: K3,
  MonitorSpeakerIcon: K3,
  MonitorStop: X3,
  MonitorStopIcon: X3,
  MonitorUp: Q3,
  MonitorUpIcon: Q3,
  MonitorX: J3,
  MonitorXIcon: J3,
  Moon: af,
  MoonIcon: af,
  MoonStar: tf,
  MoonStarIcon: tf,
  MoreHorizontal: I1,
  MoreHorizontalIcon: I1,
  MoreVertical: S1,
  MoreVerticalIcon: S1,
  Mountain: of,
  MountainIcon: of,
  MountainSnow: nf,
  MountainSnowIcon: nf,
  Mouse: uf,
  MouseIcon: uf,
  MouseOff: rf,
  MouseOffIcon: rf,
  MousePointer: sf,
  MousePointer2: lf,
  MousePointer2Icon: lf,
  MousePointerBan: cf,
  MousePointerBanIcon: cf,
  MousePointerClick: df,
  MousePointerClickIcon: df,
  MousePointerIcon: sf,
  MousePointerSquareDashed: Xn,
  MousePointerSquareDashedIcon: Xn,
  Move: Sf,
  Move3D: an,
  Move3DIcon: an,
  Move3d: an,
  Move3dIcon: an,
  MoveDiagonal: pf,
  MoveDiagonal2: hf,
  MoveDiagonal2Icon: hf,
  MoveDiagonalIcon: pf,
  MoveDown: mf,
  MoveDownIcon: mf,
  MoveDownLeft: yf,
  MoveDownLeftIcon: yf,
  MoveDownRight: kf,
  MoveDownRightIcon: kf,
  MoveHorizontal: ff,
  MoveHorizontalIcon: ff,
  MoveIcon: Sf,
  MoveLeft: vf,
  MoveLeftIcon: vf,
  MoveRight: gf,
  MoveRightIcon: gf,
  MoveUp: xf,
  MoveUpIcon: xf,
  MoveUpLeft: Mf,
  MoveUpLeftIcon: Mf,
  MoveUpRight: bf,
  MoveUpRightIcon: bf,
  MoveVertical: wf,
  MoveVerticalIcon: wf,
  Music: Af,
  Music2: Lf,
  Music2Icon: Lf,
  Music3: If,
  Music3Icon: If,
  Music4: Cf,
  Music4Icon: Cf,
  MusicIcon: Af,
  Navigation: _f,
  Navigation2: zf,
  Navigation2Icon: zf,
  Navigation2Off: qf,
  Navigation2OffIcon: qf,
  NavigationIcon: _f,
  NavigationOff: Pf,
  NavigationOffIcon: Pf,
  Network: jf,
  NetworkIcon: jf,
  Newspaper: Hf,
  NewspaperIcon: Hf,
  Nfc: Vf,
  NfcIcon: Vf,
  NonBinary: Bf,
  NonBinaryIcon: Bf,
  Notebook: Of,
  NotebookIcon: Of,
  NotebookPen: Df,
  NotebookPenIcon: Df,
  NotebookTabs: Tf,
  NotebookTabsIcon: Tf,
  NotebookText: $f,
  NotebookTextIcon: $f,
  NotepadText: Ff,
  NotepadTextDashed: Rf,
  NotepadTextDashedIcon: Rf,
  NotepadTextIcon: Ff,
  Nut: Uf,
  NutIcon: Uf,
  NutOff: Ef,
  NutOffIcon: Ef,
  Octagon: Wf,
  OctagonAlert: nn,
  OctagonAlertIcon: nn,
  OctagonIcon: Wf,
  OctagonMinus: Nf,
  OctagonMinusIcon: Nf,
  OctagonPause: on,
  OctagonPauseIcon: on,
  OctagonX: rn,
  OctagonXIcon: rn,
  Omega: Gf,
  OmegaIcon: Gf,
  Option: Zf,
  OptionIcon: Zf,
  Orbit: Yf,
  OrbitIcon: Yf,
  Origami: Kf,
  OrigamiIcon: Kf,
  Outdent: Y1,
  OutdentIcon: Y1,
  Package: ov,
  Package2: Xf,
  Package2Icon: Xf,
  PackageCheck: Qf,
  PackageCheckIcon: Qf,
  PackageIcon: ov,
  PackageMinus: Jf,
  PackageMinusIcon: Jf,
  PackageOpen: ev,
  PackageOpenIcon: ev,
  PackagePlus: tv,
  PackagePlusIcon: tv,
  PackageSearch: av,
  PackageSearchIcon: av,
  PackageX: nv,
  PackageXIcon: nv,
  PaintBucket: rv,
  PaintBucketIcon: rv,
  PaintRoller: lv,
  PaintRollerIcon: lv,
  Paintbrush: iv,
  Paintbrush2: ln,
  Paintbrush2Icon: ln,
  PaintbrushIcon: iv,
  PaintbrushVertical: ln,
  PaintbrushVerticalIcon: ln,
  Palette: cv,
  PaletteIcon: cv,
  Palmtree: zo,
  PalmtreeIcon: zo,
  PanelBottom: uv,
  PanelBottomClose: dv,
  PanelBottomCloseIcon: dv,
  PanelBottomDashed: cn,
  PanelBottomDashedIcon: cn,
  PanelBottomIcon: uv,
  PanelBottomInactive: cn,
  PanelBottomInactiveIcon: cn,
  PanelBottomOpen: sv,
  PanelBottomOpenIcon: sv,
  PanelLeft: hn,
  PanelLeftClose: dn,
  PanelLeftCloseIcon: dn,
  PanelLeftDashed: sn,
  PanelLeftDashedIcon: sn,
  PanelLeftIcon: hn,
  PanelLeftInactive: sn,
  PanelLeftInactiveIcon: sn,
  PanelLeftOpen: un,
  PanelLeftOpenIcon: un,
  PanelRight: yv,
  PanelRightClose: hv,
  PanelRightCloseIcon: hv,
  PanelRightDashed: pn,
  PanelRightDashedIcon: pn,
  PanelRightIcon: yv,
  PanelRightInactive: pn,
  PanelRightInactiveIcon: pn,
  PanelRightOpen: pv,
  PanelRightOpenIcon: pv,
  PanelTop: fv,
  PanelTopClose: kv,
  PanelTopCloseIcon: kv,
  PanelTopDashed: yn,
  PanelTopDashedIcon: yn,
  PanelTopIcon: fv,
  PanelTopInactive: yn,
  PanelTopInactiveIcon: yn,
  PanelTopOpen: mv,
  PanelTopOpenIcon: mv,
  PanelsLeftBottom: vv,
  PanelsLeftBottomIcon: vv,
  PanelsLeftRight: b1,
  PanelsLeftRightIcon: b1,
  PanelsRightBottom: gv,
  PanelsRightBottomIcon: gv,
  PanelsTopBottom: xn,
  PanelsTopBottomIcon: xn,
  PanelsTopLeft: kn,
  PanelsTopLeftIcon: kn,
  Paperclip: Mv,
  PaperclipIcon: Mv,
  Parentheses: xv,
  ParenthesesIcon: xv,
  ParkingCircle: o1,
  ParkingCircleIcon: o1,
  ParkingCircleOff: n1,
  ParkingCircleOffIcon: n1,
  ParkingMeter: bv,
  ParkingMeterIcon: bv,
  ParkingSquare: uo,
  ParkingSquareIcon: uo,
  ParkingSquareOff: so,
  ParkingSquareOffIcon: so,
  PartyPopper: wv,
  PartyPopperIcon: wv,
  Pause: Lv,
  PauseCircle: r1,
  PauseCircleIcon: r1,
  PauseIcon: Lv,
  PauseOctagon: on,
  PauseOctagonIcon: on,
  PawPrint: Sv,
  PawPrintIcon: Sv,
  PcCase: Iv,
  PcCaseIcon: Iv,
  Pen: fn,
  PenBox: xt,
  PenBoxIcon: xt,
  PenIcon: fn,
  PenLine: mn,
  PenLineIcon: mn,
  PenOff: Cv,
  PenOffIcon: Cv,
  PenSquare: xt,
  PenSquareIcon: xt,
  PenTool: Av,
  PenToolIcon: Av,
  Pencil: _v,
  PencilIcon: _v,
  PencilLine: qv,
  PencilLineIcon: qv,
  PencilOff: zv,
  PencilOffIcon: zv,
  PencilRuler: Pv,
  PencilRulerIcon: Pv,
  Pentagon: jv,
  PentagonIcon: jv,
  Percent: Hv,
  PercentCircle: l1,
  PercentCircleIcon: l1,
  PercentDiamond: w1,
  PercentDiamondIcon: w1,
  PercentIcon: Hv,
  PercentSquare: ho,
  PercentSquareIcon: ho,
  PersonStanding: Vv,
  PersonStandingIcon: Vv,
  PhilippinePeso: Bv,
  PhilippinePesoIcon: Bv,
  Phone: Ev,
  PhoneCall: Dv,
  PhoneCallIcon: Dv,
  PhoneForwarded: Tv,
  PhoneForwardedIcon: Tv,
  PhoneIcon: Ev,
  PhoneIncoming: $v,
  PhoneIncomingIcon: $v,
  PhoneMissed: Ov,
  PhoneMissedIcon: Ov,
  PhoneOff: Rv,
  PhoneOffIcon: Rv,
  PhoneOutgoing: Fv,
  PhoneOutgoingIcon: Fv,
  Pi: Uv,
  PiIcon: Uv,
  PiSquare: po,
  PiSquareIcon: po,
  Piano: Nv,
  PianoIcon: Nv,
  Pickaxe: Wv,
  PickaxeIcon: Wv,
  PictureInPicture: Zv,
  PictureInPicture2: Gv,
  PictureInPicture2Icon: Gv,
  PictureInPictureIcon: Zv,
  PieChart: Ba,
  PieChartIcon: Ba,
  PiggyBank: Yv,
  PiggyBankIcon: Yv,
  Pilcrow: Qv,
  PilcrowIcon: Qv,
  PilcrowLeft: Kv,
  PilcrowLeftIcon: Kv,
  PilcrowRight: Xv,
  PilcrowRightIcon: Xv,
  PilcrowSquare: yo,
  PilcrowSquareIcon: yo,
  Pill: e6,
  PillBottle: Jv,
  PillBottleIcon: Jv,
  PillIcon: e6,
  Pin: a6,
  PinIcon: a6,
  PinOff: t6,
  PinOffIcon: t6,
  Pipette: o6,
  PipetteIcon: o6,
  Pizza: n6,
  PizzaIcon: n6,
  Plane: i6,
  PlaneIcon: i6,
  PlaneLanding: r6,
  PlaneLandingIcon: r6,
  PlaneTakeoff: l6,
  PlaneTakeoffIcon: l6,
  Play: c6,
  PlayCircle: i1,
  PlayCircleIcon: i1,
  PlayIcon: c6,
  PlaySquare: ko,
  PlaySquareIcon: ko,
  Plug: s6,
  Plug2: d6,
  Plug2Icon: d6,
  PlugIcon: s6,
  PlugZap: vn,
  PlugZap2: vn,
  PlugZap2Icon: vn,
  PlugZapIcon: vn,
  Plus: u6,
  PlusCircle: c1,
  PlusCircleIcon: c1,
  PlusIcon: u6,
  PlusSquare: mo,
  PlusSquareIcon: mo,
  Pocket: h6,
  PocketIcon: h6,
  PocketKnife: p6,
  PocketKnifeIcon: p6,
  Podcast: y6,
  PodcastIcon: y6,
  Pointer: k6,
  PointerIcon: k6,
  PointerOff: m6,
  PointerOffIcon: m6,
  Popcorn: f6,
  PopcornIcon: f6,
  Popsicle: v6,
  PopsicleIcon: v6,
  PoundSterling: g6,
  PoundSterlingIcon: g6,
  Power: b6,
  PowerCircle: d1,
  PowerCircleIcon: d1,
  PowerIcon: b6,
  PowerOff: M6,
  PowerOffIcon: M6,
  PowerSquare: fo,
  PowerSquareIcon: fo,
  Presentation: x6,
  PresentationIcon: x6,
  Printer: L6,
  PrinterCheck: w6,
  PrinterCheckIcon: w6,
  PrinterIcon: L6,
  Projector: S6,
  ProjectorIcon: S6,
  Proportions: I6,
  ProportionsIcon: I6,
  Puzzle: A6,
  PuzzleIcon: A6,
  Pyramid: C6,
  PyramidIcon: C6,
  QrCode: q6,
  QrCodeIcon: q6,
  Quote: z6,
  QuoteIcon: z6,
  Rabbit: P6,
  RabbitIcon: P6,
  Radar: _6,
  RadarIcon: _6,
  Radiation: j6,
  RadiationIcon: j6,
  Radical: H6,
  RadicalIcon: H6,
  Radio: D6,
  RadioIcon: D6,
  RadioReceiver: V6,
  RadioReceiverIcon: V6,
  RadioTower: B6,
  RadioTowerIcon: B6,
  Radius: T6,
  RadiusIcon: T6,
  RailSymbol: $6,
  RailSymbolIcon: $6,
  Rainbow: O6,
  RainbowIcon: O6,
  Rat: R6,
  RatIcon: R6,
  Ratio: F6,
  RatioIcon: F6,
  Receipt: X6,
  ReceiptCent: E6,
  ReceiptCentIcon: E6,
  ReceiptEuro: U6,
  ReceiptEuroIcon: U6,
  ReceiptIcon: X6,
  ReceiptIndianRupee: N6,
  ReceiptIndianRupeeIcon: N6,
  ReceiptJapaneseYen: W6,
  ReceiptJapaneseYenIcon: W6,
  ReceiptPoundSterling: G6,
  ReceiptPoundSterlingIcon: G6,
  ReceiptRussianRuble: Z6,
  ReceiptRussianRubleIcon: Z6,
  ReceiptSwissFranc: Y6,
  ReceiptSwissFrancIcon: Y6,
  ReceiptText: K6,
  ReceiptTextIcon: K6,
  RectangleEllipsis: gn,
  RectangleEllipsisIcon: gn,
  RectangleHorizontal: Q6,
  RectangleHorizontalIcon: Q6,
  RectangleVertical: J6,
  RectangleVerticalIcon: J6,
  Recycle: e8,
  RecycleIcon: e8,
  Redo: n8,
  Redo2: t8,
  Redo2Icon: t8,
  RedoDot: a8,
  RedoDotIcon: a8,
  RedoIcon: n8,
  RefreshCcw: r8,
  RefreshCcwDot: o8,
  RefreshCcwDotIcon: o8,
  RefreshCcwIcon: r8,
  RefreshCw: i8,
  RefreshCwIcon: i8,
  RefreshCwOff: l8,
  RefreshCwOffIcon: l8,
  Refrigerator: c8,
  RefrigeratorIcon: c8,
  Regex: d8,
  RegexIcon: d8,
  RemoveFormatting: s8,
  RemoveFormattingIcon: s8,
  Repeat: p8,
  Repeat1: u8,
  Repeat1Icon: u8,
  Repeat2: h8,
  Repeat2Icon: h8,
  RepeatIcon: p8,
  Replace: k8,
  ReplaceAll: y8,
  ReplaceAllIcon: y8,
  ReplaceIcon: k8,
  Reply: f8,
  ReplyAll: m8,
  ReplyAllIcon: m8,
  ReplyIcon: f8,
  Rewind: v8,
  RewindIcon: v8,
  Ribbon: g8,
  RibbonIcon: g8,
  Rocket: M8,
  RocketIcon: M8,
  RockingChair: b8,
  RockingChairIcon: b8,
  RollerCoaster: x8,
  RollerCoasterIcon: x8,
  Rotate3D: Mn,
  Rotate3DIcon: Mn,
  Rotate3d: Mn,
  Rotate3dIcon: Mn,
  RotateCcw: L8,
  RotateCcwIcon: L8,
  RotateCcwSquare: w8,
  RotateCcwSquareIcon: w8,
  RotateCw: I8,
  RotateCwIcon: I8,
  RotateCwSquare: S8,
  RotateCwSquareIcon: S8,
  Route: A8,
  RouteIcon: A8,
  RouteOff: C8,
  RouteOffIcon: C8,
  Router: q8,
  RouterIcon: q8,
  Rows: bn,
  Rows2: bn,
  Rows2Icon: bn,
  Rows3: xn,
  Rows3Icon: xn,
  Rows4: z8,
  Rows4Icon: z8,
  RowsIcon: bn,
  Rss: P8,
  RssIcon: P8,
  Ruler: _8,
  RulerIcon: _8,
  RussianRuble: j8,
  RussianRubleIcon: j8,
  Sailboat: H8,
  SailboatIcon: H8,
  Salad: V8,
  SaladIcon: V8,
  Sandwich: B8,
  SandwichIcon: B8,
  Satellite: T8,
  SatelliteDish: D8,
  SatelliteDishIcon: D8,
  SatelliteIcon: T8,
  SaudiRiyal: $8,
  SaudiRiyalIcon: $8,
  Save: F8,
  SaveAll: O8,
  SaveAllIcon: O8,
  SaveIcon: F8,
  SaveOff: R8,
  SaveOffIcon: R8,
  Scale: E8,
  Scale3D: wn,
  Scale3DIcon: wn,
  Scale3d: wn,
  Scale3dIcon: wn,
  ScaleIcon: E8,
  Scaling: U8,
  ScalingIcon: U8,
  Scan: J8,
  ScanBarcode: N8,
  ScanBarcodeIcon: N8,
  ScanEye: W8,
  ScanEyeIcon: W8,
  ScanFace: G8,
  ScanFaceIcon: G8,
  ScanHeart: Z8,
  ScanHeartIcon: Z8,
  ScanIcon: J8,
  ScanLine: Y8,
  ScanLineIcon: Y8,
  ScanQrCode: K8,
  ScanQrCodeIcon: K8,
  ScanSearch: Q8,
  ScanSearchIcon: Q8,
  ScanText: X8,
  ScanTextIcon: X8,
  ScatterChart: Da,
  ScatterChartIcon: Da,
  School: eg,
  School2: jo,
  School2Icon: jo,
  SchoolIcon: eg,
  Scissors: ag,
  ScissorsIcon: ag,
  ScissorsLineDashed: tg,
  ScissorsLineDashedIcon: tg,
  ScissorsSquare: vo,
  ScissorsSquareDashedBottom: Fn,
  ScissorsSquareDashedBottomIcon: Fn,
  ScissorsSquareIcon: vo,
  ScreenShare: og,
  ScreenShareIcon: og,
  ScreenShareOff: ng,
  ScreenShareOffIcon: ng,
  Scroll: lg,
  ScrollIcon: lg,
  ScrollText: rg,
  ScrollTextIcon: rg,
  Search: ug,
  SearchCheck: ig,
  SearchCheckIcon: ig,
  SearchCode: cg,
  SearchCodeIcon: cg,
  SearchIcon: ug,
  SearchSlash: dg,
  SearchSlashIcon: dg,
  SearchX: sg,
  SearchXIcon: sg,
  Section: hg,
  SectionIcon: hg,
  Send: yg,
  SendHorizonal: Ln,
  SendHorizonalIcon: Ln,
  SendHorizontal: Ln,
  SendHorizontalIcon: Ln,
  SendIcon: yg,
  SendToBack: pg,
  SendToBackIcon: pg,
  SeparatorHorizontal: kg,
  SeparatorHorizontalIcon: kg,
  SeparatorVertical: mg,
  SeparatorVerticalIcon: mg,
  Server: Mg,
  ServerCog: fg,
  ServerCogIcon: fg,
  ServerCrash: vg,
  ServerCrashIcon: vg,
  ServerIcon: Mg,
  ServerOff: gg,
  ServerOffIcon: gg,
  Settings: xg,
  Settings2: bg,
  Settings2Icon: bg,
  SettingsIcon: xg,
  Shapes: wg,
  ShapesIcon: wg,
  Share: Sg,
  Share2: Lg,
  Share2Icon: Lg,
  ShareIcon: Sg,
  Sheet: Ig,
  SheetIcon: Ig,
  Shell: Cg,
  ShellIcon: Cg,
  Shield: Tg,
  ShieldAlert: Ag,
  ShieldAlertIcon: Ag,
  ShieldBan: qg,
  ShieldBanIcon: qg,
  ShieldCheck: zg,
  ShieldCheckIcon: zg,
  ShieldClose: Sn,
  ShieldCloseIcon: Sn,
  ShieldEllipsis: Pg,
  ShieldEllipsisIcon: Pg,
  ShieldHalf: _g,
  ShieldHalfIcon: _g,
  ShieldIcon: Tg,
  ShieldMinus: jg,
  ShieldMinusIcon: jg,
  ShieldOff: Hg,
  ShieldOffIcon: Hg,
  ShieldPlus: Vg,
  ShieldPlusIcon: Vg,
  ShieldQuestion: Bg,
  ShieldQuestionIcon: Bg,
  ShieldUser: Dg,
  ShieldUserIcon: Dg,
  ShieldX: Sn,
  ShieldXIcon: Sn,
  Ship: Og,
  ShipIcon: Og,
  ShipWheel: $g,
  ShipWheelIcon: $g,
  Shirt: Rg,
  ShirtIcon: Rg,
  ShoppingBag: Fg,
  ShoppingBagIcon: Fg,
  ShoppingBasket: Eg,
  ShoppingBasketIcon: Eg,
  ShoppingCart: Ug,
  ShoppingCartIcon: Ug,
  Shovel: Ng,
  ShovelIcon: Ng,
  ShowerHead: Wg,
  ShowerHeadIcon: Wg,
  Shrimp: Gg,
  ShrimpIcon: Gg,
  Shrink: Yg,
  ShrinkIcon: Yg,
  Shrub: Zg,
  ShrubIcon: Zg,
  Shuffle: Kg,
  ShuffleIcon: Kg,
  Sidebar: hn,
  SidebarClose: dn,
  SidebarCloseIcon: dn,
  SidebarIcon: hn,
  SidebarOpen: un,
  SidebarOpenIcon: un,
  Sigma: Xg,
  SigmaIcon: Xg,
  SigmaSquare: go,
  SigmaSquareIcon: go,
  Signal: a7,
  SignalHigh: Qg,
  SignalHighIcon: Qg,
  SignalIcon: a7,
  SignalLow: Jg,
  SignalLowIcon: Jg,
  SignalMedium: e7,
  SignalMediumIcon: e7,
  SignalZero: t7,
  SignalZeroIcon: t7,
  Signature: n7,
  SignatureIcon: n7,
  Signpost: r7,
  SignpostBig: o7,
  SignpostBigIcon: o7,
  SignpostIcon: r7,
  Siren: l7,
  SirenIcon: l7,
  SkipBack: i7,
  SkipBackIcon: i7,
  SkipForward: c7,
  SkipForwardIcon: c7,
  Skull: d7,
  SkullIcon: d7,
  Slack: s7,
  SlackIcon: s7,
  Slash: u7,
  SlashIcon: u7,
  SlashSquare: Mo,
  SlashSquareIcon: Mo,
  Slice: h7,
  SliceIcon: h7,
  Sliders: In,
  SlidersHorizontal: p7,
  SlidersHorizontalIcon: p7,
  SlidersIcon: In,
  SlidersVertical: In,
  SlidersVerticalIcon: In,
  Smartphone: m7,
  SmartphoneCharging: y7,
  SmartphoneChargingIcon: y7,
  SmartphoneIcon: m7,
  SmartphoneNfc: k7,
  SmartphoneNfcIcon: k7,
  Smile: v7,
  SmileIcon: v7,
  SmilePlus: f7,
  SmilePlusIcon: f7,
  Snail: g7,
  SnailIcon: g7,
  Snowflake: M7,
  SnowflakeIcon: M7,
  Sofa: b7,
  SofaIcon: b7,
  SortAsc: ma,
  SortAscIcon: ma,
  SortDesc: pa,
  SortDescIcon: pa,
  Soup: x7,
  SoupIcon: x7,
  Space: w7,
  SpaceIcon: w7,
  Spade: L7,
  SpadeIcon: L7,
  Sparkle: S7,
  SparkleIcon: S7,
  Sparkles: Cn,
  SparklesIcon: Cn,
  Speaker: I7,
  SpeakerIcon: I7,
  Speech: C7,
  SpeechIcon: C7,
  SpellCheck: q7,
  SpellCheck2: A7,
  SpellCheck2Icon: A7,
  SpellCheckIcon: q7,
  Spline: P7,
  SplineIcon: P7,
  SplinePointer: z7,
  SplinePointerIcon: z7,
  Split: _7,
  SplitIcon: _7,
  SplitSquareHorizontal: bo,
  SplitSquareHorizontalIcon: bo,
  SplitSquareVertical: xo,
  SplitSquareVerticalIcon: xo,
  SprayCan: j7,
  SprayCanIcon: j7,
  Sprout: H7,
  SproutIcon: H7,
  Square: R7,
  SquareActivity: An,
  SquareActivityIcon: An,
  SquareArrowDown: Pn,
  SquareArrowDownIcon: Pn,
  SquareArrowDownLeft: qn,
  SquareArrowDownLeftIcon: qn,
  SquareArrowDownRight: zn,
  SquareArrowDownRightIcon: zn,
  SquareArrowLeft: _n,
  SquareArrowLeftIcon: _n,
  SquareArrowOutDownLeft: jn,
  SquareArrowOutDownLeftIcon: jn,
  SquareArrowOutDownRight: Hn,
  SquareArrowOutDownRightIcon: Hn,
  SquareArrowOutUpLeft: Vn,
  SquareArrowOutUpLeftIcon: Vn,
  SquareArrowOutUpRight: Bn,
  SquareArrowOutUpRightIcon: Bn,
  SquareArrowRight: Dn,
  SquareArrowRightIcon: Dn,
  SquareArrowUp: On,
  SquareArrowUpIcon: On,
  SquareArrowUpLeft: Tn,
  SquareArrowUpLeftIcon: Tn,
  SquareArrowUpRight: $n,
  SquareArrowUpRightIcon: $n,
  SquareAsterisk: Rn,
  SquareAsteriskIcon: Rn,
  SquareBottomDashedScissors: Fn,
  SquareBottomDashedScissorsIcon: Fn,
  SquareChartGantt: Bt,
  SquareChartGanttIcon: Bt,
  SquareCheck: Un,
  SquareCheckBig: En,
  SquareCheckBigIcon: En,
  SquareCheckIcon: Un,
  SquareChevronDown: Nn,
  SquareChevronDownIcon: Nn,
  SquareChevronLeft: Wn,
  SquareChevronLeftIcon: Wn,
  SquareChevronRight: Gn,
  SquareChevronRightIcon: Gn,
  SquareChevronUp: Zn,
  SquareChevronUpIcon: Zn,
  SquareCode: Yn,
  SquareCodeIcon: Yn,
  SquareDashed: Qn,
  SquareDashedBottom: B7,
  SquareDashedBottomCode: V7,
  SquareDashedBottomCodeIcon: V7,
  SquareDashedBottomIcon: B7,
  SquareDashedIcon: Qn,
  SquareDashedKanban: Kn,
  SquareDashedKanbanIcon: Kn,
  SquareDashedMousePointer: Xn,
  SquareDashedMousePointerIcon: Xn,
  SquareDivide: eo,
  SquareDivideIcon: eo,
  SquareDot: Jn,
  SquareDotIcon: Jn,
  SquareEqual: to,
  SquareEqualIcon: to,
  SquareFunction: ao,
  SquareFunctionIcon: ao,
  SquareGanttChart: Bt,
  SquareGanttChartIcon: Bt,
  SquareIcon: R7,
  SquareKanban: no,
  SquareKanbanIcon: no,
  SquareLibrary: oo,
  SquareLibraryIcon: oo,
  SquareM: ro,
  SquareMIcon: ro,
  SquareMenu: lo,
  SquareMenuIcon: lo,
  SquareMinus: io,
  SquareMinusIcon: io,
  SquareMousePointer: co,
  SquareMousePointerIcon: co,
  SquareParking: uo,
  SquareParkingIcon: uo,
  SquareParkingOff: so,
  SquareParkingOffIcon: so,
  SquarePen: xt,
  SquarePenIcon: xt,
  SquarePercent: ho,
  SquarePercentIcon: ho,
  SquarePi: po,
  SquarePiIcon: po,
  SquarePilcrow: yo,
  SquarePilcrowIcon: yo,
  SquarePlay: ko,
  SquarePlayIcon: ko,
  SquarePlus: mo,
  SquarePlusIcon: mo,
  SquarePower: fo,
  SquarePowerIcon: fo,
  SquareRadical: D7,
  SquareRadicalIcon: D7,
  SquareRoundCorner: T7,
  SquareRoundCornerIcon: T7,
  SquareScissors: vo,
  SquareScissorsIcon: vo,
  SquareSigma: go,
  SquareSigmaIcon: go,
  SquareSlash: Mo,
  SquareSlashIcon: Mo,
  SquareSplitHorizontal: bo,
  SquareSplitHorizontalIcon: bo,
  SquareSplitVertical: xo,
  SquareSplitVerticalIcon: xo,
  SquareSquare: $7,
  SquareSquareIcon: $7,
  SquareStack: O7,
  SquareStackIcon: O7,
  SquareTerminal: wo,
  SquareTerminalIcon: wo,
  SquareUser: So,
  SquareUserIcon: So,
  SquareUserRound: Lo,
  SquareUserRoundIcon: Lo,
  SquareX: Io,
  SquareXIcon: Io,
  Squircle: F7,
  SquircleIcon: F7,
  Squirrel: E7,
  SquirrelIcon: E7,
  Stamp: U7,
  StampIcon: U7,
  Star: G7,
  StarHalf: N7,
  StarHalfIcon: N7,
  StarIcon: G7,
  StarOff: W7,
  StarOffIcon: W7,
  Stars: Cn,
  StarsIcon: Cn,
  StepBack: Z7,
  StepBackIcon: Z7,
  StepForward: Y7,
  StepForwardIcon: Y7,
  Stethoscope: K7,
  StethoscopeIcon: K7,
  Sticker: X7,
  StickerIcon: X7,
  StickyNote: Q7,
  StickyNoteIcon: Q7,
  StopCircle: u1,
  StopCircleIcon: u1,
  Store: J7,
  StoreIcon: J7,
  StretchHorizontal: eM,
  StretchHorizontalIcon: eM,
  StretchVertical: tM,
  StretchVerticalIcon: tM,
  Strikethrough: aM,
  StrikethroughIcon: aM,
  Subscript: nM,
  SubscriptIcon: nM,
  Subtitles: La,
  SubtitlesIcon: La,
  Sun: cM,
  SunDim: oM,
  SunDimIcon: oM,
  SunIcon: cM,
  SunMedium: rM,
  SunMediumIcon: rM,
  SunMoon: lM,
  SunMoonIcon: lM,
  SunSnow: iM,
  SunSnowIcon: iM,
  Sunrise: dM,
  SunriseIcon: dM,
  Sunset: sM,
  SunsetIcon: sM,
  Superscript: uM,
  SuperscriptIcon: uM,
  SwatchBook: hM,
  SwatchBookIcon: hM,
  SwissFranc: pM,
  SwissFrancIcon: pM,
  SwitchCamera: yM,
  SwitchCameraIcon: yM,
  Sword: kM,
  SwordIcon: kM,
  Swords: mM,
  SwordsIcon: mM,
  Syringe: fM,
  SyringeIcon: fM,
  Table: SM,
  Table2: vM,
  Table2Icon: vM,
  TableCellsMerge: gM,
  TableCellsMergeIcon: gM,
  TableCellsSplit: MM,
  TableCellsSplitIcon: MM,
  TableColumnsSplit: bM,
  TableColumnsSplitIcon: bM,
  TableIcon: SM,
  TableOfContents: xM,
  TableOfContentsIcon: xM,
  TableProperties: wM,
  TablePropertiesIcon: wM,
  TableRowsSplit: LM,
  TableRowsSplitIcon: LM,
  Tablet: CM,
  TabletIcon: CM,
  TabletSmartphone: IM,
  TabletSmartphoneIcon: IM,
  Tablets: AM,
  TabletsIcon: AM,
  Tag: PM,
  TagIcon: PM,
  Tags: qM,
  TagsIcon: qM,
  Tally1: zM,
  Tally1Icon: zM,
  Tally2: _M,
  Tally2Icon: _M,
  Tally3: jM,
  Tally3Icon: jM,
  Tally4: HM,
  Tally4Icon: HM,
  Tally5: VM,
  Tally5Icon: VM,
  Tangent: BM,
  TangentIcon: BM,
  Target: DM,
  TargetIcon: DM,
  Telescope: TM,
  TelescopeIcon: TM,
  Tent: OM,
  TentIcon: OM,
  TentTree: $M,
  TentTreeIcon: $M,
  Terminal: RM,
  TerminalIcon: RM,
  TerminalSquare: wo,
  TerminalSquareIcon: wo,
  TestTube: FM,
  TestTube2: Co,
  TestTube2Icon: Co,
  TestTubeDiagonal: Co,
  TestTubeDiagonalIcon: Co,
  TestTubeIcon: FM,
  TestTubes: EM,
  TestTubesIcon: EM,
  Text: ZM,
  TextCursor: NM,
  TextCursorIcon: NM,
  TextCursorInput: UM,
  TextCursorInputIcon: UM,
  TextIcon: ZM,
  TextQuote: WM,
  TextQuoteIcon: WM,
  TextSearch: GM,
  TextSearchIcon: GM,
  TextSelect: Ao,
  TextSelectIcon: Ao,
  TextSelection: Ao,
  TextSelectionIcon: Ao,
  Theater: YM,
  TheaterIcon: YM,
  Thermometer: QM,
  ThermometerIcon: QM,
  ThermometerSnowflake: KM,
  ThermometerSnowflakeIcon: KM,
  ThermometerSun: XM,
  ThermometerSunIcon: XM,
  ThumbsDown: JM,
  ThumbsDownIcon: JM,
  ThumbsUp: e9,
  ThumbsUpIcon: e9,
  Ticket: i9,
  TicketCheck: t9,
  TicketCheckIcon: t9,
  TicketIcon: i9,
  TicketMinus: a9,
  TicketMinusIcon: a9,
  TicketPercent: n9,
  TicketPercentIcon: n9,
  TicketPlus: o9,
  TicketPlusIcon: o9,
  TicketSlash: r9,
  TicketSlashIcon: r9,
  TicketX: l9,
  TicketXIcon: l9,
  Tickets: d9,
  TicketsIcon: d9,
  TicketsPlane: c9,
  TicketsPlaneIcon: c9,
  Timer: h9,
  TimerIcon: h9,
  TimerOff: s9,
  TimerOffIcon: s9,
  TimerReset: u9,
  TimerResetIcon: u9,
  ToggleLeft: p9,
  ToggleLeftIcon: p9,
  ToggleRight: y9,
  ToggleRightIcon: y9,
  Toilet: k9,
  ToiletIcon: k9,
  Tornado: m9,
  TornadoIcon: m9,
  Torus: f9,
  TorusIcon: f9,
  Touchpad: g9,
  TouchpadIcon: g9,
  TouchpadOff: v9,
  TouchpadOffIcon: v9,
  TowerControl: M9,
  TowerControlIcon: M9,
  ToyBrick: b9,
  ToyBrickIcon: b9,
  Tractor: x9,
  TractorIcon: x9,
  TrafficCone: w9,
  TrafficConeIcon: w9,
  Train: qo,
  TrainFront: S9,
  TrainFrontIcon: S9,
  TrainFrontTunnel: L9,
  TrainFrontTunnelIcon: L9,
  TrainIcon: qo,
  TrainTrack: I9,
  TrainTrackIcon: I9,
  TramFront: qo,
  TramFrontIcon: qo,
  Transgender: A9,
  TransgenderIcon: A9,
  Trash: q9,
  Trash2: C9,
  Trash2Icon: C9,
  TrashIcon: q9,
  TreeDeciduous: z9,
  TreeDeciduousIcon: z9,
  TreePalm: zo,
  TreePalmIcon: zo,
  TreePine: P9,
  TreePineIcon: P9,
  Trees: _9,
  TreesIcon: _9,
  Trello: j9,
  TrelloIcon: j9,
  TrendingDown: H9,
  TrendingDownIcon: H9,
  TrendingUp: B9,
  TrendingUpDown: V9,
  TrendingUpDownIcon: V9,
  TrendingUpIcon: B9,
  Triangle: $9,
  TriangleAlert: Po,
  TriangleAlertIcon: Po,
  TriangleDashed: D9,
  TriangleDashedIcon: D9,
  TriangleIcon: $9,
  TriangleRight: T9,
  TriangleRightIcon: T9,
  Trophy: O9,
  TrophyIcon: O9,
  Truck: R9,
  TruckIcon: R9,
  Turtle: F9,
  TurtleIcon: F9,
  Tv: U9,
  Tv2: _o,
  Tv2Icon: _o,
  TvIcon: U9,
  TvMinimal: _o,
  TvMinimalIcon: _o,
  TvMinimalPlay: E9,
  TvMinimalPlayIcon: E9,
  Twitch: N9,
  TwitchIcon: N9,
  Twitter: W9,
  TwitterIcon: W9,
  Type: Z9,
  TypeIcon: Z9,
  TypeOutline: G9,
  TypeOutlineIcon: G9,
  Umbrella: K9,
  UmbrellaIcon: K9,
  UmbrellaOff: Y9,
  UmbrellaOffIcon: Y9,
  Underline: X9,
  UnderlineIcon: X9,
  Undo: eb,
  Undo2: Q9,
  Undo2Icon: Q9,
  UndoDot: J9,
  UndoDotIcon: J9,
  UndoIcon: eb,
  UnfoldHorizontal: tb,
  UnfoldHorizontalIcon: tb,
  UnfoldVertical: ab,
  UnfoldVerticalIcon: ab,
  Ungroup: nb,
  UngroupIcon: nb,
  University: jo,
  UniversityIcon: jo,
  Unlink: rb,
  Unlink2: ob,
  Unlink2Icon: ob,
  UnlinkIcon: rb,
  Unlock: en,
  UnlockIcon: en,
  UnlockKeyhole: J1,
  UnlockKeyholeIcon: J1,
  Unplug: lb,
  UnplugIcon: lb,
  Upload: ib,
  UploadCloud: v1,
  UploadCloudIcon: v1,
  UploadIcon: ib,
  Usb: cb,
  UsbIcon: cb,
  User: vb,
  User2: $o,
  User2Icon: $o,
  UserCheck: db,
  UserCheck2: Ho,
  UserCheck2Icon: Ho,
  UserCheckIcon: db,
  UserCircle: p1,
  UserCircle2: h1,
  UserCircle2Icon: h1,
  UserCircleIcon: p1,
  UserCog: sb,
  UserCog2: Vo,
  UserCog2Icon: Vo,
  UserCogIcon: sb,
  UserIcon: vb,
  UserMinus: ub,
  UserMinus2: Bo,
  UserMinus2Icon: Bo,
  UserMinusIcon: ub,
  UserPen: hb,
  UserPenIcon: hb,
  UserPlus: pb,
  UserPlus2: Do,
  UserPlus2Icon: Do,
  UserPlusIcon: pb,
  UserRound: $o,
  UserRoundCheck: Ho,
  UserRoundCheckIcon: Ho,
  UserRoundCog: Vo,
  UserRoundCogIcon: Vo,
  UserRoundIcon: $o,
  UserRoundMinus: Bo,
  UserRoundMinusIcon: Bo,
  UserRoundPen: yb,
  UserRoundPenIcon: yb,
  UserRoundPlus: Do,
  UserRoundPlusIcon: Do,
  UserRoundSearch: kb,
  UserRoundSearchIcon: kb,
  UserRoundX: To,
  UserRoundXIcon: To,
  UserSearch: mb,
  UserSearchIcon: mb,
  UserSquare: So,
  UserSquare2: Lo,
  UserSquare2Icon: Lo,
  UserSquareIcon: So,
  UserX: fb,
  UserX2: To,
  UserX2Icon: To,
  UserXIcon: fb,
  Users: gb,
  Users2: Oo,
  Users2Icon: Oo,
  UsersIcon: gb,
  UsersRound: Oo,
  UsersRoundIcon: Oo,
  Utensils: Fo,
  UtensilsCrossed: Ro,
  UtensilsCrossedIcon: Ro,
  UtensilsIcon: Fo,
  UtilityPole: Mb,
  UtilityPoleIcon: Mb,
  Variable: bb,
  VariableIcon: bb,
  Vault: xb,
  VaultIcon: xb,
  Vegan: wb,
  VeganIcon: wb,
  VenetianMask: Lb,
  VenetianMaskIcon: Lb,
  Venus: Ib,
  VenusAndMars: Sb,
  VenusAndMarsIcon: Sb,
  VenusIcon: Ib,
  Verified: ga,
  VerifiedIcon: ga,
  Vibrate: Cb,
  VibrateIcon: Cb,
  VibrateOff: Ab,
  VibrateOffIcon: Ab,
  Video: zb,
  VideoIcon: zb,
  VideoOff: qb,
  VideoOffIcon: qb,
  Videotape: Pb,
  VideotapeIcon: Pb,
  View: _b,
  ViewIcon: _b,
  Voicemail: Hb,
  VoicemailIcon: Hb,
  Volleyball: jb,
  VolleyballIcon: jb,
  Volume: $b,
  Volume1: Vb,
  Volume1Icon: Vb,
  Volume2: Bb,
  Volume2Icon: Bb,
  VolumeIcon: $b,
  VolumeOff: Db,
  VolumeOffIcon: Db,
  VolumeX: Tb,
  VolumeXIcon: Tb,
  Vote: Ob,
  VoteIcon: Ob,
  Wallet: Fb,
  Wallet2: Eo,
  Wallet2Icon: Eo,
  WalletCards: Rb,
  WalletCardsIcon: Rb,
  WalletIcon: Fb,
  WalletMinimal: Eo,
  WalletMinimalIcon: Eo,
  Wallpaper: Eb,
  WallpaperIcon: Eb,
  Wand: Ub,
  Wand2: Uo,
  Wand2Icon: Uo,
  WandIcon: Ub,
  WandSparkles: Uo,
  WandSparklesIcon: Uo,
  Warehouse: Nb,
  WarehouseIcon: Nb,
  WashingMachine: Wb,
  WashingMachineIcon: Wb,
  Watch: Gb,
  WatchIcon: Gb,
  Waves: Yb,
  WavesIcon: Yb,
  WavesLadder: Zb,
  WavesLadderIcon: Zb,
  Waypoints: Kb,
  WaypointsIcon: Kb,
  Webcam: Xb,
  WebcamIcon: Xb,
  Webhook: Jb,
  WebhookIcon: Jb,
  WebhookOff: Qb,
  WebhookOffIcon: Qb,
  Weight: ex,
  WeightIcon: ex,
  Wheat: ax,
  WheatIcon: ax,
  WheatOff: tx,
  WheatOffIcon: tx,
  WholeWord: nx,
  WholeWordIcon: nx,
  Wifi: cx,
  WifiHigh: ox,
  WifiHighIcon: ox,
  WifiIcon: cx,
  WifiLow: rx,
  WifiLowIcon: rx,
  WifiOff: lx,
  WifiOffIcon: lx,
  WifiZero: ix,
  WifiZeroIcon: ix,
  Wind: sx,
  WindArrowDown: dx,
  WindArrowDownIcon: dx,
  WindIcon: sx,
  Wine: hx,
  WineIcon: hx,
  WineOff: ux,
  WineOffIcon: ux,
  Workflow: px,
  WorkflowIcon: px,
  Worm: yx,
  WormIcon: yx,
  WrapText: kx,
  WrapTextIcon: kx,
  Wrench: mx,
  WrenchIcon: mx,
  X: fx,
  XCircle: y1,
  XCircleIcon: y1,
  XIcon: fx,
  XOctagon: rn,
  XOctagonIcon: rn,
  XSquare: Io,
  XSquareIcon: Io,
  Youtube: vx,
  YoutubeIcon: vx,
  Zap: Mx,
  ZapIcon: Mx,
  ZapOff: gx,
  ZapOffIcon: gx,
  ZoomIn: bx,
  ZoomInIcon: bx,
  ZoomOut: xx,
  ZoomOutIcon: xx,
  createLucideIcon: n,
  icons: tA
}, Symbol.toStringTag, { value: "Module" }));
var el = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Vx(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function aA() {
  this.__data__ = [], this.size = 0;
}
var nA = aA;
function oA(e, a) {
  return e === a || e !== e && a !== a;
}
var Er = oA, rA = Er;
function lA(e, a) {
  for (var t = e.length; t--; )
    if (rA(e[t][0], a))
      return t;
  return -1;
}
var Bx = lA, iA = Bx, cA = Array.prototype, dA = cA.splice;
function sA(e) {
  var a = this.__data__, t = iA(a, e);
  if (t < 0)
    return !1;
  var o = a.length - 1;
  return t == o ? a.pop() : dA.call(a, t, 1), --this.size, !0;
}
var uA = sA, hA = Bx;
function pA(e) {
  var a = this.__data__, t = hA(a, e);
  return t < 0 ? void 0 : a[t][1];
}
var yA = pA, kA = Bx;
function mA(e) {
  return kA(this.__data__, e) > -1;
}
var fA = mA, vA = Bx;
function gA(e, a) {
  var t = this.__data__, o = vA(t, e);
  return o < 0 ? (++this.size, t.push([e, a])) : t[o][1] = a, this;
}
var MA = gA, bA = nA, xA = uA, wA = yA, LA = fA, SA = MA;
function fr(e) {
  var a = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++a < t; ) {
    var o = e[a];
    this.set(o[0], o[1]);
  }
}
fr.prototype.clear = bA;
fr.prototype.delete = xA;
fr.prototype.get = wA;
fr.prototype.has = LA;
fr.prototype.set = SA;
var Dx = fr, IA = Dx;
function CA() {
  this.__data__ = new IA(), this.size = 0;
}
var AA = CA;
function qA(e) {
  var a = this.__data__, t = a.delete(e);
  return this.size = a.size, t;
}
var zA = qA;
function PA(e) {
  return this.__data__.get(e);
}
var _A = PA;
function jA(e) {
  return this.__data__.has(e);
}
var HA = jA, VA = typeof el == "object" && el && el.Object === Object && el, lI = VA, BA = lI, DA = typeof self == "object" && self && self.Object === Object && self, TA = BA || DA || Function("return this")(), Et = TA, $A = Et, OA = $A.Symbol, Ur = OA, PL = Ur, iI = Object.prototype, RA = iI.hasOwnProperty, FA = iI.toString, Ar = PL ? PL.toStringTag : void 0;
function EA(e) {
  var a = RA.call(e, Ar), t = e[Ar];
  try {
    e[Ar] = void 0;
    var o = !0;
  } catch {
  }
  var r = FA.call(e);
  return o && (a ? e[Ar] = t : delete e[Ar]), r;
}
var UA = EA, NA = Object.prototype, WA = NA.toString;
function GA(e) {
  return WA.call(e);
}
var ZA = GA, _L = Ur, YA = UA, KA = ZA, XA = "[object Null]", QA = "[object Undefined]", jL = _L ? _L.toStringTag : void 0;
function JA(e) {
  return e == null ? e === void 0 ? QA : XA : jL && jL in Object(e) ? YA(e) : KA(e);
}
var vr = JA;
function eq(e) {
  var a = typeof e;
  return e != null && (a == "object" || a == "function");
}
var Ut = eq, tq = vr, aq = Ut, nq = "[object AsyncFunction]", oq = "[object Function]", rq = "[object GeneratorFunction]", lq = "[object Proxy]";
function iq(e) {
  if (!aq(e))
    return !1;
  var a = tq(e);
  return a == oq || a == rq || a == nq || a == lq;
}
var Ew = iq, cq = Et, dq = cq["__core-js_shared__"], sq = dq, sw = sq, HL = function() {
  var e = /[^.]+$/.exec(sw && sw.keys && sw.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function uq(e) {
  return !!HL && HL in e;
}
var hq = uq, pq = Function.prototype, yq = pq.toString;
function kq(e) {
  if (e != null) {
    try {
      return yq.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var cI = kq, mq = Ew, fq = hq, vq = Ut, gq = cI, Mq = /[\\^$.*+?()[\]{}|]/g, bq = /^\[object .+?Constructor\]$/, xq = Function.prototype, wq = Object.prototype, Lq = xq.toString, Sq = wq.hasOwnProperty, Iq = RegExp(
  "^" + Lq.call(Sq).replace(Mq, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Cq(e) {
  if (!vq(e) || fq(e))
    return !1;
  var a = mq(e) ? Iq : bq;
  return a.test(gq(e));
}
var Aq = Cq;
function qq(e, a) {
  return e == null ? void 0 : e[a];
}
var zq = qq, Pq = Aq, _q = zq;
function jq(e, a) {
  var t = _q(e, a);
  return Pq(t) ? t : void 0;
}
var ar = jq, Hq = ar, Vq = Et, Bq = Hq(Vq, "Map"), Uw = Bq, Dq = ar, Tq = Dq(Object, "create"), Tx = Tq, VL = Tx;
function $q() {
  this.__data__ = VL ? VL(null) : {}, this.size = 0;
}
var Oq = $q;
function Rq(e) {
  var a = this.has(e) && delete this.__data__[e];
  return this.size -= a ? 1 : 0, a;
}
var Fq = Rq, Eq = Tx, Uq = "__lodash_hash_undefined__", Nq = Object.prototype, Wq = Nq.hasOwnProperty;
function Gq(e) {
  var a = this.__data__;
  if (Eq) {
    var t = a[e];
    return t === Uq ? void 0 : t;
  }
  return Wq.call(a, e) ? a[e] : void 0;
}
var Zq = Gq, Yq = Tx, Kq = Object.prototype, Xq = Kq.hasOwnProperty;
function Qq(e) {
  var a = this.__data__;
  return Yq ? a[e] !== void 0 : Xq.call(a, e);
}
var Jq = Qq, ez = Tx, tz = "__lodash_hash_undefined__";
function az(e, a) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = ez && a === void 0 ? tz : a, this;
}
var nz = az, oz = Oq, rz = Fq, lz = Zq, iz = Jq, cz = nz;
function gr(e) {
  var a = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++a < t; ) {
    var o = e[a];
    this.set(o[0], o[1]);
  }
}
gr.prototype.clear = oz;
gr.prototype.delete = rz;
gr.prototype.get = lz;
gr.prototype.has = iz;
gr.prototype.set = cz;
var dz = gr, BL = dz, sz = Dx, uz = Uw;
function hz() {
  this.size = 0, this.__data__ = {
    hash: new BL(),
    map: new (uz || sz)(),
    string: new BL()
  };
}
var pz = hz;
function yz(e) {
  var a = typeof e;
  return a == "string" || a == "number" || a == "symbol" || a == "boolean" ? e !== "__proto__" : e === null;
}
var kz = yz, mz = kz;
function fz(e, a) {
  var t = e.__data__;
  return mz(a) ? t[typeof a == "string" ? "string" : "hash"] : t.map;
}
var $x = fz, vz = $x;
function gz(e) {
  var a = vz(this, e).delete(e);
  return this.size -= a ? 1 : 0, a;
}
var Mz = gz, bz = $x;
function xz(e) {
  return bz(this, e).get(e);
}
var wz = xz, Lz = $x;
function Sz(e) {
  return Lz(this, e).has(e);
}
var Iz = Sz, Cz = $x;
function Az(e, a) {
  var t = Cz(this, e), o = t.size;
  return t.set(e, a), this.size += t.size == o ? 0 : 1, this;
}
var qz = Az, zz = pz, Pz = Mz, _z = wz, jz = Iz, Hz = qz;
function Mr(e) {
  var a = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++a < t; ) {
    var o = e[a];
    this.set(o[0], o[1]);
  }
}
Mr.prototype.clear = zz;
Mr.prototype.delete = Pz;
Mr.prototype.get = _z;
Mr.prototype.has = jz;
Mr.prototype.set = Hz;
var Nw = Mr, Vz = Dx, Bz = Uw, Dz = Nw, Tz = 200;
function $z(e, a) {
  var t = this.__data__;
  if (t instanceof Vz) {
    var o = t.__data__;
    if (!Bz || o.length < Tz - 1)
      return o.push([e, a]), this.size = ++t.size, this;
    t = this.__data__ = new Dz(o);
  }
  return t.set(e, a), this.size = t.size, this;
}
var Oz = $z, Rz = Dx, Fz = AA, Ez = zA, Uz = _A, Nz = HA, Wz = Oz;
function br(e) {
  var a = this.__data__ = new Rz(e);
  this.size = a.size;
}
br.prototype.clear = Fz;
br.prototype.delete = Ez;
br.prototype.get = Uz;
br.prototype.has = Nz;
br.prototype.set = Wz;
var Ox = br, Gz = ar, Zz = function() {
  try {
    var e = Gz(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), dI = Zz, DL = dI;
function Yz(e, a, t) {
  a == "__proto__" && DL ? DL(e, a, {
    configurable: !0,
    enumerable: !0,
    value: t,
    writable: !0
  }) : e[a] = t;
}
var Ww = Yz, Kz = Ww, Xz = Er;
function Qz(e, a, t) {
  (t !== void 0 && !Xz(e[a], t) || t === void 0 && !(a in e)) && Kz(e, a, t);
}
var sI = Qz;
function Jz(e) {
  return function(a, t, o) {
    for (var r = -1, l = Object(a), i = o(a), c = i.length; c--; ) {
      var u = i[e ? c : ++r];
      if (t(l[u], u, l) === !1)
        break;
    }
    return a;
  };
}
var eP = Jz, tP = eP, aP = tP(), uI = aP, Sx = { exports: {} };
Sx.exports;
(function(e, a) {
  var t = Et, o = a && !a.nodeType && a, r = o && !0 && e && !e.nodeType && e, l = r && r.exports === o, i = l ? t.Buffer : void 0, c = i ? i.allocUnsafe : void 0;
  function u(v, k) {
    if (k)
      return v.slice();
    var f = v.length, p = c ? c(f) : new v.constructor(f);
    return v.copy(p), p;
  }
  e.exports = u;
})(Sx, Sx.exports);
var hI = Sx.exports, nP = Et, oP = nP.Uint8Array, pI = oP, TL = pI;
function rP(e) {
  var a = new e.constructor(e.byteLength);
  return new TL(a).set(new TL(e)), a;
}
var Gw = rP, lP = Gw;
function iP(e, a) {
  var t = a ? lP(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.length);
}
var yI = iP;
function cP(e, a) {
  var t = -1, o = e.length;
  for (a || (a = Array(o)); ++t < o; )
    a[t] = e[t];
  return a;
}
var kI = cP, dP = Ut, $L = Object.create, sP = function() {
  function e() {
  }
  return function(a) {
    if (!dP(a))
      return {};
    if ($L)
      return $L(a);
    e.prototype = a;
    var t = new e();
    return e.prototype = void 0, t;
  };
}(), uP = sP;
function hP(e, a) {
  return function(t) {
    return e(a(t));
  };
}
var mI = hP, pP = mI, yP = pP(Object.getPrototypeOf, Object), Zw = yP, kP = Object.prototype;
function mP(e) {
  var a = e && e.constructor, t = typeof a == "function" && a.prototype || kP;
  return e === t;
}
var Yw = mP, fP = uP, vP = Zw, gP = Yw;
function MP(e) {
  return typeof e.constructor == "function" && !gP(e) ? fP(vP(e)) : {};
}
var fI = MP;
function bP(e) {
  return e != null && typeof e == "object";
}
var Yt = bP, xP = vr, wP = Yt, LP = "[object Arguments]";
function SP(e) {
  return wP(e) && xP(e) == LP;
}
var IP = SP, OL = IP, CP = Yt, vI = Object.prototype, AP = vI.hasOwnProperty, qP = vI.propertyIsEnumerable, zP = OL(function() {
  return arguments;
}()) ? OL : function(e) {
  return CP(e) && AP.call(e, "callee") && !qP.call(e, "callee");
}, Kw = zP, PP = Array.isArray, St = PP, _P = 9007199254740991;
function jP(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= _P;
}
var Xw = jP, HP = Ew, VP = Xw;
function BP(e) {
  return e != null && VP(e.length) && !HP(e);
}
var xr = BP, DP = xr, TP = Yt;
function $P(e) {
  return TP(e) && DP(e);
}
var OP = $P, Ix = { exports: {} };
function RP() {
  return !1;
}
var FP = RP;
Ix.exports;
(function(e, a) {
  var t = Et, o = FP, r = a && !a.nodeType && a, l = r && !0 && e && !e.nodeType && e, i = l && l.exports === r, c = i ? t.Buffer : void 0, u = c ? c.isBuffer : void 0, v = u || o;
  e.exports = v;
})(Ix, Ix.exports);
var Rx = Ix.exports, EP = vr, UP = Zw, NP = Yt, WP = "[object Object]", GP = Function.prototype, ZP = Object.prototype, gI = GP.toString, YP = ZP.hasOwnProperty, KP = gI.call(Object);
function XP(e) {
  if (!NP(e) || EP(e) != WP)
    return !1;
  var a = UP(e);
  if (a === null)
    return !0;
  var t = YP.call(a, "constructor") && a.constructor;
  return typeof t == "function" && t instanceof t && gI.call(t) == KP;
}
var QP = XP, JP = vr, e_ = Xw, t_ = Yt, a_ = "[object Arguments]", n_ = "[object Array]", o_ = "[object Boolean]", r_ = "[object Date]", l_ = "[object Error]", i_ = "[object Function]", c_ = "[object Map]", d_ = "[object Number]", s_ = "[object Object]", u_ = "[object RegExp]", h_ = "[object Set]", p_ = "[object String]", y_ = "[object WeakMap]", k_ = "[object ArrayBuffer]", m_ = "[object DataView]", f_ = "[object Float32Array]", v_ = "[object Float64Array]", g_ = "[object Int8Array]", M_ = "[object Int16Array]", b_ = "[object Int32Array]", x_ = "[object Uint8Array]", w_ = "[object Uint8ClampedArray]", L_ = "[object Uint16Array]", S_ = "[object Uint32Array]", Ne = {};
Ne[f_] = Ne[v_] = Ne[g_] = Ne[M_] = Ne[b_] = Ne[x_] = Ne[w_] = Ne[L_] = Ne[S_] = !0;
Ne[a_] = Ne[n_] = Ne[k_] = Ne[o_] = Ne[m_] = Ne[r_] = Ne[l_] = Ne[i_] = Ne[c_] = Ne[d_] = Ne[s_] = Ne[u_] = Ne[h_] = Ne[p_] = Ne[y_] = !1;
function I_(e) {
  return t_(e) && e_(e.length) && !!Ne[JP(e)];
}
var C_ = I_;
function A_(e) {
  return function(a) {
    return e(a);
  };
}
var Fx = A_, Cx = { exports: {} };
Cx.exports;
(function(e, a) {
  var t = lI, o = a && !a.nodeType && a, r = o && !0 && e && !e.nodeType && e, l = r && r.exports === o, i = l && t.process, c = function() {
    try {
      var u = r && r.require && r.require("util").types;
      return u || i && i.binding && i.binding("util");
    } catch {
    }
  }();
  e.exports = c;
})(Cx, Cx.exports);
var Qw = Cx.exports, q_ = C_, z_ = Fx, RL = Qw, FL = RL && RL.isTypedArray, P_ = FL ? z_(FL) : q_, Jw = P_;
function __(e, a) {
  if (!(a === "constructor" && typeof e[a] == "function") && a != "__proto__")
    return e[a];
}
var MI = __, j_ = Ww, H_ = Er, V_ = Object.prototype, B_ = V_.hasOwnProperty;
function D_(e, a, t) {
  var o = e[a];
  (!(B_.call(e, a) && H_(o, t)) || t === void 0 && !(a in e)) && j_(e, a, t);
}
var bI = D_, T_ = bI, $_ = Ww;
function O_(e, a, t, o) {
  var r = !t;
  t || (t = {});
  for (var l = -1, i = a.length; ++l < i; ) {
    var c = a[l], u = o ? o(t[c], e[c], c, t, e) : void 0;
    u === void 0 && (u = e[c]), r ? $_(t, c, u) : T_(t, c, u);
  }
  return t;
}
var Nr = O_;
function R_(e, a) {
  for (var t = -1, o = Array(e); ++t < e; )
    o[t] = a(t);
  return o;
}
var F_ = R_, E_ = 9007199254740991, U_ = /^(?:0|[1-9]\d*)$/;
function N_(e, a) {
  var t = typeof e;
  return a = a ?? E_, !!a && (t == "number" || t != "symbol" && U_.test(e)) && e > -1 && e % 1 == 0 && e < a;
}
var eL = N_, W_ = F_, G_ = Kw, Z_ = St, Y_ = Rx, K_ = eL, X_ = Jw, Q_ = Object.prototype, J_ = Q_.hasOwnProperty;
function ej(e, a) {
  var t = Z_(e), o = !t && G_(e), r = !t && !o && Y_(e), l = !t && !o && !r && X_(e), i = t || o || r || l, c = i ? W_(e.length, String) : [], u = c.length;
  for (var v in e)
    (a || J_.call(e, v)) && !(i && // Safari 9 has enumerable `arguments.length` in strict mode.
    (v == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    r && (v == "offset" || v == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    l && (v == "buffer" || v == "byteLength" || v == "byteOffset") || // Skip index properties.
    K_(v, u))) && c.push(v);
  return c;
}
var xI = ej;
function tj(e) {
  var a = [];
  if (e != null)
    for (var t in Object(e))
      a.push(t);
  return a;
}
var aj = tj, nj = Ut, oj = Yw, rj = aj, lj = Object.prototype, ij = lj.hasOwnProperty;
function cj(e) {
  if (!nj(e))
    return rj(e);
  var a = oj(e), t = [];
  for (var o in e)
    o == "constructor" && (a || !ij.call(e, o)) || t.push(o);
  return t;
}
var dj = cj, sj = xI, uj = dj, hj = xr;
function pj(e) {
  return hj(e) ? sj(e, !0) : uj(e);
}
var Wr = pj, yj = Nr, kj = Wr;
function mj(e) {
  return yj(e, kj(e));
}
var fj = mj, EL = sI, vj = hI, gj = yI, Mj = kI, bj = fI, UL = Kw, NL = St, xj = OP, wj = Rx, Lj = Ew, Sj = Ut, Ij = QP, Cj = Jw, WL = MI, Aj = fj;
function qj(e, a, t, o, r, l, i) {
  var c = WL(e, t), u = WL(a, t), v = i.get(u);
  if (v) {
    EL(e, t, v);
    return;
  }
  var k = l ? l(c, u, t + "", e, a, i) : void 0, f = k === void 0;
  if (f) {
    var p = NL(u), m = !p && wj(u), I = !p && !m && Cj(u);
    k = u, p || m || I ? NL(c) ? k = c : xj(c) ? k = Mj(c) : m ? (f = !1, k = vj(u, !0)) : I ? (f = !1, k = gj(u, !0)) : k = [] : Ij(u) || UL(u) ? (k = c, UL(c) ? k = Aj(c) : (!Sj(c) || Lj(c)) && (k = bj(u))) : f = !1;
  }
  f && (i.set(u, k), r(k, u, o, l, i), i.delete(u)), EL(e, t, k);
}
var zj = qj, Pj = Ox, _j = sI, jj = uI, Hj = zj, Vj = Ut, Bj = Wr, Dj = MI;
function wI(e, a, t, o, r) {
  e !== a && jj(a, function(l, i) {
    if (r || (r = new Pj()), Vj(l))
      Hj(e, a, i, t, wI, o, r);
    else {
      var c = o ? o(Dj(e, i), l, i + "", e, a, r) : void 0;
      c === void 0 && (c = l), _j(e, i, c);
    }
  }, Bj);
}
var tL = wI;
function Tj(e) {
  return e;
}
var Ex = Tj;
function $j(e, a, t) {
  switch (t.length) {
    case 0:
      return e.call(a);
    case 1:
      return e.call(a, t[0]);
    case 2:
      return e.call(a, t[0], t[1]);
    case 3:
      return e.call(a, t[0], t[1], t[2]);
  }
  return e.apply(a, t);
}
var LI = $j, Oj = LI, GL = Math.max;
function Rj(e, a, t) {
  return a = GL(a === void 0 ? e.length - 1 : a, 0), function() {
    for (var o = arguments, r = -1, l = GL(o.length - a, 0), i = Array(l); ++r < l; )
      i[r] = o[a + r];
    r = -1;
    for (var c = Array(a + 1); ++r < a; )
      c[r] = o[r];
    return c[a] = t(i), Oj(e, this, c);
  };
}
var Fj = Rj;
function Ej(e) {
  return function() {
    return e;
  };
}
var Uj = Ej, Nj = Uj, ZL = dI, Wj = Ex, Gj = ZL ? function(e, a) {
  return ZL(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Nj(a),
    writable: !0
  });
} : Wj, Zj = Gj, Yj = 800, Kj = 16, Xj = Date.now;
function Qj(e) {
  var a = 0, t = 0;
  return function() {
    var o = Xj(), r = Kj - (o - t);
    if (t = o, r > 0) {
      if (++a >= Yj)
        return arguments[0];
    } else
      a = 0;
    return e.apply(void 0, arguments);
  };
}
var Jj = Qj, eH = Zj, tH = Jj, aH = tH(eH), nH = aH, oH = Ex, rH = Fj, lH = nH;
function iH(e, a) {
  return lH(rH(e, a, oH), e + "");
}
var SI = iH, cH = Er, dH = xr, sH = eL, uH = Ut;
function hH(e, a, t) {
  if (!uH(t))
    return !1;
  var o = typeof a;
  return (o == "number" ? dH(t) && sH(a, t.length) : o == "string" && a in t) ? cH(t[a], e) : !1;
}
var pH = hH, yH = SI, kH = pH;
function mH(e) {
  return yH(function(a, t) {
    var o = -1, r = t.length, l = r > 1 ? t[r - 1] : void 0, i = r > 2 ? t[2] : void 0;
    for (l = e.length > 3 && typeof l == "function" ? (r--, l) : void 0, i && kH(t[0], t[1], i) && (l = r < 3 ? void 0 : l, r = 1), a = Object(a); ++o < r; ) {
      var c = t[o];
      c && e(a, c, o, l);
    }
    return a;
  });
}
var II = mH, fH = tL, vH = II, gH = vH(function(e, a, t) {
  fH(e, a, t);
}), MH = gH;
const Ux = /* @__PURE__ */ Vx(MH);
function Pe({ props: e, locals: a, defaults: t }) {
  const r = tI().type.__name, l = F(() => t.pt || {}), i = F(
    () => {
      var v, k, f, p;
      return ((k = (v = e.themeConfig) == null ? void 0 : v[r]) == null ? void 0 : k.pt) || ((p = (f = Fw("one-ui-config")) == null ? void 0 : f[r]) == null ? void 0 : p.pt) || {};
    }
  ), c = F(() => e.pt || {});
  return { ep: F(() => bH({
    defaults: l.value,
    theme: i.value,
    local: c.value,
    props: e,
    locals: a != null && a.value ? a.value : a
  })) };
}
function bH({ defaults: e, theme: a, local: t, props: o, locals: r }) {
  const l = Ux({}, e, a, t), i = {};
  for (const [c, u] of Object.entries(l))
    i[c] = {
      ...u.propsStatic,
      classList: []
    }, u._common && xH({
      elementResult: i[c],
      commonConfig: u._common
    }), u.propsStateBased && wH({
      elementResult: i[c],
      propsStateBased: u.propsStateBased,
      props: o,
      locals: r
    }), u.props && (i[c] = {
      ...i[c],
      ...u.props
    }), i[c].classList && (i[c].class = i[c].classList.join(" ")), delete i[c].classList;
  return i;
}
function xH({ elementResult: e, commonConfig: a }) {
  typeof a == "string" && a.length > 0 ? e.classList.push(a) : typeof a == "object" && Object.assign(e, a);
}
function wH({ elementResult: e, propsStateBased: a, props: t, locals: o }) {
  for (const [r, l] of Object.entries(a)) {
    const i = CI({ key: r, props: t, locals: o });
    if (i !== void 0 && l[i] !== void 0) {
      const c = l[i];
      typeof c._common == "string" && c._common.length > 0 ? e.classList.push(c._common) : typeof c._common == "object" && Object.assign(e, c._common), typeof c == "string" && c.length > 0 ? e.classList.push(c) : typeof c == "object" && LH({
        elementResult: e,
        stateConfig: c,
        props: t,
        locals: o
      });
    }
  }
}
function LH({ elementResult: e, stateConfig: a, props: t, locals: o }) {
  for (const [r, l] of Object.entries(a))
    if (r !== "_common") {
      const i = CI({ key: r, props: t, locals: o }), c = l[i];
      i !== void 0 && c !== void 0 ? typeof c == "string" && c.length > 0 ? e.classList.push(c) : c && (c.class && c.class.length > 0 && e.classList.push(c.class), c.props && Object.assign(e, c.props)) : r == "class" ? e.classList.push(l) : e[r] = l;
    }
}
function CI({ key: e, props: a, locals: t }) {
  var r, l, i;
  return ((l = (r = t == null ? void 0 : t[e]) == null ? void 0 : r.value) == null ? void 0 : l.toString()) || ((i = a[e]) == null ? void 0 : i.toString());
}
const SH = {
  composer: {
    props: {
      name: {
        default: !1,
        control: "input"
      },
      lucide: {
        default: "Loader2",
        control: "input"
      },
      lucideSize: {
        default: 24,
        control: "input"
      },
      lucideColor: {
        default: "currentColor",
        control: "input"
      },
      lucideStrokeWidth: {
        default: 2,
        control: "input"
      },
      lucideAbsoluteStrokeWidth: {
        default: !1,
        control: "switch"
      },
      lucideDefaultClass: {
        default: "lucide-icon",
        control: "input"
      },
      spin: {
        default: !0,
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      propsStateBased: {
        spin: {
          true: "animate-spin",
          false: ""
        }
      }
    }
  }
}, $e = {
  __name: "Icon",
  props: {
    name: {
      type: [String, Boolean],
      default: !1
    },
    lucide: {
      type: [String, Boolean],
      default: !1
    },
    lucideSize: {
      type: Number,
      default: 24
    },
    lucideColor: {
      type: String,
      default: "currentColor"
    },
    lucideStrokeWidth: {
      type: Number,
      default: 2
    },
    lucideAbsoluteStrokeWidth: {
      type: Boolean,
      default: !1
    },
    lucideDefaultClass: {
      type: String,
      default: "lucide-icon"
    },
    lucideFill: {
      type: String,
      default: null
    },
    spin: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = /* @__PURE__ */ Object.assign({ "../../icons/Progress.svg": () => import("./Progress-728072aa.js") }), t = e, { ep: o } = Pe({ props: t, defaults: SH }), r = F(() => {
      if (t.lucide)
        return rI[t.lucide];
      if (t.name) {
        const i = `${t.name}.svg`;
        return console.log({ icons: a, iconFileName: i }), console.log(a[`../icons/${i}`]), aI(() => a[`../../icons/${i}`]());
      } else
        return !1;
    }), l = F(() => t.lucide ? {
      size: t.lucideSize,
      color: t.lucideColor,
      strokeWidth: t.lucideStrokeWidth,
      absoluteStrokeWidth: t.lucideAbsoluteStrokeWidth,
      defaultClass: t.lucideDefaultClass,
      ...t.lucideFill && { fill: t.lucideFill }
      // experimental - https://lucide.dev/guide/advanced/filled-icons
    } : {});
    return (i, c) => r.value ? (d(), K(s(r), j(H({ key: 0 }, { ...s(o).root, ...l.value })), null, 16)) : y("", !0);
  }
}, IH = {
  composer: {
    compositions: [
      { id: "default", name: "default" },
      { id: "variant", name: "variant" },
      { id: "kind", name: "kind" },
      { id: "size", name: "size" },
      { id: "rounded", name: "rounded" },
      { id: "icon", name: "icon" }
    ],
    tags: ["platforma", "atlaseek"],
    props: {
      variant: {
        options: ["primary", "secondary", "form", "black", "white", "success", "error", "disabled"],
        default: "primary",
        control: "select"
      },
      kind: {
        options: ["solid", "ghost", "naked", "plain"],
        default: "solid",
        control: "select"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      glass: {
        options: [!1, !0],
        default: !1,
        control: "switch"
      },
      shake: {
        default: !1,
        control: "switch"
      },
      label: {
        default: !1,
        control: "input"
      },
      labelSecondary: {
        default: !1,
        control: "input"
      },
      doubleAction: {
        default: !1,
        control: "switch"
      },
      size: {
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8, 7, 6, 5],
        default: 11,
        control: "select"
      },
      circle: {
        options: [!0, !1],
        default: !1,
        control: "switch"
      },
      padding: {
        options: ["none", "small", "default", "large"],
        default: "default",
        control: "select"
      },
      rounded: {
        options: ["none", "md", "lg", "xl", "full"],
        default: "full",
        control: "select"
      },
      // context: {
      //   options: ["dark", "neutral", "light"],
      //   default: "light",
      //   control: "select",
      // },
      locale: {
        options: ["en", "cs", "ar", "kr"],
        default: "en",
        control: "select"
      },
      progress: {
        default: !1,
        control: "switch"
      },
      icon: {
        default: !1,
        control: "input"
      },
      iconStart: {
        default: !1,
        control: "input"
      },
      iconEnd: {
        default: !1,
        control: "input"
      },
      iconSet: {
        options: ["lucide"],
        default: "lucide",
        control: "select"
      },
      iconStrokeWidth: {
        options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.5, 4, 5],
        default: 2,
        control: "select"
      },
      iconAnimate: {
        default: !1,
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: ""
    },
    button: {
      _common: "relative group inline-flex flex-row items-center gap-2 font-element font-semibold transition-all duration-300 ease-in-out cursor-pointer",
      propsStateBased: {
        align: {
          start: "justify-start",
          center: "justify-center",
          end: "justify-end"
        },
        rounded: {
          none: "rounded-none",
          md: "rounded-md",
          lg: "rounded-lg",
          xl: "rounded-xl",
          full: "rounded-full"
        },
        // size: {
        //   24: "h-24 px-14 text-2xl",
        //   20: "h-20 px-10 text-2xl",
        //   16: "h-16 px-8 text-2xl",
        //   14: "h-14 px-7 text-xl",
        //   12: "h-12 px-6 text-xl",
        //   11: "h-11 px-5 text-lg", // default
        //   10: "h-10 px-4 text-base",
        //   9: "h-9 px-4 text-base",
        //   8: "h-8 px-3.5 text-base",
        //   7: "h-7 px-3.5 text-sm",
        //   6: "h-6 px-3 text-sm",
        //   5: "h-5 px-2.5 text-xs",
        // },
        circle: {
          true: {
            _common: "aspect-square",
            size: {
              24: "h-24 text-2xl",
              20: "h-20 text-2xl",
              16: "h-16 text-2xl",
              14: "h-14 text-xl",
              12: "h-12 text-xl",
              11: "h-11 text-lg",
              // default
              10: "h-10 text-base",
              9: "h-9 text-base",
              8: "h-8 text-base",
              7: "h-7 text-sm",
              6: "h-6 text-sm",
              5: "h-5 text-xs"
            }
          },
          false: {
            _common: "aspect-auto",
            size: {
              24: "h-24 px-14 text-2xl",
              20: "h-20 px-10 text-2xl",
              16: "h-16 px-8 text-2xl",
              14: "h-14 px-7 text-xl",
              12: "h-12 px-6 text-xl",
              11: "h-11 px-5 text-base",
              // default
              10: "h-10 px-4 text-base",
              9: "h-9 px-4 text-base",
              8: "h-8 px-3.5 text-base",
              7: "h-7 px-3.5 text-sm",
              6: "h-6 px-3 text-sm",
              5: "h-5 px-2.5 text-xs"
            }
          }
        },
        fullWidth: {
          true: "!w-full"
        },
        fullHeight: {
          true: "!h-full"
        },
        kind: {
          ghost: "outline outline-2 -outline-offset-2",
          plain: "!px-0"
        },
        glass: {
          true: "bg-opacity-50 backdrop-blur-sm"
        },
        variant: {
          primary: {
            kind: {
              solid: "bg-neutral-800 context-dark:bg-neutral-500 hover:bg-neutral-600 active:bg-neutral-900 text-white dark:bg-neutral-50 dark:text-neutral-900 dark:hover:bg-neutral-300 dark:active:bg-neutral-500",
              ghost: "text-neutral-900 outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900 dark:text-neutral-50 dark:outline-neutral-50 dark:hover:outline-neutral-700 dark:active:outline-neutral-900",
              naked: "text-neutral-900 hover:text-white hover:bg-neutral-900 dark:text-neutral-50 dark:hover:bg-neutral-50 dark:hover:text-neutral-900 active:bg-neutral-500 dark:active:bg-neutral-400",
              plain: "text-neutral-900 dark:text-neutral-50 hover:text-neutral-400 active:text-neutral-900 dark:hover:text-neutral-500 dark:active:text-neutral-700"
            }
          },
          secondary: {
            kind: {
              solid: "text-neutral-900 bg-neutral-200 hover:bg-neutral-300 active:bg-neutral-400 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-700 dark:active:bg-neutral-900",
              ghost: "text-neutral-900 outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600 dark:text-neutral-50 dark:outline-neutral-600 dark:hover:outline-neutral-800 dark:active:outline-neutral-900",
              naked: "text-neutral-400 hover:bg-neutral-200 dark:hover:bg-neutral-800 active:bg-neutral-300 dark:active:bg-neutral-900",
              plain: "text-neutral-400 hover:text-neutral-600 active:text-neutral-900"
            }
          },
          form: {
            kind: {
              solid: "text-neutral-500 bg-neutral-100 hover:bg-neutral-200 active:bg-neutral-300 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:active:bg-neutral-900",
              ghost: "text-neutral-500 outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600 dark:outline-neutral-800 dark:hover:outline-neutral-900",
              naked: "text-neutral-500 hover:bg-neutral-200 active:bg-neutral-300 dark:hover:bg-neutral-800 dark:active:bg-neutral-900",
              plain: "text-neutral-500 hover:text-neutral-600 active:text-neutral-900"
            }
          },
          black: {
            kind: {
              solid: "bg-neutral-900 context-dark:bg-neutral-500 hover:bg-neutral-600 active:bg-neutral-900 text-white dark:hover:bg-neutral-800",
              ghost: "text-neutral-900 outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900",
              naked: "text-neutral-900 hover:bg-neutral-900 hover:bg-opacity-50",
              plain: "text-neutral-900 hover:text-neutral-400 active:text-neutral-900"
            }
          },
          white: {
            kind: {
              solid: "bg-white context-dark:bg-neutral-500 hover:bg-neutral-200 active:bg-neutral-400 text-neutral-900",
              ghost: "text-white outline-white hover:outline-neutral-400 active:outline-neutral-900",
              naked: "text-white hover:bg-white hover:bg-opacity-20 active:bg-opacity-40",
              plain: "text-white hover:opacity-50 active:opacity-80"
            }
          },
          success: {
            kind: {
              solid: "text-success-900 bg-success-500 hover:bg-success-400 active:bg-success-500",
              ghost: "text-success-900 dark:text-success-500 outline-success-500 hover:outline-success-400 active:outline-success-600",
              naked: "text-success-500 hover:bg-success-200 active:bg-success-300",
              plain: "text-success-500 hover:text-success-600 active:text-success-400"
            }
          },
          error: {
            kind: {
              solid: "text-red-900 bg-red-500 hover:bg-red-400 active:bg-red-500",
              ghost: "text-red-900 dark:text-red-500 outline-red-500 hover:outline-red-300 active:outline-red-600",
              naked: "text-red-500 hover:bg-red-100 dark:hover:bg-red-900 active:bg-red-200",
              plain: "text-red-500 hover:text-red-700 active:text-red-500"
            }
          },
          disabled: {
            _common: "!cursor-not-allowed",
            // _common applied to all
            kind: {
              solid: "bg-neutral-100 text-neutral-300 dark:bg-neutral-900 dark:text-neutral-700",
              ghost: "bg-transparent outline-neutral-200 text-neutral-200 dark:outline-neutral-900 dark:text-neutral-700",
              naked: "bg-transparent text-neutral-200 dark:text-neutral-700",
              plain: "bg-transparent text-neutral-200 dark:text-neutral-700"
            }
          }
        }
      }
    },
    text: {
      _common: "whitespace-nowrap"
    },
    progressIcon: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          20: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          16: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          14: { class: "w-6 h-6 -ml-1 mr-1 opacity-40", lucideStrokeWidth: 4 },
          12: { class: "w-6 h-6 -ml-2 mr-1 opacity-40", lucideStrokeWidth: 4 },
          11: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          10: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          9: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          8: { class: "w-5 h-5 -ml-1.5 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          7: { class: "w-4 h-4 -ml-2 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          6: { class: "w-4 h-4 -ml-1.5 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          5: { class: "w-3 h-3 -ml-1 -mr-1 opacity-40", lucideStrokeWidth: 4 }
        }
      }
    },
    icon: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8" },
          20: { class: "w-8 h-8" },
          16: { class: "w-8 h-8" },
          14: { class: "w-6 h-6" },
          12: { class: "w-6 h-6" },
          11: { class: "w-5 h-5" },
          10: { class: "w-5 h-5" },
          9: { class: "w-5 h-5" },
          8: { class: "w-5 h-5" },
          7: { class: "w-4 h-4" },
          6: { class: "w-4 h-4" },
          5: { class: "w-3 h-3" }
        }
      }
    },
    iconStart: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -ml-1 mr-2" },
          20: { class: "w-8 h-8 -ml-1 mr-2" },
          16: { class: "w-8 h-8 -ml-1 mr-2" },
          14: { class: "w-6 h-6 -ml-1 mr-1" },
          12: { class: "w-6 h-6 -ml-2 mr-1" },
          11: { class: "w-5 h-5 -ml-2 mr-0" },
          10: { class: "w-5 h-5 -ml-2 mr-0" },
          9: { class: "w-5 h-5 -ml-2 mr-0" },
          8: { class: "w-5 h-5 -ml-1.5 -mr-0.5" },
          7: { class: "w-4 h-4 -ml-2 -mr-0.5" },
          6: { class: "w-4 h-4 -ml-1.5 -mr-0.5" },
          5: { class: "w-3 h-3 -ml-1 -mr-1" }
        }
      }
    },
    iconEnd: {
      _common: "",
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -mr-1 ml-2" },
          20: { class: "w-8 h-8 -mr-1 ml-2" },
          16: { class: "w-8 h-8 -mr-1 ml-2" },
          14: { class: "w-6 h-6 -mr-1 ml-1" },
          12: { class: "w-6 h-6 -mr-2 ml-1" },
          11: { class: "w-5 h-5 -mr-2 ml-0" },
          10: { class: "w-5 h-5 -mr-2 ml-0" },
          9: { class: "w-5 h-5 -mr-2 ml-0" },
          8: { class: "w-5 h-5 -mr-1.5 -ml-0.5" },
          7: { class: "w-4 h-4 -mr-2 -ml-0.5" },
          6: { class: "w-4 h-4 -mr-1.5 -ml-0.5" },
          5: { class: "w-3 h-3 -mr-1 -ml-1" }
        },
        iconAnimate: {
          true: "group-hover:transform group-hover:translate-x-1 group-active:translate-x-2 ease-in-out duration-300 transition-all"
        }
      }
    }
  }
}, CH = {
  text: {
    "element-button": "tlačítko",
    "element-chip": "čip"
  }
}, AH = {
  text: {
    "element-button": "button",
    "element-tag": "tag",
    "element-chip": "chip"
  }
}, qH = {
  text: {
    "element-button": "زرّ"
  }
}, zH = {
  text: {
    "element-button": "버튼"
  }
}, Nx = {
  data: { cs: CH, en: AH, ar: qH, kr: zH },
  available: ["cs", "en", "ar", "kr"],
  lang: "en",
  overrides: {},
  get(e, a, t) {
    let o = t || this.lang, r = e;
    if (this.overrides[e] ? r = this.overrides[e][o] : this.data[o] != null && this.data[o].text[e] != null && (r = this.data[o].text[e]), a)
      for (let l = 0; l < a.length; l++)
        r = r.replace("%" + l, a[l]);
    return r;
  },
  gets(e) {
    return this.data[this.lang] != null && this.data[this.lang].text[e] != null ? this.data[this.lang].text[e] : e;
  },
  setLang(e) {
    return console.log("Selecting lang", e), this.available.indexOf(e) == -1 ? !1 : (this.lang = e, !0);
  }
}, PH = {
  key: 0,
  class: ""
}, _H = { class: "mt-1 text-sm text-neutral-400 dark:text-neutral-700" }, ft = {
  __name: "Button",
  props: {
    // contains overrides for all components
    themeConfig: {
      type: Object
    },
    // contains overrides for this component only
    pt: {
      type: Object
    },
    variant: {
      type: String,
      default: "primary"
    },
    kind: {
      type: String,
      default: "solid"
    },
    glass: {
      type: Boolean,
      default: !1
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelSecondary: {
      type: [String, Boolean],
      default: !1
    },
    doubleAction: {
      type: Boolean,
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    circle: {
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    fullHeight: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      default: "default"
    },
    rounded: {
      type: String,
      default: "full"
    },
    align: {
      type: String,
      default: "center"
    },
    context: {
      type: String
    },
    locale: {
      type: String,
      default: "en"
    },
    progress: {
      type: Boolean,
      default: !1
    },
    // only icon, no label
    icon: {
      type: [String, Object, Boolean],
      default: !1
    },
    iconStart: {
      type: [String, Object, Boolean],
      default: !1
    },
    iconEnd: {
      type: [String, Object, Boolean],
      default: !1
    },
    iconSet: {
      type: String,
      default: "lucide"
    },
    iconStrokeWidth: {
      type: Number,
      default: 2
    },
    iconAnimate: {
      type: Boolean,
      default: !1
    },
    // overrides variant to disabled
    disabled: {
      type: Boolean,
      default: !1
    },
    shake: {
      type: Boolean,
      default: !1
    },
    tag: {
      type: String,
      default: "button"
      // button | a
    },
    href: {
      type: String,
      default: null
    },
    target: {
      type: String,
      default: "_self"
    }
  },
  emits: ["action"],
  setup(e, { emit: a }) {
    const t = e, o = a, r = F(() => t.disabled ? "disabled" : t.variant), l = F(() => ({
      variant: r
    })), { ep: i } = Pe({
      props: {
        ...t
        // variant: props.disabled ? "disabled" : props.variant,
      },
      defaults: IH,
      locals: l
    }), c = U(t.label || !1), u = U(0);
    We(
      () => t.label,
      (k) => {
        c.value = k;
      },
      {
        immediate: !0
      }
    );
    function v() {
      t.disabled || t.progress || (t.doubleAction ? (u.value++, u.value == 1 ? c.value = t.labelSecondary : u.value == 2 && (o("action"), u.value = 0)) : o("action"));
    }
    return (k, f) => (d(), h("div", j(re(s(i).root)), [
      (d(), K(st(e.tag), H(s(i).button, {
        href: e.href,
        target: e.target,
        class: [{ "animate-shake": e.shake }],
        onClick: v
      }), {
        default: fe(() => [
          te(k.$slots, "default", {}, () => [
            e.progress ? (d(), K($e, H({ key: 0 }, s(i).progressIcon, {
              class: "animate-spin",
              lucide: "Loader2"
            }), null, 16)) : y("", !0),
            e.iconStart && e.iconSet == "lucide" && typeof e.iconStart == "string" ? (d(), K($e, H({ key: 1 }, s(i).iconStart, {
              lucide: e.iconStart,
              "lucide-stroke-width": e.iconStrokeWidth
            }), null, 16, ["lucide", "lucide-stroke-width"])) : y("", !0),
            typeof e.iconStart == "object" ? (d(), K(st(e.iconStart), j(H({ key: 2 }, s(i).iconStart)), null, 16)) : y("", !0),
            e.icon && e.iconSet == "lucide" && typeof e.icon == "string" ? (d(), K($e, H({ key: 3 }, s(i).icon, {
              lucide: e.icon,
              "lucide-stroke-width": e.iconStrokeWidth
            }), null, 16, ["lucide", "lucide-stroke-width"])) : y("", !0),
            typeof e.icon == "object" ? (d(), K(st(e.icon), j(H({ key: 4 }, s(i).icon)), null, 16)) : y("", !0),
            c.value && !e.icon ? (d(), h("span", j(H({ key: 5 }, s(i).text)), N(c.value), 17)) : e.icon ? y("", !0) : (d(), h("span", j(H({ key: 6 }, s(i).text)), N(s(Nx).get("element-button", null, e.locale)), 17)),
            e.iconEnd && !e.icon && e.iconSet == "lucide" && typeof e.iconEnd == "string" ? (d(), K($e, H({ key: 7 }, s(i).iconEnd, {
              lucide: e.iconEnd,
              "lucide-stroke-width": e.iconStrokeWidth
            }), null, 16, ["lucide", "lucide-stroke-width"])) : y("", !0),
            typeof e.iconEnd == "object" ? (d(), K(st(e.iconEnd), j(H({ key: 8 }, s(i).iconEnd)), null, 16)) : y("", !0)
          ])
        ]),
        _: 3
      }, 16, ["href", "target", "class"])),
      e.caption || k.$slots.caption ? (d(), h("div", PH, [
        te(k.$slots, "caption", {}, () => [
          P("p", _H, N(e.caption), 1)
        ])
      ])) : y("", !0)
    ], 16));
  }
}, jH = {
  composer: {
    props: {
      modelValue: {
        default: !0,
        control: "switch"
      },
      size: {
        default: 6,
        // TODO: set 11
        control: "select",
        options: [14, 12, 11, 10, 9, 8, 7, 6, 5]
      },
      rounded: {
        default: "md",
        options: ["full", "md"],
        control: "select"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      label: {
        default: "label",
        control: "input"
      },
      labelStart: {
        default: "label",
        control: "input"
      },
      labelEnd: {
        default: "label",
        control: "input"
      },
      sublabelStart: {
        default: "sublabel",
        control: "input"
      },
      sublabelEnd: {
        default: "sublabel",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      }
    }
  },
  pt: {
    root: {},
    checkboxWrap: {
      _common: "flex flex-row items-center justify-start",
      propsStateBased: {
        size: {
          14: "gap-4",
          12: "gap-4",
          11: "gap-4",
          10: "gap-4",
          9: "gap-4",
          8: "gap-2.5",
          7: "gap-2",
          6: "gap-2",
          5: "gap-2"
        }
      }
    },
    checkbox: {
      _common: "cursor-pointer flex flex-row items-center justify-center relative",
      propsStateBased: {
        modelValue: {
          true: {
            _common: "bg-neutral-800"
          },
          false: {
            _common: "bg-neutral-200 dark:bg-neutral-900 dark:border dark:border-neutral-800"
          }
        },
        rounded: {
          full: {
            _common: "rounded-full",
            size: {
              14: "h-14 w-14",
              12: "h-12 w-12",
              11: "h-11 w-11",
              // default
              10: "h-10 w-10",
              9: "h-9 w-9",
              8: "h-8 w-8",
              7: "h-7 w-7",
              6: "h-6 w-6",
              5: "h-5 w-5"
            }
          },
          md: {
            size: {
              14: "h-14 w-14 rounded-xl",
              12: "h-12 w-12 rounded-xl",
              11: "h-11 w-11 rounded-xl",
              // default
              10: "h-10 w-10 rounded-lg",
              9: "h-9 w-9 rounded-lg",
              8: "h-8 w-8 rounded-lg",
              7: "h-7 w-7 rounded-lg",
              6: "h-6 w-6 rounded-lg",
              5: "h-5 w-5 rounded-md"
            }
          }
        }
      }
    },
    checkboxCheck: {
      _common: "text-white",
      propsStateBased: {
        size: {
          14: {
            class: "w-10 h-10",
            lucideStrokeWidth: 3
          },
          12: {
            class: "w-8 h-8",
            lucideStrokeWidth: 4
          },
          11: {
            class: "w-7 h-7",
            lucideStrokeWidth: 4
          },
          10: {
            class: "w-6 h-6",
            lucideStrokeWidth: 4
          },
          9: {
            class: "w-5 h-5",
            lucideStrokeWidth: 4.5
          },
          8: {
            class: "w-5 h-5",
            lucideStrokeWidth: 4.5
          },
          7: {
            class: "w-5 h-5",
            lucideStrokeWidth: 4.5
          },
          6: {
            class: "w-4 h-4",
            lucideStrokeWidth: 4.5
          },
          5: {
            class: "w-3.5 h-3.5",
            lucideStrokeWidth: 4.5
          }
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-lg font-bold text-neutral-600 dark:text-neutral-200 font-element"
    },
    labelStart: {
      _common: "inline-block text-lg font-bold text-neutral-600 dark:text-neutral-200 font-element"
    },
    labelStartWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEndWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEnd: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    sublabelStart: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    sublabelEnd: {
      _common: "leading-3 text-sm text-neutral-500"
    }
  }
}, HH = {
  key: 0,
  class: "flex flex-col"
}, VH = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, BH = {
  key: 1,
  class: ""
}, DH = { class: "mt-1 text-sm text-neutral-400" }, AI = {
  __name: "Checkbox",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelStart: {
      type: [String, Boolean],
      default: !1
    },
    labelEnd: {
      type: [String, Boolean],
      default: !1
    },
    sublabelStart: {
      type: [String, Boolean],
      default: !1
    },
    sublabelEnd: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, locals: {}, defaults: jH });
    function l() {
      o("update:modelValue", !t.modelValue);
    }
    return (i, c) => (d(), h("div", j(re(s(r).root)), [
      t.mode == "edit" ? (d(), h("div", HH, [
        t.label ? (d(), h("div", VH, [
          t.label ? (d(), h("span", j(H({ key: 0 }, s(r).labelOuter)), N(t.label), 17)) : y("", !0)
        ])) : y("", !0),
        P("div", j(re(s(r).checkboxWrap)), [
          t.labelStart || t.sublabelStart ? (d(), h("div", j(H({ key: 0 }, s(r).labelStartWrap)), [
            t.labelStart ? (d(), h("span", j(H({ key: 0 }, s(r).labelStart)), N(t.labelStart), 17)) : y("", !0),
            t.sublabelStart ? (d(), h("span", j(H({ key: 1 }, s(r).sublabelStart)), N(t.sublabelStart), 17)) : y("", !0)
          ], 16)) : y("", !0),
          P("div", H(s(r).checkbox, { onClick: l }), [
            e.modelValue === !0 ? (d(), K($e, H({ key: 0 }, s(r).checkboxCheck, { lucide: "Check" }), null, 16)) : y("", !0)
          ], 16),
          t.labelEnd || t.sublabelEnd ? (d(), h("div", j(H({ key: 1 }, s(r).labelEndWrap)), [
            t.labelEnd ? (d(), h("span", j(H({ key: 0 }, s(r).labelEnd)), N(t.labelEnd), 17)) : y("", !0),
            t.sublabelEnd ? (d(), h("span", j(H({ key: 1 }, s(r).sublabelEnd)), N(t.sublabelEnd), 17)) : y("", !0)
          ], 16)) : y("", !0)
        ], 16),
        e.caption || i.$slots.caption ? (d(), h("div", BH, [
          te(i.$slots, "caption", {}, () => [
            P("p", DH, N(e.caption), 1)
          ])
        ])) : y("", !0)
      ])) : y("", !0)
    ], 16));
  }
}, TH = {
  composer: {
    compositions: [
      { id: "default", name: "default" },
      { id: "variant", name: "variant" },
      { id: "kind", name: "kind" },
      { id: "size", name: "size" },
      { id: "rounded", name: "rounded" },
      { id: "icon", name: "icon" }
    ],
    // tags: ["platforma", "atlaseek"],
    props: {
      variant: {
        options: ["primary", "secondary", "form", "black", "white", "success", "error", "disabled"],
        default: "primary",
        control: "select"
      },
      kind: {
        options: ["solid", "ghost", "naked", "plain"],
        default: "solid",
        control: "select"
      },
      glass: {
        options: [!1, !0],
        default: !1,
        control: "switch"
      },
      label: {
        default: !1,
        control: "input"
      },
      labelSecondary: {
        default: !1,
        control: "input"
      },
      doubleAction: {
        default: !1,
        control: "switch"
      },
      size: {
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8, 7, 6, 5],
        default: 11,
        control: "select"
      },
      circle: {
        options: [!0, !1],
        default: !1,
        control: "switch"
      },
      padding: {
        options: ["none", "small", "default", "large"],
        default: "default",
        control: "select"
      },
      rounded: {
        options: ["none", "md", "lg", "xl", "full"],
        default: "full",
        control: "select"
      },
      // context: {
      //   options: ["dark", "neutral", "light"],
      //   default: "light",
      //   control: "select",
      // },
      locale: {
        options: ["en", "cs", "ar", "kr"],
        default: "en",
        control: "select"
      },
      progress: {
        default: !1,
        control: "switch"
      },
      icon: {
        default: !1,
        control: "input"
      },
      iconStart: {
        default: !1,
        control: "input"
      },
      iconEnd: {
        default: !1,
        control: "input"
      },
      iconSet: {
        options: ["lucide"],
        default: "lucide",
        control: "select"
      },
      iconStrokeWidth: {
        options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.5, 4, 5],
        default: 2,
        control: "select"
      },
      iconAnimate: {
        default: !1,
        control: "switch"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      showX: {
        default: !0,
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "group inline-flex flex-row justify-center items-center gap-2 font-element  transition-all duration-300 ease-in-out select-none",
      propsStateBased: {
        clickable: {
          true: "cursor-pointer",
          false: ""
        },
        rounded: {
          none: "rounded-none",
          md: "rounded-md",
          lg: "rounded-lg",
          xl: "rounded-xl",
          full: "rounded-full"
        },
        // size: {
        //   24: "h-24 px-14 text-2xl",
        //   20: "h-20 px-10 text-2xl",
        //   16: "h-16 px-8 text-2xl",
        //   14: "h-14 px-7 text-xl",
        //   12: "h-12 px-6 text-xl",
        //   11: "h-11 px-5 text-lg", // default
        //   10: "h-10 px-4 text-base",
        //   9: "h-9 px-4 text-base",
        //   8: "h-8 px-3.5 text-base",
        //   7: "h-7 px-3.5 text-sm",
        //   6: "h-6 px-3 text-sm",
        //   5: "h-5 px-2.5 text-xs",
        // },
        circle: {
          true: {
            _common: "aspect-square",
            size: {
              24: "h-24 text-2xl",
              20: "h-20 text-2xl",
              16: "h-16 text-2xl",
              14: "h-14 text-xl",
              12: "h-12 text-xl",
              11: "h-11 text-lg",
              // default
              10: "h-10 text-base",
              9: "h-9 text-base",
              8: "h-8 text-base",
              7: "h-7 text-sm",
              6: "h-6 text-sm",
              5: "h-5 text-xs"
            }
          },
          false: {
            _common: "aspect-auto",
            size: {
              24: "h-24 px-14 text-2xl",
              20: "h-20 px-10 text-2xl",
              16: "h-16 px-8 text-2xl",
              14: "h-14 px-7 text-xl",
              12: "h-12 px-6 text-xl",
              11: "h-11 px-5 text-lg",
              // default
              10: "h-10 px-4 text-base",
              9: "h-9 px-4 text-base",
              8: "h-8 px-3.5 text-base",
              7: "h-7 px-3.5 text-sm",
              6: "h-6 px-2.5 text-sm",
              5: "h-5 px-2.5 text-xs"
            }
          }
        },
        fullWidth: {
          true: "!w-full"
        },
        fullHeight: {
          true: "!h-full"
        },
        kind: {
          ghost: "outline outline-2 -outline-offset-2",
          plain: "!px-0"
        },
        glass: {
          true: "bg-opacity-50 backdrop-blur-sm"
        },
        variant: {
          primary: {
            kind: {
              solid: "bg-neutral-800 context-dark:bg-neutral-500 hover:bg-neutral-600 active:bg-neutral-900 text-white dark:bg-neutral-50 dark:text-neutral-900 dark:hover:bg-neutral-300 dark:active:bg-neutral-500",
              ghost: "text-neutral-900 outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900 dark:text-neutral-50 dark:outline-neutral-50 dark:hover:outline-neutral-700 dark:active:outline-neutral-900",
              naked: "text-neutral-900 hover:text-white hover:bg-neutral-900 dark:text-neutral-50 dark:hover:bg-neutral-50 dark:hover:text-neutral-900 active:bg-neutral-500 dark:active:bg-neutral-400",
              plain: "text-neutral-900 dark:text-neutral-50 hover:text-neutral-400 active:text-neutral-900 dark:hover:text-neutral-500 dark:active:text-neutral-700"
            }
          },
          secondary: {
            kind: {
              solid: "text-neutral-900 bg-neutral-200 hover:bg-neutral-300 active:bg-neutral-400 dark:bg-neutral-800 dark:text-neutral-50 dark:hover:bg-neutral-700 dark:active:bg-neutral-900",
              ghost: "text-neutral-900 outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600 dark:text-neutral-50 dark:outline-neutral-600 dark:hover:outline-neutral-800 dark:active:outline-neutral-900",
              naked: "text-neutral-400 hover:bg-neutral-200 dark:hover:bg-neutral-800 active:bg-neutral-300 dark:active:bg-neutral-900",
              plain: "text-neutral-400 hover:text-neutral-600 active:text-neutral-900"
            }
          },
          form: {
            kind: {
              solid: "text-neutral-500 bg-neutral-100 hover:bg-neutral-200 active:bg-neutral-300 dark:bg-neutral-900 dark:hover:bg-neutral-800 dark:active:bg-neutral-900",
              ghost: "text-neutral-500 outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600 dark:outline-neutral-800 dark:hover:outline-neutral-900",
              naked: "text-neutral-500 hover:bg-neutral-200 active:bg-neutral-300 dark:hover:bg-neutral-800 dark:active:bg-neutral-900",
              plain: "text-neutral-500 hover:text-neutral-600 active:text-neutral-900"
            }
          },
          black: {
            kind: {
              solid: "bg-neutral-900 context-dark:bg-neutral-500 hover:bg-neutral-600 active:bg-neutral-900 text-white dark:hover:bg-neutral-800",
              ghost: "text-neutral-900 outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900",
              naked: "text-neutral-900 hover:bg-neutral-900 hover:bg-opacity-50",
              plain: "text-neutral-900 hover:text-neutral-400 active:text-neutral-900"
            }
          },
          white: {
            kind: {
              solid: "bg-white context-dark:bg-neutral-500 hover:bg-neutral-200 active:bg-neutral-400 text-neutral-900",
              ghost: "text-white outline-white hover:outline-neutral-400 active:outline-neutral-900",
              naked: "text-white hover:bg-white hover:bg-opacity-20 active:bg-opacity-40",
              plain: "text-white hover:opacity-50 active:opacity-80"
            }
          },
          success: {
            kind: {
              solid: "text-success-900 bg-success-500 hover:bg-success-400 active:bg-success-500",
              ghost: "text-success-900 dark:text-success-500 outline-success-500 hover:outline-success-400 active:outline-success-600",
              naked: "text-success-500 hover:bg-success-200 active:bg-success-300",
              plain: "text-success-500 hover:text-success-600 active:text-success-400"
            }
          },
          error: {
            kind: {
              solid: "text-red-900 bg-red-500 hover:bg-red-400 active:bg-red-500",
              ghost: "text-red-900 dark:text-red-500 outline-red-500 hover:outline-red-300 active:outline-red-600",
              naked: "text-red-500 hover:bg-red-100 dark:hover:bg-red-900 active:bg-red-200",
              plain: "text-red-500 hover:text-red-700 active:text-red-500"
            }
          },
          disabled: {
            _common: "cursor-not-allowed",
            // _common applied to all
            kind: {
              solid: "bg-neutral-100 text-neutral-300 dark:bg-neutral-900 dark:text-neutral-700",
              ghost: "bg-transparent outline-neutral-200 text-neutral-200 dark:outline-neutral-900 dark:text-neutral-700",
              naked: "bg-transparent text-neutral-200 dark:text-neutral-700",
              plain: "bg-transparent text-neutral-200 dark:text-neutral-700"
            }
          }
        }
      }
    },
    text: {
      _common: "whitespace-nowrap"
    },
    progressIcon: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          20: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          16: { class: "w-8 h-8 -ml-1 mr-2 opacity-40", lucideStrokeWidth: 3 },
          14: { class: "w-6 h-6 -ml-1 mr-1 opacity-40", lucideStrokeWidth: 4 },
          12: { class: "w-6 h-6 -ml-2 mr-1 opacity-40", lucideStrokeWidth: 4 },
          11: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          10: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          9: { class: "w-5 h-5 -ml-2 mr-0 opacity-40", lucideStrokeWidth: 4 },
          8: { class: "w-5 h-5 -ml-1.5 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          7: { class: "w-4 h-4 -ml-2 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          6: { class: "w-4 h-4 -ml-1.5 -mr-0.5 opacity-40", lucideStrokeWidth: 4 },
          5: { class: "w-3 h-3 -ml-1 -mr-1 opacity-40", lucideStrokeWidth: 4 }
        }
      }
    },
    icon: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8" },
          20: { class: "w-8 h-8" },
          16: { class: "w-8 h-8" },
          14: { class: "w-6 h-6" },
          12: { class: "w-6 h-6" },
          11: { class: "w-5 h-5" },
          10: { class: "w-5 h-5" },
          9: { class: "w-5 h-5" },
          8: { class: "w-5 h-5" },
          7: { class: "w-4 h-4" },
          6: { class: "w-4 h-4" },
          5: { class: "w-3 h-3" }
        }
      }
    },
    iconStart: {
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -ml-1 mr-2" },
          20: { class: "w-8 h-8 -ml-1 mr-2" },
          16: { class: "w-8 h-8 -ml-1 mr-2" },
          14: { class: "w-6 h-6 -ml-1 mr-1" },
          12: { class: "w-6 h-6 -ml-2 mr-1" },
          11: { class: "w-5 h-5 -ml-2 mr-0" },
          10: { class: "w-5 h-5 -ml-2 mr-0" },
          9: { class: "w-5 h-5 -ml-2 mr-0" },
          8: { class: "w-5 h-5 -ml-1.5 -mr-0.5" },
          7: { class: "w-4 h-4 -ml-2 -mr-0.5" },
          6: { class: "w-4 h-4 -ml-1.5 -mr-0.5" },
          5: { class: "w-3 h-3 -ml-1 -mr-1" }
        }
      }
    },
    iconEnd: {
      _common: "",
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8 -mr-1 ml-2" },
          20: { class: "w-8 h-8 -mr-1 ml-2" },
          16: { class: "w-8 h-8 -mr-1 ml-2" },
          14: { class: "w-6 h-6 -mr-1 ml-1" },
          12: { class: "w-6 h-6 -mr-2 ml-1" },
          11: { class: "w-5 h-5 -mr-2 ml-0" },
          10: { class: "w-5 h-5 -mr-2 ml-0" },
          9: { class: "w-5 h-5 -mr-2 ml-0" },
          8: { class: "w-5 h-5 -mr-1.5 -ml-0.5" },
          7: { class: "w-4 h-4 -mr-2 -ml-0.5" },
          6: { class: "w-4 h-4 -mr-1.5 -ml-0.5" },
          5: { class: "w-3 h-3 -mr-1 -ml-1" }
        },
        iconAnimate: {
          true: "group-hover:transform group-hover:translate-x-1 group-active:translate-x-2 ease-in-out duration-300 transition-all"
        }
      }
    },
    iconX: {
      _common: "cursor-pointer",
      propsStateBased: {
        size: {
          24: { class: "w-8 h-8", lucideStrokeWidth: 3 },
          20: { class: "w-8 h-8", lucideStrokeWidth: 3 },
          16: { class: "w-8 h-8", lucideStrokeWidth: 3 },
          14: { class: "w-6 h-6", lucideStrokeWidth: 4 },
          12: { class: "w-6 h-6", lucideStrokeWidth: 4 },
          11: { class: "w-5 h-5", lucideStrokeWidth: 4 },
          10: { class: "w-5 h-5", lucideStrokeWidth: 4 },
          9: { class: "w-5 h-5", lucideStrokeWidth: 3 },
          8: { class: "w-4 h-4", lucideStrokeWidth: 3.5 },
          7: { class: "w-4 h-4", lucideStrokeWidth: 3 },
          6: { class: "w-4 h-4", lucideStrokeWidth: 3 },
          5: { class: "w-3 h-3", lucideStrokeWidth: 4 }
        }
      }
    }
  }
}, Ax = {
  __name: "Chip",
  props: {
    // contains overrides for all components
    themeConfig: {
      type: Object
    },
    // contains overrides for this component only
    pt: {
      type: Object
    },
    variant: {
      type: String,
      default: "primary"
    },
    kind: {
      type: String,
      default: "solid"
    },
    glass: {
      type: Boolean,
      default: !1
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelSecondary: {
      type: [String, Boolean],
      default: !1
    },
    doubleAction: {
      type: Boolean,
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    circle: {
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    fullHeight: {
      type: Boolean,
      default: !1
    },
    padding: {
      type: String,
      default: "default"
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String
    },
    locale: {
      type: String,
      default: "en"
    },
    progress: {
      type: Boolean,
      default: !1
    },
    // only icon, no label
    icon: {
      type: [String, Boolean],
      default: !1
    },
    iconStart: {
      type: [String, Boolean],
      default: !1
    },
    iconEnd: {
      type: [String, Boolean],
      default: !1
    },
    iconSet: {
      type: String,
      default: "lucide"
    },
    iconStrokeWidth: {
      type: Number,
      default: 2
    },
    iconAnimate: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    showX: {
      type: Boolean,
      default: !1
    },
    clickable: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["action", "actionX"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, defaults: TH }), l = U(t.label || !1), i = U(0);
    We(
      () => t.label,
      (v) => {
        l.value = v;
      },
      {
        immediate: !0
      }
    );
    function c() {
      t.disabled || (t.doubleAction ? (i.value++, i.value == 1 ? l.value = t.labelSecondary : i.value == 2 && (o("action"), i.value = 0)) : o("action"));
    }
    function u() {
      t.disabled || o("actionX");
    }
    return (v, k) => (d(), h("div", H(s(r).root, { onClick: c }), [
      te(v.$slots, "default", {}, () => [
        e.progress ? (d(), K($e, H({ key: 0 }, s(r).progressIcon, {
          class: "animate-spin",
          lucide: "Loader2"
        }), null, 16)) : y("", !0),
        e.iconStart && e.iconSet == "lucide" ? (d(), K($e, H({ key: 1 }, s(r).iconStart, {
          lucide: e.iconStart,
          "lucide-stroke-width": e.iconStrokeWidth
        }), null, 16, ["lucide", "lucide-stroke-width"])) : y("", !0),
        e.icon && e.iconSet == "lucide" ? (d(), K($e, H({ key: 2 }, s(r).icon, {
          lucide: e.icon,
          "lucide-stroke-width": e.iconStrokeWidth
        }), null, 16, ["lucide", "lucide-stroke-width"])) : y("", !0),
        l.value && !e.icon ? (d(), h("span", j(H({ key: 3 }, s(r).text)), N(l.value), 17)) : e.icon ? y("", !0) : (d(), h("span", j(H({ key: 4 }, s(r).text)), N(s(Nx).get("element-chip", null, e.locale)), 17)),
        e.iconEnd && !e.icon && e.iconSet == "lucide" ? (d(), K($e, H({ key: 5 }, s(r).iconEnd, {
          lucide: e.iconEnd,
          "lucide-stroke-width": e.iconStrokeWidth
        }), null, 16, ["lucide", "lucide-stroke-width"])) : y("", !0),
        e.showX ? (d(), K($e, H({ key: 6 }, s(r).iconX, {
          lucide: "X",
          onClick: u
        }), null, 16)) : y("", !0)
      ])
    ], 16));
  }
}, $H = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      modelValue: {
        default: [],
        control: "input"
      },
      placeholder: {
        default: "select something",
        control: "input"
      },
      options: {
        default: [
          {
            label: "option 1",
            labelSecondary: "label 2",
            sublabel: "sublabel 1",
            value: "option-1"
          },
          {
            label: "option 2",
            sublabel: "sublabel 2",
            value: "option-2"
          },
          {
            label: "option 3",
            sublabel: "sublabel 3",
            value: "option-3",
            disabled: !0
          },
          {
            label: "option 4",
            value: "option-4"
          }
        ],
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      // status: {
      //   default: false, //"error",
      //   control: "select",
      //   options: [false, "success", "error", "progress"],
      // },
      size: {
        default: 11,
        control: "select",
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8]
      },
      // statusMessage: {
      //   default: "status message",
      //   control: "input",
      // },
      disabled: {
        default: !1,
        control: "switch"
      },
      layout: {
        default: "vertical",
        control: "select",
        options: ["horizontal", "vertical", "grid"]
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    options: {
      _common: "gap-2",
      propsStateBased: {
        layout: {
          horizontal: "flex flex-row",
          vertical: "flex flex-col",
          grid: "grid grid-cols-2 gap-2"
        },
        fullWidth: {
          true: "w-full",
          false: "min-w-[300px]"
        }
      }
    },
    option: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "bg-neutral-100",
          false: "outline outline-neutral-300 dark:outline-neutral-800"
        },
        disabled: {
          true: "dark:bg-neutral-800 cursor-not-allowed",
          false: {
            _common: "cursor-pointer",
            filled: {
              true: "hover:bg-neutral-200",
              false: "hover:outline-neutral-400"
            }
          }
        }
      }
    },
    optionSelected: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "outline outline-2 outline-neutral-500 bg-neutral-100 dark:bg-neutral-800 dark:outline-neutral-400",
          false: "outline outline-2 outline-neutral-500 dark:outline-neutral-200"
        }
      }
    },
    optionDisabled: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "bg-neutral-50",
          false: "outline outline-2 outline-neutral-50"
        }
      }
    },
    optionLabels: {
      _common: "flex flex-col px-4 gap-0 justify-center",
      propsStateBased: {
        layout: {
          horizontal: "",
          vertical: "",
          grid: "w-full items-center"
        }
      }
    },
    optionLabel: {
      _common: "font-bold",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200 dark:text-neutral-600",
          false: "text-neutral-900 dark:text-neutral-100"
        }
      }
    },
    optionLabelSecondary: {
      _common: "font-bold",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200",
          false: "text-neutral-900"
        }
      }
    },
    optionSublabel: {
      _common: "leading-3 text-xs",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200",
          false: "text-neutral-400"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    innerElementsLeft: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "ml-1.5 gap-1.5 py-1.5",
          12: "ml-1.5 gap-1.5 py-1.5",
          11: "ml-1.5 gap-1.5 py-1.5",
          10: "ml-1 gap-1 py-1",
          9: "ml-1 gap-1 py-1",
          8: "ml-1 gap-1 py-1"
        }
      }
    },
    innerElementsRight: {
      _common: "flex flex-row h-full items-center px-4",
      propsStateBased: {}
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, OH = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      placeholder: {
        default: "placeholder",
        control: "input"
      },
      prefix: {
        default: !1,
        //"https://",
        control: "input"
      },
      suffix: {
        default: !1,
        //"CZK",
        control: "input"
      },
      status: {
        default: !1,
        //"error",
        control: "select",
        options: [!1, "success", "error", "progress"]
      },
      size: {
        default: 11,
        control: "select",
        options: [14, 12, 11, 10, 9, 8]
      },
      statusMessage: {
        default: "status message",
        control: "input"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      fullWidth: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      },
      long: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    container: {
      _common: "border flex flex-row overflow-hidden",
      propsStateBased: {
        fullWidth: {
          true: "w-full"
        },
        long: {
          false: {
            size: {
              14: "h-14 rounded-xl",
              12: "h-12 rounded-xl",
              11: "h-11 rounded-xl",
              // default
              10: "h-10 rounded-lg",
              9: "h-9 rounded-lg",
              8: "h-8 rounded-lg"
            }
          },
          true: {
            size: {
              14: "rounded-xl",
              12: "rounded-xl",
              11: "rounded-xl",
              // default
              10: "rounded-lg",
              9: "rounded-lg",
              8: "rounded-lg"
            }
          }
        },
        focused: {
          true: {
            _common: "shadow-[0px_0px_0px_1px]",
            status: {
              false: "border-neutral-400 shadow-neutral-400",
              success: "border-neutral-400 shadow-neutral-400",
              error: "border-critical-500 shadow-critical-500",
              progress: "border-neutral-400 shadow-neutral-400"
            }
          },
          false: {
            status: {
              false: "border-neutral-300 dark:border-neutral-700",
              success: "border-neutral-300 dark:border-neutral-700",
              error: "border-critical-500",
              progress: "border-neutral-300 dark:border-neutral-700"
            }
          }
        },
        disabled: {
          true: "bg-neutral-100 dark:bg-neutral-800"
        },
        multiPosition: {
          first: "rounded-b-none",
          middle: "!rounded-none -my-px",
          last: "rounded-t-none"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelInner: {
      // _common: "absolute left-1.5 text-neutral-600 dark:text-neutral-200",
      _common: "left-1.5 text-neutral-600 dark:text-neutral-500 text-left text-sm font-bold pt-0.5",
      propsStateBased: {
        // focused: {
        //   true: "top-1",
        //   false: "top-5",
        // },
      }
    },
    labelLang: {
      _common: "text-sm font-normal text-neutral-600 dark:text-neutral-700 font-element absolute right-0.5 top-0.5"
    },
    labelOptional: {
      _common: "text-neutral-400 dark:text-neutral-800"
    },
    inputFieldWithPlaceholder: {
      _common: "relative h-full min-w-[5rem] overflow-x-hidden overflow-y-hidden"
    },
    placeholder: {
      _common: "flex flex-row items-center justify-start absolute inset-0 z-0 font-normal text-neutral-300 dark:text-neutral-700 pointer-events-none font-element whitespace-nowrap",
      propsStateBased: {
        focused: {
          // true: "top-1",
          // false: "top-5",
        }
      }
    },
    inputField: {
      _common: "text-left text-neutral-900 dark:text-neutral-100",
      propsStateBased: {
        fullWidth: {
          true: "w-full"
        },
        mode: {
          edit: "",
          view: "whitespace-pre-wrap"
        },
        long: {
          false: "h-full",
          true: "h-full my-1.5"
        }
      }
    },
    innerElementsLeft: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "ml-1.5 gap-1.5 py-1.5",
          12: "ml-1.5 gap-1.5 py-1.5",
          11: "ml-1.5 gap-1.5 py-1.5",
          10: "ml-1 gap-1 py-1",
          9: "ml-1 gap-1 py-1",
          8: "ml-1 gap-1 py-1"
        }
      }
    },
    innerElementsRight: {
      _common: "flex flex-row items-end",
      propsStateBased: {
        size: {
          14: "mr-1.5 gap-1.5 py-1.5",
          12: "mr-1.5 gap-1.5 py-1.5",
          11: "mr-1.5 gap-1.5 py-1.5",
          10: "mr-1 gap-1 py-1",
          9: "mr-1 gap-1 py-1",
          8: "mr-1 gap-1 py-1"
        }
      }
    },
    statusIndicator: {
      _common: "flex bg-opacity-10 px-1.5 flex-center",
      propsStateBased: {
        status: {
          success: "bg-success-600",
          error: "bg-critical-600",
          progress: "bg-neutral-600"
        },
        size: {
          14: "rounded-md",
          12: "rounded-md",
          11: "rounded-md",
          10: "rounded",
          9: "rounded",
          8: "rounded"
        }
      }
    },
    statusIndicatorIcon: {
      propsStateBased: {
        status: {
          success: {
            lucide: "Check",
            lucideStrokeWidth: 4,
            class: "w-4 text-success-700"
          },
          error: {
            lucide: "X",
            lucideStrokeWidth: 4,
            class: "w-4 text-critical-700"
          },
          progress: {
            lucide: "Loader2",
            lucideStrokeWidth: 4,
            spin: !0,
            class: "w-4 text-neutral-500"
          }
        }
      }
    },
    statusMessage: {
      _common: "font-normal text-sm font-element",
      propsStateBased: {
        status: {
          success: "text-success-600",
          error: "text-critical-600",
          progress: "text-neutral-600"
        }
      }
    },
    prefixContainer: {
      _common: "flex h-full flex-center",
      propsStateBased: {
        prefixTransparent: {
          true: "pl-3",
          false: "px-3 bg-neutral-100 dark:bg-neutral-800"
        }
      }
    },
    prefixText: {
      _common: "font-semibold text-neutral-400"
    },
    suffixContainer: {
      _common: "flex h-full bg-neutral-100 dark:bg-neutral-800 px-3 flex-center"
    },
    suffixText: {
      _common: "font-semibold text-neutral-400 dark:text-neutral-400"
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
};
function qw(e, a, t) {
  var o, r, l, i, c;
  a == null && (a = 100);
  function u() {
    var k = Date.now() - i;
    k < a && k >= 0 ? o = setTimeout(u, a - k) : (o = null, t || (c = e.apply(l, r), l = r = null));
  }
  var v = function() {
    l = this, r = arguments, i = Date.now();
    var k = t && !o;
    return o || (o = setTimeout(u, a)), k && (c = e.apply(l, r), l = r = null), c;
  };
  return v.clear = function() {
    o && (clearTimeout(o), o = null);
  }, v.flush = function() {
    o && (c = e.apply(l, r), l = r = null, clearTimeout(o), o = null);
  }, v;
}
qw.debounce = qw;
var aL = qw;
const Wx = (e, a) => {
  const t = e.__vccOpts || e;
  for (const [o, r] of a)
    t[o] = r;
  return t;
}, RH = ["name", "value", "placeholder", "autocomplete", "type", "inputmode", "data-1p-ignore"], FH = ["name", "value", "placeholder", "inputmode"], EH = {
  __name: "DatatypeString",
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: null
    },
    name: {
      type: [String, Boolean],
      default: !1
    },
    multiline: {
      type: Boolean,
      default: !1
    },
    lowercase: {
      type: Boolean,
      default: !1
    },
    nospace: {
      type: Boolean,
      default: !1
    },
    regex: {
      type: [String, Boolean],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
      // view | edit
    },
    focus: {
      type: Boolean,
      default: !1
    },
    // parse value as float
    float: {
      type: Boolean,
      default: !1
    },
    // parse value as int
    int: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "text",
      validator: (e) => ["text", "username", "email", "password", "otp"].includes(e)
    },
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#inputmode
    inputMode: {
      type: String,
      default: "text",
      validator: (e) => ["url", "email", "numeric", "decimal", "search"].includes(e)
    },
    placeholder: {
      type: [String, Boolean],
      default: !1
    },
    autocomplete: {
      type: String,
      default: "off"
    }
  },
  emits: [
    "update:modelValue",
    "input",
    "paste",
    "keyup",
    "keydown",
    "focus",
    "blur",
    "enter",
    "mouseup"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = e, r = t, l = U(null), i = U(null), c = U(null), u = F(() => o.long ? i.value : l.value), v = F(() => o.placeholder ? o.placeholder : ""), k = F(() => o.type === "username" ? "username" : o.type === "email" ? "email" : o.type === "password" ? "current-password" : o.type === "otp" ? "one-time-code" : "off"), f = F(() => o.type === "otp" ? "text" : o.type), p = F(() => o.type === "otp" ? "numeric" : o.inputMode);
    function m(G) {
      z(G);
      const ke = A(G);
      r("input", ke), r("update:modelValue", ke);
    }
    function I(G) {
      z(G);
      const ke = A(G);
      r("input", ke), r("update:modelValue", ke), c.value.dataset.replicatedValue = ke;
    }
    function S(G) {
      G.key === "Enter" && r("enter", G), r("keydown", G);
    }
    function C(G) {
      r("keyup", G);
    }
    function B(G) {
      r("focus", G);
    }
    function $(G) {
      r("blur", G);
    }
    function x(G) {
      r("paste", G);
    }
    function q(G) {
      r("mouseup", G);
    }
    function _(G) {
      u.value.focus();
    }
    function A(G, ke) {
      var w;
      if (!G)
        return;
      let T = ke || ((w = G == null ? void 0 : G.target) == null ? void 0 : w.value);
      return o.lowercase && (T = T.toLowerCase()), o.nospace && (T = T.replace(/\s/g, "")), o.regex && (new RegExp(o.regex).test(T) || (T = null)), o.float && (T = parseFloat(T), isNaN(T) && (T = null)), o.int && (T = parseInt(T), isNaN(T) && (T = null)), T != null && T.trim && G.inputType !== "deleteContentBackward" && (T = T.trim()), T === "" && (T = null), T === "true" && (T = !0), T === "false" && (T = !1), T;
    }
    function z(G) {
      if (!J(G)) {
        G.preventDefault(), G.stopPropagation(), G.stopImmediatePropagation();
        return;
      }
    }
    function J(G) {
      if (!o.disabled)
        return ee(G) && Z(G) && se(G);
    }
    function ee(G) {
      return o.nospace ? G.keyCode !== 32 : !0;
    }
    function Z(G) {
      return o.multiline ? !0 : G.keyCode !== 13;
    }
    function se(G) {
      return o.regex && ![8, 46, 9, 37, 38, 39, 40].includes(G.keyCode) && !([65, 67, 86].includes(G.keyCode) && (G.metaKey || G.ctrlKey)) ? new RegExp(`${o.regex}`).test(G.key) : !0;
    }
    return a({
      doFocus: _
    }), Qe(() => {
      o.focus && _(), o.multiline && (c.value.dataset.replicatedValue = o.modelValue);
    }), We(
      () => o.modelValue,
      () => {
        o.multiline && (c.value.dataset.replicatedValue = o.modelValue);
      }
    ), (G, ke) => e.multiline ? e.multiline ? (d(), h("div", {
      key: 1,
      ref_key: "textareaWrap",
      ref: c,
      class: "grow-wrap"
    }, [
      P("textarea", {
        class: "border-none bg-transparent outline-none",
        ref_key: "textarea",
        ref: i,
        name: e.name,
        value: e.modelValue,
        placeholder: v.value,
        spellcheck: "false",
        inputmode: p.value,
        onInput: I,
        onKeydown: S,
        onKeyup: C,
        onFocus: B,
        onBlur: $,
        onPaste: x,
        onMouseup: q
      }, null, 40, FH)
    ], 512)) : y("", !0) : (d(), h("input", {
      key: 0,
      class: be(["font-element bg-transparent outline-none focus:outline-none", [{ lowercase: e.lowercase }, { disabled: e.disabled }, `mode-${e.mode}`]]),
      ref_key: "input",
      ref: l,
      name: e.name,
      value: e.modelValue,
      placeholder: v.value,
      autocomplete: k.value,
      autocapitalize: "none",
      spellcheck: "false",
      type: f.value,
      inputmode: p.value,
      "data-1p-ignore": e.type === "otp" ? "true" : "false",
      onInput: m,
      onKeydown: S,
      onKeyup: C,
      onFocus: B,
      onBlur: $,
      onPaste: x,
      onMouseup: q
    }, null, 42, RH));
  }
}, qI = /* @__PURE__ */ Wx(EH, [["__scopeId", "data-v-40194afa"]]);
function zI(e, a) {
  const t = (r) => {
    r.key === e && (r.preventDefault(), r.stopPropagation(), a("down"));
  }, o = (r) => {
    r.key === e && (r.preventDefault(), r.stopPropagation(), a("up"));
  };
  Qe(() => {
    window.addEventListener("keydown", t), window.addEventListener("keyup", o);
  }), er(() => {
    window.removeEventListener("keydown", t), window.removeEventListener("keyup", o);
  });
}
const UH = {
  key: 0,
  class: "flex flex-col"
}, NH = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, WH = { class: "flex flex-row items-end gap-2" }, GH = {
  key: 1,
  class: "mb-1"
}, ZH = { class: "flex flex-row gap-1.5" }, YH = { key: 0 }, KH = { class: "relative flex w-full flex-col justify-center px-1.5 py-0" }, XH = { key: 0 }, QH = { key: 0 }, JH = { key: 1 }, eV = { key: 0 }, tV = {
  key: 1,
  class: ""
}, aV = { class: "mt-1 text-sm text-neutral-400 dark:text-neutral-700" }, nV = {
  key: 1,
  class: "flex flex-col"
}, oV = {
  key: 0,
  class: "text-sm text-neutral-400 dark:text-neutral-700"
}, Qo = {
  __name: "Input",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: [String, Number]
    },
    langs: {
      type: Array
    },
    prefix: {
      type: [String, Boolean],
      default: !1
    },
    suffix: {
      type: [String, Boolean],
      default: !1
    },
    long: {
      type: Boolean,
      default: !1
    },
    lowercase: {
      type: Boolean,
      default: !1
    },
    nospace: {
      type: Boolean,
      default: !1
    },
    regex: {
      type: [String, Boolean],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: [String, Object, Boolean],
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    name: {
      type: [String, Boolean],
      default: !1
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelInside: {
      type: Boolean,
      default: !1
    },
    labelLang: {
      type: [String, Boolean],
      default: !1
    },
    multiPosition: {
      type: [String, Boolean],
      default: !1,
      validator: (e) => [!1, "first", "middle", "last"].includes(e)
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    padding: {
      type: String,
      default: "default"
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    locale: {
      type: String,
      default: "en"
    },
    status: {
      type: [String, Boolean],
      default: !1
    },
    statusMessage: {
      type: [String, Boolean],
      default: !1
    },
    // how long to wait with emitting input event after typing has stopped
    debounce: {
      type: Number,
      default: 750
    },
    // saving state indicator - init | saving | saved | error
    saveState: {
      // manual
      type: [String, Boolean],
      default: !1
    },
    autoState: {
      // auto -> 'formSaveState' store necessary
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    focus: {
      type: Boolean,
      default: !1
    },
    // parse value as float
    float: {
      type: Boolean,
      default: !1
    },
    // parse value as int
    int: {
      type: Boolean,
      default: !1
    },
    focusOnSlashKey: {
      type: Boolean,
      default: !1
    },
    prefixTransparent: {
      type: Boolean,
      default: !1
    },
    type: {
      type: String,
      default: "text",
      validator: (e) => ["text", "username", "email", "password", "otp"].includes(e)
    },
    container: {
      type: String,
      default: "p",
      validator: (e) => ["p", "input"].includes(e)
    },
    optional: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "update:modelValue",
    "keyup",
    "keydown",
    "enter",
    "focus",
    "blur",
    "input-debounced",
    "mouseup"
  ],
  setup(e, { emit: a }) {
    const t = e, o = a, r = U(null), l = Gt(t, "modelValue"), i = U(t.modelValue), c = U(!1), u = F(() => t.labelInside && t.size >= 11 ? "inside" : "outside"), v = F(() => t.locale === "cs" ? "nepovinné" : "optional");
    F(() => t.int || t.float ? t.placeholder && (i.value === null || i.value === void 0) : t.placeholder && !i.value);
    const k = aL.debounce(function(_, A) {
      $(_);
    }, t.debounce);
    function f(_) {
      o("keyup", _);
    }
    function p(_) {
      o("keydown", _);
    }
    function m(_) {
      o("enter", _);
    }
    function I() {
      c.value = !0, o("focus");
    }
    function S() {
      c.value = !1, o("blur");
    }
    function C(_) {
      o("mouseup", _);
    }
    function B(_) {
      i.value = _, x(_), k(_);
    }
    function $(_) {
      o("input-debounced", _);
    }
    function x(_) {
      o("update:modelValue", _);
    }
    const { ep: q } = Pe({ props: t, locals: { focused: c, labelPosition: u }, defaults: OH });
    return t.focusOnSlashKey && zI("/", () => {
      console.log("You pressed the / key"), r.value.doFocus();
    }), (_, A) => (d(), h("div", j(re(s(q).root)), [
      t.mode == "edit" ? (d(), h("div", UH, [
        t.label || e.statusMessage || _.$slots.buttonOuterTop ? (d(), h("div", NH, [
          t.label && u.value === "outside" ? (d(), h("span", j(H({ key: 0 }, s(q).labelOuter)), [
            lt(N(t.label) + " ", 1),
            e.optional ? (d(), h("span", j(H({ key: 0 }, s(q).labelOptional)), N(v.value), 17)) : y("", !0)
          ], 16)) : y("", !0),
          P("div", WH, [
            e.statusMessage ? (d(), h("span", j(H({ key: 0 }, s(q).statusMessage)), N(e.statusMessage), 17)) : y("", !0),
            _.$slots.buttonOuterTop ? (d(), h("div", GH, [
              te(_.$slots, "buttonOuterTop", {}, () => [
                Le(ft, {
                  variant: "form",
                  size: 5,
                  rounded: "full"
                })
              ])
            ])) : y("", !0)
          ])
        ])) : y("", !0),
        P("div", ZH, [
          P("div", j(re(s(q).container)), [
            e.prefix || _.$slots.prefix ? (d(), h("div", j(H({ key: 0 }, s(q).prefixContainer)), [
              te(_.$slots, "prefix", {}, () => [
                P("span", j(re(s(q).prefixText)), N(e.prefix), 17)
              ])
            ], 16)) : y("", !0),
            P("div", j(re(s(q).innerElementsLeft)), [
              _.$slots.buttonInnerLeft ? (d(), h("div", YH, [
                te(_.$slots, "buttonInnerLeft", {}, () => [
                  Le(ft, {
                    variant: "form",
                    size: 11,
                    rounded: "lg"
                  })
                ])
              ])) : y("", !0)
            ], 16),
            P("div", KH, [
              u.value == "inside" ? (d(), h("div", j(H({ key: 0 }, s(q).labelInner)), [
                t.label ? (d(), h("span", XH, [
                  lt(N(t.label) + " ", 1),
                  e.optional ? (d(), h("span", j(H({ key: 0 }, s(q).labelOptional)), N(v.value), 17)) : y("", !0)
                ])) : y("", !0)
              ], 16)) : y("", !0),
              t.labelLang ? (d(), h("span", j(H({ key: 1 }, s(q).labelLang)), N(t.labelLang), 17)) : y("", !0),
              P("div", j(re(s(q).inputFieldWithPlaceholder)), [
                Le(qI, H({
                  ref_key: "elDatatypeString",
                  ref: r
                }, s(q).inputField, {
                  modelValue: l.value,
                  name: e.name,
                  multiline: e.long,
                  lowercase: e.lowercase,
                  nospace: e.nospace,
                  regex: e.regex,
                  disabled: e.disabled,
                  mode: e.mode,
                  focus: e.focus,
                  int: e.int,
                  float: e.float,
                  type: e.type,
                  container: e.container,
                  placeholder: t.placeholder,
                  "onUpdate:modelValue": B,
                  on_paste: B,
                  onKeyup: f,
                  onKeydown: p,
                  onFocus: I,
                  onBlur: S,
                  onEnter: m,
                  onMouseup: C
                }), null, 16, ["modelValue", "name", "multiline", "lowercase", "nospace", "regex", "disabled", "mode", "focus", "int", "float", "type", "container", "placeholder"])
              ], 16)
            ]),
            P("div", j(re(s(q).innerElementsRight)), [
              _.$slots.buttonInnerTop ? (d(), h("div", QH, [
                te(_.$slots, "buttonInnerTop", {}, () => [
                  Le(ft, {
                    variant: "form",
                    size: 5,
                    rounded: "full"
                  })
                ])
              ])) : y("", !0),
              _.$slots.buttonInnerRight ? (d(), h("div", JH, [
                te(_.$slots, "buttonInnerRight", {}, () => [
                  Le(ft, {
                    variant: "form",
                    size: e.size - 3,
                    rounded: "lg"
                  }, null, 8, ["size"])
                ])
              ])) : y("", !0),
              e.status ? (d(), h("div", j(H({ key: 2 }, s(q).statusIndicator)), [
                Le($e, j(re(s(q).statusIndicatorIcon)), null, 16)
              ], 16)) : y("", !0)
            ], 16),
            e.suffix || _.$slots.suffix ? (d(), h("div", j(H({ key: 1 }, s(q).suffixContainer)), [
              te(_.$slots, "suffix", {}, () => [
                P("span", j(re(s(q).suffixText)), N(e.suffix), 17)
              ])
            ], 16)) : y("", !0)
          ], 16),
          _.$slots.buttonOuterRight ? (d(), h("div", eV, [
            te(_.$slots, "buttonOuterRight", {}, () => [
              Le(ft, {
                variant: "form",
                size: 14,
                rounded: "xl"
              })
            ])
          ])) : y("", !0)
        ]),
        e.caption || _.$slots.caption ? (d(), h("div", tV, [
          te(_.$slots, "caption", {}, () => [
            P("p", aV, N(e.caption), 1)
          ])
        ])) : y("", !0)
      ])) : y("", !0),
      t.mode == "view" ? (d(), h("div", nV, [
        t.label ? (d(), h("span", j(H({ key: 0 }, s(q).labelOuter)), N(t.label), 17)) : y("", !0),
        P("p", j(re(s(q).modeViewValue)), [
          lt(N(l.value) + " ", 1),
          t.labelLang ? (d(), h("span", oV, N(t.labelLang), 1)) : y("", !0)
        ], 16)
      ])) : y("", !0)
    ], 16));
  }
};
function rV(e, a) {
  for (var t = -1, o = e == null ? 0 : e.length, r = Array(o); ++t < o; )
    r[t] = a(e[t], t, e);
  return r;
}
var PI = rV, lV = vr, iV = Yt, cV = "[object Symbol]";
function dV(e) {
  return typeof e == "symbol" || iV(e) && lV(e) == cV;
}
var Gx = dV, sV = St, uV = Gx, hV = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, pV = /^\w*$/;
function yV(e, a) {
  if (sV(e))
    return !1;
  var t = typeof e;
  return t == "number" || t == "symbol" || t == "boolean" || e == null || uV(e) ? !0 : pV.test(e) || !hV.test(e) || a != null && e in Object(a);
}
var nL = yV, _I = Nw, kV = "Expected a function";
function oL(e, a) {
  if (typeof e != "function" || a != null && typeof a != "function")
    throw new TypeError(kV);
  var t = function() {
    var o = arguments, r = a ? a.apply(this, o) : o[0], l = t.cache;
    if (l.has(r))
      return l.get(r);
    var i = e.apply(this, o);
    return t.cache = l.set(r, i) || l, i;
  };
  return t.cache = new (oL.Cache || _I)(), t;
}
oL.Cache = _I;
var mV = oL, fV = mV, vV = 500;
function gV(e) {
  var a = fV(e, function(o) {
    return t.size === vV && t.clear(), o;
  }), t = a.cache;
  return a;
}
var MV = gV, bV = MV, xV = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, wV = /\\(\\)?/g, LV = bV(function(e) {
  var a = [];
  return e.charCodeAt(0) === 46 && a.push(""), e.replace(xV, function(t, o, r, l) {
    a.push(r ? l.replace(wV, "$1") : o || t);
  }), a;
}), SV = LV, YL = Ur, IV = PI, CV = St, AV = Gx, qV = 1 / 0, KL = YL ? YL.prototype : void 0, XL = KL ? KL.toString : void 0;
function jI(e) {
  if (typeof e == "string")
    return e;
  if (CV(e))
    return IV(e, jI) + "";
  if (AV(e))
    return XL ? XL.call(e) : "";
  var a = e + "";
  return a == "0" && 1 / e == -qV ? "-0" : a;
}
var zV = jI, PV = zV;
function _V(e) {
  return e == null ? "" : PV(e);
}
var jV = _V, HV = St, VV = nL, BV = SV, DV = jV;
function TV(e, a) {
  return HV(e) ? e : VV(e, a) ? [e] : BV(DV(e));
}
var HI = TV, $V = Gx, OV = 1 / 0;
function RV(e) {
  if (typeof e == "string" || $V(e))
    return e;
  var a = e + "";
  return a == "0" && 1 / e == -OV ? "-0" : a;
}
var Zx = RV, FV = HI, EV = Zx;
function UV(e, a) {
  a = FV(a, e);
  for (var t = 0, o = a.length; e != null && t < o; )
    e = e[EV(a[t++])];
  return t && t == o ? e : void 0;
}
var rL = UV, NV = "__lodash_hash_undefined__";
function WV(e) {
  return this.__data__.set(e, NV), this;
}
var GV = WV;
function ZV(e) {
  return this.__data__.has(e);
}
var YV = ZV, KV = Nw, XV = GV, QV = YV;
function qx(e) {
  var a = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new KV(); ++a < t; )
    this.add(e[a]);
}
qx.prototype.add = qx.prototype.push = XV;
qx.prototype.has = QV;
var JV = qx;
function eB(e, a) {
  for (var t = -1, o = e == null ? 0 : e.length; ++t < o; )
    if (a(e[t], t, e))
      return !0;
  return !1;
}
var tB = eB;
function aB(e, a) {
  return e.has(a);
}
var nB = aB, oB = JV, rB = tB, lB = nB, iB = 1, cB = 2;
function dB(e, a, t, o, r, l) {
  var i = t & iB, c = e.length, u = a.length;
  if (c != u && !(i && u > c))
    return !1;
  var v = l.get(e), k = l.get(a);
  if (v && k)
    return v == a && k == e;
  var f = -1, p = !0, m = t & cB ? new oB() : void 0;
  for (l.set(e, a), l.set(a, e); ++f < c; ) {
    var I = e[f], S = a[f];
    if (o)
      var C = i ? o(S, I, f, a, e, l) : o(I, S, f, e, a, l);
    if (C !== void 0) {
      if (C)
        continue;
      p = !1;
      break;
    }
    if (m) {
      if (!rB(a, function(B, $) {
        if (!lB(m, $) && (I === B || r(I, B, t, o, l)))
          return m.push($);
      })) {
        p = !1;
        break;
      }
    } else if (!(I === S || r(I, S, t, o, l))) {
      p = !1;
      break;
    }
  }
  return l.delete(e), l.delete(a), p;
}
var VI = dB;
function sB(e) {
  var a = -1, t = Array(e.size);
  return e.forEach(function(o, r) {
    t[++a] = [r, o];
  }), t;
}
var uB = sB;
function hB(e) {
  var a = -1, t = Array(e.size);
  return e.forEach(function(o) {
    t[++a] = o;
  }), t;
}
var pB = hB, QL = Ur, JL = pI, yB = Er, kB = VI, mB = uB, fB = pB, vB = 1, gB = 2, MB = "[object Boolean]", bB = "[object Date]", xB = "[object Error]", wB = "[object Map]", LB = "[object Number]", SB = "[object RegExp]", IB = "[object Set]", CB = "[object String]", AB = "[object Symbol]", qB = "[object ArrayBuffer]", zB = "[object DataView]", eS = QL ? QL.prototype : void 0, uw = eS ? eS.valueOf : void 0;
function PB(e, a, t, o, r, l, i) {
  switch (t) {
    case zB:
      if (e.byteLength != a.byteLength || e.byteOffset != a.byteOffset)
        return !1;
      e = e.buffer, a = a.buffer;
    case qB:
      return !(e.byteLength != a.byteLength || !l(new JL(e), new JL(a)));
    case MB:
    case bB:
    case LB:
      return yB(+e, +a);
    case xB:
      return e.name == a.name && e.message == a.message;
    case SB:
    case CB:
      return e == a + "";
    case wB:
      var c = mB;
    case IB:
      var u = o & vB;
      if (c || (c = fB), e.size != a.size && !u)
        return !1;
      var v = i.get(e);
      if (v)
        return v == a;
      o |= gB, i.set(e, a);
      var k = kB(c(e), c(a), o, r, l, i);
      return i.delete(e), k;
    case AB:
      if (uw)
        return uw.call(e) == uw.call(a);
  }
  return !1;
}
var _B = PB;
function jB(e, a) {
  for (var t = -1, o = a.length, r = e.length; ++t < o; )
    e[r + t] = a[t];
  return e;
}
var BI = jB, HB = BI, VB = St;
function BB(e, a, t) {
  var o = a(e);
  return VB(e) ? o : HB(o, t(e));
}
var DI = BB;
function DB(e, a) {
  for (var t = -1, o = e == null ? 0 : e.length, r = 0, l = []; ++t < o; ) {
    var i = e[t];
    a(i, t, e) && (l[r++] = i);
  }
  return l;
}
var TB = DB;
function $B() {
  return [];
}
var TI = $B, OB = TB, RB = TI, FB = Object.prototype, EB = FB.propertyIsEnumerable, tS = Object.getOwnPropertySymbols, UB = tS ? function(e) {
  return e == null ? [] : (e = Object(e), OB(tS(e), function(a) {
    return EB.call(e, a);
  }));
} : RB, lL = UB, NB = mI, WB = NB(Object.keys, Object), GB = WB, ZB = Yw, YB = GB, KB = Object.prototype, XB = KB.hasOwnProperty;
function QB(e) {
  if (!ZB(e))
    return YB(e);
  var a = [];
  for (var t in Object(e))
    XB.call(e, t) && t != "constructor" && a.push(t);
  return a;
}
var JB = QB, eD = xI, tD = JB, aD = xr;
function nD(e) {
  return aD(e) ? eD(e) : tD(e);
}
var Gr = nD, oD = DI, rD = lL, lD = Gr;
function iD(e) {
  return oD(e, lD, rD);
}
var $I = iD, aS = $I, cD = 1, dD = Object.prototype, sD = dD.hasOwnProperty;
function uD(e, a, t, o, r, l) {
  var i = t & cD, c = aS(e), u = c.length, v = aS(a), k = v.length;
  if (u != k && !i)
    return !1;
  for (var f = u; f--; ) {
    var p = c[f];
    if (!(i ? p in a : sD.call(a, p)))
      return !1;
  }
  var m = l.get(e), I = l.get(a);
  if (m && I)
    return m == a && I == e;
  var S = !0;
  l.set(e, a), l.set(a, e);
  for (var C = i; ++f < u; ) {
    p = c[f];
    var B = e[p], $ = a[p];
    if (o)
      var x = i ? o($, B, p, a, e, l) : o(B, $, p, e, a, l);
    if (!(x === void 0 ? B === $ || r(B, $, t, o, l) : x)) {
      S = !1;
      break;
    }
    C || (C = p == "constructor");
  }
  if (S && !C) {
    var q = e.constructor, _ = a.constructor;
    q != _ && "constructor" in e && "constructor" in a && !(typeof q == "function" && q instanceof q && typeof _ == "function" && _ instanceof _) && (S = !1);
  }
  return l.delete(e), l.delete(a), S;
}
var hD = uD, pD = ar, yD = Et, kD = pD(yD, "DataView"), mD = kD, fD = ar, vD = Et, gD = fD(vD, "Promise"), MD = gD, bD = ar, xD = Et, wD = bD(xD, "Set"), LD = wD, SD = ar, ID = Et, CD = SD(ID, "WeakMap"), AD = CD, zw = mD, Pw = Uw, _w = MD, jw = LD, Hw = AD, OI = vr, wr = cI, nS = "[object Map]", qD = "[object Object]", oS = "[object Promise]", rS = "[object Set]", lS = "[object WeakMap]", iS = "[object DataView]", zD = wr(zw), PD = wr(Pw), _D = wr(_w), jD = wr(jw), HD = wr(Hw), No = OI;
(zw && No(new zw(new ArrayBuffer(1))) != iS || Pw && No(new Pw()) != nS || _w && No(_w.resolve()) != oS || jw && No(new jw()) != rS || Hw && No(new Hw()) != lS) && (No = function(e) {
  var a = OI(e), t = a == qD ? e.constructor : void 0, o = t ? wr(t) : "";
  if (o)
    switch (o) {
      case zD:
        return iS;
      case PD:
        return nS;
      case _D:
        return oS;
      case jD:
        return rS;
      case HD:
        return lS;
    }
  return a;
});
var Yx = No, hw = Ox, VD = VI, BD = _B, DD = hD, cS = Yx, dS = St, sS = Rx, TD = Jw, $D = 1, uS = "[object Arguments]", hS = "[object Array]", tl = "[object Object]", OD = Object.prototype, pS = OD.hasOwnProperty;
function RD(e, a, t, o, r, l) {
  var i = dS(e), c = dS(a), u = i ? hS : cS(e), v = c ? hS : cS(a);
  u = u == uS ? tl : u, v = v == uS ? tl : v;
  var k = u == tl, f = v == tl, p = u == v;
  if (p && sS(e)) {
    if (!sS(a))
      return !1;
    i = !0, k = !1;
  }
  if (p && !k)
    return l || (l = new hw()), i || TD(e) ? VD(e, a, t, o, r, l) : BD(e, a, u, t, o, r, l);
  if (!(t & $D)) {
    var m = k && pS.call(e, "__wrapped__"), I = f && pS.call(a, "__wrapped__");
    if (m || I) {
      var S = m ? e.value() : e, C = I ? a.value() : a;
      return l || (l = new hw()), r(S, C, t, o, l);
    }
  }
  return p ? (l || (l = new hw()), DD(e, a, t, o, r, l)) : !1;
}
var FD = RD, ED = FD, yS = Yt;
function RI(e, a, t, o, r) {
  return e === a ? !0 : e == null || a == null || !yS(e) && !yS(a) ? e !== e && a !== a : ED(e, a, t, o, RI, r);
}
var FI = RI, UD = Ox, ND = FI, WD = 1, GD = 2;
function ZD(e, a, t, o) {
  var r = t.length, l = r, i = !o;
  if (e == null)
    return !l;
  for (e = Object(e); r--; ) {
    var c = t[r];
    if (i && c[2] ? c[1] !== e[c[0]] : !(c[0] in e))
      return !1;
  }
  for (; ++r < l; ) {
    c = t[r];
    var u = c[0], v = e[u], k = c[1];
    if (i && c[2]) {
      if (v === void 0 && !(u in e))
        return !1;
    } else {
      var f = new UD();
      if (o)
        var p = o(v, k, u, e, a, f);
      if (!(p === void 0 ? ND(k, v, WD | GD, o, f) : p))
        return !1;
    }
  }
  return !0;
}
var YD = ZD, KD = Ut;
function XD(e) {
  return e === e && !KD(e);
}
var EI = XD, QD = EI, JD = Gr;
function eT(e) {
  for (var a = JD(e), t = a.length; t--; ) {
    var o = a[t], r = e[o];
    a[t] = [o, r, QD(r)];
  }
  return a;
}
var tT = eT;
function aT(e, a) {
  return function(t) {
    return t == null ? !1 : t[e] === a && (a !== void 0 || e in Object(t));
  };
}
var UI = aT, nT = YD, oT = tT, rT = UI;
function lT(e) {
  var a = oT(e);
  return a.length == 1 && a[0][2] ? rT(a[0][0], a[0][1]) : function(t) {
    return t === e || nT(t, e, a);
  };
}
var iT = lT, cT = rL;
function dT(e, a, t) {
  var o = e == null ? void 0 : cT(e, a);
  return o === void 0 ? t : o;
}
var sT = dT;
function uT(e, a) {
  return e != null && a in Object(e);
}
var hT = uT, pT = HI, yT = Kw, kT = St, mT = eL, fT = Xw, vT = Zx;
function gT(e, a, t) {
  a = pT(a, e);
  for (var o = -1, r = a.length, l = !1; ++o < r; ) {
    var i = vT(a[o]);
    if (!(l = e != null && t(e, i)))
      break;
    e = e[i];
  }
  return l || ++o != r ? l : (r = e == null ? 0 : e.length, !!r && fT(r) && mT(i, r) && (kT(e) || yT(e)));
}
var MT = gT, bT = hT, xT = MT;
function wT(e, a) {
  return e != null && xT(e, a, bT);
}
var LT = wT, ST = FI, IT = sT, CT = LT, AT = nL, qT = EI, zT = UI, PT = Zx, _T = 1, jT = 2;
function HT(e, a) {
  return AT(e) && qT(a) ? zT(PT(e), a) : function(t) {
    var o = IT(t, e);
    return o === void 0 && o === a ? CT(t, e) : ST(a, o, _T | jT);
  };
}
var VT = HT;
function BT(e) {
  return function(a) {
    return a == null ? void 0 : a[e];
  };
}
var DT = BT, TT = rL;
function $T(e) {
  return function(a) {
    return TT(a, e);
  };
}
var OT = $T, RT = DT, FT = OT, ET = nL, UT = Zx;
function NT(e) {
  return ET(e) ? RT(UT(e)) : FT(e);
}
var WT = NT, GT = iT, ZT = VT, YT = Ex, KT = St, XT = WT;
function QT(e) {
  return typeof e == "function" ? e : e == null ? YT : typeof e == "object" ? KT(e) ? ZT(e[0], e[1]) : GT(e) : XT(e);
}
var JT = QT, e$ = uI, t$ = Gr;
function a$(e, a) {
  return e && e$(e, a, t$);
}
var n$ = a$, o$ = xr;
function r$(e, a) {
  return function(t, o) {
    if (t == null)
      return t;
    if (!o$(t))
      return e(t, o);
    for (var r = t.length, l = a ? r : -1, i = Object(t); (a ? l-- : ++l < r) && o(i[l], l, i) !== !1; )
      ;
    return t;
  };
}
var l$ = r$, i$ = n$, c$ = l$, d$ = c$(i$), s$ = d$, u$ = s$, h$ = xr;
function p$(e, a) {
  var t = -1, o = h$(e) ? Array(e.length) : [];
  return u$(e, function(r, l, i) {
    o[++t] = a(r, l, i);
  }), o;
}
var y$ = p$;
function k$(e, a) {
  var t = e.length;
  for (e.sort(a); t--; )
    e[t] = e[t].value;
  return e;
}
var m$ = k$, kS = Gx;
function f$(e, a) {
  if (e !== a) {
    var t = e !== void 0, o = e === null, r = e === e, l = kS(e), i = a !== void 0, c = a === null, u = a === a, v = kS(a);
    if (!c && !v && !l && e > a || l && i && u && !c && !v || o && i && u || !t && u || !r)
      return 1;
    if (!o && !l && !v && e < a || v && t && r && !o && !l || c && t && r || !i && r || !u)
      return -1;
  }
  return 0;
}
var v$ = f$, g$ = v$;
function M$(e, a, t) {
  for (var o = -1, r = e.criteria, l = a.criteria, i = r.length, c = t.length; ++o < i; ) {
    var u = g$(r[o], l[o]);
    if (u) {
      if (o >= c)
        return u;
      var v = t[o];
      return u * (v == "desc" ? -1 : 1);
    }
  }
  return e.index - a.index;
}
var b$ = M$, pw = PI, x$ = rL, w$ = JT, L$ = y$, S$ = m$, I$ = Fx, C$ = b$, A$ = Ex, q$ = St;
function z$(e, a, t) {
  a.length ? a = pw(a, function(l) {
    return q$(l) ? function(i) {
      return x$(i, l.length === 1 ? l[0] : l);
    } : l;
  }) : a = [A$];
  var o = -1;
  a = pw(a, I$(w$));
  var r = L$(e, function(l, i, c) {
    var u = pw(a, function(v) {
      return v(l);
    });
    return { criteria: u, index: ++o, value: l };
  });
  return S$(r, function(l, i) {
    return C$(l, i, t);
  });
}
var P$ = z$, _$ = P$, mS = St;
function j$(e, a, t, o) {
  return e == null ? [] : (mS(a) || (a = a == null ? [] : [a]), t = o ? void 0 : t, mS(t) || (t = t == null ? [] : [t]), _$(e, a, t));
}
var H$ = j$;
const iL = /* @__PURE__ */ Vx(H$);
function V$(e, a) {
  for (var t = -1, o = e == null ? 0 : e.length; ++t < o && a(e[t], t, e) !== !1; )
    ;
  return e;
}
var B$ = V$, D$ = Nr, T$ = Gr;
function $$(e, a) {
  return e && D$(a, T$(a), e);
}
var O$ = $$, R$ = Nr, F$ = Wr;
function E$(e, a) {
  return e && R$(a, F$(a), e);
}
var U$ = E$, N$ = Nr, W$ = lL;
function G$(e, a) {
  return N$(e, W$(e), a);
}
var Z$ = G$, Y$ = BI, K$ = Zw, X$ = lL, Q$ = TI, J$ = Object.getOwnPropertySymbols, eO = J$ ? function(e) {
  for (var a = []; e; )
    Y$(a, X$(e)), e = K$(e);
  return a;
} : Q$, NI = eO, tO = Nr, aO = NI;
function nO(e, a) {
  return tO(e, aO(e), a);
}
var oO = nO, rO = DI, lO = NI, iO = Wr;
function cO(e) {
  return rO(e, iO, lO);
}
var dO = cO, sO = Object.prototype, uO = sO.hasOwnProperty;
function hO(e) {
  var a = e.length, t = new e.constructor(a);
  return a && typeof e[0] == "string" && uO.call(e, "index") && (t.index = e.index, t.input = e.input), t;
}
var pO = hO, yO = Gw;
function kO(e, a) {
  var t = a ? yO(e.buffer) : e.buffer;
  return new e.constructor(t, e.byteOffset, e.byteLength);
}
var mO = kO, fO = /\w*$/;
function vO(e) {
  var a = new e.constructor(e.source, fO.exec(e));
  return a.lastIndex = e.lastIndex, a;
}
var gO = vO, fS = Ur, vS = fS ? fS.prototype : void 0, gS = vS ? vS.valueOf : void 0;
function MO(e) {
  return gS ? Object(gS.call(e)) : {};
}
var bO = MO, xO = Gw, wO = mO, LO = gO, SO = bO, IO = yI, CO = "[object Boolean]", AO = "[object Date]", qO = "[object Map]", zO = "[object Number]", PO = "[object RegExp]", _O = "[object Set]", jO = "[object String]", HO = "[object Symbol]", VO = "[object ArrayBuffer]", BO = "[object DataView]", DO = "[object Float32Array]", TO = "[object Float64Array]", $O = "[object Int8Array]", OO = "[object Int16Array]", RO = "[object Int32Array]", FO = "[object Uint8Array]", EO = "[object Uint8ClampedArray]", UO = "[object Uint16Array]", NO = "[object Uint32Array]";
function WO(e, a, t) {
  var o = e.constructor;
  switch (a) {
    case VO:
      return xO(e);
    case CO:
    case AO:
      return new o(+e);
    case BO:
      return wO(e, t);
    case DO:
    case TO:
    case $O:
    case OO:
    case RO:
    case FO:
    case EO:
    case UO:
    case NO:
      return IO(e, t);
    case qO:
      return new o();
    case zO:
    case jO:
      return new o(e);
    case PO:
      return LO(e);
    case _O:
      return new o();
    case HO:
      return SO(e);
  }
}
var GO = WO, ZO = Yx, YO = Yt, KO = "[object Map]";
function XO(e) {
  return YO(e) && ZO(e) == KO;
}
var QO = XO, JO = QO, eR = Fx, MS = Qw, bS = MS && MS.isMap, tR = bS ? eR(bS) : JO, aR = tR, nR = Yx, oR = Yt, rR = "[object Set]";
function lR(e) {
  return oR(e) && nR(e) == rR;
}
var iR = lR, cR = iR, dR = Fx, xS = Qw, wS = xS && xS.isSet, sR = wS ? dR(wS) : cR, uR = sR, hR = Ox, pR = B$, yR = bI, kR = O$, mR = U$, fR = hI, vR = kI, gR = Z$, MR = oO, bR = $I, xR = dO, wR = Yx, LR = pO, SR = GO, IR = fI, CR = St, AR = Rx, qR = aR, zR = Ut, PR = uR, _R = Gr, jR = Wr, HR = 1, VR = 2, BR = 4, WI = "[object Arguments]", DR = "[object Array]", TR = "[object Boolean]", $R = "[object Date]", OR = "[object Error]", GI = "[object Function]", RR = "[object GeneratorFunction]", FR = "[object Map]", ER = "[object Number]", ZI = "[object Object]", UR = "[object RegExp]", NR = "[object Set]", WR = "[object String]", GR = "[object Symbol]", ZR = "[object WeakMap]", YR = "[object ArrayBuffer]", KR = "[object DataView]", XR = "[object Float32Array]", QR = "[object Float64Array]", JR = "[object Int8Array]", eF = "[object Int16Array]", tF = "[object Int32Array]", aF = "[object Uint8Array]", nF = "[object Uint8ClampedArray]", oF = "[object Uint16Array]", rF = "[object Uint32Array]", Fe = {};
Fe[WI] = Fe[DR] = Fe[YR] = Fe[KR] = Fe[TR] = Fe[$R] = Fe[XR] = Fe[QR] = Fe[JR] = Fe[eF] = Fe[tF] = Fe[FR] = Fe[ER] = Fe[ZI] = Fe[UR] = Fe[NR] = Fe[WR] = Fe[GR] = Fe[aF] = Fe[nF] = Fe[oF] = Fe[rF] = !0;
Fe[OR] = Fe[GI] = Fe[ZR] = !1;
function wx(e, a, t, o, r, l) {
  var i, c = a & HR, u = a & VR, v = a & BR;
  if (t && (i = r ? t(e, o, r, l) : t(e)), i !== void 0)
    return i;
  if (!zR(e))
    return e;
  var k = CR(e);
  if (k) {
    if (i = LR(e), !c)
      return vR(e, i);
  } else {
    var f = wR(e), p = f == GI || f == RR;
    if (AR(e))
      return fR(e, c);
    if (f == ZI || f == WI || p && !r) {
      if (i = u || p ? {} : IR(e), !c)
        return u ? MR(e, mR(i, e)) : gR(e, kR(i, e));
    } else {
      if (!Fe[f])
        return r ? e : {};
      i = SR(e, f, c);
    }
  }
  l || (l = new hR());
  var m = l.get(e);
  if (m)
    return m;
  l.set(e, i), PR(e) ? e.forEach(function(C) {
    i.add(wx(C, a, t, C, e, l));
  }) : qR(e) && e.forEach(function(C, B) {
    i.set(B, wx(C, a, t, B, e, l));
  });
  var I = v ? u ? xR : bR : u ? jR : _R, S = k ? void 0 : I(e);
  return pR(S || e, function(C, B) {
    S && (B = C, C = e[B]), yR(i, B, wx(C, a, t, B, e, l));
  }), i;
}
var lF = wx, iF = lF, cF = 1, dF = 4;
function sF(e) {
  return iF(e, cF | dF);
}
var uF = sF;
const zx = /* @__PURE__ */ Vx(uF), hF = {
  key: 0,
  class: "relative flex flex-col"
}, pF = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, yF = ["onClick"], kF = {
  key: 1,
  class: ""
}, mF = { class: "mt-1 text-sm text-neutral-400" }, fF = {
  key: 1,
  class: "flex flex-col"
}, vF = { class: "flex flex-row flex-wrap gap-2" }, LS = {
  __name: "Chips",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    kind: {
      type: String,
      default: "choice"
      // choice | TODO: input | filter | action // TODO: inspo: https://m2.material.io/components/chips#action-chips
    },
    multi: {
      type: Boolean,
      // selecting mutliple chips (array)
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    placeholder: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    filled: {
      type: Boolean,
      default: !1
    },
    collapsible: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "vertical"
      // horizontal, vertical, grid
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    filter: {
      type: Boolean,
      default: !1
    },
    sort: {
      type: Boolean,
      default: !1
    },
    variantSelected: {
      type: String,
      default: "primary"
    },
    variantUnselected: {
      type: String,
      default: "secondary"
    },
    showAddButton: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "add"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, locals: {}, defaults: $H }), l = U(""), i = U(!1);
    F(() => {
      const p = t.options.find((m) => m.value === t.modelValue);
      return p ? p.label : "";
    });
    const c = F(() => t.sort ? iL(t.options, [(p) => p.label.toLowerCase()], ["asc"]) : t.options), u = F(() => {
      if (!l.value)
        return c.value;
      const p = l.value.toLowerCase().trim();
      return c.value.filter((m) => {
        const I = m.label.toLowerCase().trim(), S = m.sublabel ? m.sublabel.toLowerCase().trim() : "", C = m.value.toLowerCase().trim();
        return I.includes(p) || S.includes(p) || C.includes(p);
      });
    }), v = F(() => u.value.filter((p) => {
      var m;
      return t.multi ? (m = t.modelValue) == null ? void 0 : m.includes(p.value) : t.modelValue === p.value;
    }));
    function k(p) {
      if (t.disabled)
        return;
      i.value = !1;
      let m = zx(Br(t.modelValue));
      t.multi ? (m = m || [], m.includes(p.value) ? m.splice(m.indexOf(p.value), 1) : m.push(p.value)) : m === p.value ? m = null : m = p.value, o("update:modelValue", m);
    }
    function f(p) {
      var m;
      return t.multi ? (m = t.modelValue) == null ? void 0 : m.includes(p.value) : t.modelValue === p.value;
    }
    return (p, m) => (d(), h("div", j(re(s(r).root)), [
      t.mode == "edit" ? (d(), h("div", hF, [
        t.label ? (d(), h("div", pF, [
          t.label ? (d(), h("span", j(H({ key: 0 }, s(r).labelOuter)), N(t.label), 17)) : y("", !0)
        ])) : y("", !0),
        P("div", {
          class: "flex w-full flex-row flex-wrap items-center gap-2",
          onClick: m[1] || (m[1] = (I) => i.value = !i.value)
        }, [
          (d(!0), h(ve, null, Ie(u.value, (I) => (d(), h("div", {
            class: "",
            key: I.value,
            onClick: (S) => k(I)
          }, [
            Le(Ax, {
              label: I.label,
              variant: f(I) ? e.variantSelected : e.variantUnselected,
              size: e.size,
              clickable: ""
            }, null, 8, ["label", "variant", "size"])
          ], 8, yF))), 128)),
          e.showAddButton ? (d(), K(ft, {
            key: 0,
            icon: "Plus",
            circle: "",
            size: e.size,
            onAction: m[0] || (m[0] = (I) => p.$emit("add"))
          }, null, 8, ["size"])) : y("", !0)
        ]),
        e.caption || p.$slots.caption ? (d(), h("div", kF, [
          te(p.$slots, "caption", {}, () => [
            P("p", mF, N(e.caption), 1)
          ])
        ])) : y("", !0)
      ])) : y("", !0),
      t.mode == "view" ? (d(), h("div", fF, [
        t.label ? (d(), h("span", j(H({ key: 0 }, s(r).labelOuter)), N(t.label), 17)) : y("", !0),
        P("div", vF, [
          (d(!0), h(ve, null, Ie(v.value, (I) => (d(), h("div", {
            class: "",
            key: I.value
          }, [
            Le(Ax, {
              label: I.label,
              variant: "secondary",
              size: e.size,
              clickable: !1
            }, null, 8, ["label", "size"])
          ]))), 128))
        ])
      ])) : y("", !0)
    ], 16));
  }
}, gF = { class: "" }, MF = { class: "mb-1 flex w-full flex-row justify-between" }, bF = {
  key: 0,
  class: "mb-1 block text-base font-bold text-neutral-700 dark:text-neutral-600"
}, xF = {
  key: 1,
  class: "mb-1"
}, cX = {
  __name: "InputMulti",
  props: {
    modelValue: {
      type: Object
    },
    langs: {
      type: Array
    },
    placeholders: {
      type: Array,
      default: () => []
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    long: {
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit",
      validator: (e) => ["edit", "view"].includes(e)
    }
  },
  emits: [
    "update:modelValue",
    "keyup",
    "enter",
    "focus",
    "blur",
    "input-debounced",
    "mouseup"
  ],
  setup(e, { emit: a }) {
    const t = e, o = a;
    function r(c) {
      return c === 0 ? "first" : c === t.langs.length - 1 ? "last" : "middle";
    }
    function l(c, u) {
      const v = zx(Br(t.modelValue));
      v[u] = c, o("update:modelValue", v);
    }
    function i(c, u) {
      console.log("onInputDebounced", c, u);
      const v = zx(Br(t.modelValue));
      v[u] = c, console.log("emitting input debouced multi:", v), o("input-debounced", v);
    }
    return (c, u) => (d(), h("div", gF, [
      P("div", MF, [
        e.label ? (d(), h("span", bF, N(e.label), 1)) : y("", !0),
        c.$slots.buttonOuterTop ? (d(), h("div", xF, [
          te(c.$slots, "buttonOuterTop", {}, () => [
            Le(ft, {
              variant: "form",
              size: 5,
              rounded: "full"
            })
          ])
        ])) : y("", !0)
      ]),
      (d(!0), h(ve, null, Ie(e.langs, (v, k) => (d(), h("div", {
        class: "",
        key: v
      }, [
        Le(Qo, {
          modelValue: e.modelValue[v],
          placeholder: e.placeholders[k],
          "multi-position": r(k),
          "label-lang": v,
          long: e.long,
          fullWidth: e.fullWidth,
          mode: e.mode,
          "onUpdate:modelValue": (f) => l(f, v),
          onKeyup: (f) => o("keyup", f, v),
          onEnter: (f) => o("enter", f, v),
          onFocus: (f) => o("focus", f, v),
          onBlur: (f) => o("blur", f, v),
          onInputDebounced: (f) => i(f, v),
          onMouseup: (f) => o("mouseup", f, v)
        }, null, 8, ["modelValue", "placeholder", "multi-position", "label-lang", "long", "fullWidth", "mode", "onUpdate:modelValue", "onKeyup", "onEnter", "onFocus", "onBlur", "onInputDebounced", "onMouseup"])
      ]))), 128))
    ]));
  }
}, wF = {
  composer: {
    props: {
      name: {
        default: !1,
        control: "input"
      },
      lucide: {
        default: "Loader2",
        control: "input"
      },
      lucideSize: {
        default: 24,
        control: "input"
      },
      lucideColor: {
        default: "currentColor",
        control: "input"
      },
      lucideStrokeWidth: {
        default: 2,
        control: "input"
      },
      lucideAbsoluteStrokeWidth: {
        default: !1,
        control: "switch"
      },
      lucideDefaultClass: {
        default: "lucide-icon",
        control: "input"
      },
      spin: {
        default: !0,
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      propsStateBased: {
        spin: {
          true: "animate-spin",
          false: ""
        }
      }
    }
  }
}, LF = ["srcset", "type", "media"], SF = ["src"], dX = /* @__PURE__ */ Object.assign({
  inheritAttrs: !1
  // prevents from applying classes to <picture>
}, {
  __name: "ImageCDN",
  props: {
    urlPrefix: {
      type: [Boolean, String],
      default: !1
    },
    image: {
      type: Object
      // imageId, contentType
    },
    // breakpoint overrides = max image width at widest state of given breakpoint
    // - "auto" - use tailwind breakpoints
    // - "def:400|sm:500|md:600" -> image will be nearest larger of 400px wide on default breakpoint, 500px on sm, 600px on md. lg+ stays default
    // - "lg:1080|xl:1080" -> image will never be wider than 1080px, regardless of screen size. Useful for images that are not full-width.
    breakpoints: {
      type: String
    }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, o = a;
    Pe({ props: t, defaults: wF });
    const r = {
      // breakpoints: [240, 320, 480, 640, 720, 1080, 1280, 1440, 1920, 2560],
      breakpoints: [320, 900, 1300, 1800, 2500],
      devicePixelRatios: [1, 2, 3],
      imageTypes: [
        { mime: "image/webp", extension: "webp" },
        { mime: "image/jpeg", extension: "jpg" }
      ]
    }, l = [
      // {name: "xl", bpWidth: 1200, imgWidth: 2560},
      // {name: "lg", bpWidth: 992, imgWidth: 1280},
      // {name: "md", bpWidth: 768, imgWidth: 1080},
      // {name: "sm", bpWidth: 576, imgWidth: 1080},
      // {name: "xs", bpWidth: 375, imgWidth: 640},
      // {name: "def", bpWidth: 0, imgWidth: 480},
      { name: "xl", bpWidth: 1200, imgWidth: 2500 },
      { name: "lg", bpWidth: 992, imgWidth: 1800 },
      { name: "md", bpWidth: 768, imgWidth: 1300 },
      { name: "sm", bpWidth: 576, imgWidth: 900 },
      { name: "xs", bpWidth: 375, imgWidth: 900 },
      { name: "def", bpWidth: 0, imgWidth: 320 }
    ], i = {}.VITE_ENVIRONMENT === "local_dev" && {}.VITE_USE_EMULATOR === "false" ? {}.VITE_URL_CDN_PRODUCTION : {}.VITE_URL_CDN, c = Fw("FRAMEWORK_ONE_URL_CDN_IMAGES");
    let u = null;
    t.urlPrefix ? u = t.urlPrefix : c != null && c.value ? u = c.value : u = `${i}/images`;
    const k = NC().class, f = U(null), p = F(() => {
      if (!t.breakpoints || t.breakpoints == "auto")
        return {};
      const I = t.breakpoints.split("|"), S = {};
      return I.forEach((C) => {
        const [B, $] = C.split(":");
        S[B] = parseInt($);
      }), S;
    }), m = F(() => {
      if (!l)
        return [];
      const I = [];
      return l.forEach((S) => {
        const C = S.name;
        let B = S.imgWidth;
        const $ = p.value[S.name];
        $ && (B = r.breakpoints.find((x) => x >= $)), r.imageTypes.forEach((x) => {
          const q = C == "def" ? 0 : S.bpWidth, _ = {
            type: x.mime,
            media: `(min-width: ${q}px)`
          };
          let A = [];
          r.devicePixelRatios.forEach((z) => {
            x.extension;
            const J = t.image.contentType === "image/png" ? "c_9" : "q_80", ee = `${u}/${t.image.imageId}$w_${B},${J},x_${z}`;
            A.push(`${ee} ${z}x`), x.mime == "image/jpeg" && z == 1 && !f.value && (f.value = ee);
          }), _.srcset = A.join(", "), I.push(_);
        });
      }), I;
    });
    return (I, S) => (d(), h("picture", {
      onClick: S[0] || (S[0] = (C) => o("click"))
    }, [
      (d(!0), h(ve, null, Ie(m.value, (C, B) => (d(), h("source", {
        key: B,
        srcset: C.srcset,
        type: C.type,
        media: C.media
      }, null, 8, LF))), 128)),
      P("img", {
        class: be(s(k)),
        src: f.value,
        type: "image/jpeg"
      }, null, 10, SF)
    ]));
  }
}), IF = {
  composer: {
    props: {
      mode: {
        default: "edit",
        options: ["edit", "view"],
        control: "select"
      },
      fields: {
        control: "input",
        default: [
          {
            id: "username",
            label: "username",
            ui: "input",
            placeholder: "evazubeck",
            caption: ""
            // status: validation.value.email.status,
            // statusMessage: validation.value.email.statusMessage,
          },
          {
            id: "name",
            label: "name",
            ui: "input",
            placeholder: "eva zu beck",
            caption: ""
            // status: validation.value.email.status,
            // statusMessage: validation.value.email.statusMessage,
          },
          {
            id: "email",
            label: "email",
            ui: "input",
            placeholder: "eva@zubeck.com",
            caption: "unique email tied to account. used for sign-in, notifications and our communication"
            // status: validation.value.email.status,
            // statusMessage: validation.value.email.statusMessage,
          },
          {
            id: "scope",
            label: "scope",
            ui: "radio",
            options: [
              { label: "public", value: "public" },
              { label: "private", value: "private" }
            ],
            caption: "lala"
          },
          {
            id: "someselect",
            label: "someselect",
            ui: "select",
            options: [
              { label: "option1", value: "option1" },
              { label: "option2", value: "option2" }
            ]
          },
          {
            id: "separator1",
            ui: "separator"
          },
          {
            id: "title1",
            title: "some separating title",
            ui: "title"
          },
          {
            id: "somechips",
            label: "somechips",
            ui: "chips",
            options: [
              { label: "option1", value: "option1" },
              { label: "option2", value: "option2" },
              { label: "option3", value: "option3" },
              { label: "option4", value: "option4" },
              { label: "option5", value: "option5" }
            ]
          },
          {
            id: "enabled",
            label: "enabled",
            ui: "switch"
          },
          {
            id: "permissions",
            label: "permissions",
            ui: "subFields",
            subFields: [
              {
                id: "read",
                label: "read",
                ui: "switch"
              },
              {
                id: "write",
                label: "write",
                ui: "switch"
              },
              {
                id: "delete",
                label: "delete",
                ui: "switch"
              },
              {
                id: "special quota",
                label: "special quota",
                ui: "input",
                placeholder: "100",
                caption: "this is a special quota"
              },
              {
                id: "scope",
                label: "scope",
                ui: "radio",
                options: [
                  { label: "public", value: "public" },
                  { label: "private", value: "private" }
                ],
                caption: "lala"
              },
              {
                id: "separator2",
                ui: "separator"
              },
              {
                id: "title2",
                title: "some separating title",
                ui: "title"
              },
              {
                id: "someselect",
                label: "someselect",
                ui: "select",
                options: [
                  { label: "option1", value: "option1" },
                  { label: "option2", value: "option2" }
                ]
              },
              {
                id: "somechips",
                label: "somechips",
                ui: "chips",
                options: [
                  { label: "option1", value: "option1" },
                  { label: "option2", value: "option2" },
                  { label: "option3", value: "option3" },
                  { label: "option4", value: "option4" },
                  { label: "option5", value: "option5" }
                ]
              }
            ]
          }
        ]
      }
    }
  },
  pt: {
    root: {
      _common: "",
      propsStateBased: {}
    }
  }
}, CF = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      modelValue: {
        default: "option-2",
        control: "input"
      },
      options: {
        default: [
          {
            label: "option 1",
            labelSecondary: "label 2",
            sublabel: "sublabel 1",
            value: "option-1"
          },
          {
            label: "option 2",
            sublabel: "sublabel 2",
            value: "option-2"
          },
          {
            label: "option 3",
            sublabel: "sublabel 3",
            value: "option-3",
            disabled: !0
          },
          {
            label: "option 4",
            value: "option-4"
          }
        ],
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      // status: {
      //   default: false, //"error",
      //   control: "select",
      //   options: [false, "success", "error", "progress"],
      // },
      size: {
        default: 11,
        control: "select",
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8]
      },
      // statusMessage: {
      //   default: "status message",
      //   control: "input",
      // },
      disabled: {
        default: !1,
        control: "switch"
      },
      layout: {
        default: "vertical",
        control: "select",
        options: ["horizontal", "vertical", "grid"]
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    options: {
      _common: "gap-2",
      propsStateBased: {
        layout: {
          horizontal: "flex flex-row",
          vertical: "flex flex-col",
          grid: "grid grid-cols-2 gap-2"
        },
        fullWidth: {
          true: "w-full",
          false: "min-w-[300px]"
        }
      }
    },
    option: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "bg-neutral-100",
          false: "outline outline-neutral-300 dark:outline-neutral-800"
        },
        disabled: {
          true: "dark:bg-neutral-800 cursor-not-allowed",
          false: {
            _common: "cursor-pointer",
            filled: {
              true: "hover:bg-neutral-200",
              false: "hover:outline-neutral-400"
            }
          }
        }
      }
    },
    optionSelected: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "outline outline-2 outline-neutral-500 bg-neutral-100 dark:bg-neutral-800 dark:outline-neutral-400",
          false: "outline outline-2 outline-neutral-500 dark:outline-neutral-200"
        }
      }
    },
    optionDisabled: {
      _common: "flex grow flex-row justify-between overflow-hidden transition-all duration-300 ease-in-out w-full",
      propsStateBased: {
        size: {
          24: "h-24 rounded-xl",
          20: "h-20 rounded-xl",
          16: "h-16 rounded-xl",
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        filled: {
          true: "bg-neutral-50",
          false: "outline outline-2 outline-neutral-50"
        }
      }
    },
    optionLabels: {
      _common: "flex flex-col px-4 gap-0 justify-center",
      propsStateBased: {
        layout: {
          horizontal: "",
          vertical: "",
          grid: "w-full items-center"
        }
      }
    },
    optionLabel: {
      _common: "font-bold",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200 dark:text-neutral-600",
          false: "text-neutral-900 dark:text-neutral-100"
        }
      }
    },
    optionLabelSecondary: {
      _common: "font-bold",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200",
          false: "text-neutral-900"
        }
      }
    },
    optionSublabel: {
      _common: "leading-3 text-xs",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200",
          false: "text-neutral-400"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    innerElementsLeft: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "ml-1.5 gap-1.5 py-1.5",
          12: "ml-1.5 gap-1.5 py-1.5",
          11: "ml-1.5 gap-1.5 py-1.5",
          10: "ml-1 gap-1 py-1",
          9: "ml-1 gap-1 py-1",
          8: "ml-1 gap-1 py-1"
        }
      }
    },
    innerElementsRight: {
      _common: "flex flex-row h-full items-center px-4",
      propsStateBased: {}
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, AF = {
  key: 0,
  class: "flex flex-col"
}, qF = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, zF = ["onClick"], PF = {
  key: 1,
  class: ""
}, _F = { class: "mt-1 text-sm text-neutral-400" }, jF = {
  key: 1,
  class: "flex flex-col"
}, SS = {
  __name: "Radio",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: String,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    filled: {
      type: Boolean,
      default: !1
    },
    collapsible: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "vertical"
      // horizontal, vertical, grid
    },
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, locals: {}, defaults: CF }), l = F(() => {
      const c = t.options.find((u) => u.value === t.modelValue);
      return c ? c.label : "";
    });
    function i(c) {
      t.disabled || o("update:modelValue", c.value);
    }
    return (c, u) => (d(), h("div", j(re(s(r).root)), [
      t.mode == "edit" ? (d(), h("div", AF, [
        t.label ? (d(), h("div", qF, [
          t.label ? (d(), h("span", j(H({ key: 0 }, s(r).labelOuter)), N(t.label), 17)) : y("", !0)
        ])) : y("", !0),
        P("div", j(re(s(r).options)), [
          (d(!0), h(ve, null, Ie(e.options, (v, k) => (d(), h("div", {
            class: "flex",
            key: v.value
          }, [
            P("div", H({ ref_for: !0 }, {
              ...v.value !== e.modelValue && { ...s(r).option },
              ...v.value === e.modelValue && { ...s(r).optionSelected },
              ...v.disabled && { ...s(r).optionDisabled }
            }, {
              onClick: (f) => i(v)
            }), [
              P("div", H({ ref_for: !0 }, s(r).optionLabels), [
                P("span", H({ ref_for: !0 }, s(r).optionLabel), N(v.label), 17),
                v.sublabel ? (d(), h("span", H({
                  key: 0,
                  ref_for: !0
                }, s(r).optionSublabel), N(v.sublabel), 17)) : y("", !0)
              ], 16),
              v.labelSecondary && e.layout !== "grid" ? (d(), h("div", H({
                key: 0,
                ref_for: !0
              }, s(r).innerElementsRight), [
                P("span", H({ ref_for: !0 }, s(r).optionLabelSecondary), N(v.labelSecondary), 17)
              ], 16)) : y("", !0)
            ], 16, zF)
          ]))), 128))
        ], 16),
        e.caption || c.$slots.caption ? (d(), h("div", PF, [
          te(c.$slots, "caption", {}, () => [
            P("p", _F, N(e.caption), 1)
          ])
        ])) : y("", !0)
      ])) : y("", !0),
      t.mode == "view" ? (d(), h("div", jF, [
        t.label ? (d(), h("span", j(H({ key: 0 }, s(r).inputLabel)), N(t.label), 17)) : y("", !0),
        P("p", j(re(s(r).modeViewValue)), N(l.value), 17)
      ])) : y("", !0)
    ], 16));
  }
}, HF = {
  composer: {
    props: {
      modelValue: {
        default: !1,
        control: "switch"
      },
      size: {
        default: 6,
        //11,
        control: "select",
        options: [14, 12, 11, 10, 9, 8, 7, 6]
      },
      rounded: {
        default: "full",
        options: ["full", "md"],
        control: "select"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      label: {
        default: "label",
        control: "input"
      },
      labelStart: {
        default: "label",
        control: "input"
      },
      labelEnd: {
        default: "label",
        control: "input"
      },
      sublabelStart: {
        default: "sublabel",
        control: "input"
      },
      sublabelEnd: {
        default: "sublabel",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      }
    }
  },
  pt: {
    root: {},
    switchWrap: {
      _common: "flex flex-row items-center justify-start gap-4"
    },
    switch: {
      _common: "bg-neutral-200 dark:bg-neutral-800 cursor-pointer flex flex-row items-center relative",
      propsStateBased: {
        rounded: {
          full: {
            _common: "rounded-full",
            size: {
              14: "h-14 w-28",
              12: "h-12 w-[5.75rem]",
              11: "h-11 w-20",
              // default
              10: "h-10 w-[4.5rem]",
              9: "h-9 w-16",
              8: "h-8 w-14",
              7: "h-7 w-12",
              6: "h-6 w-10"
            }
          },
          md: {
            size: {
              14: "h-14 w-28 rounded-xl",
              12: "h-12 w-24 rounded-xl",
              11: "h-11 w-20 rounded-xl",
              // default
              10: "h-10 w-20 rounded-lg",
              9: "h-9 w-16 rounded-lg",
              8: "h-8 w-14 rounded-lg",
              7: "h-7 w-12 rounded-lg",
              6: "h-6 w-10 rounded-lg"
            }
          }
        }
      }
    },
    switchToggle: {
      _common: "absolute transition-all duration-300 ease-in-out",
      propsStateBased: {
        rounded: {
          full: {
            _common: "rounded-full",
            size: {
              14: "size-11",
              12: "size-9",
              11: "size-8",
              // default
              10: "size-[1.875rem]",
              9: "size-7",
              8: "size-6",
              7: "size-5",
              6: "size-4"
            }
          },
          md: {
            size: {
              14: "size-14",
              12: "size-12",
              11: "size-8",
              // default
              10: "size-10",
              9: "size-9",
              8: "size-6",
              7: "size-5",
              6: "size-4"
            }
          }
        },
        modelValue: {
          false: {
            _common: "bg-neutral-400 dark:bg-neutral-600",
            size: {
              14: "left-2",
              12: "left-2",
              11: "left-2",
              // default
              10: "left-1.5",
              9: "left-1",
              8: "left-1",
              7: "left-1",
              6: "left-1"
            }
          },
          true: {
            _common: "bg-neutral-800 dark:bg-neutral-100",
            size: {
              14: "left-[3.75rem]",
              12: "left-12",
              11: "left-10",
              // default
              10: "left-9",
              9: "left-8",
              8: "left-7",
              7: "left-6",
              6: "left-5"
            }
          }
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelStart: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelStartWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEndWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEnd: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    sublabelStart: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    sublabelEnd: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, VF = {
  key: 0,
  class: "flex flex-col"
}, BF = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, DF = {
  key: 1,
  class: ""
}, TF = { class: "pl-14 _mt-1 text-sm text-neutral-400 dark:text-neutral-700" }, $F = {
  key: 1,
  class: "flex flex-col"
}, IS = {
  __name: "Switch",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelStart: {
      type: [String, Boolean],
      default: !1
    },
    labelEnd: {
      type: [String, Boolean],
      default: !1
    },
    sublabelStart: {
      type: [String, Boolean],
      default: !1
    },
    sublabelEnd: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, locals: {}, defaults: HF });
    function l() {
      t.disabled || o("update:modelValue", !t.modelValue);
    }
    return (i, c) => (d(), h("div", j(re(s(r).root)), [
      t.mode == "edit" ? (d(), h("div", VF, [
        t.label ? (d(), h("div", BF, [
          t.label ? (d(), h("span", j(H({ key: 0 }, s(r).labelOuter)), N(t.label), 17)) : y("", !0)
        ])) : y("", !0),
        P("div", j(re(s(r).switchWrap)), [
          t.labelStart || t.sublabelStart ? (d(), h("div", j(H({ key: 0 }, s(r).labelStartWrap)), [
            t.labelStart ? (d(), h("span", j(H({ key: 0 }, s(r).labelStart)), N(t.labelStart), 17)) : y("", !0),
            t.sublabelStart ? (d(), h("span", j(H({ key: 1 }, s(r).sublabelStart)), N(t.sublabelStart), 17)) : y("", !0)
          ], 16)) : y("", !0),
          P("div", H(s(r).switch, { onClick: l }), [
            P("div", j(re(s(r).switchToggle)), null, 16)
          ], 16),
          t.labelEnd || t.sublabelEnd ? (d(), h("div", j(H({ key: 1 }, s(r).labelEndWrap)), [
            t.labelEnd ? (d(), h("span", j(H({ key: 0 }, s(r).labelEnd)), N(t.labelEnd), 17)) : y("", !0),
            t.sublabelEnd ? (d(), h("span", j(H({ key: 1 }, s(r).sublabelEnd)), N(t.sublabelEnd), 17)) : y("", !0)
          ], 16)) : y("", !0)
        ], 16),
        e.caption || i.$slots.caption ? (d(), h("div", DF, [
          te(i.$slots, "caption", {}, () => [
            P("p", TF, N(e.caption), 1)
          ])
        ])) : y("", !0)
      ])) : y("", !0),
      t.mode == "view" ? (d(), h("div", $F, [
        t.label || t.labelEnd || t.labelStart ? (d(), h("span", j(H({ key: 0 }, s(r).labelOuter)), N(t.label || t.labelEnd || t.labelStart), 17)) : y("", !0),
        P("p", j(re(s(r).modeViewValue)), N(t.modelValue), 17)
      ])) : y("", !0)
    ], 16));
  }
}, OF = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      modelValue: {
        default: "",
        control: "input"
      },
      placeholder: {
        default: "select something",
        control: "input"
      },
      options: {
        default: [
          {
            label: "option 1",
            labelSecondary: "label 2",
            sublabel: "sublabel 1",
            value: "option-1"
          },
          {
            label: "option 2",
            sublabel: "sublabel 2",
            value: "option-2"
          },
          {
            label: "option 3",
            sublabel: "sublabel 3",
            value: "option-3",
            disabled: !0
          },
          {
            label: "option 4",
            value: "option-4"
          },
          {
            label: "option 5",
            value: "option-5"
          },
          {
            label: "option 6",
            value: "option-6"
          },
          {
            label: "option 7",
            value: "option-7"
          },
          {
            label: "option 8",
            value: "option-8"
          }
        ],
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      // status: {
      //   default: false, //"error",
      //   control: "select",
      //   options: [false, "success", "error", "progress"],
      // },
      size: {
        default: 11,
        control: "select",
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8]
      },
      // statusMessage: {
      //   default: "status message",
      //   control: "input",
      // },
      disabled: {
        default: !1,
        control: "switch"
      },
      layout: {
        default: "vertical",
        control: "select",
        options: ["horizontal", "vertical", "grid"]
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    selectWrapper: {
      _common: "flex min-h-11 w-full flex-row items-center gap-2 rounded-xl p-2 transition-all duration-300 ease-in-out ",
      propsStateBased: {
        disabled: {
          true: "cursor-not-allowed bg-neutral-100 dark:bg-neutral-900 dark:hover:bg-neutral-700",
          false: "cursor-pointer bg-neutral-150 hover:bg-neutral-200 dark:bg-neutral-800 dark:hover:bg-neutral-700"
        }
      }
    },
    selectedValueLabel: {
      _common: "",
      propsStateBased: {
        disabled: {
          true: "text-neutral-400 dark:text-neutral-700",
          false: "text-neutral-800 dark:text-neutral-100"
        }
      }
    },
    placeholder: {
      _common: "text-neutral-400 dark:text-neutral-500"
    },
    chevron: {
      _common: "pointer-events-none shrink-0 mt-0.5",
      propsStateBased: {
        disabled: {
          true: "text-neutral-200 dark:text-neutral-800",
          false: "text-neutral-400 dark:text-neutral-600"
        }
      }
    },
    optionsContainer: {
      _common: "absolute left-0 right-0 top-full z-50 mt-1 flex max-h-64 flex-col gap-0 rounded-2xl border border-neutral-200 bg-white p-2 dark:border-neutral-800 dark:bg-neutral-950"
    },
    option: {
      _common: "flex w-full cursor-pointer flex-row items-center justify-between rounded-lg p-2 transition-all duration-300 ease-in-out hover:bg-neutral-200 dark:hover:bg-neutral-800"
    },
    optionMultiSelected: {
      _common: "flex w-full cursor-pointer flex-row items-center justify-between rounded-lg p-2 transition-all duration-300 ease-in-out hover:bg-neutral-200 dark:hover:bg-neutral-800 bg-neutral-150 dark:bg-neutral-600"
    },
    optionLabelWrap: {
      _common: "flex flex-col"
    },
    optionLabel: {
      _common: "pointer-events-none select-none text-neutral-900 dark:text-neutral-100"
    },
    optionSublabel: {
      _common: "pointer-events-none select-none text-neutral-400 dark:text-neutral-500 text-sm"
    },
    optionCheckIcon: {
      _common: "pointer-events-none text-neutral-900 dark:text-neutral-100"
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    caption: {
      _common: "mt-1 text-sm text-neutral-400 dark:text-neutral-700"
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, RF = {
  key: 0,
  class: "relative flex flex-col"
}, FF = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, EF = { class: "pointer-events-none flex grow select-none flex-row items-center justify-start pl-1 text-left" }, UF = { key: 0 }, NF = {
  key: 1,
  class: "flex flex-row flex-wrap gap-2"
}, WF = { class: "flex flex-col gap-1 overflow-y-scroll" }, GF = ["onClick"], ZF = {
  key: 2,
  class: ""
}, YF = {
  key: 1,
  class: "flex flex-col"
}, KF = {
  key: 2,
  class: "mt-2 flex flex-row flex-wrap gap-2"
}, XF = ["onClick"], CS = {
  __name: "Select",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    multi: {
      type: Boolean,
      // selecting mutliple items (array)
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    placeholder: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    filled: {
      type: Boolean,
      default: !1
    },
    collapsible: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "vertical"
      // horizontal, vertical, grid
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    filter: {
      type: Boolean,
      default: !1
    },
    sort: {
      type: Boolean,
      default: !1
    },
    chipVariantSelected: {
      type: String,
      default: "primary"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { expose: a, emit: t }) {
    const o = e, r = t, { ep: l } = Pe({ props: o, locals: {}, defaults: OF }), i = U(""), c = U(!1), u = U(null), v = U(null);
    U(null);
    const k = F(() => {
      var q;
      if (!((q = o.options) != null && q.find))
        return "";
      const x = o.options.find((_) => _.value === o.modelValue);
      return x ? x.label : "";
    }), f = F(() => {
      var q;
      if (!((q = o.options) != null && q.find))
        return "";
      const x = o.options.find((_) => _.value === o.modelValue);
      return x ? x.sublabel : "";
    }), p = F(() => o.options ? o.sort ? iL(
      o.options,
      [
        (x) => x.sortFirst ? "\0" : "ჿFF",
        // sort first items first
        (x) => x.sortString ? x.sortString : "ჿFF",
        // sort empty sort strings last
        (x) => {
          var q;
          return (q = x.label) != null && q.toLowerCase ? x.label.toLowerCase() : "wtf";
        }
      ],
      ["asc", "asc", "asc"]
    ) : o.options : []), m = F(() => {
      var q;
      if (!((q = i.value) != null && q.toLowerCase))
        return p.value;
      const x = i.value.toLowerCase().trim();
      return p.value.filter((_) => {
        var ee, Z, se;
        const A = (ee = _.label) != null && ee.toLowerCase ? _.label.toLowerCase().trim() : "", z = (Z = _.sublabel) != null && Z.toLowerCase ? _.sublabel.toLowerCase().trim() : "", J = (se = _.value) != null && se.toLowerCase ? _.value.toLowerCase().trim() : "";
        return A.includes(x) || z.includes(x) || J.includes(x);
      });
    }), I = F(() => m.value.filter((x) => {
      var q;
      return (q = o.modelValue) == null ? void 0 : q.includes(x.value);
    }));
    function S() {
      o.disabled || (c.value = !c.value);
    }
    function C(x) {
      if (o.disabled)
        return;
      o.multi || (c.value = !1);
      let q = zx(Br(o.modelValue));
      o.multi ? (q = q || [], q.includes(x.value) ? q.splice(q.indexOf(x.value), 1) : q.push(x.value)) : q = x.value, r("update:modelValue", q);
    }
    function B(x) {
      var q, _;
      (q = u.value) != null && q.contains(x.target) || (_ = v.value) != null && _.contains(x.target) || (console.log("outer click triggered"), c.value = !1);
    }
    function $(x) {
      var q;
      return o.multi && ((q = o.modelValue) != null && q.includes(x.value)) ? l.value.optionMultiSelected : l.value.option;
    }
    return We(c, (x) => {
      x ? window.addEventListener("click", B) : window.removeEventListener("click", B);
    }), a({
      filterOptions: i
      // to be able to reset the filter from parent
    }), (x, q) => {
      var _;
      return d(), h("div", j(re(s(l).root)), [
        o.mode == "edit" ? (d(), h("div", RF, [
          o != null && o.label ? (d(), h("div", FF, [
            o != null && o.label ? (d(), h("span", j(H({ key: 0 }, s(l).labelOuter)), N(o.label), 17)) : y("", !0)
          ])) : y("", !0),
          P("div", H({
            ref_key: "elSelectWrapper",
            ref: u
          }, s(l).selectWrapper, { onClick: S }), [
            P("div", EF, [
              k.value ? (d(), h("span", j(H({ key: 0 }, s(l).selectedValueLabel)), [
                lt(N(k.value) + " ", 1),
                f.value ? (d(), h("span", UF, "(" + N(f.value) + ")", 1)) : y("", !0)
              ], 16)) : y("", !0),
              o.multi && o.modelValue ? (d(), h("div", NF, [
                (d(!0), h(ve, null, Ie(o.modelValue, (A) => {
                  var z;
                  return d(), K(Ax, {
                    key: A,
                    label: (z = e.options.find((J) => J.value === A)) == null ? void 0 : z.label,
                    variant: e.chipVariantSelected,
                    size: 6,
                    clickable: "",
                    disabled: e.disabled
                  }, null, 8, ["label", "variant", "disabled"]);
                }), 128))
              ])) : y("", !0),
              !k.value && !(e.multi && ((_ = o.modelValue) != null && _.length)) ? (d(), h("span", j(H({ key: 2 }, s(l).placeholder)), N(o.placeholder || "select ..."), 17)) : y("", !0)
            ]),
            Ot(Le($e, H(s(l).chevron, {
              lucide: "ChevronDown",
              lucideStrokeWidth: 2.5,
              size: 20
            }), null, 16), [
              [Rt, !c.value]
            ]),
            Ot(Le($e, H(s(l).chevron, {
              lucide: "ChevronUp",
              lucideStrokeWidth: 2.5,
              size: 20
            }), null, 16), [
              [Rt, c.value]
            ])
          ], 16),
          c.value ? (d(), h("div", H({
            key: 1,
            ref_key: "elOptionsContainer",
            ref: v
          }, s(l).optionsContainer), [
            e.filter ? (d(), K(Qo, {
              key: 0,
              class: "mb-2 w-full",
              modelValue: i.value,
              "onUpdate:modelValue": q[0] || (q[0] = (A) => i.value = A),
              placeholder: "search",
              size: 8,
              focus: "",
              fullWidth: ""
            }, null, 8, ["modelValue"])) : y("", !0),
            P("div", WF, [
              (d(!0), h(ve, null, Ie(m.value, (A) => {
                var z;
                return d(), h("div", H({ ref_for: !0 }, $(A), {
                  key: A.value,
                  onClick: (J) => C(A)
                }), [
                  P("div", H({ ref_for: !0 }, s(l).optionLabelWrap), [
                    P("span", H({ ref_for: !0 }, s(l).optionLabel), N(A.label), 17),
                    A.sublabel ? (d(), h("span", H({
                      key: 0,
                      ref_for: !0
                    }, s(l).optionSublabel), N(A.sublabel), 17)) : y("", !0)
                  ], 16),
                  e.multi && ((z = e.modelValue) != null && z.includes(A.value)) ? (d(), K($e, H({
                    key: 0,
                    lucide: "Check",
                    lucideStrokeWidth: "3.5",
                    size: 16,
                    ref_for: !0
                  }, s(l).optionCheckIcon), null, 16)) : y("", !0)
                ], 16, GF);
              }), 128))
            ])
          ], 16)) : y("", !0),
          e.caption || x.$slots.caption ? (d(), h("div", ZF, [
            te(x.$slots, "caption", {}, () => [
              P("p", j(re(s(l).caption)), N(e.caption), 17)
            ])
          ])) : y("", !0)
        ])) : y("", !0),
        o.mode == "view" ? (d(), h("div", YF, [
          o != null && o.label ? (d(), h("span", j(H({ key: 0 }, s(l).labelOuter)), N(o.label), 17)) : y("", !0),
          e.multi ? y("", !0) : (d(), h("p", j(H({ key: 1 }, s(l).modeViewValue)), N(k.value), 17)),
          e.multi ? (d(), h("div", KF, [
            (d(!0), h(ve, null, Ie(I.value, (A) => (d(), h("div", {
              class: "",
              key: A.value,
              onClick: (z) => C(A)
            }, [
              Le(Ax, {
                label: A == null ? void 0 : A.label,
                variant: "secondary",
                size: 6,
                clickable: ""
              }, null, 8, ["label"])
            ], 8, XF))), 128))
          ])) : y("", !0)
        ])) : y("", !0)
      ], 16);
    };
  }
}, QF = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      placeholder: {
        default: "placeholder",
        control: "input"
      },
      prefix: {
        default: !1,
        //"https://",
        control: "input"
      },
      suffix: {
        default: !1,
        //"CZK",
        control: "input"
      },
      status: {
        default: !1,
        //"error",
        control: "select",
        options: [!1, "success", "error", "progress"]
      },
      size: {
        default: 11,
        control: "select",
        options: [14, 12, 11, 10, 9, 8]
      },
      statusMessage: {
        default: "status message",
        control: "input"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      fullWidth: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    container: {
      _common: "border flex flex-row overflow-hidden",
      propsStateBased: {
        fullWidth: {
          true: "w-full"
        },
        size: {
          14: "h-14 rounded-xl",
          12: "h-12 rounded-xl",
          11: "h-11 rounded-xl",
          // default
          10: "h-10 rounded-lg",
          9: "h-9 rounded-lg",
          8: "h-8 rounded-lg"
        },
        focused: {
          true: {
            _common: "shadow-[0px_0px_0px_1px]",
            status: {
              false: "border-neutral-400 shadow-neutral-400",
              success: "border-neutral-400 shadow-neutral-400",
              error: "border-critical-500 shadow-critical-500",
              progress: "border-neutral-400 shadow-neutral-400"
            }
          },
          false: {
            status: {
              false: "border-neutral-300 dark:border-neutral-700",
              success: "border-neutral-300 dark:border-neutral-700",
              error: "border-critical-500",
              progress: "border-neutral-300 dark:border-neutral-700"
            }
          }
        },
        disabled: {
          true: "bg-neutral-100 dark:bg-neutral-800"
        },
        multiPosition: {
          first: "rounded-b-none",
          middle: "!rounded-none -my-px",
          last: "rounded-t-none"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-md pb-1 font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelInner: {
      // _common: "absolute left-1.5 text-neutral-600 dark:text-neutral-200",
      _common: "left-1.5 text-neutral-600 dark:text-neutral-200 text-sm font-bold pt-0.5",
      propsStateBased: {
        // focused: {
        //   true: "top-1",
        //   false: "top-5",
        // },
      }
    },
    labelLang: {
      _common: "text-sm font-normal text-neutral-600 dark:text-neutral-700 font-element absolute right-0.5 top-0.5"
    },
    inputFieldWithPlaceholder: {
      _common: "relative h-full min-w-[10rem]"
    },
    placeholder: {
      _common: "flex flex-row items-center justify-start absolute inset-0 font-normal text-neutral-300 dark:text-neutral-700 pointer-events-none font-element",
      propsStateBased: {
        focused: {
          // true: "top-1",
          // false: "top-5",
        }
      }
    },
    inputField: {
      _common: "flex flex-row items-center justify-start absolute inset-0  text-neutral-900 dark:text-neutral-100",
      propsStateBased: {
        mode: {
          edit: "",
          view: "whitespace-pre-wrap"
        }
      }
    },
    innerElementsLeft: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "ml-1.5 gap-1.5 py-1.5",
          12: "ml-1.5 gap-1.5 py-1.5",
          11: "ml-1.5 gap-1.5 py-1.5",
          10: "ml-1 gap-1 py-1",
          9: "ml-1 gap-1 py-1",
          8: "ml-1 gap-1 py-1"
        }
      }
    },
    innerElementsRight: {
      _common: "flex flex-row",
      propsStateBased: {
        size: {
          14: "mr-1.5 gap-1.5 py-1.5",
          12: "mr-1.5 gap-1.5 py-1.5",
          11: "mr-1.5 gap-1.5 py-1.5",
          10: "mr-1 gap-1 py-1",
          9: "mr-1 gap-1 py-1",
          8: "mr-1 gap-1 py-1"
        }
      }
    },
    statusIndicator: {
      _common: "flex bg-opacity-10 px-1.5 flex-center",
      propsStateBased: {
        status: {
          success: "bg-success-600",
          error: "bg-critical-600",
          progress: "bg-neutral-600"
        },
        size: {
          14: "rounded-md",
          12: "rounded-md",
          11: "rounded-md",
          10: "rounded",
          9: "rounded",
          8: "rounded"
        }
      }
    },
    statusIndicatorIcon: {
      propsStateBased: {
        status: {
          success: {
            lucide: "Check",
            lucideStrokeWidth: 4,
            class: "w-4 text-success-700"
          },
          error: {
            lucide: "X",
            lucideStrokeWidth: 4,
            class: "w-4 text-critical-700"
          },
          progress: {
            lucide: "Loader2",
            lucideStrokeWidth: 4,
            spin: !0,
            class: "w-4 text-neutral-500"
          }
        }
      }
    },
    statusMessage: {
      _common: "font-normal text-sm text-neutral-600 font-element"
    },
    prefixContainer: {
      _common: "flex h-full bg-neutral-100 dark:bg-neutral-800 px-3 flex-center"
    },
    prefixText: {
      _common: "font-semibold text-neutral-400"
    },
    suffixContainer: {
      _common: "flex h-full bg-neutral-100 dark:bg-neutral-800 px-3 flex-center"
    },
    suffixText: {
      _common: "font-semibold text-neutral-400 dark:text-neutral-400"
    }
  }
};
function we(e) {
  const a = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && a === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || a === "[object Number]" || typeof e == "string" || a === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function De(e, a) {
  return e instanceof Date ? new e.constructor(a) : new Date(a);
}
function At(e, a) {
  const t = we(e);
  return isNaN(a) ? De(e, NaN) : (a && t.setDate(t.getDate() + a), t);
}
function zt(e, a) {
  const t = we(e);
  if (isNaN(a))
    return De(e, NaN);
  if (!a)
    return t;
  const o = t.getDate(), r = De(e, t.getTime());
  r.setMonth(t.getMonth() + a + 1, 0);
  const l = r.getDate();
  return o >= l ? r : (t.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    o
  ), t);
}
function YI(e, a) {
  const {
    years: t = 0,
    months: o = 0,
    weeks: r = 0,
    days: l = 0,
    hours: i = 0,
    minutes: c = 0,
    seconds: u = 0
  } = a, v = we(e), k = o || t ? zt(v, o + t * 12) : v, f = l || r ? At(k, l + r * 7) : k, p = c + i * 60, I = (u + p * 60) * 1e3;
  return De(e, f.getTime() + I);
}
function JF(e, a) {
  const t = +we(e);
  return De(e, t + a);
}
const KI = 6048e5, eE = 864e5, tE = 6e4, XI = 36e5, aE = 1e3;
function nE(e, a) {
  return JF(e, a * XI);
}
let oE = {};
function nr() {
  return oE;
}
function Pt(e, a) {
  var c, u, v, k;
  const t = nr(), o = (a == null ? void 0 : a.weekStartsOn) ?? ((u = (c = a == null ? void 0 : a.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? t.weekStartsOn ?? ((k = (v = t.locale) == null ? void 0 : v.options) == null ? void 0 : k.weekStartsOn) ?? 0, r = we(e), l = r.getDay(), i = (l < o ? 7 : 0) + l - o;
  return r.setDate(r.getDate() - i), r.setHours(0, 0, 0, 0), r;
}
function sr(e) {
  return Pt(e, { weekStartsOn: 1 });
}
function QI(e) {
  const a = we(e), t = a.getFullYear(), o = De(e, 0);
  o.setFullYear(t + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const r = sr(o), l = De(e, 0);
  l.setFullYear(t, 0, 4), l.setHours(0, 0, 0, 0);
  const i = sr(l);
  return a.getTime() >= r.getTime() ? t + 1 : a.getTime() >= i.getTime() ? t : t - 1;
}
function AS(e) {
  const a = we(e);
  return a.setHours(0, 0, 0, 0), a;
}
function Px(e) {
  const a = we(e), t = new Date(
    Date.UTC(
      a.getFullYear(),
      a.getMonth(),
      a.getDate(),
      a.getHours(),
      a.getMinutes(),
      a.getSeconds(),
      a.getMilliseconds()
    )
  );
  return t.setUTCFullYear(a.getFullYear()), +e - +t;
}
function JI(e, a) {
  const t = AS(e), o = AS(a), r = +t - Px(t), l = +o - Px(o);
  return Math.round((r - l) / eE);
}
function rE(e) {
  const a = QI(e), t = De(e, 0);
  return t.setFullYear(a, 0, 4), t.setHours(0, 0, 0, 0), sr(t);
}
function lE(e, a) {
  const t = a * 3;
  return zt(e, t);
}
function cL(e, a) {
  return zt(e, a * 12);
}
function qS(e, a) {
  const t = we(e), o = we(a), r = t.getTime() - o.getTime();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function eC(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Hr(e) {
  if (!eC(e) && typeof e != "number")
    return !1;
  const a = we(e);
  return !isNaN(Number(a));
}
function zS(e) {
  const a = we(e);
  return Math.trunc(a.getMonth() / 3) + 1;
}
function iE(e, a) {
  const t = we(e), o = we(a);
  return t.getFullYear() - o.getFullYear();
}
function cE(e, a) {
  const t = we(e), o = we(a), r = qS(t, o), l = Math.abs(iE(t, o));
  t.setFullYear(1584), o.setFullYear(1584);
  const i = qS(t, o) === -r, c = r * (l - +i);
  return c === 0 ? 0 : c;
}
function tC(e, a) {
  const t = we(e.start), o = we(e.end);
  let r = +t > +o;
  const l = r ? +t : +o, i = r ? o : t;
  i.setHours(0, 0, 0, 0);
  let c = (a == null ? void 0 : a.step) ?? 1;
  if (!c)
    return [];
  c < 0 && (c = -c, r = !r);
  const u = [];
  for (; +i <= l; )
    u.push(we(i)), i.setDate(i.getDate() + c), i.setHours(0, 0, 0, 0);
  return r ? u.reverse() : u;
}
function Zo(e) {
  const a = we(e), t = a.getMonth(), o = t - t % 3;
  return a.setMonth(o, 1), a.setHours(0, 0, 0, 0), a;
}
function dE(e, a) {
  const t = we(e.start), o = we(e.end);
  let r = +t > +o;
  const l = r ? +Zo(t) : +Zo(o);
  let i = Zo(r ? o : t), c = (a == null ? void 0 : a.step) ?? 1;
  if (!c)
    return [];
  c < 0 && (c = -c, r = !r);
  const u = [];
  for (; +i <= l; )
    u.push(we(i)), i = lE(i, c);
  return r ? u.reverse() : u;
}
function sE(e) {
  const a = we(e);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function aC(e) {
  const a = we(e), t = a.getFullYear();
  return a.setFullYear(t + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function Tr(e) {
  const a = we(e), t = De(e, 0);
  return t.setFullYear(a.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function nC(e, a) {
  var c, u, v, k;
  const t = nr(), o = (a == null ? void 0 : a.weekStartsOn) ?? ((u = (c = a == null ? void 0 : a.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? t.weekStartsOn ?? ((k = (v = t.locale) == null ? void 0 : v.options) == null ? void 0 : k.weekStartsOn) ?? 0, r = we(e), l = r.getDay(), i = (l < o ? -7 : 0) + 6 - (l - o);
  return r.setDate(r.getDate() + i), r.setHours(23, 59, 59, 999), r;
}
function PS(e) {
  const a = we(e), t = a.getMonth(), o = t - t % 3 + 3;
  return a.setMonth(o, 0), a.setHours(23, 59, 59, 999), a;
}
const uE = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, hE = (e, a, t) => {
  let o;
  const r = uE[e];
  return typeof r == "string" ? o = r : a === 1 ? o = r.one : o = r.other.replace("{{count}}", a.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + o : o + " ago" : o;
};
function yw(e) {
  return (a = {}) => {
    const t = a.width ? String(a.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const pE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, yE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, kE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mE = {
  date: yw({
    formats: pE,
    defaultWidth: "full"
  }),
  time: yw({
    formats: yE,
    defaultWidth: "full"
  }),
  dateTime: yw({
    formats: kE,
    defaultWidth: "full"
  })
}, fE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, vE = (e, a, t, o) => fE[e];
function qr(e) {
  return (a, t) => {
    const o = t != null && t.context ? String(t.context) : "standalone";
    let r;
    if (o === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, c = t != null && t.width ? String(t.width) : i;
      r = e.formattingValues[c] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, c = t != null && t.width ? String(t.width) : e.defaultWidth;
      r = e.values[c] || e.values[i];
    }
    const l = e.argumentCallback ? e.argumentCallback(a) : a;
    return r[l];
  };
}
const gE = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ME = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, bE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, xE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, wE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, LE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, SE = (e, a) => {
  const t = Number(e), o = t % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, IE = {
  ordinalNumber: SE,
  era: qr({
    values: gE,
    defaultWidth: "wide"
  }),
  quarter: qr({
    values: ME,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: qr({
    values: bE,
    defaultWidth: "wide"
  }),
  day: qr({
    values: xE,
    defaultWidth: "wide"
  }),
  dayPeriod: qr({
    values: wE,
    defaultWidth: "wide",
    formattingValues: LE,
    defaultFormattingWidth: "wide"
  })
};
function zr(e) {
  return (a, t = {}) => {
    const o = t.width, r = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], l = a.match(r);
    if (!l)
      return null;
    const i = l[0], c = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], u = Array.isArray(c) ? AE(c, (f) => f.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      CE(c, (f) => f.test(i))
    );
    let v;
    v = e.valueCallback ? e.valueCallback(u) : u, v = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(v)
    ) : v;
    const k = a.slice(i.length);
    return { value: v, rest: k };
  };
}
function CE(e, a) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && a(e[t]))
      return t;
}
function AE(e, a) {
  for (let t = 0; t < e.length; t++)
    if (a(e[t]))
      return t;
}
function qE(e) {
  return (a, t = {}) => {
    const o = a.match(e.matchPattern);
    if (!o)
      return null;
    const r = o[0], l = a.match(e.parsePattern);
    if (!l)
      return null;
    let i = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    const c = a.slice(r.length);
    return { value: i, rest: c };
  };
}
const zE = /^(\d+)(th|st|nd|rd)?/i, PE = /\d+/i, _E = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, jE = {
  any: [/^b/i, /^(a|c)/i]
}, HE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, VE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, BE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, DE = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, TE = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, $E = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, OE = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, RE = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, FE = {
  ordinalNumber: qE({
    matchPattern: zE,
    parsePattern: PE,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: zr({
    matchPatterns: _E,
    defaultMatchWidth: "wide",
    parsePatterns: jE,
    defaultParseWidth: "any"
  }),
  quarter: zr({
    matchPatterns: HE,
    defaultMatchWidth: "wide",
    parsePatterns: VE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: zr({
    matchPatterns: BE,
    defaultMatchWidth: "wide",
    parsePatterns: DE,
    defaultParseWidth: "any"
  }),
  day: zr({
    matchPatterns: TE,
    defaultMatchWidth: "wide",
    parsePatterns: $E,
    defaultParseWidth: "any"
  }),
  dayPeriod: zr({
    matchPatterns: OE,
    defaultMatchWidth: "any",
    parsePatterns: RE,
    defaultParseWidth: "any"
  })
}, oC = {
  code: "en-US",
  formatDistance: hE,
  formatLong: mE,
  formatRelative: vE,
  localize: IE,
  match: FE,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function EE(e) {
  const a = we(e);
  return JI(a, Tr(a)) + 1;
}
function dL(e) {
  const a = we(e), t = +sr(a) - +rE(a);
  return Math.round(t / KI) + 1;
}
function sL(e, a) {
  var k, f, p, m;
  const t = we(e), o = t.getFullYear(), r = nr(), l = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((f = (k = a == null ? void 0 : a.locale) == null ? void 0 : k.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (p = r.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = De(e, 0);
  i.setFullYear(o + 1, 0, l), i.setHours(0, 0, 0, 0);
  const c = Pt(i, a), u = De(e, 0);
  u.setFullYear(o, 0, l), u.setHours(0, 0, 0, 0);
  const v = Pt(u, a);
  return t.getTime() >= c.getTime() ? o + 1 : t.getTime() >= v.getTime() ? o : o - 1;
}
function UE(e, a) {
  var c, u, v, k;
  const t = nr(), o = (a == null ? void 0 : a.firstWeekContainsDate) ?? ((u = (c = a == null ? void 0 : a.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((k = (v = t.locale) == null ? void 0 : v.options) == null ? void 0 : k.firstWeekContainsDate) ?? 1, r = sL(e, a), l = De(e, 0);
  return l.setFullYear(r, 0, o), l.setHours(0, 0, 0, 0), Pt(l, a);
}
function uL(e, a) {
  const t = we(e), o = +Pt(t, a) - +UE(t, a);
  return Math.round(o / KI) + 1;
}
function Oe(e, a) {
  const t = e < 0 ? "-" : "", o = Math.abs(e).toString().padStart(a, "0");
  return t + o;
}
const Qt = {
  // Year
  y(e, a) {
    const t = e.getFullYear(), o = t > 0 ? t : 1 - t;
    return Oe(a === "yy" ? o % 100 : o, a.length);
  },
  // Month
  M(e, a) {
    const t = e.getMonth();
    return a === "M" ? String(t + 1) : Oe(t + 1, 2);
  },
  // Day of the month
  d(e, a) {
    return Oe(e.getDate(), a.length);
  },
  // AM or PM
  a(e, a) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, a) {
    return Oe(e.getHours() % 12 || 12, a.length);
  },
  // Hour [0-23]
  H(e, a) {
    return Oe(e.getHours(), a.length);
  },
  // Minute
  m(e, a) {
    return Oe(e.getMinutes(), a.length);
  },
  // Second
  s(e, a) {
    return Oe(e.getSeconds(), a.length);
  },
  // Fraction of second
  S(e, a) {
    const t = a.length, o = e.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, t - 3)
    );
    return Oe(r, a.length);
  }
}, lr = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, _S = {
  // Era
  G: function(e, a, t) {
    const o = e.getFullYear() > 0 ? 1 : 0;
    switch (a) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(o, { width: "abbreviated" });
      case "GGGGG":
        return t.era(o, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(e, a, t) {
    if (a === "yo") {
      const o = e.getFullYear(), r = o > 0 ? o : 1 - o;
      return t.ordinalNumber(r, { unit: "year" });
    }
    return Qt.y(e, a);
  },
  // Local week-numbering year
  Y: function(e, a, t, o) {
    const r = sL(e, o), l = r > 0 ? r : 1 - r;
    if (a === "YY") {
      const i = l % 100;
      return Oe(i, 2);
    }
    return a === "Yo" ? t.ordinalNumber(l, { unit: "year" }) : Oe(l, a.length);
  },
  // ISO week-numbering year
  R: function(e, a) {
    const t = QI(e);
    return Oe(t, a.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, a) {
    const t = e.getFullYear();
    return Oe(t, a.length);
  },
  // Quarter
  Q: function(e, a, t) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      case "Q":
        return String(o);
      case "QQ":
        return Oe(o, 2);
      case "Qo":
        return t.ordinalNumber(o, { unit: "quarter" });
      case "QQQ":
        return t.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, a, t) {
    const o = Math.ceil((e.getMonth() + 1) / 3);
    switch (a) {
      case "q":
        return String(o);
      case "qq":
        return Oe(o, 2);
      case "qo":
        return t.ordinalNumber(o, { unit: "quarter" });
      case "qqq":
        return t.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, a, t) {
    const o = e.getMonth();
    switch (a) {
      case "M":
      case "MM":
        return Qt.M(e, a);
      case "Mo":
        return t.ordinalNumber(o + 1, { unit: "month" });
      case "MMM":
        return t.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(o, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, a, t) {
    const o = e.getMonth();
    switch (a) {
      case "L":
        return String(o + 1);
      case "LL":
        return Oe(o + 1, 2);
      case "Lo":
        return t.ordinalNumber(o + 1, { unit: "month" });
      case "LLL":
        return t.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(o, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, a, t, o) {
    const r = uL(e, o);
    return a === "wo" ? t.ordinalNumber(r, { unit: "week" }) : Oe(r, a.length);
  },
  // ISO week of year
  I: function(e, a, t) {
    const o = dL(e);
    return a === "Io" ? t.ordinalNumber(o, { unit: "week" }) : Oe(o, a.length);
  },
  // Day of the month
  d: function(e, a, t) {
    return a === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Qt.d(e, a);
  },
  // Day of year
  D: function(e, a, t) {
    const o = EE(e);
    return a === "Do" ? t.ordinalNumber(o, { unit: "dayOfYear" }) : Oe(o, a.length);
  },
  // Day of week
  E: function(e, a, t) {
    const o = e.getDay();
    switch (a) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, a, t, o) {
    const r = e.getDay(), l = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "e":
        return String(l);
      case "ee":
        return Oe(l, 2);
      case "eo":
        return t.ordinalNumber(l, { unit: "day" });
      case "eee":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, a, t, o) {
    const r = e.getDay(), l = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (a) {
      case "c":
        return String(l);
      case "cc":
        return Oe(l, a.length);
      case "co":
        return t.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return t.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, a, t) {
    const o = e.getDay(), r = o === 0 ? 7 : o;
    switch (a) {
      case "i":
        return String(r);
      case "ii":
        return Oe(r, a.length);
      case "io":
        return t.ordinalNumber(r, { unit: "day" });
      case "iii":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, a, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (a) {
      case "a":
      case "aa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, a, t) {
    const o = e.getHours();
    let r;
    switch (o === 12 ? r = lr.noon : o === 0 ? r = lr.midnight : r = o / 12 >= 1 ? "pm" : "am", a) {
      case "b":
      case "bb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, a, t) {
    const o = e.getHours();
    let r;
    switch (o >= 17 ? r = lr.evening : o >= 12 ? r = lr.afternoon : o >= 4 ? r = lr.morning : r = lr.night, a) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, a, t) {
    if (a === "ho") {
      let o = e.getHours() % 12;
      return o === 0 && (o = 12), t.ordinalNumber(o, { unit: "hour" });
    }
    return Qt.h(e, a);
  },
  // Hour [0-23]
  H: function(e, a, t) {
    return a === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Qt.H(e, a);
  },
  // Hour [0-11]
  K: function(e, a, t) {
    const o = e.getHours() % 12;
    return a === "Ko" ? t.ordinalNumber(o, { unit: "hour" }) : Oe(o, a.length);
  },
  // Hour [1-24]
  k: function(e, a, t) {
    let o = e.getHours();
    return o === 0 && (o = 24), a === "ko" ? t.ordinalNumber(o, { unit: "hour" }) : Oe(o, a.length);
  },
  // Minute
  m: function(e, a, t) {
    return a === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Qt.m(e, a);
  },
  // Second
  s: function(e, a, t) {
    return a === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Qt.s(e, a);
  },
  // Fraction of second
  S: function(e, a) {
    return Qt.S(e, a);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, a, t) {
    const o = e.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (a) {
      case "X":
        return HS(o);
      case "XXXX":
      case "XX":
        return Wo(o);
      case "XXXXX":
      case "XXX":
      default:
        return Wo(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, a, t) {
    const o = e.getTimezoneOffset();
    switch (a) {
      case "x":
        return HS(o);
      case "xxxx":
      case "xx":
        return Wo(o);
      case "xxxxx":
      case "xxx":
      default:
        return Wo(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, a, t) {
    const o = e.getTimezoneOffset();
    switch (a) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + jS(o, ":");
      case "OOOO":
      default:
        return "GMT" + Wo(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, a, t) {
    const o = e.getTimezoneOffset();
    switch (a) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + jS(o, ":");
      case "zzzz":
      default:
        return "GMT" + Wo(o, ":");
    }
  },
  // Seconds timestamp
  t: function(e, a, t) {
    const o = Math.trunc(e.getTime() / 1e3);
    return Oe(o, a.length);
  },
  // Milliseconds timestamp
  T: function(e, a, t) {
    const o = e.getTime();
    return Oe(o, a.length);
  }
};
function jS(e, a = "") {
  const t = e > 0 ? "-" : "+", o = Math.abs(e), r = Math.trunc(o / 60), l = o % 60;
  return l === 0 ? t + String(r) : t + String(r) + a + Oe(l, 2);
}
function HS(e, a) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Oe(Math.abs(e) / 60, 2) : Wo(e, a);
}
function Wo(e, a = "") {
  const t = e > 0 ? "-" : "+", o = Math.abs(e), r = Oe(Math.trunc(o / 60), 2), l = Oe(o % 60, 2);
  return t + r + a + l;
}
const VS = (e, a) => {
  switch (e) {
    case "P":
      return a.date({ width: "short" });
    case "PP":
      return a.date({ width: "medium" });
    case "PPP":
      return a.date({ width: "long" });
    case "PPPP":
    default:
      return a.date({ width: "full" });
  }
}, rC = (e, a) => {
  switch (e) {
    case "p":
      return a.time({ width: "short" });
    case "pp":
      return a.time({ width: "medium" });
    case "ppp":
      return a.time({ width: "long" });
    case "pppp":
    default:
      return a.time({ width: "full" });
  }
}, NE = (e, a) => {
  const t = e.match(/(P+)(p+)?/) || [], o = t[1], r = t[2];
  if (!r)
    return VS(e, a);
  let l;
  switch (o) {
    case "P":
      l = a.dateTime({ width: "short" });
      break;
    case "PP":
      l = a.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = a.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      l = a.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", VS(o, a)).replace("{{time}}", rC(r, a));
}, Vw = {
  p: rC,
  P: NE
}, WE = /^D+$/, GE = /^Y+$/, ZE = ["D", "DD", "YY", "YYYY"];
function lC(e) {
  return WE.test(e);
}
function iC(e) {
  return GE.test(e);
}
function Bw(e, a, t) {
  const o = YE(e, a, t);
  if (console.warn(o), ZE.includes(e))
    throw new RangeError(o);
}
function YE(e, a, t) {
  const o = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${a}\`) for formatting ${o} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const KE = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, XE = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, QE = /^'([^]*?)'?$/, JE = /''/g, eU = /[a-zA-Z]/;
function Ft(e, a, t) {
  var k, f, p, m, I, S, C, B;
  const o = nr(), r = (t == null ? void 0 : t.locale) ?? o.locale ?? oC, l = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (k = t == null ? void 0 : t.locale) == null ? void 0 : k.options) == null ? void 0 : f.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((m = (p = o.locale) == null ? void 0 : p.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, i = (t == null ? void 0 : t.weekStartsOn) ?? ((S = (I = t == null ? void 0 : t.locale) == null ? void 0 : I.options) == null ? void 0 : S.weekStartsOn) ?? o.weekStartsOn ?? ((B = (C = o.locale) == null ? void 0 : C.options) == null ? void 0 : B.weekStartsOn) ?? 0, c = we(e);
  if (!Hr(c))
    throw new RangeError("Invalid time value");
  let u = a.match(XE).map(($) => {
    const x = $[0];
    if (x === "p" || x === "P") {
      const q = Vw[x];
      return q($, r.formatLong);
    }
    return $;
  }).join("").match(KE).map(($) => {
    if ($ === "''")
      return { isToken: !1, value: "'" };
    const x = $[0];
    if (x === "'")
      return { isToken: !1, value: tU($) };
    if (_S[x])
      return { isToken: !0, value: $ };
    if (x.match(eU))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: $ };
  });
  r.localize.preprocessor && (u = r.localize.preprocessor(c, u));
  const v = {
    firstWeekContainsDate: l,
    weekStartsOn: i,
    locale: r
  };
  return u.map(($) => {
    if (!$.isToken)
      return $.value;
    const x = $.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && iC(x) || !(t != null && t.useAdditionalDayOfYearTokens) && lC(x)) && Bw(x, a, String(e));
    const q = _S[x[0]];
    return q(c, x, r.localize, v);
  }).join("");
}
function tU(e) {
  const a = e.match(QE);
  return a ? a[1].replace(JE, "'") : e;
}
function aU(e) {
  return we(e).getDay();
}
function nU(e) {
  const a = we(e), t = a.getFullYear(), o = a.getMonth(), r = De(e, 0);
  return r.setFullYear(t, o + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function oU() {
  return Object.assign({}, nr());
}
function Zt(e) {
  return we(e).getHours();
}
function rU(e) {
  let t = we(e).getDay();
  return t === 0 && (t = 7), t;
}
function oa(e) {
  return we(e).getMinutes();
}
function _e(e) {
  return we(e).getMonth();
}
function ur(e) {
  return we(e).getSeconds();
}
function ze(e) {
  return we(e).getFullYear();
}
function hr(e, a) {
  const t = we(e), o = we(a);
  return t.getTime() > o.getTime();
}
function $r(e, a) {
  const t = we(e), o = we(a);
  return +t < +o;
}
function dr(e, a) {
  const t = we(e), o = we(a);
  return +t == +o;
}
function lU(e, a) {
  const t = a instanceof Date ? De(a, 0) : new a(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const iU = 10;
class cC {
  constructor() {
    Me(this, "subPriority", 0);
  }
  validate(a, t) {
    return !0;
  }
}
class cU extends cC {
  constructor(a, t, o, r, l) {
    super(), this.value = a, this.validateValue = t, this.setValue = o, this.priority = r, l && (this.subPriority = l);
  }
  validate(a, t) {
    return this.validateValue(a, this.value, t);
  }
  set(a, t, o) {
    return this.setValue(a, t, this.value, o);
  }
}
class dU extends cC {
  constructor() {
    super(...arguments);
    Me(this, "priority", iU);
    Me(this, "subPriority", -1);
  }
  set(t, o) {
    return o.timestampIsSet ? t : De(t, lU(t, Date));
  }
}
class Te {
  run(a, t, o, r) {
    const l = this.parse(a, t, o, r);
    return l ? {
      setter: new cU(
        l.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: l.rest
    } : null;
  }
  validate(a, t, o) {
    return !0;
  }
}
class sU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 140);
    Me(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, o, r) {
    return o.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const tt = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Dt = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function at(e, a) {
  return e && {
    value: a(e.value),
    rest: e.rest
  };
}
function Ze(e, a) {
  const t = a.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: a.slice(t[0].length)
  } : null;
}
function Tt(e, a) {
  const t = a.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: a.slice(1)
    };
  const o = t[1] === "+" ? 1 : -1, r = t[2] ? parseInt(t[2], 10) : 0, l = t[3] ? parseInt(t[3], 10) : 0, i = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: o * (r * XI + l * tE + i * aE),
    rest: a.slice(t[0].length)
  };
}
function dC(e) {
  return Ze(tt.anyDigitsSigned, e);
}
function Xe(e, a) {
  switch (e) {
    case 1:
      return Ze(tt.singleDigit, a);
    case 2:
      return Ze(tt.twoDigits, a);
    case 3:
      return Ze(tt.threeDigits, a);
    case 4:
      return Ze(tt.fourDigits, a);
    default:
      return Ze(new RegExp("^\\d{1," + e + "}"), a);
  }
}
function _x(e, a) {
  switch (e) {
    case 1:
      return Ze(tt.singleDigitSigned, a);
    case 2:
      return Ze(tt.twoDigitsSigned, a);
    case 3:
      return Ze(tt.threeDigitsSigned, a);
    case 4:
      return Ze(tt.fourDigitsSigned, a);
    default:
      return Ze(new RegExp("^-?\\d{1," + e + "}"), a);
  }
}
function hL(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function sC(e, a) {
  const t = a > 0, o = t ? a : 1 - a;
  let r;
  if (o <= 50)
    r = e || 100;
  else {
    const l = o + 50, i = Math.trunc(l / 100) * 100, c = e >= l % 100;
    r = e + i - (c ? 100 : 0);
  }
  return t ? r : 1 - r;
}
function uC(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class uU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 130);
    Me(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, o, r) {
    const l = (i) => ({
      year: i,
      isTwoDigitYear: o === "yy"
    });
    switch (o) {
      case "y":
        return at(Xe(4, t), l);
      case "yo":
        return at(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return at(Xe(o.length, t), l);
    }
  }
  validate(t, o) {
    return o.isTwoDigitYear || o.year > 0;
  }
  set(t, o, r) {
    const l = t.getFullYear();
    if (r.isTwoDigitYear) {
      const c = sC(
        r.year,
        l
      );
      return t.setFullYear(c, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in o) || o.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class hU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 130);
    Me(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    const l = (i) => ({
      year: i,
      isTwoDigitYear: o === "YY"
    });
    switch (o) {
      case "Y":
        return at(Xe(4, t), l);
      case "Yo":
        return at(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          l
        );
      default:
        return at(Xe(o.length, t), l);
    }
  }
  validate(t, o) {
    return o.isTwoDigitYear || o.year > 0;
  }
  set(t, o, r, l) {
    const i = sL(t, l);
    if (r.isTwoDigitYear) {
      const u = sC(
        r.year,
        i
      );
      return t.setFullYear(
        u,
        0,
        l.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), Pt(t, l);
    }
    const c = !("era" in o) || o.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(c, 0, l.firstWeekContainsDate), t.setHours(0, 0, 0, 0), Pt(t, l);
  }
}
class pU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 130);
    Me(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o) {
    return _x(o === "R" ? 4 : o.length, t);
  }
  set(t, o, r) {
    const l = De(t, 0);
    return l.setFullYear(r, 0, 4), l.setHours(0, 0, 0, 0), sr(l);
  }
}
class yU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 130);
    Me(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, o) {
    return _x(o === "u" ? 4 : o.length, t);
  }
  set(t, o, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class kU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 120);
    Me(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    switch (o) {
      case "Q":
      case "QQ":
        return Xe(o.length, t);
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 4;
  }
  set(t, o, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class mU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 120);
    Me(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    switch (o) {
      case "q":
      case "qq":
        return Xe(o.length, t);
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 4;
  }
  set(t, o, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class fU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    Me(this, "priority", 110);
  }
  parse(t, o, r) {
    const l = (i) => i - 1;
    switch (o) {
      case "M":
        return at(
          Ze(tt.month, t),
          l
        );
      case "MM":
        return at(Xe(2, t), l);
      case "Mo":
        return at(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 11;
  }
  set(t, o, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class vU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 110);
    Me(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    const l = (i) => i - 1;
    switch (o) {
      case "L":
        return at(
          Ze(tt.month, t),
          l
        );
      case "LL":
        return at(Xe(2, t), l);
      case "Lo":
        return at(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          l
        );
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 11;
  }
  set(t, o, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function gU(e, a, t) {
  const o = we(e), r = uL(o, t) - a;
  return o.setDate(o.getDate() - r * 7), o;
}
class MU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 100);
    Me(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    switch (o) {
      case "w":
        return Ze(tt.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 53;
  }
  set(t, o, r, l) {
    return Pt(gU(t, r, l), l);
  }
}
function bU(e, a) {
  const t = we(e), o = dL(t) - a;
  return t.setDate(t.getDate() - o * 7), t;
}
class xU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 100);
    Me(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    switch (o) {
      case "I":
        return Ze(tt.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 53;
  }
  set(t, o, r) {
    return sr(bU(t, r));
  }
}
const wU = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], LU = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class SU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 90);
    Me(this, "subPriority", 1);
    Me(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    switch (o) {
      case "d":
        return Ze(tt.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    const r = t.getFullYear(), l = uC(r), i = t.getMonth();
    return l ? o >= 1 && o <= LU[i] : o >= 1 && o <= wU[i];
  }
  set(t, o, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
}
class IU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 90);
    Me(this, "subpriority", 1);
    Me(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    switch (o) {
      case "D":
      case "DD":
        return Ze(tt.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    const r = t.getFullYear();
    return uC(r) ? o >= 1 && o <= 366 : o >= 1 && o <= 365;
  }
  set(t, o, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
}
function pL(e, a, t) {
  var f, p, m, I;
  const o = nr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (f = t == null ? void 0 : t.locale) == null ? void 0 : f.options) == null ? void 0 : p.weekStartsOn) ?? o.weekStartsOn ?? ((I = (m = o.locale) == null ? void 0 : m.options) == null ? void 0 : I.weekStartsOn) ?? 0, l = we(e), i = l.getDay(), u = (a % 7 + 7) % 7, v = 7 - r, k = a < 0 || a > 6 ? a - (i + v) % 7 : (u + v) % 7 - (i + v) % 7;
  return At(l, k);
}
class CU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 90);
    Me(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 6;
  }
  set(t, o, r, l) {
    return t = pL(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
class AU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 90);
    Me(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o, r, l) {
    const i = (c) => {
      const u = Math.floor((c - 1) / 7) * 7;
      return (c + l.weekStartsOn + 6) % 7 + u;
    };
    switch (o) {
      case "e":
      case "ee":
        return at(Xe(o.length, t), i);
      case "eo":
        return at(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 6;
  }
  set(t, o, r, l) {
    return t = pL(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
class qU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 90);
    Me(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, o, r, l) {
    const i = (c) => {
      const u = Math.floor((c - 1) / 7) * 7;
      return (c + l.weekStartsOn + 6) % 7 + u;
    };
    switch (o) {
      case "c":
      case "cc":
        return at(Xe(o.length, t), i);
      case "co":
        return at(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 6;
  }
  set(t, o, r, l) {
    return t = pL(t, r, l), t.setHours(0, 0, 0, 0), t;
  }
}
function zU(e, a) {
  const t = we(e), o = rU(t), r = a - o;
  return At(t, r);
}
class PU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 90);
    Me(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, o, r) {
    const l = (i) => i === 0 ? 7 : i;
    switch (o) {
      case "i":
      case "ii":
        return Xe(o.length, t);
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      case "iii":
        return at(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiiii":
        return at(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiiiii":
        return at(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
      case "iiii":
      default:
        return at(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          l
        );
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 7;
  }
  set(t, o, r) {
    return t = zU(t, r), t.setHours(0, 0, 0, 0), t;
  }
}
class _U extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 80);
    Me(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, o, r) {
    return t.setHours(hL(r), 0, 0, 0), t;
  }
}
class jU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 80);
    Me(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, o, r) {
    return t.setHours(hL(r), 0, 0, 0), t;
  }
}
class HU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 80);
    Me(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, o, r) {
    return t.setHours(hL(r), 0, 0, 0), t;
  }
}
class VU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 70);
    Me(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "h":
        return Ze(tt.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 12;
  }
  set(t, o, r) {
    const l = t.getHours() >= 12;
    return l && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !l && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class BU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 70);
    Me(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "H":
        return Ze(tt.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 23;
  }
  set(t, o, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
}
class DU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 70);
    Me(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "K":
        return Ze(tt.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 11;
  }
  set(t, o, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class TU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 70);
    Me(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "k":
        return Ze(tt.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 1 && o <= 24;
  }
  set(t, o, r) {
    const l = r <= 24 ? r % 24 : r;
    return t.setHours(l, 0, 0, 0), t;
  }
}
class $U extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 60);
    Me(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "m":
        return Ze(tt.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 59;
  }
  set(t, o, r) {
    return t.setMinutes(r, 0, 0), t;
  }
}
class OU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 50);
    Me(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, o, r) {
    switch (o) {
      case "s":
        return Ze(tt.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return Xe(o.length, t);
    }
  }
  validate(t, o) {
    return o >= 0 && o <= 59;
  }
  set(t, o, r) {
    return t.setSeconds(r, 0), t;
  }
}
class RU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 30);
    Me(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, o) {
    const r = (l) => Math.trunc(l * Math.pow(10, -o.length + 3));
    return at(Xe(o.length, t), r);
  }
  set(t, o, r) {
    return t.setMilliseconds(r), t;
  }
}
class FU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 10);
    Me(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, o) {
    switch (o) {
      case "X":
        return Tt(
          Dt.basicOptionalMinutes,
          t
        );
      case "XX":
        return Tt(Dt.basic, t);
      case "XXXX":
        return Tt(
          Dt.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Tt(
          Dt.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Tt(Dt.extended, t);
    }
  }
  set(t, o, r) {
    return o.timestampIsSet ? t : De(
      t,
      t.getTime() - Px(t) - r
    );
  }
}
class EU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 10);
    Me(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, o) {
    switch (o) {
      case "x":
        return Tt(
          Dt.basicOptionalMinutes,
          t
        );
      case "xx":
        return Tt(Dt.basic, t);
      case "xxxx":
        return Tt(
          Dt.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Tt(
          Dt.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Tt(Dt.extended, t);
    }
  }
  set(t, o, r) {
    return o.timestampIsSet ? t : De(
      t,
      t.getTime() - Px(t) - r
    );
  }
}
class UU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 40);
    Me(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return dC(t);
  }
  set(t, o, r) {
    return [De(t, r * 1e3), { timestampIsSet: !0 }];
  }
}
class NU extends Te {
  constructor() {
    super(...arguments);
    Me(this, "priority", 20);
    Me(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return dC(t);
  }
  set(t, o, r) {
    return [De(t, r), { timestampIsSet: !0 }];
  }
}
const WU = {
  G: new sU(),
  y: new uU(),
  Y: new hU(),
  R: new pU(),
  u: new yU(),
  Q: new kU(),
  q: new mU(),
  M: new fU(),
  L: new vU(),
  w: new MU(),
  I: new xU(),
  d: new SU(),
  D: new IU(),
  E: new CU(),
  e: new AU(),
  c: new qU(),
  i: new PU(),
  a: new _U(),
  b: new jU(),
  B: new HU(),
  h: new VU(),
  H: new BU(),
  K: new DU(),
  k: new TU(),
  m: new $U(),
  s: new OU(),
  S: new RU(),
  X: new FU(),
  x: new EU(),
  t: new UU(),
  T: new NU()
}, GU = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ZU = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, YU = /^'([^]*?)'?$/, KU = /''/g, XU = /\S/, QU = /[a-zA-Z]/;
function Dw(e, a, t, o) {
  var S, C, B, $, x, q, _, A;
  const r = oU(), l = (o == null ? void 0 : o.locale) ?? r.locale ?? oC, i = (o == null ? void 0 : o.firstWeekContainsDate) ?? ((C = (S = o == null ? void 0 : o.locale) == null ? void 0 : S.options) == null ? void 0 : C.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? (($ = (B = r.locale) == null ? void 0 : B.options) == null ? void 0 : $.firstWeekContainsDate) ?? 1, c = (o == null ? void 0 : o.weekStartsOn) ?? ((q = (x = o == null ? void 0 : o.locale) == null ? void 0 : x.options) == null ? void 0 : q.weekStartsOn) ?? r.weekStartsOn ?? ((A = (_ = r.locale) == null ? void 0 : _.options) == null ? void 0 : A.weekStartsOn) ?? 0;
  if (a === "")
    return e === "" ? we(t) : De(t, NaN);
  const u = {
    firstWeekContainsDate: i,
    weekStartsOn: c,
    locale: l
  }, v = [new dU()], k = a.match(ZU).map((z) => {
    const J = z[0];
    if (J in Vw) {
      const ee = Vw[J];
      return ee(z, l.formatLong);
    }
    return z;
  }).join("").match(GU), f = [];
  for (let z of k) {
    !(o != null && o.useAdditionalWeekYearTokens) && iC(z) && Bw(z, a, e), !(o != null && o.useAdditionalDayOfYearTokens) && lC(z) && Bw(z, a, e);
    const J = z[0], ee = WU[J];
    if (ee) {
      const { incompatibleTokens: Z } = ee;
      if (Array.isArray(Z)) {
        const G = f.find(
          (ke) => Z.includes(ke.token) || ke.token === J
        );
        if (G)
          throw new RangeError(
            `The format string mustn't contain \`${G.fullToken}\` and \`${z}\` at the same time`
          );
      } else if (ee.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${z}\` and any other token at the same time`
        );
      f.push({ token: J, fullToken: z });
      const se = ee.run(
        e,
        z,
        l.match,
        u
      );
      if (!se)
        return De(t, NaN);
      v.push(se.setter), e = se.rest;
    } else {
      if (J.match(QU))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + J + "`"
        );
      if (z === "''" ? z = "'" : J === "'" && (z = JU(z)), e.indexOf(z) === 0)
        e = e.slice(z.length);
      else
        return De(t, NaN);
    }
  }
  if (e.length > 0 && XU.test(e))
    return De(t, NaN);
  const p = v.map((z) => z.priority).sort((z, J) => J - z).filter((z, J, ee) => ee.indexOf(z) === J).map(
    (z) => v.filter((J) => J.priority === z).sort((J, ee) => ee.subPriority - J.subPriority)
  ).map((z) => z[0]);
  let m = we(t);
  if (isNaN(m.getTime()))
    return De(t, NaN);
  const I = {};
  for (const z of p) {
    if (!z.validate(m, u))
      return De(t, NaN);
    const J = z.set(m, I, u);
    Array.isArray(J) ? (m = J[0], Object.assign(I, J[1])) : m = J;
  }
  return De(t, m);
}
function JU(e) {
  return e.match(YU)[1].replace(KU, "'");
}
function BS(e, a) {
  const t = Zo(e), o = Zo(a);
  return +t == +o;
}
function eN(e, a) {
  return At(e, -a);
}
function hC(e, a) {
  const t = we(e), o = t.getFullYear(), r = t.getDate(), l = De(e, 0);
  l.setFullYear(o, a, 15), l.setHours(0, 0, 0, 0);
  const i = nU(l);
  return t.setMonth(a, Math.min(r, i)), t;
}
function Re(e, a) {
  let t = we(e);
  return isNaN(+t) ? De(e, NaN) : (a.year != null && t.setFullYear(a.year), a.month != null && (t = hC(t, a.month)), a.date != null && t.setDate(a.date), a.hours != null && t.setHours(a.hours), a.minutes != null && t.setMinutes(a.minutes), a.seconds != null && t.setSeconds(a.seconds), a.milliseconds != null && t.setMilliseconds(a.milliseconds), t);
}
function tN(e, a) {
  const t = we(e);
  return t.setHours(a), t;
}
function pC(e, a) {
  const t = we(e);
  return t.setMilliseconds(a), t;
}
function aN(e, a) {
  const t = we(e);
  return t.setMinutes(a), t;
}
function yC(e, a) {
  const t = we(e);
  return t.setSeconds(a), t;
}
function $t(e, a) {
  const t = we(e);
  return isNaN(+t) ? De(e, NaN) : (t.setFullYear(a), t);
}
function pr(e, a) {
  return zt(e, -a);
}
function nN(e, a) {
  const {
    years: t = 0,
    months: o = 0,
    weeks: r = 0,
    days: l = 0,
    hours: i = 0,
    minutes: c = 0,
    seconds: u = 0
  } = a, v = pr(e, o + t * 12), k = eN(v, l + r * 7), f = c + i * 60, m = (u + f * 60) * 1e3;
  return De(e, k.getTime() - m);
}
function kC(e, a) {
  return cL(e, -a);
}
function Lr() {
  return d(), h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      P("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      P("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      P("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      P("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Lr.compatConfig = {
  MODE: 3
};
function mC() {
  return d(), h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      P("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      P("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
mC.compatConfig = {
  MODE: 3
};
function yL() {
  return d(), h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      P("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
yL.compatConfig = {
  MODE: 3
};
function kL() {
  return d(), h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      P("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
kL.compatConfig = {
  MODE: 3
};
function mL() {
  return d(), h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      P("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      P("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
mL.compatConfig = {
  MODE: 3
};
function fL() {
  return d(), h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      P("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
fL.compatConfig = {
  MODE: 3
};
function vL() {
  return d(), h(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      P("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
vL.compatConfig = {
  MODE: 3
};
const gt = (e, a) => a ? new Date(e.toLocaleString("en-US", { timeZone: a })) : new Date(e), gL = (e, a, t) => Tw(e, a, t) || ce(), oN = (e, a, t) => {
  const o = a.dateInTz ? gt(new Date(e), a.dateInTz) : ce(e);
  return t ? kt(o, !0) : o;
}, Tw = (e, a, t) => {
  if (!e)
    return null;
  const o = t ? kt(ce(e), !0) : ce(e);
  return a ? a.exactMatch ? oN(e, a, t) : gt(o, a.timezone) : o;
}, rN = (e) => {
  if (!e)
    return 0;
  const a = /* @__PURE__ */ new Date(), t = new Date(a.toLocaleString("en-US", { timeZone: "UTC" })), o = new Date(a.toLocaleString("en-US", { timeZone: e })), r = o.getTimezoneOffset() / 60;
  return (+t - +o) / (1e3 * 60 * 60) - r;
};
var Ct = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(Ct || {}), Go = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(Go || {}), Ko = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(Ko || {}), dt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(dt || {});
const lN = ["timestamp", "date", "iso"];
var yt = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(yt || {}), Ge = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(Ge || {});
function DS(e) {
  return (a) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${a}T00:00:00+00:00`)).slice(0, 2);
}
function iN(e) {
  return (a) => Ft(gt(/* @__PURE__ */ new Date(`2017-01-0${a}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const cN = (e, a, t) => {
  const o = [1, 2, 3, 4, 5, 6, 7];
  let r;
  if (e !== null)
    try {
      r = o.map(iN(e));
    } catch {
      r = o.map(DS(a));
    }
  else
    r = o.map(DS(a));
  const l = r.slice(0, t), i = r.slice(t + 1, r.length);
  return [r[t]].concat(...i).concat(...l);
}, ML = (e, a, t) => {
  const o = [];
  for (let r = +e[0]; r <= +e[1]; r++)
    o.push({ value: +r, text: MC(r, a) });
  return t ? o.reverse() : o;
}, fC = (e, a, t) => {
  const o = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((l) => {
    const i = l < 10 ? `0${l}` : l;
    return /* @__PURE__ */ new Date(`2017-${i}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const l = t === "long" ? "LLLL" : "LLL";
      return o.map((i, c) => {
        const u = Ft(gt(i, "UTC"), l, { locale: e });
        return {
          text: u.charAt(0).toUpperCase() + u.substring(1),
          value: c
        };
      });
    } catch {
    }
  const r = new Intl.DateTimeFormat(a, { month: t, timeZone: "UTC" });
  return o.map((l, i) => {
    const c = r.format(l);
    return {
      text: c.charAt(0).toUpperCase() + c.substring(1),
      value: i
    };
  });
}, dN = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], nt = (e) => {
  const a = s(e);
  return a != null && a.$el ? a == null ? void 0 : a.$el : a;
}, sN = (e) => ({ type: "dot", ...e ?? {} }), vC = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, bL = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, ot = (e) => e, TS = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, $S = (e) => e === null, gC = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, uN = (e) => {
  const a = [], t = (o) => o.filter((r) => r);
  for (let o = 0; o < e.length; o += 3) {
    const r = [e[o], e[o + 1], e[o + 2]];
    a.push(t(r));
  }
  return a;
}, Or = (e, a, t) => {
  const o = t != null, r = a != null;
  if (!o && !r)
    return !1;
  const l = +t, i = +a;
  return o && r ? +e > l || +e < i : o ? +e > l : r ? +e < i : !1;
}, yr = (e, a) => uN(e).map((t) => t.map((o) => {
  const { active: r, disabled: l, isBetween: i, highlighted: c } = a(o);
  return {
    ...o,
    active: r,
    disabled: l,
    className: {
      dp__overlay_cell_active: r,
      dp__overlay_cell: !r,
      dp__overlay_cell_disabled: l,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: l && r,
      dp__cell_in_between: i,
      "dp--highlighted": c
    }
  };
})), aa = (e, a, t = !1) => {
  e && a.allowStopPropagation && (t && e.stopImmediatePropagation(), e.stopPropagation());
}, hN = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function pN(e, a) {
  let t = [...document.querySelectorAll(hN())];
  t = t.filter((r) => !e.contains(r) || r.hasAttribute("data-datepicker-instance"));
  const o = t.indexOf(e);
  if (o >= 0 && (a ? o - 1 >= 0 : o + 1 <= t.length))
    return t[o + (a ? -1 : 1)];
}
const yN = (e, a) => e == null ? void 0 : e.querySelector(`[data-dp-element="${a}"]`), MC = (e, a) => new Intl.NumberFormat(a, { useGrouping: !1, style: "decimal" }).format(e), xL = (e) => Ft(e, "dd-MM-yyyy"), kw = (e) => Array.isArray(e), jx = (e, a) => a.get(xL(e)), kN = (e, a) => e ? a ? a instanceof Map ? !!jx(e, a) : a(ce(e)) : !1 : !0, vt = (e, a, t = !1) => {
  if (e.key === Ge.enter || e.key === Ge.space)
    return t && e.preventDefault(), a();
}, OS = (e, a, t, o, r, l) => {
  const i = Dw(e, a.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: l });
  return Hr(i) && eC(i) ? o || r ? i : Re(i, {
    hours: +t.hours,
    minutes: +(t == null ? void 0 : t.minutes),
    seconds: +(t == null ? void 0 : t.seconds),
    milliseconds: 0
  }) : null;
}, mN = (e, a, t, o, r, l) => {
  const i = Array.isArray(t) ? t[0] : t;
  if (typeof a == "string")
    return OS(e, a, i, o, r, l);
  if (Array.isArray(a)) {
    let c = null;
    for (const u of a)
      if (c = OS(e, u, i, o, r, l), c)
        break;
    return c;
  }
  return typeof a == "function" ? a(e) : null;
}, ce = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), fN = (e, a, t) => {
  if (a) {
    const r = (e.getMonth() + 1).toString().padStart(2, "0"), l = e.getDate().toString().padStart(2, "0"), i = e.getHours().toString().padStart(2, "0"), c = e.getMinutes().toString().padStart(2, "0"), u = t ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${r}-${l}T${i}:${c}:${u}.000Z`;
  }
  const o = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(o).toISOString();
}, kt = (e, a) => {
  const t = ce(JSON.parse(JSON.stringify(e))), o = Re(t, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return a ? sE(o) : o;
}, na = (e, a, t, o) => {
  let r = e ? ce(e) : ce();
  return (a || a === 0) && (r = tN(r, +a)), (t || t === 0) && (r = aN(r, +t)), (o || o === 0) && (r = yC(r, +o)), pC(r, 0);
}, Ke = (e, a) => !e || !a ? !1 : $r(kt(e), kt(a)), Ve = (e, a) => !e || !a ? !1 : dr(kt(e), kt(a)), et = (e, a) => !e || !a ? !1 : hr(kt(e), kt(a)), Kx = (e, a, t) => e != null && e[0] && e != null && e[1] ? et(t, e[0]) && Ke(t, e[1]) : e != null && e[0] && a ? et(t, e[0]) && Ke(t, a) || Ke(t, e[0]) && et(t, a) : !1, qt = (e) => {
  const a = Re(new Date(e), { date: 1 });
  return kt(a);
}, mw = (e, a, t) => a && (t || t === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((o) => o === a ? [o, t] : [o, isNaN(+e[o]) ? void 0 : +e[o]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, Xo = (e) => ({
  hours: Zt(e),
  minutes: oa(e),
  seconds: ur(e)
}), bC = (e, a) => {
  if (a) {
    const t = ze(ce(a));
    if (t > e)
      return 12;
    if (t === e)
      return _e(ce(a));
  }
}, xC = (e, a) => {
  if (a) {
    const t = ze(ce(a));
    return t < e ? -1 : t === e ? _e(ce(a)) : void 0;
  }
}, kr = (e) => {
  if (e)
    return ze(ce(e));
}, wC = (e, a) => {
  const t = et(e, a) ? a : e, o = et(a, e) ? a : e;
  return tC({ start: t, end: o });
}, vN = (e) => {
  const a = zt(e, 1);
  return { month: _e(a), year: ze(a) };
}, Nt = (e, a) => {
  const t = Pt(e, { weekStartsOn: +a }), o = nC(e, { weekStartsOn: +a });
  return [t, o];
}, LC = (e, a) => {
  const t = {
    hours: Zt(ce()),
    minutes: oa(ce()),
    seconds: a ? ur(ce()) : 0
  };
  return Object.assign(t, e);
}, ta = (e, a, t) => [Re(ce(e), { date: 1 }), Re(ce(), { month: a, year: t, date: 1 })], Wt = (e, a, t) => {
  let o = e ? ce(e) : ce();
  return (a || a === 0) && (o = hC(o, a)), t && (o = $t(o, t)), o;
}, SC = (e, a, t, o, r) => {
  if (!o || r && !a || !r && !t)
    return !1;
  const l = r ? zt(e, 1) : pr(e, 1), i = [_e(l), ze(l)];
  return r ? !MN(...i, a) : !gN(...i, t);
}, gN = (e, a, t) => Ke(...ta(t, e, a)) || Ve(...ta(t, e, a)), MN = (e, a, t) => et(...ta(t, e, a)) || Ve(...ta(t, e, a)), IC = (e, a, t, o, r, l, i) => {
  if (typeof a == "function" && !i)
    return a(e);
  const c = t ? { locale: t } : void 0;
  return Array.isArray(e) ? `${Ft(e[0], l, c)}${r && !e[1] ? "" : o}${e[1] ? Ft(e[1], l, c) : ""}` : Ft(e, l, c);
}, ir = (e) => {
  if (e)
    return null;
  throw new Error(bL.prop("partial-range"));
}, al = (e, a) => {
  if (a)
    return e();
  throw new Error(bL.prop("range"));
}, $w = (e) => Array.isArray(e) ? Hr(e[0]) && (e[1] ? Hr(e[1]) : !0) : e ? Hr(e) : !1, bN = (e, a) => Re(a ?? ce(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), fw = (e, a, t, o) => {
  if (!e)
    return !0;
  if (o) {
    const r = t === "max" ? $r(e, a) : hr(e, a), l = { seconds: 0, milliseconds: 0 };
    return r || dr(Re(e, l), Re(a, l));
  }
  return t === "max" ? e.getTime() <= a.getTime() : e.getTime() >= a.getTime();
}, vw = (e, a, t) => e ? bN(e, a) : ce(t ?? a), RS = (e, a, t, o, r) => {
  if (Array.isArray(o)) {
    const i = vw(e, o[0], a), c = vw(e, o[1], a);
    return fw(o[0], i, t, !!a) && fw(o[1], c, t, !!a) && r;
  }
  const l = vw(e, o, a);
  return fw(o, l, t, !!a) && r;
}, gw = (e) => Re(ce(), Xo(e)), xN = (e, a) => e instanceof Map ? Array.from(e.values()).filter((t) => ze(ce(t)) === a).map((t) => _e(t)) : [], CC = (e, a, t) => typeof e == "function" ? e({ month: a, year: t }) : !!e.months.find((o) => o.month === a && o.year === t), wL = (e, a) => typeof e == "function" ? e(a) : e.years.includes(a), AC = (e) => Ft(e, "yyyy-MM-dd"), Pr = Rr({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), qC = () => {
  const e = (t) => {
    Pr.menuFocused = t;
  }, a = (t) => {
    Pr.shiftKeyInMenu !== t && (Pr.shiftKeyInMenu = t);
  };
  return {
    control: F(() => ({ shiftKeyInMenu: Pr.shiftKeyInMenu, menuFocused: Pr.menuFocused })),
    setMenuFocused: e,
    setShiftKey: a
  };
}, Ee = Rr({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Mw = U(null), nl = U(!1), bw = U(!1), xw = U(!1), ww = U(!1), ct = U(0), Je = U(0), ra = () => {
  const e = F(() => nl.value ? [...Ee.selectionGrid, Ee.actionRow].filter((f) => f.length) : bw.value ? [
    ...Ee.timePicker[0],
    ...Ee.timePicker[1],
    ww.value ? [] : [Mw.value],
    Ee.actionRow
  ].filter((f) => f.length) : xw.value ? [...Ee.monthPicker, Ee.actionRow] : [Ee.monthYear, ...Ee.calendar, Ee.time, Ee.actionRow].filter((f) => f.length)), a = (f) => {
    ct.value = f ? ct.value + 1 : ct.value - 1;
    let p = null;
    e.value[Je.value] && (p = e.value[Je.value][ct.value]), !p && e.value[Je.value + (f ? 1 : -1)] ? (Je.value = Je.value + (f ? 1 : -1), ct.value = f ? 0 : e.value[Je.value].length - 1) : p || (ct.value = f ? ct.value - 1 : ct.value + 1);
  }, t = (f) => {
    Je.value === 0 && !f || Je.value === e.value.length && f || (Je.value = f ? Je.value + 1 : Je.value - 1, e.value[Je.value] ? e.value[Je.value] && !e.value[Je.value][ct.value] && ct.value !== 0 && (ct.value = e.value[Je.value].length - 1) : Je.value = f ? Je.value - 1 : Je.value + 1);
  }, o = (f) => {
    let p = null;
    e.value[Je.value] && (p = e.value[Je.value][ct.value]), p ? p.focus({ preventScroll: !nl.value }) : ct.value = f ? ct.value - 1 : ct.value + 1;
  }, r = () => {
    a(!0), o(!0);
  }, l = () => {
    a(!1), o(!1);
  }, i = () => {
    t(!1), o(!0);
  }, c = () => {
    t(!0), o(!0);
  }, u = (f, p) => {
    Ee[p] = f;
  }, v = (f, p) => {
    Ee[p] = f;
  }, k = () => {
    ct.value = 0, Je.value = 0;
  };
  return {
    buildMatrix: u,
    buildMultiLevelMatrix: v,
    setTimePickerBackRef: (f) => {
      Mw.value = f;
    },
    setSelectionGrid: (f) => {
      nl.value = f, k(), f || (Ee.selectionGrid = []);
    },
    setTimePicker: (f, p = !1) => {
      bw.value = f, ww.value = p, k(), f || (Ee.timePicker[0] = [], Ee.timePicker[1] = []);
    },
    setTimePickerElements: (f, p = 0) => {
      Ee.timePicker[p] = f;
    },
    arrowRight: r,
    arrowLeft: l,
    arrowUp: i,
    arrowDown: c,
    clearArrowNav: () => {
      Ee.monthYear = [], Ee.calendar = [], Ee.time = [], Ee.actionRow = [], Ee.selectionGrid = [], Ee.timePicker[0] = [], Ee.timePicker[1] = [], nl.value = !1, bw.value = !1, ww.value = !1, xw.value = !1, k(), Mw.value = null;
    },
    setMonthPicker: (f) => {
      xw.value = f, k();
    },
    refSets: Ee
    // exposed for testing
  };
}, FS = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), wN = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (a) => `Increment ${a}`,
  decrementValue: (a) => `Decrement ${a}`,
  openTpOverlay: (a) => `Open ${a} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  ...e ?? {}
}), ES = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, LN = (e) => {
  const a = typeof e == "object" && e, t = {
    static: !0,
    solo: !1
  };
  if (!e)
    return { ...t, count: ES(!1) };
  const o = a ? e : {}, r = a ? o.count ?? !0 : e, l = ES(r);
  return Object.assign(t, o, { count: l });
}, SN = (e, a, t) => e || (typeof t == "string" ? t : a), IN = (e) => typeof e == "boolean" ? e ? FS({}) : !1 : FS(e), CN = (e) => {
  const a = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: !0,
    selectOnFocus: !1,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...a, ...e ?? {}, enabled: !0 } : { ...a, enabled: e };
}, AN = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), qN = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), zN = (e) => {
  const a = { input: !1 };
  return typeof e == "object" ? { ...a, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...a
  };
}, PN = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, ...e ?? {} }), _N = (e) => {
  const a = {
    dates: Array.isArray(e) ? e.map((t) => ce(t)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...a, ...e ?? {} };
}, jN = (e) => typeof e == "object" ? {
  type: (e == null ? void 0 : e.type) ?? "local",
  hideOnOffsetDates: (e == null ? void 0 : e.hideOnOffsetDates) ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, HN = (e, a) => typeof e == "object" ? { enabled: !0, ...{
  noDisabledRange: !1,
  showLastInRange: !0,
  minMaxRawRange: !1,
  partialRange: !0,
  disableTimeRangeValidation: !1,
  maxRange: void 0,
  minRange: void 0,
  autoRange: void 0,
  fixedStart: !1,
  fixedEnd: !1
}, ...e } : {
  enabled: e,
  noDisabledRange: a.noDisabledRange,
  showLastInRange: a.showLastInRange,
  minMaxRawRange: a.minMaxRawRange,
  partialRange: a.partialRange,
  disableTimeRangeValidation: a.disableTimeRangeValidation,
  maxRange: a.maxRange,
  minRange: a.minRange,
  autoRange: a.autoRange,
  fixedStart: a.fixedStart,
  fixedEnd: a.fixedEnd
}, VN = (e, a) => e ? typeof e == "string" ? { timezone: e, exactMatch: !1, dateInTz: void 0, emitTimezone: a, convertModel: !0 } : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? !1,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: a ?? e.emitTimezone,
  convertModel: e.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: a }, Lw = (e, a, t) => new Map(
  e.map((o) => {
    const r = gL(o, a, t);
    return [xL(r), r];
  })
), BN = (e, a) => e.length ? new Map(
  e.map((t) => {
    const o = gL(t.date, a);
    return [xL(o), t];
  })
) : null, DN = (e) => {
  var a;
  return {
    minDate: Tw(e.minDate, e.timezone, e.isSpecific),
    maxDate: Tw(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: kw(e.disabledDates) ? Lw(e.disabledDates, e.timezone, e.isSpecific) : e.disabledDates,
    allowedDates: kw(e.allowedDates) ? Lw(e.allowedDates, e.timezone, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && kw((a = e.highlight) == null ? void 0 : a.dates) ? Lw(e.highlight.dates, e.timezone) : e.highlight,
    markers: BN(e.markers, e.timezone)
  };
}, TN = (e, a) => typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: +a } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? !0
}, $N = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((a) => {
      const t = a, o = e[t], r = typeof e[t] == "string" ? { [o]: !0 } : Object.fromEntries(o.map((l) => [l, !0]));
      return [a, r];
    })
  )
}), Ye = (e) => {
  const a = () => {
    const A = e.enableSeconds ? ":ss" : "", z = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${z}${A}` : `hh${z}${A} aa`;
  }, t = () => {
    var A;
    return e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? a() : e.weekPicker ? `${((A = C.value) == null ? void 0 : A.type) === "iso" ? "RR" : "ww"}-yyyy` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${a()}` : "MM/dd/yyyy";
  }, o = (A) => LC(A, e.enableSeconds), r = () => q.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [o(e.startTime[0]), o(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? o(e.startTime) : null, l = F(() => LN(e.multiCalendars)), i = F(() => r()), c = F(() => wN(e.ariaLabels)), u = F(() => AN(e.filters)), v = F(() => IN(e.transitions)), k = F(() => qN(e.actionRow)), f = F(
    () => SN(e.previewFormat, e.format, t())
  ), p = F(() => CN(e.textInput)), m = F(() => zN(e.inline)), I = F(() => PN(e.config)), S = F(() => _N(e.highlight)), C = F(() => jN(e.weekNumbers)), B = F(() => VN(e.timezone, e.emitTimezone)), $ = F(() => TN(e.multiDates, e.multiDatesLimit)), x = F(
    () => DN({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: S.value,
      markers: e.markers,
      timezone: B.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker
    })
  ), q = F(
    () => HN(e.range, {
      minMaxRawRange: !1,
      maxRange: e.maxRange,
      minRange: e.minRange,
      noDisabledRange: e.noDisabledRange,
      showLastInRange: e.showLastInRange,
      partialRange: e.partialRange,
      disableTimeRangeValidation: e.disableTimeRangeValidation,
      autoRange: e.autoRange,
      fixedStart: e.fixedStart,
      fixedEnd: e.fixedEnd
    })
  ), _ = F(() => $N(e.ui));
  return {
    defaultedTransitions: v,
    defaultedMultiCalendars: l,
    defaultedStartTime: i,
    defaultedAriaLabels: c,
    defaultedFilters: u,
    defaultedActionRow: k,
    defaultedPreviewFormat: f,
    defaultedTextInput: p,
    defaultedInline: m,
    defaultedConfig: I,
    defaultedHighlight: S,
    defaultedWeekNumbers: C,
    defaultedRange: q,
    propDates: x,
    defaultedTz: B,
    defaultedMultiDates: $,
    defaultedUI: _,
    getDefaultPattern: t,
    getDefaultStartTime: r
  };
}, ON = (e, a, t) => {
  const o = U(), { defaultedTextInput: r, defaultedRange: l, defaultedTz: i, defaultedMultiDates: c, getDefaultPattern: u } = Ye(a), v = U(""), k = Gt(a, "format"), f = Gt(a, "formatLocale");
  We(
    o,
    () => {
      typeof a.onInternalModelChange == "function" && e("internal-model-change", o.value, ae(!0));
    },
    { deep: !0 }
  ), We(l, (L, de) => {
    L.enabled !== de.enabled && (o.value = null);
  }), We(k, () => {
    ne();
  });
  const p = (L) => i.value.timezone && i.value.convertModel ? gt(L, i.value.timezone) : L, m = (L) => {
    if (i.value.timezone && i.value.convertModel) {
      const de = rN(i.value.timezone);
      return nE(L, de);
    }
    return L;
  }, I = (L, de, Ce = !1) => IC(
    L,
    a.format,
    a.formatLocale,
    r.value.rangeSeparator,
    a.modelAuto,
    de ?? u(),
    Ce
  ), S = (L) => L ? a.modelType ? me(L) : {
    hours: Zt(L),
    minutes: oa(L),
    seconds: a.enableSeconds ? ur(L) : 0
  } : null, C = (L) => a.modelType ? me(L) : { month: _e(L), year: ze(L) }, B = (L) => Array.isArray(L) ? c.value.enabled ? L.map((de) => $(de, $t(ce(), de))) : al(
    () => [
      $t(ce(), L[0]),
      L[1] ? $t(ce(), L[1]) : ir(l.value.partialRange)
    ],
    l.value.enabled
  ) : $t(ce(), +L), $ = (L, de) => (typeof L == "string" || typeof L == "number") && a.modelType ? ue(L) : de, x = (L) => Array.isArray(L) ? [
    $(
      L[0],
      na(null, +L[0].hours, +L[0].minutes, L[0].seconds)
    ),
    $(
      L[1],
      na(null, +L[1].hours, +L[1].minutes, L[1].seconds)
    )
  ] : $(L, na(null, L.hours, L.minutes, L.seconds)), q = (L) => {
    const de = Re(ce(), { date: 1 });
    return Array.isArray(L) ? c.value.enabled ? L.map((Ce) => $(Ce, Wt(de, +Ce.month, +Ce.year))) : al(
      () => [
        $(L[0], Wt(de, +L[0].month, +L[0].year)),
        $(
          L[1],
          L[1] ? Wt(de, +L[1].month, +L[1].year) : ir(l.value.partialRange)
        )
      ],
      l.value.enabled
    ) : $(L, Wt(de, +L.month, +L.year));
  }, _ = (L) => {
    if (Array.isArray(L))
      return L.map((de) => ue(de));
    throw new Error(bL.dateArr("multi-dates"));
  }, A = (L) => {
    if (Array.isArray(L) && l.value.enabled) {
      const de = L[0], Ce = L[1];
      return [
        ce(Array.isArray(de) ? de[0] : null),
        ce(Array.isArray(Ce) ? Ce[0] : null)
      ];
    }
    return ce(L[0]);
  }, z = (L) => a.modelAuto ? Array.isArray(L) ? [ue(L[0]), ue(L[1])] : a.autoApply ? [ue(L)] : [ue(L), null] : Array.isArray(L) ? al(
    () => L[1] ? [
      ue(L[0]),
      L[1] ? ue(L[1]) : ir(l.value.partialRange)
    ] : [ue(L[0])],
    l.value.enabled
  ) : ue(L), J = () => {
    Array.isArray(o.value) && l.value.enabled && o.value.length === 1 && o.value.push(ir(l.value.partialRange));
  }, ee = () => {
    const L = o.value;
    return [
      me(L[0]),
      L[1] ? me(L[1]) : ir(l.value.partialRange)
    ];
  }, Z = () => o.value[1] ? ee() : me(ot(o.value[0])), se = () => (o.value || []).map((L) => me(L)), G = (L = !1) => (L || J(), a.modelAuto ? Z() : c.value.enabled ? se() : Array.isArray(o.value) ? al(() => ee(), l.value.enabled) : me(ot(o.value))), ke = (L) => !L || Array.isArray(L) && !L.length ? null : a.timePicker ? x(ot(L)) : a.monthPicker ? q(ot(L)) : a.yearPicker ? B(ot(L)) : c.value.enabled ? _(ot(L)) : a.weekPicker ? A(ot(L)) : z(ot(L)), T = (L) => {
    const de = ke(L);
    $w(ot(de)) ? (o.value = ot(de), ne()) : (o.value = null, v.value = "");
  }, w = () => {
    const L = (de) => Ft(de, r.value.format);
    return `${L(o.value[0])} ${r.value.rangeSeparator} ${o.value[1] ? L(o.value[1]) : ""}`;
  }, E = () => t.value && o.value ? Array.isArray(o.value) ? w() : Ft(o.value, r.value.format) : I(o.value), M = () => o.value ? c.value.enabled ? o.value.map((L) => I(L)).join("; ") : r.value.enabled && typeof r.value.format == "string" ? E() : I(o.value) : "", ne = () => {
    !a.format || typeof a.format == "string" || r.value.enabled && typeof r.value.format == "string" ? v.value = M() : v.value = a.format(o.value);
  }, ue = (L) => {
    if (a.utc) {
      const de = new Date(L);
      return a.utc === "preserve" ? new Date(de.getTime() + de.getTimezoneOffset() * 6e4) : de;
    }
    return a.modelType ? lN.includes(a.modelType) ? p(new Date(L)) : a.modelType === "format" && (typeof a.format == "string" || !a.format) ? p(
      Dw(L, u(), /* @__PURE__ */ new Date(), { locale: f.value })
    ) : p(
      Dw(L, a.modelType, /* @__PURE__ */ new Date(), { locale: f.value })
    ) : p(new Date(L));
  }, me = (L) => L ? a.utc ? fN(L, a.utc === "preserve", a.enableSeconds) : a.modelType ? a.modelType === "timestamp" ? +m(L) : a.modelType === "iso" ? m(L).toISOString() : a.modelType === "format" && (typeof a.format == "string" || !a.format) ? I(m(L)) : I(m(L), a.modelType, !0) : m(L) : "", Se = (L, de = !1, Ce = !1) => {
    if (Ce)
      return L;
    if (e("update:model-value", L), i.value.emitTimezone && de) {
      const W = Array.isArray(L) ? L.map((xe) => gt(ot(xe), i.value.emitTimezone)) : gt(ot(L), i.value.emitTimezone);
      e("update:model-timezone-value", W);
    }
  }, V = (L) => Array.isArray(o.value) ? c.value.enabled ? o.value.map((de) => L(de)) : [
    L(o.value[0]),
    o.value[1] ? L(o.value[1]) : ir(l.value.partialRange)
  ] : L(ot(o.value)), Q = () => {
    if (Array.isArray(o.value)) {
      const L = Nt(o.value[0], a.weekStart), de = o.value[1] ? Nt(o.value[1], a.weekStart) : [];
      return [L.map((Ce) => ce(Ce)), de.map((Ce) => ce(Ce))];
    }
    return Nt(o.value, a.weekStart).map((L) => ce(L));
  }, g = (L, de) => Se(ot(V(L)), !1, de), D = (L) => {
    const de = Q();
    return L ? de : e("update:model-value", Q());
  }, ae = (L = !1) => (L || ne(), a.monthPicker ? g(C, L) : a.timePicker ? g(S, L) : a.yearPicker ? g(ze, L) : a.weekPicker ? D(L) : Se(G(L), !0, L));
  return {
    inputValue: v,
    internalModelValue: o,
    checkBeforeEmit: () => o.value ? l.value.enabled ? l.value.partialRange ? o.value.length >= 1 : o.value.length === 2 : !!o.value : !1,
    parseExternalModelValue: T,
    formatInputValue: ne,
    emitModelValue: ae
  };
}, RN = (e, a) => {
  const { defaultedFilters: t, propDates: o } = Ye(e), { validateMonthYearInRange: r } = la(e), l = (k, f) => {
    let p = k;
    return t.value.months.includes(_e(p)) ? (p = f ? zt(k, 1) : pr(k, 1), l(p, f)) : p;
  }, i = (k, f) => {
    let p = k;
    return t.value.years.includes(ze(p)) ? (p = f ? cL(k, 1) : kC(k, 1), i(p, f)) : p;
  }, c = (k, f = !1) => {
    const p = Re(ce(), { month: e.month, year: e.year });
    let m = k ? zt(p, 1) : pr(p, 1);
    e.disableYearSelect && (m = $t(m, e.year));
    let I = _e(m), S = ze(m);
    t.value.months.includes(I) && (m = l(m, k), I = _e(m), S = ze(m)), t.value.years.includes(S) && (m = i(m, k), S = ze(m)), r(I, S, k, e.preventMinMaxNavigation) && u(I, S, f);
  }, u = (k, f, p) => {
    a("update-month-year", { month: k, year: f, fromNav: p });
  }, v = F(() => (k) => SC(
    Re(ce(), { month: e.month, year: e.year }),
    o.value.maxDate,
    o.value.minDate,
    e.preventMinMaxNavigation,
    k
  ));
  return { handleMonthYearChange: c, isDisabled: v, updateMonthYear: u };
}, Xx = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: !0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, _t = {
  ...Xx,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 }
}, FN = ["title"], EN = ["disabled"], UN = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ..._t
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: a }) {
    const t = a, o = e, {
      defaultedActionRow: r,
      defaultedPreviewFormat: l,
      defaultedMultiCalendars: i,
      defaultedTextInput: c,
      defaultedInline: u,
      defaultedRange: v,
      defaultedMultiDates: k,
      getDefaultPattern: f
    } = Ye(o), { isTimeValid: p, isMonthValid: m } = la(o), { buildMatrix: I } = ra(), S = U(null), C = U(null), B = U(!1), $ = U({}), x = U(null), q = U(null);
    Qe(() => {
      o.arrowNavigation && I([nt(S), nt(C)], "actionRow"), _(), window.addEventListener("resize", _);
    }), er(() => {
      window.removeEventListener("resize", _);
    });
    const _ = () => {
      B.value = !1, setTimeout(() => {
        var w, E;
        const M = (w = x.value) == null ? void 0 : w.getBoundingClientRect(), ne = (E = q.value) == null ? void 0 : E.getBoundingClientRect();
        M && ne && ($.value.maxWidth = `${ne.width - M.width - 20}px`), B.value = !0;
      }, 0);
    }, A = F(() => v.value.enabled && !v.value.partialRange && o.internalModelValue ? o.internalModelValue.length === 2 : !0), z = F(
      () => !p.value(o.internalModelValue) || !m.value(o.internalModelValue) || !A.value
    ), J = () => {
      const w = l.value;
      return o.timePicker || o.monthPicker, w(ot(o.internalModelValue));
    }, ee = () => {
      const w = o.internalModelValue;
      return i.value.count > 0 ? `${Z(w[0])} - ${Z(w[1])}` : [Z(w[0]), Z(w[1])];
    }, Z = (w) => IC(
      w,
      l.value,
      o.formatLocale,
      c.value.rangeSeparator,
      o.modelAuto,
      f()
    ), se = F(() => !o.internalModelValue || !o.menuMount ? "" : typeof l.value == "string" ? Array.isArray(o.internalModelValue) ? o.internalModelValue.length === 2 && o.internalModelValue[1] ? ee() : k.value.enabled ? o.internalModelValue.map((w) => `${Z(w)}`) : o.modelAuto ? `${Z(o.internalModelValue[0])}` : `${Z(o.internalModelValue[0])} -` : Z(o.internalModelValue) : J()), G = () => k.value.enabled ? "; " : " - ", ke = F(
      () => Array.isArray(se.value) ? se.value.join(G()) : se.value
    ), T = () => {
      p.value(o.internalModelValue) && m.value(o.internalModelValue) && A.value ? t("select-date") : t("invalid-select");
    };
    return (w, E) => (d(), h("div", {
      ref_key: "actionRowRef",
      ref: q,
      class: "dp__action_row"
    }, [
      w.$slots["action-row"] ? te(w.$slots, "action-row", j(H({ key: 0 }, {
        internalModelValue: w.internalModelValue,
        disabled: z.value,
        selectDate: () => w.$emit("select-date"),
        closePicker: () => w.$emit("close-picker")
      }))) : (d(), h(ve, { key: 1 }, [
        s(r).showPreview ? (d(), h("div", {
          key: 0,
          class: "dp__selection_preview",
          title: ke.value,
          style: ut($.value)
        }, [
          w.$slots["action-preview"] && B.value ? te(w.$slots, "action-preview", {
            key: 0,
            value: w.internalModelValue
          }) : y("", !0),
          !w.$slots["action-preview"] && B.value ? (d(), h(ve, { key: 1 }, [
            lt(N(ke.value), 1)
          ], 64)) : y("", !0)
        ], 12, FN)) : y("", !0),
        P("div", {
          ref_key: "actionBtnContainer",
          ref: x,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          w.$slots["action-buttons"] ? te(w.$slots, "action-buttons", {
            key: 0,
            value: w.internalModelValue
          }) : y("", !0),
          w.$slots["action-buttons"] ? y("", !0) : (d(), h(ve, { key: 1 }, [
            !s(u).enabled && s(r).showCancel ? (d(), h("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: S,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: E[0] || (E[0] = (M) => w.$emit("close-picker")),
              onKeydown: E[1] || (E[1] = (M) => s(vt)(M, () => w.$emit("close-picker")))
            }, N(w.cancelText), 545)) : y("", !0),
            s(r).showNow ? (d(), h("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: E[2] || (E[2] = (M) => w.$emit("select-now")),
              onKeydown: E[3] || (E[3] = (M) => s(vt)(M, () => w.$emit("select-now")))
            }, N(w.nowButtonLabel), 33)) : y("", !0),
            s(r).showSelect ? (d(), h("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: C,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: z.value,
              "data-test": "select-button",
              onKeydown: E[4] || (E[4] = (M) => s(vt)(M, () => T())),
              onClick: T
            }, N(w.selectText), 41, EN)) : y("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), NN = { class: "dp__selection_grid_header" }, WN = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], GN = ["aria-label"], Zr = /* @__PURE__ */ it({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: a, emit: t }) {
    const { setSelectionGrid: o, buildMultiLevelMatrix: r, setMonthPicker: l } = ra(), i = t, c = e, { defaultedAriaLabels: u, defaultedTextInput: v, defaultedConfig: k } = Ye(
      c
    ), { hideNavigationButtons: f } = ew(), p = U(!1), m = U(null), I = U(null), S = U([]), C = U(), B = U(null), $ = U(0), x = U(null);
    GC(() => {
      m.value = null;
    }), Qe(() => {
      Mt().then(() => se()), c.noOverlayFocus || _(), q(!0);
    }), er(() => q(!1));
    const q = (V) => {
      var Q;
      c.arrowNavigation && ((Q = c.headerRefs) != null && Q.length ? l(V) : o(V));
    }, _ = () => {
      var V;
      const Q = nt(I);
      Q && (v.value.enabled || (m.value ? (V = m.value) == null || V.focus({ preventScroll: !0 }) : Q.focus({ preventScroll: !0 })), p.value = Q.clientHeight < Q.scrollHeight);
    }, A = F(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !c.useRelative,
        "dp--overlay-relative": c.useRelative
      })
    ), z = F(
      () => c.useRelative ? { height: `${c.height}px`, width: "260px" } : void 0
    ), J = F(() => ({
      dp__overlay_col: !0
    })), ee = F(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: p.value,
        dp__button_bottom: c.isLast
      })
    ), Z = F(() => {
      var V, Q;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((V = c.items) == null ? void 0 : V.length) <= 6,
        dp__container_block: ((Q = c.items) == null ? void 0 : Q.length) > 6
      };
    });
    We(
      () => c.items,
      () => se(!1),
      { deep: !0 }
    );
    const se = (V = !0) => {
      Mt().then(() => {
        const Q = nt(m), g = nt(I), D = nt(B), ae = nt(x), L = D ? D.getBoundingClientRect().height : 0;
        g && (g.getBoundingClientRect().height ? $.value = g.getBoundingClientRect().height - L : $.value = k.value.modeHeight - L), Q && ae && V && (ae.scrollTop = Q.offsetTop - ae.offsetTop - ($.value / 2 - Q.getBoundingClientRect().height) - L);
      });
    }, G = (V) => {
      V.disabled || i("selected", V.value);
    }, ke = () => {
      i("toggle"), i("reset-flow");
    }, T = () => {
      c.escClose && ke();
    }, w = (V, Q, g, D) => {
      V && ((Q.active || Q.value === c.focusValue) && (m.value = V), c.arrowNavigation && (Array.isArray(S.value[g]) ? S.value[g][D] = V : S.value[g] = [V], E()));
    }, E = () => {
      var V, Q;
      const g = (V = c.headerRefs) != null && V.length ? [c.headerRefs].concat(S.value) : S.value.concat([c.skipButtonRef ? [] : [B.value]]);
      r(ot(g), (Q = c.headerRefs) != null && Q.length ? "monthPicker" : "selectionGrid");
    }, M = (V) => {
      c.arrowNavigation || aa(V, k.value, !0);
    }, ne = (V) => {
      C.value = V, i("hover-value", V);
    }, ue = () => {
      if (ke(), !c.isLast) {
        const V = yN(c.menuWrapRef ?? null, "action-row");
        if (V) {
          const Q = gC(V);
          Q == null || Q.focus();
        }
      }
    }, me = (V) => {
      switch (V.key) {
        case Ge.esc:
          return T();
        case Ge.arrowLeft:
          return M(V);
        case Ge.arrowRight:
          return M(V);
        case Ge.arrowUp:
          return M(V);
        case Ge.arrowDown:
          return M(V);
        default:
          return;
      }
    }, Se = (V) => {
      if (V.key === Ge.enter)
        return ke();
      if (V.key === Ge.tab)
        return ue();
    };
    return a({ focusGrid: _ }), (V, Q) => {
      var g;
      return d(), h("div", {
        ref_key: "gridWrapRef",
        ref: I,
        class: be(A.value),
        style: ut(z.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: me,
        onClick: Q[0] || (Q[0] = Dr(() => {
        }, ["prevent"]))
      }, [
        P("div", {
          ref_key: "containerRef",
          ref: x,
          class: be(Z.value),
          role: "grid",
          style: ut({ "--dp-overlay-height": `${$.value}px` })
        }, [
          P("div", NN, [
            te(V.$slots, "header")
          ]),
          V.$slots.overlay ? te(V.$slots, "overlay", { key: 0 }) : (d(!0), h(ve, { key: 1 }, Ie(V.items, (D, ae) => (d(), h("div", {
            key: ae,
            class: be(["dp__overlay_row", { dp__flex_row: V.items.length >= 3 }]),
            role: "row"
          }, [
            (d(!0), h(ve, null, Ie(D, (L, de) => (d(), h("div", {
              key: L.value,
              ref_for: !0,
              ref: (Ce) => w(Ce, L, ae, de),
              role: "gridcell",
              class: be(J.value),
              "aria-selected": L.active || void 0,
              "aria-disabled": L.disabled || void 0,
              tabindex: "0",
              "data-test": L.text,
              onClick: Dr((Ce) => G(L), ["prevent"]),
              onKeydown: (Ce) => s(vt)(Ce, () => G(L), !0),
              onMouseover: (Ce) => ne(L.value)
            }, [
              P("div", {
                class: be(L.className)
              }, [
                V.$slots.item ? te(V.$slots, "item", {
                  key: 0,
                  item: L
                }) : y("", !0),
                V.$slots.item ? y("", !0) : (d(), h(ve, { key: 1 }, [
                  lt(N(L.text), 1)
                ], 64))
              ], 2)
            ], 42, WN))), 128))
          ], 2))), 128))
        ], 6),
        V.$slots["button-icon"] ? Ot((d(), h("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: B,
          type: "button",
          "aria-label": (g = s(u)) == null ? void 0 : g.toggleOverlay,
          class: be(ee.value),
          tabindex: "0",
          onClick: ke,
          onKeydown: Se
        }, [
          te(V.$slots, "button-icon")
        ], 42, GN)), [
          [Rt, !s(f)(V.hideNavigation, V.type)]
        ]) : y("", !0)
      ], 38);
    };
  }
}), Qx = /* @__PURE__ */ it({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const a = e, t = F(
      () => a.multiCalendars > 0 ? [...Array(a.multiCalendars).keys()] : [0]
    ), o = F(() => ({
      dp__instance_calendar: a.multiCalendars > 0
    }));
    return (r, l) => (d(), h("div", {
      class: be({
        dp__menu_inner: !r.stretch,
        "dp--menu--inner-stretched": r.stretch,
        dp__flex_display: r.multiCalendars > 0,
        "dp--flex-display-collapsed": r.collapse
      })
    }, [
      (d(!0), h(ve, null, Ie(t.value, (i, c) => (d(), h("div", {
        key: i,
        class: be(o.value)
      }, [
        te(r.$slots, "default", {
          instance: i,
          index: c
        })
      ], 2))), 128))
    ], 2));
  }
}), ZN = ["aria-label", "aria-disabled"], Vr = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: a }) {
    const t = a, o = U(null);
    return Qe(() => t("set-ref", o)), (r, l) => (d(), h("button", {
      ref_key: "elRef",
      ref: o,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": r.ariaLabel,
      "aria-disabled": r.disabled || void 0,
      onClick: l[0] || (l[0] = (i) => r.$emit("activate")),
      onKeydown: l[1] || (l[1] = (i) => s(vt)(i, () => r.$emit("activate"), !0))
    }, [
      P("span", {
        class: be(["dp__inner_nav", { dp__inner_nav_disabled: r.disabled }])
      }, [
        te(r.$slots, "default")
      ], 2)
    ], 40, ZN));
  }
}), YN = { class: "dp--year-mode-picker" }, KN = ["aria-label", "data-test"], zC = /* @__PURE__ */ it({
  __name: "YearModePicker",
  props: {
    ..._t,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: a }) {
    const t = a, o = e, { showRightIcon: r, showLeftIcon: l } = ew(), { defaultedConfig: i, defaultedMultiCalendars: c, defaultedAriaLabels: u, defaultedTransitions: v, defaultedUI: k } = Ye(o), { showTransition: f, transitionName: p } = Yr(v), m = (C = !1, B) => {
      t("toggle-year-picker", { flow: C, show: B });
    }, I = (C) => {
      t("year-select", C);
    }, S = (C = !1) => {
      t("handle-year", C);
    };
    return (C, B) => {
      var $, x, q, _, A;
      return d(), h("div", YN, [
        s(l)(s(c), e.instance) ? (d(), K(Vr, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": ($ = s(u)) == null ? void 0 : $.prevYear,
          disabled: e.isDisabled(!1),
          class: be((x = s(k)) == null ? void 0 : x.navBtnPrev),
          onActivate: B[0] || (B[0] = (z) => S(!1))
        }, {
          default: fe(() => [
            C.$slots["arrow-left"] ? te(C.$slots, "arrow-left", { key: 0 }) : y("", !0),
            C.$slots["arrow-left"] ? y("", !0) : (d(), K(s(yL), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : y("", !0),
        P("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (q = s(u)) == null ? void 0 : q.openYearsOverlay,
          "data-test": `year-mode-btn-${e.instance}`,
          onClick: B[1] || (B[1] = () => m(!1)),
          onKeydown: B[2] || (B[2] = ZC(() => m(!1), ["enter"]))
        }, [
          C.$slots.year ? te(C.$slots, "year", {
            key: 0,
            year: e.year
          }) : y("", !0),
          C.$slots.year ? y("", !0) : (d(), h(ve, { key: 1 }, [
            lt(N(e.year), 1)
          ], 64))
        ], 40, KN),
        s(r)(s(c), e.instance) ? (d(), K(Vr, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (_ = s(u)) == null ? void 0 : _.nextYear,
          disabled: e.isDisabled(!0),
          class: be((A = s(k)) == null ? void 0 : A.navBtnNext),
          onActivate: B[3] || (B[3] = (z) => S(!0))
        }, {
          default: fe(() => [
            C.$slots["arrow-right"] ? te(C.$slots, "arrow-right", { key: 0 }) : y("", !0),
            C.$slots["arrow-right"] ? y("", !0) : (d(), K(s(kL), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : y("", !0),
        Le(mr, {
          name: s(p)(e.showYearPicker),
          css: s(f)
        }, {
          default: fe(() => [
            e.showYearPicker ? (d(), K(Zr, {
              key: 0,
              items: e.items,
              "text-input": C.textInput,
              "esc-close": C.escClose,
              config: C.config,
              "is-last": C.autoApply && !s(i).keepActionRow,
              "hide-navigation": C.hideNavigation,
              "aria-labels": C.ariaLabels,
              type: "year",
              onToggle: m,
              onSelected: B[4] || (B[4] = (z) => I(z))
            }, ht({
              "button-icon": fe(() => [
                C.$slots["calendar-icon"] ? te(C.$slots, "calendar-icon", { key: 0 }) : y("", !0),
                C.$slots["calendar-icon"] ? y("", !0) : (d(), K(s(Lr), { key: 1 }))
              ]),
              _: 2
            }, [
              C.$slots["year-overlay-value"] ? {
                name: "item",
                fn: fe(({ item: z }) => [
                  te(C.$slots, "year-overlay-value", {
                    text: z.text,
                    value: z.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels"])) : y("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), LL = (e, a, t) => {
  if (a.value && Array.isArray(a.value))
    if (a.value.some((o) => Ve(e, o))) {
      const o = a.value.filter((r) => !Ve(r, e));
      a.value = o.length ? o : null;
    } else
      (t && +t > a.value.length || !t) && a.value.push(e);
  else
    a.value = [e];
}, SL = (e, a, t) => {
  let o = e.value ? e.value.slice() : [];
  return o.length === 2 && o[1] !== null && (o = []), o.length ? Ke(a, o[0]) ? (o.unshift(a), t("range-start", o[0]), t("range-start", o[1])) : (o[1] = a, t("range-end", a)) : (o = [a], t("range-start", a)), o;
}, Jx = (e, a, t, o) => {
  e && (e[0] && e[1] && t && a("auto-apply"), e[0] && !e[1] && o && t && a("auto-apply"));
}, PC = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((a) => gt(ce(a), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = gt(ce(e.value), e.timezone));
}, _C = (e, a, t, o) => Array.isArray(a.value) && (a.value.length === 2 || a.value.length === 1 && o.value.partialRange) ? o.value.fixedStart && (et(e, a.value[0]) || Ve(e, a.value[0])) ? [a.value[0], e] : o.value.fixedEnd && (Ke(e, a.value[1]) || Ve(e, a.value[1])) ? [e, a.value[1]] : (t("invalid-fixed-range", e), a.value) : [], jC = ({
  multiCalendars: e,
  range: a,
  highlight: t,
  propDates: o,
  calendars: r,
  modelValue: l,
  props: i,
  filters: c,
  year: u,
  month: v,
  emit: k
}) => {
  const f = F(() => ML(i.yearRange, i.locale, i.reverseYears)), p = U([!1]), m = F(() => (Z, se) => {
    const G = Re(qt(/* @__PURE__ */ new Date()), {
      month: v.value(Z),
      year: u.value(Z)
    }), ke = se ? aC(G) : Tr(G);
    return SC(
      ke,
      o.value.maxDate,
      o.value.minDate,
      i.preventMinMaxNavigation,
      se
    );
  }), I = () => Array.isArray(l.value) && e.value.solo && l.value[1], S = () => {
    for (let Z = 0; Z < e.value.count; Z++)
      if (Z === 0)
        r.value[Z] = r.value[0];
      else if (Z === e.value.count - 1 && I())
        r.value[Z] = {
          month: _e(l.value[1]),
          year: ze(l.value[1])
        };
      else {
        const se = Re(ce(), r.value[Z - 1]);
        r.value[Z] = { month: _e(se), year: ze(cL(se, 1)) };
      }
  }, C = (Z) => {
    if (!Z)
      return S();
    const se = Re(ce(), r.value[Z]);
    return r.value[0].year = ze(kC(se, e.value.count - 1)), S();
  }, B = (Z, se) => {
    const G = cE(se, Z);
    return a.value.showLastInRange && G > 1 ? se : Z;
  }, $ = (Z) => i.focusStartDate || e.value.solo ? Z[0] : Z[1] ? B(Z[0], Z[1]) : Z[0], x = () => {
    if (l.value) {
      const Z = Array.isArray(l.value) ? $(l.value) : l.value;
      r.value[0] = { month: _e(Z), year: ze(Z) };
    }
  }, q = () => {
    x(), e.value.count && S();
  };
  We(l, (Z, se) => {
    i.isTextInputDate && JSON.stringify(Z ?? {}) !== JSON.stringify(se ?? {}) && q();
  }), Qe(() => {
    q();
  });
  const _ = (Z, se) => {
    r.value[se].year = Z, k("update-month-year", { instance: se, year: Z, month: r.value[se].month }), e.value.count && !e.value.solo && C(se);
  }, A = F(() => (Z) => yr(f.value, (se) => {
    var G;
    const ke = u.value(Z) === se.value, T = Or(
      se.value,
      kr(o.value.minDate),
      kr(o.value.maxDate)
    ) || ((G = c.value.years) == null ? void 0 : G.includes(u.value(Z))), w = wL(t.value, se.value);
    return { active: ke, disabled: T, highlighted: w };
  })), z = (Z, se) => {
    _(Z, se), ee(se);
  }, J = (Z, se = !1) => {
    if (!m.value(Z, se)) {
      const G = se ? u.value(Z) + 1 : u.value(Z) - 1;
      _(G, Z);
    }
  }, ee = (Z, se = !1, G) => {
    se || k("reset-flow"), G !== void 0 ? p.value[Z] = G : p.value[Z] = !p.value[Z], p.value[Z] ? k("overlay-toggle", { open: !0, overlay: dt.year }) : (k("overlay-closed"), k("overlay-toggle", { open: !1, overlay: dt.year }));
  };
  return {
    isDisabled: m,
    groupedYears: A,
    showYearPicker: p,
    selectYear: _,
    toggleYearPicker: ee,
    handleYearSelect: z,
    handleYear: J
  };
}, XN = (e, a) => {
  const {
    defaultedMultiCalendars: t,
    defaultedAriaLabels: o,
    defaultedTransitions: r,
    defaultedConfig: l,
    defaultedRange: i,
    defaultedHighlight: c,
    propDates: u,
    defaultedTz: v,
    defaultedFilters: k,
    defaultedMultiDates: f
  } = Ye(e), p = () => {
    e.isTextInputDate && q(ze(ce(e.startDate)), 0);
  }, { modelValue: m, year: I, month: S, calendars: C } = Kr(e, a, p), B = F(() => fC(e.formatLocale, e.locale, e.monthNameFormat)), $ = U(null), { checkMinMaxRange: x } = la(e), {
    selectYear: q,
    groupedYears: _,
    showYearPicker: A,
    toggleYearPicker: z,
    handleYearSelect: J,
    handleYear: ee,
    isDisabled: Z
  } = jC({
    modelValue: m,
    multiCalendars: t,
    range: i,
    highlight: c,
    calendars: C,
    year: I,
    propDates: u,
    month: S,
    filters: k,
    props: e,
    emit: a
  });
  Qe(() => {
    e.startDate && (m.value && e.focusStartDate || !m.value) && q(ze(ce(e.startDate)), 0);
  });
  const se = (g) => g ? { month: _e(g), year: ze(g) } : { month: null, year: null }, G = () => m.value ? Array.isArray(m.value) ? m.value.map((g) => se(g)) : se(m.value) : se(), ke = (g, D) => {
    const ae = C.value[g], L = G();
    return Array.isArray(L) ? L.some((de) => de.year === (ae == null ? void 0 : ae.year) && de.month === D) : (ae == null ? void 0 : ae.year) === L.year && D === L.month;
  }, T = (g, D, ae) => {
    var L, de;
    const Ce = G();
    return Array.isArray(Ce) ? I.value(D) === ((L = Ce[ae]) == null ? void 0 : L.year) && g === ((de = Ce[ae]) == null ? void 0 : de.month) : !1;
  }, w = (g, D) => {
    if (i.value.enabled) {
      const ae = G();
      if (Array.isArray(m.value) && Array.isArray(ae)) {
        const L = T(g, D, 0) || T(g, D, 1), de = Wt(qt(ce()), g, I.value(D));
        return Kx(m.value, $.value, de) && !L;
      }
      return !1;
    }
    return !1;
  }, E = F(() => (g) => yr(B.value, (D) => {
    var ae;
    const L = ke(g, D.value), de = Or(
      D.value,
      bC(I.value(g), u.value.minDate),
      xC(I.value(g), u.value.maxDate)
    ) || xN(u.value.disabledDates, I.value(g)).includes(D.value) || ((ae = k.value.months) == null ? void 0 : ae.includes(D.value)), Ce = w(D.value, g), W = CC(c.value, D.value, I.value(g));
    return { active: L, disabled: de, isBetween: Ce, highlighted: W };
  })), M = (g, D) => Wt(qt(ce()), g, I.value(D)), ne = (g, D) => {
    const ae = m.value ? m.value : qt(/* @__PURE__ */ new Date());
    m.value = Wt(ae, g, I.value(D)), a("auto-apply"), a("update-flow-step");
  }, ue = (g, D) => {
    const ae = M(g, D);
    i.value.fixedEnd || i.value.fixedStart ? m.value = _C(ae, m, a, i) : m.value ? x(ae, m.value) && (m.value = SL(m, M(g, D), a)) : m.value = [M(g, D)], Mt().then(() => {
      Jx(m.value, a, e.autoApply, e.modelAuto);
    });
  }, me = (g, D) => {
    LL(M(g, D), m, f.value.limit), a("auto-apply", !0);
  }, Se = (g, D) => (C.value[D].month = g, Q(D, C.value[D].year, g), f.value.enabled ? me(g, D) : i.value.enabled ? ue(g, D) : ne(g, D)), V = (g, D) => {
    q(g, D), Q(D, g, null);
  }, Q = (g, D, ae) => {
    let L = ae;
    if (!L && L !== 0) {
      const de = G();
      L = Array.isArray(de) ? de[g].month : de.month;
    }
    a("update-month-year", { instance: g, year: D, month: L });
  };
  return {
    groupedMonths: E,
    groupedYears: _,
    year: I,
    isDisabled: Z,
    defaultedMultiCalendars: t,
    defaultedAriaLabels: o,
    defaultedTransitions: r,
    defaultedConfig: l,
    showYearPicker: A,
    modelValue: m,
    presetDate: (g, D) => {
      PC({
        value: g,
        modelValue: m,
        range: i.value.enabled,
        timezone: D ? void 0 : v.value.timezone
      }), a("auto-apply");
    },
    setHoverDate: (g, D) => {
      $.value = M(g, D);
    },
    selectMonth: Se,
    selectYear: V,
    toggleYearPicker: z,
    handleYearSelect: J,
    handleYear: ee,
    getModelMonthYear: G
  };
}, QN = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ..._t
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = tr(), l = wt(r, "yearMode"), i = e;
    Qe(() => {
      i.shadow || o("mount", null);
    });
    const {
      groupedMonths: c,
      groupedYears: u,
      year: v,
      isDisabled: k,
      defaultedMultiCalendars: f,
      defaultedConfig: p,
      showYearPicker: m,
      modelValue: I,
      presetDate: S,
      setHoverDate: C,
      selectMonth: B,
      selectYear: $,
      toggleYearPicker: x,
      handleYearSelect: q,
      handleYear: _,
      getModelMonthYear: A
    } = XN(i, o);
    return a({ getSidebarProps: () => ({
      modelValue: I,
      year: v,
      getModelMonthYear: A,
      selectMonth: B,
      selectYear: $,
      handleYear: _
    }), presetDate: S, toggleYearPicker: (z) => x(0, z) }), (z, J) => (d(), K(Qx, {
      "multi-calendars": s(f).count,
      collapse: z.collapse,
      stretch: ""
    }, {
      default: fe(({ instance: ee }) => [
        z.$slots["top-extra"] ? te(z.$slots, "top-extra", {
          key: 0,
          value: z.internalModelValue
        }) : y("", !0),
        z.$slots["month-year"] ? te(z.$slots, "month-year", j(H({ key: 1 }, {
          year: s(v),
          months: s(c)(ee),
          years: s(u)(ee),
          selectMonth: s(B),
          selectYear: s($),
          instance: ee
        }))) : (d(), K(Zr, {
          key: 2,
          items: s(c)(ee),
          "arrow-navigation": z.arrowNavigation,
          "is-last": z.autoApply && !s(p).keepActionRow,
          "esc-close": z.escClose,
          height: s(p).modeHeight,
          config: z.config,
          "no-overlay-focus": !!(z.noOverlayFocus || z.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (Z) => s(B)(Z, ee),
          onHoverValue: (Z) => s(C)(Z, ee)
        }, ht({
          header: fe(() => [
            Le(zC, H(z.$props, {
              items: s(u)(ee),
              instance: ee,
              "show-year-picker": s(m)[ee],
              year: s(v)(ee),
              "is-disabled": (Z) => s(k)(ee, Z),
              onHandleYear: (Z) => s(_)(ee, Z),
              onYearSelect: (Z) => s(q)(Z, ee),
              onToggleYearPicker: (Z) => s(x)(ee, Z == null ? void 0 : Z.flow, Z == null ? void 0 : Z.show)
            }), ht({ _: 2 }, [
              Ie(s(l), (Z, se) => ({
                name: Z,
                fn: fe((G) => [
                  te(z.$slots, Z, j(re(G)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          z.$slots["month-overlay-value"] ? {
            name: "item",
            fn: fe(({ item: Z }) => [
              te(z.$slots, "month-overlay-value", {
                text: Z.text,
                value: Z.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), JN = (e, a) => {
  const t = () => {
    e.isTextInputDate && (k.value = ze(ce(e.startDate)));
  }, { modelValue: o } = Kr(e, a, t), r = U(null), { defaultedHighlight: l, defaultedMultiDates: i, defaultedFilters: c, defaultedRange: u, propDates: v } = Ye(e), k = U();
  Qe(() => {
    e.startDate && (o.value && e.focusStartDate || !o.value) && (k.value = ze(ce(e.startDate)));
  });
  const f = (S) => Array.isArray(o.value) ? o.value.some((C) => ze(C) === S) : o.value ? ze(o.value) === S : !1, p = (S) => u.value.enabled && Array.isArray(o.value) ? Kx(o.value, r.value, I(S)) : !1, m = F(() => yr(ML(e.yearRange, e.locale, e.reverseYears), (S) => {
    const C = f(S.value), B = Or(
      S.value,
      kr(v.value.minDate),
      kr(v.value.maxDate)
    ) || c.value.years.includes(S.value), $ = p(S.value) && !C, x = wL(l.value, S.value);
    return { active: C, disabled: B, isBetween: $, highlighted: x };
  })), I = (S) => $t(qt(Tr(/* @__PURE__ */ new Date())), S);
  return {
    groupedYears: m,
    modelValue: o,
    focusYear: k,
    setHoverValue: (S) => {
      r.value = $t(qt(/* @__PURE__ */ new Date()), S);
    },
    selectYear: (S) => {
      var C;
      if (a("update-month-year", { instance: 0, year: S }), i.value.enabled)
        return o.value ? Array.isArray(o.value) && (((C = o.value) == null ? void 0 : C.map((B) => ze(B))).includes(S) ? o.value = o.value.filter((B) => ze(B) !== S) : o.value.push($t(kt(ce()), S))) : o.value = [$t(kt(Tr(ce())), S)], a("auto-apply", !0);
      u.value.enabled ? (o.value = SL(o, I(S), a), Mt().then(() => {
        Jx(o.value, a, e.autoApply, e.modelAuto);
      })) : (o.value = I(S), a("auto-apply"));
    }
  };
}, eW = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ..._t
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, { groupedYears: l, modelValue: i, focusYear: c, selectYear: u, setHoverValue: v } = JN(r, o), { defaultedConfig: k } = Ye(r);
    return a({ getSidebarProps: () => ({
      modelValue: i,
      selectYear: u
    }) }), (f, p) => (d(), h("div", null, [
      f.$slots["top-extra"] ? te(f.$slots, "top-extra", {
        key: 0,
        value: f.internalModelValue
      }) : y("", !0),
      f.$slots["month-year"] ? te(f.$slots, "month-year", j(H({ key: 1 }, {
        years: s(l),
        selectYear: s(u)
      }))) : (d(), K(Zr, {
        key: 2,
        items: s(l),
        "is-last": f.autoApply && !s(k).keepActionRow,
        height: s(k).modeHeight,
        config: f.config,
        "no-overlay-focus": !!(f.noOverlayFocus || f.textInput),
        "focus-value": s(c),
        type: "year",
        "use-relative": "",
        onSelected: s(u),
        onHoverValue: s(v)
      }, ht({ _: 2 }, [
        f.$slots["year-overlay-value"] ? {
          name: "item",
          fn: fe(({ item: m }) => [
            te(f.$slots, "year-overlay-value", {
              text: m.text,
              value: m.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), tW = {
  key: 0,
  class: "dp__time_input"
}, aW = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], nW = /* @__PURE__ */ P("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), oW = /* @__PURE__ */ P("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), rW = ["aria-label", "disabled", "data-test", "onKeydown", "onClick"], lW = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], iW = /* @__PURE__ */ P("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), cW = /* @__PURE__ */ P("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), dW = { key: 0 }, sW = ["aria-label"], uW = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ..._t
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, { setTimePickerElements: l, setTimePickerBackRef: i } = ra(), { defaultedAriaLabels: c, defaultedTransitions: u, defaultedFilters: v, defaultedConfig: k, defaultedRange: f } = Ye(r), { transitionName: p, showTransition: m } = Yr(u), I = Rr({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), S = U("AM"), C = U(null), B = U([]), $ = U();
    Qe(() => {
      o("mounted");
    });
    const x = (b) => Re(/* @__PURE__ */ new Date(), {
      hours: b.hours,
      minutes: b.minutes,
      seconds: r.enableSeconds ? b.seconds : 0,
      milliseconds: 0
    }), q = F(
      () => (b) => E(b, r[b]) || A(b, r[b])
    ), _ = F(() => ({ hours: r.hours, minutes: r.minutes, seconds: r.seconds })), A = (b, Y) => f.value.enabled && !f.value.disableTimeRangeValidation ? !r.validateTime(b, Y) : !1, z = (b, Y) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const le = Y ? +r[`${b}Increment`] : -+r[`${b}Increment`], ie = r[b] + le;
        return !r.validateTime(b, ie);
      }
      return !1;
    }, J = F(() => (b) => !Se(+r[b] + +r[`${b}Increment`], b) || z(b, !0)), ee = F(() => (b) => !Se(+r[b] - +r[`${b}Increment`], b) || z(b, !1)), Z = (b, Y) => YI(Re(ce(), b), Y), se = (b, Y) => nN(Re(ce(), b), Y), G = F(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !r.timePickerInline,
        dp__time_col_reg_block: !r.enableSeconds && r.is24 && !r.timePickerInline,
        dp__time_col_reg_inline: !r.enableSeconds && r.is24 && r.timePickerInline,
        dp__time_col_reg_with_button: !r.enableSeconds && !r.is24,
        dp__time_col_sec: r.enableSeconds && r.is24,
        dp__time_col_sec_with_button: r.enableSeconds && !r.is24
      })
    ), ke = F(() => {
      const b = [{ type: "hours" }];
      return r.enableMinutes && b.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), r.enableSeconds && b.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), b;
    }), T = F(() => ke.value.filter((b) => !b.separator)), w = F(() => (b) => {
      if (b === "hours") {
        const Y = L(+r.hours);
        return { text: Y < 10 ? `0${Y}` : `${Y}`, value: Y };
      }
      return { text: r[b] < 10 ? `0${r[b]}` : `${r[b]}`, value: r[b] };
    }), E = (b, Y) => {
      var le;
      if (!r.disabledTimesConfig)
        return !1;
      const ie = r.disabledTimesConfig(r.order, b === "hours" ? Y : void 0);
      return ie[b] ? !!((le = ie[b]) != null && le.includes(Y)) : !0;
    }, M = (b, Y) => Y !== "hours" || S.value === "AM" ? b : b + 12, ne = (b) => {
      const Y = r.is24 ? 24 : 12, le = b === "hours" ? Y : 60, ie = +r[`${b}GridIncrement`], oe = b === "hours" && !r.is24 ? ie : 0, je = [];
      for (let R = oe; R < le; R += ie)
        je.push({ value: r.is24 ? R : M(R, b), text: R < 10 ? `0${R}` : `${R}` });
      return b === "hours" && !r.is24 && je.unshift({ value: S.value === "PM" ? 12 : 0, text: "12" }), yr(je, (R) => ({ active: !1, disabled: v.value.times[b].includes(R.value) || !Se(R.value, b) || E(b, R.value) || A(b, R.value) }));
    }, ue = (b) => b >= 0 ? b : 59, me = (b) => b >= 0 ? b : 23, Se = (b, Y) => {
      const le = r.minTime ? x(mw(r.minTime)) : null, ie = r.maxTime ? x(mw(r.maxTime)) : null, oe = x(
        mw(
          _.value,
          Y,
          Y === "minutes" || Y === "seconds" ? ue(b) : me(b)
        )
      );
      return le && ie ? ($r(oe, ie) || dr(oe, ie)) && (hr(oe, le) || dr(oe, le)) : le ? hr(oe, le) || dr(oe, le) : ie ? $r(oe, ie) || dr(oe, ie) : !0;
    }, V = (b) => r[`no${b[0].toUpperCase() + b.slice(1)}Overlay`], Q = (b) => {
      V(b) || (I[b] = !I[b], I[b] ? o("overlay-opened", b) : o("overlay-closed", b));
    }, g = (b) => b === "hours" ? Zt : b === "minutes" ? oa : ur, D = () => {
      $.value && clearTimeout($.value);
    }, ae = (b, Y = !0, le) => {
      const ie = Y ? Z : se, oe = Y ? +r[`${b}Increment`] : -+r[`${b}Increment`];
      Se(+r[b] + oe, b) && o(
        `update:${b}`,
        g(b)(ie({ [b]: +r[b] }, { [b]: +r[`${b}Increment`] }))
      ), !(le != null && le.keyboard) && k.value.timeArrowHoldThreshold && ($.value = setTimeout(() => {
        ae(b, Y);
      }, k.value.timeArrowHoldThreshold));
    }, L = (b) => r.is24 ? b : (b >= 12 ? S.value = "PM" : S.value = "AM", dN(b)), de = () => {
      S.value === "PM" ? (S.value = "AM", o("update:hours", r.hours - 12)) : (S.value = "PM", o("update:hours", r.hours + 12)), o("am-pm-change", S.value);
    }, Ce = (b) => {
      I[b] = !0;
    }, W = (b, Y, le) => {
      if (b && r.arrowNavigation) {
        Array.isArray(B.value[Y]) ? B.value[Y][le] = b : B.value[Y] = [b];
        const ie = B.value.reduce(
          (oe, je) => je.map((R, ye) => [...oe[ye] || [], je[ye]]),
          []
        );
        i(r.closeTimePickerBtn), C.value && (ie[1] = ie[1].concat(C.value)), l(ie, r.order);
      }
    }, xe = (b, Y) => (Q(b), o(`update:${b}`, Y));
    return a({ openChildCmp: Ce }), (b, Y) => {
      var le;
      return b.disabled ? y("", !0) : (d(), h("div", tW, [
        (d(!0), h(ve, null, Ie(ke.value, (ie, oe) => {
          var je, R, ye;
          return d(), h("div", {
            key: oe,
            class: be(G.value)
          }, [
            ie.separator ? (d(), h(ve, { key: 0 }, [
              lt(" : ")
            ], 64)) : (d(), h(ve, { key: 1 }, [
              P("button", {
                ref_for: !0,
                ref: (qe) => W(qe, oe, 0),
                type: "button",
                class: be({
                  dp__btn: !0,
                  dp__inc_dec_button: !b.timePickerInline,
                  dp__inc_dec_button_inline: b.timePickerInline,
                  dp__tp_inline_btn_top: b.timePickerInline,
                  dp__inc_dec_button_disabled: J.value(ie.type)
                }),
                "data-test": `${ie.type}-time-inc-btn-${r.order}`,
                "aria-label": (je = s(c)) == null ? void 0 : je.incrementValue(ie.type),
                tabindex: "0",
                onKeydown: (qe) => s(vt)(qe, () => ae(ie.type, !0, { keyboard: !0 }), !0),
                onClick: (qe) => s(k).timeArrowHoldThreshold ? void 0 : ae(ie.type, !0),
                onMousedown: (qe) => s(k).timeArrowHoldThreshold ? ae(ie.type, !0) : void 0,
                onMouseup: D
              }, [
                r.timePickerInline ? (d(), h(ve, { key: 1 }, [
                  b.$slots["tp-inline-arrow-up"] ? te(b.$slots, "tp-inline-arrow-up", { key: 0 }) : (d(), h(ve, { key: 1 }, [
                    nW,
                    oW
                  ], 64))
                ], 64)) : (d(), h(ve, { key: 0 }, [
                  b.$slots["arrow-up"] ? te(b.$slots, "arrow-up", { key: 0 }) : y("", !0),
                  b.$slots["arrow-up"] ? y("", !0) : (d(), K(s(fL), { key: 1 }))
                ], 64))
              ], 42, aW),
              P("button", {
                ref_for: !0,
                ref: (qe) => W(qe, oe, 1),
                type: "button",
                "aria-label": (R = s(c)) == null ? void 0 : R.openTpOverlay(ie.type),
                class: be({
                  dp__time_display: !0,
                  dp__time_display_block: !b.timePickerInline,
                  dp__time_display_inline: b.timePickerInline,
                  "dp--time-invalid": q.value(ie.type),
                  "dp--time-overlay-btn": !q.value(ie.type)
                }),
                disabled: V(ie.type),
                tabindex: "0",
                "data-test": `${ie.type}-toggle-overlay-btn-${r.order}`,
                onKeydown: (qe) => s(vt)(qe, () => Q(ie.type), !0),
                onClick: (qe) => Q(ie.type)
              }, [
                b.$slots[ie.type] ? te(b.$slots, ie.type, {
                  key: 0,
                  text: w.value(ie.type).text,
                  value: w.value(ie.type).value
                }) : y("", !0),
                b.$slots[ie.type] ? y("", !0) : (d(), h(ve, { key: 1 }, [
                  lt(N(w.value(ie.type).text), 1)
                ], 64))
              ], 42, rW),
              P("button", {
                ref_for: !0,
                ref: (qe) => W(qe, oe, 2),
                type: "button",
                class: be({
                  dp__btn: !0,
                  dp__inc_dec_button: !b.timePickerInline,
                  dp__inc_dec_button_inline: b.timePickerInline,
                  dp__tp_inline_btn_bottom: b.timePickerInline,
                  dp__inc_dec_button_disabled: ee.value(ie.type)
                }),
                "data-test": `${ie.type}-time-dec-btn-${r.order}`,
                "aria-label": (ye = s(c)) == null ? void 0 : ye.decrementValue(ie.type),
                tabindex: "0",
                onKeydown: (qe) => s(vt)(qe, () => ae(ie.type, !1, { keyboard: !0 }), !0),
                onClick: (qe) => s(k).timeArrowHoldThreshold ? void 0 : ae(ie.type, !1),
                onMousedown: (qe) => s(k).timeArrowHoldThreshold ? ae(ie.type, !1) : void 0,
                onMouseup: D
              }, [
                r.timePickerInline ? (d(), h(ve, { key: 1 }, [
                  b.$slots["tp-inline-arrow-down"] ? te(b.$slots, "tp-inline-arrow-down", { key: 0 }) : (d(), h(ve, { key: 1 }, [
                    iW,
                    cW
                  ], 64))
                ], 64)) : (d(), h(ve, { key: 0 }, [
                  b.$slots["arrow-down"] ? te(b.$slots, "arrow-down", { key: 0 }) : y("", !0),
                  b.$slots["arrow-down"] ? y("", !0) : (d(), K(s(vL), { key: 1 }))
                ], 64))
              ], 42, lW)
            ], 64))
          ], 2);
        }), 128)),
        b.is24 ? y("", !0) : (d(), h("div", dW, [
          b.$slots["am-pm-button"] ? te(b.$slots, "am-pm-button", {
            key: 0,
            toggle: de,
            value: S.value
          }) : y("", !0),
          b.$slots["am-pm-button"] ? y("", !0) : (d(), h("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: C,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (le = s(c)) == null ? void 0 : le.amPmButton,
            tabindex: "0",
            onClick: de,
            onKeydown: Y[0] || (Y[0] = (ie) => s(vt)(ie, () => de(), !0))
          }, N(S.value), 41, sW))
        ])),
        (d(!0), h(ve, null, Ie(T.value, (ie, oe) => (d(), K(mr, {
          key: oe,
          name: s(p)(I[ie.type]),
          css: s(m)
        }, {
          default: fe(() => [
            I[ie.type] ? (d(), K(Zr, {
              key: 0,
              items: ne(ie.type),
              "is-last": b.autoApply && !s(k).keepActionRow,
              "esc-close": b.escClose,
              type: ie.type,
              "text-input": b.textInput,
              config: b.config,
              "arrow-navigation": b.arrowNavigation,
              "aria-labels": b.ariaLabels,
              onSelected: (je) => xe(ie.type, je),
              onToggle: (je) => Q(ie.type),
              onResetFlow: Y[1] || (Y[1] = (je) => b.$emit("reset-flow"))
            }, ht({
              "button-icon": fe(() => [
                b.$slots["clock-icon"] ? te(b.$slots, "clock-icon", { key: 0 }) : y("", !0),
                b.$slots["clock-icon"] ? y("", !0) : (d(), K(st(b.timePickerInline ? s(Lr) : s(mL)), { key: 1 }))
              ]),
              _: 2
            }, [
              b.$slots[`${ie.type}-overlay-value`] ? {
                name: "item",
                fn: fe(({ item: je }) => [
                  te(b.$slots, `${ie.type}-overlay-value`, {
                    text: je.text,
                    value: je.value
                  })
                ]),
                key: "0"
              } : void 0,
              b.$slots[`${ie.type}-overlay-header`] ? {
                name: "header",
                fn: fe(() => [
                  te(b.$slots, `${ie.type}-overlay-header`, {
                    toggle: () => Q(ie.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "onSelected", "onToggle"])) : y("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), hW = { class: "dp--tp-wrap" }, pW = ["aria-label", "tabindex"], yW = ["tabindex"], kW = ["aria-label"], HC = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ..._t
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, { buildMatrix: l, setTimePicker: i } = ra(), c = tr(), { defaultedTransitions: u, defaultedAriaLabels: v, defaultedTextInput: k, defaultedConfig: f, defaultedRange: p } = Ye(r), { transitionName: m, showTransition: I } = Yr(u), { hideNavigationButtons: S } = ew(), C = U(null), B = U(null), $ = U([]), x = U(null);
    Qe(() => {
      o("mount"), !r.timePicker && r.arrowNavigation ? l([nt(C.value)], "time") : i(!0, r.timePicker);
    });
    const q = F(() => p.value.enabled && r.modelAuto ? vC(r.internalModelValue) : !0), _ = U(!1), A = (M) => ({
      hours: Array.isArray(r.hours) ? r.hours[M] : r.hours,
      minutes: Array.isArray(r.minutes) ? r.minutes[M] : r.minutes,
      seconds: Array.isArray(r.seconds) ? r.seconds[M] : r.seconds
    }), z = F(() => {
      const M = [];
      if (p.value.enabled)
        for (let ne = 0; ne < 2; ne++)
          M.push(A(ne));
      else
        M.push(A(0));
      return M;
    }), J = (M, ne = !1, ue = "") => {
      ne || o("reset-flow"), _.value = M, o(M ? "overlay-opened" : "overlay-closed", dt.time), r.arrowNavigation && i(M), Mt(() => {
        ue !== "" && $.value[0] && $.value[0].openChildCmp(ue);
      });
    }, ee = F(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: r.autoApply && !f.value.keepActionRow
    })), Z = wt(c, "timePicker"), se = (M, ne, ue) => p.value.enabled ? ne === 0 ? [M, z.value[1][ue]] : [z.value[0][ue], M] : M, G = (M) => {
      o("update:hours", M);
    }, ke = (M) => {
      o("update:minutes", M);
    }, T = (M) => {
      o("update:seconds", M);
    }, w = () => {
      if (x.value && !k.value.enabled && !r.noOverlayFocus) {
        const M = gC(x.value);
        M && M.focus({ preventScroll: !0 });
      }
    }, E = (M) => {
      o("overlay-closed", M);
    };
    return a({ toggleTimePicker: J }), (M, ne) => {
      var ue;
      return d(), h("div", hW, [
        !M.timePicker && !M.timePickerInline ? Ot((d(), h("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: C,
          type: "button",
          class: be(ee.value),
          "aria-label": (ue = s(v)) == null ? void 0 : ue.openTimePicker,
          tabindex: M.noOverlayFocus ? void 0 : 0,
          "data-test": "open-time-picker-btn",
          onKeydown: ne[0] || (ne[0] = (me) => s(vt)(me, () => J(!0))),
          onClick: ne[1] || (ne[1] = (me) => J(!0))
        }, [
          M.$slots["clock-icon"] ? te(M.$slots, "clock-icon", { key: 0 }) : y("", !0),
          M.$slots["clock-icon"] ? y("", !0) : (d(), K(s(mL), { key: 1 }))
        ], 42, pW)), [
          [Rt, !s(S)(M.hideNavigation, "time")]
        ]) : y("", !0),
        Le(mr, {
          name: s(m)(_.value),
          css: s(I) && !M.timePickerInline
        }, {
          default: fe(() => {
            var me;
            return [
              _.value || M.timePicker || M.timePickerInline ? (d(), h("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: x,
                class: be({
                  dp__overlay: !M.timePickerInline,
                  "dp--overlay-absolute": !r.timePicker && !M.timePickerInline,
                  "dp--overlay-relative": r.timePicker
                }),
                style: ut(M.timePicker ? { height: `${s(f).modeHeight}px` } : void 0),
                tabindex: M.timePickerInline ? void 0 : 0
              }, [
                P("div", {
                  class: be(
                    M.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  M.$slots["time-picker-overlay"] ? te(M.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: G,
                    setMinutes: ke,
                    setSeconds: T
                  }) : y("", !0),
                  M.$slots["time-picker-overlay"] ? y("", !0) : (d(), h("div", {
                    key: 1,
                    class: be(M.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (d(!0), h(ve, null, Ie(z.value, (Se, V) => Ot((d(), K(uW, H({
                      key: V,
                      ref_for: !0
                    }, {
                      ...M.$props,
                      order: V,
                      hours: Se.hours,
                      minutes: Se.minutes,
                      seconds: Se.seconds,
                      closeTimePickerBtn: B.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: V === 0 ? M.fixedStart : M.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: $,
                      "validate-time": (Q, g) => e.validateTime(Q, se(g, V, Q)),
                      "onUpdate:hours": (Q) => G(se(Q, V, "hours")),
                      "onUpdate:minutes": (Q) => ke(se(Q, V, "minutes")),
                      "onUpdate:seconds": (Q) => T(se(Q, V, "seconds")),
                      onMounted: w,
                      onOverlayClosed: E,
                      onOverlayOpened: ne[2] || (ne[2] = (Q) => M.$emit("overlay-opened", Q)),
                      onAmPmChange: ne[3] || (ne[3] = (Q) => M.$emit("am-pm-change", Q))
                    }), ht({ _: 2 }, [
                      Ie(s(Z), (Q, g) => ({
                        name: Q,
                        fn: fe((D) => [
                          te(M.$slots, Q, H({ ref_for: !0 }, D))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Rt, V === 0 ? !0 : q.value]
                    ])), 128))
                  ], 2)),
                  !M.timePicker && !M.timePickerInline ? Ot((d(), h("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: B,
                    type: "button",
                    class: be(ee.value),
                    "aria-label": (me = s(v)) == null ? void 0 : me.closeTimePicker,
                    tabindex: "0",
                    onKeydown: ne[4] || (ne[4] = (Se) => s(vt)(Se, () => J(!1))),
                    onClick: ne[5] || (ne[5] = (Se) => J(!1))
                  }, [
                    M.$slots["calendar-icon"] ? te(M.$slots, "calendar-icon", { key: 0 }) : y("", !0),
                    M.$slots["calendar-icon"] ? y("", !0) : (d(), K(s(Lr), { key: 1 }))
                  ], 42, kW)), [
                    [Rt, !s(S)(M.hideNavigation, "time")]
                  ]) : y("", !0)
                ], 2)
              ], 14, yW)) : y("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), VC = (e, a, t, o) => {
  const { defaultedRange: r } = Ye(e), l = (x, q) => Array.isArray(a[x]) ? a[x][q] : a[x], i = (x) => e.enableSeconds ? Array.isArray(a.seconds) ? a.seconds[x] : a.seconds : 0, c = (x, q) => x ? q !== void 0 ? na(x, l("hours", q), l("minutes", q), i(q)) : na(x, a.hours, a.minutes, i()) : yC(ce(), i(q)), u = (x, q) => {
    a[x] = q;
  }, v = F(() => e.modelAuto && r.value.enabled ? Array.isArray(t.value) ? t.value.length > 1 : !1 : r.value.enabled), k = (x, q) => {
    const _ = Object.fromEntries(
      Object.keys(a).map((A) => A === x ? [A, q] : [A, a[A]].slice())
    );
    if (v.value && !r.value.disableTimeRangeValidation) {
      const A = (J) => t.value ? na(
        t.value[J],
        _.hours[J],
        _.minutes[J],
        _.seconds[J]
      ) : null, z = (J) => pC(t.value[J], 0);
      return !(Ve(A(0), A(1)) && (hr(A(0), z(1)) || $r(A(1), z(0))));
    }
    return !0;
  }, f = (x, q) => {
    k(x, q) && (u(x, q), o && o());
  }, p = (x) => {
    f("hours", x);
  }, m = (x) => {
    f("minutes", x);
  }, I = (x) => {
    f("seconds", x);
  }, S = (x, q, _, A) => {
    q && p(x), !q && !_ && m(x), _ && I(x), t.value && A(t.value);
  }, C = (x) => {
    if (x) {
      const q = Array.isArray(x), _ = q ? [+x[0].hours, +x[1].hours] : +x.hours, A = q ? [+x[0].minutes, +x[1].minutes] : +x.minutes, z = q ? [+x[0].seconds, +x[1].seconds] : +x.seconds;
      u("hours", _), u("minutes", A), e.enableSeconds && u("seconds", z);
    }
  }, B = (x, q) => {
    const _ = {
      hours: Array.isArray(a.hours) ? a.hours[x] : a.hours,
      disabledArr: []
    };
    return (q || q === 0) && (_.hours = q), Array.isArray(e.disabledTimes) && (_.disabledArr = r.value.enabled && Array.isArray(e.disabledTimes[x]) ? e.disabledTimes[x] : e.disabledTimes), _;
  }, $ = F(() => (x, q) => {
    var _;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: A, hours: z } = B(x, q), J = A.filter((ee) => +ee.hours === z);
      return ((_ = J[0]) == null ? void 0 : _.minutes) === "*" ? { hours: [z], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (J == null ? void 0 : J.map((ee) => +ee.minutes)) ?? [],
        seconds: (J == null ? void 0 : J.map((ee) => ee.seconds ? +ee.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: u,
    updateHours: p,
    updateMinutes: m,
    updateSeconds: I,
    getSetDateTime: c,
    updateTimeValues: S,
    getSecondsValue: i,
    assignStartTime: C,
    validateTime: k,
    disabledTimesConfig: $
  };
}, mW = (e, a) => {
  const t = () => {
    e.isTextInputDate && q();
  }, { modelValue: o, time: r } = Kr(e, a, t), { defaultedStartTime: l, defaultedRange: i, defaultedTz: c } = Ye(e), { updateTimeValues: u, getSetDateTime: v, setTime: k, assignStartTime: f, disabledTimesConfig: p, validateTime: m } = VC(e, r, o, I);
  function I() {
    a("update-flow-step");
  }
  const S = (A) => {
    const { hours: z, minutes: J, seconds: ee } = A;
    return { hours: +z, minutes: +J, seconds: ee ? +ee : 0 };
  }, C = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const z = S(e.startTime[0]), J = S(e.startTime[1]);
        return [Re(ce(), z), Re(ce(), J)];
      }
      const A = S(e.startTime);
      return Re(ce(), A);
    }
    return i.value.enabled ? [null, null] : null;
  }, B = () => {
    if (i.value.enabled) {
      const [A, z] = C();
      o.value = [
        gt(v(A, 0), c.value.timezone),
        gt(v(z, 1), c.value.timezone)
      ];
    } else
      o.value = gt(v(C()), c.value.timezone);
  }, $ = (A) => Array.isArray(A) ? [Xo(ce(A[0])), Xo(ce(A[1]))] : [Xo(A ?? ce())], x = (A, z, J) => {
    k("hours", A), k("minutes", z), k("seconds", e.enableSeconds ? J : 0);
  }, q = () => {
    const [A, z] = $(o.value);
    return i.value.enabled ? x(
      [A.hours, z.hours],
      [A.minutes, z.minutes],
      [A.seconds, z.seconds]
    ) : x(A.hours, A.minutes, A.seconds);
  };
  Qe(() => {
    if (!e.shadow)
      return f(l.value), o.value ? q() : B();
  });
  const _ = () => {
    Array.isArray(o.value) ? o.value = o.value.map((A, z) => A && v(A, z)) : o.value = v(o.value), a("time-update");
  };
  return {
    modelValue: o,
    time: r,
    disabledTimesConfig: p,
    updateTime: (A, z = !0, J = !1) => {
      u(A, z, J, _);
    },
    validateTime: m
  };
}, fW = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ..._t
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, l = tr(), i = wt(l, "timePicker"), c = U(null), { time: u, modelValue: v, disabledTimesConfig: k, updateTime: f, validateTime: p } = mW(r, o);
    return Qe(() => {
      r.shadow || o("mount", null);
    }), a({ getSidebarProps: () => ({
      modelValue: v,
      time: u,
      updateTime: f
    }), toggleTimePicker: (m, I = !1, S = "") => {
      var C;
      (C = c.value) == null || C.toggleTimePicker(m, I, S);
    } }), (m, I) => (d(), K(Qx, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: fe(() => [
        Le(HC, H({
          ref_key: "tpRef",
          ref: c
        }, m.$props, {
          hours: s(u).hours,
          minutes: s(u).minutes,
          seconds: s(u).seconds,
          "internal-model-value": m.internalModelValue,
          "disabled-times-config": s(k),
          "validate-time": s(p),
          "onUpdate:hours": I[0] || (I[0] = (S) => s(f)(S)),
          "onUpdate:minutes": I[1] || (I[1] = (S) => s(f)(S, !1)),
          "onUpdate:seconds": I[2] || (I[2] = (S) => s(f)(S, !1, !0)),
          onAmPmChange: I[3] || (I[3] = (S) => m.$emit("am-pm-change", S)),
          onResetFlow: I[4] || (I[4] = (S) => m.$emit("reset-flow")),
          onOverlayClosed: I[5] || (I[5] = (S) => m.$emit("overlay-toggle", { open: !1, overlay: S })),
          onOverlayOpened: I[6] || (I[6] = (S) => m.$emit("overlay-toggle", { open: !0, overlay: S }))
        }), ht({ _: 2 }, [
          Ie(s(i), (S, C) => ({
            name: S,
            fn: fe((B) => [
              te(m.$slots, S, j(re(B)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), vW = { class: "dp--header-wrap" }, gW = {
  key: 0,
  class: "dp__month_year_wrap"
}, MW = { key: 0 }, bW = { class: "dp__month_year_wrap" }, xW = ["aria-label", "data-test", "onClick", "onKeydown"], wW = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ..._t
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, {
      defaultedTransitions: l,
      defaultedAriaLabels: i,
      defaultedMultiCalendars: c,
      defaultedFilters: u,
      defaultedConfig: v,
      defaultedHighlight: k,
      propDates: f,
      defaultedUI: p
    } = Ye(r), { transitionName: m, showTransition: I } = Yr(l), { buildMatrix: S } = ra(), { handleMonthYearChange: C, isDisabled: B, updateMonthYear: $ } = RN(r, o), { showLeftIcon: x, showRightIcon: q } = ew(), _ = U(!1), A = U(!1), z = U([null, null, null, null]);
    Qe(() => {
      o("mount");
    });
    const J = (V) => ({
      get: () => r[V],
      set: (Q) => {
        const g = V === Ct.month ? Ct.year : Ct.month;
        o("update-month-year", { [V]: Q, [g]: r[g] }), V === Ct.month ? E(!0) : M(!0);
      }
    }), ee = F(J(Ct.month)), Z = F(J(Ct.year)), se = F(() => (V) => ({
      month: r.month,
      year: r.year,
      items: V === Ct.month ? r.months : r.years,
      instance: r.instance,
      updateMonthYear: $,
      toggle: V === Ct.month ? E : M
    })), G = F(() => r.months.find((Q) => Q.value === r.month) || { text: "", value: 0 }), ke = F(() => yr(r.months, (V) => {
      const Q = r.month === V.value, g = Or(
        V.value,
        bC(r.year, f.value.minDate),
        xC(r.year, f.value.maxDate)
      ) || u.value.months.includes(V.value), D = CC(k.value, V.value, r.year);
      return { active: Q, disabled: g, highlighted: D };
    })), T = F(() => yr(r.years, (V) => {
      const Q = r.year === V.value, g = Or(
        V.value,
        kr(f.value.minDate),
        kr(f.value.maxDate)
      ) || u.value.years.includes(V.value), D = wL(k.value, V.value);
      return { active: Q, disabled: g, highlighted: D };
    })), w = (V, Q, g) => {
      g !== void 0 ? V.value = g : V.value = !V.value, V.value ? o("overlay-opened", Q) : o("overlay-closed", Q);
    }, E = (V = !1, Q) => {
      ne(V), w(_, dt.month, Q);
    }, M = (V = !1, Q) => {
      ne(V), w(A, dt.year, Q);
    }, ne = (V) => {
      V || o("reset-flow");
    }, ue = (V, Q) => {
      r.arrowNavigation && (z.value[Q] = nt(V), S(z.value, "monthYear"));
    }, me = F(() => {
      var V, Q;
      return [
        {
          type: Ct.month,
          index: 1,
          toggle: E,
          modelValue: ee.value,
          updateModelValue: (g) => ee.value = g,
          text: G.value.text,
          showSelectionGrid: _.value,
          items: ke.value,
          ariaLabel: (V = i.value) == null ? void 0 : V.openMonthsOverlay
        },
        {
          type: Ct.year,
          index: 2,
          toggle: M,
          modelValue: Z.value,
          updateModelValue: (g) => Z.value = g,
          text: MC(r.year, r.locale),
          showSelectionGrid: A.value,
          items: T.value,
          ariaLabel: (Q = i.value) == null ? void 0 : Q.openYearsOverlay
        }
      ];
    }), Se = F(() => r.disableYearSelect ? [me.value[0]] : r.yearFirst ? [...me.value].reverse() : me.value);
    return a({
      toggleMonthPicker: E,
      toggleYearPicker: M,
      handleMonthYearChange: C
    }), (V, Q) => {
      var g, D, ae, L, de, Ce;
      return d(), h("div", vW, [
        V.$slots["month-year"] ? (d(), h("div", gW, [
          te(V.$slots, "month-year", j(re({ month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: s($), handleMonthYearChange: s(C), instance: e.instance })))
        ])) : (d(), h(ve, { key: 1 }, [
          V.$slots["top-extra"] ? (d(), h("div", MW, [
            te(V.$slots, "top-extra", { value: V.internalModelValue })
          ])) : y("", !0),
          P("div", bW, [
            s(x)(s(c), e.instance) && !V.vertical ? (d(), K(Vr, {
              key: 0,
              "aria-label": (g = s(i)) == null ? void 0 : g.prevMonth,
              disabled: s(B)(!1),
              class: be((D = s(p)) == null ? void 0 : D.navBtnPrev),
              onActivate: Q[0] || (Q[0] = (W) => s(C)(!1, !0)),
              onSetRef: Q[1] || (Q[1] = (W) => ue(W, 0))
            }, {
              default: fe(() => [
                V.$slots["arrow-left"] ? te(V.$slots, "arrow-left", { key: 0 }) : y("", !0),
                V.$slots["arrow-left"] ? y("", !0) : (d(), K(s(yL), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : y("", !0),
            P("div", {
              class: be(["dp__month_year_wrap", {
                dp__year_disable_select: V.disableYearSelect
              }])
            }, [
              (d(!0), h(ve, null, Ie(Se.value, (W, xe) => (d(), h(ve, {
                key: W.type
              }, [
                P("button", {
                  ref_for: !0,
                  ref: (b) => ue(b, xe + 1),
                  type: "button",
                  class: "dp__btn dp__month_year_select",
                  tabindex: "0",
                  "aria-label": W.ariaLabel,
                  "data-test": `${W.type}-toggle-overlay-${e.instance}`,
                  onClick: W.toggle,
                  onKeydown: (b) => s(vt)(b, () => W.toggle(), !0)
                }, [
                  V.$slots[W.type] ? te(V.$slots, W.type, {
                    key: 0,
                    text: W.text,
                    value: r[W.type]
                  }) : y("", !0),
                  V.$slots[W.type] ? y("", !0) : (d(), h(ve, { key: 1 }, [
                    lt(N(W.text), 1)
                  ], 64))
                ], 40, xW),
                Le(mr, {
                  name: s(m)(W.showSelectionGrid),
                  css: s(I)
                }, {
                  default: fe(() => [
                    W.showSelectionGrid ? (d(), K(Zr, {
                      key: 0,
                      items: W.items,
                      "arrow-navigation": V.arrowNavigation,
                      "hide-navigation": V.hideNavigation,
                      "is-last": V.autoApply && !s(v).keepActionRow,
                      "skip-button-ref": !1,
                      config: V.config,
                      type: W.type,
                      "header-refs": [],
                      "esc-close": V.escClose,
                      "menu-wrap-ref": V.menuWrapRef,
                      "text-input": V.textInput,
                      "aria-labels": V.ariaLabels,
                      onSelected: W.updateModelValue,
                      onToggle: W.toggle
                    }, ht({
                      "button-icon": fe(() => [
                        V.$slots["calendar-icon"] ? te(V.$slots, "calendar-icon", { key: 0 }) : y("", !0),
                        V.$slots["calendar-icon"] ? y("", !0) : (d(), K(s(Lr), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      V.$slots[`${W.type}-overlay-value`] ? {
                        name: "item",
                        fn: fe(({ item: b }) => [
                          te(V.$slots, `${W.type}-overlay-value`, {
                            text: b.text,
                            value: b.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      V.$slots[`${W.type}-overlay`] ? {
                        name: "overlay",
                        fn: fe(() => [
                          te(V.$slots, `${W.type}-overlay`, H({ ref_for: !0 }, se.value(W.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      V.$slots[`${W.type}-overlay-header`] ? {
                        name: "header",
                        fn: fe(() => [
                          te(V.$slots, `${W.type}-overlay-header`, {
                            toggle: W.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "onSelected", "onToggle"])) : y("", !0)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            s(x)(s(c), e.instance) && V.vertical ? (d(), K(Vr, {
              key: 1,
              "aria-label": (ae = s(i)) == null ? void 0 : ae.prevMonth,
              disabled: s(B)(!1),
              class: be((L = s(p)) == null ? void 0 : L.navBtnPrev),
              onActivate: Q[2] || (Q[2] = (W) => s(C)(!1, !0))
            }, {
              default: fe(() => [
                V.$slots["arrow-up"] ? te(V.$slots, "arrow-up", { key: 0 }) : y("", !0),
                V.$slots["arrow-up"] ? y("", !0) : (d(), K(s(fL), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : y("", !0),
            s(q)(s(c), e.instance) ? (d(), K(Vr, {
              key: 2,
              ref: "rightIcon",
              disabled: s(B)(!0),
              "aria-label": (de = s(i)) == null ? void 0 : de.nextMonth,
              class: be((Ce = s(p)) == null ? void 0 : Ce.navBtnNext),
              onActivate: Q[3] || (Q[3] = (W) => s(C)(!0, !0)),
              onSetRef: Q[4] || (Q[4] = (W) => ue(W, V.disableYearSelect ? 2 : 3))
            }, {
              default: fe(() => [
                V.$slots[V.vertical ? "arrow-down" : "arrow-right"] ? te(V.$slots, V.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : y("", !0),
                V.$slots[V.vertical ? "arrow-down" : "arrow-right"] ? y("", !0) : (d(), K(st(V.vertical ? s(vL) : s(kL)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : y("", !0)
          ])
        ], 64))
      ]);
    };
  }
}), LW = ["aria-label"], SW = {
  class: "dp__calendar_header",
  role: "row"
}, IW = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, CW = ["aria-label"], AW = /* @__PURE__ */ P("div", { class: "dp__calendar_header_separator" }, null, -1), qW = ["aria-label"], zW = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, PW = { class: "dp__cell_inner" }, _W = ["id", "aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], jW = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ..._t
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, { buildMultiLevelMatrix: l } = ra(), {
      defaultedTransitions: i,
      defaultedConfig: c,
      defaultedAriaLabels: u,
      defaultedMultiCalendars: v,
      defaultedWeekNumbers: k,
      defaultedMultiDates: f,
      defaultedUI: p
    } = Ye(r), m = U(null), I = U({
      bottom: "",
      left: "",
      transform: ""
    }), S = U([]), C = U(null), B = U(!0), $ = U(""), x = U({ startX: 0, endX: 0, startY: 0, endY: 0 }), q = U([]), _ = U({ left: "50%" }), A = U(!1), z = F(() => r.calendar ? r.calendar(r.mappedDates) : r.mappedDates), J = F(() => r.dayNames ? Array.isArray(r.dayNames) ? r.dayNames : r.dayNames(r.locale, +r.weekStart) : cN(r.formatLocale, r.locale, +r.weekStart));
    Qe(() => {
      o("mount", { cmp: "calendar", refs: S }), c.value.noSwipe || C.value && (C.value.addEventListener("touchstart", ue, { passive: !1 }), C.value.addEventListener("touchend", me, { passive: !1 }), C.value.addEventListener("touchmove", Se, { passive: !1 })), r.monthChangeOnScroll && C.value && C.value.addEventListener("wheel", g, { passive: !1 });
    });
    const ee = (W) => W ? r.vertical ? "vNext" : "next" : r.vertical ? "vPrevious" : "previous", Z = (W, xe) => {
      if (r.transitions) {
        const b = kt(Wt(ce(), r.month, r.year));
        $.value = et(kt(Wt(ce(), W, xe)), b) ? i.value[ee(!0)] : i.value[ee(!1)], B.value = !1, Mt(() => {
          B.value = !0;
        });
      }
    }, se = F(
      () => ({
        [r.calendarClassName]: !!r.calendarClassName,
        ...p.value.calendar ?? {}
      })
    ), G = F(() => (W) => {
      const xe = sN(W);
      return {
        dp__marker_dot: xe.type === "dot",
        dp__marker_line: xe.type === "line"
      };
    }), ke = F(() => (W) => Ve(W, m.value)), T = F(() => ({
      dp__calendar: !0,
      dp__calendar_next: v.value.count > 0 && r.instance !== 0
    })), w = F(() => (W) => r.hideOffsetDates ? W.current : !0), E = async (W, xe, b) => {
      const Y = nt(S.value[xe][b]);
      if (Y) {
        const { width: le, height: ie } = Y.getBoundingClientRect();
        m.value = W.value;
        let oe = { left: `${le / 2}px` }, je = -50;
        if (await Mt(), q.value[0]) {
          const { left: R, width: ye } = q.value[0].getBoundingClientRect();
          R < 0 && (oe = { left: "0" }, je = 0, _.value.left = `${le / 2}px`), window.innerWidth < R + ye && (oe = { right: "0" }, je = 0, _.value.left = `${ye - le / 2}px`);
        }
        I.value = {
          bottom: `${ie}px`,
          ...oe,
          transform: `translateX(${je}%)`
        }, o("tooltip-open", W.marker);
      }
    }, M = async (W, xe, b) => {
      var Y, le;
      if (A.value && f.value.enabled && f.value.dragSelect)
        return o("select-date", W);
      o("set-hover-date", W), (le = (Y = W.marker) == null ? void 0 : Y.tooltip) != null && le.length && await E(W, xe, b);
    }, ne = (W) => {
      m.value && (m.value = null, I.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), o("tooltip-close", W.marker));
    }, ue = (W) => {
      x.value.startX = W.changedTouches[0].screenX, x.value.startY = W.changedTouches[0].screenY;
    }, me = (W) => {
      x.value.endX = W.changedTouches[0].screenX, x.value.endY = W.changedTouches[0].screenY, V();
    }, Se = (W) => {
      r.vertical && !r.inline && W.preventDefault();
    }, V = () => {
      const W = r.vertical ? "Y" : "X";
      Math.abs(x.value[`start${W}`] - x.value[`end${W}`]) > 10 && o("handle-swipe", x.value[`start${W}`] > x.value[`end${W}`] ? "right" : "left");
    }, Q = (W, xe, b) => {
      W && (Array.isArray(S.value[xe]) ? S.value[xe][b] = W : S.value[xe] = [W]), r.arrowNavigation && l(S.value, "calendar");
    }, g = (W) => {
      r.monthChangeOnScroll && (W.preventDefault(), o("handle-scroll", W));
    }, D = (W) => k.value.type === "local" ? uL(W.value, { weekStartsOn: +r.weekStart }) : k.value.type === "iso" ? dL(W.value) : typeof k.value.type == "function" ? k.value.type(W.value) : "", ae = (W) => {
      const xe = W[0];
      return k.value.hideOnOffsetDates ? W.some((b) => b.current) ? D(xe) : "" : D(xe);
    }, L = (W, xe) => {
      f.value.enabled || (aa(W, c.value), o("select-date", xe));
    }, de = (W) => {
      aa(W, c.value);
    }, Ce = (W) => {
      f.value.enabled && f.value.dragSelect ? (A.value = !0, o("select-date", W)) : f.value.enabled && o("select-date", W);
    };
    return a({ triggerTransition: Z }), (W, xe) => {
      var b;
      return d(), h("div", {
        class: be(T.value)
      }, [
        P("div", {
          ref_key: "calendarWrapRef",
          ref: C,
          role: "grid",
          class: be(se.value),
          "aria-label": (b = s(u)) == null ? void 0 : b.calendarWrap
        }, [
          P("div", SW, [
            W.weekNumbers ? (d(), h("div", IW, N(W.weekNumName), 1)) : y("", !0),
            (d(!0), h(ve, null, Ie(J.value, (Y, le) => {
              var ie, oe;
              return d(), h("div", {
                key: le,
                class: "dp__calendar_header_item",
                role: "gridcell",
                "data-test": "calendar-header",
                "aria-label": (oe = (ie = s(u)) == null ? void 0 : ie.weekDay) == null ? void 0 : oe.call(ie, le)
              }, [
                W.$slots["calendar-header"] ? te(W.$slots, "calendar-header", {
                  key: 0,
                  day: Y,
                  index: le
                }) : y("", !0),
                W.$slots["calendar-header"] ? y("", !0) : (d(), h(ve, { key: 1 }, [
                  lt(N(Y), 1)
                ], 64))
              ], 8, CW);
            }), 128))
          ]),
          AW,
          Le(mr, {
            name: $.value,
            css: !!W.transitions
          }, {
            default: fe(() => {
              var Y;
              return [
                B.value ? (d(), h("div", {
                  key: 0,
                  class: "dp__calendar",
                  role: "rowgroup",
                  "aria-label": ((Y = s(u)) == null ? void 0 : Y.calendarDays) || void 0,
                  onMouseleave: xe[1] || (xe[1] = (le) => A.value = !1)
                }, [
                  (d(!0), h(ve, null, Ie(z.value, (le, ie) => (d(), h("div", {
                    key: ie,
                    class: "dp__calendar_row",
                    role: "row"
                  }, [
                    W.weekNumbers ? (d(), h("div", zW, [
                      P("div", PW, N(ae(le.days)), 1)
                    ])) : y("", !0),
                    (d(!0), h(ve, null, Ie(le.days, (oe, je) => {
                      var R, ye, qe;
                      return d(), h("div", {
                        id: s(AC)(oe.value),
                        ref_for: !0,
                        ref: (Be) => Q(Be, ie, je),
                        key: je + ie,
                        role: "gridcell",
                        class: "dp__calendar_item",
                        "aria-selected": (oe.classData.dp__active_date || oe.classData.dp__range_start || oe.classData.dp__range_start) ?? void 0,
                        "aria-disabled": oe.classData.dp__cell_disabled || void 0,
                        "aria-label": (ye = (R = s(u)) == null ? void 0 : R.day) == null ? void 0 : ye.call(R, oe),
                        tabindex: "0",
                        "data-test": oe.value,
                        onClick: Dr((Be) => L(Be, oe), ["prevent"]),
                        onKeydown: (Be) => s(vt)(Be, () => W.$emit("select-date", oe)),
                        onMouseenter: (Be) => M(oe, ie, je),
                        onMouseleave: (Be) => ne(oe),
                        onMousedown: (Be) => Ce(oe),
                        onMouseup: xe[0] || (xe[0] = (Be) => A.value = !1)
                      }, [
                        P("div", {
                          class: be(["dp__cell_inner", oe.classData])
                        }, [
                          W.$slots.day && w.value(oe) ? te(W.$slots, "day", {
                            key: 0,
                            day: +oe.text,
                            date: oe.value
                          }) : y("", !0),
                          W.$slots.day ? y("", !0) : (d(), h(ve, { key: 1 }, [
                            lt(N(oe.text), 1)
                          ], 64)),
                          oe.marker && w.value(oe) ? (d(), h(ve, { key: 2 }, [
                            W.$slots.marker ? te(W.$slots, "marker", {
                              key: 0,
                              marker: oe.marker,
                              day: +oe.text,
                              date: oe.value
                            }) : (d(), h("div", {
                              key: 1,
                              class: be(G.value(oe.marker)),
                              style: ut(oe.marker.color ? { backgroundColor: oe.marker.color } : {})
                            }, null, 6))
                          ], 64)) : y("", !0),
                          ke.value(oe.value) ? (d(), h("div", {
                            key: 3,
                            ref_for: !0,
                            ref_key: "activeTooltip",
                            ref: q,
                            class: "dp__marker_tooltip",
                            style: ut(I.value)
                          }, [
                            (qe = oe.marker) != null && qe.tooltip ? (d(), h("div", {
                              key: 0,
                              class: "dp__tooltip_content",
                              onClick: de
                            }, [
                              (d(!0), h(ve, null, Ie(oe.marker.tooltip, (Be, mt) => (d(), h("div", {
                                key: mt,
                                class: "dp__tooltip_text"
                              }, [
                                W.$slots["marker-tooltip"] ? te(W.$slots, "marker-tooltip", {
                                  key: 0,
                                  tooltip: Be,
                                  day: oe.value
                                }) : y("", !0),
                                W.$slots["marker-tooltip"] ? y("", !0) : (d(), h(ve, { key: 1 }, [
                                  P("div", {
                                    class: "dp__tooltip_mark",
                                    style: ut(Be.color ? { backgroundColor: Be.color } : {})
                                  }, null, 4),
                                  P("div", null, N(Be.text), 1)
                                ], 64))
                              ]))), 128)),
                              P("div", {
                                class: "dp__arrow_bottom_tp",
                                style: ut(_.value)
                              }, null, 4)
                            ])) : y("", !0)
                          ], 4)) : y("", !0)
                        ], 2)
                      ], 40, _W);
                    }), 128))
                  ]))), 128))
                ], 40, qW)) : y("", !0)
              ];
            }),
            _: 3
          }, 8, ["name", "css"])
        ], 10, LW)
      ], 2);
    };
  }
}), US = (e) => Array.isArray(e), HW = (e, a, t, o) => {
  const r = U([]), l = U(/* @__PURE__ */ new Date()), i = U(), c = () => me(e.isTextInputDate), { modelValue: u, calendars: v, time: k, today: f } = Kr(e, a, c), {
    defaultedMultiCalendars: p,
    defaultedStartTime: m,
    defaultedRange: I,
    defaultedConfig: S,
    defaultedTz: C,
    propDates: B,
    defaultedMultiDates: $
  } = Ye(e), { validateMonthYearInRange: x, isDisabled: q, isDateRangeAllowed: _, checkMinMaxRange: A } = la(e), { updateTimeValues: z, getSetDateTime: J, setTime: ee, assignStartTime: Z, validateTime: se, disabledTimesConfig: G } = VC(e, k, u, o), ke = F(
    () => (O) => v.value[O] ? v.value[O].month : 0
  ), T = F(
    () => (O) => v.value[O] ? v.value[O].year : 0
  ), w = (O) => !S.value.keepViewOnOffsetClick || O ? !0 : !i.value, E = (O, he, X, pe = !1) => {
    var ge, pt;
    w(pe) && (v.value[O] || (v.value[O] = { month: 0, year: 0 }), v.value[O].month = $S(he) ? (ge = v.value[O]) == null ? void 0 : ge.month : he, v.value[O].year = $S(X) ? (pt = v.value[O]) == null ? void 0 : pt.year : X);
  }, M = () => {
    e.autoApply && a("select-date");
  };
  Qe(() => {
    e.shadow || (u.value || (xe(), m.value && Z(m.value)), me(!0), e.focusStartDate && e.startDate && xe());
  });
  const ne = F(() => {
    var O;
    return (O = e.flow) != null && O.length && !e.partialFlow ? e.flowStep === e.flow.length : !0;
  }), ue = () => {
    e.autoApply && ne.value && a("auto-apply");
  }, me = (O = !1) => {
    if (u.value)
      return Array.isArray(u.value) ? (r.value = u.value, L(O)) : Q(u.value, O);
    if (p.value.count && O && !e.startDate)
      return V(ce(), O);
  }, Se = () => Array.isArray(u.value) && I.value.enabled ? _e(u.value[0]) === _e(u.value[1] ?? u.value[0]) : !1, V = (O = /* @__PURE__ */ new Date(), he = !1) => {
    if ((!p.value.count || !p.value.static || he) && E(0, _e(O), ze(O)), p.value.count && (!p.value.solo || !u.value || Se()))
      for (let X = 1; X < p.value.count; X++) {
        const pe = Re(ce(), { month: ke.value(X - 1), year: T.value(X - 1) }), ge = YI(pe, { months: 1 });
        v.value[X] = { month: _e(ge), year: ze(ge) };
      }
  }, Q = (O, he) => {
    V(O), ee("hours", Zt(O)), ee("minutes", oa(O)), ee("seconds", ur(O)), p.value.count && he && W();
  }, g = (O) => {
    if (p.value.count) {
      if (p.value.solo)
        return 0;
      const he = _e(O[0]), X = _e(O[1]);
      return Math.abs(X - he) < p.value.count ? 0 : 1;
    }
    return 1;
  }, D = (O, he) => {
    O[1] && I.value.showLastInRange ? V(O[g(O)], he) : V(O[0], he);
    const X = (pe, ge) => [
      pe(O[0]),
      O[1] ? pe(O[1]) : k[ge][1]
    ];
    ee("hours", X(Zt, "hours")), ee("minutes", X(oa, "minutes")), ee("seconds", X(ur, "seconds"));
  }, ae = (O, he) => {
    if ((I.value.enabled || e.weekPicker) && !$.value.enabled)
      return D(O, he);
    if ($.value.enabled && he) {
      const X = O[O.length - 1];
      return Q(X, he);
    }
  }, L = (O) => {
    const he = u.value;
    ae(he, O), p.value.count && p.value.solo && W();
  }, de = (O, he) => {
    const X = Re(ce(), { month: ke.value(he), year: T.value(he) }), pe = O < 0 ? zt(X, 1) : pr(X, 1);
    x(_e(pe), ze(pe), O < 0, e.preventMinMaxNavigation) && (E(he, _e(pe), ze(pe)), a("update-month-year", { instance: he, month: _e(pe), year: ze(pe) }), p.value.count && !p.value.solo && Ce(he), t());
  }, Ce = (O) => {
    for (let he = O - 1; he >= 0; he--) {
      const X = pr(Re(ce(), { month: ke.value(he + 1), year: T.value(he + 1) }), 1);
      E(he, _e(X), ze(X));
    }
    for (let he = O + 1; he <= p.value.count - 1; he++) {
      const X = zt(Re(ce(), { month: ke.value(he - 1), year: T.value(he - 1) }), 1);
      E(he, _e(X), ze(X));
    }
  }, W = () => {
    if (Array.isArray(u.value) && u.value.length === 2) {
      const O = ce(
        ce(u.value[1] ? u.value[1] : zt(u.value[0], 1))
      ), [he, X] = [_e(u.value[0]), ze(u.value[0])], [pe, ge] = [_e(u.value[1]), ze(u.value[1])];
      (he !== pe || he === pe && X !== ge) && p.value.solo && E(1, _e(O), ze(O));
    } else
      u.value && !Array.isArray(u.value) && (E(0, _e(u.value), ze(u.value)), V(ce()));
  }, xe = () => {
    e.startDate && (E(0, _e(ce(e.startDate)), ze(ce(e.startDate))), p.value.count && Ce(0));
  }, b = (O, he) => {
    if (e.monthChangeOnScroll) {
      const X = (/* @__PURE__ */ new Date()).getTime() - l.value.getTime(), pe = Math.abs(O.deltaY);
      let ge = 500;
      pe > 1 && (ge = 100), pe > 100 && (ge = 0), X > ge && (l.value = /* @__PURE__ */ new Date(), de(e.monthChangeOnScroll !== "inverse" ? -O.deltaY : O.deltaY, he));
    }
  }, Y = (O, he, X = !1) => {
    e.monthChangeOnArrows && e.vertical === X && le(O, he);
  }, le = (O, he) => {
    de(O === "right" ? -1 : 1, he);
  }, ie = (O) => {
    if (B.value.markers)
      return jx(O.value, B.value.markers);
  }, oe = (O, he) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [O == 0, !0];
      case "fair":
        return [O == 0 || he > O, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, je = (O, he, X, pe) => {
    if (e.sixWeeks && O.length < 6) {
      const ge = 6 - O.length, pt = (he.getDay() + 7 - pe) % 7, Lt = 6 - (X.getDay() + 7 - pe) % 7, [ca, Qr] = oe(pt, Lt);
      for (let Cr = 1; Cr <= ge; Cr++)
        if (Qr ? !!(Cr % 2) == ca : ca) {
          const Xt = O[0].days[0], dw = R(At(Xt.value, -7), _e(he));
          O.unshift({ days: dw });
        } else {
          const Xt = O[O.length - 1], dw = Xt.days[Xt.days.length - 1], FC = R(At(dw.value, 1), _e(he));
          O.push({ days: FC });
        }
    }
    return O;
  }, R = (O, he) => {
    const X = ce(O), pe = [];
    for (let ge = 0; ge < 7; ge++) {
      const pt = At(X, ge), Lt = _e(pt) !== he;
      pe.push({
        text: e.hideOffsetDates && Lt ? "" : pt.getDate(),
        value: pt,
        current: !Lt,
        classData: {}
      });
    }
    return pe;
  }, ye = (O, he) => {
    const X = [], pe = new Date(he, O), ge = new Date(he, O + 1, 0), pt = e.weekStart, Lt = Pt(pe, { weekStartsOn: pt }), ca = (Qr) => {
      const Cr = R(Qr, O);
      if (X.push({ days: Cr }), !X[X.length - 1].days.some(
        (Xt) => Ve(kt(Xt.value), kt(ge))
      )) {
        const Xt = At(Qr, 7);
        ca(Xt);
      }
    };
    return ca(Lt), je(X, pe, ge, pt);
  }, qe = (O) => {
    const he = na(ce(O.value), k.hours, k.minutes, bt());
    a("date-update", he), $.value.enabled ? LL(he, u, $.value.limit) : u.value = he, o(), Mt().then(() => {
      ue();
    });
  }, Be = (O) => I.value.noDisabledRange ? wC(r.value[0], O).some((he) => q(he)) : !1, mt = () => {
    r.value = u.value ? u.value.slice() : [], r.value.length === 2 && !(I.value.fixedStart || I.value.fixedEnd) && (r.value = []);
  }, Ae = (O, he) => {
    const X = [
      ce(O.value),
      At(ce(O.value), +I.value.autoRange)
    ];
    _(X) ? (he && Kt(O.value), r.value = X) : a("invalid-date", O.value);
  }, Kt = (O) => {
    const he = _e(ce(O)), X = ze(ce(O));
    if (E(0, he, X), p.value.count > 0)
      for (let pe = 1; pe < p.value.count; pe++) {
        const ge = vN(
          Re(ce(O), { year: ke.value(pe - 1), month: T.value(pe - 1) })
        );
        E(pe, ge.month, ge.year);
      }
  }, Ht = (O) => {
    if (Be(O.value) || !A(O.value, u.value, I.value.fixedStart ? 0 : 1))
      return a("invalid-date", O.value);
    r.value = _C(ce(O.value), u, a, I);
  }, Sr = (O, he) => {
    if (mt(), I.value.autoRange)
      return Ae(O, he);
    if (I.value.fixedStart || I.value.fixedEnd)
      return Ht(O);
    r.value[0] ? A(ce(O.value), u.value) && !Be(O.value) ? Ke(ce(O.value), ce(r.value[0])) ? (r.value.unshift(ce(O.value)), a("range-end", r.value[0])) : (r.value[1] = ce(O.value), a("range-end", r.value[1])) : (e.autoApply && a("auto-apply-invalid", O.value), a("invalid-date", O.value)) : (r.value[0] = ce(O.value), a("range-start", r.value[0]));
  }, bt = (O = !0) => e.enableSeconds ? Array.isArray(k.seconds) ? O ? k.seconds[0] : k.seconds[1] : k.seconds : 0, Ir = (O) => {
    r.value[O] = na(
      r.value[O],
      k.hours[O],
      k.minutes[O],
      bt(O !== 1)
    );
  }, aw = () => {
    var O, he;
    r.value[0] && r.value[1] && +((O = r.value) == null ? void 0 : O[0]) > +((he = r.value) == null ? void 0 : he[1]) && (r.value.reverse(), a("range-start", r.value[0]), a("range-end", r.value[1]));
  }, Xr = () => {
    r.value.length && (r.value[0] && !r.value[1] ? Ir(0) : (Ir(0), Ir(1), o()), aw(), u.value = r.value.slice(), Jx(r.value, a, e.autoApply, e.modelAuto));
  }, nw = (O, he = !1) => {
    if (q(O.value) || !O.current && e.hideOffsetDates)
      return a("invalid-date", O.value);
    if (i.value = JSON.parse(JSON.stringify(O)), !I.value.enabled)
      return qe(O);
    US(k.hours) && US(k.minutes) && !$.value.enabled && (Sr(O, he), Xr());
  }, ow = (O, he) => {
    var X;
    E(O, he.month, he.year, !0), p.value.count && !p.value.solo && Ce(O), a("update-month-year", { instance: O, month: he.month, year: he.year }), t(p.value.solo ? O : void 0);
    const pe = (X = e.flow) != null && X.length ? e.flow[e.flowStep] : void 0;
    !he.fromNav && (pe === dt.month || pe === dt.year) && o();
  }, rw = (O, he) => {
    PC({
      value: O,
      modelValue: u,
      range: I.value.enabled,
      timezone: he ? void 0 : C.value.timezone
    }), M(), e.multiCalendars && Mt().then(() => me(!0));
  }, lw = () => {
    const O = gL(ce(), C.value);
    I.value.enabled ? u.value && Array.isArray(u.value) && u.value[0] ? u.value = Ke(O, u.value[0]) ? [O, u.value[0]] : [u.value[0], O] : u.value = [O] : u.value = O, M();
  }, iw = () => {
    if (Array.isArray(u.value))
      if ($.value.enabled) {
        const O = cw();
        u.value[u.value.length - 1] = J(O);
      } else
        u.value = u.value.map((O, he) => O && J(O, he));
    else
      u.value = J(u.value);
    a("time-update");
  }, cw = () => Array.isArray(u.value) && u.value.length ? u.value[u.value.length - 1] : null;
  return {
    calendars: v,
    modelValue: u,
    month: ke,
    year: T,
    time: k,
    disabledTimesConfig: G,
    today: f,
    validateTime: se,
    getCalendarDays: ye,
    getMarker: ie,
    handleScroll: b,
    handleSwipe: le,
    handleArrow: Y,
    selectDate: nw,
    updateMonthYear: ow,
    presetDate: rw,
    selectCurrentDate: lw,
    updateTime: (O, he = !0, X = !1) => {
      z(O, he, X, iw);
    },
    assignMonthAndYear: V
  };
}, VW = { key: 0 }, BW = /* @__PURE__ */ it({
  __name: "DatePicker",
  props: {
    ..._t
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, {
      calendars: l,
      month: i,
      year: c,
      modelValue: u,
      time: v,
      disabledTimesConfig: k,
      today: f,
      validateTime: p,
      getCalendarDays: m,
      getMarker: I,
      handleArrow: S,
      handleScroll: C,
      handleSwipe: B,
      selectDate: $,
      updateMonthYear: x,
      presetDate: q,
      selectCurrentDate: _,
      updateTime: A,
      assignMonthAndYear: z
    } = HW(r, o, Se, V), J = tr(), { setHoverDate: ee, getDayClassData: Z, clearHoverDate: se } = QW(u, r), { defaultedMultiCalendars: G } = Ye(r), ke = U([]), T = U([]), w = U(null), E = wt(J, "calendar"), M = wt(J, "monthYear"), ne = wt(J, "timePicker"), ue = (b) => {
      r.shadow || o("mount", b);
    };
    We(
      l,
      () => {
        r.shadow || setTimeout(() => {
          o("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), We(
      G,
      (b, Y) => {
        b.count - Y.count > 0 && z();
      },
      { deep: !0 }
    );
    const me = F(() => (b) => m(i.value(b), c.value(b)).map((Y) => ({
      ...Y,
      days: Y.days.map((le) => (le.marker = I(le), le.classData = Z(le), le))
    })));
    function Se(b) {
      var Y;
      b || b === 0 ? (Y = T.value[b]) == null || Y.triggerTransition(i.value(b), c.value(b)) : T.value.forEach((le, ie) => le.triggerTransition(i.value(ie), c.value(ie)));
    }
    function V() {
      o("update-flow-step");
    }
    const Q = (b, Y = !1) => {
      $(b, Y), r.spaceConfirm && o("select-date");
    }, g = (b, Y, le = 0) => {
      var ie;
      (ie = ke.value[le]) == null || ie.toggleMonthPicker(b, Y);
    }, D = (b, Y, le = 0) => {
      var ie;
      (ie = ke.value[le]) == null || ie.toggleYearPicker(b, Y);
    }, ae = (b, Y, le) => {
      var ie;
      (ie = w.value) == null || ie.toggleTimePicker(b, Y, le);
    }, L = (b, Y) => {
      var le;
      if (!r.range) {
        const ie = u.value ? u.value : f, oe = Y ? new Date(Y) : ie, je = b ? Pt(oe, { weekStartsOn: 1 }) : nC(oe, { weekStartsOn: 1 });
        $({
          value: je,
          current: _e(oe) === i.value(0),
          text: "",
          classData: {}
        }), (le = document.getElementById(AC(je))) == null || le.focus();
      }
    }, de = (b) => {
      var Y;
      (Y = ke.value[0]) == null || Y.handleMonthYearChange(b, !0);
    }, Ce = (b) => {
      x(0, { month: i.value(0), year: c.value(0) + (b ? 1 : -1), fromNav: !0 });
    }, W = (b, Y) => {
      b === dt.time && o(`time-picker-${Y ? "open" : "close"}`), o("overlay-toggle", { open: Y, overlay: b });
    }, xe = (b) => {
      o("overlay-toggle", { open: !1, overlay: b }), o("focus-menu");
    };
    return a({
      clearHoverDate: se,
      presetDate: q,
      selectCurrentDate: _,
      toggleMonthPicker: g,
      toggleYearPicker: D,
      toggleTimePicker: ae,
      handleArrow: S,
      updateMonthYear: x,
      getSidebarProps: () => ({
        modelValue: u,
        month: i,
        year: c,
        time: v,
        updateTime: A,
        updateMonthYear: x,
        selectDate: $,
        presetDate: q
      }),
      changeMonth: de,
      changeYear: Ce,
      selectWeekDate: L
    }), (b, Y) => (d(), h(ve, null, [
      Le(Qx, {
        "multi-calendars": s(G).count,
        collapse: b.collapse
      }, {
        default: fe(({ instance: le, index: ie }) => [
          b.disableMonthYearSelect ? y("", !0) : (d(), K(wW, H({
            key: 0,
            ref: (oe) => {
              oe && (ke.value[ie] = oe);
            },
            months: s(fC)(b.formatLocale, b.locale, b.monthNameFormat),
            years: s(ML)(b.yearRange, b.locale, b.reverseYears),
            month: s(i)(le),
            year: s(c)(le),
            instance: le
          }, b.$props, {
            onMount: Y[0] || (Y[0] = (oe) => ue(s(Ko).header)),
            onResetFlow: Y[1] || (Y[1] = (oe) => b.$emit("reset-flow")),
            onUpdateMonthYear: (oe) => s(x)(le, oe),
            onOverlayClosed: xe,
            onOverlayOpened: Y[2] || (Y[2] = (oe) => b.$emit("overlay-toggle", { open: !0, overlay: oe }))
          }), ht({ _: 2 }, [
            Ie(s(M), (oe, je) => ({
              name: oe,
              fn: fe((R) => [
                te(b.$slots, oe, j(re(R)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          Le(jW, H({
            ref: (oe) => {
              oe && (T.value[ie] = oe);
            },
            "mapped-dates": me.value(le),
            month: s(i)(le),
            year: s(c)(le),
            instance: le
          }, b.$props, {
            onSelectDate: (oe) => s($)(oe, le !== 1),
            onHandleSpace: (oe) => Q(oe, le !== 1),
            onSetHoverDate: Y[3] || (Y[3] = (oe) => s(ee)(oe)),
            onHandleScroll: (oe) => s(C)(oe, le),
            onHandleSwipe: (oe) => s(B)(oe, le),
            onMount: Y[4] || (Y[4] = (oe) => ue(s(Ko).calendar)),
            onResetFlow: Y[5] || (Y[5] = (oe) => b.$emit("reset-flow")),
            onTooltipOpen: Y[6] || (Y[6] = (oe) => b.$emit("tooltip-open", oe)),
            onTooltipClose: Y[7] || (Y[7] = (oe) => b.$emit("tooltip-close", oe))
          }), ht({ _: 2 }, [
            Ie(s(E), (oe, je) => ({
              name: oe,
              fn: fe((R) => [
                te(b.$slots, oe, j(re({ ...R })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse"]),
      b.enableTimePicker ? (d(), h("div", VW, [
        b.$slots["time-picker"] ? te(b.$slots, "time-picker", j(H({ key: 0 }, { time: s(v), updateTime: s(A) }))) : (d(), K(HC, H({
          key: 1,
          ref_key: "timePickerRef",
          ref: w
        }, b.$props, {
          hours: s(v).hours,
          minutes: s(v).minutes,
          seconds: s(v).seconds,
          "internal-model-value": b.internalModelValue,
          "disabled-times-config": s(k),
          "validate-time": s(p),
          onMount: Y[8] || (Y[8] = (le) => ue(s(Ko).timePicker)),
          "onUpdate:hours": Y[9] || (Y[9] = (le) => s(A)(le)),
          "onUpdate:minutes": Y[10] || (Y[10] = (le) => s(A)(le, !1)),
          "onUpdate:seconds": Y[11] || (Y[11] = (le) => s(A)(le, !1, !0)),
          onResetFlow: Y[12] || (Y[12] = (le) => b.$emit("reset-flow")),
          onOverlayClosed: Y[13] || (Y[13] = (le) => W(le, !1)),
          onOverlayOpened: Y[14] || (Y[14] = (le) => W(le, !0)),
          onAmPmChange: Y[15] || (Y[15] = (le) => b.$emit("am-pm-change", le))
        }), ht({ _: 2 }, [
          Ie(s(ne), (le, ie) => ({
            name: le,
            fn: fe((oe) => [
              te(b.$slots, le, j(re(oe)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : y("", !0)
    ], 64));
  }
}), DW = (e, a) => {
  const t = U(), {
    defaultedMultiCalendars: o,
    defaultedConfig: r,
    defaultedHighlight: l,
    defaultedRange: i,
    propDates: c,
    defaultedFilters: u,
    defaultedMultiDates: v
  } = Ye(e), { modelValue: k, year: f, month: p, calendars: m } = Kr(e, a), { isDisabled: I } = la(e), { selectYear: S, groupedYears: C, showYearPicker: B, isDisabled: $, toggleYearPicker: x, handleYearSelect: q, handleYear: _ } = jC({
    modelValue: k,
    multiCalendars: o,
    range: i,
    highlight: l,
    calendars: m,
    propDates: c,
    month: p,
    year: f,
    filters: u,
    props: e,
    emit: a
  }), A = (w, E) => [w, E].map((M) => Ft(M, "MMMM", { locale: e.formatLocale })).join("-"), z = F(() => (w) => k.value ? Array.isArray(k.value) ? k.value.some((E) => BS(w, E)) : BS(k.value, w) : !1), J = (w) => {
    if (i.value.enabled) {
      if (Array.isArray(k.value)) {
        const E = Ve(w, k.value[0]) || Ve(w, k.value[1]);
        return Kx(k.value, t.value, w) && !E;
      }
      return !1;
    }
    return !1;
  }, ee = (w, E) => w.quarter === zS(E) && w.year === ze(E), Z = (w) => typeof l.value == "function" ? l.value({ quarter: zS(w), year: ze(w) }) : !!l.value.quarters.find((E) => ee(E, w)), se = F(() => (w) => {
    const E = Re(/* @__PURE__ */ new Date(), { year: f.value(w) });
    return dE({
      start: Tr(E),
      end: aC(E)
    }).map((M) => {
      const ne = Zo(M), ue = PS(M), me = I(M), Se = J(ne), V = Z(ne);
      return {
        text: A(ne, ue),
        value: ne,
        active: z.value(ne),
        highlighted: V,
        disabled: me,
        isBetween: Se
      };
    });
  }), G = (w) => {
    LL(w, k, v.value.limit), a("auto-apply", !0);
  }, ke = (w) => {
    k.value = SL(k, w, a), Jx(k.value, a, e.autoApply, e.modelAuto);
  }, T = (w) => {
    k.value = w, a("auto-apply");
  };
  return {
    defaultedConfig: r,
    defaultedMultiCalendars: o,
    groupedYears: C,
    year: f,
    isDisabled: $,
    quarters: se,
    showYearPicker: B,
    modelValue: k,
    setHoverDate: (w) => {
      t.value = w;
    },
    selectYear: S,
    selectQuarter: (w, E, M) => {
      if (!M)
        return m.value[E].month = _e(PS(w)), v.value.enabled ? G(w) : i.value.enabled ? ke(w) : T(w);
    },
    toggleYearPicker: x,
    handleYearSelect: q,
    handleYear: _
  };
}, TW = { class: "dp--quarter-items" }, $W = ["data-test", "disabled", "onClick", "onMouseover"], OW = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ..._t
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, l = tr(), i = wt(l, "yearMode"), {
      defaultedMultiCalendars: c,
      defaultedConfig: u,
      groupedYears: v,
      year: k,
      isDisabled: f,
      quarters: p,
      modelValue: m,
      showYearPicker: I,
      setHoverDate: S,
      selectQuarter: C,
      toggleYearPicker: B,
      handleYearSelect: $,
      handleYear: x
    } = DW(r, o);
    return a({ getSidebarProps: () => ({
      modelValue: m,
      year: k,
      selectQuarter: C,
      handleYearSelect: $,
      handleYear: x
    }) }), (q, _) => (d(), K(Qx, {
      "multi-calendars": s(c).count,
      collapse: q.collapse,
      stretch: ""
    }, {
      default: fe(({ instance: A }) => [
        P("div", {
          class: "dp-quarter-picker-wrap",
          style: ut({ minHeight: `${s(u).modeHeight}px` })
        }, [
          q.$slots["top-extra"] ? te(q.$slots, "top-extra", {
            key: 0,
            value: q.internalModelValue
          }) : y("", !0),
          P("div", null, [
            Le(zC, H(q.$props, {
              items: s(v)(A),
              instance: A,
              "show-year-picker": s(I)[A],
              year: s(k)(A),
              "is-disabled": (z) => s(f)(A, z),
              onHandleYear: (z) => s(x)(A, z),
              onYearSelect: (z) => s($)(z, A),
              onToggleYearPicker: (z) => s(B)(A, z == null ? void 0 : z.flow, z == null ? void 0 : z.show)
            }), ht({ _: 2 }, [
              Ie(s(i), (z, J) => ({
                name: z,
                fn: fe((ee) => [
                  te(q.$slots, z, j(re(ee)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          P("div", TW, [
            (d(!0), h(ve, null, Ie(s(p)(A), (z, J) => (d(), h("div", { key: J }, [
              P("button", {
                type: "button",
                class: be(["dp--qr-btn", {
                  "dp--qr-btn-active": z.active,
                  "dp--qr-btn-between": z.isBetween,
                  "dp--qr-btn-disabled": z.disabled,
                  "dp--highlighted": z.highlighted
                }]),
                "data-test": z.value,
                disabled: z.disabled,
                onClick: (ee) => s(C)(z.value, A, z.disabled),
                onMouseover: (ee) => s(S)(z.value)
              }, [
                q.$slots.quarter ? te(q.$slots, "quarter", {
                  key: 0,
                  value: z.value,
                  text: z.text
                }) : (d(), h(ve, { key: 1 }, [
                  lt(N(z.text), 1)
                ], 64))
              ], 42, $W)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), RW = ["id", "aria-label"], FW = {
  key: 0,
  class: "dp--menu-load-container"
}, EW = /* @__PURE__ */ P("span", { class: "dp--menu-loader" }, null, -1), UW = [
  EW
], NW = {
  key: 0,
  class: "dp__sidebar_left"
}, WW = ["data-test", "onClick", "onKeydown"], GW = {
  key: 2,
  class: "dp__sidebar_right"
}, ZW = {
  key: 3,
  class: "dp__action_extra"
}, NS = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Xx,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, l = U(null), i = F(() => {
      const { openOnTop: R, ...ye } = r;
      return {
        ...ye,
        flowStep: ee.value,
        collapse: r.collapse,
        noOverlayFocus: r.noOverlayFocus,
        menuWrapRef: l.value
      };
    }), { setMenuFocused: c, setShiftKey: u, control: v } = qC(), k = tr(), { defaultedTextInput: f, defaultedInline: p, defaultedConfig: m, defaultedUI: I } = Ye(r), S = U(null), C = U(0), B = U(null), $ = U(!1), x = U(null);
    Qe(() => {
      if (!r.shadow) {
        $.value = !0, q(), window.addEventListener("resize", q);
        const R = nt(l);
        if (R && !f.value.enabled && !p.value.enabled && (c(!0), E()), R) {
          const ye = (qe) => {
            m.value.allowPreventDefault && qe.preventDefault(), aa(qe, m.value, !0);
          };
          R.addEventListener("pointerdown", ye), R.addEventListener("mousedown", ye);
        }
      }
    }), er(() => {
      window.removeEventListener("resize", q);
    });
    const q = () => {
      const R = nt(B);
      R && (C.value = R.getBoundingClientRect().width);
    }, { arrowRight: _, arrowLeft: A, arrowDown: z, arrowUp: J } = ra(), { flowStep: ee, updateFlowStep: Z, childMount: se, resetFlow: G, handleFlow: ke } = JW(r, o, x), T = F(() => r.monthPicker ? QN : r.yearPicker ? eW : r.timePicker ? fW : r.quarterPicker ? OW : BW), w = F(() => {
      var R;
      if (m.value.arrowLeft)
        return m.value.arrowLeft;
      const ye = (R = l.value) == null ? void 0 : R.getBoundingClientRect(), qe = r.getInputRect();
      return (qe == null ? void 0 : qe.width) < (C == null ? void 0 : C.value) && (qe == null ? void 0 : qe.left) <= ((ye == null ? void 0 : ye.left) ?? 0) ? `${(qe == null ? void 0 : qe.width) / 2}px` : (qe == null ? void 0 : qe.right) >= ((ye == null ? void 0 : ye.right) ?? 0) && (qe == null ? void 0 : qe.width) < (C == null ? void 0 : C.value) ? `${(C == null ? void 0 : C.value) - (qe == null ? void 0 : qe.width) / 2}px` : "50%";
    }), E = () => {
      const R = nt(l);
      R && R.focus({ preventScroll: !0 });
    }, M = F(() => {
      var R;
      return ((R = x.value) == null ? void 0 : R.getSidebarProps()) || {};
    }), ne = () => {
      r.openOnTop && o("recalculate-position");
    }, ue = wt(k, "action"), me = F(() => r.monthPicker || r.yearPicker ? wt(k, "monthYear") : r.timePicker ? wt(k, "timePicker") : wt(k, "shared")), Se = F(() => r.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), V = F(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly,
      "dp-menu-loading": r.loading
    })), Q = F(
      () => ({
        dp__menu: !0,
        dp__menu_index: !p.value.enabled,
        dp__relative: p.value.enabled,
        [r.menuClassName]: !!r.menuClassName,
        ...I.value.menu ?? {}
      })
    ), g = (R) => {
      aa(R, m.value, !0);
    }, D = () => {
      r.escClose && o("close-picker");
    }, ae = (R) => {
      if (r.arrowNavigation) {
        if (R === yt.up)
          return J();
        if (R === yt.down)
          return z();
        if (R === yt.left)
          return A();
        if (R === yt.right)
          return _();
      } else
        R === yt.left || R === yt.up ? xe("handleArrow", yt.left, 0, R === yt.up) : xe("handleArrow", yt.right, 0, R === yt.down);
    }, L = (R) => {
      u(R.shiftKey), !r.disableMonthYearSelect && R.code === Ge.tab && R.target.classList.contains("dp__menu") && v.value.shiftKeyInMenu && (R.preventDefault(), aa(R, m.value, !0), o("close-picker"));
    }, de = () => {
      E(), o("time-picker-close");
    }, Ce = (R) => {
      var ye, qe, Be;
      (ye = x.value) == null || ye.toggleTimePicker(!1, !1), (qe = x.value) == null || qe.toggleMonthPicker(!1, !1, R), (Be = x.value) == null || Be.toggleYearPicker(!1, !1, R);
    }, W = (R, ye = 0) => {
      var qe, Be, mt;
      return R === "month" ? (qe = x.value) == null ? void 0 : qe.toggleMonthPicker(!1, !0, ye) : R === "year" ? (Be = x.value) == null ? void 0 : Be.toggleYearPicker(!1, !0, ye) : R === "time" ? (mt = x.value) == null ? void 0 : mt.toggleTimePicker(!0, !1) : Ce(ye);
    }, xe = (R, ...ye) => {
      var qe, Be;
      (qe = x.value) != null && qe[R] && ((Be = x.value) == null || Be[R](...ye));
    }, b = () => {
      xe("selectCurrentDate");
    }, Y = (R, ye) => {
      xe("presetDate", R, ye);
    }, le = () => {
      xe("clearHoverDate");
    }, ie = (R, ye) => {
      xe("updateMonthYear", R, ye);
    }, oe = (R, ye) => {
      R.preventDefault(), ae(ye);
    }, je = (R) => {
      var ye;
      if (L(R), R.key === Ge.home || R.key === Ge.end)
        return xe(
          "selectWeekDate",
          R.key === Ge.home,
          R.target.getAttribute("id")
        );
      switch ((R.key === Ge.pageUp || R.key === Ge.pageDown) && (R.shiftKey ? xe("changeYear", R.key === Ge.pageUp) : xe("changeMonth", R.key === Ge.pageUp), R.target.getAttribute("id") && ((ye = l.value) == null || ye.focus({ preventScroll: !0 }))), R.key) {
        case Ge.esc:
          return D();
        case Ge.arrowLeft:
          return oe(R, yt.left);
        case Ge.arrowRight:
          return oe(R, yt.right);
        case Ge.arrowUp:
          return oe(R, yt.up);
        case Ge.arrowDown:
          return oe(R, yt.down);
        default:
          return;
      }
    };
    return a({
      updateMonthYear: ie,
      switchView: W,
      handleFlow: ke
    }), (R, ye) => {
      var qe, Be, mt;
      return d(), h("div", {
        id: R.uid ? `dp-menu-${R.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: l,
        tabindex: "0",
        role: "dialog",
        "aria-label": (qe = R.ariaLabels) == null ? void 0 : qe.menu,
        class: be(Q.value),
        style: ut({ "--dp-arrow-left": w.value }),
        onMouseleave: le,
        onClick: g,
        onKeydown: je
      }, [
        (R.disabled || R.readonly) && s(p).enabled || R.loading ? (d(), h("div", {
          key: 0,
          class: be(V.value)
        }, [
          R.loading ? (d(), h("div", FW, UW)) : y("", !0)
        ], 2)) : y("", !0),
        !s(p).enabled && !R.teleportCenter ? (d(), h("div", {
          key: 1,
          class: be(Se.value)
        }, null, 2)) : y("", !0),
        P("div", {
          ref_key: "innerMenuRef",
          ref: B,
          class: be({
            dp__menu_content_wrapper: ((Be = R.presetDates) == null ? void 0 : Be.length) || !!R.$slots["left-sidebar"] || !!R.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((mt = R.presetDates) == null ? void 0 : mt.length) || !!R.$slots["left-sidebar"] || !!R.$slots["right-sidebar"])
          }),
          style: ut({ "--dp-menu-width": `${C.value}px` })
        }, [
          R.$slots["left-sidebar"] ? (d(), h("div", NW, [
            te(R.$slots, "left-sidebar", j(re(M.value)))
          ])) : y("", !0),
          R.presetDates.length ? (d(), h("div", {
            key: 1,
            class: be({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 })
          }, [
            (d(!0), h(ve, null, Ie(R.presetDates, (Ae, Kt) => (d(), h(ve, { key: Kt }, [
              Ae.slot ? te(R.$slots, Ae.slot, {
                key: 0,
                presetDate: Y,
                label: Ae.label,
                value: Ae.value
              }) : (d(), h("button", {
                key: 1,
                type: "button",
                style: ut(Ae.style || {}),
                class: be(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test": Ae.testId ?? void 0,
                onClick: Dr((Ht) => Y(Ae.value, Ae.noTz), ["prevent"]),
                onKeydown: (Ht) => s(vt)(Ht, () => Y(Ae.value, Ae.noTz), !0)
              }, N(Ae.label), 47, WW))
            ], 64))), 128))
          ], 2)) : y("", !0),
          P("div", {
            ref_key: "calendarWrapperRef",
            ref: S,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (d(), K(st(T.value), H({
              ref_key: "dynCmpRef",
              ref: x
            }, i.value, {
              "flow-step": s(ee),
              onMount: s(se),
              onUpdateFlowStep: s(Z),
              onResetFlow: s(G),
              onFocusMenu: E,
              onSelectDate: ye[0] || (ye[0] = (Ae) => R.$emit("select-date")),
              onDateUpdate: ye[1] || (ye[1] = (Ae) => R.$emit("date-update", Ae)),
              onTooltipOpen: ye[2] || (ye[2] = (Ae) => R.$emit("tooltip-open", Ae)),
              onTooltipClose: ye[3] || (ye[3] = (Ae) => R.$emit("tooltip-close", Ae)),
              onAutoApply: ye[4] || (ye[4] = (Ae) => R.$emit("auto-apply", Ae)),
              onRangeStart: ye[5] || (ye[5] = (Ae) => R.$emit("range-start", Ae)),
              onRangeEnd: ye[6] || (ye[6] = (Ae) => R.$emit("range-end", Ae)),
              onInvalidFixedRange: ye[7] || (ye[7] = (Ae) => R.$emit("invalid-fixed-range", Ae)),
              onTimeUpdate: ye[8] || (ye[8] = (Ae) => R.$emit("time-update")),
              onAmPmChange: ye[9] || (ye[9] = (Ae) => R.$emit("am-pm-change", Ae)),
              onTimePickerOpen: ye[10] || (ye[10] = (Ae) => R.$emit("time-picker-open", Ae)),
              onTimePickerClose: de,
              onRecalculatePosition: ne,
              onUpdateMonthYear: ye[11] || (ye[11] = (Ae) => R.$emit("update-month-year", Ae)),
              onAutoApplyInvalid: ye[12] || (ye[12] = (Ae) => R.$emit("auto-apply-invalid", Ae)),
              onInvalidDate: ye[13] || (ye[13] = (Ae) => R.$emit("invalid-date", Ae)),
              onOverlayToggle: ye[14] || (ye[14] = (Ae) => R.$emit("overlay-toggle", Ae)),
              "onUpdate:internalModelValue": ye[15] || (ye[15] = (Ae) => R.$emit("update:internal-model-value", Ae))
            }), ht({ _: 2 }, [
              Ie(me.value, (Ae, Kt) => ({
                name: Ae,
                fn: fe((Ht) => [
                  te(R.$slots, Ae, j(re({ ...Ht })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          R.$slots["right-sidebar"] ? (d(), h("div", GW, [
            te(R.$slots, "right-sidebar", j(re(M.value)))
          ])) : y("", !0),
          R.$slots["action-extra"] ? (d(), h("div", ZW, [
            R.$slots["action-extra"] ? te(R.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: b
            }) : y("", !0)
          ])) : y("", !0)
        ], 6),
        !R.autoApply || s(m).keepActionRow ? (d(), K(UN, H({
          key: 2,
          "menu-mount": $.value
        }, i.value, {
          "calendar-width": C.value,
          onClosePicker: ye[16] || (ye[16] = (Ae) => R.$emit("close-picker")),
          onSelectDate: ye[17] || (ye[17] = (Ae) => R.$emit("select-date")),
          onInvalidSelect: ye[18] || (ye[18] = (Ae) => R.$emit("invalid-select")),
          onSelectNow: b
        }), ht({ _: 2 }, [
          Ie(s(ue), (Ae, Kt) => ({
            name: Ae,
            fn: fe((Ht) => [
              te(R.$slots, Ae, j(re({ ...Ht })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : y("", !0)
      ], 46, RW);
    };
  }
});
var cr = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(cr || {});
const YW = ({
  menuRef: e,
  menuRefInner: a,
  inputRef: t,
  pickerWrapperRef: o,
  inline: r,
  emit: l,
  props: i,
  slots: c
}) => {
  const u = U({}), v = U(!1), k = U({
    top: "0",
    left: "0"
  }), f = U(!1), p = Gt(i, "teleportCenter");
  We(p, () => {
    k.value = JSON.parse(JSON.stringify({})), q();
  });
  const m = (w) => {
    if (i.teleport) {
      const E = w.getBoundingClientRect();
      return {
        left: E.left + window.scrollX,
        top: E.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, I = (w, E) => {
    k.value.left = `${w + E - u.value.width}px`;
  }, S = (w) => {
    k.value.left = `${w}px`;
  }, C = (w, E) => {
    i.position === cr.left && S(w), i.position === cr.right && I(w, E), i.position === cr.center && (k.value.left = `${w + E / 2 - u.value.width / 2}px`);
  }, B = (w) => {
    const { width: E, height: M } = w.getBoundingClientRect(), { top: ne, left: ue } = i.altPosition ? i.altPosition(w) : m(w);
    return { top: +ne, left: +ue, width: E, height: M };
  }, $ = () => {
    k.value.left = "50%", k.value.top = "50%", k.value.transform = "translate(-50%, -50%)", k.value.position = "fixed", delete k.value.opacity;
  }, x = () => {
    const w = nt(t), { top: E, left: M, transform: ne } = i.altPosition(w);
    k.value = { top: `${E}px`, left: `${M}px`, transform: ne ?? "" };
  }, q = (w = !0) => {
    var E;
    if (!r.value.enabled) {
      if (p.value)
        return $();
      if (i.altPosition !== null)
        return x();
      if (w) {
        const M = i.teleport ? (E = a.value) == null ? void 0 : E.$el : e.value;
        M && (u.value = M.getBoundingClientRect()), l("recalculate-position");
      }
      return se();
    }
  }, _ = ({ inputEl: w, left: E, width: M }) => {
    window.screen.width > 768 && !v.value && C(E, M), J(w);
  }, A = (w) => {
    const { top: E, left: M, height: ne, width: ue } = B(w);
    k.value.top = `${ne + E + +i.offset}px`, f.value = !1, v.value || (k.value.left = `${M + ue / 2 - u.value.width / 2}px`), _({ inputEl: w, left: M, width: ue });
  }, z = (w) => {
    const { top: E, left: M, width: ne } = B(w);
    k.value.top = `${E - +i.offset - u.value.height}px`, f.value = !0, _({ inputEl: w, left: M, width: ne });
  }, J = (w) => {
    if (i.autoPosition) {
      const { left: E, width: M } = B(w), { left: ne, right: ue } = u.value;
      if (!v.value) {
        if (Math.abs(ne) !== Math.abs(ue)) {
          if (ne <= 0)
            return v.value = !0, S(E);
          if (ue >= document.documentElement.clientWidth)
            return v.value = !0, I(E, M);
        }
        return C(E, M);
      }
    }
  }, ee = () => {
    const w = nt(t);
    if (w) {
      const { height: E } = u.value, { top: M, height: ne } = w.getBoundingClientRect(), ue = window.innerHeight - M - ne, me = M;
      return E <= ue ? Go.bottom : E > ue && E <= me ? Go.top : ue >= me ? Go.bottom : Go.top;
    }
    return Go.bottom;
  }, Z = (w) => ee() === Go.bottom ? A(w) : z(w), se = () => {
    const w = nt(t);
    if (w)
      return i.autoPosition ? Z(w) : A(w);
  }, G = function(w) {
    if (w) {
      const E = w.scrollHeight > w.clientHeight, M = window.getComputedStyle(w).overflowY.indexOf("hidden") !== -1;
      return E && !M;
    }
    return !0;
  }, ke = function(w) {
    return !w || w === document.body || w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : G(w) ? w : ke(w.assignedSlot ? w.assignedSlot.parentNode : w.parentNode);
  }, T = (w) => {
    if (w)
      switch (i.position) {
        case cr.left:
          return { left: 0, transform: "translateX(0)" };
        case cr.right:
          return { left: `${w.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${w.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: f,
    menuStyle: k,
    xCorrect: v,
    setMenuPosition: q,
    getScrollableParent: ke,
    shadowRender: (w, E) => {
      var M, ne, ue;
      const me = document.createElement("div"), Se = (M = nt(t)) == null ? void 0 : M.getBoundingClientRect();
      me.setAttribute("id", "dp--temp-container");
      const V = (ne = o.value) != null && ne.clientWidth ? o.value : document.body;
      V.append(me);
      const Q = T(Se), g = Lx(
        w,
        {
          ...E,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...Q }
        },
        Object.fromEntries(
          Object.keys(c).filter((D) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(D)).map((D) => [D, c[D]])
        )
      );
      qL(g, me), u.value = (ue = g.el) == null ? void 0 : ue.getBoundingClientRect(), qL(null, me), V.removeChild(me);
    }
  };
}, Jt = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] }
], KW = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], XW = {
  all: () => Jt,
  monthYear: () => Jt.filter((e) => e.use.includes("month-year")),
  input: () => KW,
  timePicker: () => Jt.filter((e) => e.use.includes("time")),
  action: () => Jt.filter((e) => e.use.includes("action")),
  calendar: () => Jt.filter((e) => e.use.includes("calendar")),
  menu: () => Jt.filter((e) => e.use.includes("menu")),
  shared: () => Jt.filter((e) => e.use.includes("shared")),
  yearMode: () => Jt.filter((e) => e.use.includes("year-mode"))
}, wt = (e, a, t) => {
  const o = [];
  return XW[a]().forEach((r) => {
    e[r.name] && o.push(r.name);
  }), t != null && t.length && t.forEach((r) => {
    r.slot && o.push(r.slot);
  }), o;
}, Yr = (e) => {
  const a = F(() => (o) => e.value ? o ? e.value.open : e.value.close : ""), t = F(() => (o) => e.value ? o ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: a, showTransition: !!e.value, menuTransition: t };
}, Kr = (e, a, t) => {
  const { defaultedRange: o, defaultedTz: r } = Ye(e), l = ce(gt(ce(), r.value.timezone)), i = U([{ month: _e(l), year: ze(l) }]), c = (p) => {
    const m = {
      hours: Zt(l),
      minutes: oa(l),
      seconds: 0
    };
    return o.value.enabled ? [m[p], m[p]] : m[p];
  }, u = Rr({
    hours: c("hours"),
    minutes: c("minutes"),
    seconds: c("seconds")
  });
  We(
    o,
    (p, m) => {
      p.enabled !== m.enabled && (u.hours = c("hours"), u.minutes = c("minutes"), u.seconds = c("seconds"));
    },
    { deep: !0 }
  );
  const v = F({
    get: () => e.internalModelValue,
    set: (p) => {
      !e.readonly && !e.disabled && a("update:internal-model-value", p);
    }
  }), k = F(
    () => (p) => i.value[p] ? i.value[p].month : 0
  ), f = F(
    () => (p) => i.value[p] ? i.value[p].year : 0
  );
  return We(
    v,
    (p, m) => {
      t && JSON.stringify(p ?? {}) !== JSON.stringify(m ?? {}) && t();
    },
    { deep: !0 }
  ), {
    calendars: i,
    time: u,
    modelValue: v,
    month: k,
    year: f,
    today: l
  };
}, QW = (e, a) => {
  const {
    defaultedMultiCalendars: t,
    defaultedMultiDates: o,
    defaultedUI: r,
    defaultedHighlight: l,
    defaultedTz: i,
    propDates: c,
    defaultedRange: u
  } = Ye(a), { isDisabled: v } = la(a), k = U(null), f = U(gt(/* @__PURE__ */ new Date(), i.value.timezone)), p = (g) => {
    !g.current && a.hideOffsetDates || (k.value = g.value);
  }, m = () => {
    k.value = null;
  }, I = (g) => Array.isArray(e.value) && u.value.enabled && e.value[0] && k.value ? g ? et(k.value, e.value[0]) : Ke(k.value, e.value[0]) : !0, S = (g, D) => {
    const ae = () => e.value ? D ? e.value[0] || null : e.value[1] : null, L = e.value && Array.isArray(e.value) ? ae() : null;
    return Ve(ce(g.value), L);
  }, C = (g) => {
    const D = Array.isArray(e.value) ? e.value[0] : null;
    return g ? !Ke(k.value ?? null, D) : !0;
  }, B = (g, D = !0) => (u.value.enabled || a.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? a.hideOffsetDates && !g.current ? !1 : Ve(ce(g.value), e.value[D ? 0 : 1]) : u.value.enabled ? S(g, D) && C(D) || Ve(g.value, Array.isArray(e.value) ? e.value[0] : null) && I(D) : !1, $ = (g, D) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const ae = Ve(g.value, k.value);
      return D ? et(e.value[0], g.value) && ae : Ke(e.value[0], g.value) && ae;
    }
    return !1;
  }, x = (g) => !e.value || a.hideOffsetDates && !g.current ? !1 : u.value.enabled ? a.modelAuto && Array.isArray(e.value) ? Ve(g.value, e.value[0] ? e.value[0] : f.value) : !1 : o.value.enabled && Array.isArray(e.value) ? e.value.some((D) => Ve(D, g.value)) : Ve(g.value, e.value ? e.value : f.value), q = (g) => {
    if (u.value.autoRange || a.weekPicker) {
      if (k.value) {
        if (a.hideOffsetDates && !g.current)
          return !1;
        const D = At(k.value, +u.value.autoRange), ae = Nt(ce(k.value), a.weekStart);
        return a.weekPicker ? Ve(ae[1], ce(g.value)) : Ve(D, ce(g.value));
      }
      return !1;
    }
    return !1;
  }, _ = (g) => {
    if (u.value.autoRange || a.weekPicker) {
      if (k.value) {
        const D = At(k.value, +u.value.autoRange);
        if (a.hideOffsetDates && !g.current)
          return !1;
        const ae = Nt(ce(k.value), a.weekStart);
        return a.weekPicker ? et(g.value, ae[0]) && Ke(g.value, ae[1]) : et(g.value, k.value) && Ke(g.value, D);
      }
      return !1;
    }
    return !1;
  }, A = (g) => {
    if (u.value.autoRange || a.weekPicker) {
      if (k.value) {
        if (a.hideOffsetDates && !g.current)
          return !1;
        const D = Nt(ce(k.value), a.weekStart);
        return a.weekPicker ? Ve(D[0], g.value) : Ve(k.value, g.value);
      }
      return !1;
    }
    return !1;
  }, z = (g) => Kx(e.value, k.value, g.value), J = () => a.modelAuto && Array.isArray(a.internalModelValue) ? !!a.internalModelValue[0] : !1, ee = () => a.modelAuto ? vC(a.internalModelValue) : !0, Z = (g) => {
    if (a.weekPicker)
      return !1;
    const D = u.value.enabled ? !B(g) && !B(g, !1) : !0;
    return !v(g.value) && !x(g) && !(!g.current && a.hideOffsetDates) && D;
  }, se = (g) => u.value.enabled ? a.modelAuto ? J() && x(g) : !1 : x(g), G = (g) => l.value ? kN(g.value, c.value.highlight) : !1, ke = (g) => {
    const D = v(g.value);
    return D && (typeof l.value == "function" ? !l.value(g.value, D) : !l.value.options.highlightDisabled);
  }, T = (g) => {
    var D;
    return typeof l.value == "function" ? l.value(g.value) : (D = l.value.weekdays) == null ? void 0 : D.includes(g.value.getDay());
  }, w = (g) => (u.value.enabled || a.weekPicker) && (!(t.value.count > 0) || g.current) && ee() && !(!g.current && a.hideOffsetDates) && !x(g) ? z(g) : !1, E = (g) => {
    const { isRangeStart: D, isRangeEnd: ae } = me(g), L = u.value.enabled ? D || ae : !1;
    return {
      dp__cell_offset: !g.current,
      dp__pointer: !a.disabled && !(!g.current && a.hideOffsetDates) && !v(g.value),
      dp__cell_disabled: v(g.value),
      dp__cell_highlight: !ke(g) && (G(g) || T(g)) && !se(g) && !L && !A(g) && !(w(g) && a.weekPicker) && !ae,
      dp__cell_highlight_active: !ke(g) && (G(g) || T(g)) && se(g),
      dp__today: !a.noToday && Ve(g.value, f.value) && g.current,
      "dp--past": Ke(g.value, f.value),
      "dp--future": et(g.value, f.value)
    };
  }, M = (g) => ({
    dp__active_date: se(g),
    dp__date_hover: Z(g)
  }), ne = (g) => {
    if (e.value && !Array.isArray(e.value)) {
      const D = Nt(e.value, a.weekStart);
      return {
        ...V(g),
        dp__range_start: Ve(D[0], g.value),
        dp__range_end: Ve(D[1], g.value),
        dp__range_between_week: et(g.value, D[0]) && Ke(g.value, D[1])
      };
    }
    return {
      ...V(g)
    };
  }, ue = (g) => {
    if (e.value && Array.isArray(e.value)) {
      const D = Nt(e.value[0], a.weekStart), ae = e.value[1] ? Nt(e.value[1], a.weekStart) : [];
      return {
        ...V(g),
        dp__range_start: Ve(D[0], g.value) || Ve(ae[0], g.value),
        dp__range_end: Ve(D[1], g.value) || Ve(ae[1], g.value),
        dp__range_between_week: et(g.value, D[0]) && Ke(g.value, D[1]) || et(g.value, ae[0]) && Ke(g.value, ae[1]),
        dp__range_between: et(g.value, D[1]) && Ke(g.value, ae[0])
      };
    }
    return {
      ...V(g)
    };
  }, me = (g) => {
    const D = t.value.count > 0 ? g.current && B(g) && ee() : B(g) && ee(), ae = t.value.count > 0 ? g.current && B(g, !1) && ee() : B(g, !1) && ee();
    return { isRangeStart: D, isRangeEnd: ae };
  }, Se = (g) => {
    const { isRangeStart: D, isRangeEnd: ae } = me(g);
    return {
      dp__range_start: D,
      dp__range_end: ae,
      dp__range_between: w(g),
      dp__date_hover: Ve(g.value, k.value) && !D && !ae && !a.weekPicker,
      dp__date_hover_start: $(g, !0),
      dp__date_hover_end: $(g, !1)
    };
  }, V = (g) => ({
    ...Se(g),
    dp__cell_auto_range: _(g),
    dp__cell_auto_range_start: A(g),
    dp__cell_auto_range_end: q(g)
  }), Q = (g) => u.value.enabled ? u.value.autoRange ? V(g) : a.modelAuto ? { ...M(g), ...Se(g) } : a.weekPicker ? ue(g) : Se(g) : a.weekPicker ? ne(g) : M(g);
  return {
    setHoverDate: p,
    clearHoverDate: m,
    getDayClassData: (g) => a.hideOffsetDates && !g.current ? {} : {
      ...E(g),
      ...Q(g),
      [a.dayClass ? a.dayClass(g.value, a.internalModelValue) : ""]: !0,
      [a.calendarCellClassName]: !!a.calendarCellClassName,
      ...r.value.calendarCell ?? {}
    }
  };
}, la = (e) => {
  const { defaultedFilters: a, defaultedRange: t, propDates: o, defaultedMultiDates: r } = Ye(e), l = (T) => o.value.disabledDates ? typeof o.value.disabledDates == "function" ? o.value.disabledDates(ce(T)) : !!jx(T, o.value.disabledDates) : !1, i = (T) => o.value.maxDate ? e.yearPicker ? ze(T) > ze(o.value.maxDate) : et(T, o.value.maxDate) : !1, c = (T) => o.value.minDate ? e.yearPicker ? ze(T) < ze(o.value.minDate) : Ke(T, o.value.minDate) : !1, u = (T) => {
    const w = i(T), E = c(T), M = l(T), ne = a.value.months.map((Q) => +Q).includes(_e(T)), ue = e.disabledWeekDays.length ? e.disabledWeekDays.some((Q) => +Q === aU(T)) : !1, me = m(T), Se = ze(T), V = Se < +e.yearRange[0] || Se > +e.yearRange[1];
    return !(w || E || M || ne || V || ue || me);
  }, v = (T, w) => Ke(...ta(o.value.minDate, T, w)) || Ve(...ta(o.value.minDate, T, w)), k = (T, w) => et(...ta(o.value.maxDate, T, w)) || Ve(...ta(o.value.maxDate, T, w)), f = (T, w, E) => {
    let M = !1;
    return o.value.maxDate && E && k(T, w) && (M = !0), o.value.minDate && !E && v(T, w) && (M = !0), M;
  }, p = (T, w, E, M) => {
    let ne = !1;
    return M ? o.value.minDate && o.value.maxDate ? ne = f(T, w, E) : (o.value.minDate && v(T, w) || o.value.maxDate && k(T, w)) && (ne = !0) : ne = !0, ne;
  }, m = (T) => Array.isArray(o.value.allowedDates) && !o.value.allowedDates.length ? !0 : o.value.allowedDates ? !jx(T, o.value.allowedDates) : !1, I = (T) => !u(T), S = (T) => t.value.noDisabledRange ? !tC({ start: T[0], end: T[1] }).some((w) => I(w)) : !0, C = (T) => {
    if (T) {
      const w = ze(T);
      return w >= +e.yearRange[0] && w <= e.yearRange[1];
    }
    return !0;
  }, B = (T, w) => !!(Array.isArray(T) && T[w] && (t.value.maxRange || t.value.minRange) && C(T[w])), $ = (T, w, E = 0) => {
    if (B(w, E) && C(T)) {
      const M = JI(T, w[E]), ne = wC(w[E], T), ue = ne.length === 1 ? 0 : ne.filter((Se) => I(Se)).length, me = Math.abs(M) - (t.value.minMaxRawRange ? 0 : ue);
      if (t.value.minRange && t.value.maxRange)
        return me >= +t.value.minRange && me <= +t.value.maxRange;
      if (t.value.minRange)
        return me >= +t.value.minRange;
      if (t.value.maxRange)
        return me <= +t.value.maxRange;
    }
    return !0;
  }, x = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, q = (T) => Array.isArray(T) ? [T[0] ? gw(T[0]) : null, T[1] ? gw(T[1]) : null] : gw(T), _ = (T, w, E) => T.find(
    (M) => +M.hours === Zt(w) && M.minutes === "*" ? !0 : +M.minutes === oa(w) && +M.hours === Zt(w)
  ) && E, A = (T, w, E) => {
    const [M, ne] = T, [ue, me] = w;
    return !_(M, ue, E) && !_(ne, me, E) && E;
  }, z = (T, w) => {
    const E = Array.isArray(w) ? w : [w];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? A(e.disabledTimes, E, T) : !E.some((M) => _(e.disabledTimes, M, T)) : T;
  }, J = (T, w) => {
    const E = Array.isArray(w) ? [Xo(w[0]), w[1] ? Xo(w[1]) : void 0] : Xo(w), M = !e.disabledTimes(E);
    return T && M;
  }, ee = (T, w) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? z(w, T) : J(w, T) : w, Z = (T) => {
    let w = !0;
    if (!T || x())
      return !0;
    const E = !o.value.minDate && !o.value.maxDate ? q(T) : T;
    return (e.maxTime || o.value.maxDate) && (w = RS(
      e.maxTime,
      o.value.maxDate,
      "max",
      ot(E),
      w
    )), (e.minTime || o.value.minDate) && (w = RS(
      e.minTime,
      o.value.minDate,
      "min",
      ot(E),
      w
    )), ee(T, w);
  }, se = (T) => {
    if (!e.monthPicker)
      return !0;
    let w = !0;
    const E = ce(qt(T));
    if (o.value.minDate && o.value.maxDate) {
      const M = ce(qt(o.value.minDate)), ne = ce(qt(o.value.maxDate));
      return et(E, M) && Ke(E, ne) || Ve(E, M) || Ve(E, ne);
    }
    if (o.value.minDate) {
      const M = ce(qt(o.value.minDate));
      w = et(E, M) || Ve(E, M);
    }
    if (o.value.maxDate) {
      const M = ce(qt(o.value.maxDate));
      w = Ke(E, M) || Ve(E, M);
    }
    return w;
  }, G = F(() => (T) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : Z(T)), ke = F(() => (T) => e.monthPicker ? Array.isArray(T) && (t.value.enabled || r.value.enabled) ? !T.filter((w) => !se(w)).length : se(T) : !0);
  return {
    isDisabled: I,
    validateDate: u,
    validateMonthYearInRange: p,
    isDateRangeAllowed: S,
    checkMinMaxRange: $,
    isValidTime: Z,
    isTimeValid: G,
    isMonthValid: ke
  };
}, ew = () => {
  const e = F(() => (o, r) => o == null ? void 0 : o.includes(r)), a = F(() => (o, r) => o.count ? o.solo ? !0 : r === 0 : !0), t = F(() => (o, r) => o.count ? o.solo ? !0 : r === o.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: a, showRightIcon: t };
}, JW = (e, a, t) => {
  const o = U(0), r = Rr({
    [Ko.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [Ko.calendar]: !1,
    [Ko.header]: !1
  }), l = F(() => e.monthPicker || e.timePicker), i = (f) => {
    var p;
    if ((p = e.flow) != null && p.length) {
      if (!f && l.value)
        return k();
      r[f] = !0, Object.keys(r).filter((m) => !r[m]).length || k();
    }
  }, c = () => {
    var f, p;
    (f = e.flow) != null && f.length && o.value !== -1 && (o.value += 1, a("flow-step", o.value), k()), ((p = e.flow) == null ? void 0 : p.length) === o.value && Mt().then(() => u());
  }, u = () => {
    o.value = -1;
  }, v = (f, p, ...m) => {
    var I, S;
    e.flow[o.value] === f && t.value && ((S = (I = t.value)[p]) == null || S.call(I, ...m));
  }, k = (f = 0) => {
    f && (o.value += f), v(dt.month, "toggleMonthPicker", !0), v(dt.year, "toggleYearPicker", !0), v(dt.calendar, "toggleTimePicker", !1, !0), v(dt.time, "toggleTimePicker", !0, !0);
    const p = e.flow[o.value];
    (p === dt.hours || p === dt.minutes || p === dt.seconds) && v(p, "toggleTimePicker", !0, !0, p);
  };
  return { childMount: i, updateFlowStep: c, resetFlow: u, handleFlow: k, flowStep: o };
}, eG = {
  key: 1,
  class: "dp__input_wrap"
}, tG = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], aG = {
  key: 2,
  class: "dp__clear_icon"
}, nG = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Xx
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, {
      defaultedTextInput: l,
      defaultedAriaLabels: i,
      defaultedInline: c,
      defaultedConfig: u,
      defaultedRange: v,
      defaultedMultiDates: k,
      defaultedUI: f,
      getDefaultPattern: p,
      getDefaultStartTime: m
    } = Ye(r), { checkMinMaxRange: I } = la(r), S = U(), C = U(null), B = U(!1), $ = U(!1), x = F(
      () => ({
        dp__pointer: !r.disabled && !r.readonly && !l.value.enabled,
        dp__disabled: r.disabled,
        dp__input_readonly: !l.value.enabled,
        dp__input: !0,
        dp__input_icon_pad: !r.hideInputIcon,
        dp__input_valid: !!r.state,
        dp__input_invalid: r.state === !1,
        dp__input_focus: B.value || r.isMenuOpen,
        dp__input_reg: !l.value.enabled,
        [r.inputClassName]: !!r.inputClassName,
        ...f.value.input ?? {}
      })
    ), q = () => {
      o("set-input-date", null), r.clearable && r.autoApply && (o("set-empty-date"), S.value = null);
    }, _ = (M) => {
      const ne = m();
      return mN(
        M,
        l.value.format ?? p(),
        ne ?? LC({}, r.enableSeconds),
        r.inputValue,
        $.value,
        r.formatLocale
      );
    }, A = (M) => {
      const { rangeSeparator: ne } = l.value, [ue, me] = M.split(`${ne}`);
      if (ue) {
        const Se = _(ue.trim()), V = me ? _(me.trim()) : null;
        if (hr(Se, V))
          return;
        const Q = Se && V ? [Se, V] : [Se];
        I(V, Q, 0) && (S.value = Se ? Q : null);
      }
    }, z = () => {
      $.value = !0;
    }, J = (M) => {
      if (v.value.enabled)
        A(M);
      else if (k.value.enabled) {
        const ne = M.split(";");
        S.value = ne.map((ue) => _(ue.trim())).filter((ue) => ue);
      } else
        S.value = _(M);
    }, ee = (M) => {
      var ne;
      const ue = typeof M == "string" ? M : (ne = M.target) == null ? void 0 : ne.value;
      ue !== "" ? (l.value.openMenu && !r.isMenuOpen && o("open"), J(ue), o("set-input-date", S.value)) : q(), $.value = !1, o("update:input-value", ue);
    }, Z = (M) => {
      l.value.enabled ? (J(M.target.value), l.value.enterSubmit && $w(S.value) && r.inputValue !== "" ? (o("set-input-date", S.value, !0), S.value = null) : l.value.enterSubmit && r.inputValue === "" && (S.value = null, o("clear"))) : ke(M);
    }, se = (M) => {
      l.value.enabled && l.value.tabSubmit && J(M.target.value), l.value.tabSubmit && $w(S.value) && r.inputValue !== "" ? (o("set-input-date", S.value, !0, !0), S.value = null) : l.value.tabSubmit && r.inputValue === "" && (S.value = null, o("clear", !0));
    }, G = () => {
      B.value = !0, o("focus"), Mt().then(() => {
        var M;
        l.value.enabled && l.value.selectOnFocus && ((M = C.value) == null || M.select());
      });
    }, ke = (M) => {
      M.preventDefault(), aa(M, u.value, !0), l.value.enabled && l.value.openMenu && !c.value.input && !r.isMenuOpen ? o("open") : l.value.enabled || o("toggle");
    }, T = () => {
      o("real-blur"), B.value = !1, (!r.isMenuOpen || c.value.enabled && c.value.input) && o("blur"), r.autoApply && l.value.enabled && S.value && !r.isMenuOpen && (o("set-input-date", S.value), o("select-date"), S.value = null);
    }, w = (M) => {
      aa(M, u.value, !0), o("clear");
    }, E = (M) => {
      if (M.key === "Tab" && se(M), M.key === "Enter" && Z(M), !l.value.enabled) {
        if (M.code === "Tab")
          return;
        M.preventDefault();
      }
    };
    return a({
      focusInput: () => {
        var M;
        (M = C.value) == null || M.focus({ preventScroll: !0 });
      },
      setParsedDate: (M) => {
        S.value = M;
      }
    }), (M, ne) => {
      var ue;
      return d(), h("div", { onClick: ke }, [
        M.$slots.trigger && !M.$slots["dp-input"] && !s(c).enabled ? te(M.$slots, "trigger", { key: 0 }) : y("", !0),
        !M.$slots.trigger && (!s(c).enabled || s(c).input) ? (d(), h("div", eG, [
          M.$slots["dp-input"] && !M.$slots.trigger && (!s(c).enabled || s(c).enabled && s(c).input) ? te(M.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: ee,
            onEnter: Z,
            onTab: se,
            onClear: w,
            onBlur: T,
            onKeypress: E,
            onPaste: z,
            onFocus: G,
            openMenu: () => M.$emit("open"),
            closeMenu: () => M.$emit("close"),
            toggleMenu: () => M.$emit("toggle")
          }) : y("", !0),
          M.$slots["dp-input"] ? y("", !0) : (d(), h("input", {
            key: 1,
            id: M.uid ? `dp-input-${M.uid}` : void 0,
            ref_key: "inputRef",
            ref: C,
            "data-test": "dp-input",
            name: M.name,
            class: be(x.value),
            inputmode: s(l).enabled ? "text" : "none",
            placeholder: M.placeholder,
            disabled: M.disabled,
            readonly: M.readonly,
            required: M.required,
            value: e.inputValue,
            autocomplete: M.autocomplete,
            "aria-label": (ue = s(i)) == null ? void 0 : ue.input,
            "aria-disabled": M.disabled || void 0,
            "aria-invalid": M.state === !1 ? !0 : void 0,
            onInput: ee,
            onBlur: T,
            onFocus: G,
            onKeypress: E,
            onKeydown: E,
            onPaste: z
          }, null, 42, tG)),
          P("div", {
            onClick: ne[2] || (ne[2] = (me) => o("toggle"))
          }, [
            M.$slots["input-icon"] && !M.hideInputIcon ? (d(), h("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: ne[0] || (ne[0] = (me) => o("toggle"))
            }, [
              te(M.$slots, "input-icon")
            ])) : y("", !0),
            !M.$slots["input-icon"] && !M.hideInputIcon && !M.$slots["dp-input"] ? (d(), K(s(Lr), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: ne[1] || (ne[1] = (me) => o("toggle"))
            })) : y("", !0)
          ]),
          M.$slots["clear-icon"] && e.inputValue && M.clearable && !M.disabled && !M.readonly ? (d(), h("span", aG, [
            te(M.$slots, "clear-icon", { clear: w })
          ])) : y("", !0),
          M.clearable && !M.$slots["clear-icon"] && e.inputValue && !M.disabled && !M.readonly ? (d(), K(s(mC), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: ne[3] || (ne[3] = Dr((me) => w(me), ["prevent"]))
          })) : y("", !0)
        ])) : y("", !0)
      ]);
    };
  }
}), oG = typeof window < "u" ? window : void 0, Sw = () => {
}, rG = (e) => YC() ? (KC(e), !0) : !1, lG = (e, a, t, o) => {
  if (!e)
    return Sw;
  let r = Sw;
  const l = We(
    () => s(e),
    (c) => {
      r(), c && (c.addEventListener(a, t, o), r = () => {
        c.removeEventListener(a, t, o), r = Sw;
      });
    },
    { immediate: !0, flush: "post" }
  ), i = () => {
    l(), r();
  };
  return rG(i), i;
}, iG = (e, a, t, o = {}) => {
  const { window: r = oG, event: l = "pointerdown" } = o;
  return r ? lG(r, l, (i) => {
    const c = nt(e), u = nt(a);
    !c || !u || c === i.target || i.composedPath().includes(c) || i.composedPath().includes(u) || t(i);
  }, { passive: !0 }) : void 0;
}, cG = /* @__PURE__ */ it({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Xx
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: a, emit: t }) {
    const o = t, r = e, l = tr(), i = U(!1), c = Gt(r, "modelValue"), u = Gt(r, "timezone"), v = U(null), k = U(null), f = U(null), p = U(!1), m = U(null), I = U(!1), S = U(!1), C = U(!1), B = U(!1), { setMenuFocused: $, setShiftKey: x } = qC(), { clearArrowNav: q } = ra(), { validateDate: _, isValidTime: A } = la(r), {
      defaultedTransitions: z,
      defaultedTextInput: J,
      defaultedInline: ee,
      defaultedConfig: Z,
      defaultedRange: se,
      defaultedMultiDates: G
    } = Ye(r), { menuTransition: ke, showTransition: T } = Yr(z);
    Qe(() => {
      D(r.modelValue), Mt().then(() => {
        if (!ee.value.enabled) {
          const X = Se(m.value);
          X == null || X.addEventListener("scroll", ie), window == null || window.addEventListener("resize", oe);
        }
      }), ee.value.enabled && (i.value = !0), window == null || window.addEventListener("keyup", je), window == null || window.addEventListener("keydown", R);
    }), er(() => {
      if (!ee.value.enabled) {
        const X = Se(m.value);
        X == null || X.removeEventListener("scroll", ie), window == null || window.removeEventListener("resize", oe);
      }
      window == null || window.removeEventListener("keyup", je), window == null || window.removeEventListener("keydown", R);
    });
    const w = wt(l, "all", r.presetDates), E = wt(l, "input");
    We(
      [c, u],
      () => {
        D(c.value);
      },
      { deep: !0 }
    );
    const { openOnTop: M, menuStyle: ne, xCorrect: ue, setMenuPosition: me, getScrollableParent: Se, shadowRender: V } = YW({
      menuRef: v,
      menuRefInner: k,
      inputRef: f,
      pickerWrapperRef: m,
      inline: ee,
      emit: o,
      props: r,
      slots: l
    }), {
      inputValue: Q,
      internalModelValue: g,
      parseExternalModelValue: D,
      emitModelValue: ae,
      formatInputValue: L,
      checkBeforeEmit: de
    } = ON(o, r, p), Ce = F(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: ee.value.enabled,
        "dp--flex-display-collapsed": C.value,
        dp__flex_display_with_input: ee.value.input
      })
    ), W = F(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), xe = F(() => r.teleport ? {
      to: typeof r.teleport == "boolean" ? "body" : r.teleport,
      disabled: !r.teleport || ee.value.enabled
    } : {}), b = F(() => ({ class: "dp__outer_menu_wrap" })), Y = F(() => ee.value.enabled && (r.timePicker || r.monthPicker || r.yearPicker || r.quarterPicker)), le = () => {
      var X, pe;
      return (pe = (X = f.value) == null ? void 0 : X.$el) == null ? void 0 : pe.getBoundingClientRect();
    }, ie = () => {
      i.value && (Z.value.closeOnScroll ? bt() : me());
    }, oe = () => {
      var X;
      i.value && me();
      const pe = (X = k.value) == null ? void 0 : X.$el.getBoundingClientRect().width;
      C.value = document.body.offsetWidth <= pe;
    }, je = (X) => {
      X.key === "Tab" && !ee.value.enabled && !r.teleport && Z.value.tabOutClosesMenu && (m.value.contains(document.activeElement) || bt()), S.value = X.shiftKey;
    }, R = (X) => {
      S.value = X.shiftKey;
    }, ye = () => {
      !r.disabled && !r.readonly && (V(NS, r), me(!1), i.value = !0, i.value && o("open"), i.value || Sr(), D(r.modelValue));
    }, qe = () => {
      var X;
      Q.value = "", Sr(), (X = f.value) == null || X.setParsedDate(null), o("update:model-value", null), o("update:model-timezone-value", null), o("cleared"), Z.value.closeOnClearValue && bt();
    }, Be = () => {
      const X = g.value;
      return !X || !Array.isArray(X) && _(X) ? !0 : Array.isArray(X) ? G.value.enabled || X.length === 2 && _(X[0]) && _(X[1]) ? !0 : se.value.partialRange && !r.timePicker ? _(X[0]) : !1 : !1;
    }, mt = () => {
      de() && Be() ? (ae(), bt()) : o("invalid-select", g.value);
    }, Ae = (X) => {
      Kt(), ae(), Z.value.closeOnAutoApply && !X && bt();
    }, Kt = () => {
      f.value && J.value.enabled && f.value.setParsedDate(g.value);
    }, Ht = (X = !1) => {
      r.autoApply && A(g.value) && Be() && (se.value.enabled && Array.isArray(g.value) ? (se.value.partialRange || g.value.length === 2) && Ae(X) : Ae(X));
    }, Sr = () => {
      J.value.enabled || (g.value = null);
    }, bt = () => {
      ee.value.enabled || (i.value && (i.value = !1, ue.value = !1, $(!1), x(!1), q(), o("closed"), Q.value && D(c.value)), Sr(), o("blur"));
    }, Ir = (X, pe, ge = !1) => {
      if (!X) {
        g.value = null;
        return;
      }
      const pt = Array.isArray(X) ? !X.some((ca) => !_(ca)) : _(X), Lt = A(X);
      pt && Lt && (B.value = !0, g.value = X, pe && (I.value = ge, mt(), o("text-submit")), Mt().then(() => {
        B.value = !1;
      }));
    }, aw = () => {
      r.autoApply && A(g.value) && ae(), Kt();
    }, Xr = () => i.value ? bt() : ye(), nw = (X) => {
      g.value = X;
    }, ow = () => {
      J.value.enabled && (p.value = !0, L()), o("focus");
    }, rw = () => {
      if (J.value.enabled && (p.value = !1, D(r.modelValue), I.value)) {
        const X = pN(m.value, S.value);
        X == null || X.focus();
      }
      o("blur");
    }, lw = (X) => {
      k.value && k.value.updateMonthYear(0, {
        month: TS(X.month),
        year: TS(X.year)
      });
    }, iw = (X) => {
      D(X ?? r.modelValue);
    }, cw = (X, pe) => {
      var ge;
      (ge = k.value) == null || ge.switchView(X, pe);
    }, O = (X) => Z.value.onClickOutside ? Z.value.onClickOutside(X) : bt(), he = (X = 0) => {
      var pe;
      (pe = k.value) == null || pe.handleFlow(X);
    };
    return iG(v, f, () => O(Be)), a({
      closeMenu: bt,
      selectDate: mt,
      clearValue: qe,
      openMenu: ye,
      onScroll: ie,
      formatInputValue: L,
      // exposed for testing purposes
      updateInternalModelValue: nw,
      // modify internal modelValue
      setMonthYear: lw,
      parseModel: iw,
      switchView: cw,
      toggleMenu: Xr,
      handleFlow: he
    }), (X, pe) => (d(), h("div", {
      ref_key: "pickerWrapperRef",
      ref: m,
      class: be(Ce.value),
      "data-datepicker-instance": ""
    }, [
      Le(nG, H({
        ref_key: "inputRef",
        ref: f,
        "input-value": s(Q),
        "onUpdate:inputValue": pe[0] || (pe[0] = (ge) => Aw(Q) ? Q.value = ge : null),
        "is-menu-open": i.value
      }, X.$props, {
        onClear: qe,
        onOpen: ye,
        onSetInputDate: Ir,
        onSetEmptyDate: s(ae),
        onSelectDate: mt,
        onToggle: Xr,
        onClose: bt,
        onFocus: ow,
        onBlur: rw,
        onRealBlur: pe[1] || (pe[1] = (ge) => p.value = !1)
      }), ht({ _: 2 }, [
        Ie(s(E), (ge, pt) => ({
          name: ge,
          fn: fe((Lt) => [
            te(X.$slots, ge, j(re(Lt)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (d(), K(st(X.teleport ? WC : "div"), j(re(xe.value)), {
        default: fe(() => [
          Le(mr, {
            name: s(ke)(s(M)),
            css: s(T) && !s(ee).enabled
          }, {
            default: fe(() => [
              i.value ? (d(), h("div", H({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: v
              }, b.value, {
                class: { "dp--menu-wrapper": !s(ee).enabled },
                style: s(ee).enabled ? void 0 : s(ne)
              }), [
                Le(NS, H({
                  ref_key: "dpMenuRef",
                  ref: k
                }, X.$props, {
                  "internal-model-value": s(g),
                  "onUpdate:internalModelValue": pe[2] || (pe[2] = (ge) => Aw(g) ? g.value = ge : null),
                  class: { [W.value]: !0, "dp--menu-wrapper": X.teleport },
                  "open-on-top": s(M),
                  "no-overlay-focus": Y.value,
                  collapse: C.value,
                  "get-input-rect": le,
                  "is-text-input-date": B.value,
                  onClosePicker: bt,
                  onSelectDate: mt,
                  onAutoApply: Ht,
                  onTimeUpdate: aw,
                  onFlowStep: pe[3] || (pe[3] = (ge) => X.$emit("flow-step", ge)),
                  onUpdateMonthYear: pe[4] || (pe[4] = (ge) => X.$emit("update-month-year", ge)),
                  onInvalidSelect: pe[5] || (pe[5] = (ge) => X.$emit("invalid-select", s(g))),
                  onAutoApplyInvalid: pe[6] || (pe[6] = (ge) => X.$emit("invalid-select", ge)),
                  onInvalidFixedRange: pe[7] || (pe[7] = (ge) => X.$emit("invalid-fixed-range", ge)),
                  onRecalculatePosition: s(me),
                  onTooltipOpen: pe[8] || (pe[8] = (ge) => X.$emit("tooltip-open", ge)),
                  onTooltipClose: pe[9] || (pe[9] = (ge) => X.$emit("tooltip-close", ge)),
                  onTimePickerOpen: pe[10] || (pe[10] = (ge) => X.$emit("time-picker-open", ge)),
                  onTimePickerClose: pe[11] || (pe[11] = (ge) => X.$emit("time-picker-close", ge)),
                  onAmPmChange: pe[12] || (pe[12] = (ge) => X.$emit("am-pm-change", ge)),
                  onRangeStart: pe[13] || (pe[13] = (ge) => X.$emit("range-start", ge)),
                  onRangeEnd: pe[14] || (pe[14] = (ge) => X.$emit("range-end", ge)),
                  onDateUpdate: pe[15] || (pe[15] = (ge) => X.$emit("date-update", ge)),
                  onInvalidDate: pe[16] || (pe[16] = (ge) => X.$emit("invalid-date", ge)),
                  onOverlayToggle: pe[17] || (pe[17] = (ge) => X.$emit("overlay-toggle", ge))
                }), ht({ _: 2 }, [
                  Ie(s(w), (ge, pt) => ({
                    name: ge,
                    fn: fe((Lt) => [
                      te(X.$slots, ge, j(re({ ...Lt })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : y("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 2));
  }
}), IL = /* @__PURE__ */ (() => {
  const e = cG;
  return e.install = (a) => {
    a.component("Vue3DatePicker", e);
  }, e;
})(), dG = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: IL
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(dG).forEach(([e, a]) => {
  e !== "default" && (IL[e] = a);
});
const sG = {
  key: 2,
  class: "text-neutral-800 dark:text-neutral-200"
}, uG = { class: "mt-1 text-sm text-neutral-400 dark:text-neutral-700" }, hG = {
  __name: "Datepicker",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: [String, Number, Object]
    },
    langs: {
      type: Array
    },
    prefix: {
      type: [String, Boolean],
      default: !1
    },
    suffix: {
      type: [String, Boolean],
      default: !1
    },
    long: {
      type: Boolean,
      default: !1
    },
    lowercase: {
      type: Boolean,
      default: !1
    },
    nospace: {
      type: Boolean,
      default: !1
    },
    regex: {
      type: [String, Boolean],
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: [String, Object, Boolean],
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelInside: {
      type: Boolean,
      default: !1
    },
    labelLang: {
      type: [String, Boolean],
      default: !1
    },
    multiPosition: {
      type: [String, Boolean],
      default: !1,
      validator: (e) => [!1, "first", "middle", "last"].includes(e)
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    padding: {
      type: String,
      default: "default"
    },
    rounded: {
      type: String,
      default: "full"
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    locale: {
      type: String,
      default: "en"
    },
    status: {
      type: [String, Boolean],
      default: !1
    },
    statusMessage: {
      type: [String, Boolean],
      default: !1
    },
    // how long to wait with emitting input event after typing has stopped
    debounce: {
      type: Number,
      default: 750
    },
    // saving state indicator - init | saving | saved | error
    saveState: {
      // manual
      type: [String, Boolean],
      default: !1
    },
    autoState: {
      // auto -> 'formSaveState' store necessary
      type: Boolean,
      default: !1
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    VueDatePickerConfig: {
      type: Object,
      default: () => ({ inline: !0 })
    },
    lang: {
      type: String,
      default: "en"
    }
  },
  emits: [
    "update:modelValue",
    "keyup",
    "enter",
    "focus",
    "blur",
    "input-debounced",
    "mouseup"
  ],
  setup(e, { emit: a }) {
    const t = e, o = a, r = Gt(t, "modelValue"), l = U(!1), i = F(() => t.labelInside && t.size >= 11 ? "inside" : "outside");
    F(() => t.placeholder && !r.value && !l.value);
    const c = aL.debounce(function(p, m) {
      v(p);
    }, t.debounce);
    function u(p) {
      console.log("onInput", p), k(p), c(p);
    }
    function v(p) {
      o("input-debounced", p);
    }
    function k(p) {
      o("update:modelValue", p);
    }
    const { ep: f } = Pe({ props: t, locals: { focused: l }, defaults: QF });
    return (p, m) => (d(), h("div", j(re(s(f).root)), [
      t.label && i.value === "outside" ? (d(), h("span", j(H({ key: 0 }, s(f).labelOuter)), N(t.label), 17)) : y("", !0),
      e.mode === "edit" ? (d(), K(s(IL), H({
        key: 1,
        id: "auto",
        modelValue: r.value,
        "onUpdate:modelValue": m[0] || (m[0] = (I) => r.value = I)
      }, e.VueDatePickerConfig, {
        locale: e.lang,
        "onUpdate:modelValue": u,
        disabled: t.disabled
      }), null, 16, ["modelValue", "locale", "disabled"])) : y("", !0),
      e.mode === "view" && r.value ? (d(), h("span", sG, N(new Date(r.value.toLocaleString())), 1)) : y("", !0),
      t.caption ? (d(), h("span", j(H({ key: 3 }, s(f).caption)), [
        P("p", uG, N(e.caption), 1)
      ], 16)) : y("", !0)
    ], 16));
  }
};
const pG = {
  key: 6,
  class: "inline-grid grid-cols-[auto,auto] gap-y-2"
}, yG = {
  key: 5,
  class: "h-2"
}, kG = {
  key: 6,
  class: ""
}, mG = { class: "text-md font-bold text-neutral-400 dark:text-neutral-700" }, fG = {
  key: 7,
  class: "h-4"
}, vG = {
  key: 8,
  class: ""
}, gG = { class: "text-lg font-bold text-neutral-400 dark:text-neutral-700" }, MG = {
  key: 9,
  class: "text-sm text-neutral-400 dark:text-neutral-700"
}, sX = {
  __name: "KeyValueEditor",
  props: {
    modelValue: {
      type: Object,
      required: !0
    },
    fields: {
      type: Array,
      required: !0
    },
    mode: {
      type: String,
      default: "view"
    },
    cols: {
      type: Number,
      default: 2
    },
    showDividers: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, defaults: IF }), l = F(() => {
      var k;
      return (k = window == null ? void 0 : window.matchMedia("(prefers-color-scheme: dark)")) == null ? void 0 : k.matches;
    }), i = F({
      get: () => t.modelValue,
      set: (k) => {
        console.log("emitting value:", k), o("update:modelValue", k);
      }
    });
    function c() {
    }
    function u() {
      for (const k of t.fields)
        if (k.ui === "subFields")
          for (const f of k.subFields)
            i.value[k.id] === void 0 && (i.value[k.id] = {});
    }
    function v() {
      u();
    }
    return v(), (k, f) => (d(), h("div", H(s(r).root, {
      class: ["inline-grid gap-y-2", { "grid-cols-[auto,auto]": e.cols === 2 }]
    }), [
      (d(!0), h(ve, null, Ie(e.fields, (p) => (d(), h("div", {
        class: "contents",
        key: p.id
      }, [
        e.cols === 2 ? (d(), h("div", {
          key: 0,
          class: be(["pl-2 pr-6", [
            {
              "border-b border-neutral-100 dark:border-neutral-800": e.showDividers && p.ui !== "separator"
            }
          ]])
        }, [
          P("span", {
            class: be(["block font-bold", [
              { "text-neutral-600 dark:text-neutral-500": e.mode === "edit" },
              { "text-neutral-400 dark:text-neutral-700": e.mode === "view" },
              { "pt-3.5": ["input", "radio", "select"].includes(p.ui) && e.mode === "edit" },
              { "pt-0.5": ["chips"].includes(p.ui) },
              { "pt-0.5": ["switch"].includes(p.ui) && e.mode === "edit" }
            ]])
          }, N(p.label), 3)
        ], 2)) : y("", !0),
        P("div", {
          class: be(["pb-2.5", [
            { "pt-1 ": e.mode === "edit" },
            { "pr-2": e.mode === "edit" && p.ui !== "subField" },
            {
              "border-b border-neutral-100 dark:border-neutral-800": e.showDividers && e.cols === 2 && p.ui !== "separator"
            }
          ]])
        }, [
          p.ui === "input" ? (d(), K(Qo, H({
            key: 0,
            modelValue: i.value[p.id],
            "onUpdate:modelValue": (m) => i.value[p.id] = m,
            ref_for: !0
          }, p, {
            label: e.cols === 2 ? !1 : p.label,
            mode: p.mode || e.mode,
            fullWidth: "",
            onInput: c
          }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
          p.ui === "radio" ? (d(), K(SS, H({
            key: 1,
            modelValue: i.value[p.id],
            "onUpdate:modelValue": (m) => i.value[p.id] = m,
            ref_for: !0
          }, p, {
            label: e.cols === 2 ? !1 : p.label,
            mode: p.mode || e.mode,
            fullWidth: "",
            "onUpdate:modelValue": c
          }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
          p.ui === "switch" ? (d(), K(IS, H({
            key: 2,
            modelValue: i.value[p.id],
            "onUpdate:modelValue": (m) => i.value[p.id] = m,
            ref_for: !0
          }, p, {
            label: e.cols === 2 ? !1 : p.label,
            mode: p.mode || e.mode,
            size: 6,
            fullWidth: "",
            "onUpdate:modelValue": c
          }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
          p.ui === "chips" ? (d(), K(LS, H({
            key: 3,
            modelValue: i.value[p.id],
            "onUpdate:modelValue": (m) => i.value[p.id] = m,
            ref_for: !0
          }, p, {
            label: e.cols === 2 ? !1 : p.label,
            mode: p.mode || e.mode,
            fullWidth: "",
            size: 6,
            "onUpdate:modelValue": c
          }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
          p.ui === "select" ? (d(), K(CS, H({
            key: 4,
            modelValue: i.value[p.id],
            "onUpdate:modelValue": (m) => i.value[p.id] = m,
            ref_for: !0
          }, p, {
            label: e.cols === 2 ? !1 : p.label,
            mode: p.mode || e.mode,
            fullWidth: "",
            "onUpdate:modelValue": c
          }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
          p.ui === "datepicker" ? (d(), K(hG, H({
            key: 5,
            class: "dpkr",
            modelValue: i.value[p.id],
            "onUpdate:modelValue": (m) => i.value[p.id] = m,
            ref_for: !0
          }, p, {
            label: e.cols === 2 ? !1 : p.label,
            mode: p.mode || e.mode,
            VueDatePickerConfig: {
              dark: l.value,
              monthChangeOnScroll: !1,
              enableTimePicker: !1,
              inline: !0,
              timePickerInline: !0,
              autoApply: !0,
              actionRow: {
                showSelect: !1,
                showCancel: !1,
                showPreview: !1
              },
              ...p.datepickerConfig
            },
            "onUpdate:modelValue": c
          }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode", "VueDatePickerConfig"])) : y("", !0),
          p.ui === "subFields" ? (d(), h("div", pG, [
            (d(!0), h(ve, null, Ie(p.subFields, (m) => (d(), h("div", {
              class: "contents",
              key: m.id
            }, [
              P("div", {
                class: be(["pl-2 pr-6", [
                  {
                    "border-b border-neutral-100 dark:border-neutral-800": e.showDividers && m.ui !== "separator"
                  }
                ]])
              }, [
                P("span", {
                  class: be(["block font-bold", [
                    { "text-neutral-600 dark:text-neutral-500": e.mode === "edit" },
                    { "text-neutral-400 dark:text-neutral-700": e.mode === "view" },
                    { "pt-3.5": ["input", "radio", "select"].includes(m.ui) && e.mode === "edit" },
                    { "pt-0.5": ["chips"].includes(m.ui) },
                    { "pt-0.5": ["switch"].includes(m.ui) && e.mode === "edit" }
                  ]])
                }, N(m.label), 3)
              ], 2),
              P("div", {
                class: be(["pb-2.5 pr-2", [
                  { "pt-1 ": e.mode === "edit" },
                  {
                    "border-b border-neutral-100 dark:border-neutral-800": e.showDividers && e.cols === 2 && m.ui !== "separator"
                  }
                ]])
              }, [
                m.ui === "input" ? (d(), K(Qo, H({
                  key: 0,
                  modelValue: i.value[p.id][m.id],
                  "onUpdate:modelValue": (I) => i.value[p.id][m.id] = I,
                  ref_for: !0
                }, m, {
                  label: e.cols === 2 ? !1 : p.label,
                  mode: e.mode,
                  fullWidth: "",
                  onInput: c
                }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
                m.ui === "radio" ? (d(), K(SS, H({
                  key: 1,
                  modelValue: i.value[p.id][m.id],
                  "onUpdate:modelValue": (I) => i.value[p.id][m.id] = I,
                  ref_for: !0
                }, m, {
                  label: e.cols === 2 ? !1 : p.label,
                  mode: e.mode,
                  fullWidth: "",
                  "onUpdate:modelValue": c
                }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
                m.ui === "switch" ? (d(), K(IS, H({
                  key: 2,
                  modelValue: i.value[p.id][m.id],
                  "onUpdate:modelValue": (I) => i.value[p.id][m.id] = I,
                  ref_for: !0
                }, m, {
                  label: e.cols === 2 ? !1 : p.label,
                  size: 6,
                  mode: e.mode,
                  fullWidth: "",
                  "onUpdate:modelValue": c
                }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
                m.ui === "chips" ? (d(), K(LS, H({
                  key: 3,
                  modelValue: i.value[p.id][m.id],
                  "onUpdate:modelValue": (I) => i.value[p.id][m.id] = I,
                  ref_for: !0
                }, m, {
                  label: e.cols === 2 ? !1 : p.label,
                  mode: e.mode,
                  fullWidth: "",
                  size: 6,
                  "onUpdate:modelValue": c
                }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
                m.ui === "select" ? (d(), K(CS, H({
                  key: 4,
                  modelValue: i.value[p.id][m.id],
                  "onUpdate:modelValue": (I) => i.value[p.id][m.id] = I,
                  ref_for: !0
                }, m, {
                  label: e.cols === 2 ? !1 : p.label,
                  mode: e.mode,
                  fullWidth: "",
                  "onUpdate:modelValue": c
                }), null, 16, ["modelValue", "onUpdate:modelValue", "label", "mode"])) : y("", !0),
                m.ui === "separator" ? (d(), h("div", yG)) : y("", !0),
                m.ui === "title" ? (d(), h("div", kG, [
                  P("span", mG, N(m.title), 1)
                ])) : y("", !0)
              ], 2)
            ]))), 128))
          ])) : y("", !0),
          p.ui === "separator" ? (d(), h("div", fG)) : y("", !0),
          p.ui === "title" ? (d(), h("div", vG, [
            P("span", gG, N(p.title), 1)
          ])) : y("", !0),
          p.ui === "note" && (p.mode && e.mode === p.mode || !p.mode) ? (d(), h("div", MG, N(p.note), 1)) : y("", !0),
          p.ui === "component" ? (d(), K(st(p.component), H({
            key: 10,
            modelValue: i.value[p.id],
            "onUpdate:modelValue": (m) => i.value[p.id] = m,
            ref_for: !0
          }, p.args, {
            mode: e.mode,
            "onUpdate:modelValue": c
          }), null, 16, ["modelValue", "onUpdate:modelValue", "mode"])) : y("", !0)
        ], 2)
      ]))), 128))
    ], 16));
  }
}, bG = {
  composer: {
    props: {
      title: {
        default: "Heading",
        control: "input"
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "px-4 fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm",
      propsStateBased: {}
    },
    dialog: {
      _common: "min-w-64 max-h-[90vh] bg-white dark:bg-neutral-950 dark:text-neutral-200 dark:border dark:border-neutral-800 p-4",
      propsStateBased: {
        rounded: {
          none: "",
          "2xl": "rounded-2xl"
        },
        fullWidth: {
          true: "max-w-full",
          false: "max-w-[600px]"
        }
      }
    },
    title: {
      _common: "text-2xl font-bold",
      propsStateBased: {}
    },
    body: {
      _common: "",
      propsStateBased: {}
    }
  }
}, uX = {
  __name: "Dialog",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    rounded: {
      type: String,
      default: "2xl"
    },
    fullWidth: {
      type: Boolean,
      default: !1
    },
    title: {
      type: [Boolean, String],
      default: !1
    },
    closeButton: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close", "outerClick"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, locals: {}, defaults: bG }), l = U(null);
    function i(c) {
      var u;
      (u = l.value) != null && u.contains(c.target) || o("outerClick");
    }
    return Qe(async () => {
      console.log("mounted"), setTimeout(() => {
        window.addEventListener("click", i);
      }, 100);
    }), er(() => {
      window.removeEventListener("click", i);
    }), (c, u) => (d(), h("div", j(re(s(r).root)), [
      P("div", H({
        ref_key: "elDialog",
        ref: l
      }, s(r).dialog), [
        e.title && !c.$slots.title && !e.closeButton ? (d(), h("h2", H({ key: 0 }, s(r).title, { class: "pb-4" }), N(e.title), 17)) : y("", !0),
        te(c.$slots, "default", {}, () => [
          c.$slots.title && e.title || e.closeButton ? te(c.$slots, "header", { key: 0 }, () => [
            P("div", {
              class: be(["mb-4 flex flex-row items-center", e.title || c.$slots.title ? "justify-between" : "justify-end"])
            }, [
              te(c.$slots, "title", {}, () => [
                e.title ? (d(), h("h2", j(H({ key: 0 }, s(r).title)), N(e.title), 17)) : y("", !0)
              ]),
              e.closeButton ? (d(), K(ft, {
                key: 0,
                class: "shrink-0",
                icon: "X",
                iconStrokeWidth: 3,
                label: "lala",
                circle: "",
                variant: "secondary",
                kind: "solid",
                size: 8,
                onAction: u[0] || (u[0] = (v) => o("close"))
              })) : y("", !0)
            ], 2)
          ]) : y("", !0),
          te(c.$slots, "body", {}, () => [
            P("div", j(re(s(r).body)), "lalala", 16)
          ])
        ])
      ], 16)
    ], 16));
  }
}, xG = {
  composer: {
    compositions: [
      { id: "default", name: "default" },
      { id: "empty", name: "empty" },
      { id: "loading", name: "loading" }
    ],
    props: {
      items: {
        default: [
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "Elevate your sushi experience—literally and figuratively—with a helicopter ride over Dubai followed by a 7-course Omakase dinner at the Burj Al Arab.",
            image: {
              src: "https://picsum.photos/800/800?random=1",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Meet & greet sushi master",
            description: "Have a chat with our sushi god",
            image: {
              src: "https://picsum.photos/800/600?random=2",
              aspect: "portrait",
              fit: "cover"
            },
            price: "2,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Private course",
            description: "You are the chef",
            image: {
              src: "https://picsum.photos/800/800?random=3",
              aspect: "portrait",
              fit: "cover"
            },
            price: "5,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Monetary",
            description: "You choose the value!",
            image: {
              src: "https://picsum.photos/1200/800?random=4",
              aspect: "portrait",
              fit: "cover"
            },
            price: "500 - 10,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "2 week intensive course with sushi master in our beach restaurant",
            description: "Learn the art of sushi making in our beach restaurant. You will be taught by our sushi master and will be able to enjoy your creations afterwards.",
            image: {
              src: "https://picsum.photos/800/400?random=5",
              aspect: "portrait",
              fit: "cover"
            },
            price: "50,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Private course for 2",
            description: "Don't want to share your sushi with strangers? We get it.",
            image: {
              src: "https://picsum.photos/800/400?random=6",
              aspect: "portrait",
              fit: "cover"
            },
            price: "8,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/800/1200?random=7",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/800/500?random=8",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/500/800?random=9",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          }
        ],
        control: "input"
      },
      productItem: {
        rounded: {
          default: !1,
          options: [!1, !0],
          control: "switch"
        },
        frame: {
          default: !1,
          options: [!1, !0],
          control: "switch"
        },
        image: {
          aspect: {
            default: "square",
            options: [
              "auto",
              "square",
              "1/1",
              "landscape",
              "16/9",
              "4/3",
              "3/2",
              "2/1",
              "portrait",
              "9/16",
              "3/4",
              "2/3",
              "1/2"
            ],
            control: "select"
          },
          fit: {
            default: "cover",
            options: ["none", "cover", "contain"],
            control: "select"
          }
        }
      },
      layout: {
        default: "grid",
        options: ["grid", "masonry", "list"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "@container w-full",
      propsStateBased: {}
    },
    wrap: {
      _common: "",
      propsStateBased: {
        layout: {
          grid: "grid grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 gap-2 sm:gap-4",
          masonry: "columns-2 @2xl:columns-3 @4xl:columns-4 space-y-4",
          list: "flex flex-col gap-4 items-center"
        }
      }
    },
    productItem: {
      propsStateBased: {
        layout: {
          grid: "",
          masonry: "",
          list: { layout: "horizontal" }
        }
      }
    }
  }
}, wG = {
  composer: {
    props: {
      title: {
        default: `Omakase & Night Skies:
Dinner and Helicopter Tour`,
        control: "input"
      },
      description: {
        default: "Elevate your sushi experience—literally and figuratively—with a helicopter ride over Dubai followed by a 7-course Omakase dinner at the Burj Al Arab.",
        control: "input"
      },
      image: {
        default: {
          src: "https://picsum.photos/800/800",
          aspect: "square",
          fit: "cover"
        },
        control: "input"
      },
      price: {
        default: "100",
        control: "input"
      },
      pricePrefix: {
        default: "AED",
        control: "input"
      },
      priceSuffix: {
        default: "",
        control: "input"
      },
      rounded: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      },
      frame: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      },
      layout: {
        default: "vertical",
        options: ["vertical", "horizontal"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "group flex w-full cursor-pointer overflow-hidden bg-white dark:bg-neutral-900 p-0 transition-all duration-700 ease-in-out",
      propsStateBased: {
        frame: {
          true: {
            _common: "border border-neutral-100 hover:border-neutral-200 dark:border-neutral-800",
            rounded: {
              true: "rounded-2xl",
              false: "rounded-none"
            }
          }
        },
        layout: {
          vertical: "flex-col max-w-sm gap-0",
          horizontal: "flex-row-reverse min-h-40 max-h-52 max-w-xl gap-2"
        }
      }
    },
    imageWrap: {
      _common: "overflow-hidden shrink-0",
      propsStateBased: {
        layout: {
          vertical: "w-full",
          horizontal: "w-44 h-full"
        },
        rounded: {
          true: {
            frame: {
              true: "",
              false: "rounded-2xl"
            }
          },
          false: "rounded-none"
        }
      }
    },
    image: {
      _common: "shrink-0 group-hover:scale-105 group-hover:opacity-90 transition-all duration-700 ease-in-out block",
      propsStateBased: {
        layout: {
          vertical: {
            classImg: "w-full"
          },
          horizontal: {
            classImg: "w-44 h-full"
          }
        }
      }
    },
    content: {
      _common: "mt-0 flex grow flex-col justify-between",
      propsStateBased: {
        frame: {
          true: "p-3",
          false: "py-3"
        }
      }
    },
    title: {
      _common: "whitespace-pre-wrap text-lg font-bold font-heading leading-6 text-neutral-800 dark:text-neutral-100 group-hover:underline"
    },
    description: {
      _common: "mt-1 mb-2 line-clamp-2 overflow-hidden overflow-ellipsis text-sm text-neutral-400 font-body"
    },
    priceContainer: {
      _common: "mt-1 flex flex-row items-baseline font-body",
      propsStateBased: {
        layout: {
          vertical: "justify-start",
          horizontal: "justify-start"
        }
      }
    },
    priceWrap: {
      _common: "bg-neutral-100 dark:bg-neutral-800 px-1.5 py-0.5",
      propsStateBased: {
        rounded: {
          true: "rounded-md",
          false: "rounded-none"
        }
      }
    },
    pricePrefix: {
      _common: "mr-1 text-xs text-neutral-400 dark:text-neutral-500"
    },
    price: {
      _common: "text-lg text-neutral-500 dark:text-neutral-300"
    },
    priceSuffix: {
      _common: "mx-1 text-xs text-neutral-400 dark:text-neutral-500"
    }
  }
}, LG = {
  composer: {
    props: {
      src: {
        default: "https://picsum.photos/4000/3000",
        control: "input"
      },
      aspect: {
        default: "auto",
        options: ["auto", "square", "16/9", "4/3", "3/2", "2/1", "1/1", "portrait", "landscape"],
        control: "select"
      },
      fit: {
        default: "cover",
        options: ["none", "cover", "contain"],
        control: "select"
      }
    }
  },
  pt: {
    picture: {
      _common: "block",
      propsStateBased: {
        aspect: {
          auto: "aspect-auto",
          square: "aspect-square",
          "16/9": "aspect-[16/9]",
          "9/16": "aspect-[9/16]",
          "4/3": "aspect-[4/3]",
          "3/4": "aspect-[3/4]",
          "3/2": "aspect-[3/2]",
          "2/3": "aspect-[2/3]",
          "2/1": "aspect-[2/1]",
          "1/2": "aspect-[1/2]",
          "1/1": "aspect-[1/1]",
          portrait: "aspect-[3/4]",
          landscape: "aspect-[4/3]"
        },
        fit: {
          // none: "object-none",
          cover: "object-cover w-full h-full",
          contain: "object-contain"
        }
      }
    },
    img: {
      // _common: "block w-full h-full",
      _common: "block",
      propsStateBased: {
        aspect: {
          auto: "aspect-auto",
          square: "aspect-square",
          "16/9": "aspect-[16/9]",
          "9/16": "aspect-[9/16]",
          "4/3": "aspect-[4/3]",
          "3/4": "aspect-[3/4]",
          "3/2": "aspect-[3/2]",
          "2/3": "aspect-[2/3]",
          "2/1": "aspect-[2/1]",
          "1/2": "aspect-[1/2]",
          "1/1": "aspect-[1/1]",
          portrait: "aspect-[3/4]",
          landscape: "aspect-[4/3]"
        },
        fit: {
          // none: "object-none",
          cover: "object-cover w-full h-full",
          // cover: "w-full h-full"
          contain: "object-contain"
        }
      }
    }
  }
}, SG = ["srcset", "type", "media"], IG = ["src"], or = {
  __name: "Image",
  props: {
    src: {
      type: String,
      required: !0
    },
    sources: {
      type: Array
    },
    aspect: {
      type: String,
      default: "auto"
    },
    fit: {
      type: String,
      default: "none"
    },
    classImg: {
      type: String
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: LG });
    return (o, r) => (d(), h("picture", j(re(s(t).picture)), [
      (d(!0), h(ve, null, Ie(e.sources, (l, i) => (d(), h("source", {
        key: i,
        srcset: l.srcset,
        type: l.type,
        media: l.media
      }, null, 8, SG))), 128)),
      P("img", H(s(t).img, {
        class: e.classImg,
        src: e.src
      }), null, 16, IG)
    ], 16));
  }
}, CG = {
  __name: "ProductItem",
  props: {
    image: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String
    },
    price: {
      type: String
    },
    pricePrefix: {
      type: String
    },
    priceSuffix: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    frame: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "vertical"
      // vertical, horizontal
    },
    link: {
      type: Object
    }
  },
  emits: ["click"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, defaults: wG });
    function l() {
      o("click");
    }
    return (i, c) => {
      var v;
      const u = Fr("RouterLink");
      return d(), K(u, H({
        to: ((v = e.link) == null ? void 0 : v.route) || {}
      }, s(r).root, { onClick: l }), {
        default: fe(() => [
          P("div", j(re(s(r).imageWrap)), [
            Le(or, j(re({ ...e.image, ...s(r).image })), null, 16)
          ], 16),
          P("div", j(re(s(r).content)), [
            P("div", null, [
              P("h3", j(re(s(r).title)), N(e.title), 17),
              e.description ? (d(), h("p", j(H({ key: 0 }, s(r).description)), N(e.description), 17)) : y("", !0)
            ]),
            e.price || e.pricePrefix || e.priceSuffix ? (d(), h("div", j(H({ key: 0 }, s(r).priceContainer)), [
              P("div", j(re(s(r).priceWrap)), [
                e.pricePrefix ? (d(), h("span", j(H({ key: 0 }, s(r).pricePrefix)), N(e.pricePrefix), 17)) : y("", !0),
                e.price ? (d(), h("span", j(H({ key: 1 }, s(r).price)), N(e.price), 17)) : y("", !0),
                e.priceSuffix ? (d(), h("span", j(H({ key: 2 }, s(r).priceSuffix)), N(e.priceSuffix), 17)) : y("", !0)
              ], 16)
            ], 16)) : y("", !0)
          ], 16)
        ]),
        _: 1
      }, 16, ["to"]);
    };
  }
};
var AG = tL, WS = Ut;
function BC(e, a, t, o, r, l) {
  return WS(e) && WS(a) && (l.set(a, e), AG(e, a, void 0, BC, l), l.delete(a)), e;
}
var qG = BC, zG = tL, PG = II, _G = PG(function(e, a, t, o) {
  zG(e, a, t, o);
}), jG = _G, HG = LI, VG = SI, BG = qG, DG = jG, TG = VG(function(e) {
  return e.push(void 0, BG), HG(DG, void 0, e);
}), $G = TG;
const OG = /* @__PURE__ */ Vx($G), RG = {
  composer: {
    props: {
      lucide: {
        default: "Loader2",
        control: "input"
      },
      lucideSize: {
        default: 24,
        control: "input"
      },
      lucideColor: {
        default: "currentColor",
        control: "input"
      },
      lucideStrokeWidth: {
        default: 2.5,
        control: "input"
      },
      center: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "",
      propsStateBased: {
        center: {
          true: "flex flex-center w-full"
        }
      }
    }
  }
}, tw = {
  __name: "Progress",
  props: {
    lucide: {
      type: String,
      default: "Loader2"
    },
    lucideSize: {
      type: Number,
      default: 24
    },
    lucideColor: {
      type: String,
      default: "currentColor"
    },
    lucideStrokeWidth: {
      type: Number,
      default: 2.5
    },
    center: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: RG });
    return (o, r) => (d(), h("div", j(re(s(t).root)), [
      Le($e, H(a, { spin: "" }), null, 16)
    ], 16));
  }
}, FG = {
  key: 0,
  class: ""
}, EG = {
  key: 1,
  class: "w-full text-center"
}, UG = { class: "" }, NG = {
  __name: "ProductItemList",
  props: {
    items: {
      type: Array,
      required: !0
    },
    productItem: {
      type: Object
    },
    layout: {
      type: String,
      default: "grid"
      // grid, masonry, list
    },
    noItemsLabel: {
      type: String,
      default: "no items"
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: "productItemClick",
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, defaults: xG });
    function l(c) {
      return Ux({}, c, t.productItem, r.value.productItem);
    }
    function i(c) {
      o("productItemClick", c);
    }
    return (c, u) => (d(), h("div", j(re(s(r).root)), [
      e.loading ? (d(), h("div", FG, [
        Le(tw, { center: "" })
      ])) : y("", !0),
      !e.loading && e.items.length === 0 ? (d(), h("div", EG, [
        P("span", UG, N(e.noItemsLabel), 1)
      ])) : y("", !0),
      e.items.length > 0 ? (d(), h("div", j(H({ key: 2 }, s(r).wrap)), [
        (d(!0), h(ve, null, Ie(e.items, (v) => (d(), K(CG, H({
          key: v.id,
          ref_for: !0
        }, l(v), {
          onClick: (k) => i(v)
        }), null, 16, ["onClick"]))), 128))
      ], 16)) : y("", !0)
    ], 16));
  }
}, WG = {
  composer: {
    props: {
      table: {
        control: "input",
        default: {
          head: [
            [
              { checkbox: !0 },
              { c: "id", align: "left" },
              { c: "status" },
              { c: "name" },
              { c: "age" },
              { c: "email" },
              { c: "phone" },
              { c: "street" },
              { c: "city" },
              { c: "country" },
              { c: "postal" },
              { c: "created" },
              { c: "updated" }
            ]
          ],
          body: [
            [
              { checkbox: !0, id: "a" },
              { c: "1" },
              { c: "success" },
              { c: "John Doe" },
              { c: "25" },
              { c: "johndoe@outlook.com" },
              { c: "1234567890" },
              { c: "123 Main St" },
              { c: "New York" },
              { c: "USA" },
              { c: "12345" },
              { c: "2022-01-01" },
              { c: "2022-01-01" }
            ],
            [
              { checkbox: !0, id: "b" },
              { c: "2" },
              { c: "success" },
              { c: "Jane Doe" },
              { c: "23" },
              { c: "janedoe@gmail.com" },
              { c: "1234567890" },
              { c: "456 Elm St" },
              { c: "Los Angeles" },
              { c: "USA" },
              { c: "67890" },
              { c: "2022-02-02" },
              { c: "2022-02-02" }
            ],
            [
              { checkbox: !0, id: "c" },
              { c: "3" },
              { c: "success" },
              { c: "Joe Doe" },
              { c: "30" },
              { c: "joedoe@yahoo.com" },
              { c: "1234567890" },
              { c: "789 Oak St" },
              { c: "Chicago" },
              { c: "USA" },
              { c: "54321" },
              { c: "2022-03-03" },
              { c: "2022-03-03" }
            ],
            [
              { checkbox: !0, id: "d" },
              { c: "4" },
              { c: "success" },
              { c: "Jill Doe" },
              { c: "28" },
              { c: "jilldoe@hotmail.com" },
              { c: "1234567890" },
              { c: "321 Pine St" },
              { c: "Houston" },
              { c: "USA" },
              { c: "09876" },
              { c: "2022-04-04" },
              { c: "2022-04-04" }
            ],
            [
              { checkbox: !0, id: "e" },
              { c: "5" },
              { c: "success" },
              { c: "Jack Doe" },
              { c: "35" },
              { c: "jackdoe@outlook.com" },
              { c: "1234567890" },
              { c: "654 Maple St" },
              { c: "Miami" },
              { c: "USA" },
              { c: "13579" },
              { c: "2022-05-05" },
              { c: "2022-05-05" }
            ]
          ],
          foot: [
            [
              { checkbox: !0 },
              { c: "5" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" },
              { c: "-" }
            ]
          ]
        }
      },
      columnsSticky: {
        control: "input",
        default: 3
      }
    }
  },
  pt: {
    root: {
      _common: "h-full flex flex-col gap-4",
      propsStateBased: {
        fullWidth: {
          true: "w-full",
          false: "w-auto"
        }
      }
    },
    table: {
      _common: "table-fixed",
      propsStateBased: {
        fullWidth: {
          true: "min-w-full",
          false: ""
        }
      }
    }
  }
}, GG = { class: "hover:xbg-neutral-100 dark:xhover:bg-neutral-950 transition-all duration-200 ease-in-out first:rounded-l-xl last:rounded-r-xl" }, ZG = ["onClick"], YG = { key: 2 }, KG = { key: 3 }, XG = { key: 4 }, QG = { key: 5 }, JG = { key: 6 }, eZ = {
  __name: "TableRow",
  props: {
    table: Object,
    tc: Object,
    row: Array,
    columnsSticky: Number,
    styles: Object,
    checkedRows: Object,
    hoveredRow: Number,
    onClick: Function,
    elTableWrap: Object,
    tbodyTrIndex: Number
  },
  emits: ["click", "checkedRow"],
  setup(e, { emit: a }) {
    const t = a;
    return (o, r) => {
      const l = Fr("RouterLink");
      return d(), h("tr", GG, [
        (d(!0), h(ve, null, Ie(e.row, (i, c) => (d(), h("td", {
          class: be([
            e.tc.body.td,
            { "text-neutral-300 dark:text-neutral-800": i.ignored },
            { "text-neutral-600 dark:text-neutral-300": !i.ignored },
            { "w-0 pr-0": i.warning },
            { "w-0 pr-0": i.checkbox },
            { "font-mono": i.mono },
            { "font-bold": i.bold },
            `text-${e.table.head[0][c].align ? e.table.head[0][c].align : "right"}`,
            { "bg-neutral-50 dark:bg-neutral-900": c < e.columnsSticky }
          ]),
          style: ut(e.styles[c]),
          key: c
        }, [
          P("span", {
            class: be([
              {
                "hover:xunderline cursor-pointer rounded-lg px-2 py-1 transition-all duration-300 ease-in-out hover:bg-neutral-150 dark:hover:bg-neutral-800 dark:hover:text-neutral-50": i.routerLink || i.link
              },
              { "cursor-copy hover:text-neutral-300": i.clickToCopy }
            ]),
            onClick: (u) => t("click", i)
          }, [
            i.routerLink ? (d(), K(l, {
              key: 0,
              class: be({ "whitespace-pre-wrap ": i.wrap }),
              to: i.routerLink,
              replace: i.routerLink.replace || !1
            }, {
              default: fe(() => [
                lt(N(i.c), 1)
              ]),
              _: 2
            }, 1032, ["class", "to", "replace"])) : y("", !0),
            i.checkbox ? (d(), K(AI, {
              key: 1,
              modelValue: e.checkedRows[i.id],
              "onUpdate:modelValue": [(u) => e.checkedRows[i.id] = u, (u) => t("checkedRow", { id: i.id, index: e.tbodyTrIndex, value: u })],
              rounded: "md",
              size: 5
            }, null, 8, ["modelValue", "onUpdate:modelValue"])) : y("", !0),
            i.truncate ? (d(), h("span", YG, N(o.truncateAddress(i.c)), 1)) : i.warning === !0 ? (d(), h("span", KG, "⚠️")) : i.warning === !1 ? (d(), h("span", XG)) : i.c === !1 ? (d(), h("span", QG, "false")) : !i.c && i.c !== 0 && !i.component && !i.checkbox ? (d(), h("span", JG)) : i.routerLink ? y("", !0) : (d(), h("span", {
              key: 7,
              class: be({ "whitespace-pre-wrap": i.wrap })
            }, N(i.c), 3)),
            i.component ? (d(), K(st(i.component), H({
              key: 8,
              ref_for: !0
            }, i.args, nI((i == null ? void 0 : i.listeners) || {})), null, 16)) : y("", !0)
          ], 10, ZG)
        ], 6))), 128))
      ]);
    };
  }
}, tZ = {
  key: 0,
  class: "mb-2 flex flex-row justify-between items-center gap-4"
}, aZ = {
  key: 0,
  class: ""
}, nZ = ["onClick"], oZ = { class: "" }, rZ = { key: 1 }, lZ = ["colspan"], iZ = { key: 2 }, cZ = ["colspan"], dZ = ["colspan"], sZ = { key: 4 }, uZ = { key: 0 }, hZ = {
  key: 1,
  class: ""
}, pZ = {
  key: 1,
  class: "fixed right-0 top-0 z-50 border border-red-500 bg-white dark:bg-neutral-950"
}, Iw = 49, hX = {
  __name: "Table",
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    table: Object,
    loading: {
      type: Boolean,
      default: !1
    },
    router: {
      type: Object
    },
    // stick first N columns to left
    columnsSticky: {
      type: Number,
      default: 0
    },
    // necessary when using columns sticky
    fullWidth: {
      type: Boolean,
      default: !1
    },
    orderByColumnInitial: {
      type: Number,
      default: null
    },
    orderDirectionInitial: {
      type: String,
      default: "asc"
    },
    toolbar: {
      type: Boolean,
      default: !1
    },
    toolbarSearch: {
      type: Boolean,
      default: !1
    },
    debug: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, o = a, r = U(0), l = U(0), i = U(0), c = U(0), u = U([]), v = U(!1), k = U(0), f = U(null), p = U(null), m = U(null), I = U(!1), S = U(null), C = U(null), B = U({}), $ = F(
      () => Object.keys(B.value).filter((D) => B.value[D] === !0)
    ), x = U(null), q = U(!1), _ = U(t.orderByColumnInitial), A = U(t.orderDirectionInitial), z = U(null), J = U({
      head: {
        th: "px-2 py-2 text-xs font-medium text-neutral-500 dark:text-neutral-500 uppercase tracking-wider"
      },
      body: {
        td: "px-2 py-3 whitespace-nowrap text-sm"
      },
      foot: {
        td: "px-2 py-2 font-bold whitespace-nowrap text-sm"
      }
    });
    function ee(D) {
      D.link && window.open(D.link.url, D.link.target || "_blank"), D.clickToCopy && this.copyToClipboard(D.c);
    }
    const { ep: Z } = Pe({ props: t, defaults: WG }), se = new ResizeObserver((D) => {
      for (let ae of D)
        ae.target.tagName === "TABLE" && k.value++;
    }), G = F(() => {
      if (!t.table.body)
        return [];
      if (!z.value)
        return t.table.body;
      const D = z.value.toLowerCase().trim();
      return t.table.body.filter((ae) => ae.some((L) => {
        var b, Y, le;
        const de = L.id || "", Ce = ((b = L.c) == null ? void 0 : b.toString().toLowerCase().trim()) || "", W = ((Y = L.sortString) == null ? void 0 : Y.toString().toLowerCase().trim()) || "", xe = ((le = L.filterString) == null ? void 0 : le.toString().toLowerCase().trim()) || "";
        return de.includes(D) || Ce.includes(D) || W.includes(D) || xe.includes(D);
      }));
    }), ke = F(() => G.value ? iL(
      G.value,
      [
        (ae) => {
          const L = ae[_.value];
          if (!L)
            return null;
          const de = L.hasOwnProperty("sortString") ? L.sortString : L.c, Ce = "￿", W = "\0";
          return de == null || de === "" ? A.value === "asc" ? Ce : W : typeof de == "boolean" ? de === !0 ? Ce : W : !isNaN(de) && de !== "" ? Number(de) : de.toString().toLowerCase().normalize("NFD");
        }
      ],
      [A.value]
    ).map((ae) => ({
      id: ae[0].id,
      rowColumns: ae
      // render: isRowVisible(row),
    })) : []), T = F(() => ke.value ? ke.value.slice(
      i.value,
      i.value + r.value
    ) : []), w = F(() => ke.value ? ke.value.length : 0), E = F(() => t.table.head ? t.table.head[0].length : 0), M = F(() => {
      const D = [];
      for (let ae = 0; ae < i.value; ae++)
        D.push({ id: `filler-${ae}` });
      return D;
    }), ne = F(() => {
      const D = [], ae = w.value - T.value.length - M.value.length;
      for (let L = 0; L < ae; L++)
        D.push({ id: `filler-${L}` });
      return D;
    }), ue = F(() => {
      k.value;
      const D = {};
      if (!f.value || f.value.rows.length === 0)
        return D;
      const ae = f.value.rows;
      if (!(ae != null && ae[0]))
        return D;
      const L = ae[0].cells.length;
      for (let de = 0; de < L; de++)
        if (de < t.columnsSticky) {
          let Ce = 0;
          for (let W = 0; W < de; W++)
            Ce += ae[0].cells[W].offsetWidth;
          D[de] = {
            left: `${Ce}px`,
            position: "sticky",
            width: "1px"
          };
        }
      return D;
    });
    function me() {
      var D;
      if ((D = f.value.tBodies) != null && D[0] && m.value) {
        const ae = f.value.tBodies[0].rows[x.value];
        if (ae) {
          const L = ae.getBoundingClientRect();
          m.value.style.top = `${L.top + window.scrollY - 1}px`, m.value.style.height = `${L.height + 2}px`, m.value.style.width = `${p.value.offsetWidth + 4}px`, m.value.style.left = `${p.value.offsetLeft + window.scrollX - 2}px`;
        }
      }
    }
    function Se({ columnIndex: D }) {
      _.value === D ? A.value = A.value === "asc" ? "desc" : "asc" : (_.value = D, A.value = "asc");
    }
    function V() {
      const D = p.value.scrollTop;
      i.value = Math.floor(D / Iw), c.value = i.value + r.value;
    }
    const Q = V;
    function g({ id: D, index: ae, value: L }) {
      if (v.value) {
        const de = Math.min(C.value, ae), Ce = Math.max(C.value, ae);
        for (let W = de; W <= Ce; W++) {
          const xe = ke.value[W].id;
          B.value[xe] = L;
        }
      } else
        B.value[D] = L;
      S.value = D, C.value = ae;
    }
    return We(I, (D) => {
      D ? (B.value = {}, ke.value.forEach((ae, L) => {
        ae.rowColumns.forEach((de) => {
          de.checkbox && (B.value[de.id] = !0);
        });
      })) : B.value = {};
    }), We($, (D) => {
      o("update:modelValue", D);
    }), We(
      t.modelValue,
      (D) => {
        Object.entries(t.modelValue).forEach(([ae, L]) => {
          B.value[L] = !0;
        });
      },
      { immediate: !0 }
    ), We(x, (D) => {
      me();
    }), Qe(async () => {
      await Mt(), f.value && se.observe(f.value), p.value.addEventListener("scroll", Q), r.value = Math.ceil(window.innerHeight / Iw), c.value = i.value + r.value, l.value = r.value;
    }), er(() => {
      f.value && se.unobserve(f.value), p.value && p.value.removeEventListener("scroll", Q);
    }), zI("Shift", (D) => {
      v.value = D === "down";
    }), (D, ae) => {
      var L, de, Ce, W;
      return d(), h("div", j(re(s(Z).root)), [
        e.toolbar ? (d(), h("div", tZ, [
          te(D.$slots, "toolbarStart"),
          e.toolbarSearch ? (d(), K(Qo, {
            key: 0,
            modelValue: z.value,
            "onUpdate:modelValue": ae[0] || (ae[0] = (xe) => z.value = xe),
            focusOnSlashKey: "",
            prefixTransparent: ""
          }, {
            prefix: fe(() => [
              Le($e, {
                class: "size-5 text-neutral-300",
                lucide: "Search",
                lucideStrokeWidth: 3
              })
            ]),
            _: 1
          }, 8, ["modelValue"])) : y("", !0),
          te(D.$slots, "toolbarEnd")
        ])) : y("", !0),
        Ot(P("div", {
          ref_key: "elFocusBox",
          ref: m,
          class: "pointer-events-none absolute z-10 rounded-lg border-2 border-neutral-300 dark:border-neutral-700"
        }, null, 512), [
          [Rt, q.value]
        ]),
        P("div", {
          ref_key: "elTableWrap",
          ref: p,
          class: "h-full min-h-0 overflow-x-auto overflow-y-auto"
        }, [
          e.table ? (d(), h("table", H({
            key: 0,
            ref_key: "elTable",
            ref: f
          }, s(Z).table), [
            e.table.head ? (d(), h("thead", aZ, [
              (d(!0), h(ve, null, Ie(e.table.head, (xe, b) => (d(), h("tr", { key: b }, [
                (d(!0), h(ve, null, Ie(xe, (Y, le) => (d(), h("th", {
                  class: be(["sticky top-0 z-10 bg-neutral-100 align-bottom last:rounded-r-xl dark:bg-neutral-900", [
                    J.value.head.th,
                    `text-${Y.align ? Y.align : "right"}`,
                    { "first:rounded-l-xl": e.columnsSticky === 0 },
                    { "first:rounded-tl-xl": e.columnsSticky > 0 }
                  ]]),
                  style: ut(ue.value[le]),
                  key: le
                }, [
                  Y.checkbox ? (d(), K(AI, {
                    key: 0,
                    modelValue: I.value,
                    "onUpdate:modelValue": ae[1] || (ae[1] = (ie) => I.value = ie),
                    rounded: "md",
                    size: 5
                  }, null, 8, ["modelValue"])) : y("", !0),
                  Y.checkbox ? y("", !0) : (d(), h("span", {
                    key: 1,
                    class: be(["inline-flex select-none flex-row items-center gap-1 whitespace-nowrap rounded-lg px-2 py-1 font-semibold transition-all duration-300 ease-in-out hover:cursor-pointer hover:bg-neutral-200 dark:hover:bg-neutral-700", [
                      {
                        "bg-neutral-200 dark:bg-neutral-900 dark:outline dark:outline-neutral-700": _.value === le
                      }
                    ]]),
                    onClick: (ie) => Se({ columnIndex: le })
                  }, [
                    _.value === le && A.value == "asc" ? (d(), K($e, {
                      key: 0,
                      lucide: "ArrowUp",
                      lucideStrokeWidth: 3,
                      class: "inline-block h-3 w-3"
                    })) : y("", !0),
                    _.value === le && A.value == "desc" ? (d(), K($e, {
                      key: 1,
                      lucide: "ArrowDown",
                      lucideStrokeWidth: 3,
                      class: "inline-block h-3 w-3"
                    })) : y("", !0),
                    P("span", oZ, N(Y.c), 1)
                  ], 10, nZ))
                ], 6))), 128))
              ]))), 128))
            ])) : y("", !0),
            e.loading && ((L = e.table.head) != null && L[0]) ? (d(), h("tbody", rZ, [
              P("tr", null, [
                P("td", {
                  colspan: e.table.head[0].length,
                  class: "p-6"
                }, [
                  Le(tw, {
                    class: "text-neutral-500",
                    center: ""
                  })
                ], 8, lZ)
              ])
            ])) : y("", !0),
            !e.loading && ke.value.length === 0 && ((de = e.table.head) != null && de[0]) ? (d(), h("tbody", iZ, [
              P("tr", null, [
                P("td", {
                  colspan: e.table.head[0].length,
                  class: "p-6 text-center"
                }, "nothing here 😔", 8, cZ)
              ])
            ])) : y("", !0),
            !e.loading && T.value.length > 0 ? (d(), h("tbody", {
              key: 3,
              class: "divide-sand divide-y dark:divide-neutral-800",
              onMouseenter: ae[2] || (ae[2] = (xe) => q.value = !0),
              onMouseleave: ae[3] || (ae[3] = (xe) => q.value = !1)
            }, [
              (d(!0), h(ve, null, Ie(ke.value, (xe, b) => (d(), h(ve, {
                key: xe.id
              }, [
                b >= i.value - l.value && b < c.value + l.value ? (d(), K(eZ, {
                  key: 0,
                  table: e.table,
                  tc: J.value,
                  row: xe.rowColumns,
                  columnsSticky: e.columnsSticky,
                  styles: ue.value,
                  checkedRows: B.value,
                  hoveredRow: x.value,
                  render: !0,
                  elTableWrap: p.value,
                  tbodyTrIndex: b,
                  onClick: ee,
                  onCheckedRow: g,
                  onMouseover: (Y) => x.value = b
                }, null, 8, ["table", "tc", "row", "columnsSticky", "styles", "checkedRows", "hoveredRow", "elTableWrap", "tbodyTrIndex", "onMouseover"])) : (d(), h("tr", {
                  key: 1,
                  style: ut({ height: `${Iw}px` })
                }, [
                  P("td", {
                    colspan: E.value.value
                  }, null, 8, dZ)
                ], 4))
              ], 64))), 128))
            ], 32)) : y("", !0),
            !e.loading && e.table.foot ? (d(), h("tfoot", sZ, [
              (d(!0), h(ve, null, Ie(e.table.foot, (xe, b) => (d(), h("tr", { key: b }, [
                (d(!0), h(ve, null, Ie(xe, (Y, le) => (d(), h("td", {
                  class: be(["bg-white dark:bg-neutral-800", [
                    J.value.foot.td,
                    { "text-left": e.table.head[0][le].align === "left" },
                    { "text-center": e.table.head[0][le].align === "center" },
                    { "text-right": e.table.head[0][le].align === "right" },
                    { "text-right": !e.table.head[0][le].align && !Y.checkbox },
                    { "text-center": Y.checkbox }
                  ]]),
                  style: ut(ue.value[le]),
                  key: le
                }, [
                  Y.checkbox ? (d(), h("span", uZ, N($.value.length), 1)) : y("", !0),
                  Y.checkbox ? y("", !0) : (d(), h("span", hZ, N(Y.c), 1))
                ], 6))), 128))
              ]))), 128))
            ])) : y("", !0)
          ], 16)) : y("", !0)
        ], 512),
        e.debug ? (d(), h("div", pZ, [
          P("pre", null, N({
            startIndex: i.value,
            endIndex: c.value,
            rowsRendered: r.value,
            rowsBuffered: l.value,
            orderByColumn: _.value,
            orderDirection: A.value,
            tableVisibleRows: u.value,
            tableBodyFilteredSortedRendered: (W = (Ce = T.value[0]) == null ? void 0 : Ce[0]) == null ? void 0 : W.id,
            tableBodyFilteredSortedFillerRowsBefore: M.value.length,
            tableBodyFilteredSortedFillerRowsAfter: ne.value.length,
            tableBodyFilteredSortedTotalRows: w.value,
            tableTotalColumns: E.value,
            modelValue: e.modelValue,
            checkedRows: B.value
          }), 1)
        ])) : y("", !0)
      ], 16);
    };
  }
}, yZ = {
  composer: {
    props: {
      table: {
        control: "input",
        default: [
          {
            key: { c: "id", align: "right" },
            value: { c: "1", align: "left" }
          },
          {
            key: { c: "status" },
            value: { c: "success" }
          },
          {
            key: { c: "name" },
            value: { c: "John Doe" }
          },
          {
            key: { c: "age" },
            value: { c: "25" }
          },
          {
            key: { c: "email" },
            value: { c: "johndoe@outlook.com" }
          },
          {
            key: { c: "phone" },
            value: { c: "1234567890" }
          },
          {
            key: { c: "street" },
            value: { c: "123 Main St" }
          },
          {
            key: { c: "city" },
            value: { c: "New York" }
          },
          {
            key: { c: "country" },
            value: { c: "USA" }
          },
          {
            key: { c: "postal" },
            value: { c: "12345" }
          },
          {
            key: { c: "created" },
            value: { c: "2022-01-01" }
          },
          {
            key: { c: "updated" },
            value: { c: "2022-01-01" }
          }
        ]
      }
    }
  },
  pt: {
    root: {
      _common: "h-full flex flex-col gap-4",
      propsStateBased: {
        fullWidth: {
          true: "w-full",
          false: "w-auto"
        }
      }
    },
    table: {
      _common: "table-fixed",
      propsStateBased: {
        fullWidth: {
          true: "min-w-full",
          false: ""
        }
      }
    }
  }
}, kZ = { class: "hover:xbg-neutral-100 dark:xhover:bg-neutral-950 transition-all duration-200 ease-in-out first:rounded-l-xl last:rounded-r-xl" }, mZ = ["onClick"], fZ = { key: 1 }, vZ = { key: 2 }, gZ = { key: 3 }, MZ = { key: 4 }, bZ = { key: 5 }, xZ = {
  __name: "TableKeyValueRow",
  props: {
    table: Object,
    tc: Object,
    row: Array,
    onClick: Function,
    elTableWrap: Object,
    tbodyTrIndex: Number
  },
  emits: ["click", "checkedRow"],
  setup(e, { emit: a }) {
    const t = a;
    return (o, r) => {
      const l = Fr("RouterLink");
      return d(), h("tr", kZ, [
        (d(!0), h(ve, null, Ie(e.row, (i, c) => (d(), h("td", {
          class: be([
            e.tc.body.td,
            { "text-neutral-400 dark:text-neutral-500": c === "key" },
            { "text-neutral-600 dark:text-neutral-300": c === "value" },
            { "w-0 pr-0": i.warning },
            { "w-0 pr-0": i.checkbox },
            { "font-mono": i.mono },
            { "font-bold": i.bold },
            `text-${e.table[0][c].align ? e.table[0][c].align : "left"}`
          ]),
          key: c
        }, [
          P("span", {
            class: be([
              {
                "hover:xunderline cursor-pointer rounded-lg px-2 py-1 transition-all duration-300 ease-in-out hover:bg-neutral-150 dark:hover:bg-neutral-800 dark:hover:text-neutral-50": i.routerLink || i.link
              },
              { "cursor-copy hover:text-neutral-300": i.clickToCopy }
            ]),
            onClick: (u) => t("click", i)
          }, [
            i.routerLink ? (d(), K(l, {
              key: 0,
              class: be({ "whitespace-pre-wrap ": i.wrap }),
              to: i.routerLink,
              replace: i.routerLink.replace || !1
            }, {
              default: fe(() => [
                lt(N(i.c), 1)
              ]),
              _: 2
            }, 1032, ["class", "to", "replace"])) : y("", !0),
            i.truncate ? (d(), h("span", fZ, N(o.truncateAddress(i.c)), 1)) : i.warning === !0 ? (d(), h("span", vZ, "⚠️")) : i.warning === !1 ? (d(), h("span", gZ)) : i.c === !1 ? (d(), h("span", MZ, "false")) : !i.c && i.c !== 0 && !i.component && !i.checkbox ? (d(), h("span", bZ)) : i.routerLink ? y("", !0) : (d(), h("span", {
              key: 6,
              class: be({ "whitespace-pre-wrap": i.wrap })
            }, N(i.c), 3)),
            i.component ? (d(), K(st(i.component), H({
              key: 7,
              ref_for: !0
            }, i.args, nI(i.listeners)), null, 16)) : y("", !0)
          ], 10, mZ)
        ], 2))), 128))
      ]);
    };
  }
}, wZ = {
  key: 0,
  class: "mb-4"
}, LZ = {
  ref: "elFocusBox",
  class: "pointer-events-none absolute z-10 rounded-lg border-2 border-neutral-300 dark:border-neutral-700"
}, SZ = { key: 0 }, IZ = ["colspan"], CZ = { key: 1 }, AZ = ["colspan"], qZ = {
  key: 2,
  class: "divide-sand divide-y dark:divide-neutral-800"
}, zZ = {
  key: 1,
  class: "fixed right-0 top-0 z-50 border border-red-500 bg-white dark:bg-neutral-950 dark:text-white"
}, pX = {
  __name: "TableKeyValue",
  props: {
    table: Object,
    loading: {
      type: Boolean,
      default: !1
    },
    router: {
      type: Object
    },
    // necessary when using columns sticky
    fullWidth: {
      type: Boolean,
      default: !1
    },
    debug: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, t = U(null), o = U(null), r = U({
      head: {
        th: "px-2 py-2 text-xs font-medium text-neutral-500 dark:text-neutral-500 uppercase tracking-wider"
      },
      body: {
        td: "px-2 py-3 whitespace-nowrap text-sm"
      },
      foot: {
        td: "px-2 py-2 font-bold whitespace-nowrap text-sm"
      }
    });
    function l(c) {
      c.link && window.open(c.link.url, c.link.target || "_blank"), c.clickToCopy && this.copyToClipboard(c.c);
    }
    const { ep: i } = Pe({ props: a, defaults: yZ });
    return (c, u) => {
      var v, k;
      return d(), h("div", j(re(s(i).root)), [
        c.toolbar ? (d(), h("div", wZ, [
          c.toolbarSearch ? (d(), K(Qo, {
            key: 0,
            modelValue: c.search,
            "onUpdate:modelValue": u[0] || (u[0] = (f) => c.search = f),
            focusOnSlashKey: "",
            prefixTransparent: ""
          }, {
            prefix: fe(() => [
              Le($e, {
                class: "size-5 text-neutral-300",
                lucide: "Search",
                lucideStrokeWidth: 3
              })
            ]),
            _: 1
          }, 8, ["modelValue"])) : y("", !0)
        ])) : y("", !0),
        Ot(P("div", LZ, null, 512), [
          [Rt, c.showFocusBox]
        ]),
        P("div", {
          ref_key: "elTableWrap",
          ref: o,
          class: "h-full min-h-0 overflow-x-auto overflow-y-auto"
        }, [
          e.table ? (d(), h("table", H({
            key: 0,
            ref_key: "elTable",
            ref: t
          }, s(i).table), [
            e.loading && ((v = e.table.head) != null && v[0]) ? (d(), h("tbody", SZ, [
              P("tr", null, [
                P("td", {
                  colspan: e.table.length,
                  class: "p-6"
                }, [
                  Le(tw, {
                    class: "text-neutral-500",
                    center: ""
                  })
                ], 8, IZ)
              ])
            ])) : y("", !0),
            !e.loading && e.table.length === 0 && ((k = e.table.head) != null && k[0]) ? (d(), h("tbody", CZ, [
              P("tr", null, [
                P("td", {
                  colspan: e.table.length,
                  class: "p-6 text-center"
                }, "nothing here 😔", 8, AZ)
              ])
            ])) : y("", !0),
            !e.loading && e.table.length > 0 ? (d(), h("tbody", qZ, [
              (d(!0), h(ve, null, Ie(e.table, (f, p) => (d(), K(xZ, {
                key: f.id,
                table: e.table,
                tc: r.value,
                row: f,
                tbodyTrIndex: p,
                onClick: l,
                onCheckedRow: c.onCheckedRow,
                onMouseover: (m) => c.hoveredRow = p
              }, null, 8, ["table", "tc", "row", "tbodyTrIndex", "onCheckedRow", "onMouseover"]))), 128))
            ])) : y("", !0)
          ], 16)) : y("", !0)
        ], 512),
        e.debug ? (d(), h("div", zZ, [
          P("pre", null, N({
            startIndex: c.startIndex,
            endIndex: c.endIndex,
            rowsRendered: c.rowsRendered,
            rowsBuffered: c.rowsBuffered,
            orderByColumn: c.orderByColumn,
            orderDirection: c.orderDirection,
            table: e.table,
            tableTotalColumns: c.tableTotalColumns,
            modelValue: c.modelValue,
            checkedRows: c.checkedRows
          }), 1)
        ])) : y("", !0)
      ], 16);
    };
  }
}, PZ = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "@container m-auto max-w-7xl px-2 sm:px-4 2xl:px-0",
      propsStateBased: {
        debug: {
          true: "border border-red-500"
        }
      }
    }
  }
}, _Z = { class: "w-full" }, ia = /* @__PURE__ */ Object.assign({
  inheritAttrs: !1
}, {
  __name: "LayoutContainer",
  props: {},
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: PZ });
    return (o, r) => (d(), h("div", _Z, [
      P("div", j(re(s(t).root)), [
        te(o.$slots, "default")
      ], 16)
    ]));
  }
}), jZ = {
  composer: {
    props: {
      logo: {
        src: {
          default: "https://storage.googleapis.com/platformaone-sites-files-commerce-original-production/logos/19e952c9-0e16-4a2c-b2e7-55a63c9d80b1",
          control: "input"
        }
      },
      line1: {
        default: "text line 1",
        control: "input"
      },
      line2: {
        default: "text line 2",
        control: "input"
      },
      phone: {
        default: "+420 777 321 431",
        control: "input"
      },
      email: {
        default: "lala@example.com",
        control: "input"
      },
      contactsAsIcons: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      },
      facebook: {
        default: "platformaone",
        control: "input"
      },
      instagram: {
        default: "platformaone",
        control: "input"
      },
      socialsAsIcons: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      },
      align: {
        default: "start",
        options: ["start", "center", "end"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full",
      propsStateBased: {}
    },
    wrap: {
      _common: "w-full flex flex-col",
      propsStateBased: {
        align: {
          start: "items-start",
          center: "items-center",
          end: "items-end"
        }
      }
    },
    logo: {
      _common: "",
      propsStateBased: {},
      props: {
        classImg: "w-auto h-5 mb-4"
      }
    },
    contactsAndSocials: {
      _common: "mt-4 flex gap-4",
      propsStateBased: {
        contactsAsIcons: {
          true: {
            socialsAsIcons: {
              true: "flex-row",
              false: "flex-col"
            }
          },
          false: "flex-col"
        }
      }
    },
    contacts: {
      _common: "flex",
      propsStateBased: {
        contactsAsIcons: {
          true: "flex-row gap-4",
          false: "flex-col gap-0"
        },
        align: {
          start: "items-start",
          center: "items-center",
          end: "items-end"
        }
      }
    },
    socials: {
      _common: "flex flex-row",
      propsStateBased: {
        socialsAsIcons: {
          true: "flex-row gap-4",
          false: "flex-col gap-0"
        },
        align: {
          start: "items-start",
          center: "items-center",
          end: "items-end"
        }
      }
    }
  }
}, HZ = {
  composer: {
    props: {
      text: {
        default: "You will receive printable A4 size PDF immediately after payment to e-mail address used during checkout.",
        control: "input"
      },
      as: {
        default: "div",
        control: "select",
        options: ["div", "span", "p", "h1", "h2", "h3", "h4", "h5", "h6"]
      }
    }
  },
  pt: {
    root: {
      _common: "whitespace-pre-wrap",
      propsStateBased: {}
    }
  }
}, Jo = {
  __name: "Text",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    text: {
      type: String,
      default: ""
    },
    as: {
      type: String,
      default: "div",
      validator: (e) => ["div", "span", "p", "h1", "h2", "h3", "h4", "h5", "h6"].includes(e)
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, locals: {}, defaults: HZ });
    return (o, r) => (d(), K(st(e.as), j(re(s(t).root)), {
      default: fe(() => [
        te(o.$slots, "default", {}, () => [
          lt(N(e.text), 1)
        ])
      ]),
      _: 3
    }, 16));
  }
}, VZ = ["href"], BZ = {
  key: 1,
  class: ""
}, DZ = ["href"], TZ = {
  key: 1,
  class: ""
}, $Z = ["href"], OZ = {
  key: 1,
  class: ""
}, RZ = ["href"], FZ = {
  key: 1,
  class: ""
}, yX = {
  __name: "SectionFooter",
  props: {
    logo: {
      type: [Boolean, String],
      default: !1
    },
    line1: {
      type: [Boolean, String],
      default: !1
    },
    line2: {
      type: [Boolean, String],
      default: !1
    },
    phone: {
      type: [Boolean, String],
      default: !1
    },
    email: {
      type: [Boolean, String],
      default: !1
    },
    contactsAsIcons: {
      type: Boolean,
      default: !1
    },
    facebook: {
      type: [Boolean, String],
      default: !1
    },
    instagram: {
      type: [Boolean, String],
      default: !1
    },
    socialsAsIcons: {
      type: Boolean,
      default: !1
    },
    align: {
      type: String,
      default: "start",
      validator: (e) => ["start", "center", "end"].includes(e)
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: jZ });
    return (o, r) => (d(), h("div", j(re(s(t).root)), [
      Le(ia, null, {
        default: fe(() => [
          P("div", j(re(s(t).wrap)), [
            P("div", null, [
              e.logo ? (d(), K(or, j(H({ key: 0 }, { ...e.logo, ...s(t).logo })), null, 16)) : y("", !0)
            ]),
            e.line1 ? (d(), K(Jo, {
              key: 0,
              text: e.line1
            }, null, 8, ["text"])) : y("", !0),
            e.line2 ? (d(), K(Jo, {
              key: 1,
              text: e.line2
            }, null, 8, ["text"])) : y("", !0),
            P("div", j(re(s(t).contactsAndSocials)), [
              P("div", j(re(s(t).contacts)), [
                P("a", {
                  href: `mailto:${e.email}`,
                  target: "_blank"
                }, [
                  e.contactsAsIcons ? (d(), K($e, {
                    key: 0,
                    lucide: "AtSign"
                  })) : y("", !0),
                  e.contactsAsIcons ? y("", !0) : (d(), h("span", BZ, N(e.email), 1))
                ], 8, VZ),
                P("a", {
                  href: `tel:${e.phone}`,
                  target: "_blank"
                }, [
                  e.contactsAsIcons ? (d(), K($e, {
                    key: 0,
                    lucide: "Phone"
                  })) : y("", !0),
                  e.contactsAsIcons ? y("", !0) : (d(), h("span", TZ, N(e.phone), 1))
                ], 8, DZ)
              ], 16),
              P("div", j(re(s(t).socials)), [
                P("a", {
                  href: `https://facebook.com/${e.facebook}`,
                  target: "_blank"
                }, [
                  e.socialsAsIcons ? (d(), K($e, {
                    key: 0,
                    lucide: "Facebook"
                  })) : y("", !0),
                  e.socialsAsIcons ? y("", !0) : (d(), h("span", OZ, "facebook"))
                ], 8, $Z),
                P("a", {
                  href: `https://instagram.com/${e.instagram}`,
                  target: "_blank"
                }, [
                  e.socialsAsIcons ? (d(), K($e, {
                    key: 0,
                    lucide: "Instagram"
                  })) : y("", !0),
                  e.socialsAsIcons ? y("", !0) : (d(), h("span", FZ, "instagram"))
                ], 8, RZ)
              ], 16)
            ], 16)
          ], 16)
        ]),
        _: 1
      })
    ], 16));
  }
}, EZ = {
  composer: {
    props: {
      items: {
        default: [
          {
            src: "https://picsum.photos/800/800?random=1"
          },
          {
            src: "https://picsum.photos/800/600?random=2"
          },
          {
            src: "https://picsum.photos/800/800?random=3"
          },
          {
            src: "https://picsum.photos/1200/800?random=4"
          },
          {
            src: "https://picsum.photos/800/400?random=5"
          },
          {
            src: "https://picsum.photos/800/400?random=6"
          },
          {
            src: "https://picsum.photos/800/1200?random=7"
          },
          {
            src: "https://picsum.photos/800/500?random=8"
          },
          {
            src: "https://picsum.photos/500/800?random=9"
          }
        ],
        control: "input"
      },
      Image: {
        aspect: {
          default: "square",
          options: [
            "auto",
            "square",
            "1/1",
            "landscape",
            "16/9",
            "4/3",
            "3/2",
            "2/1",
            "portrait",
            "9/16",
            "3/4",
            "2/3",
            "1/2"
          ],
          control: "select"
        },
        fit: {
          default: "cover",
          options: ["none", "cover", "contain"],
          control: "select"
        }
      },
      layout: {
        default: "masonry",
        options: ["grid", "masonry", "list"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full",
      propsStateBased: {}
    }
  }
}, UZ = {
  composer: {
    // compositions: [{id: "default", name: "default"}],
    props: {
      items: {
        default: [
          {
            src: "https://picsum.photos/800/800?random=1"
          },
          {
            src: "https://picsum.photos/800/600?random=2"
          },
          {
            src: "https://picsum.photos/800/800?random=3"
          },
          {
            src: "https://picsum.photos/1200/800?random=4"
          },
          {
            src: "https://picsum.photos/800/400?random=5"
          },
          {
            src: "https://picsum.photos/800/400?random=6"
          },
          {
            src: "https://picsum.photos/800/1200?random=7"
          },
          {
            src: "https://picsum.photos/800/500?random=8"
          },
          {
            src: "https://picsum.photos/500/800?random=9"
          }
        ],
        control: "input"
      },
      Image: {
        aspect: {
          default: "square",
          options: [
            "auto",
            "square",
            "1/1",
            "landscape",
            "16/9",
            "4/3",
            "3/2",
            "2/1",
            "portrait",
            "9/16",
            "3/4",
            "2/3",
            "1/2"
          ],
          control: "select"
        },
        fit: {
          default: "cover",
          options: ["none", "cover", "contain"],
          control: "select"
        }
      },
      layout: {
        default: "grid",
        options: ["grid", "masonry", "list"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "@container w-full",
      propsStateBased: {}
    },
    wrap: {
      _common: "",
      propsStateBased: {
        layout: {
          grid: "grid grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 gap-2 @sm:gap-4",
          masonry: "columns-2 @2xl:columns-3 space-y-2 gap-x-2 @md:space-y-4 @md:gap-x-4",
          list: "flex flex-col gap-4 items-center"
        }
      }
    },
    productItem: {
      propsStateBased: {
        layout: {
          grid: "",
          masonry: "",
          list: { layout: "horizontal" }
        }
      }
    }
  }
}, NZ = {
  key: 0,
  class: ""
}, WZ = {
  key: 1,
  class: "w-full text-center"
}, GZ = { class: "" }, ZZ = {
  __name: "ImageList",
  props: {
    items: {
      type: Array,
      required: !0
    },
    Image: {
      type: Object
    },
    layout: {
      type: String,
      default: "grid"
      // grid, masonry, list
    },
    noItemsLabel: {
      type: String,
      default: "no items"
    },
    loading: {
      type: Boolean,
      default: !1
    }
  },
  emits: "ImageClick",
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, defaults: UZ });
    function l(c) {
      return Ux({}, c, t.Image, r.value.Image);
    }
    function i(c) {
      o("ImageClick", c);
    }
    return (c, u) => (d(), h("div", j(re(s(r).root)), [
      e.loading ? (d(), h("div", NZ, [
        Le(tw, { center: "" })
      ])) : y("", !0),
      !e.loading && e.items.length === 0 ? (d(), h("div", WZ, [
        P("span", GZ, N(e.noItemsLabel), 1)
      ])) : y("", !0),
      e.items.length > 0 ? (d(), h("div", j(H({ key: 2 }, s(r).wrap)), [
        (d(!0), h(ve, null, Ie(e.items, (v) => (d(), K(or, H({
          key: v.id,
          ref_for: !0
        }, l(v), {
          onClick: (k) => i(v)
        }), null, 16, ["onClick"]))), 128))
      ], 16)) : y("", !0)
    ], 16));
  }
}, kX = {
  __name: "SectionGallery",
  props: {
    items: {
      type: Array
    },
    Image: {
      type: Object
    },
    layout: {
      type: String,
      default: "grid"
      // grid, masonry, list
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: EZ });
    return (o, r) => (d(), h("div", j(re(s(t).root)), [
      Le(ia, null, {
        default: fe(() => [
          Le(ZZ, j(re(a)), null, 16)
        ]),
        _: 1
      })
    ], 16));
  }
}, YZ = {
  composer: {
    props: {
      logo: {
        src: {
          default: "https://storage.googleapis.com/platformaone-sites-files-commerce-original-production/logos/19e952c9-0e16-4a2c-b2e7-55a63c9d80b1",
          control: "input"
        }
      },
      logoAlign: {
        default: "center",
        options: ["start", "center", "end"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full",
      propsStateBased: {}
    },
    wrap: {
      _common: "w-full flex flex-row",
      propsStateBased: {
        logoAlign: {
          start: "justify-start",
          center: "justify-center",
          end: "justify-end"
        }
      }
    },
    logo: {
      _common: "py-6",
      propsStateBased: {},
      props: {
        classImg: "w-52 h-auto"
      }
    }
  }
}, mX = {
  __name: "SectionHeader",
  props: {
    logo: {
      type: [Boolean, String],
      default: !1
    },
    logoAlign: {
      type: String,
      default: "start",
      validator: (e) => ["start", "center", "end"].includes(e)
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: YZ });
    return (o, r) => (d(), h("div", j(re(s(t).root)), [
      Le(ia, null, {
        default: fe(() => [
          P("div", j(re(s(t).wrap)), [
            e.logo ? (d(), K(or, j(H({ key: 0 }, { ...e.logo, ...s(t).logo })), null, 16)) : y("", !0)
          ], 16)
        ]),
        _: 1
      })
    ], 16));
  }
}, KZ = {
  composer: {
    compositions: [
      { id: "default", name: "default" },
      { id: "no-image", name: "no image" },
      { id: "headline-only", name: "headline only" },
      { id: "text-only", name: "text only" },
      { id: "image-end", name: "image end" }
    ],
    props: {
      headline: {
        default: "Headline",
        control: "input"
      },
      text: {
        default: "I'm baby blue bottle biodiesel raclette, affogato fixie banjo fit organic godard gastropub. DIY hammock humblebrag same pour-over, locavore coloring book small batch. Adaptogen affogato PBR&B, man bun hot chicken bespoke farm-to-table neutral milk hotel vinyl lo-fi migas +1 cornhole. Wolf banh mi pinterest snackwave lomo brunch. Sartorial cray DIY, grailed banjo succulents biodiesel kinfolk edison bulb selfies pickled literally godard snackwave food truck. Bushwick mlkshk sus, food truck knausgaard sustainable blackbird spyplane.",
        control: "input"
      },
      image: {
        src: {
          default: "https://source.unsplash.com/random/1920x1080",
          control: "input"
        },
        aspect: {
          default: "square",
          options: ["auto", "square", "16/9", "4/3", "3/2", "2/1", "1/1", "portrait", "landscape"],
          control: "select"
        },
        fit: {
          default: "cover",
          options: ["none", "cover", "contain"],
          control: "select"
        }
      },
      cta: {
        label: {
          default: "CTA",
          control: "input"
        }
      },
      imagePositionHorizontal: {
        default: "start",
        options: ["start", "end"],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full py-8",
      propsStateBased: {}
    },
    wrap: {
      _common: "flex gap-8 flex-col items-start justify-start",
      propsStateBased: {
        imagePositionHorizontal: {
          start: "@md:flex-row",
          end: "@md:flex-row-reverse"
        }
      }
    },
    headline: {
      _common: "text-4xl font-bold font-heading",
      propsStateBased: {}
    },
    text: {
      _common: "mt-2 text-lg font-body",
      propsStateBased: {}
    },
    cta: {
      _common: "mt-6",
      propsStateBased: {}
    },
    Image: {
      _common: "@md:w-1/2 shrink-0",
      propsStateBased: {}
    },
    content: {
      _common: "",
      propsStateBased: {}
    }
  }
}, fX = {
  __name: "SectionHeadlineTextImageCTA",
  props: {
    headline: {
      type: [Boolean, String],
      default: !1
    },
    text: {
      type: [Boolean, String],
      default: !1
    },
    image: {
      type: [Boolean, Object],
      default: !1
    },
    cta: {
      type: [Boolean, String],
      default: !1
    },
    imagePositionHorizontal: {
      type: String,
      default: "start"
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: KZ });
    return (o, r) => (d(), h("div", j(re(s(t).root)), [
      Le(ia, null, {
        default: fe(() => [
          P("div", j(re(s(t).wrap)), [
            e.image ? (d(), K(or, j(H({ key: 0 }, { ...e.image, ...s(t).Image })), null, 16)) : y("", !0),
            P("div", j(re(o.content)), [
              e.headline ? (d(), K(Jo, H({ key: 0 }, s(t).headline, { text: e.headline }), null, 16, ["text"])) : y("", !0),
              e.text ? (d(), K(Jo, H({ key: 1 }, s(t).text, { text: e.text }), null, 16, ["text"])) : y("", !0),
              e.cta ? (d(), K(ft, j(H({ key: 2 }, { ...e.cta, ...s(t).cta })), null, 16)) : y("", !0)
            ], 16)
          ], 16)
        ]),
        _: 1
      })
    ], 16));
  }
}, XZ = {
  composer: {
    props: {
      logo: {
        src: {
          default: "https://storage.googleapis.com/platformaone-sites-files-commerce-original-production/logos/19e952c9-0e16-4a2c-b2e7-55a63c9d80b1",
          control: "input"
        }
      },
      title: {
        default: "Hero Title",
        control: "input"
      },
      subtitle: {
        default: "Subtitle",
        control: "input"
      },
      cta: {
        label: {
          default: "CTA",
          control: "input"
        }
      },
      backgroundImageSrc: {
        default: "https://source.unsplash.com/random/1920x1080",
        control: "input"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full bg-cover h-[30vh] flex flex-col justify-center items-start",
      propsStateBased: {}
    },
    logo: {
      _common: "",
      propsStateBased: {},
      props: {
        classImg: "w-52 mb-5"
      }
    },
    title: {
      _common: "text-5xl font-bold text-white font-heading",
      propsStateBased: {}
    },
    subtitle: {
      _common: "text-2xl text-white font-body",
      propsStateBased: {}
    },
    cta: {
      _common: "mt-6",
      propsStateBased: {}
    }
  }
}, vX = {
  __name: "SectionHero",
  props: {
    logo: {
      type: [Boolean, String],
      default: !1
    },
    title: {
      type: [Boolean, String],
      default: !1
    },
    subtitle: {
      type: [Boolean, String],
      default: !1
    },
    cta: {
      type: [Boolean, String],
      default: !1
    },
    backgroundImageSrc: {
      type: [Boolean, String],
      default: !1
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: XZ }), o = {
      backgroundImage: `url(${a.backgroundImageSrc})`
    };
    return (r, l) => (d(), h("div", H(s(t).root, { style: o }), [
      Le(ia, null, {
        default: fe(() => [
          e.logo ? (d(), K(or, j(H({ key: 0 }, { ...e.logo, ...s(t).logo })), null, 16)) : y("", !0),
          e.title ? (d(), K(Jo, H({ key: 1 }, s(t).title, { text: e.title }), null, 16, ["text"])) : y("", !0),
          e.subtitle ? (d(), K(Jo, H({ key: 2 }, s(t).subtitle, { text: e.subtitle }), null, 16, ["text"])) : y("", !0),
          e.cta ? (d(), K(ft, j(H({ key: 3 }, { ...e.cta, ...s(t).cta })), null, 16)) : y("", !0)
        ]),
        _: 1
      })
    ], 16));
  }
}, QZ = {
  composer: {
    props: {
      title: {
        default: `Omakase & Night Skies:
Dinner and Helicopter Tour`,
        control: "input"
      },
      description: {
        default: "Elevate your sushi experience—literally and figuratively—with a helicopter ride over Dubai followed by a 7-course Omakase dinner at the Burj Al Arab.",
        control: "input"
      },
      image: {
        default: {
          src: "https://picsum.photos/800/800",
          aspect: "square",
          fit: "cover"
        },
        control: "input"
      },
      rounded: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "group grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 2xl:gap-16 w-full p-0",
      propsStateBased: {}
    },
    imageWrap: {
      _common: "block",
      propsStateBased: {}
    },
    image: {
      _common: "shrink-0 block overflow-hidden",
      propsStateBased: {
        rounded: {
          true: "rounded-2xl",
          false: "rounded-none"
        }
      }
    },
    content: {
      // _common: "mt-0 flex flex-col p-3 max-w-lg",
    },
    title: {
      _common: "whitespace-pre-wrap text-3xl font-bold leading-9 text-neutral-800 dark:text-neutral-100 font-heading"
    },
    description: {
      _common: "mt-4 text-lg text-neutral-400 font-body"
    }
  }
}, gX = {
  __name: "SectionProductItemDetail",
  props: {
    image: {
      type: Object,
      required: !0
    },
    title: {
      type: String,
      required: !0
    },
    description: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: QZ });
    return (o, r) => (d(), K(ia, null, {
      default: fe(() => [
        P("div", j(re(s(t).root)), [
          P("div", j(re(s(t).imageWrap)), [
            Le(or, H({ src: o.imageSrc }, { ...e.image, ...s(t).image }), null, 16, ["src"])
          ], 16),
          P("div", j(re(s(t).content)), [
            P("div", null, [
              P("h2", j(re(s(t).title)), N(e.title), 17),
              P("p", j(re(s(t).description)), N(e.description), 17)
            ]),
            P("div", j(re(s(t).actions)), [
              te(o.$slots, "actions")
            ], 16)
          ], 16)
        ], 16)
      ]),
      _: 3
    }));
  }
}, JZ = {
  composer: {
    props: {
      items: {
        default: [
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "Elevate your sushi experience—literally and figuratively—with a helicopter ride over Dubai followed by a 7-course Omakase dinner at the Burj Al Arab.",
            image: {
              src: "https://picsum.photos/800/800?random=1",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Meet & greet sushi master",
            description: "Have a chat with our sushi god",
            image: {
              src: "https://picsum.photos/800/600?random=2",
              aspect: "portrait",
              fit: "cover"
            },
            price: "2,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Private course",
            description: "You are the chef",
            image: {
              src: "https://picsum.photos/800/800?random=3",
              aspect: "portrait",
              fit: "cover"
            },
            price: "5,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Monetary",
            description: "You choose the value!",
            image: {
              src: "https://picsum.photos/1200/800?random=4",
              aspect: "portrait",
              fit: "cover"
            },
            price: "500 - 10,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "2 week intensive course with sushi master in our beach restaurant",
            description: "Learn the art of sushi making in our beach restaurant. You will be taught by our sushi master and will be able to enjoy your creations afterwards.",
            image: {
              src: "https://picsum.photos/800/400?random=5",
              aspect: "portrait",
              fit: "cover"
            },
            price: "50,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Private course for 2",
            description: "Don't want to share your sushi with strangers? We get it.",
            image: {
              src: "https://picsum.photos/800/400?random=6",
              aspect: "portrait",
              fit: "cover"
            },
            price: "8,000",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/800/1200?random=7",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/800/500?random=8",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          },
          {
            title: "Omakase & Night Skies: Dinner and Helicopter Tour",
            description: "",
            image: {
              src: "https://picsum.photos/500/800?random=9",
              aspect: "portrait",
              fit: "cover"
            },
            price: "6,500",
            pricePrefix: "AED",
            priceSuffix: ""
          }
        ],
        control: "input"
      },
      loading: {
        default: !1,
        options: [!1, !0],
        control: "switch"
      }
    }
  },
  pt: {
    root: {
      _common: "group grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-8 2xl:gap-16 w-full p-0",
      propsStateBased: {}
    },
    imageWrap: {
      _common: "block",
      propsStateBased: {}
    },
    image: {
      _common: "shrink-0 block overflow-hidden",
      propsStateBased: {
        rounded: {
          true: "rounded-2xl",
          false: "rounded-none"
        }
      }
    },
    content: {
      _common: "mt-0 flex flex-col p-3 max-w-lg"
    },
    title: {
      _common: "whitespace-pre-wrap text-3xl font-bold leading-9 text-neutral-800 dark:text-neutral-100"
    },
    description: {
      _common: "mt-4 text-lg text-neutral-400"
    }
  }
}, eY = {
  key: 0,
  class: "mt-4 flex flex-center"
}, MX = {
  __name: "SectionProductItemList",
  props: {
    items: {
      type: Array
    },
    showAllButtonShow: {
      type: Boolean,
      default: !1
    },
    showAllButtonLabel: {
      type: String,
      default: "show all"
    },
    noItemsLabel: {
      type: String
    },
    loading: {
      type: Boolean,
      default: !1
    },
    layout: {
      type: String,
      default: "grid",
      validator: (e) => ["grid", "list", "masonry"].includes(e)
    }
  },
  emits: ["showAllButtonClick"],
  setup(e) {
    const a = e;
    return Pe({ props: a, defaults: JZ }), (t, o) => (d(), K(ia, null, {
      default: fe(() => [
        Le(NG, j(re(a)), null, 16),
        e.showAllButtonShow && e.items.length > 0 ? (d(), h("div", eY, [
          Le(ft, {
            variant: "secondary",
            label: e.showAllButtonLabel,
            onClick: o[0] || (o[0] = (r) => t.$emit("showAllButtonClick"))
          }, null, 8, ["label"])
        ])) : y("", !0)
      ]),
      _: 1
    }));
  }
}, tY = {
  composer: {
    props: {
      height: {
        default: 11,
        options: [
          6,
          7,
          8,
          9,
          10,
          11,
          // default
          12,
          14,
          16,
          20,
          24,
          28,
          32,
          36,
          40,
          44,
          48,
          52,
          56,
          60,
          64,
          72,
          80,
          96,
          "25vh",
          "50vh",
          "75vh",
          "screen",
          "svh",
          "lvh",
          "dvh"
        ],
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "w-full",
      propsStateBased: {
        height: {
          6: "h-6",
          7: "h-7",
          8: "h-8",
          9: "h-9",
          10: "h-10",
          11: "h-11",
          // default
          12: "h-12",
          14: "h-14",
          16: "h-16",
          20: "h-20",
          24: "h-24",
          28: "h-28",
          32: "h-32",
          36: "h-36",
          40: "h-40",
          44: "h-44",
          48: "h-48",
          52: "h-52",
          56: "h-56",
          60: "h-60",
          64: "h-64",
          72: "h-72",
          80: "h-80",
          96: "h-96",
          "25vh": "h-25vh",
          "50vh": "h-50vh",
          "75vh": "h-75vh",
          screen: "h-screen",
          svh: "h-svh",
          lvh: "h-lvh",
          dvh: "h-dvh"
        }
      }
    }
  }
}, bX = {
  __name: "SectionSpacer",
  props: {
    height: {
      type: [String, Number],
      default: 11
    }
  },
  setup(e) {
    const a = e, { ep: t } = Pe({ props: a, defaults: tY });
    return (o, r) => (d(), h("div", j(re(s(t).root)), null, 16));
  }
}, aY = {
  composer: {
    props: {
      text: {
        default: "You will receive printable A4 size PDF immediately after payment to e-mail address used during checkout.",
        control: "input"
      },
      icon: {
        default: "Info",
        control: "input"
      },
      iconSet: {
        options: ["lucide"],
        default: "lucide",
        control: "select"
      },
      iconStrokeWidth: {
        options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3, 3.5, 4, 5],
        default: 2,
        control: "select"
      },
      layout: {
        options: ["horizontal", "vertical"],
        default: "horizontal",
        control: "select"
      }
    }
  },
  pt: {
    root: {
      _common: "flex gap-2 bg-neutral-100 p-2 rounded-md",
      propsStateBased: {
        layout: {
          horizontal: "flex-row",
          vertical: "flex-col"
        },
        fullWidth: {
          true: "w-full",
          false: "min-w-[300px]"
        }
      }
    },
    icon: {
      _common: "shrink-0 w-5 h-5 text-neutral-400"
    },
    content: {
      _common: "text-sm text-neutral-500"
    }
  }
}, xX = {
  __name: "TextBox",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    text: {
      type: String,
      default: ""
    },
    rounded: {
      type: String,
      default: "full"
    },
    filled: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: [String, Boolean],
      default: !1
    },
    iconSet: {
      type: String,
      default: "lucide"
    },
    iconStrokeWidth: {
      type: Number,
      default: 2
    },
    layout: {
      type: String,
      default: "horizontal"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, { ep: o } = Pe({ props: t, locals: {}, defaults: aY });
    return (r, l) => (d(), h("div", j(re(s(o).root)), [
      e.icon && e.iconSet == "lucide" ? (d(), K($e, H({ key: 0 }, s(o).icon, {
        lucide: e.icon,
        "lucide-stroke-width": e.iconStrokeWidth
      }), null, 16, ["lucide", "lucide-stroke-width"])) : y("", !0),
      Le(Jo, j(re(s(o).content)), {
        default: fe(() => [
          lt(N(e.text), 1)
        ]),
        _: 1
      }, 16)
    ], 16));
  }
}, nY = {
  composer: {
    props: {
      title: {
        default: "Toast title",
        control: "input"
      },
      message: {
        default: "Additional message",
        control: "input"
      }
    }
  },
  pt: {
    root: {
      _common: "",
      propsStateBased: {
        autoposition: {
          true: "fixed left-1/2 bottom-2 transform -translateX-1/2",
          false: ""
        }
      }
    },
    icon: {
      _common: ""
    },
    content: {
      _common: ""
    }
  }
};
function oY(e, a) {
  return d(), h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    P("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function rY(e, a) {
  return d(), h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    P("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function lY(e, a) {
  return d(), h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    P("path", {
      "fill-rule": "evenodd",
      d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm8.706-1.442c1.146-.573 2.437.463 2.126 1.706l-.709 2.836.042-.02a.75.75 0 0 1 .67 1.34l-.04.022c-1.147.573-2.438-.463-2.127-1.706l.71-2.836-.042.02a.75.75 0 1 1-.671-1.34l.041-.022ZM12 9a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
      "clip-rule": "evenodd"
    })
  ]);
}
function iY(e, a) {
  return d(), h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    "data-slot": "icon"
  }, [
    P("path", {
      "fill-rule": "evenodd",
      d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z",
      "clip-rule": "evenodd"
    })
  ]);
}
const cY = { class: "flex max-w-xs shrink-0 flex-row items-center gap-2 rounded-full bg-neutral-800 py-3 pl-3 pr-4" }, dY = { class: "" }, sY = { class: "leading-5" }, uY = {
  key: 0,
  class: "whitespace-nowrap font-semibold text-white"
}, hY = {
  key: 1,
  class: "whitespace-nowrap pr-2 text-neutral-400"
}, GS = 300, pY = {
  __name: "Toast",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    text: {
      type: String,
      default: ""
    },
    rounded: {
      type: String,
      default: "full"
    },
    filled: {
      type: Boolean,
      default: !1
    },
    icon: {
      type: [String, Boolean],
      default: !1
    },
    iconSet: {
      type: String,
      default: "lucide"
    },
    iconStrokeWidth: {
      type: Number,
      default: 2
    },
    layout: {
      type: String,
      default: "horizontal"
    },
    title: {
      type: [Boolean, String],
      default: !1
    },
    message: {
      type: [Boolean, String],
      default: !1
    },
    type: {
      type: String,
      default: "info"
    },
    autoposition: {
      type: Boolean,
      default: !1
    },
    autohide: {
      type: [Boolean, Number],
      default: 5e3
      // ms
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, { ep: o } = Pe({ props: t, locals: {}, defaults: nY }), r = U(!0), l = U("animate-fadeInDown");
    function i() {
      t.autohide && setTimeout(() => {
        l.value = "animate-fadeOutUp", console.log("setting fade out without destroy", t.autohide), setTimeout(() => {
          r.value = !1;
        }, GS);
      }, t.autohide - GS);
    }
    return i(), (c, u) => r.value ? (d(), h("div", H({
      key: 0,
      class: l.value
    }, s(o).root, {
      onClick: u[0] || (u[0] = (...v) => c.onClick && c.onClick(...v))
    }), [
      P("div", cY, [
        P("div", dY, [
          e.type === "info" ? (d(), K(s(lY), {
            key: 0,
            class: "size-6 shrink-0 text-blue-400"
          })) : y("", !0),
          e.type === "success" ? (d(), K(s(oY), {
            key: 1,
            class: "size-6 shrink-0 text-green-400"
          })) : y("", !0),
          e.type === "warning" ? (d(), K(s(rY), {
            key: 2,
            class: "size-6 shrink-0 text-orange-400"
          })) : y("", !0),
          e.type === "error" ? (d(), K(s(iY), {
            key: 3,
            class: "size-6 shrink-0 text-red-400"
          })) : y("", !0)
        ]),
        P("div", sY, [
          e.title ? (d(), h("span", uY, N(e.title), 1)) : y("", !0),
          e.message ? (d(), h("p", hY, N(e.message), 1)) : y("", !0)
        ])
      ])
    ], 16)) : y("", !0);
  }
}, yY = {
  composer: {
    props: {
      modelValue: {
        default: !1,
        control: "switch"
      },
      size: {
        default: 6,
        //11,
        control: "select",
        options: [14, 12, 11, 10, 9, 8, 7, 6]
      },
      rounded: {
        default: !1,
        options: [!1, "full", "md", "sm"],
        control: "select"
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      label: {
        default: "label",
        control: "input"
      },
      labelStart: {
        default: "label",
        control: "input"
      },
      labelEnd: {
        default: "label",
        control: "input"
      },
      sublabelStart: {
        default: "sublabel",
        control: "input"
      },
      sublabelEnd: {
        default: "sublabel",
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      }
    }
  },
  pt: {
    root: {},
    toggleWrap: {
      _common: "flex flex-row items-center justify-start gap-4"
    },
    toggle: {
      _common: "transition-all ease-in-out duration-300 cursor-pointer flex flex-row flex-center relative hover:opacity-50 dark:text-neutral-400",
      propsStateBased: {
        modelValue: {
          false: {
            _common: "hover:bg-neutral-100 dark:hover:bg-neutral-800"
          },
          true: {
            _common: "bg-neutral-200 dark:bg-neutral-800"
          }
        },
        rounded: {
          false: {
            _common: "",
            size: {
              14: "size-14",
              12: "size-12",
              11: "size-11",
              // default
              10: "size-10",
              9: "size-9",
              8: "size-8",
              7: "size-7",
              6: "size-6"
            }
          },
          full: {
            _common: "rounded-full",
            size: {
              14: "size-14",
              12: "size-12",
              11: "size-11",
              // default
              10: "size-10",
              9: "size-9",
              8: "size-8",
              7: "size-7",
              6: "size-6"
            }
          },
          md: {
            size: {
              14: "size-14 rounded-xl",
              12: "size-12 rounded-xl",
              11: "size-11 rounded-xl",
              // default
              10: "size-10 rounded-lg",
              9: "size-9 rounded-lg",
              8: "size-8 rounded-lg",
              7: "size-7 rounded-lg",
              6: "size-6 rounded-lg"
            }
          },
          sm: {
            size: {
              14: "size-14 rounded-md",
              12: "size-12 rounded-md",
              11: "size-11 rounded-md",
              // default
              10: "size-10 rounded-md",
              9: "size-9 rounded-md",
              8: "size-8 rounded-md",
              7: "size-7 rounded-md",
              6: "size-6 rounded-md"
            }
          }
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelStart: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    labelStartWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEndWrap: {
      _common: "flex flex-col gap-0"
    },
    labelEnd: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    sublabelStart: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    sublabelEnd: {
      _common: "leading-3 text-sm text-neutral-500"
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, kY = {
  key: 0,
  class: "flex flex-col"
}, mY = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, fY = {
  key: 1,
  class: ""
}, vY = { class: "mt-1 text-sm text-neutral-400 dark:text-neutral-700" }, gY = {
  key: 1,
  class: "flex flex-col"
}, wX = {
  __name: "Toggle",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    labelStart: {
      type: [String, Boolean],
      default: !1
    },
    labelEnd: {
      type: [String, Boolean],
      default: !1
    },
    sublabelStart: {
      type: [String, Boolean],
      default: !1
    },
    sublabelEnd: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    },
    rounded: {
      type: [String, Boolean],
      default: !1
    },
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, locals: {}, defaults: yY });
    function l() {
      console.log("onClickToggle"), o("update:modelValue", !t.modelValue);
    }
    return (i, c) => (d(), h("div", j(re(s(r).root)), [
      t.mode == "edit" ? (d(), h("div", kY, [
        t.label ? (d(), h("div", mY, [
          t.label ? (d(), h("span", j(H({ key: 0 }, s(r).labelOuter)), N(t.label), 17)) : y("", !0)
        ])) : y("", !0),
        P("div", j(re(s(r).toggleWrap)), [
          t.labelStart || t.sublabelStart ? (d(), h("div", j(H({ key: 0 }, s(r).labelStartWrap)), [
            t.labelStart ? (d(), h("span", j(H({ key: 0 }, s(r).labelStart)), N(t.labelStart), 17)) : y("", !0),
            t.sublabelStart ? (d(), h("span", j(H({ key: 1 }, s(r).sublabelStart)), N(t.sublabelStart), 17)) : y("", !0)
          ], 16)) : y("", !0),
          P("div", H(s(r).toggle, { onClick: l }), [
            te(i.$slots, "default")
          ], 16),
          t.labelEnd || t.sublabelEnd ? (d(), h("div", j(H({ key: 1 }, s(r).labelEndWrap)), [
            t.labelEnd ? (d(), h("span", j(H({ key: 0 }, s(r).labelEnd)), N(t.labelEnd), 17)) : y("", !0),
            t.sublabelEnd ? (d(), h("span", j(H({ key: 1 }, s(r).sublabelEnd)), N(t.sublabelEnd), 17)) : y("", !0)
          ], 16)) : y("", !0)
        ], 16),
        e.caption || i.$slots.caption ? (d(), h("div", fY, [
          te(i.$slots, "caption", {}, () => [
            P("p", vY, N(e.caption), 1)
          ])
        ])) : y("", !0)
      ])) : y("", !0),
      t.mode == "view" ? (d(), h("div", gY, [
        t.label || t.labelEnd || t.labelStart ? (d(), h("span", j(H({ key: 0 }, s(r).inputLabel)), N(t.label || t.labelEnd || t.labelStart), 17)) : y("", !0),
        P("p", j(re(s(r).modeViewValue)), N(t.modelValue), 17)
      ])) : y("", !0)
    ], 16));
  }
}, MY = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "flex flex-row justify-center pointer-events-none"
    },
    panel: {
      _common: "mb-4 bg-neutral-200 rounded-full inline-flex flex-row px-2 items-center h-14 transition-all duration-500 ease-in-out bg-opacity-30 backdrop-blur-sm gap-2 pointer-events-auto",
      propsStateBased: {
        fullWidth: {
          true: "w-full",
          false: "w-auto"
        }
      }
    }
  }
}, bY = {
  __name: "MenuFloating",
  props: {
    fullWidth: {
      type: Boolean,
      default: !1
    }
  },
  emits: [],
  setup(e, { emit: a }) {
    const t = e, { ep: o } = Pe({ props: t, defaults: MY });
    return (r, l) => (d(), K(ia, null, {
      default: fe(() => [
        P("div", j(re(s(o).root)), [
          P("div", j(re(s(o).panel)), [
            te(r.$slots, "buttons")
          ], 16)
        ], 16)
      ]),
      _: 3
    }));
  }
}, xY = { class: "relative" }, wY = {
  key: 0,
  class: "absolute -right-2 -top-2 block rounded-full bg-neutral-800 px-1.5 py-0.5 text-center text-xs font-medium text-neutral-100 dark:text-neutral-200"
}, LY = {
  __name: "MenuFloatingItem",
  props: {
    item: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const a = e;
    return F(() => a.item.variant || "secondary"), F(() => a.item.iconStrokeWidth || 2), (t, o) => (d(), h("div", xY, [
      Le(ft, {
        circle: !!e.item.icon,
        icon: e.item.icon,
        iconStart: e.item.iconStart,
        label: e.item.label,
        variant: e.item.variant,
        kind: "solid",
        iconStrokeWidth: e.item.iconStrokeWidth,
        onAction: o[0] || (o[0] = (r) => e.item.route ? t.$router.push(e.item.route) : e.item.action())
      }, null, 8, ["circle", "icon", "iconStart", "label", "variant", "iconStrokeWidth"]),
      e.item.badge ? (d(), h("span", wY, N(e.item.badge), 1)) : y("", !0)
    ]));
  }
};
process.env.NODE_ENV !== "production" ? Symbol("pinia") : (
  /* istanbul ignore next */
  Symbol()
);
var ZS;
(function(e) {
  e.direct = "direct", e.patchObject = "patch object", e.patchFunction = "patch function";
})(ZS || (ZS = {}));
process.env.NODE_ENV !== "production" ? Symbol("pinia:skipHydration") : (
  /* istanbul ignore next */
  Symbol()
);
function SY(e) {
  {
    const a = Br(e), t = {};
    for (const o in a) {
      const r = a[o];
      r.effect ? t[o] = // ...
      F({
        get: () => e[o],
        set(l) {
          e[o] = l;
        }
      }) : (Aw(r) || XC(r)) && (t[o] = // ---
      Gt(e, o));
    }
    return t;
  }
}
const IY = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "fixed top-2 left-2 right-2 z-[5000] m-auto flex flex-col-reverse items-center justify-center gap-2 transition-all duration-300 ease-in-out",
      propsStateBased: {}
    }
  }
}, LX = {
  __name: "Notifications",
  props: {
    appNotificationsStore: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    const a = e, { notifications: t } = SY(a.appNotificationsStore), { ep: o } = Pe({ props: a, defaults: IY });
    return (r, l) => (d(), h("div", j(re(s(o).root)), [
      (d(!0), h(ve, null, Ie(s(t), (i) => (d(), h("div", {
        key: i.id
      }, [
        Le(pY, {
          title: i.title,
          message: i.message,
          type: i.type,
          autohide: i.delay,
          autoposition: !1
        }, null, 8, ["title", "message", "type", "autohide"])
      ]))), 128))
    ], 16));
  }
}, CL = {
  composer: {
    props: {
      items: {
        default: [
          {
            id: "dashboard",
            title: "Dashboard",
            icon: "Home",
            route: "/admin",
            active: !0
          },
          { id: "users", title: "Users", xicon: "users", route: "/admin/users", active: !1 },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          },
          {
            id: "settings",
            title: "Settings",
            xicon: "cog",
            route: "/admin/settings",
            active: !1
          }
        ],
        control: "input"
      }
    }
  },
  pt: {
    root: {
      _common: "flex flex-col items-start @container grow overflow-y-scroll mt-4 mb-4 md:mt-4 md:mb-10",
      propsStateBased: {}
    },
    items: {
      _common: "flex flex-col gap-0 w-full"
    },
    itemWrap: {
      _common: "rounded-lg hover:bg-neutral-150 dark:hover:bg-neutral-900 w-full px-2 py-1 ease-in-out transition-all duration-300 flex flex-row justify-center @[8rem]:justify-start"
    },
    itemWrapActive: {
      _common: "rounded-lg w-full px-2 py-1 ease-in-out transition-all duration-300 flex flex-row justify-center @[8rem]:justify-start"
    },
    item: {
      _common: "block flex cursor-pointer flex-row items-center justify-start w-full gap-2 text-lg font-medium text-neutral-400 dark:text-neutral-800 hover:text-neutral-600 dark:hover:text-neutral-600 ease-in-out transition-all duration-300 relative"
    },
    itemActive: {
      _common: "flex cursor-pointer flex-row items-center justify-start w-full gap-2 text-lg font-medium text-neutral-900 dark:text-neutral-200"
    },
    itemIcon: {
      _common: "size-4 text-neutral-400 dark:text-neutral-600 shrink-0"
    },
    itemIconActive: {
      _common: "size-4 text-neutral-800 dark:text-neutral-200 shrink-0"
    },
    itemTitle: {
      _common: "hidden @[8rem]:inline text-neutral-400 dark:text-neutral-600 dark:hover:text-neutral-500 whitespace-nowrap mr-auto",
      propsStateBased: {}
    },
    itemTitleActive: {
      _common: "hidden @[8rem]:inline text-neutral-800 dark:text-neutral-200 whitespace-nowrap mr-auto"
    },
    itemBadge: {
      _common: "block px-2 py-0.5 rounded-full bg-neutral-400 dark:bg-neutral-900 text-center text-neutral-100 dark:text-neutral-500 text-xs font-medium"
    },
    itemBadgeActive: {
      _common: "block px-2 py-0.5 rounded-full bg-neutral-800 text-center text-neutral-100 text-xs font-medium dark:text-neutral-200"
    }
  }
}, CY = {
  composer: {
    props: {
      sidebarWidthCollapsed: {
        default: 60,
        control: "input"
      },
      sidebarWidthExpanded: {
        default: 220,
        control: "input"
      },
      sidebarMenuItems: CL.composer.props.items
    }
  },
  pt: {
    root: {
      _common: "w-full md:h-screen md:bg-neutral-50 dark:md:bg-neutral-950 p-0 md:p-4",
      propsStateBased: {}
    },
    sidebarMain: {
      _common: "flex flex-row gap-0 h-full",
      propsStateBased: {}
    },
    sidebar: {
      _common: "pr-3 relative transition-all duration-500 ease-in-out shrink-0 overflow-hidden hidden md:block",
      propsStateBased: {}
    },
    resizeHandle: {
      _common: "h-12 w-2 bg-neutral-200 dark:bg-neutral-900 cursor-pointer rounded-full hover:bg-neutral-400 dark:hover:bg-neutral-700 transition-all duration-300 ease-in-out",
      propsStateBased: {}
    },
    main: {
      _common: "grow",
      propsStateBased: {
        mainShowBackground: {
          true: "bg-white dark:bg-black dark:md:bg-black",
          false: ""
        },
        mainShowBorder: {
          true: "md:rounded-2xl md:border md:border-neutral-200 dark:md:border-none",
          false: ""
        },
        mainScrollable: {
          true: "md:overflow-y-scroll",
          false: "md:overflow-y-hidden"
        },
        mainPadding: {
          // pb-20 is to fit floating menu on mobile
          true: {
            showMenuMobile: {
              true: "p-4 pb-20 md:pb-4",
              false: "p-4 pb-0 md:pb-4"
            }
          },
          false: "p-0 md:pb-0"
        }
      }
    }
  }
}, AY = {
  composer: {
    props: {
      menuItems: CL.composer.props.items
    }
  },
  pt: {
    root: {
      _common: "flex flex-col justify-between grow max-h-full gap-0 md:h-full",
      propsStateBased: {}
    },
    projectSelectorAndMenuItems: {
      _common: "flex flex-col grow gap-10 max-h-full"
    }
  }
}, qY = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "relative @container z-10",
      propsStateBased: {}
    },
    projectActive: {
      _common: "h-15 flex flex-row items-center justify-between rounded-2xl @[8rem]:border @[8rem]:border-neutral-200 dark:@[8rem]:border-neutral-900 p-0 @[8rem]:p-2 cursor-pointer transition-all duration-300 ease-in-out @[8rem]:active:bg-neutral-200 dark:@[8rem]:active:bg-neutral-800",
      propsStateBased: {
        showProjectsList: {
          true: "@[8rem]:bg-neutral-200 dark:@[8rem]:bg-neutral-900",
          false: "hover:bg-white dark:hover:bg-black"
        }
      }
    },
    selectorChevrons: {
      _common: "pointer-events-none hidden h-6 w-6 shrink-0 text-neutral-400 dark:text-neutral-600 @[8rem]:block"
    },
    project: {
      _common: "flex flex-row items-center gap-2 overflow-x-hidden",
      propsStateBased: {}
    },
    projectsList: {
      _common: "absolute w-full min-w-52 max-h-96 mt-2 flex flex-col gap-0 bg-white dark:bg-black rounded-2xl p-1 border border-neutral-200 dark:border-neutral-900 shadow-xl shadow-neutral-500/10"
    },
    projectsListItem: {
      _common: "flex p-1 flex-row items-center gap-2 hover:bg-neutral-150 dark:hover:bg-neutral-950 rounded-xl cursor-pointer transition-all duration-300 ease-in-out"
    }
  }
}, zY = { class: "mt-0.5 hidden flex-col gap-0 leading-4 @[8rem]:flex" }, PY = { class: "text-md select-none font-medium text-neutral-900 dark:text-neutral-200" }, _Y = { class: "select-none whitespace-nowrap text-xs text-neutral-400" }, jY = { class: "overflow-y-scroll" }, HY = {
  key: 0,
  class: "py-2"
}, VY = ["onClick"], BY = { class: "mt-0.5 flex flex-col gap-0 leading-4" }, DY = { class: "text-md select-none font-medium text-neutral-900 dark:text-neutral-200" }, TY = { class: "select-none text-xs text-neutral-400 dark:text-neutral-500" }, $Y = { class: "size-11 shrink-0 rounded-lg bg-neutral-200 flex-center dark:bg-neutral-800" }, OY = {
  __name: "AdminSidebarProjectSelector",
  props: {
    projects: {
      type: Array,
      default: () => [
        // {
        //   id: 1,
        //   title: "Project 1",
        //   subtitle: "Project Description",
        //   active: true,
        // },
        // {
        //   id: 2,
        //   title: "Project 2",
        //   subtitle: "Project Description",
        //   active: false,
        // },
        // {
        //   id: 3,
        //   title: "Project 3",
        //   subtitle: "Project Description",
        //   active: false,
        // },
      ]
    },
    showCreateNewProject: {
      type: Boolean,
      default: !1
    },
    createNewProjectLabel: {
      type: String,
      default: "create new project"
    }
  },
  emits: ["projectSelected", "clickProjectNew"],
  setup(e, { emit: a }) {
    const t = e, o = a, r = U(null), l = U(null), i = U(!1), c = U(null), u = F(() => t.projects ? t.projects.find((C) => C.active) : null), v = F(() => t.projects ? t.projects.filter((C) => !C.active) : []), k = F(() => c.value ? v.value.filter((C) => {
      if (C.id === "separator")
        return !1;
      const B = c.value.toLowerCase().trim(), $ = C.title.toLowerCase().trim(), x = C.subtitle.toLowerCase().trim();
      return $.includes(B) || x.includes(B);
    }) : v.value);
    function f() {
      console.log("onClickProjectActive"), i.value = !i.value;
    }
    function p(C, B) {
      console.log("onClickProject", C, B == null ? void 0 : B.metaKey), (B == null ? void 0 : B.metaKey) === !1 && (i.value = !1), o("projectSelected", { project: C, e: B }), u.value.active = !1;
    }
    function m() {
      console.log("onClickProjectNew"), o("clickProjectNew");
    }
    function I(C) {
      C.target !== r.value && (C.metaKey || (i.value = !1));
    }
    We(i, (C) => {
      C ? window.addEventListener("click", I) : window.removeEventListener("click", I);
    });
    const { ep: S } = Pe({ props: t, defaults: qY, locals: { showProjectsList: i } });
    return (C, B) => (d(), h("div", j(re(s(S).root)), [
      P("div", H({
        ref_key: "elProjectActive",
        ref: r
      }, s(S).projectActive, { onClick: f }), [
        u.value ? (d(), h("div", H({
          key: 0,
          class: "pointer-events-none"
        }, s(S).project), [
          B[1] || (B[1] = P("div", { class: "h-11 w-11 shrink-0 rounded-lg bg-neutral-300 dark:bg-neutral-800" }, null, -1)),
          P("div", zY, [
            P("span", PY, N(u.value.title), 1),
            P("span", _Y, N(u.value.subtitle), 1)
          ])
        ], 16)) : y("", !0),
        Ot(Le($e, H({ lucide: "ChevronsUpDown" }, s(S).selectorChevrons), null, 16), [
          [Rt, !i.value]
        ]),
        Ot(Le($e, H({ lucide: "ChevronsDownUp" }, s(S).selectorChevrons), null, 16), [
          [Rt, i.value]
        ])
      ], 16),
      i.value ? (d(), h("div", j(H({ key: 0 }, s(S).projectsList)), [
        k.value.length > 5 ? (d(), K(Qo, {
          key: 0,
          ref_key: "elFilter",
          ref: l,
          modelValue: c.value,
          "onUpdate:modelValue": B[0] || (B[0] = ($) => c.value = $),
          placeholder: "filter projects",
          class: "mb-2",
          focus: !0,
          fullWidth: ""
        }, null, 8, ["modelValue"])) : y("", !0),
        P("div", jY, [
          (d(!0), h(ve, null, Ie(k.value, ($) => (d(), h("div", {
            key: $.id
          }, [
            $.id === "separator" ? (d(), h("div", HY, B[2] || (B[2] = [
              P("hr", { class: "dark:border-neutral-800" }, null, -1)
            ]))) : (d(), h("div", H({
              key: 1,
              ref_for: !0
            }, s(S).projectsListItem, {
              onClick: (x) => p($, x)
            }), [
              B[3] || (B[3] = P("div", { class: "h-11 w-11 shrink-0 rounded-lg bg-neutral-300 dark:bg-neutral-800" }, null, -1)),
              P("div", BY, [
                P("span", DY, N($.title), 1),
                P("span", TY, N($.subtitle), 1)
              ])
            ], 16, VY))
          ]))), 128)),
          e.showCreateNewProject ? (d(), h("div", H({ key: 0 }, s(S).projectsListItem, { onClick: m }), [
            P("div", $Y, [
              Le($e, { lucide: "Plus" })
            ]),
            P("span", null, N(e.createNewProjectLabel), 1)
          ], 16)) : y("", !0)
        ])
      ], 16)) : y("", !0)
    ], 16));
  }
}, RY = {
  key: 1,
  class: "size-5 shrink-0 rounded-md bg-neutral-300 dark:bg-neutral-900"
}, FY = {
  __name: "AdminSidebarMenu",
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ["itemClick"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, defaults: CL });
    function l(k) {
      return k.active ? r.value.itemActive : r.value.item;
    }
    function i(k) {
      return k.active ? r.value.itemWrapActive : r.value.itemWrap;
    }
    function c(k) {
      return k.active ? r.value.itemIconActive : r.value.itemIcon;
    }
    function u(k) {
      return k.active ? r.value.itemTitleActive : r.value.itemTitle;
    }
    function v(k) {
      return k.active ? r.value.itemBadgeActive : r.value.itemBadge;
    }
    return (k, f) => {
      const p = Fr("RouterLink");
      return d(), h("div", j(re(s(r).root)), [
        P("div", j(re(s(r).items)), [
          (d(!0), h(ve, null, Ie(e.items, (m) => (d(), h("span", H({ ref_for: !0 }, i(m), {
            key: m.id
          }), [
            Le(p, H({ ref_for: !0 }, l(m), {
              to: m.route,
              onClick: (I) => o("itemClick", m)
            }), {
              default: fe(() => [
                m.icon ? (d(), K($e, H({
                  key: 0,
                  ref_for: !0
                }, c(m), {
                  lucide: m.icon,
                  lucideStrokeWidth: 2.5
                }), null, 16, ["lucide"])) : y("", !0),
                m.icon ? y("", !0) : (d(), h("span", RY)),
                P("span", H({ ref_for: !0 }, u(m)), N(m.title), 17),
                m.badge ? (d(), h("span", H({
                  key: 2,
                  ref_for: !0
                }, v(m)), N(m.badge), 17)) : y("", !0)
              ]),
              _: 2
            }, 1040, ["to", "onClick"])
          ], 16))), 128))
        ], 16)
      ], 16);
    };
  }
}, EY = {
  composer: {
    props: {}
  },
  pt: {
    root: {
      _common: "relative @container",
      propsStateBased: {}
    },
    userBox: {
      _common: "flex transition-all duration-300 ease-in-out @[8rem]:hover:bg-neutral-150 dark:hover:bg-neutral-800 cursor-pointer flex-row gap-2 rounded-full p-1 shrink-0",
      propsStateBased: {}
    },
    userBoxImage: {
      _common: "pointer-events-none size-11 shrink-0 select-none rounded-full bg-neutral-300 dark:bg-neutral-800 aspect-square"
    },
    userBoxTitleSubtitle: {
      _common: "pointer-events-none mt-1.5 hidden select-none flex-col gap-0 leading-4 @[8rem]:flex"
    },
    userBoxTitle: {
      _common: "text-md whitespace-nowrap font-medium text-neutral-900 dark:text-neutral-400"
    },
    userBoxSubtitle: {
      _common: "whitespace-nowrap text-xs text-neutral-400 dark:text-neutral-600"
    },
    popup: {
      _common: "absolute bottom-14 w-full min-w-52 flex flex-col gap-0 bg-white dark:bg-black rounded-2xl p-1 border border-neutral-200 dark:border-neutral-800 shadow-xl shadow-neutral-500/10 dark:shadow-neutral-800/10"
    }
  }
}, UY = ["src"], NY = {
  __name: "AdminSidebarUser",
  props: {
    title: {
      type: String,
      default: "User Name"
    },
    subtitle: {
      type: String,
      default: "User email"
    },
    imageURL: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const a = e, t = U(null), o = U(null), r = U(!1), { ep: l } = Pe({ props: a, defaults: EY });
    function i() {
      console.log("onClickUserBox"), r.value = !r.value;
    }
    function c(u) {
      !t.value || !o.value || t.value.contains(u.target) || o.value.contains(u.target) || (r.value = !1);
    }
    return We(r, (u) => {
      u ? window.addEventListener("click", c) : window.removeEventListener("click", c);
    }), (u, v) => (d(), h("div", j(re(s(l).root)), [
      r.value ? (d(), h("div", H({
        key: 0,
        ref_key: "elPopup",
        ref: o
      }, s(l).popup), [
        te(u.$slots, "popup")
      ], 16)) : y("", !0),
      P("div", H({
        ref_key: "elUserBox",
        ref: t
      }, s(l).userBox, { onClick: i }), [
        e.imageURL ? (d(), h("img", H({ key: 0 }, s(l).userBoxImage, { src: e.imageURL }), null, 16, UY)) : y("", !0),
        e.imageURL ? y("", !0) : (d(), h("div", j(H({ key: 1 }, s(l).userBoxImage)), null, 16)),
        P("div", j(re(s(l).userBoxTitleSubtitle)), [
          P("span", j(re(s(l).userBoxTitle)), N(e.title), 17),
          P("span", j(re(s(l).userBoxSubtitle)), N(e.subtitle), 17)
        ], 16)
      ], 16)
    ], 16));
  }
}, YS = {
  __name: "AdminSidebar",
  props: {
    menuItems: {
      type: Array,
      default: () => []
    },
    user: {
      type: Object
    },
    projects: {
      type: Array
    },
    showProjectSelector: {
      type: Boolean,
      default: !0
    },
    showCreateNewProject: {
      type: Boolean
    },
    createNewProjectLabel: {
      type: String
    }
  },
  emits: ["projectSelected", "menuItemClick", "clickProjectNew"],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, defaults: AY });
    return (l, i) => (d(), h("div", j(re(s(r).root)), [
      te(l.$slots, "logo"),
      e.showProjectSelector ? (d(), K(OY, {
        key: 0,
        projects: e.projects,
        showCreateNewProject: e.showCreateNewProject,
        createNewProjectLabel: e.createNewProjectLabel,
        onProjectSelected: i[0] || (i[0] = (c) => o("projectSelected", c)),
        onClickProjectNew: i[1] || (i[1] = (c) => o("clickProjectNew"))
      }, null, 8, ["projects", "showCreateNewProject", "createNewProjectLabel"])) : y("", !0),
      Le(FY, {
        items: e.menuItems,
        onItemClick: i[2] || (i[2] = (c) => o("menuItemClick", c))
      }, null, 8, ["items"]),
      te(l.$slots, "additionalContent"),
      Le(NY, j(re(e.user)), {
        popup: fe(() => [
          te(l.$slots, "userPopup")
        ]),
        _: 3
      }, 16)
    ], 16));
  }
}, WY = { class: "absolute bottom-0 right-2 top-0 flex flex-col justify-center" }, GY = {
  key: 0,
  class: "pointer-events-auto flex grow flex-col justify-between overflow-hidden rounded-3xl border border-neutral-200 bg-white p-4 dark:border-neutral-900 dark:bg-neutral-950"
}, ZY = {
  key: 1,
  class: "fixed inset-0 z-40 bg-neutral-900 bg-opacity-90 backdrop-blur-sm"
}, SX = {
  __name: "ViewAdmin",
  props: {
    sidebarWidthCollapsed: {
      type: Number,
      default: 60
    },
    sidebarWidthExpanded: {
      type: Number,
      default: 220
    },
    sidebarShowProjectSelector: {
      type: Boolean,
      default: !0
    },
    sidebarShowCreateNewProject: {
      type: Boolean
    },
    sidebarCreateNewProjectLabel: {
      type: String
    },
    sidebarProjects: {
      type: Array
    },
    sidebarState: {
      type: String,
      default: "expanded"
    },
    sidebarMenuItems: {
      type: Array,
      default: () => []
    },
    sidebarUser: Object,
    mainScrollable: {
      type: Boolean,
      default: !0
    },
    mainShowBackground: {
      type: Boolean,
      default: !0
    },
    mainShowBorder: {
      type: Boolean,
      default: !0
    },
    mainPadding: {
      type: Boolean,
      default: !0
    },
    menuShowBackButton: {
      type: Boolean,
      default: !0
    },
    menuButtons: {
      type: Array,
      default: () => []
    },
    floatingMenu: {
      type: Object,
      default: () => {
      }
    },
    showMenuMobile: {
      type: Boolean,
      default: !0
    }
  },
  emits: [
    "clickResizeHandle",
    "projectSelected",
    "sidebarMenuItemClick",
    "clickProjectNew"
  ],
  setup(e, { emit: a }) {
    const t = e, o = a, { ep: r } = Pe({ props: t, defaults: CY }), l = U(t.sidebarState), i = U(!1), c = F(() => l.value === "expanded" ? t.sidebarWidthExpanded : t.sidebarWidthCollapsed), u = () => {
      l.value = l.value === "expanded" ? "collapsed" : "expanded", o("clickResizeHandle", l.value);
    }, v = (f) => {
      console.log("onSidebarMenuItemClick", f), o("sidebarMenuItemClick", f), i.value = !1;
    }, k = () => {
      i.value = !i.value;
    };
    return (f, p) => {
      var m, I, S;
      return d(), h("div", j(re(s(r).root)), [
        P("div", j(re(s(r).sidebarMain)), [
          P("div", H(s(r).sidebar, {
            style: { width: c.value + "px" }
          }), [
            te(f.$slots, "sidebar", {}, () => [
              Le(YS, {
                projects: e.sidebarProjects,
                menuItems: e.sidebarMenuItems,
                user: e.sidebarUser,
                showProjectSelector: e.sidebarShowProjectSelector,
                showCreateNewProject: e.sidebarShowCreateNewProject,
                createNewProjectLabel: e.sidebarCreateNewProjectLabel,
                onMenuItemClick: v,
                onProjectSelected: p[0] || (p[0] = (C) => o("projectSelected", C)),
                onClickProjectNew: p[1] || (p[1] = (C) => o("clickProjectNew"))
              }, {
                logo: fe(() => [
                  te(f.$slots, "logo")
                ]),
                additionalContent: fe(() => [
                  te(f.$slots, "additionalContent")
                ]),
                userPopup: fe(() => [
                  te(f.$slots, "userPopup")
                ]),
                _: 3
              }, 8, ["projects", "menuItems", "user", "showProjectSelector", "showCreateNewProject", "createNewProjectLabel"])
            ]),
            P("div", WY, [
              P("div", H(s(r).resizeHandle, { onClick: u }), null, 16)
            ])
          ], 16),
          e.showMenuMobile ? (d(), h("div", {
            key: 0,
            class: be(["pointer-events-none", [
              {
                "_md:hidden fixed inset-0 z-50 flex flex-col justify-end gap-2 p-2 pb-0": i.value
              },
              {
                "_md:hidden fixed bottom-0 left-0 right-0 z-50 flex flex-col justify-end gap-2 p-2 pb-0": !i.value
              }
            ]])
          }, [
            i.value ? (d(), h("div", GY, [
              te(f.$slots, "sidebar", {}, () => [
                Le(YS, {
                  projects: e.sidebarProjects,
                  menuItems: e.sidebarMenuItems,
                  user: e.sidebarUser,
                  showProjectSelector: e.sidebarShowProjectSelector,
                  showCreateNewProject: e.sidebarShowCreateNewProject,
                  createNewProjectLabel: e.sidebarCreateNewProjectLabel,
                  onMenuItemClick: v,
                  onProjectSelected: p[2] || (p[2] = (C) => o("projectSelected", C))
                }, {
                  logo: fe(() => [
                    te(f.$slots, "logo")
                  ]),
                  additionalContent: fe(() => [
                    te(f.$slots, "additionalContent")
                  ]),
                  userPopup: fe(() => [
                    te(f.$slots, "userPopup")
                  ]),
                  _: 3
                }, 8, ["projects", "menuItems", "user", "showProjectSelector", "showCreateNewProject", "createNewProjectLabel"])
              ])
            ])) : y("", !0),
            P("div", {
              class: be(["_md:hidden pointer-events-none z-50 flex w-full flex-center", [
                {
                  "md:hidden": !e.floatingMenu || !((m = e.floatingMenu) != null && m.backRoute) && ((S = (I = e.floatingMenu) == null ? void 0 : I.buttons) == null ? void 0 : S.length) === 0
                }
              ]])
            }, [
              Le(bY, null, {
                buttons: fe(() => {
                  var C, B;
                  return [
                    (C = e.floatingMenu) != null && C.backRoute ? (d(), K(ft, {
                      key: 0,
                      circle: "",
                      icon: "ArrowLeft",
                      variant: "secondary",
                      iconStrokeWidth: 2,
                      onAction: p[3] || (p[3] = ($) => f.$router.push(e.floatingMenu.backRoute))
                    })) : y("", !0),
                    (d(!0), h(ve, null, Ie((B = e.floatingMenu) == null ? void 0 : B.buttons, ($) => (d(), K(LY, {
                      key: $.id,
                      item: $
                    }, null, 8, ["item"]))), 128)),
                    Le(ft, {
                      class: "flex md:hidden",
                      circle: "",
                      icon: "Ellipsis",
                      variant: "secondary",
                      kind: "solid",
                      iconStrokeWidth: 3,
                      onAction: k
                    })
                  ];
                }),
                _: 1
              })
            ], 2)
          ], 2)) : y("", !0),
          i.value ? (d(), h("div", ZY)) : y("", !0),
          P("div", j(re(s(r).main)), [
            te(f.$slots, "main")
          ], 16)
        ], 16)
      ], 16);
    };
  }
}, YY = {
  composer: {
    props: {
      label: {
        default: "label",
        control: "input"
      },
      modelValue: {
        default: 3,
        control: "input"
      },
      max: {
        default: 5,
        control: "input"
      },
      caption: {
        default: "caption with additional information",
        control: "input"
      },
      size: {
        default: 11,
        control: "select",
        options: [24, 20, 16, 14, 12, 11, 10, 9, 8]
      },
      disabled: {
        default: !1,
        control: "switch"
      },
      layout: {
        default: "vertical",
        control: "select",
        options: ["horizontal", "vertical", "grid"]
      },
      fullWidth: {
        default: !1,
        options: [!0, !1],
        control: "switch"
      }
    }
  },
  pt: {
    options: {
      _common: "gap-2",
      propsStateBased: {
        layout: {
          horizontal: "flex flex-row",
          vertical: "flex flex-col",
          grid: "grid grid-cols-2 gap-2"
        },
        fullWidth: {
          true: "w-full",
          false: "min-w-[300px]"
        }
      }
    },
    labelOuter: {
      _common: "inline-block text-base font-bold text-neutral-600 dark:text-neutral-500 font-element"
    },
    stars: {
      _common: "flex items-center"
    },
    starWrap: {
      _common: "first:pl-0 last:pr-0",
      propsStateBased: {
        mode: {
          view: "cursor-default",
          edit: "cursor-pointer"
        },
        size: {
          24: "px-1",
          20: "px-1",
          16: "px-1",
          14: "px-1",
          12: "px-1",
          11: "px-1",
          10: "px-0.5",
          9: "px-0.5",
          8: "px-0.5"
        }
      }
    },
    star: {
      _common: "text-neutral-800",
      propsStateBased: {
        size: {
          24: "size-16",
          20: "size-14",
          16: "size-12",
          14: "size-10",
          12: "size-9",
          11: "size-8",
          10: "size-6",
          9: "size-5",
          8: "size-4"
        }
      }
    },
    modeViewValue: {
      _common: "text-neutral-900 dark:text-neutral-100"
    }
  }
}, KY = {
  key: 0,
  class: "flex flex-col"
}, XY = {
  key: 0,
  class: "mb-1 flex flex-row items-end justify-between"
}, QY = ["onMouseover", "onClick"], JY = {
  key: 1,
  class: ""
}, eK = { class: "mt-1 text-sm text-neutral-400" }, tK = {
  key: 1,
  class: "flex flex-col"
}, aK = { class: "flex flex-row items-center" }, IX = {
  __name: "RatingStars",
  props: {
    globalConfig: {
      type: Object
    },
    pt: {
      type: Object
    },
    modelValue: {
      type: Number
    },
    max: {
      type: Number,
      default: 5
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    mode: {
      type: String,
      default: "edit"
    },
    label: {
      type: [String, Boolean],
      default: !1
    },
    caption: {
      type: [String, Boolean],
      default: !1
    },
    size: {
      type: Number,
      default: 11
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, o = U(0), r = F(() => o.value ? o.value : t.modelValue), l = a, { ep: i } = Pe({ props: t, locals: {}, defaults: YY });
    function c(u) {
      t.disabled || l("update:modelValue", u + 1);
    }
    return (u, v) => (d(), h("div", j(re(s(i).root)), [
      t.mode == "edit" ? (d(), h("div", KY, [
        t.label ? (d(), h("div", XY, [
          t.label ? (d(), h("span", j(H({ key: 0 }, s(i).labelOuter)), N(t.label), 17)) : y("", !0)
        ])) : y("", !0),
        P("div", H(s(i).stars, {
          onMouseout: v[0] || (v[0] = (k) => o.value = 0)
        }), [
          (d(!0), h(ve, null, Ie(e.max, (k, f) => (d(), h("div", H({ ref_for: !0 }, s(i).starWrap, {
            key: f,
            onMouseover: (p) => o.value = f + 1,
            onClick: (p) => c(f)
          }), [
            Le($e, H({
              class: [{ "fill-current": f + 1 <= r.value }],
              lucide: "Star",
              ref_for: !0
            }, s(i).star), null, 16, ["class"])
          ], 16, QY))), 128))
        ], 16),
        e.caption || u.$slots.caption ? (d(), h("div", JY, [
          te(u.$slots, "caption", {}, () => [
            P("p", eK, N(e.caption), 1)
          ])
        ])) : y("", !0)
      ])) : y("", !0),
      t.mode == "view" ? (d(), h("div", tK, [
        t.label ? (d(), h("span", j(H({ key: 0 }, s(i).inputLabel)), N(t.label), 17)) : y("", !0),
        P("div", aK, [
          (d(!0), h(ve, null, Ie(e.max, (k, f) => (d(), h("div", H({ ref_for: !0 }, s(i).starWrap, { key: f }), [
            Le($e, H({
              class: [{ "fill-current": f + 1 <= r.value }],
              lucide: "Star",
              ref_for: !0
            }, s(i).star), null, 16, ["class"])
          ], 16))), 128))
        ])
      ])) : y("", !0)
    ], 16));
  }
};
function nK() {
  for (var e = 0, a, t, o = ""; e < arguments.length; )
    (a = arguments[e++]) && (t = DC(a)) && (o && (o += " "), o += t);
  return o;
}
function DC(e) {
  if (typeof e == "string")
    return e;
  for (var a, t = "", o = 0; o < e.length; o++)
    e[o] && (a = DC(e[o])) && (t && (t += " "), t += a);
  return t;
}
var AL = "-";
function oK(e) {
  var a = lK(e), t = e.conflictingClassGroups, o = e.conflictingClassGroupModifiers, r = o === void 0 ? {} : o;
  function l(c) {
    var u = c.split(AL);
    return u[0] === "" && u.length !== 1 && u.shift(), TC(u, a) || rK(c);
  }
  function i(c, u) {
    var v = t[c] || [];
    return u && r[c] ? [].concat(v, r[c]) : v;
  }
  return {
    getClassGroupId: l,
    getConflictingClassGroupIds: i
  };
}
function TC(e, a) {
  var i;
  if (e.length === 0)
    return a.classGroupId;
  var t = e[0], o = a.nextPart.get(t), r = o ? TC(e.slice(1), o) : void 0;
  if (r)
    return r;
  if (a.validators.length !== 0) {
    var l = e.join(AL);
    return (i = a.validators.find(function(c) {
      var u = c.validator;
      return u(l);
    })) == null ? void 0 : i.classGroupId;
  }
}
var KS = /^\[(.+)\]$/;
function rK(e) {
  if (KS.test(e)) {
    var a = KS.exec(e)[1], t = a == null ? void 0 : a.substring(0, a.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}
function lK(e) {
  var a = e.theme, t = e.prefix, o = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, r = cK(Object.entries(e.classGroups), t);
  return r.forEach(function(l) {
    var i = l[0], c = l[1];
    Ow(c, o, i, a);
  }), o;
}
function Ow(e, a, t, o) {
  e.forEach(function(r) {
    if (typeof r == "string") {
      var l = r === "" ? a : XS(a, r);
      l.classGroupId = t;
      return;
    }
    if (typeof r == "function") {
      if (iK(r)) {
        Ow(r(o), a, t, o);
        return;
      }
      a.validators.push({
        validator: r,
        classGroupId: t
      });
      return;
    }
    Object.entries(r).forEach(function(i) {
      var c = i[0], u = i[1];
      Ow(u, XS(a, c), t, o);
    });
  });
}
function XS(e, a) {
  var t = e;
  return a.split(AL).forEach(function(o) {
    t.nextPart.has(o) || t.nextPart.set(o, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(o);
  }), t;
}
function iK(e) {
  return e.isThemeGetter;
}
function cK(e, a) {
  return a ? e.map(function(t) {
    var o = t[0], r = t[1], l = r.map(function(i) {
      return typeof i == "string" ? a + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(function(c) {
        var u = c[0], v = c[1];
        return [a + u, v];
      })) : i;
    });
    return [o, l];
  }) : e;
}
function dK(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var a = 0, t = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
  function r(l, i) {
    t.set(l, i), a++, a > e && (a = 0, o = t, t = /* @__PURE__ */ new Map());
  }
  return {
    get: function(i) {
      var c = t.get(i);
      if (c !== void 0)
        return c;
      if ((c = o.get(i)) !== void 0)
        return r(i, c), c;
    },
    set: function(i, c) {
      t.has(i) ? t.set(i, c) : r(i, c);
    }
  };
}
var $C = "!";
function sK(e) {
  var a = e.separator || ":", t = a.length === 1, o = a[0], r = a.length;
  return function(i) {
    for (var c = [], u = 0, v = 0, k, f = 0; f < i.length; f++) {
      var p = i[f];
      if (u === 0) {
        if (p === o && (t || i.slice(f, f + r) === a)) {
          c.push(i.slice(v, f)), v = f + r;
          continue;
        }
        if (p === "/") {
          k = f;
          continue;
        }
      }
      p === "[" ? u++ : p === "]" && u--;
    }
    var m = c.length === 0 ? i : i.substring(v), I = m.startsWith($C), S = I ? m.substring(1) : m, C = k && k > v ? k - v : void 0;
    return {
      modifiers: c,
      hasImportantModifier: I,
      baseClassName: S,
      maybePostfixModifierPosition: C
    };
  };
}
function uK(e) {
  if (e.length <= 1)
    return e;
  var a = [], t = [];
  return e.forEach(function(o) {
    var r = o[0] === "[";
    r ? (a.push.apply(a, t.sort().concat([o])), t = []) : t.push(o);
  }), a.push.apply(a, t.sort()), a;
}
function hK(e) {
  return {
    cache: dK(e.cacheSize),
    splitModifiers: sK(e),
    ...oK(e)
  };
}
var pK = /\s+/;
function yK(e, a) {
  var t = a.splitModifiers, o = a.getClassGroupId, r = a.getConflictingClassGroupIds, l = /* @__PURE__ */ new Set();
  return e.trim().split(pK).map(function(i) {
    var c = t(i), u = c.modifiers, v = c.hasImportantModifier, k = c.baseClassName, f = c.maybePostfixModifierPosition, p = o(f ? k.substring(0, f) : k), m = !!f;
    if (!p) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (p = o(k), !p)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      m = !1;
    }
    var I = uK(u).join(":"), S = v ? I + $C : I;
    return {
      isTailwindClass: !0,
      modifierId: S,
      classGroupId: p,
      originalClassName: i,
      hasPostfixModifier: m
    };
  }).reverse().filter(function(i) {
    if (!i.isTailwindClass)
      return !0;
    var c = i.modifierId, u = i.classGroupId, v = i.hasPostfixModifier, k = c + u;
    return l.has(k) ? !1 : (l.add(k), r(u, v).forEach(function(f) {
      return l.add(c + f);
    }), !0);
  }).reverse().map(function(i) {
    return i.originalClassName;
  }).join(" ");
}
function kK() {
  for (var e = arguments.length, a = new Array(e), t = 0; t < e; t++)
    a[t] = arguments[t];
  var o, r, l, i = c;
  function c(v) {
    var k = a[0], f = a.slice(1), p = f.reduce(function(m, I) {
      return I(m);
    }, k());
    return o = hK(p), r = o.cache.get, l = o.cache.set, i = u, u(v);
  }
  function u(v) {
    var k = r(v);
    if (k)
      return k;
    var f = yK(v, o);
    return l(v, f), f;
  }
  return function() {
    return i(nK.apply(null, arguments));
  };
}
function Ue(e) {
  var a = function(o) {
    return o[e] || [];
  };
  return a.isThemeGetter = !0, a;
}
var OC = /^\[(?:([a-z-]+):)?(.+)\]$/i, mK = /^\d+\/\d+$/, fK = /* @__PURE__ */ new Set(["px", "full", "screen"]), vK = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, gK = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, MK = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function It(e) {
  return Yo(e) || fK.has(e) || mK.test(e) || Rw(e);
}
function Rw(e) {
  return rr(e, "length", IK);
}
function bK(e) {
  return rr(e, "size", RC);
}
function xK(e) {
  return rr(e, "position", RC);
}
function wK(e) {
  return rr(e, "url", CK);
}
function ol(e) {
  return rr(e, "number", Yo);
}
function Yo(e) {
  return !Number.isNaN(Number(e));
}
function LK(e) {
  return e.endsWith("%") && Yo(e.slice(0, -1));
}
function _r(e) {
  return QS(e) || rr(e, "number", QS);
}
function He(e) {
  return OC.test(e);
}
function jr() {
  return !0;
}
function ea(e) {
  return vK.test(e);
}
function SK(e) {
  return rr(e, "", AK);
}
function rr(e, a, t) {
  var o = OC.exec(e);
  return o ? o[1] ? o[1] === a : t(o[2]) : !1;
}
function IK(e) {
  return gK.test(e);
}
function RC() {
  return !1;
}
function CK(e) {
  return e.startsWith("url(");
}
function QS(e) {
  return Number.isInteger(Number(e));
}
function AK(e) {
  return MK.test(e);
}
function qK() {
  var e = Ue("colors"), a = Ue("spacing"), t = Ue("blur"), o = Ue("brightness"), r = Ue("borderColor"), l = Ue("borderRadius"), i = Ue("borderSpacing"), c = Ue("borderWidth"), u = Ue("contrast"), v = Ue("grayscale"), k = Ue("hueRotate"), f = Ue("invert"), p = Ue("gap"), m = Ue("gradientColorStops"), I = Ue("gradientColorStopPositions"), S = Ue("inset"), C = Ue("margin"), B = Ue("opacity"), $ = Ue("padding"), x = Ue("saturate"), q = Ue("scale"), _ = Ue("sepia"), A = Ue("skew"), z = Ue("space"), J = Ue("translate"), ee = function() {
    return ["auto", "contain", "none"];
  }, Z = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, se = function() {
    return ["auto", He, a];
  }, G = function() {
    return [He, a];
  }, ke = function() {
    return ["", It];
  }, T = function() {
    return ["auto", Yo, He];
  }, w = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, E = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, M = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, ne = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, ue = function() {
    return ["", "0", He];
  }, me = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, Se = function() {
    return [Yo, ol];
  }, V = function() {
    return [Yo, He];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [jr],
      spacing: [It],
      blur: ["none", "", ea, He],
      brightness: Se(),
      borderColor: [e],
      borderRadius: ["none", "", "full", ea, He],
      borderSpacing: G(),
      borderWidth: ke(),
      contrast: Se(),
      grayscale: ue(),
      hueRotate: V(),
      invert: ue(),
      gap: G(),
      gradientColorStops: [e],
      gradientColorStopPositions: [LK, Rw],
      inset: se(),
      margin: se(),
      opacity: Se(),
      padding: G(),
      saturate: Se(),
      scale: Se(),
      sepia: ue(),
      skew: V(),
      space: G(),
      translate: G()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", He]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ea]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": me()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": me()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(w(), [He])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: Z()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": Z()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": Z()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: ee()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": ee()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": ee()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [S]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [S]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [S]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [S]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [S]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [S]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [S]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [S]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [S]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", _r]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: se()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", He]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ue()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ue()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", _r]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [jr]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", _r]
        }, He]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": T()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": T()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [jr]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [_r]
        }, He]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": T()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": T()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", He]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", He]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(ne())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(ne(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(ne(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [$]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [$]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [$]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [$]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [$]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [$]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [$]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [$]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [$]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [C]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [C]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [C]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [C]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [C]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [C]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [C]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [C]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [C]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [z]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [z]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", He, a]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", He, It]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [ea]
        }, ea, He]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [He, a, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", He, It]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [He, a, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", ea, Rw]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ol]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [jr]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", He]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", Yo, ol]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", He, It]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", He]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", He]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [B]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [B]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(E(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", It]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", He, It]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: G()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", He]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", He]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [B]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(w(), [xK])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", bK]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, wK]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [I]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [I]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [I]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [l]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [l]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [l]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [l]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [l]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [l]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [l]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [l]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [l]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [l]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [l]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [l]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [l]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [l]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [l]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [c]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [c]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [c]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [c]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [c]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [c]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [c]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [c]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [c]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [B]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(E(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [c]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [c]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [B]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: E()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [r]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [r]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [r]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [r]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [r]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [r]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [r]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [r]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(E())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [He, It]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [It]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: ke()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [B]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [It]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", ea, SK]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [jr]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [B]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": M()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": M()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [t]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [o]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", ea, He]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [v]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [k]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [x]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [_]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [t]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [o]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [v]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [k]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [B]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [x]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [_]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", He]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: V()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", He]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: V()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", He]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [q]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [q]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [q]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [_r, He]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [J]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [J]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", He]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", He]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": G()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": G()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": G()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": G()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": G()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": G()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": G()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": G()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": G()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": G()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": G()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": G()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": G()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": G()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": G()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": G()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": G()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": G()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", He]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [It, ol]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
var JS = /* @__PURE__ */ kK(qK);
function jt(e) {
  var v, k;
  const t = tI().type.__name, o = e.defaults, r = e.localProps, l = ((v = r.globalConfig) == null ? void 0 : v[t]) || ((k = Fw("one-ui-config")) == null ? void 0 : k[t]), i = F(() => {
    let f = { ...r };
    return delete f.globalConfig, Ux({}, o == null ? void 0 : o.props, l == null ? void 0 : l.props, f);
  });
  OG(o.classes, l == null ? void 0 : l.classes);
  const c = Object.entries(i.value).map(([f, p]) => {
    if (typeof p == "boolean" && (p = p.toString()), p && !(p instanceof Object) && typeof p != "number")
      return `${f}${p.charAt(0).toUpperCase() + p.slice(1)}`;
  }).filter(Boolean);
  return F(() => {
    let f = i.value;
    return Object.entries(o.classes).forEach(([p, m]) => {
      var I, S;
      f[p] = {}, f[p].class = JS(
        m.commonClasses,
        (S = (I = l == null ? void 0 : l.classes) == null ? void 0 : I[p]) == null ? void 0 : S.commonClasses
      ), m.propsClasses && Object.entries(m.propsClasses).forEach(([C, B]) => {
        B._common && (f[p].class += ` ${B._common}`);
        const $ = i.value[C], x = B[$];
        if (x instanceof Object) {
          x._common && (f[p].class += ` ${x._common}`);
          let q = !0;
          Object.entries(x).forEach(([_, A]) => {
            var z, J, ee, Z, se;
            c.includes(_) && (q = !1, f[p].class += ` ${JS(
              A,
              (se = (Z = (ee = (J = (z = l == null ? void 0 : l.classes) == null ? void 0 : z[p]) == null ? void 0 : J.propsClasses) == null ? void 0 : ee[C]) == null ? void 0 : Z[$]) == null ? void 0 : se[_]
            )}`);
          }), q && (f[p].class += ` ${x._default}`);
        } else
          f[p].class += ` ${x}`;
      });
    }), f;
  });
}
const Hx = {
  __name: "OIcon",
  props: {
    name: {
      type: String
    },
    lucide: {
      type: String
    }
  },
  setup(e) {
    const a = /* @__PURE__ */ Object.assign({ "../icons/Progress.svg": () => import("./Progress-728072aa.js") }), t = e, o = F(() => {
      if (t.lucide)
        return rI[t.lucide];
      {
        const r = `${t.name}.svg`;
        return console.log({ icons: a, iconFileName: r }), console.log(a[`../icons/${r}`]), aI(() => a[`../icons/${r}`]());
      }
    });
    return (r, l) => (d(), K(st(o.value)));
  }
}, CX = {
  __name: "OButton",
  props: {
    /**
     * label
     */
    label: {
      type: [Boolean, String]
    },
    /**
     * label for secondary action
     */
    labelSecondary: {
      type: String
    },
    /**
     * button has double action (eg. delete button requires confirmation click)
     */
    doubleAction: {
      type: Boolean
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * padding (only padding) [none | small | default | large]
     */
    padding: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    // TODO: could be: 'rectangular', 'rounded', 'pill'
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * shape [solid | ghost | naked | plain]
     */
    kind: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | success | error | disabled | [...custom globalConfig defined]]
     */
    status: {
      type: String
    },
    /**
     * progress (for showing loading indicator)
     */
    progress: {
      type: Boolean
    },
    /**
     * icon (for showing icon only)
     */
    icon: {
      type: Boolean
    },
    /**
     * icon from Lucide.dev (for showing icon)
     */
    iconLucide: {
      type: [Boolean, String]
    },
    /**
     * disabled
     */
    disabled: {
      type: Boolean
    }
  },
  emits: ["action"],
  setup(e, { emit: a }) {
    const t = e, o = a, r = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        kind: "solid",
        status: "primary",
        rounded: "full",
        padding: "default",
        doubleAction: !1,
        icon: !1,
        disabled: !1
      },
      classes: {
        wrapper: {
          commonClasses: ""
          //"p-4 border",
        },
        button: {
          commonClasses: "flex flex-row justify-center items-center gap-2 font-element font-semibold transition-all duration-250 ease-in-out",
          propsClasses: {
            rounded: {
              none: "rounded-none",
              slight: "rounded-lg",
              full: "rounded-full"
            },
            padding: {
              large: "h-[52px] px-7",
              default: "h-[44px] px-4",
              small: "py-1 px-2",
              none: "p-0"
            },
            kind: {
              ghost: "outline outline-2 -outline-offset-2"
            },
            status: {
              // _common: "", // applied to all
              primary: {
                kindSolid: "bg-neutral-900 context-dark:bg-neutral-500 hover:bg-neutral-700 active:bg-neutral-900 text-white dark:bg-neutral-600 dark:text-neutral-200 dark:hover:bg-neutral-700 dark:active:bg-neutral-800",
                // roundedNone: "outline-red-500 outline outline-2 outline-offset-4", //just for testing purposes, if button is not rounded
                kindGhost: "outline-neutral-900 hover:outline-neutral-400 active:outline-neutral-900",
                kindNaked: "hover:bg-neutral-200 dark:hover:bg-neutral-800 active:bg-neutral-300",
                kindPlain: "text-neutral-900 hover:text-neutral-500 active:text-neutral-900"
              },
              secondary: {
                kindSolid: "bg-neutral-200 hover:bg-neutral-300 active:bg-neutral-400",
                kindGhost: "outline-neutral-200 hover:outline-neutral-400 active:outline-neutral-600",
                kindNaked: "text-neutral-500 hover:bg-neutral-200 active:bg-neutral-300",
                kindPlain: "text-neutral-500 hover:text-neutral-600 active:text-neutral-900"
              },
              success: {
                kindSolid: "bg-green-500 hover:bg-green-400 active:bg-green-500",
                kindGhost: "outline-green-500 hover:outline-green-400 active:outline-green-600",
                kindNaked: "text-green-500 hover:bg-green-100 active:bg-green-200",
                kindPlain: "text-green-500 hover:text-green-400 active:text-green-500"
              },
              error: {
                kindSolid: "bg-red-500 hover:bg-red-400 active:bg-red-500",
                kindGhost: "outline-red-500 hover:outline-red-400 active:outline-red-600",
                kindNaked: "text-red-500 hover:bg-red-100 dark:hover:bg-red-900 active:bg-red-200",
                kindPlain: "text-red-500 hover:text-red-400 active:text-red-500"
              },
              disabled: {
                _common: "cursor-not-allowed",
                // _common applied to all
                // _default: "", // _default applied when none of the following (kindSolid, kindGhost, kindNaked, kindPlain) is matched
                kindSolid: "bg-neutral-100 text-neutral-300",
                kindGhost: "bg-transparent outline-neutral-200 text-neutral-200",
                kindNaked: "bg-transparent text-neutral-200",
                kindPlain: "bg-transparent text-neutral-200"
              }
            }
          }
        }
      }
    };
    r.classes.wrapper.commonClasses += ` context-${t.context}`;
    const l = jt({ localProps: t, defaults: r }), i = U(l.value.label || !1);
    We(
      () => t.label,
      (v) => {
        i.value = v;
      },
      {
        immediate: !0
      }
    ), We(l, (v) => {
    });
    const c = U(0);
    function u() {
      l.value.disabled || (l.value.doubleAction ? (c.value++, c.value == 1 ? i.value = l.value.labelSecondary : c.value == 2 && (o("action"), c.value = 0)) : o("action"));
    }
    return (v, k) => (d(), h("div", j(re(s(l).wrapper)), [
      P("button", H(s(l).button, { onClick: u }), [
        s(l).progress ? (d(), K(Hx, {
          key: 0,
          class: "animate-spin",
          name: "Progress"
        })) : y("", !0),
        s(l).iconLucide ? (d(), K(Hx, {
          key: 1,
          lucide: s(l).iconLucide
        }, null, 8, ["lucide"])) : y("", !0),
        i.value && !s(l).icon ? (d(), h("span", j(H({ key: 2 }, s(l).text)), N(i.value), 17)) : s(l).icon ? y("", !0) : (d(), h("span", j(H({ key: 3 }, s(l).text)), N(s(Nx).get("element-button", null, s(l).locale)), 17))
      ], 16)
    ], 16));
  }
};
let rl;
const zK = new Uint8Array(16);
function PK() {
  if (!rl && (rl = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !rl))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return rl(zK);
}
const rt = [];
for (let e = 0; e < 256; ++e)
  rt.push((e + 256).toString(16).slice(1));
function _K(e, a = 0) {
  return rt[e[a + 0]] + rt[e[a + 1]] + rt[e[a + 2]] + rt[e[a + 3]] + "-" + rt[e[a + 4]] + rt[e[a + 5]] + "-" + rt[e[a + 6]] + rt[e[a + 7]] + "-" + rt[e[a + 8]] + rt[e[a + 9]] + "-" + rt[e[a + 10]] + rt[e[a + 11]] + rt[e[a + 12]] + rt[e[a + 13]] + rt[e[a + 14]] + rt[e[a + 15]];
}
const jK = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), eI = {
  randomUUID: jK
};
function HK(e, a, t) {
  if (eI.randomUUID && !a && !e)
    return eI.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || PK)();
  if (o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, a) {
    t = t || 0;
    for (let r = 0; r < 16; ++r)
      a[t + r] = o[r];
    return a;
  }
  return _K(o);
}
const VK = {
  key: 0,
  class: "flex flex-col"
}, BK = {
  key: 1,
  class: "flex flex-col"
}, AX = {
  __name: "OInput",
  props: {
    /**
     * value
     */
    modelValue: {
      type: String
    },
    /**
     * langs
     */
    langs: {
      type: Array
    },
    /**
     * long (multiline)
     */
    long: {
      type: Boolean
    },
    /**
     * lowercase
     */
    lowercase: {
      type: Boolean
    },
    /**
     * nospace
     */
    nospace: {
      type: Boolean
    },
    regex: {
      type: [String, Boolean]
    },
    disabled: {
      type: Boolean
    },
    /** placeholder */
    placeholder: {
      type: String
    },
    /**
     * mode [view | edit]
     */
    mode: {
      type: String
    },
    /**
     * label
     */
    label: {
      type: String
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * padding (only padding) [none | small | default | large]
     */
    padding: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | success | error | disabled | [...custom globalConfig defined]]
     */
    status: {
      type: String
    },
    // how long to wait with emitting input event after typing has stopped
    debounce: {
      type: Number
    },
    // saving state indicator - init | saving | saved | error
    saveState: {
      // manual
      type: String
    },
    autoState: {
      // auto -> 'formSaveState' store necessary
      type: Boolean
    }
  },
  emits: [
    "update:modelValue",
    "keyup",
    "enter",
    "focus",
    "blur",
    "input-debounced",
    "mouseup"
  ],
  setup(e, { emit: a }) {
    const t = e, o = a, r = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        status: "primary",
        rounded: "full",
        mode: "edit",
        padding: "default",
        lowercase: !1,
        nospace: !1,
        regex: !1,
        disabled: !1,
        debounce: 750,
        saveState: "init",
        autoState: !1
      },
      classes: {
        wrapper: {
          commonClasses: "@container"
          //"p-4 border",
        },
        container: {
          commonClasses: "shadow-[0_1px_0px_0px,0_-1px_0px_0px] @sm:shadow-none shadow-neutral-200 @sm:outline @sm:outline-1 @sm:outline-neutral-200 @sm:hover:outline-neutral-300 px-4 py-4 min-h-[58px] @sm:rounded-lg flex flex-col justify-center mt-2"
        },
        // input: {
        //   commonClasses:
        //     "font-element font-semibold transition-all duration-250 ease-in-out border dark:border-neutral-700 dark:bg-neutral-800 font-element",
        //   propsClasses: {
        //     padding: {
        //       large: "h-[52px] px-7",
        //       default: "h-[44px] px-2",
        //       small: "py-1 px-2",
        //       none: "p-0",
        //     },
        //   },
        // },
        inputField: {
          commonClasses: "",
          propsClasses: {
            mode: {
              edit: "",
              view: "pl-4 whitespace-pre-wrap"
            }
          }
        },
        inputLabel: {
          commonClasses: "font-bold text-neutral-600 pl-4 font-element"
        },
        placeholder: {
          commonClasses: "font-normal text-neutral-400 absolute pointer-events-none font-element"
        }
      }
    };
    r.classes.wrapper.commonClasses += ` context-${t.context}`;
    const l = jt({ localProps: t, defaults: r }), i = Gt(t, "modelValue"), c = U(!1), u = F(() => t.placeholder && !i.value && !c.value), v = aL.debounce(function(_, A) {
      x(_, A);
    }, t.debounce), k = HK();
    function f(_) {
      const A = _;
      if (!t.placeholder)
        A ? u.value[A] = !1 : u.value = !1;
      else {
        let z = !0;
        A ? (t.modelValue && t.modelValue[A] && t.modelValue[A].length > 0 && (z = !1), u.value[A] = z) : setTimeout(() => {
          t.modelValue && t.modelValue.length > 0 && (z = !1), u.value = z;
        }, 50);
      }
    }
    function p() {
      t.autoState && (t.langs ? t.langs.forEach((_) => {
        u.value[_] = !1, f(_);
      }) : f());
    }
    function m(_) {
      o("keyup", _);
    }
    function I(_) {
      o("enter", _);
    }
    function S() {
      c.value = !0, o("focus");
    }
    function C() {
      c.value = !1, o("blur");
    }
    function B(_) {
      o("mouseup", _);
    }
    function $(_, A) {
      console.log("Input.vue: onInput", _, A), f(A), q(_, A), v(_, A);
    }
    function x(_, A) {
      let z = t.langs ? i : _, J = A ? `${k}-${A}` : k;
      o("input-debounced", z, { fieldId: J, lang: A });
    }
    function q(_, A) {
      let z = t.langs ? i : _;
      console.log("emitInput()", _, i, z);
      let J = A ? `${k}-${A}` : k;
      o("update:modelValue", z, { fieldId: J, lang: A });
    }
    return Qe(async () => {
    }), p(), (_, A) => (d(), h("div", j(re(s(l).wrapper)), [
      s(l).mode == "edit" ? (d(), h("div", VK, [
        s(l).label ? (d(), h("span", j(H({ key: 0 }, s(l).inputLabel)), N(s(l).label), 17)) : y("", !0),
        P("div", j(re(s(l).container)), [
          u.value ? (d(), h("span", j(H({ key: 0 }, s(l).placeholder)), N(t.placeholder), 17)) : y("", !0),
          Le(qI, H(s(l).inputField, {
            modelValue: i.value,
            "onUpdate:modelValue": [
              A[0] || (A[0] = (z) => i.value = z),
              $
            ],
            multiline: e.long,
            lowercase: e.lowercase,
            nospace: e.nospace,
            regex: e.regex,
            disabled: e.disabled,
            mode: e.mode,
            onPaste: $,
            onKeyup: m,
            onFocus: S,
            onBlur: C,
            onEnter: I,
            onMouseup: B
          }), null, 16, ["modelValue", "multiline", "lowercase", "nospace", "regex", "disabled", "mode"])
        ], 16)
      ])) : y("", !0),
      s(l).mode == "view" ? (d(), h("div", BK, [
        s(l).label ? (d(), h("span", j(H({ key: 0 }, s(l).inputLabel)), N(s(l).label), 17)) : y("", !0),
        P("p", j(re(s(l).inputField)), N(t.modelValue), 17)
      ])) : y("", !0)
    ], 16));
  }
}, DK = { class: "flex flex-col" }, TK = ["value"], $K = ["value"], OK = { key: 1 }, qX = {
  __name: "OSelect",
  props: {
    /**
     * value
     */
    modelValue: {
      type: [String, Number]
    },
    /** options */
    options: {
      type: Array
    },
    /**
     * mode [view | edit]
     */
    mode: {
      type: String
    },
    /**
     * label
     */
    label: {
      type: String
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | success | error | disabled | [...custom globalConfig defined]]
     */
    status: {
      type: String
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: a }) {
    const t = e, o = a, r = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        status: "primary",
        rounded: "full"
      },
      classes: {
        wrapper: {
          commonClasses: ""
          //"p-4 border",
        },
        select: {
          commonClasses: "bg-transparent font-element font-semibold h-[52px] px-2 transition-all duration-250 ease-in-out border  dark:border-neutral-700 dark:bg-neutral-800",
          propsClasses: {}
        }
      }
    };
    r.classes.wrapper.commonClasses += ` context-${t.context}`;
    const l = jt({ localProps: t, defaults: r });
    function i(c) {
      console.log("onInput:", c.target.value), o("update:modelValue", c.target.value);
    }
    return (c, u) => (d(), h("div", j(re(s(l).wrapper)), [
      P("div", DK, [
        P("span", null, N(s(l).label), 1),
        e.mode == "edit" ? (d(), h("select", H({ key: 0 }, s(l).select, {
          value: t.modelValue,
          onInput: i
        }), [
          u[0] || (u[0] = P("option", { value: "" }, "---", -1)),
          (d(!0), h(ve, null, Ie(e.options, (v) => (d(), h("option", {
            value: v.value,
            key: v.value
          }, N(v.label), 9, $K))), 128))
        ], 16, TK)) : y("", !0),
        e.mode == "view" ? (d(), h("span", OK, N(t.modelValue), 1)) : y("", !0)
      ])
    ], 16));
  }
}, RK = { key: 1 }, zX = {
  __name: "OToggle",
  props: {
    /**
     * value
     */
    modelValue: {
      type: Boolean
    },
    /** label */
    label: {
      type: String
    },
    /**
     * mode [view | edit]
     */
    mode: {
      type: String
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * padding (only padding) [none | small | default | large]
     */
    padding: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | success | error | disabled | [...custom globalConfig defined]]
     */
    status: {
      type: String
    }
  },
  emits: ["update:model-value"],
  setup(e, { emit: a }) {
    const t = e, o = a, r = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        status: "primary",
        rounded: "full",
        mode: "edit",
        padding: "default"
      },
      classes: {
        wrapper: {
          commonClasses: "cursor-pointer flex flex-row items-center gap-4"
          //"p-4 border",
        },
        label: {
          commonClasses: ""
        },
        toggle: {
          commonClasses: ""
        },
        toggleHandle: {
          commonClasses: "",
          propsClasses: {
            modelValue: {
              false: "left-1 bg-neutral-400",
              true: "right-1 bg-neutral-900"
            }
          }
        },
        input: {
          commonClasses: "font-element font-semibold transition-all duration-250 ease-in-out border",
          propsClasses: {
            padding: {
              large: "h-[52px] px-7",
              default: "h-[44px] px-2",
              small: "py-1 px-2",
              none: "p-0"
            }
          }
        }
      }
    };
    r.classes.wrapper.commonClasses += ` context-${t.context}`;
    const l = jt({ localProps: t, defaults: r });
    function i() {
      o("update:model-value", !t.modelValue);
    }
    return (c, u) => (d(), h("div", j(re(s(l).wrapper)), [
      s(l).mode == "edit" ? (d(), h("div", {
        key: 0,
        class: "relative h-[34px] w-16 rounded-full border border-neutral-300",
        onClick: i
      }, [
        P("div", {
          class: be(["absolute top-1 h-6 w-6 rounded-full", [
            { "left-1 bg-neutral-400": s(l).modelValue === !1 || !s(l).modelValue },
            { "right-1 bg-neutral-900": s(l).modelValue === !0 }
          ]])
        }, null, 2)
      ])) : y("", !0),
      s(l).mode == "view" ? (d(), h("div", RK, [
        s(l).modelValue === !1 || !s(l).modelValue ? (d(), K(Hx, {
          key: 0,
          lucide: "X"
        })) : y("", !0),
        s(l).modelValue === !0 ? (d(), K(Hx, {
          key: 1,
          lucide: "Check"
        })) : y("", !0)
      ])) : y("", !0),
      t.label ? (d(), h("span", j(H({ key: 2 }, s(l).label)), N(t.label), 17)) : y("", !0)
    ], 16));
  }
}, PX = {
  __name: "Tag",
  props: {
    /**
     * label
     */
    label: {
      type: String
    },
    /**
     * size (font + padding) [small | medium | large]
     */
    size: {
      type: String
    },
    /**
     * padding (only padding) [none | small | default | large]
     */
    padding: {
      type: String
    },
    /**
     * corner rounding [none | slight | full]
     */
    rounded: {
      type: String
    },
    /**
     * contextual background [dark | neutral | light]
     */
    context: {
      type: String,
      validator: function(e) {
        return ["dark", "neutral", "light"].indexOf(e) !== -1;
      }
    },
    /**
     * used for presetting props & overriding styles in Storybook. In userland, use provide('one-ui-config', {}) instead
     */
    globalConfig: {
      type: Object
    },
    locale: {
      type: String
    },
    /**
     * shape [solid | ghost | plain]
     */
    kind: {
      type: String
    },
    /**
     * current status - mostly communicated as color [primary | secondary | [...custom globalConfig defined]]
     */
    status: {
      type: String
    }
  },
  setup(e) {
    const a = e, t = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        kind: "solid",
        status: "primary",
        rounded: "slight",
        padding: "default"
      },
      classes: {
        wrapper: {
          commonClasses: "w-auto"
          //"p-4 border",
        },
        tag: {
          commonClasses: "inline-flex flex-row justify-center items-center gap-2 font-element font-semibold transition-all duration-250 ease-in-out",
          propsClasses: {
            rounded: {
              none: "rounded-none",
              slight: "rounded-md",
              full: "rounded-full"
            },
            padding: {
              large: "h-[52px] px-7",
              default: "h-[26px] px-2",
              small: "py-1 px-2",
              none: "p-0"
            },
            kind: {
              ghost: "outline outline-2 -outline-offset-2"
            },
            status: {
              // _common: "", // applied to all
              primary: {
                kindSolid: "bg-neutral-900 context-dark:bg-neutral-500 text-white dark:bg-neutral-600 dark:text-neutral-200",
                kindGhost: "outline-neutral-900",
                kindPlain: "bg-transparent"
              },
              secondary: {
                kindSolid: "bg-neutral-200",
                kindGhost: "outline-neutral-200",
                kindPlain: "bg-transparent"
              }
            }
          }
        },
        text: {
          commonClasses: "uppercase text-[0.8rem] font-bold"
        }
      }
    };
    t.classes.wrapper.commonClasses += ` context-${a.context}`;
    const o = jt({ localProps: a, defaults: t });
    return (r, l) => (d(), h("div", j(re(s(o).wrapper)), [
      P("div", j(re(s(o).tag)), [
        s(o).label ? (d(), h("span", j(H({ key: 0 }, s(o).text)), N(s(o).label), 17)) : (d(), h("span", j(H({ key: 1 }, s(o).text)), N(s(Nx).get("element-tag", null, s(o).locale)), 17))
      ], 16)
    ], 16));
  }
};
const FK = ["data-one-component"], _X = {
  __name: "OVideoYoutube",
  props: {
    code: {
      type: String
    },
    playlist: {
      type: Boolean,
      default: !1
    },
    autoplay: {
      type: Boolean,
      default: !1
    },
    mute: {
      type: Boolean,
      default: !1
    },
    controls: {
      type: Boolean,
      default: !0
    },
    allowFullscreen: {
      type: Boolean,
      default: !0
    },
    loop: {
      type: Boolean,
      default: !0
    },
    moreVideos: {
      type: Boolean,
      default: !1
    },
    // emit 'elapsed' event every N seconds
    elapsedInterval: {
      type: Number,
      default: 1
    }
  },
  emits: [
    "ready",
    "elapsed",
    "unstarted",
    "ended",
    "playing",
    "paused",
    "buffering",
    "cued",
    "stateChange",
    "playbackQualityChange",
    "playbackRateChange",
    "error"
  ],
  setup(e, { emit: a }) {
    const t = e, o = a, r = U(null), l = U(null), i = U(0), c = U(null);
    function u(x) {
      if (x === "playing") {
        const q = {
          interval: t.elapsedInterval,
          videoDuration: i.value,
          videoCurrentTime: Math.round(l.value.getCurrentTime()),
          videoCurrentPosition: Math.round(l.value.getCurrentTime() / i.value * 100)
        };
        q.videoCurrentTime > 0 && (o("elapsed", q), console.log("elapsed", q)), c.value = setTimeout(() => {
          u("playing");
        }, 1e3 * t.elapsedInterval);
      } else
        x === "paused" && clearTimeout(c.value);
    }
    function v(x) {
      console.log("player ready"), i.value = x.target.getDuration();
      const q = {
        videoDuration: i.value
      };
      o("ready", q), console.log("duration", q);
    }
    function k(x) {
      const q = Math.round(x.target.getCurrentTime()), _ = Math.round(q / i.value * 100);
      console.log({ videoCurrentTime: q, videoCurrentPosition: _ });
      const A = {
        interval: t.elapsedInterval,
        videoDuration: i.value,
        videoCurrentTime: q,
        videoCurrentPosition: _
      };
      switch (x.data) {
        case window.YT.PlayerState.UNSTARTED:
          o("unstarted", A), console.log("unstarted", A);
          break;
        case window.YT.PlayerState.ENDED:
          o("ended", A), console.log("ended", A);
          break;
        case window.YT.PlayerState.PLAYING:
          o("playing", A), u("playing"), console.log("playing", A);
          break;
        case window.YT.PlayerState.PAUSED:
          o("paused", A), u("paused"), console.log("paused", A);
          break;
        case window.YT.PlayerState.BUFFERING:
          o("buffering", A), console.log("buffering", A);
          break;
        case window.YT.PlayerState.CUED:
          o("cued", A), console.log("cued", A);
          break;
      }
      o("stateChange", A);
    }
    function f(x) {
      console.log("playback quality change"), o("playbackQualityChange", x.data);
    }
    function p(x) {
      console.log("playback rate change"), o("playbackRateChange", x.target);
    }
    function m(x) {
      console.log("error"), o("error", x.data);
    }
    function I(x) {
      console.log("api change"), o("apiChange", x.target);
    }
    async function S() {
      if (window.YT && window.YT.Player)
        $();
      else {
        const x = document.createElement("script");
        x.src = "https://www.youtube.com/iframe_api", x.id = "youtube-iframe-api";
        const q = document.getElementsByTagName("script")[0];
        document.getElementById("youtube-iframe-api") ? (await C(), $()) : (q.parentNode.insertBefore(x, q), window.onYouTubeIframeAPIReady = () => {
          $();
        });
      }
    }
    async function C() {
      return new Promise((x) => {
        window.YT && window.YT.Player ? x() : setTimeout(() => {
          C().then(() => {
            x();
          });
        }, 100);
      });
    }
    async function B() {
      S();
    }
    function $() {
      console.log("initializing video", t.code, window.YT), l.value = new window.YT.Player(r.value, {
        videoId: t.code,
        playerVars: {
          playsinline: 1,
          autoplay: t.autoplay,
          mute: t.mute,
          controls: t.controls,
          allowfullscreen: t.allowFullscreen,
          loop: t.loop,
          rel: t.moreVideos
        },
        events: {
          onReady: v,
          onStateChange: k,
          onPlaybackQualityChange: f,
          onPlaybackRateChange: p,
          onError: m,
          onApiChange: I
        }
      });
    }
    return Qe(() => {
      B();
    }), (x, q) => (d(), h("div", {
      class: "iframe-container",
      "data-one-component": x.$options.name
    }, [
      P("div", {
        ref_key: "playerContainer",
        ref: r
      }, null, 512)
    ], 8, FK));
  }
}, EK = {};
function UK(e, a) {
  return d(), h("tbody", null, [
    te(e.$slots, "default")
  ]);
}
const NK = /* @__PURE__ */ Wx(EK, [["render", UK]]), WK = {
  __name: "TableCaption",
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const a = e, o = jt({ localProps: a, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {},
      classes: {
        paragraph: {
          commonClasses: "text-neutral-400 text-center mt-2",
          propsClasses: {}
        }
      }
    } });
    return (r, l) => (d(), h("div", null, [
      P("p", j(re(s(o).paragraph)), N(a.text), 17)
    ]));
  }
}, GK = {
  __name: "TableCell",
  props: {
    density: {
      type: String
    }
  },
  setup(e) {
    const o = jt({ localProps: e, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        density: "default"
      },
      classes: {
        td: {
          commonClasses: "border-t border-b px-2 first:pl-2 last:pr-2",
          propsClasses: {
            density: {
              compact: "py-1",
              default: "py-3",
              spacious: "py-5"
            }
          }
        }
      }
    } });
    return (r, l) => (d(), h("td", j(re(s(o).td)), [
      te(r.$slots, "default")
    ], 16));
  }
}, ZK = {
  __name: "TableHead",
  props: {},
  setup(e) {
    const o = jt({ localProps: e, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {},
      classes: {
        th: {
          commonClasses: "uppercase text-[0.8rem] text-neutral-400 text-left pb-1 px-2 first:pl-2 last:pr-2",
          propsClasses: {}
        }
      }
    } });
    return (r, l) => (d(), h("th", j(re(s(o).th)), [
      te(r.$slots, "default")
    ], 16));
  }
}, YK = {};
function KK(e, a) {
  return d(), h("thead", null, [
    te(e.$slots, "default")
  ]);
}
const XK = /* @__PURE__ */ Wx(YK, [["render", KK]]), Cw = {
  __name: "TableRow",
  props: {},
  setup(e) {
    const o = jt({ localProps: e, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {},
      classes: {
        tr: {
          commonClasses: "",
          propsClasses: {}
        }
      }
    } });
    return (r, l) => (d(), h("tr", j(re(s(o).tr)), [
      te(r.$slots, "default")
    ], 16));
  }
}, QK = {};
function JK(e, a) {
  return d(), h("tfoot", null, [
    te(e.$slots, "default")
  ]);
}
const eX = /* @__PURE__ */ Wx(QK, [["render", JK]]), tX = {
  __name: "TableFoot",
  props: {},
  setup(e) {
    const o = jt({ localProps: e, defaults: {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {},
      classes: {
        td: {
          commonClasses: "text-neutral-400 px-2 first:pl-2 last:pr-2",
          propsClasses: {}
        }
      }
    } });
    return (r, l) => (d(), h("td", j(re(s(o).td)), [
      te(r.$slots, "default")
    ], 16));
  }
}, aX = { key: 0 }, nX = { key: 0 }, oX = { key: 1 }, rX = { key: 0 }, jX = {
  __name: "Table",
  props: {
    data: {
      type: Object
    }
  },
  setup(e) {
    const a = e, t = {
      // default props need to be defined here, if defined in defineProps(), VUE will then set those even if undefined, therefore it will mess up the merging of local, global and user defined prop values
      props: {
        kind: "solid",
        status: "primary",
        rounded: "full",
        padding: "default",
        doubleAction: !1,
        icon: !1
      },
      classes: {
        wrapper: {
          commonClasses: "w-full"
          //"p-4 border",
        },
        table: {
          commonClasses: "w-full"
        }
      }
    };
    t.classes.wrapper.commonClasses += ` context-${a.context}`;
    const o = jt({ localProps: a, defaults: t });
    return (r, l) => {
      var c, u, v, k;
      const i = Fr("RouterLink");
      return d(), h("div", j(re(s(o).wrapper)), [
        P("table", j(re(s(o).table)), [
          (c = a.data) != null && c.head ? (d(), K(XK, { key: 0 }, {
            default: fe(() => [
              (d(!0), h(ve, null, Ie(a.data.head, (f, p) => (d(), K(Cw, { key: p }, {
                default: fe(() => [
                  (d(!0), h(ve, null, Ie(f, (m, I) => (d(), K(ZK, {
                    key: I,
                    class: be(m.classes)
                  }, {
                    default: fe(() => [
                      m.value ? (d(), h("div", aX, N(m.value), 1)) : y("", !0),
                      m.component ? (d(), K(st(m.component.component), H({
                        key: 1,
                        ref_for: !0
                      }, m.component.props), null, 16)) : y("", !0)
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128))
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })) : y("", !0),
          (u = a.data) != null && u.body ? (d(), K(NK, { key: 1 }, {
            default: fe(() => [
              (d(!0), h(ve, null, Ie(a.data.body, (f, p) => (d(), K(Cw, { key: p }, {
                default: fe(() => [
                  (d(!0), h(ve, null, Ie(f, (m, I) => (d(), K(GK, {
                    key: I,
                    class: be(m.classes)
                  }, {
                    default: fe(() => [
                      m.link && m.link.to ? (d(), K(i, {
                        key: 0,
                        to: m.link.to
                      }, {
                        default: fe(() => [
                          m.value ? (d(), h("span", nX, N(m.value), 1)) : y("", !0)
                        ]),
                        _: 2
                      }, 1032, ["to"])) : y("", !0),
                      !m.link && m.value ? (d(), h("span", oX, N(m.value), 1)) : y("", !0),
                      m.component ? (d(), K(st(m.component.component), H({
                        key: 2,
                        ref_for: !0
                      }, m.component.props, {
                        onClick: (S) => m.component.props.click(m)
                      }), null, 16, ["onClick"])) : y("", !0)
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128))
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })) : y("", !0),
          (v = a.data) != null && v.foot ? (d(), K(eX, { key: 2 }, {
            default: fe(() => [
              (d(!0), h(ve, null, Ie(a.data.foot, (f, p) => (d(), K(Cw, { key: p }, {
                default: fe(() => [
                  (d(!0), h(ve, null, Ie(f, (m, I) => (d(), K(tX, {
                    key: I,
                    class: be(m.classes)
                  }, {
                    default: fe(() => [
                      m.value ? (d(), h("div", rX, N(m.value), 1)) : y("", !0),
                      m.component ? (d(), K(st(m.component.component), H({
                        key: 1,
                        ref_for: !0
                      }, m.component.props), null, 16)) : y("", !0)
                    ]),
                    _: 2
                  }, 1032, ["class"]))), 128))
                ]),
                _: 2
              }, 1024))), 128))
            ]),
            _: 1
          })) : y("", !0)
        ], 16),
        (k = a.data) != null && k.caption ? (d(), K(WK, {
          key: 0,
          text: a.data.caption
        }, null, 8, ["text"])) : y("", !0)
      ], 16);
    };
  }
};
export {
  CX as OButton,
  Hx as OIcon,
  AX as OInput,
  qX as OSelect,
  jX as OTable,
  PX as OTag,
  zX as OToggle,
  _X as OVideoYoutube,
  YS as OneAdminSidebar,
  FY as OneAdminSidebarMenu,
  NY as OneAdminSidebarUser,
  ft as OneButton,
  AI as OneCheckbox,
  Ax as OneChip,
  LS as OneChips,
  hG as OneDatepicker,
  uX as OneDialog,
  $e as OneIcon,
  dX as OneImageCDN,
  Qo as OneInput,
  cX as OneInputMulti,
  sX as OneKeyValueEditor,
  ia as OneLayoutContainer,
  bY as OneMenuFloating,
  LY as OneMenuFloatingItem,
  LX as OneNotifications,
  NG as OneProductItemList,
  tw as OneProgress,
  SS as OneRadio,
  IX as OneRatingStars,
  yX as OneSectionFooter,
  kX as OneSectionGallery,
  mX as OneSectionHeader,
  fX as OneSectionHeadlineTextImageCTA,
  vX as OneSectionHero,
  gX as OneSectionProductItemDetail,
  MX as OneSectionProductItemList,
  bX as OneSectionSpacer,
  CS as OneSelect,
  IS as OneSwitch,
  hX as OneTable,
  pX as OneTableKeyValue,
  Jo as OneText,
  xX as OneTextBox,
  pY as OneToast,
  wX as OneToggle,
  SX as OneViewAdmin
};
//# sourceMappingURL=framework.one.es.js.map
